export const MERIT_LIST_DATA = [
  {
    "session": "Session 2017-18",
    "courses": [
      {
        "courseName": "B.A I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "170090430003",
            "name": "SAVINA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "664",
            "maxMarks": "900",
            "percentage": "73.78%",
            "cells": [
              "1",
              "170090430003",
              "SAVINA",
              "RAN SINGH",
              "664",
              "900",
              "73.78%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "170090430004",
            "name": "MANDEEP KAUR",
            "fatherName": "SURESH",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "2",
              "170090430004",
              "MANDEEP KAUR",
              "SURESH",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "170090430009",
            "name": "JASPREET KAUR",
            "fatherName": "DHARAM SINGH",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "3",
              "170090430009",
              "JASPREET KAUR",
              "DHARAM SINGH",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "170090430011",
            "name": "JASWINDER",
            "fatherName": "SH GULSHAN KUMAR",
            "obtainedMarks": "711",
            "maxMarks": "900",
            "percentage": "79%",
            "cells": [
              "4",
              "170090430011",
              "JASWINDER",
              "SH GULSHAN KUMAR",
              "711",
              "900",
              "79%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "170090430016",
            "name": "POOJA RANI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "675",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "5",
              "170090430016",
              "POOJA RANI",
              "RAJESH KUMAR",
              "675",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "170090430019",
            "name": "SANDEEP KAUR",
            "fatherName": "GURBHAGAT SINGH",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "6",
              "170090430019",
              "SANDEEP KAUR",
              "GURBHAGAT SINGH",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "170090430025",
            "name": "RAMANDEEP KAUR",
            "fatherName": "SUKHMANDER SINGH",
            "obtainedMarks": "683",
            "maxMarks": "900",
            "percentage": "75.89%",
            "cells": [
              "7",
              "170090430025",
              "RAMANDEEP KAUR",
              "SUKHMANDER SINGH",
              "683",
              "900",
              "75.89%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "170090430028",
            "name": "ANNU",
            "fatherName": "CHANDER SHARMA",
            "obtainedMarks": "669",
            "maxMarks": "900",
            "percentage": "74.33%",
            "cells": [
              "8",
              "170090430028",
              "ANNU",
              "CHANDER SHARMA",
              "669",
              "900",
              "74.33%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "170090430032",
            "name": "RAVINA",
            "fatherName": "MR MAHESH KUMAR",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "9",
              "170090430032",
              "RAVINA",
              "MR MAHESH KUMAR",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "170090430039",
            "name": "ARCHNA",
            "fatherName": "BAGH CHAND",
            "obtainedMarks": "704",
            "maxMarks": "900",
            "percentage": "78.22%",
            "cells": [
              "10",
              "170090430039",
              "ARCHNA",
              "BAGH CHAND",
              "704",
              "900",
              "78.22%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "170090430044",
            "name": "VIJETA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "11",
              "170090430044",
              "VIJETA",
              "KULDEEP",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "170090430049",
            "name": "SIMRAN",
            "fatherName": "ASHOK KUMAR JAGGA",
            "obtainedMarks": "736",
            "maxMarks": "900",
            "percentage": "81.78%",
            "cells": [
              "12",
              "170090430049",
              "SIMRAN",
              "ASHOK KUMAR JAGGA",
              "736",
              "900",
              "81.78%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "170090430050",
            "name": "RAJDEEP KAUR",
            "fatherName": "INDERJEET SINGH",
            "obtainedMarks": "717",
            "maxMarks": "900",
            "percentage": "79.67%",
            "cells": [
              "13",
              "170090430050",
              "RAJDEEP KAUR",
              "INDERJEET SINGH",
              "717",
              "900",
              "79.67%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "170090430053",
            "name": "NISHA SAINI",
            "fatherName": "PAWAN SAINI",
            "obtainedMarks": "644",
            "maxMarks": "900",
            "percentage": "71.56%",
            "cells": [
              "14",
              "170090430053",
              "NISHA SAINI",
              "PAWAN SAINI",
              "644",
              "900",
              "71.56%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "170090430059",
            "name": "NEELAM",
            "fatherName": "SALENDER SINGH",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "15",
              "170090430059",
              "NEELAM",
              "SALENDER SINGH",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "170090430061",
            "name": "SANJU KAMBOJ",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "726",
            "maxMarks": "900",
            "percentage": "80.67%",
            "cells": [
              "16",
              "170090430061",
              "SANJU KAMBOJ",
              "JAGDISH KUMAR",
              "726",
              "900",
              "80.67%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "170090430064",
            "name": "GARIMA",
            "fatherName": "BABU RAM",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "17",
              "170090430064",
              "GARIMA",
              "BABU RAM",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "170090430069",
            "name": "GAYATRI",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "18",
              "170090430069",
              "GAYATRI",
              "RANJEET SINGH",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "170090430070",
            "name": "JYOTI RANI",
            "fatherName": "GANDHI RAM",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "19",
              "170090430070",
              "JYOTI RANI",
              "GANDHI RAM",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "170090430074",
            "name": "POONAM RANI",
            "fatherName": "BALRAJ SINGH",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "20",
              "170090430074",
              "POONAM RANI",
              "BALRAJ SINGH",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "170090430079",
            "name": "MONIKA",
            "fatherName": "DALIP SINGH",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "21",
              "170090430079",
              "MONIKA",
              "DALIP SINGH",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "170090430089",
            "name": "PRIYAL",
            "fatherName": "AMOLAK",
            "obtainedMarks": "779",
            "maxMarks": "900",
            "percentage": "86.56%",
            "cells": [
              "22",
              "170090430089",
              "PRIYAL",
              "AMOLAK",
              "779",
              "900",
              "86.56%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "170090430090",
            "name": "SAVITA SWAMI",
            "fatherName": "POONAM CHAND SWAMI",
            "obtainedMarks": "661",
            "maxMarks": "900",
            "percentage": "73.44%",
            "cells": [
              "23",
              "170090430090",
              "SAVITA SWAMI",
              "POONAM CHAND SWAMI",
              "661",
              "900",
              "73.44%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "170090430091",
            "name": "MONIKA",
            "fatherName": "KANHAIYALAL",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "24",
              "170090430091",
              "MONIKA",
              "KANHAIYALAL",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "170090430095",
            "name": "MANJU",
            "fatherName": "RAMESH SAHARAN",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "25",
              "170090430095",
              "MANJU",
              "RAMESH SAHARAN",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "170090430098",
            "name": "CHANDER KALA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "743",
            "maxMarks": "900",
            "percentage": "82.56%",
            "cells": [
              "26",
              "170090430098",
              "CHANDER KALA",
              "MOHAN LAL",
              "743",
              "900",
              "82.56%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "170090430100",
            "name": "JYOTI",
            "fatherName": "JAIPAL",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "27",
              "170090430100",
              "JYOTI",
              "JAIPAL",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "170090430112",
            "name": "SWATI",
            "fatherName": "SATBEER SINGH",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "28",
              "170090430112",
              "SWATI",
              "SATBEER SINGH",
              "640",
              "900",
              "71.11%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "29",
            "rollNo": "16109430007",
            "name": "KAVITA RANI",
            "fatherName": "RAM SWAROOP",
            "obtainedMarks": "652",
            "maxMarks": "800",
            "percentage": "81.50%",
            "cells": [
              "29",
              "16109430007",
              "KAVITA RANI",
              "RAM SWAROOP",
              "652",
              "800",
              "81.50%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "16109430009",
            "name": "RITU KUMARI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "630",
            "maxMarks": "800",
            "percentage": "78.75%",
            "cells": [
              "30",
              "16109430009",
              "RITU KUMARI",
              "RAJ KUMAR",
              "630",
              "800",
              "78.75%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "16109430010",
            "name": "SUMAN",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "629",
            "maxMarks": "800",
            "percentage": "78.62%",
            "cells": [
              "31",
              "16109430010",
              "SUMAN",
              "SHAMSHER SINGH",
              "629",
              "800",
              "78.62%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "16109430013",
            "name": "PRIYANKA",
            "fatherName": "MANOJ KUMAR",
            "obtainedMarks": "588",
            "maxMarks": "800",
            "percentage": "73.50%",
            "cells": [
              "32",
              "16109430013",
              "PRIYANKA",
              "MANOJ KUMAR",
              "588",
              "800",
              "73.50%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "16109430017",
            "name": "SUMAN",
            "fatherName": "SATBIR SINGH",
            "obtainedMarks": "581",
            "maxMarks": "800",
            "percentage": "72.62%",
            "cells": [
              "33",
              "16109430017",
              "SUMAN",
              "SATBIR SINGH",
              "581",
              "800",
              "72.62%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "16109430024",
            "name": "LUXMI RANI",
            "fatherName": "MAL CHAND",
            "obtainedMarks": "578",
            "maxMarks": "800",
            "percentage": "72.25%",
            "cells": [
              "34",
              "16109430024",
              "LUXMI RANI",
              "MAL CHAND",
              "578",
              "800",
              "72.25%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "16109430025",
            "name": "PREEKSHA",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "609",
            "maxMarks": "800",
            "percentage": "76.12%",
            "cells": [
              "35",
              "16109430025",
              "PREEKSHA",
              "DAYA RAM",
              "609",
              "800",
              "76.12%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "16109430026",
            "name": "BINDU",
            "fatherName": "KANAHAIYA LAL",
            "obtainedMarks": "583",
            "maxMarks": "800",
            "percentage": "72.88%",
            "cells": [
              "36",
              "16109430026",
              "BINDU",
              "KANAHAIYA LAL",
              "583",
              "800",
              "72.88%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "16109430035",
            "name": "REKHA",
            "fatherName": "SURJIT SINGH",
            "obtainedMarks": "585",
            "maxMarks": "800",
            "percentage": "73.12%",
            "cells": [
              "37",
              "16109430035",
              "REKHA",
              "SURJIT SINGH",
              "585",
              "800",
              "73.12%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "16109430067",
            "name": "POOJA",
            "fatherName": "SUBE SINGH",
            "obtainedMarks": "601",
            "maxMarks": "800",
            "percentage": "75.12%",
            "cells": [
              "38",
              "16109430067",
              "POOJA",
              "SUBE SINGH",
              "601",
              "800",
              "75.12%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "16109430071",
            "name": "NEELAM KAUR",
            "fatherName": "GURCHARAN SINGH",
            "obtainedMarks": "588",
            "maxMarks": "800",
            "percentage": "73.50%",
            "cells": [
              "39",
              "16109430071",
              "NEELAM KAUR",
              "GURCHARAN SINGH",
              "588",
              "800",
              "73.50%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "16109430074",
            "name": "SIMRAN",
            "fatherName": "VIVEK KUMAR",
            "obtainedMarks": "667",
            "maxMarks": "800",
            "percentage": "83.38%",
            "cells": [
              "40",
              "16109430074",
              "SIMRAN",
              "VIVEK KUMAR",
              "667",
              "800",
              "83.38%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "16109430083",
            "name": "SANJU",
            "fatherName": "KRISHAN",
            "obtainedMarks": "596",
            "maxMarks": "800",
            "percentage": "74.50%",
            "cells": [
              "41",
              "16109430083",
              "SANJU",
              "KRISHAN",
              "596",
              "800",
              "74.50%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "16109430084",
            "name": "MANDEEP",
            "fatherName": "GURSEV SINGH",
            "obtainedMarks": "601",
            "maxMarks": "800",
            "percentage": "75.12%",
            "cells": [
              "42",
              "16109430084",
              "MANDEEP",
              "GURSEV SINGH",
              "601",
              "800",
              "75.12%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "16109430087",
            "name": "SANJU",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "600",
            "maxMarks": "800",
            "percentage": "75%",
            "cells": [
              "43",
              "16109430087",
              "SANJU",
              "RAM NIWAS",
              "600",
              "800",
              "75%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "16109430095",
            "name": "NAVNEET",
            "fatherName": "RAGHUBIR SINGH",
            "obtainedMarks": "623",
            "maxMarks": "800",
            "percentage": "77.88%",
            "cells": [
              "44",
              "16109430095",
              "NAVNEET",
              "RAGHUBIR SINGH",
              "623",
              "800",
              "77.88%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "16109430096",
            "name": "SHWETA",
            "fatherName": "SHO PARKASH",
            "obtainedMarks": "616",
            "maxMarks": "800",
            "percentage": "77%",
            "cells": [
              "45",
              "16109430096",
              "SHWETA",
              "SHO PARKASH",
              "616",
              "800",
              "77%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "16109430097",
            "name": "SUKHPREET KAUR",
            "fatherName": "GURTEJ SINGH",
            "obtainedMarks": "587",
            "maxMarks": "800",
            "percentage": "73.38%",
            "cells": [
              "46",
              "16109430097",
              "SUKHPREET KAUR",
              "GURTEJ SINGH",
              "587",
              "800",
              "73.38%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "16109430099",
            "name": "MUSKAN",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "595",
            "maxMarks": "800",
            "percentage": "74.38%",
            "cells": [
              "47",
              "16109430099",
              "MUSKAN",
              "SANJAY KUMAR",
              "595",
              "800",
              "74.38%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "16109430101",
            "name": "EKTA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "583",
            "maxMarks": "800",
            "percentage": "72.88%",
            "cells": [
              "48",
              "16109430101",
              "EKTA",
              "MADAN LAL",
              "583",
              "800",
              "72.88%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "16109430102",
            "name": "SHIVANI",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "627",
            "maxMarks": "800",
            "percentage": "78.38%",
            "cells": [
              "49",
              "16109430102",
              "SHIVANI",
              "RAJINDER SINGH",
              "627",
              "800",
              "78.38%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "16109430103",
            "name": "SONIA",
            "fatherName": "KULDEEP SINGH",
            "obtainedMarks": "579",
            "maxMarks": "800",
            "percentage": "72.38%",
            "cells": [
              "50",
              "16109430103",
              "SONIA",
              "KULDEEP SINGH",
              "579",
              "800",
              "72.38%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "16109430107",
            "name": "PRABHJOT KAUR",
            "fatherName": "SARJANT SINGH",
            "obtainedMarks": "627",
            "maxMarks": "800",
            "percentage": "78.38%",
            "cells": [
              "51",
              "16109430107",
              "PRABHJOT KAUR",
              "SARJANT SINGH",
              "627",
              "800",
              "78.38%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "16109430108",
            "name": "PARUL",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "576",
            "maxMarks": "800",
            "percentage": "72%",
            "cells": [
              "52",
              "16109430108",
              "PARUL",
              "SOHAN PAL",
              "576",
              "800",
              "72%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "16109430109",
            "name": "PUSHPA",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "593",
            "maxMarks": "800",
            "percentage": "74.12%",
            "cells": [
              "53",
              "16109430109",
              "PUSHPA",
              "DHARMPAL",
              "593",
              "800",
              "74.12%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "16109430118",
            "name": "SHASHI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "565",
            "maxMarks": "800",
            "percentage": "70.62%",
            "cells": [
              "54",
              "16109430118",
              "SHASHI",
              "SUNIL KUMAR",
              "565",
              "800",
              "70.62%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "16109430125",
            "name": "MONIKA",
            "fatherName": "BRIJ LAL",
            "obtainedMarks": "570",
            "maxMarks": "800",
            "percentage": "71.25%",
            "cells": [
              "55",
              "16109430125",
              "MONIKA",
              "BRIJ LAL",
              "570",
              "800",
              "71.25%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "16109430136",
            "name": "RANI",
            "fatherName": "SUBASH",
            "obtainedMarks": "606",
            "maxMarks": "800",
            "percentage": "75.75%",
            "cells": [
              "56",
              "16109430136",
              "RANI",
              "SUBASH",
              "606",
              "800",
              "75.75%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "16109430144",
            "name": "MAYAWATI",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "602",
            "maxMarks": "800",
            "percentage": "75.25%",
            "cells": [
              "57",
              "16109430144",
              "MAYAWATI",
              "OM PRAKASH",
              "602",
              "800",
              "75.25%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "16109430146",
            "name": "ADESH",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "590",
            "maxMarks": "800",
            "percentage": "73.75%",
            "cells": [
              "58",
              "16109430146",
              "ADESH",
              "VED PARKASH",
              "590",
              "800",
              "73.75%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "16109430147",
            "name": "ANITA RANI",
            "fatherName": "SURENDER",
            "obtainedMarks": "602",
            "maxMarks": "800",
            "percentage": "75.25%",
            "cells": [
              "59",
              "16109430147",
              "ANITA RANI",
              "SURENDER",
              "602",
              "800",
              "75.25%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "16109430148",
            "name": "GURPRIT KOUR",
            "fatherName": "DHARMENDER SINGH",
            "obtainedMarks": "635",
            "maxMarks": "800",
            "percentage": "79.38%",
            "cells": [
              "60",
              "16109430148",
              "GURPRIT KOUR",
              "DHARMENDER SINGH",
              "635",
              "800",
              "79.38%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "16109430156",
            "name": "MONIKA",
            "fatherName": "SHYAM SUNDER",
            "obtainedMarks": "584",
            "maxMarks": "800",
            "percentage": "73%",
            "cells": [
              "61",
              "16109430156",
              "MONIKA",
              "SHYAM SUNDER",
              "584",
              "800",
              "73%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A V +VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "62",
            "rollNo": "15109430002",
            "name": "INDIRA",
            "fatherName": "RAM KUMAR",
            "obtainedMarks": "622",
            "maxMarks": "800",
            "percentage": "77.75%",
            "cells": [
              "62",
              "15109430002",
              "INDIRA",
              "RAM KUMAR",
              "622",
              "800",
              "77.75%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "15109430004",
            "name": "POONAM",
            "fatherName": "KEHAR SINGH",
            "obtainedMarks": "639",
            "maxMarks": "800",
            "percentage": "79.88%",
            "cells": [
              "63",
              "15109430004",
              "POONAM",
              "KEHAR SINGH",
              "639",
              "800",
              "79.88%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "15109430012",
            "name": "HEMLATA",
            "fatherName": "MAIN PAL",
            "obtainedMarks": "600",
            "maxMarks": "800",
            "percentage": "75%",
            "cells": [
              "64",
              "15109430012",
              "HEMLATA",
              "MAIN PAL",
              "600",
              "800",
              "75%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "15109430026",
            "name": "POONAM",
            "fatherName": "SATBIR SINGH",
            "obtainedMarks": "592",
            "maxMarks": "800",
            "percentage": "74%",
            "cells": [
              "65",
              "15109430026",
              "POONAM",
              "SATBIR SINGH",
              "592",
              "800",
              "74%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "15109430040",
            "name": "NEETU",
            "fatherName": "KARAM SINGH",
            "obtainedMarks": "599",
            "maxMarks": "800",
            "percentage": "74.88%",
            "cells": [
              "66",
              "15109430040",
              "NEETU",
              "KARAM SINGH",
              "599",
              "800",
              "74.88%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "15109430041",
            "name": "VANDNA",
            "fatherName": "CHANAN DASS",
            "obtainedMarks": "583",
            "maxMarks": "800",
            "percentage": "72.88%",
            "cells": [
              "67",
              "15109430041",
              "VANDNA",
              "CHANAN DASS",
              "583",
              "800",
              "72.88%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "15109430042",
            "name": "SUNAINA RANI",
            "fatherName": "NATHU RAM",
            "obtainedMarks": "644",
            "maxMarks": "800",
            "percentage": "80.50%",
            "cells": [
              "68",
              "15109430042",
              "SUNAINA RANI",
              "NATHU RAM",
              "644",
              "800",
              "80.50%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "15109430044",
            "name": "ANURADHA",
            "fatherName": "INDERPAL",
            "obtainedMarks": "648",
            "maxMarks": "800",
            "percentage": "81%",
            "cells": [
              "69",
              "15109430044",
              "ANURADHA",
              "INDERPAL",
              "648",
              "800",
              "81%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "15109430047",
            "name": "SUSHMA RANI",
            "fatherName": "LAL CHAND",
            "obtainedMarks": "634",
            "maxMarks": "800",
            "percentage": "79.25%",
            "cells": [
              "70",
              "15109430047",
              "SUSHMA RANI",
              "LAL CHAND",
              "634",
              "800",
              "79.25%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "15109430049",
            "name": "SAVITA RANI",
            "fatherName": "DHARAM PAL",
            "obtainedMarks": "612",
            "maxMarks": "800",
            "percentage": "76.50%",
            "cells": [
              "71",
              "15109430049",
              "SAVITA RANI",
              "DHARAM PAL",
              "612",
              "800",
              "76.50%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "15109430054",
            "name": "SAPANA",
            "fatherName": "RAJNEESH",
            "obtainedMarks": "566",
            "maxMarks": "800",
            "percentage": "70.75%",
            "cells": [
              "72",
              "15109430054",
              "SAPANA",
              "RAJNEESH",
              "566",
              "800",
              "70.75%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "15109430056",
            "name": "ANITA RANI",
            "fatherName": "RAJENDER PRASAD",
            "obtainedMarks": "591",
            "maxMarks": "800",
            "percentage": "73.88%",
            "cells": [
              "73",
              "15109430056",
              "ANITA RANI",
              "RAJENDER PRASAD",
              "591",
              "800",
              "73.88%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "15109430078",
            "name": "MANJU RANI",
            "fatherName": "SATBIR SINGH",
            "obtainedMarks": "637",
            "maxMarks": "800",
            "percentage": "79.62%",
            "cells": [
              "74",
              "15109430078",
              "MANJU RANI",
              "SATBIR SINGH",
              "637",
              "800",
              "79.62%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "15109430079",
            "name": "PRITI",
            "fatherName": "JAGDISH",
            "obtainedMarks": "598",
            "maxMarks": "800",
            "percentage": "74.75%",
            "cells": [
              "75",
              "15109430079",
              "PRITI",
              "JAGDISH",
              "598",
              "800",
              "74.75%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "15109430080",
            "name": "POOJA",
            "fatherName": "SADHU RAM",
            "obtainedMarks": "644",
            "maxMarks": "800",
            "percentage": "80.50%",
            "cells": [
              "76",
              "15109430080",
              "POOJA",
              "SADHU RAM",
              "644",
              "800",
              "80.50%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "15109430081",
            "name": "POOJA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "619",
            "maxMarks": "800",
            "percentage": "77.38%",
            "cells": [
              "77",
              "15109430081",
              "POOJA",
              "KRISHAN KUMAR",
              "619",
              "800",
              "77.38%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "15109430083",
            "name": "LAXMI DEVI",
            "fatherName": "RAMNIVASH",
            "obtainedMarks": "603",
            "maxMarks": "800",
            "percentage": "75.38%",
            "cells": [
              "78",
              "15109430083",
              "LAXMI DEVI",
              "RAMNIVASH",
              "603",
              "800",
              "75.38%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "15109430085",
            "name": "DEEPIKA THAKUR",
            "fatherName": "ARVIND SINGH THAKUR",
            "obtainedMarks": "609",
            "maxMarks": "800",
            "percentage": "76.12%",
            "cells": [
              "79",
              "15109430085",
              "DEEPIKA THAKUR",
              "ARVIND SINGH THAKUR",
              "609",
              "800",
              "76.12%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "15109430086",
            "name": "MANITA",
            "fatherName": "SWAI SINGH",
            "obtainedMarks": "634",
            "maxMarks": "800",
            "percentage": "79.25%",
            "cells": [
              "80",
              "15109430086",
              "MANITA",
              "SWAI SINGH",
              "634",
              "800",
              "79.25%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "15109430088",
            "name": "NAVDEEP",
            "fatherName": "SUKHPREET SINGH",
            "obtainedMarks": "615",
            "maxMarks": "800",
            "percentage": "76.88%",
            "cells": [
              "81",
              "15109430088",
              "NAVDEEP",
              "SUKHPREET SINGH",
              "615",
              "800",
              "76.88%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "15109430092",
            "name": "CHAHAT",
            "fatherName": "SANJAY NAGPAL",
            "obtainedMarks": "598",
            "maxMarks": "800",
            "percentage": "74.75%",
            "cells": [
              "82",
              "15109430092",
              "CHAHAT",
              "SANJAY NAGPAL",
              "598",
              "800",
              "74.75%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "15109430093",
            "name": "ANAMIKA",
            "fatherName": "DALIP KUMAR",
            "obtainedMarks": "652",
            "maxMarks": "800",
            "percentage": "81.50%",
            "cells": [
              "83",
              "15109430093",
              "ANAMIKA",
              "DALIP KUMAR",
              "652",
              "800",
              "81.50%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "15109430094",
            "name": "MANISHA",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "589",
            "maxMarks": "800",
            "percentage": "73.62%",
            "cells": [
              "84",
              "15109430094",
              "MANISHA",
              "DEVI LAL",
              "589",
              "800",
              "73.62%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "15109430098",
            "name": "URVASHI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "672",
            "maxMarks": "800",
            "percentage": "84%",
            "cells": [
              "85",
              "15109430098",
              "URVASHI",
              "SUNIL KUMAR",
              "672",
              "800",
              "84%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "15109430099",
            "name": "KAVITA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "645",
            "maxMarks": "800",
            "percentage": "80.62%",
            "cells": [
              "86",
              "15109430099",
              "KAVITA",
              "RAJESH KUMAR",
              "645",
              "800",
              "80.62%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "15109430101",
            "name": "SUJATA",
            "fatherName": "SURENDER PAL",
            "obtainedMarks": "604",
            "maxMarks": "800",
            "percentage": "75.50%",
            "cells": [
              "87",
              "15109430101",
              "SUJATA",
              "SURENDER PAL",
              "604",
              "800",
              "75.50%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "15109430103",
            "name": "SHEFFY",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "571",
            "maxMarks": "800",
            "percentage": "71.38%",
            "cells": [
              "88",
              "15109430103",
              "SHEFFY",
              "MADAN LAL",
              "571",
              "800",
              "71.38%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "15109430104",
            "name": "AARJU",
            "fatherName": "ROHTASH",
            "obtainedMarks": "589",
            "maxMarks": "800",
            "percentage": "73.62%",
            "cells": [
              "89",
              "15109430104",
              "AARJU",
              "ROHTASH",
              "589",
              "800",
              "73.62%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "15109430105",
            "name": "POONAM",
            "fatherName": "SAJJAN",
            "obtainedMarks": "576",
            "maxMarks": "800",
            "percentage": "72%",
            "cells": [
              "90",
              "15109430105",
              "POONAM",
              "SAJJAN",
              "576",
              "800",
              "72%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "15109430108",
            "name": "RUCHIKA SAHARAN",
            "fatherName": "PEERDAN SAHARAN",
            "obtainedMarks": "604",
            "maxMarks": "800",
            "percentage": "75.50%",
            "cells": [
              "91",
              "15109430108",
              "RUCHIKA SAHARAN",
              "PEERDAN SAHARAN",
              "604",
              "800",
              "75.50%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "15109430109",
            "name": "MAMTA",
            "fatherName": "JITENDER",
            "obtainedMarks": "610",
            "maxMarks": "800",
            "percentage": "76.25%",
            "cells": [
              "92",
              "15109430109",
              "MAMTA",
              "JITENDER",
              "610",
              "800",
              "76.25%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "15109430116",
            "name": "PRIYANKA",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "676",
            "maxMarks": "800",
            "percentage": "84.50%",
            "cells": [
              "93",
              "15109430116",
              "PRIYANKA",
              "ASHOK KUMAR",
              "676",
              "800",
              "84.50%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "15109430118",
            "name": "PINKI CHAHAL",
            "fatherName": "DEVI RAM",
            "obtainedMarks": "605",
            "maxMarks": "800",
            "percentage": "75.62%",
            "cells": [
              "94",
              "15109430118",
              "PINKI CHAHAL",
              "DEVI RAM",
              "605",
              "800",
              "75.62%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "15109430122",
            "name": "SHREYA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "566",
            "maxMarks": "800",
            "percentage": "70.75%",
            "cells": [
              "95",
              "15109430122",
              "SHREYA",
              "SURESH KUMAR",
              "566",
              "800",
              "70.75%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "15109430124",
            "name": "VARSHA",
            "fatherName": "SANJEEV KUMAR",
            "obtainedMarks": "560",
            "maxMarks": "800",
            "percentage": "70%",
            "cells": [
              "96",
              "15109430124",
              "VARSHA",
              "SANJEEV KUMAR",
              "560",
              "800",
              "70%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "15109430126",
            "name": "RAVNEET DHILLON",
            "fatherName": "JAGSEER SINGH DHILLON",
            "obtainedMarks": "598",
            "maxMarks": "800",
            "percentage": "74.75%",
            "cells": [
              "97",
              "15109430126",
              "RAVNEET DHILLON",
              "JAGSEER SINGH DHILLON",
              "598",
              "800",
              "74.75%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "15109430128",
            "name": "KUSHALDEEP",
            "fatherName": "KISHAN CHAND",
            "obtainedMarks": "642",
            "maxMarks": "800",
            "percentage": "80.25%",
            "cells": [
              "98",
              "15109430128",
              "KUSHALDEEP",
              "KISHAN CHAND",
              "642",
              "800",
              "80.25%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "15109430141",
            "name": "TANVI",
            "fatherName": "VIRENDER",
            "obtainedMarks": "606",
            "maxMarks": "800",
            "percentage": "75.75%",
            "cells": [
              "99",
              "15109430141",
              "TANVI",
              "VIRENDER",
              "606",
              "800",
              "75.75%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com(Gen.) I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "100",
            "rollNo": "170090450001",
            "name": "VANSHIKA GOYAL",
            "fatherName": "SUDHIR GOYAL",
            "obtainedMarks": "960",
            "maxMarks": "1150",
            "percentage": "83.48%",
            "cells": [
              "100",
              "170090450001",
              "VANSHIKA GOYAL",
              "SUDHIR GOYAL",
              "960",
              "1150",
              "83.48%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "170090450011",
            "name": "SNEHA KARWASRA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "891",
            "maxMarks": "1150",
            "percentage": "77.48%",
            "cells": [
              "101",
              "170090450011",
              "SNEHA KARWASRA",
              "NARESH KUMAR",
              "891",
              "1150",
              "77.48%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "170090450013",
            "name": "DAMIYANTI",
            "fatherName": "SH DAYANAND",
            "obtainedMarks": "892",
            "maxMarks": "1150",
            "percentage": "77.57%",
            "cells": [
              "102",
              "170090450013",
              "DAMIYANTI",
              "SH DAYANAND",
              "892",
              "1150",
              "77.57%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "170090450018",
            "name": "AARZOO",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "860",
            "maxMarks": "1150",
            "percentage": "74.78%",
            "cells": [
              "103",
              "170090450018",
              "AARZOO",
              "NARESH KUMAR",
              "860",
              "1150",
              "74.78%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "170090450030",
            "name": "JYOTSANA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "831",
            "maxMarks": "1150",
            "percentage": "72.26%",
            "cells": [
              "104",
              "170090450030",
              "JYOTSANA",
              "PREM KUMAR",
              "831",
              "1150",
              "72.26%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "170090450047",
            "name": "SIMRANPREET",
            "fatherName": "KARAMJEET SINGH",
            "obtainedMarks": "857",
            "maxMarks": "1150",
            "percentage": "74.52%",
            "cells": [
              "105",
              "170090450047",
              "SIMRANPREET",
              "KARAMJEET SINGH",
              "857",
              "1150",
              "74.52%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "170090450048",
            "name": "KHUSHBOO",
            "fatherName": "NARESH",
            "obtainedMarks": "916",
            "maxMarks": "1150",
            "percentage": "79.65%",
            "cells": [
              "106",
              "170090450048",
              "KHUSHBOO",
              "NARESH",
              "916",
              "1150",
              "79.65%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "107",
            "rollNo": "16109450009",
            "name": "NISHA",
            "fatherName": "RAM BHAGAT",
            "obtainedMarks": "843",
            "maxMarks": "1200",
            "percentage": "70.25%",
            "cells": [
              "107",
              "16109450009",
              "NISHA",
              "RAM BHAGAT",
              "843",
              "1200",
              "70.25%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "16109450047",
            "name": "MONIKA ARORA",
            "fatherName": "SHAM LAL ARORA",
            "obtainedMarks": "877",
            "maxMarks": "1200",
            "percentage": "73.08%",
            "cells": [
              "108",
              "16109450047",
              "MONIKA ARORA",
              "SHAM LAL ARORA",
              "877",
              "1200",
              "73.08%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "16109450048",
            "name": "GURJOT",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "905",
            "maxMarks": "1200",
            "percentage": "75.42%",
            "cells": [
              "109",
              "16109450048",
              "GURJOT",
              "SUKHDEV SINGH",
              "905",
              "1200",
              "75.42%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "16109450051",
            "name": "GURVINDER KAUR",
            "fatherName": "HARBHAJAN",
            "obtainedMarks": "886",
            "maxMarks": "1200",
            "percentage": "73.83%",
            "cells": [
              "110",
              "16109450051",
              "GURVINDER KAUR",
              "HARBHAJAN",
              "886",
              "1200",
              "73.83%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "16109450054",
            "name": "ANURADHA",
            "fatherName": "PURAN SINGH",
            "obtainedMarks": "898",
            "maxMarks": "1200",
            "percentage": "74.83%",
            "cells": [
              "111",
              "16109450054",
              "ANURADHA",
              "PURAN SINGH",
              "898",
              "1200",
              "74.83%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "16109450060",
            "name": "GAZAL SONI",
            "fatherName": "LAJPAT RAI SONI",
            "obtainedMarks": "799",
            "maxMarks": "1200",
            "percentage": "66.58%",
            "cells": [
              "112",
              "16109450060",
              "GAZAL SONI",
              "LAJPAT RAI SONI",
              "799",
              "1200",
              "66.58%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "16109450063",
            "name": "EKTA",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "872",
            "maxMarks": "1200",
            "percentage": "72.67%",
            "cells": [
              "113",
              "16109450063",
              "EKTA",
              "JAGDISH KUMAR",
              "872",
              "1200",
              "72.67%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "16109450064",
            "name": "ANURADHA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "860",
            "maxMarks": "1200",
            "percentage": "71.67%",
            "cells": [
              "114",
              "16109450064",
              "ANURADHA",
              "SANJAY KUMAR",
              "860",
              "1200",
              "71.67%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) V+VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "115",
            "rollNo": "15109450005",
            "name": "KOMAL RANI",
            "fatherName": "MOHAN KUMAR",
            "obtainedMarks": "879",
            "maxMarks": "1200",
            "percentage": "73.25%",
            "cells": [
              "115",
              "15109450005",
              "KOMAL RANI",
              "MOHAN KUMAR",
              "879",
              "1200",
              "73.25%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "15109450013",
            "name": "PAYAL",
            "fatherName": "SURENDER BHATIA",
            "obtainedMarks": "903",
            "maxMarks": "1200",
            "percentage": "75.25%",
            "cells": [
              "116",
              "15109450013",
              "PAYAL",
              "SURENDER BHATIA",
              "903",
              "1200",
              "75.25%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "15109450031",
            "name": "BHAWNA",
            "fatherName": "RAJESH KHURANA",
            "obtainedMarks": "904",
            "maxMarks": "1200",
            "percentage": "75.33%",
            "cells": [
              "117",
              "15109450031",
              "BHAWNA",
              "RAJESH KHURANA",
              "904",
              "1200",
              "75.33%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "15109450032",
            "name": "POOJA",
            "fatherName": "RAJESH KHURANA",
            "obtainedMarks": "864",
            "maxMarks": "1200",
            "percentage": "72%",
            "cells": [
              "118",
              "15109450032",
              "POOJA",
              "RAJESH KHURANA",
              "864",
              "1200",
              "72%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "15109450033",
            "name": "NAVJOT",
            "fatherName": "HARFOOL SINGH",
            "obtainedMarks": "897",
            "maxMarks": "1200",
            "percentage": "74.75%",
            "cells": [
              "119",
              "15109450033",
              "NAVJOT",
              "HARFOOL SINGH",
              "897",
              "1200",
              "74.75%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "15109450043",
            "name": "SONAL",
            "fatherName": "KEDARNATH ARORA",
            "obtainedMarks": "856",
            "maxMarks": "1200",
            "percentage": "71.33%",
            "cells": [
              "120",
              "15109450043",
              "SONAL",
              "KEDARNATH ARORA",
              "856",
              "1200",
              "71.33%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "15109450045",
            "name": "JYOTI",
            "fatherName": "SHAM LAL",
            "obtainedMarks": "872",
            "maxMarks": "1200",
            "percentage": "72.67%",
            "cells": [
              "121",
              "15109450045",
              "JYOTI",
              "SHAM LAL",
              "872",
              "1200",
              "72.67%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "15109450054",
            "name": "MONIKA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "887",
            "maxMarks": "1200",
            "percentage": "73.92%",
            "cells": [
              "122",
              "15109450054",
              "MONIKA",
              "RAJ KUMAR",
              "887",
              "1200",
              "73.92%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "15109450055",
            "name": "MEENA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "892",
            "maxMarks": "1200",
            "percentage": "74.33%",
            "cells": [
              "123",
              "15109450055",
              "MEENA",
              "SURESH KUMAR",
              "892",
              "1200",
              "74.33%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "15109450064",
            "name": "KAJAL",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "928",
            "maxMarks": "1200",
            "percentage": "77.33%",
            "cells": [
              "124",
              "15109450064",
              "KAJAL",
              "SUNIL KUMAR",
              "928",
              "1200",
              "77.33%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com(Voc.) I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "125",
            "rollNo": "170090460002",
            "name": "KAMALPREET KAUR",
            "fatherName": "JASKARAN SINGH",
            "obtainedMarks": "880",
            "maxMarks": "1150",
            "percentage": "76.52%",
            "cells": [
              "125",
              "170090460002",
              "KAMALPREET KAUR",
              "JASKARAN SINGH",
              "880",
              "1150",
              "76.52%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "170090460003",
            "name": "SIMRAN",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "782",
            "maxMarks": "1150",
            "percentage": "68%",
            "cells": [
              "126",
              "170090460003",
              "SIMRAN",
              "SURENDER KUMAR",
              "782",
              "1150",
              "68%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "170090460005",
            "name": "ARMANPREET KAUR",
            "fatherName": "SURINDER SINGH",
            "obtainedMarks": "768",
            "maxMarks": "1150",
            "percentage": "66.78%",
            "cells": [
              "127",
              "170090460005",
              "ARMANPREET KAUR",
              "SURINDER SINGH",
              "768",
              "1150",
              "66.78%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "170090460006",
            "name": "GURPREET KAUR",
            "fatherName": "MANISH KUMAR",
            "obtainedMarks": "821",
            "maxMarks": "1150",
            "percentage": "71.39%",
            "cells": [
              "128",
              "170090460006",
              "GURPREET KAUR",
              "MANISH KUMAR",
              "821",
              "1150",
              "71.39%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "170090460007",
            "name": "MAMTA",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "858",
            "maxMarks": "1150",
            "percentage": "74.61%",
            "cells": [
              "129",
              "170090460007",
              "MAMTA",
              "BALBIR SINGH",
              "858",
              "1150",
              "74.61%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "130",
            "rollNo": "16109460002",
            "name": "SHIVANI",
            "fatherName": "DARSHAN LAL",
            "obtainedMarks": "859",
            "maxMarks": "1200",
            "percentage": "71.58%",
            "cells": [
              "130",
              "16109460002",
              "SHIVANI",
              "DARSHAN LAL",
              "859",
              "1200",
              "71.58%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "16109460003",
            "name": "ANJALI",
            "fatherName": "ISHWER CHAND",
            "obtainedMarks": "865",
            "maxMarks": "1200",
            "percentage": "72.08%",
            "cells": [
              "131",
              "16109460003",
              "ANJALI",
              "ISHWER CHAND",
              "865",
              "1200",
              "72.08%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "16109460007",
            "name": "MANIT",
            "fatherName": "CHHABIL DASS",
            "obtainedMarks": "988",
            "maxMarks": "1200",
            "percentage": "82.33%",
            "cells": [
              "132",
              "16109460007",
              "MANIT",
              "CHHABIL DASS",
              "988",
              "1200",
              "82.33%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "16109460009",
            "name": "NISHA RANI",
            "fatherName": "JOGINDER SINGH",
            "obtainedMarks": "845",
            "maxMarks": "1200",
            "percentage": "70.42%",
            "cells": [
              "133",
              "16109460009",
              "NISHA RANI",
              "JOGINDER SINGH",
              "845",
              "1200",
              "70.42%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "16109460011",
            "name": "SIMARJEET KAUR",
            "fatherName": "AMRIK SINGH",
            "obtainedMarks": "974",
            "maxMarks": "1200",
            "percentage": "81.17%",
            "cells": [
              "134",
              "16109460011",
              "SIMARJEET KAUR",
              "AMRIK SINGH",
              "974",
              "1200",
              "81.17%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "16109460012",
            "name": "SIMRAN",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "874",
            "maxMarks": "1200",
            "percentage": "72.83%",
            "cells": [
              "135",
              "16109460012",
              "SIMRAN",
              "PAWAN KUMAR",
              "874",
              "1200",
              "72.83%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "16109460014",
            "name": "PRIYANKA GARG",
            "fatherName": "ARJUN DAS",
            "obtainedMarks": "957",
            "maxMarks": "1200",
            "percentage": "79.75%",
            "cells": [
              "136",
              "16109460014",
              "PRIYANKA GARG",
              "ARJUN DAS",
              "957",
              "1200",
              "79.75%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "16109460016",
            "name": "NALINI KAMBOJ",
            "fatherName": "RAMESH CHANDER",
            "obtainedMarks": "860",
            "maxMarks": "1200",
            "percentage": "71.67%",
            "cells": [
              "137",
              "16109460016",
              "NALINI KAMBOJ",
              "RAMESH CHANDER",
              "860",
              "1200",
              "71.67%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "16109460019",
            "name": "HEENA",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "917",
            "maxMarks": "1200",
            "percentage": "76.42%",
            "cells": [
              "138",
              "16109460019",
              "HEENA",
              "SURINDER KUMAR",
              "917",
              "1200",
              "76.42%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "16109460020",
            "name": "KHUSHPREET KAUR",
            "fatherName": "BALKARAN SINGH",
            "obtainedMarks": "874",
            "maxMarks": "1200",
            "percentage": "72.83%",
            "cells": [
              "139",
              "16109460020",
              "KHUSHPREET KAUR",
              "BALKARAN SINGH",
              "874",
              "1200",
              "72.83%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "16109460021",
            "name": "NEELAM RANI",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "979",
            "maxMarks": "1200",
            "percentage": "81.58%",
            "cells": [
              "140",
              "16109460021",
              "NEELAM RANI",
              "AMAR SINGH",
              "979",
              "1200",
              "81.58%"
            ]
          },
          {
            "sNo": "141",
            "rollNo": "16109460022",
            "name": "MAMTA CHOYAL",
            "fatherName": "SURJEET CHOYAL",
            "obtainedMarks": "1012",
            "maxMarks": "1200",
            "percentage": "84.33%",
            "cells": [
              "141",
              "16109460022",
              "MAMTA CHOYAL",
              "SURJEET CHOYAL",
              "1012",
              "1200",
              "84.33%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "16109460023",
            "name": "NANCY GARG",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "1068",
            "maxMarks": "1200",
            "percentage": "89%",
            "cells": [
              "142",
              "16109460023",
              "NANCY GARG",
              "NARESH KUMAR",
              "1068",
              "1200",
              "89%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "16109460024",
            "name": "NEELAM",
            "fatherName": "ROHTASH",
            "obtainedMarks": "895",
            "maxMarks": "1200",
            "percentage": "74.58%",
            "cells": [
              "143",
              "16109460024",
              "NEELAM",
              "ROHTASH",
              "895",
              "1200",
              "74.58%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "16109460026",
            "name": "BHAWNA SONI",
            "fatherName": "KRISHAN SONI",
            "obtainedMarks": "1004",
            "maxMarks": "1200",
            "percentage": "83.67%",
            "cells": [
              "144",
              "16109460026",
              "BHAWNA SONI",
              "KRISHAN SONI",
              "1004",
              "1200",
              "83.67%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "16109460027",
            "name": "HEENA BHATIA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "929",
            "maxMarks": "1200",
            "percentage": "77.42%",
            "cells": [
              "145",
              "16109460027",
              "HEENA BHATIA",
              "VIJAY KUMAR",
              "929",
              "1200",
              "77.42%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "16109460028",
            "name": "PALAKPREET",
            "fatherName": "JAGDISH RAI",
            "obtainedMarks": "965",
            "maxMarks": "1200",
            "percentage": "80.42%",
            "cells": [
              "146",
              "16109460028",
              "PALAKPREET",
              "JAGDISH RAI",
              "965",
              "1200",
              "80.42%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "16109460030",
            "name": "JASHANDEEP KAUR",
            "fatherName": "RAJVINDER SINGH",
            "obtainedMarks": "869",
            "maxMarks": "1200",
            "percentage": "72.42%",
            "cells": [
              "147",
              "16109460030",
              "JASHANDEEP KAUR",
              "RAJVINDER SINGH",
              "869",
              "1200",
              "72.42%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "16109460038",
            "name": "HIMANI RATHORE",
            "fatherName": "BHARAT SINGH RATHORE",
            "obtainedMarks": "926",
            "maxMarks": "1200",
            "percentage": "77.17%",
            "cells": [
              "148",
              "16109460038",
              "HIMANI RATHORE",
              "BHARAT SINGH RATHORE",
              "926",
              "1200",
              "77.17%"
            ]
          },
          {
            "sNo": "149",
            "rollNo": "16109460040",
            "name": "RABNOOR PURI",
            "fatherName": "HARBANS SINGH",
            "obtainedMarks": "860",
            "maxMarks": "1200",
            "percentage": "71.67%",
            "cells": [
              "149",
              "16109460040",
              "RABNOOR PURI",
              "HARBANS SINGH",
              "860",
              "1200",
              "71.67%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) V +VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "150",
            "rollNo": "15109460007",
            "name": "POONAM",
            "fatherName": "RAM MURTI",
            "obtainedMarks": "861",
            "maxMarks": "1200",
            "percentage": "71.75%",
            "cells": [
              "150",
              "15109460007",
              "POONAM",
              "RAM MURTI",
              "861",
              "1200",
              "71.75%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "15109460009",
            "name": "KHUSHPREET",
            "fatherName": "MEGH RAJ",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "74.67%",
            "cells": [
              "151",
              "15109460009",
              "KHUSHPREET",
              "MEGH RAJ",
              "896",
              "1200",
              "74.67%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "15109460010",
            "name": "SHAILA",
            "fatherName": "GULSHAN SARDANA",
            "obtainedMarks": "852",
            "maxMarks": "1200",
            "percentage": "71%",
            "cells": [
              "152",
              "15109460010",
              "SHAILA",
              "GULSHAN SARDANA",
              "852",
              "1200",
              "71%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "15109460011",
            "name": "RAJNI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "932",
            "maxMarks": "1200",
            "percentage": "77.67%",
            "cells": [
              "153",
              "15109460011",
              "RAJNI",
              "KEWAL KRISHAN",
              "932",
              "1200",
              "77.67%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "15109460016",
            "name": "SHALU",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "843",
            "maxMarks": "1200",
            "percentage": "70.25%",
            "cells": [
              "154",
              "15109460016",
              "SHALU",
              "RAJ KUMAR",
              "843",
              "1200",
              "70.25%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "15109460019",
            "name": "REKHA",
            "fatherName": "RAMPRATAP",
            "obtainedMarks": "851",
            "maxMarks": "1200",
            "percentage": "70.92%",
            "cells": [
              "155",
              "15109460019",
              "REKHA",
              "RAMPRATAP",
              "851",
              "1200",
              "70.92%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "15109460020",
            "name": "PREKSHA",
            "fatherName": "SURENDER",
            "obtainedMarks": "898",
            "maxMarks": "1200",
            "percentage": "74.83%",
            "cells": [
              "156",
              "15109460020",
              "PREKSHA",
              "SURENDER",
              "898",
              "1200",
              "74.83%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "15109460021",
            "name": "NAINA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "883",
            "maxMarks": "1200",
            "percentage": "73.58%",
            "cells": [
              "157",
              "15109460021",
              "NAINA",
              "RAJ KUMAR",
              "883",
              "1200",
              "73.58%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "15109460022",
            "name": "BHAWANA GUPTA",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "929",
            "maxMarks": "1200",
            "percentage": "77.42%",
            "cells": [
              "158",
              "15109460022",
              "BHAWANA GUPTA",
              "SURINDER KUMAR",
              "929",
              "1200",
              "77.42%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "15109460026",
            "name": "PREETI",
            "fatherName": "DHARAMPAL SINGH",
            "obtainedMarks": "892",
            "maxMarks": "1200",
            "percentage": "74.33%",
            "cells": [
              "159",
              "15109460026",
              "PREETI",
              "DHARAMPAL SINGH",
              "892",
              "1200",
              "74.33%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "15109460027",
            "name": "MONIKA",
            "fatherName": "BHAGAT SINGH",
            "obtainedMarks": "932",
            "maxMarks": "1200",
            "percentage": "77.67%",
            "cells": [
              "160",
              "15109460027",
              "MONIKA",
              "BHAGAT SINGH",
              "932",
              "1200",
              "77.67%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "15109460032",
            "name": "ROOMANA",
            "fatherName": "JAGDISH PRASAD",
            "obtainedMarks": "849",
            "maxMarks": "1200",
            "percentage": "70.75%",
            "cells": [
              "161",
              "15109460032",
              "ROOMANA",
              "JAGDISH PRASAD",
              "849",
              "1200",
              "70.75%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "15109460033",
            "name": "RUPA",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "859",
            "maxMarks": "1200",
            "percentage": "71.58%",
            "cells": [
              "162",
              "15109460033",
              "RUPA",
              "SOHAN PAL",
              "859",
              "1200",
              "71.58%"
            ]
          }
        ]
      },
      {
        "courseName": "B.SC (NM) I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "163",
            "rollNo": "170090442006",
            "name": "GURPUNEET\n KAUR",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "890",
            "maxMarks": "1100",
            "percentage": "80.91%",
            "cells": [
              "163",
              "170090442006",
              "GURPUNEET\n KAUR",
              "RAM SINGH",
              "890",
              "1100",
              "80.91%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "170090442008",
            "name": "MANPREET KAUR",
            "fatherName": "CHAKOTAR SINGH",
            "obtainedMarks": "830",
            "maxMarks": "1100",
            "percentage": "75.45%",
            "cells": [
              "164",
              "170090442008",
              "MANPREET KAUR",
              "CHAKOTAR SINGH",
              "830",
              "1100",
              "75.45%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "170090442012",
            "name": "REEYA",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "898",
            "maxMarks": "1100",
            "percentage": "81.64%",
            "cells": [
              "165",
              "170090442012",
              "REEYA",
              "RAVINDER KUMAR",
              "898",
              "1100",
              "81.64%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "170090442018",
            "name": "JEENU",
            "fatherName": "GORI SHANKAR",
            "obtainedMarks": "855",
            "maxMarks": "1100",
            "percentage": "77.73%",
            "cells": [
              "166",
              "170090442018",
              "JEENU",
              "GORI SHANKAR",
              "855",
              "1100",
              "77.73%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "170090442020",
            "name": "SHAKILA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "916",
            "maxMarks": "1100",
            "percentage": "83.27%",
            "cells": [
              "167",
              "170090442020",
              "SHAKILA",
              "MAHENDER SINGH",
              "916",
              "1100",
              "83.27%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "170090442021",
            "name": "PRITPAL KAUR",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "911",
            "maxMarks": "1100",
            "percentage": "82.82%",
            "cells": [
              "168",
              "170090442021",
              "PRITPAL KAUR",
              "RAJENDER SINGH",
              "911",
              "1100",
              "82.82%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "170090442023",
            "name": "ANKISHA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "877",
            "maxMarks": "1100",
            "percentage": "79.73%",
            "cells": [
              "169",
              "170090442023",
              "ANKISHA",
              "SHAMSHER SINGH",
              "877",
              "1100",
              "79.73%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "170090442027",
            "name": "KAILASH",
            "fatherName": "RAMESH \nCHANDER",
            "obtainedMarks": "867",
            "maxMarks": "1100",
            "percentage": "78.82%",
            "cells": [
              "170",
              "170090442027",
              "KAILASH",
              "RAMESH \nCHANDER",
              "867",
              "1100",
              "78.82%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "170090442035",
            "name": "ANJU RANI",
            "fatherName": "RAJVEER",
            "obtainedMarks": "882",
            "maxMarks": "1100",
            "percentage": "80.18%",
            "cells": [
              "171",
              "170090442035",
              "ANJU RANI",
              "RAJVEER",
              "882",
              "1100",
              "80.18%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "170090442037",
            "name": "DIKSHA RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "909",
            "maxMarks": "1100",
            "percentage": "82.64%",
            "cells": [
              "172",
              "170090442037",
              "DIKSHA RANI",
              "GOPAL",
              "909",
              "1100",
              "82.64%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "170090442039",
            "name": "SUKHBHEJ KAUR",
            "fatherName": "BHUPINDER SINGH",
            "obtainedMarks": "790",
            "maxMarks": "1100",
            "percentage": "71.82%",
            "cells": [
              "173",
              "170090442039",
              "SUKHBHEJ KAUR",
              "BHUPINDER SINGH",
              "790",
              "1100",
              "71.82%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "174",
            "rollNo": "16109442003",
            "name": "MANPREET KAUR",
            "fatherName": "JEET SINGH",
            "obtainedMarks": "734",
            "maxMarks": "1000",
            "percentage": "73.40%",
            "cells": [
              "174",
              "16109442003",
              "MANPREET KAUR",
              "JEET SINGH",
              "734",
              "1000",
              "73.40%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "16109442007",
            "name": "NISHA RANI",
            "fatherName": "SUKHWINDER KUMAR",
            "obtainedMarks": "771",
            "maxMarks": "1000",
            "percentage": "77.10%",
            "cells": [
              "175",
              "16109442007",
              "NISHA RANI",
              "SUKHWINDER KUMAR",
              "771",
              "1000",
              "77.10%"
            ]
          },
          {
            "sNo": "176",
            "rollNo": "16109442008",
            "name": "SHAINA GARG",
            "fatherName": "JAIPAL GARG",
            "obtainedMarks": "752",
            "maxMarks": "1000",
            "percentage": "75.20%",
            "cells": [
              "176",
              "16109442008",
              "SHAINA GARG",
              "JAIPAL GARG",
              "752",
              "1000",
              "75.20%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "16109442009",
            "name": "AARZOO",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "710",
            "maxMarks": "1000",
            "percentage": "71%",
            "cells": [
              "177",
              "16109442009",
              "AARZOO",
              "RAVINDER KUMAR",
              "710",
              "1000",
              "71%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "16109442016",
            "name": "BEANT KAUR",
            "fatherName": "KAMIKAR SINGH",
            "obtainedMarks": "843",
            "maxMarks": "1000",
            "percentage": "84.30%",
            "cells": [
              "178",
              "16109442016",
              "BEANT KAUR",
              "KAMIKAR SINGH",
              "843",
              "1000",
              "84.30%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "16109442017",
            "name": "PRIYANKA RANI",
            "fatherName": "VINOD SHARMA",
            "obtainedMarks": "706",
            "maxMarks": "1000",
            "percentage": "70.60%",
            "cells": [
              "179",
              "16109442017",
              "PRIYANKA RANI",
              "VINOD SHARMA",
              "706",
              "1000",
              "70.60%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "16109442026",
            "name": "NAMITA",
            "fatherName": "PREM POPLI",
            "obtainedMarks": "724",
            "maxMarks": "1000",
            "percentage": "72.40%",
            "cells": [
              "180",
              "16109442026",
              "NAMITA",
              "PREM POPLI",
              "724",
              "1000",
              "72.40%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "16109442037",
            "name": "PARUL",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "831",
            "maxMarks": "1000",
            "percentage": "83.10%",
            "cells": [
              "181",
              "16109442037",
              "PARUL",
              "SUSHIL KUMAR",
              "831",
              "1000",
              "83.10%"
            ]
          },
          {
            "sNo": "182",
            "rollNo": "16109442041",
            "name": "ANSHU",
            "fatherName": "GURMEET KUMAR",
            "obtainedMarks": "765",
            "maxMarks": "1000",
            "percentage": "76.50%",
            "cells": [
              "182",
              "16109442041",
              "ANSHU",
              "GURMEET KUMAR",
              "765",
              "1000",
              "76.50%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "16109442044",
            "name": "HARMEET KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "730",
            "maxMarks": "1000",
            "percentage": "73%",
            "cells": [
              "183",
              "16109442044",
              "HARMEET KAUR",
              "JASPAL SINGH",
              "730",
              "1000",
              "73%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "16109442055",
            "name": "SHIVANI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "764",
            "maxMarks": "1000",
            "percentage": "76.40%",
            "cells": [
              "184",
              "16109442055",
              "SHIVANI",
              "KEWAL KRISHAN",
              "764",
              "1000",
              "76.40%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "16109442056",
            "name": "KOMAL RANI",
            "fatherName": "RAM CHAND",
            "obtainedMarks": "739",
            "maxMarks": "1000",
            "percentage": "73.90%",
            "cells": [
              "185",
              "16109442056",
              "KOMAL RANI",
              "RAM CHAND",
              "739",
              "1000",
              "73.90%"
            ]
          },
          {
            "sNo": "186",
            "rollNo": "16109442057",
            "name": "KRITIKA",
            "fatherName": "MEKH RAM",
            "obtainedMarks": "765",
            "maxMarks": "1000",
            "percentage": "76.50%",
            "cells": [
              "186",
              "16109442057",
              "KRITIKA",
              "MEKH RAM",
              "765",
              "1000",
              "76.50%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM.) V+VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "187",
            "rollNo": "14109442001",
            "name": "SUMAN LATA",
            "fatherName": "SATBIR SINGH",
            "obtainedMarks": "767",
            "maxMarks": "900",
            "percentage": "85.22%",
            "cells": [
              "187",
              "14109442001",
              "SUMAN LATA",
              "SATBIR SINGH",
              "767",
              "900",
              "85.22%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "15109442003",
            "name": "GURPREET KAUR",
            "fatherName": "GOVIND SINGH",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.22%",
            "cells": [
              "188",
              "15109442003",
              "GURPREET KAUR",
              "GOVIND SINGH",
              "677",
              "900",
              "75.22%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "15109442004",
            "name": "SHRUTI SHARMA",
            "fatherName": "RADHE SHYAM",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "189",
              "15109442004",
              "SHRUTI SHARMA",
              "RADHE SHYAM",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "15109442009",
            "name": "BHAWNA",
            "fatherName": "YATINDER SINGH",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "190",
              "15109442009",
              "BHAWNA",
              "YATINDER SINGH",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "15109442016",
            "name": "PRIYANKA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "191",
              "15109442016",
              "PRIYANKA",
              "MADAN LAL",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "192",
            "rollNo": "15109442018",
            "name": "EKTA SHARMA",
            "fatherName": "SANJAY SHARMA",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.89%",
            "cells": [
              "192",
              "15109442018",
              "EKTA SHARMA",
              "SANJAY SHARMA",
              "737",
              "900",
              "81.89%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "15109442020",
            "name": "HEENA",
            "fatherName": "KESHAV MADAM",
            "obtainedMarks": "752",
            "maxMarks": "900",
            "percentage": "83.56%",
            "cells": [
              "193",
              "15109442020",
              "HEENA",
              "KESHAV MADAM",
              "752",
              "900",
              "83.56%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "15109442031",
            "name": "PRIYANKA",
            "fatherName": "SATPAL",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "194",
              "15109442031",
              "PRIYANKA",
              "SATPAL",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "15109442032",
            "name": "MONIKA",
            "fatherName": "DHAN SINGH",
            "obtainedMarks": "722",
            "maxMarks": "900",
            "percentage": "80.22%",
            "cells": [
              "195",
              "15109442032",
              "MONIKA",
              "DHAN SINGH",
              "722",
              "900",
              "80.22%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "15109442033",
            "name": "HARSHPREET CHEEMA",
            "fatherName": "JAIPAL SINGH",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.78%",
            "cells": [
              "196",
              "15109442033",
              "HARSHPREET CHEEMA",
              "JAIPAL SINGH",
              "637",
              "900",
              "70.78%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "15109442034",
            "name": "RUPALI",
            "fatherName": "SANJEEV KHURANA",
            "obtainedMarks": "704",
            "maxMarks": "900",
            "percentage": "78.22%",
            "cells": [
              "197",
              "15109442034",
              "RUPALI",
              "SANJEEV KHURANA",
              "704",
              "900",
              "78.22%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "15109442035",
            "name": "JYOTI",
            "fatherName": "NIHAL SINGH",
            "obtainedMarks": "712",
            "maxMarks": "900",
            "percentage": "79.11%",
            "cells": [
              "198",
              "15109442035",
              "JYOTI",
              "NIHAL SINGH",
              "712",
              "900",
              "79.11%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "15109442041",
            "name": "PARUL GANDHI",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "664",
            "maxMarks": "900",
            "percentage": "73.78%",
            "cells": [
              "199",
              "15109442041",
              "PARUL GANDHI",
              "NARESH KUMAR",
              "664",
              "900",
              "73.78%"
            ]
          }
        ]
      },
      {
        "courseName": "B.SC(CS) I+II  Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "200",
            "rollNo": "170090440006",
            "name": "SAROJ RANI",
            "fatherName": "SATPAL",
            "obtainedMarks": "810",
            "maxMarks": "1100",
            "percentage": "73.63%",
            "cells": [
              "200",
              "170090440006",
              "SAROJ RANI",
              "SATPAL",
              "810",
              "1100",
              "73.63%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "201",
            "rollNo": "16109440007",
            "name": "PRIYANKA",
            "fatherName": "MAHINDER SINGH",
            "obtainedMarks": "832",
            "maxMarks": "1000",
            "percentage": "83.20%",
            "cells": [
              "201",
              "16109440007",
              "PRIYANKA",
              "MAHINDER SINGH",
              "832",
              "1000",
              "83.20%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS.) V+VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "202",
            "rollNo": "15109440013",
            "name": "SANDHYA",
            "fatherName": "JAGAT PAL",
            "obtainedMarks": "743",
            "maxMarks": "900",
            "percentage": "82.50%",
            "cells": [
              "202",
              "15109440013",
              "SANDHYA",
              "JAGAT PAL",
              "743",
              "900",
              "82.50%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "15109440016",
            "name": "DEEPIKA",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "674",
            "maxMarks": "900",
            "percentage": "74.80%",
            "cells": [
              "203",
              "15109440016",
              "DEEPIKA",
              "RANBIR SINGH",
              "674",
              "900",
              "74.80%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA I+II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "204",
            "rollNo": "16109480003",
            "name": "PARIVINKAL THIND",
            "fatherName": "HARJINDER  SINGH",
            "obtainedMarks": "857",
            "maxMarks": "1200",
            "percentage": "71.41%",
            "cells": [
              "204",
              "16109480003",
              "PARIVINKAL THIND",
              "HARJINDER  SINGH",
              "857",
              "1200",
              "71.41%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "16109480004",
            "name": "MANDEEP KAUR",
            "fatherName": "SUKHMINDER SINGH",
            "obtainedMarks": "899",
            "maxMarks": "1200",
            "percentage": "74.92%",
            "cells": [
              "205",
              "16109480004",
              "MANDEEP KAUR",
              "SUKHMINDER SINGH",
              "899",
              "1200",
              "74.92%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "16109480010",
            "name": "NAVJEET KAUR",
            "fatherName": "LAKHVINDER SINGH",
            "obtainedMarks": "877",
            "maxMarks": "1200",
            "percentage": "73.08%",
            "cells": [
              "206",
              "16109480010",
              "NAVJEET KAUR",
              "LAKHVINDER SINGH",
              "877",
              "1200",
              "73.08%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "16109480011",
            "name": "NAVNEET KAUR",
            "fatherName": "GURPREET SINGH",
            "obtainedMarks": "874",
            "maxMarks": "1200",
            "percentage": "72.83%",
            "cells": [
              "207",
              "16109480011",
              "NAVNEET KAUR",
              "GURPREET SINGH",
              "874",
              "1200",
              "72.83%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "16109480017",
            "name": "ROOHJEET INSAN",
            "fatherName": "ST. GURMEET RAM RAHIM SINGH JI INASN",
            "obtainedMarks": "862",
            "maxMarks": "1200",
            "percentage": "71.83%",
            "cells": [
              "208",
              "16109480017",
              "ROOHJEET INSAN",
              "ST. GURMEET RAM RAHIM SINGH JI INASN",
              "862",
              "1200",
              "71.83%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA V+VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "209",
            "rollNo": "15109480004",
            "name": "JYOTI",
            "fatherName": "DEEPAK KUMAR",
            "obtainedMarks": "886",
            "maxMarks": "1250",
            "percentage": "70.80%",
            "cells": [
              "209",
              "15109480004",
              "JYOTI",
              "DEEPAK KUMAR",
              "886",
              "1250",
              "70.80%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA I +II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BCA III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "210",
            "rollNo": "16109470009",
            "name": "RASHMI",
            "fatherName": "VEERBHAN",
            "obtainedMarks": "1217",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "210",
              "16109470009",
              "RASHMI",
              "VEERBHAN",
              "1217",
              "1600",
              "76%"
            ]
          }
        ]
      },
      {
        "courseName": "BAMC I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "211",
            "rollNo": "16109420011",
            "name": "RIYA GOYAL",
            "fatherName": "BIMAL GOYAL",
            "obtainedMarks": "735",
            "maxMarks": "1000",
            "percentage": "73.50%",
            "cells": [
              "211",
              "16109420011",
              "RIYA GOYAL",
              "BIMAL GOYAL",
              "735",
              "1000",
              "73.50%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "16109420012",
            "name": "GURPREET",
            "fatherName": "JAI CHAND",
            "obtainedMarks": "742",
            "maxMarks": "1000",
            "percentage": "74.20%",
            "cells": [
              "212",
              "16109420012",
              "GURPREET",
              "JAI CHAND",
              "742",
              "1000",
              "74.20%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "16109420013",
            "name": "SIMRAN GANDHI",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "742",
            "maxMarks": "1000",
            "percentage": "74.20%",
            "cells": [
              "213",
              "16109420013",
              "SIMRAN GANDHI",
              "SANDEEP KUMAR",
              "742",
              "1000",
              "74.20%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "16109420016",
            "name": "REENA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "751",
            "maxMarks": "1000",
            "percentage": "75.10%",
            "cells": [
              "214",
              "16109420016",
              "REENA",
              "RAJENDER",
              "751",
              "1000",
              "75.10%"
            ]
          }
        ]
      },
      {
        "courseName": "BAMC III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "215",
            "rollNo": "15109420001",
            "name": "SHEETAL",
            "fatherName": "BHAJAN LAL",
            "obtainedMarks": "711",
            "maxMarks": "1000",
            "percentage": "71.10%",
            "cells": [
              "215",
              "15109420001",
              "SHEETAL",
              "BHAJAN LAL",
              "711",
              "1000",
              "71.10%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "15109420006",
            "name": "GURWINDER KAUR",
            "fatherName": "MANJIT SINGH",
            "obtainedMarks": "711",
            "maxMarks": "1000",
            "percentage": "71.10%",
            "cells": [
              "216",
              "15109420006",
              "GURWINDER KAUR",
              "MANJIT SINGH",
              "711",
              "1000",
              "71.10%"
            ]
          },
          {
            "sNo": "217",
            "rollNo": "15109420008",
            "name": "CHHAYA",
            "fatherName": "MAAN SINGH",
            "obtainedMarks": "759",
            "maxMarks": "1000",
            "percentage": "75.90%",
            "cells": [
              "217",
              "15109420008",
              "CHHAYA",
              "MAAN SINGH",
              "759",
              "1000",
              "75.90%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A  Eng.I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "170090250005",
            "name": "ARSHDEEP KAUR",
            "fatherName": "RACHHPAL SINGH",
            "obtainedMarks": "898",
            "maxMarks": "1400",
            "percentage": "64.14%",
            "cells": [
              "1",
              "170090250005",
              "ARSHDEEP KAUR",
              "RACHHPAL SINGH",
              "898",
              "1400",
              "64.14%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Eng.III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "2",
            "rollNo": "16109250003",
            "name": "RUPALI",
            "fatherName": "SOMNATH",
            "obtainedMarks": "623",
            "maxMarks": "1000",
            "percentage": "62.30%",
            "cells": [
              "2",
              "16109250003",
              "RUPALI",
              "SOMNATH",
              "623",
              "1000",
              "62.30%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A PUB. ADM.  I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "3",
            "rollNo": "170090260001",
            "name": "SHEELA DEVI",
            "fatherName": "SHAMSHER KUNDU",
            "obtainedMarks": "927",
            "maxMarks": "1400",
            "percentage": "66.21%",
            "cells": [
              "3",
              "170090260001",
              "SHEELA DEVI",
              "SHAMSHER KUNDU",
              "927",
              "1400",
              "66.21%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "170090260002",
            "name": "MEENA RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1028",
            "maxMarks": "1400",
            "percentage": "73.43%",
            "cells": [
              "4",
              "170090260002",
              "MEENA RANI",
              "MADAN LAL",
              "1028",
              "1400",
              "73.43%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "170090260003",
            "name": "POOJA",
            "fatherName": "MAHABIR SINGH",
            "obtainedMarks": "1013",
            "maxMarks": "1400",
            "percentage": "72.36%",
            "cells": [
              "5",
              "170090260003",
              "POOJA",
              "MAHABIR SINGH",
              "1013",
              "1400",
              "72.36%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "170090260006",
            "name": "REEMA",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "981",
            "maxMarks": "1400",
            "percentage": "70.07%",
            "cells": [
              "6",
              "170090260006",
              "REEMA",
              "ASHOK KUMAR",
              "981",
              "1400",
              "70.07%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm. III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "7",
            "rollNo": "16109260001",
            "name": "POOJA",
            "fatherName": "RANDHIR SINGH",
            "obtainedMarks": "714",
            "maxMarks": "1000",
            "percentage": "71.40%",
            "cells": [
              "7",
              "16109260001",
              "POOJA",
              "RANDHIR SINGH",
              "714",
              "1000",
              "71.40%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "16109260002",
            "name": "MANJU",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "659",
            "maxMarks": "1000",
            "percentage": "65.90%",
            "cells": [
              "8",
              "16109260002",
              "MANJU",
              "RAJINDER SINGH",
              "659",
              "1000",
              "65.90%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "16109260003",
            "name": "RENU",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "751",
            "maxMarks": "1000",
            "percentage": "75.10%",
            "cells": [
              "9",
              "16109260003",
              "RENU",
              "RAJINDER SINGH",
              "751",
              "1000",
              "75.10%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "16109260004",
            "name": "MEENA",
            "fatherName": "BASWA RAM",
            "obtainedMarks": "691",
            "maxMarks": "1000",
            "percentage": "69.10%",
            "cells": [
              "10",
              "16109260004",
              "MEENA",
              "BASWA RAM",
              "691",
              "1000",
              "69.10%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "16109260008",
            "name": "SANTOSH KUMARI",
            "fatherName": "CHANDER BHAN",
            "obtainedMarks": "657",
            "maxMarks": "1000",
            "percentage": "65.70%",
            "cells": [
              "11",
              "16109260008",
              "SANTOSH KUMARI",
              "CHANDER BHAN",
              "657",
              "1000",
              "65.70%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "16109260009",
            "name": "SAROJ",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "662",
            "maxMarks": "1000",
            "percentage": "66.20%",
            "cells": [
              "12",
              "16109260009",
              "SAROJ",
              "MAHENDER SINGH",
              "662",
              "1000",
              "66.20%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "16109260011",
            "name": "JYOTI BAI",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "685",
            "maxMarks": "1000",
            "percentage": "68.50%",
            "cells": [
              "13",
              "16109260011",
              "JYOTI BAI",
              "DHARAMPAL",
              "685",
              "1000",
              "68.50%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "16109260012",
            "name": "SUMAN",
            "fatherName": "KARM CHAND",
            "obtainedMarks": "664",
            "maxMarks": "1000",
            "percentage": "66.40%",
            "cells": [
              "14",
              "16109260012",
              "SUMAN",
              "KARM CHAND",
              "664",
              "1000",
              "66.40%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "16109260013",
            "name": "SUJATA RANI",
            "fatherName": "BALRAJ",
            "obtainedMarks": "731",
            "maxMarks": "1000",
            "percentage": "73.10%",
            "cells": [
              "15",
              "16109260013",
              "SUJATA RANI",
              "BALRAJ",
              "731",
              "1000",
              "73.10%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC MATHS I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "16",
            "rollNo": "170090140003",
            "name": "MANJU",
            "fatherName": "TULSI DAS",
            "obtainedMarks": "988",
            "maxMarks": "1400",
            "percentage": "70.57%",
            "cells": [
              "16",
              "170090140003",
              "MANJU",
              "TULSI DAS",
              "988",
              "1400",
              "70.57%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "170090140005",
            "name": "NANCY CHAWLA",
            "fatherName": "PREM PARKASH",
            "obtainedMarks": "1012",
            "maxMarks": "1400",
            "percentage": "72.29%",
            "cells": [
              "17",
              "170090140005",
              "NANCY CHAWLA",
              "PREM PARKASH",
              "1012",
              "1400",
              "72.29%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "170090140009",
            "name": "SHELLY",
            "fatherName": "SANJEEV MUNJAL",
            "obtainedMarks": "982",
            "maxMarks": "1400",
            "percentage": "70.14%",
            "cells": [
              "18",
              "170090140009",
              "SHELLY",
              "SANJEEV MUNJAL",
              "982",
              "1400",
              "70.14%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "170090140010",
            "name": "NEHA DEVI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "988",
            "maxMarks": "1400",
            "percentage": "70.57%",
            "cells": [
              "19",
              "170090140010",
              "NEHA DEVI",
              "RAMESH KUMAR",
              "988",
              "1400",
              "70.57%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "170090140011",
            "name": "SANJOLI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "1054",
            "maxMarks": "1400",
            "percentage": "75.29%",
            "cells": [
              "20",
              "170090140011",
              "SANJOLI",
              "SUNIL KUMAR",
              "1054",
              "1400",
              "75.29%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "170090140012",
            "name": "PRIYANKA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "995",
            "maxMarks": "1400",
            "percentage": "71.07%",
            "cells": [
              "21",
              "170090140012",
              "PRIYANKA",
              "VINOD KUMAR",
              "995",
              "1400",
              "71.07%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "170090140014",
            "name": "SONIA TANEJA",
            "fatherName": "SANT LAL",
            "obtainedMarks": "1030",
            "maxMarks": "1400",
            "percentage": "73.57%",
            "cells": [
              "22",
              "170090140014",
              "SONIA TANEJA",
              "SANT LAL",
              "1030",
              "1400",
              "73.57%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "170090140015",
            "name": "KANIKA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "949",
            "maxMarks": "1400",
            "percentage": "67.79%",
            "cells": [
              "23",
              "170090140015",
              "KANIKA",
              "PREM KUMAR",
              "949",
              "1400",
              "67.79%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "170090140018",
            "name": "VEENU",
            "fatherName": "RAMESH PHUTELA",
            "obtainedMarks": "933",
            "maxMarks": "1400",
            "percentage": "66.64%",
            "cells": [
              "24",
              "170090140018",
              "VEENU",
              "RAMESH PHUTELA",
              "933",
              "1400",
              "66.64%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "170090140019",
            "name": "NEHA",
            "fatherName": "BHIM SAIN",
            "obtainedMarks": "943",
            "maxMarks": "1400",
            "percentage": "67.36%",
            "cells": [
              "25",
              "170090140019",
              "NEHA",
              "BHIM SAIN",
              "943",
              "1400",
              "67.36%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "170090140020",
            "name": "RAJWANT KAUR",
            "fatherName": "LABH SINGH",
            "obtainedMarks": "974",
            "maxMarks": "1400",
            "percentage": "69.57%",
            "cells": [
              "26",
              "170090140020",
              "RAJWANT KAUR",
              "LABH SINGH",
              "974",
              "1400",
              "69.57%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "170090140021",
            "name": "GURWINDER KAUR",
            "fatherName": "JASKARAN SINGH",
            "obtainedMarks": "1048",
            "maxMarks": "1400",
            "percentage": "74.86%",
            "cells": [
              "27",
              "170090140021",
              "GURWINDER KAUR",
              "JASKARAN SINGH",
              "1048",
              "1400",
              "74.86%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "170090140023",
            "name": "TAMANNA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "941",
            "maxMarks": "1400",
            "percentage": "67.21%",
            "cells": [
              "28",
              "170090140023",
              "TAMANNA",
              "RAJENDER KUMAR",
              "941",
              "1400",
              "67.21%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "170090140024",
            "name": "SAWITRI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "870",
            "maxMarks": "1400",
            "percentage": "62.14%",
            "cells": [
              "29",
              "170090140024",
              "SAWITRI",
              "BANWARI LAL",
              "870",
              "1400",
              "62.14%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "170090140027",
            "name": "SHIVANI",
            "fatherName": "MANOHAR LAL",
            "obtainedMarks": "1099",
            "maxMarks": "1400",
            "percentage": "78.50%",
            "cells": [
              "30",
              "170090140027",
              "SHIVANI",
              "MANOHAR LAL",
              "1099",
              "1400",
              "78.50%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Sc Maths III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "31",
            "rollNo": "16109140003",
            "name": "JASKINDER KAUR",
            "fatherName": "VERMA SINGH",
            "obtainedMarks": "802",
            "maxMarks": "1200",
            "percentage": "66.83%",
            "cells": [
              "31",
              "16109140003",
              "JASKINDER KAUR",
              "VERMA SINGH",
              "802",
              "1200",
              "66.83%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "16109140004",
            "name": "TANYA RANI",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "827",
            "maxMarks": "1200",
            "percentage": "68.92%",
            "cells": [
              "32",
              "16109140004",
              "TANYA RANI",
              "RAKESH KUMAR",
              "827",
              "1200",
              "68.92%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "16109140005",
            "name": "MONIKA RANI",
            "fatherName": "LALIT KUAMR",
            "obtainedMarks": "832",
            "maxMarks": "1200",
            "percentage": "69.33%",
            "cells": [
              "33",
              "16109140005",
              "MONIKA RANI",
              "LALIT KUAMR",
              "832",
              "1200",
              "69.33%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "16109140006",
            "name": "KAJIA",
            "fatherName": "JORAWAR SINGH",
            "obtainedMarks": "893",
            "maxMarks": "1200",
            "percentage": "74.42%",
            "cells": [
              "34",
              "16109140006",
              "KAJIA",
              "JORAWAR SINGH",
              "893",
              "1200",
              "74.42%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "16109140008",
            "name": "SANGEETA",
            "fatherName": "JAGDISH CHANDER",
            "obtainedMarks": "853",
            "maxMarks": "1200",
            "percentage": "71.08%",
            "cells": [
              "35",
              "16109140008",
              "SANGEETA",
              "JAGDISH CHANDER",
              "853",
              "1200",
              "71.08%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "16109140009",
            "name": "PRIYANKA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "794",
            "maxMarks": "1200",
            "percentage": "66.17%",
            "cells": [
              "36",
              "16109140009",
              "PRIYANKA",
              "KRISHAN KUMAR",
              "794",
              "1200",
              "66.17%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "16109140010",
            "name": "NISHA",
            "fatherName": "RAM SSAWROOP",
            "obtainedMarks": "809",
            "maxMarks": "1200",
            "percentage": "67.42%",
            "cells": [
              "37",
              "16109140010",
              "NISHA",
              "RAM SSAWROOP",
              "809",
              "1200",
              "67.42%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "16109140011",
            "name": "POONAM RANI",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "883",
            "maxMarks": "1200",
            "percentage": "73.58%",
            "cells": [
              "38",
              "16109140011",
              "POONAM RANI",
              "OM PARKASH",
              "883",
              "1200",
              "73.58%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "16109140012",
            "name": "SIMRAN RANI",
            "fatherName": "KUSHAL CHAND",
            "obtainedMarks": "803",
            "maxMarks": "1200",
            "percentage": "66.92%",
            "cells": [
              "39",
              "16109140012",
              "SIMRAN RANI",
              "KUSHAL CHAND",
              "803",
              "1200",
              "66.92%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "16109140014",
            "name": "PUSHPA RANI",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "747",
            "maxMarks": "1200",
            "percentage": "62.25%",
            "cells": [
              "40",
              "16109140014",
              "PUSHPA RANI",
              "NARESH KUMAR",
              "747",
              "1200",
              "62.25%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "16109140016",
            "name": "POOJA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "774",
            "maxMarks": "1200",
            "percentage": "64.50%",
            "cells": [
              "41",
              "16109140016",
              "POOJA",
              "SURENDER KUMAR",
              "774",
              "1200",
              "64.50%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "16109140017",
            "name": "SONU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "806",
            "maxMarks": "1200",
            "percentage": "67.17%",
            "cells": [
              "42",
              "16109140017",
              "SONU",
              "PAWAN KUMAR",
              "806",
              "1200",
              "67.17%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "16109140030",
            "name": "RENU",
            "fatherName": "RAMESHWAR DAS",
            "obtainedMarks": "726",
            "maxMarks": "1200",
            "percentage": "60.50%",
            "cells": [
              "43",
              "16109140030",
              "RENU",
              "RAMESHWAR DAS",
              "726",
              "1200",
              "60.50%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "44",
            "rollNo": "170090240003",
            "name": "GURPREET",
            "fatherName": "SATPAL",
            "obtainedMarks": "958",
            "maxMarks": "1400",
            "percentage": "68.43%",
            "cells": [
              "44",
              "170090240003",
              "GURPREET",
              "SATPAL",
              "958",
              "1400",
              "68.43%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "170090240004",
            "name": "NISHA",
            "fatherName": "BEER SINGH",
            "obtainedMarks": "985",
            "maxMarks": "1400",
            "percentage": "70.36%",
            "cells": [
              "45",
              "170090240004",
              "NISHA",
              "BEER SINGH",
              "985",
              "1400",
              "70.36%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "170090240005",
            "name": "MADHU BALA",
            "fatherName": "SURJEET SINGH",
            "obtainedMarks": "987",
            "maxMarks": "1400",
            "percentage": "70.50%",
            "cells": [
              "46",
              "170090240005",
              "MADHU BALA",
              "SURJEET SINGH",
              "987",
              "1400",
              "70.50%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "170090240008",
            "name": "ANJU RANI",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "867",
            "maxMarks": "1400",
            "percentage": "61.93%",
            "cells": [
              "47",
              "170090240008",
              "ANJU RANI",
              "ASHOK KUMAR",
              "867",
              "1400",
              "61.93%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "170090240013",
            "name": "TANYA KATHPAL",
            "fatherName": "PAWAN KATHPAL",
            "obtainedMarks": "1014",
            "maxMarks": "1400",
            "percentage": "72.43%",
            "cells": [
              "48",
              "170090240013",
              "TANYA KATHPAL",
              "PAWAN KATHPAL",
              "1014",
              "1400",
              "72.43%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "170090240014",
            "name": "RAKHI",
            "fatherName": "SUKHNAM LUTHRA",
            "obtainedMarks": "926",
            "maxMarks": "1400",
            "percentage": "66.14%",
            "cells": [
              "49",
              "170090240014",
              "RAKHI",
              "SUKHNAM LUTHRA",
              "926",
              "1400",
              "66.14%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "170090240016",
            "name": "MANPREET KAUR",
            "fatherName": "PURAN CHAND",
            "obtainedMarks": "861",
            "maxMarks": "1400",
            "percentage": "61.50%",
            "cells": [
              "50",
              "170090240016",
              "MANPREET KAUR",
              "PURAN CHAND",
              "861",
              "1400",
              "61.50%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "170090240017",
            "name": "DIKSHA",
            "fatherName": "JAGDISH KAKKAR",
            "obtainedMarks": "1003",
            "maxMarks": "1400",
            "percentage": "71.64%",
            "cells": [
              "51",
              "170090240017",
              "DIKSHA",
              "JAGDISH KAKKAR",
              "1003",
              "1400",
              "71.64%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "170090240018",
            "name": "SHIVANI",
            "fatherName": "LAKSHMAN DASS",
            "obtainedMarks": "995",
            "maxMarks": "1400",
            "percentage": "71.07%",
            "cells": [
              "52",
              "170090240018",
              "SHIVANI",
              "LAKSHMAN DASS",
              "995",
              "1400",
              "71.07%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "170090240020",
            "name": "PAWANDEEP",
            "fatherName": "NIRMAL SINGH",
            "obtainedMarks": "909",
            "maxMarks": "1400",
            "percentage": "64.93%",
            "cells": [
              "53",
              "170090240020",
              "PAWANDEEP",
              "NIRMAL SINGH",
              "909",
              "1400",
              "64.93%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "170090240021",
            "name": "POONAM",
            "fatherName": "JAIVEER",
            "obtainedMarks": "970",
            "maxMarks": "1400",
            "percentage": "69.29%",
            "cells": [
              "54",
              "170090240021",
              "POONAM",
              "JAIVEER",
              "970",
              "1400",
              "69.29%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "170090240022",
            "name": "PRIYANKA",
            "fatherName": "SATYA NARYAN",
            "obtainedMarks": "1054",
            "maxMarks": "1400",
            "percentage": "75.29%",
            "cells": [
              "55",
              "170090240022",
              "PRIYANKA",
              "SATYA NARYAN",
              "1054",
              "1400",
              "75.29%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "170090240023",
            "name": "SARITA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "941",
            "maxMarks": "1400",
            "percentage": "67.21%",
            "cells": [
              "56",
              "170090240023",
              "SARITA",
              "KULDEEP",
              "941",
              "1400",
              "67.21%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "170090240024",
            "name": "HARDEEP KAUR",
            "fatherName": "GURMEET SINGH",
            "obtainedMarks": "921",
            "maxMarks": "1400",
            "percentage": "65.79%",
            "cells": [
              "57",
              "170090240024",
              "HARDEEP KAUR",
              "GURMEET SINGH",
              "921",
              "1400",
              "65.79%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "58",
            "rollNo": "16109240001",
            "name": "POONAM",
            "fatherName": "RAMESHWAR",
            "obtainedMarks": "785",
            "maxMarks": "1300",
            "percentage": "60.38%",
            "cells": [
              "58",
              "16109240001",
              "POONAM",
              "RAMESHWAR",
              "785",
              "1300",
              "60.38%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "16109240002",
            "name": "PRIYANKA KHURANA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "801",
            "maxMarks": "1300",
            "percentage": "61.62%",
            "cells": [
              "59",
              "16109240002",
              "PRIYANKA KHURANA",
              "RAJ KUMAR",
              "801",
              "1300",
              "61.62%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "16109240003",
            "name": "NEHA GROVER",
            "fatherName": "JANAK RAJ",
            "obtainedMarks": "844",
            "maxMarks": "1300",
            "percentage": "64.92%",
            "cells": [
              "60",
              "16109240003",
              "NEHA GROVER",
              "JANAK RAJ",
              "844",
              "1300",
              "64.92%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "16109240006",
            "name": "MUSKAN",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "888",
            "maxMarks": "1300",
            "percentage": "68.31%",
            "cells": [
              "61",
              "16109240006",
              "MUSKAN",
              "PAWAN KUMAR",
              "888",
              "1300",
              "68.31%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "16109240008",
            "name": "ALISHA",
            "fatherName": "SANJEEV KUMAR",
            "obtainedMarks": "910",
            "maxMarks": "1300",
            "percentage": "70%",
            "cells": [
              "62",
              "16109240008",
              "ALISHA",
              "SANJEEV KUMAR",
              "910",
              "1300",
              "70%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "16109240009",
            "name": "SUMAN",
            "fatherName": "SATBIR",
            "obtainedMarks": "792",
            "maxMarks": "1300",
            "percentage": "60.92%",
            "cells": [
              "63",
              "16109240009",
              "SUMAN",
              "SATBIR",
              "792",
              "1300",
              "60.92%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "16109240010",
            "name": "SUMAN",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "893",
            "maxMarks": "1300",
            "percentage": "68.69%",
            "cells": [
              "64",
              "16109240010",
              "SUMAN",
              "SUBASH CHANDER",
              "893",
              "1300",
              "68.69%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "16109240022",
            "name": "SONIA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "780",
            "maxMarks": "1300",
            "percentage": "60%",
            "cells": [
              "65",
              "16109240022",
              "SONIA",
              "VINOD KUMAR",
              "780",
              "1300",
              "60%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "16109240025",
            "name": "SAKSHI SETHI",
            "fatherName": "RAJENDER SETHI",
            "obtainedMarks": "783",
            "maxMarks": "1300",
            "percentage": "60.23%",
            "cells": [
              "66",
              "16109240025",
              "SAKSHI SETHI",
              "RAJENDER SETHI",
              "783",
              "1300",
              "60.23%"
            ]
          }
        ]
      },
      {
        "courseName": "D.PED  I+II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.PED I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "67",
            "rollNo": "170090510001",
            "name": "PARMEET RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1280",
            "maxMarks": "1600",
            "percentage": "80%",
            "cells": [
              "67",
              "170090510001",
              "PARMEET RANI",
              "MADAN LAL",
              "1280",
              "1600",
              "80%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "170090510002",
            "name": "JASHANDEEP",
            "fatherName": "CHANDER PARKASH",
            "obtainedMarks": "1329",
            "maxMarks": "1600",
            "percentage": "83.06%",
            "cells": [
              "68",
              "170090510002",
              "JASHANDEEP",
              "CHANDER PARKASH",
              "1329",
              "1600",
              "83.06%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "170090510004",
            "name": "MANDEEP KAUR",
            "fatherName": "KARAM SINGH",
            "obtainedMarks": "1279",
            "maxMarks": "1600",
            "percentage": "79.94%",
            "cells": [
              "69",
              "170090510004",
              "MANDEEP KAUR",
              "KARAM SINGH",
              "1279",
              "1600",
              "79.94%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "170090510005",
            "name": "GAGANDEEP KAUR",
            "fatherName": "SUKHPAL SINGH",
            "obtainedMarks": "1314",
            "maxMarks": "1600",
            "percentage": "82.13%",
            "cells": [
              "70",
              "170090510005",
              "GAGANDEEP KAUR",
              "SUKHPAL SINGH",
              "1314",
              "1600",
              "82.13%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "170090510006",
            "name": "PARAMJEET KAUR",
            "fatherName": "KARTAR SINGH",
            "obtainedMarks": "1269",
            "maxMarks": "1600",
            "percentage": "79.31%",
            "cells": [
              "71",
              "170090510006",
              "PARAMJEET KAUR",
              "KARTAR SINGH",
              "1269",
              "1600",
              "79.31%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "170090510007",
            "name": "KAVITA RANI",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "1285",
            "maxMarks": "1600",
            "percentage": "80.31%",
            "cells": [
              "72",
              "170090510007",
              "KAVITA RANI",
              "RANBIR SINGH",
              "1285",
              "1600",
              "80.31%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "170090510008",
            "name": "ANJU RATHI",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "1236",
            "maxMarks": "1600",
            "percentage": "77.25%",
            "cells": [
              "73",
              "170090510008",
              "ANJU RATHI",
              "RAM NIWAS",
              "1236",
              "1600",
              "77.25%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "170090510011",
            "name": "KAJAL",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1317",
            "maxMarks": "1600",
            "percentage": "82.31%",
            "cells": [
              "74",
              "170090510011",
              "KAJAL",
              "RAMESH KUMAR",
              "1317",
              "1600",
              "82.31%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "170090510012",
            "name": "NAVDEEP KAUR",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "1287",
            "maxMarks": "1600",
            "percentage": "80.44%",
            "cells": [
              "75",
              "170090510012",
              "NAVDEEP KAUR",
              "SUKHDEV SINGH",
              "1287",
              "1600",
              "80.44%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "170090510013",
            "name": "SAVITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1267",
            "maxMarks": "1600",
            "percentage": "79.19%",
            "cells": [
              "76",
              "170090510013",
              "SAVITA",
              "RAMESH KUMAR",
              "1267",
              "1600",
              "79.19%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2018-19",
    "courses": [
      {
        "courseName": "B.A I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "180090430004",
            "name": "KARISHMA",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "770",
            "maxMarks": "975",
            "percentage": "78.97%",
            "cells": [
              "1",
              "180090430004",
              "KARISHMA",
              "PRITHVI SINGH",
              "770",
              "975",
              "78.97%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "180090430010",
            "name": "BANITA",
            "fatherName": "SATBEER SINGH",
            "obtainedMarks": "736",
            "maxMarks": "975",
            "percentage": "75.49%",
            "cells": [
              "2",
              "180090430010",
              "BANITA",
              "SATBEER SINGH",
              "736",
              "975",
              "75.49%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "180090430011",
            "name": "PAYAL",
            "fatherName": "DARIYA SINGH",
            "obtainedMarks": "853",
            "maxMarks": "975",
            "percentage": "87.49%",
            "cells": [
              "3",
              "180090430011",
              "PAYAL",
              "DARIYA SINGH",
              "853",
              "975",
              "87.49%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "180090430013",
            "name": "KAPISHA POONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "832",
            "maxMarks": "975",
            "percentage": "85.33%",
            "cells": [
              "4",
              "180090430013",
              "KAPISHA POONIA",
              "SANJAY KUMAR",
              "832",
              "975",
              "85.33%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "180090430015",
            "name": "KIRAN",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "845",
            "maxMarks": "975",
            "percentage": "86.67%",
            "cells": [
              "5",
              "180090430015",
              "KIRAN",
              "RAJENDER SINGH",
              "845",
              "975",
              "86.67%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "180090430016",
            "name": "ANAMIKA",
            "fatherName": "NACHHATRA SINGH",
            "obtainedMarks": "693",
            "maxMarks": "975",
            "percentage": "71.08%",
            "cells": [
              "6",
              "180090430016",
              "ANAMIKA",
              "NACHHATRA SINGH",
              "693",
              "975",
              "71.08%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "180090430018",
            "name": "ANUJA",
            "fatherName": "VINOD",
            "obtainedMarks": "718",
            "maxMarks": "975",
            "percentage": "73.64%",
            "cells": [
              "7",
              "180090430018",
              "ANUJA",
              "VINOD",
              "718",
              "975",
              "73.64%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "180090430024",
            "name": "LAXMI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "761",
            "maxMarks": "975",
            "percentage": "78.05%",
            "cells": [
              "8",
              "180090430024",
              "LAXMI",
              "VINOD KUMAR",
              "761",
              "975",
              "78.05%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "180090430025",
            "name": "SANTOSH",
            "fatherName": "SOHAN LAL",
            "obtainedMarks": "802",
            "maxMarks": "975",
            "percentage": "82.26%",
            "cells": [
              "9",
              "180090430025",
              "SANTOSH",
              "SOHAN LAL",
              "802",
              "975",
              "82.26%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "180090430030",
            "name": "JAIMANY JAWALIA",
            "fatherName": "JAIKARAN JAWALIA",
            "obtainedMarks": "736",
            "maxMarks": "975",
            "percentage": "75.49%",
            "cells": [
              "10",
              "180090430030",
              "JAIMANY JAWALIA",
              "JAIKARAN JAWALIA",
              "736",
              "975",
              "75.49%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "180090430032",
            "name": "ISHA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "790",
            "maxMarks": "975",
            "percentage": "81.03%",
            "cells": [
              "11",
              "180090430032",
              "ISHA",
              "RAJESH KUMAR",
              "790",
              "975",
              "81.03%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "180090430033",
            "name": "SONAM POPLI",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "856",
            "maxMarks": "975",
            "percentage": "87.79%",
            "cells": [
              "12",
              "180090430033",
              "SONAM POPLI",
              "RAVINDER KUMAR",
              "856",
              "975",
              "87.79%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "180090430034",
            "name": "RAMANDEEP KAUR",
            "fatherName": "JAGTAR SINGH",
            "obtainedMarks": "788",
            "maxMarks": "975",
            "percentage": "80.82%",
            "cells": [
              "13",
              "180090430034",
              "RAMANDEEP KAUR",
              "JAGTAR SINGH",
              "788",
              "975",
              "80.82%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "180090430039",
            "name": "MAMTA RANI",
            "fatherName": "BHOLA SINGH",
            "obtainedMarks": "697",
            "maxMarks": "975",
            "percentage": "71.49%",
            "cells": [
              "14",
              "180090430039",
              "MAMTA RANI",
              "BHOLA SINGH",
              "697",
              "975",
              "71.49%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "180090430040",
            "name": "JYOTI",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "719",
            "maxMarks": "975",
            "percentage": "73.74%",
            "cells": [
              "15",
              "180090430040",
              "JYOTI",
              "BHIM SINGH",
              "719",
              "975",
              "73.74%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "180090430041",
            "name": "PRIYANKA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "782",
            "maxMarks": "975",
            "percentage": "80.21%",
            "cells": [
              "16",
              "180090430041",
              "PRIYANKA",
              "RAKESH KUMAR",
              "782",
              "975",
              "80.21%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "180090430045",
            "name": "ANJU",
            "fatherName": "BADRI PARSAD",
            "obtainedMarks": "690",
            "maxMarks": "975",
            "percentage": "70.77%",
            "cells": [
              "17",
              "180090430045",
              "ANJU",
              "BADRI PARSAD",
              "690",
              "975",
              "70.77%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "180090430046",
            "name": "UMA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "782",
            "maxMarks": "975",
            "percentage": "80.21%",
            "cells": [
              "18",
              "180090430046",
              "UMA",
              "SUBHASH CHANDER",
              "782",
              "975",
              "80.21%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "180090430048",
            "name": "PREMLATA",
            "fatherName": "SADHU RAM",
            "obtainedMarks": "761",
            "maxMarks": "975",
            "percentage": "78.05%",
            "cells": [
              "19",
              "180090430048",
              "PREMLATA",
              "SADHU RAM",
              "761",
              "975",
              "78.05%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "180090430054",
            "name": "POONAM",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "693",
            "maxMarks": "975",
            "percentage": "71.08%",
            "cells": [
              "20",
              "180090430054",
              "POONAM",
              "RAJENDER KUMAR",
              "693",
              "975",
              "71.08%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "180090430055",
            "name": "EKTA",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "757",
            "maxMarks": "975",
            "percentage": "77.64%",
            "cells": [
              "21",
              "180090430055",
              "EKTA",
              "AATMA RAM",
              "757",
              "975",
              "77.64%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "180090430060",
            "name": "MAHIMA",
            "fatherName": "VIJESH KUMAR",
            "obtainedMarks": "801",
            "maxMarks": "975",
            "percentage": "82.15%",
            "cells": [
              "22",
              "180090430060",
              "MAHIMA",
              "VIJESH KUMAR",
              "801",
              "975",
              "82.15%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "180090430062",
            "name": "JYOTI",
            "fatherName": "DAMODAR",
            "obtainedMarks": "704",
            "maxMarks": "975",
            "percentage": "72.21%",
            "cells": [
              "23",
              "180090430062",
              "JYOTI",
              "DAMODAR",
              "704",
              "975",
              "72.21%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "180090430067",
            "name": "POOJA DEVI",
            "fatherName": "YAG DUTT",
            "obtainedMarks": "826",
            "maxMarks": "975",
            "percentage": "84.72%",
            "cells": [
              "24",
              "180090430067",
              "POOJA DEVI",
              "YAG DUTT",
              "826",
              "975",
              "84.72%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "180090430068",
            "name": "AMANPREET",
            "fatherName": "JAGSEER SINGH",
            "obtainedMarks": "737",
            "maxMarks": "975",
            "percentage": "75.59%",
            "cells": [
              "25",
              "180090430068",
              "AMANPREET",
              "JAGSEER SINGH",
              "737",
              "975",
              "75.59%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "180090430081",
            "name": "KIRTI INSAN",
            "fatherName": "RULDA INSAN",
            "obtainedMarks": "745",
            "maxMarks": "975",
            "percentage": "76.41%",
            "cells": [
              "26",
              "180090430081",
              "KIRTI INSAN",
              "RULDA INSAN",
              "745",
              "975",
              "76.41%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "180090430086",
            "name": "PREETI",
            "fatherName": "RAJINDER KUMAR",
            "obtainedMarks": "748",
            "maxMarks": "975",
            "percentage": "76.72%",
            "cells": [
              "27",
              "180090430086",
              "PREETI",
              "RAJINDER KUMAR",
              "748",
              "975",
              "76.72%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "180090430093",
            "name": "ANKITA RANI",
            "fatherName": "MANOJ GIR",
            "obtainedMarks": "686",
            "maxMarks": "975",
            "percentage": "70.36%",
            "cells": [
              "28",
              "180090430093",
              "ANKITA RANI",
              "MANOJ GIR",
              "686",
              "975",
              "70.36%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "180090430095",
            "name": "POONAM",
            "fatherName": "DAYANAND GIRI",
            "obtainedMarks": "840",
            "maxMarks": "975",
            "percentage": "86.15%",
            "cells": [
              "29",
              "180090430095",
              "POONAM",
              "DAYANAND GIRI",
              "840",
              "975",
              "86.15%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "180090430109",
            "name": "NIRMLA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.03%",
            "cells": [
              "30",
              "180090430109",
              "NIRMLA",
              "KRISHAN KUMAR",
              "712",
              "975",
              "73.03%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "180090430110",
            "name": "ROHINI",
            "fatherName": "ARJUN",
            "obtainedMarks": "703",
            "maxMarks": "975",
            "percentage": "72.10%",
            "cells": [
              "31",
              "180090430110",
              "ROHINI",
              "ARJUN",
              "703",
              "975",
              "72.10%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "180090430114",
            "name": "JYOTI KASWAN",
            "fatherName": "SATBIR",
            "obtainedMarks": "735",
            "maxMarks": "975",
            "percentage": "75.38%",
            "cells": [
              "32",
              "180090430114",
              "JYOTI KASWAN",
              "SATBIR",
              "735",
              "975",
              "75.38%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "180090430118",
            "name": "RAVINA DEVI",
            "fatherName": "AJAY PAL",
            "obtainedMarks": "710",
            "maxMarks": "975",
            "percentage": "72.82%",
            "cells": [
              "33",
              "180090430118",
              "RAVINA DEVI",
              "AJAY PAL",
              "710",
              "975",
              "72.82%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "180090430122",
            "name": "RACHNA RANI",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "796",
            "maxMarks": "975",
            "percentage": "81.64%",
            "cells": [
              "34",
              "180090430122",
              "RACHNA RANI",
              "NARESH KUMAR",
              "796",
              "975",
              "81.64%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "35",
            "rollNo": "170090430003",
            "name": "SAVINA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "710",
            "maxMarks": "900",
            "percentage": "78.89%",
            "cells": [
              "35",
              "170090430003",
              "SAVINA",
              "RAN SINGH",
              "710",
              "900",
              "78.89%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "170090430004",
            "name": "MANDEEP KAUR",
            "fatherName": "SURESH",
            "obtainedMarks": "689",
            "maxMarks": "900",
            "percentage": "76.56%",
            "cells": [
              "36",
              "170090430004",
              "MANDEEP KAUR",
              "SURESH",
              "689",
              "900",
              "76.56%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "170090430005",
            "name": "ANJU BALA",
            "fatherName": "RAMESH LAL",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "37",
              "170090430005",
              "ANJU BALA",
              "RAMESH LAL",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "170090430008",
            "name": "RINKU",
            "fatherName": "BALWANT SINGH",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "38",
              "170090430008",
              "RINKU",
              "BALWANT SINGH",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "170090430009",
            "name": "JASPREET KAUR",
            "fatherName": "DHARAM SINGH",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.78%",
            "cells": [
              "39",
              "170090430009",
              "JASPREET KAUR",
              "DHARAM SINGH",
              "700",
              "900",
              "77.78%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "170090430011",
            "name": "JASWINDER",
            "fatherName": "SH GULSHAN KUMAR",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "40",
              "170090430011",
              "JASWINDER",
              "SH GULSHAN KUMAR",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "170090430016",
            "name": "POOJA RANI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "693",
            "maxMarks": "900",
            "percentage": "77%",
            "cells": [
              "41",
              "170090430016",
              "POOJA RANI",
              "RAJESH KUMAR",
              "693",
              "900",
              "77%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "170090430017",
            "name": "POONAM THAKUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "42",
              "170090430017",
              "POONAM THAKUR",
              "GURMAIL SINGH",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "170090430019",
            "name": "SANDEEP KAUR",
            "fatherName": "GURBHAGAT SINGH",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "43",
              "170090430019",
              "SANDEEP KAUR",
              "GURBHAGAT SINGH",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "170090430022",
            "name": "ANJALI",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "44",
              "170090430022",
              "ANJALI",
              "SHYAM LAL",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "170090430025",
            "name": "RAMANDEEP KAUR",
            "fatherName": "SUKHMANDER SINGH",
            "obtainedMarks": "649",
            "maxMarks": "900",
            "percentage": "72.11%",
            "cells": [
              "45",
              "170090430025",
              "RAMANDEEP KAUR",
              "SUKHMANDER SINGH",
              "649",
              "900",
              "72.11%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "170090430027",
            "name": "PRIYA",
            "fatherName": "JAISRAJ",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "46",
              "170090430027",
              "PRIYA",
              "JAISRAJ",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "170090430028",
            "name": "ANNU",
            "fatherName": "CHANDER SHARMA",
            "obtainedMarks": "665",
            "maxMarks": "900",
            "percentage": "73.89%",
            "cells": [
              "47",
              "170090430028",
              "ANNU",
              "CHANDER SHARMA",
              "665",
              "900",
              "73.89%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "170090430032",
            "name": "RAVINA",
            "fatherName": "MR MAHESH KUMAR",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "48",
              "170090430032",
              "RAVINA",
              "MR MAHESH KUMAR",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "170090430044",
            "name": "VIJETA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.89%",
            "cells": [
              "49",
              "170090430044",
              "VIJETA",
              "KULDEEP",
              "737",
              "900",
              "81.89%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "170090430046",
            "name": "TAMANNA",
            "fatherName": "VIRENDER",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.78%",
            "cells": [
              "50",
              "170090430046",
              "TAMANNA",
              "VIRENDER",
              "637",
              "900",
              "70.78%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "170090430049",
            "name": "SIMRAN",
            "fatherName": "ASHOK KUMAR JAGGA",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "51",
              "170090430049",
              "SIMRAN",
              "ASHOK KUMAR JAGGA",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "170090430050",
            "name": "RAJDEEP KAUR",
            "fatherName": "INDERJEET SINGH",
            "obtainedMarks": "731",
            "maxMarks": "900",
            "percentage": "81.22%",
            "cells": [
              "52",
              "170090430050",
              "RAJDEEP KAUR",
              "INDERJEET SINGH",
              "731",
              "900",
              "81.22%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "170090430053",
            "name": "NISHA SAINI",
            "fatherName": "PAWAN SAINI",
            "obtainedMarks": "723",
            "maxMarks": "900",
            "percentage": "80.33%",
            "cells": [
              "53",
              "170090430053",
              "NISHA SAINI",
              "PAWAN SAINI",
              "723",
              "900",
              "80.33%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "170090430059",
            "name": "NEELAM",
            "fatherName": "SALENDER SINGH",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "54",
              "170090430059",
              "NEELAM",
              "SALENDER SINGH",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "170090430061",
            "name": "SANJU KAMBOJ",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "722",
            "maxMarks": "900",
            "percentage": "80.22%",
            "cells": [
              "55",
              "170090430061",
              "SANJU KAMBOJ",
              "JAGDISH KUMAR",
              "722",
              "900",
              "80.22%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "170090430063",
            "name": "KANTA SWAMI",
            "fatherName": "DHARAMPAL SWAMI",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "56",
              "170090430063",
              "KANTA SWAMI",
              "DHARAMPAL SWAMI",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "170090430064",
            "name": "GARIMA",
            "fatherName": "BABU RAM",
            "obtainedMarks": "733",
            "maxMarks": "900",
            "percentage": "81.44%",
            "cells": [
              "57",
              "170090430064",
              "GARIMA",
              "BABU RAM",
              "733",
              "900",
              "81.44%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "170090430067",
            "name": "POONAM",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "58",
              "170090430067",
              "POONAM",
              "RAJENDER KUMAR",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "170090430068",
            "name": "SNEHA",
            "fatherName": "CHANDER SHARMA",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "59",
              "170090430068",
              "SNEHA",
              "CHANDER SHARMA",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "170090430069",
            "name": "GAYATRI",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.78%",
            "cells": [
              "60",
              "170090430069",
              "GAYATRI",
              "RANJEET SINGH",
              "673",
              "900",
              "74.78%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "170090430070",
            "name": "JYOTI RANI",
            "fatherName": "GANDHI RAM",
            "obtainedMarks": "681",
            "maxMarks": "900",
            "percentage": "75.67%",
            "cells": [
              "61",
              "170090430070",
              "JYOTI RANI",
              "GANDHI RAM",
              "681",
              "900",
              "75.67%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "170090430074",
            "name": "POONAM RANI",
            "fatherName": "BALRAJ SINGH",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.78%",
            "cells": [
              "62",
              "170090430074",
              "POONAM RANI",
              "BALRAJ SINGH",
              "673",
              "900",
              "74.78%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "170090430079",
            "name": "MONIKA",
            "fatherName": "DALIP SINGH",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "63",
              "170090430079",
              "MONIKA",
              "DALIP SINGH",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "170090430080",
            "name": "SONIKA",
            "fatherName": "RAMNIWASH",
            "obtainedMarks": "665",
            "maxMarks": "900",
            "percentage": "73.89%",
            "cells": [
              "64",
              "170090430080",
              "SONIKA",
              "RAMNIWASH",
              "665",
              "900",
              "73.89%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "170090430086",
            "name": "JAYANTI DEVI",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "65",
              "170090430086",
              "JAYANTI DEVI",
              "MOHAN LAL",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "170090430091",
            "name": "MONIKA",
            "fatherName": "KANHAIYALAL",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.78%",
            "cells": [
              "66",
              "170090430091",
              "MONIKA",
              "KANHAIYALAL",
              "673",
              "900",
              "74.78%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "170090430095",
            "name": "MANJU",
            "fatherName": "RAMESH SAHARAN",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "67",
              "170090430095",
              "MANJU",
              "RAMESH SAHARAN",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "170090430098",
            "name": "CHANDER KALA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "688",
            "maxMarks": "900",
            "percentage": "76.44%",
            "cells": [
              "68",
              "170090430098",
              "CHANDER KALA",
              "MOHAN LAL",
              "688",
              "900",
              "76.44%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "170090430099",
            "name": "UJALA",
            "fatherName": "RAKESH",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "69",
              "170090430099",
              "UJALA",
              "RAKESH",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "170090430100",
            "name": "JYOTI",
            "fatherName": "JAIPAL",
            "obtainedMarks": "756",
            "maxMarks": "900",
            "percentage": "84%",
            "cells": [
              "70",
              "170090430100",
              "JYOTI",
              "JAIPAL",
              "756",
              "900",
              "84%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "170090430112",
            "name": "SWATI",
            "fatherName": "SATBEER SINGH",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "71",
              "170090430112",
              "SWATI",
              "SATBEER SINGH",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "170090430114",
            "name": "RITU",
            "fatherName": "KARNI SINGH",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "72",
              "170090430114",
              "RITU",
              "KARNI SINGH",
              "643",
              "900",
              "71.44%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "73",
            "rollNo": "16109430004",
            "name": "PRIYA BABBAR",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "573",
            "maxMarks": "800",
            "percentage": "71.62%",
            "cells": [
              "73",
              "16109430004",
              "PRIYA BABBAR",
              "VINOD KUMAR",
              "573",
              "800",
              "71.62%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "16109430007",
            "name": "KAVITA RANI",
            "fatherName": "RAM SWAROOP",
            "obtainedMarks": "656",
            "maxMarks": "800",
            "percentage": "82%",
            "cells": [
              "74",
              "16109430007",
              "KAVITA RANI",
              "RAM SWAROOP",
              "656",
              "800",
              "82%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "16109430009",
            "name": "RITU KUMARI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "668",
            "maxMarks": "800",
            "percentage": "83.50%",
            "cells": [
              "75",
              "16109430009",
              "RITU KUMARI",
              "RAJ KUMAR",
              "668",
              "800",
              "83.50%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "16109430010",
            "name": "SUMAN",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "639",
            "maxMarks": "800",
            "percentage": "79.88%",
            "cells": [
              "76",
              "16109430010",
              "SUMAN",
              "SHAMSHER SINGH",
              "639",
              "800",
              "79.88%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "16109430011",
            "name": "MANJU",
            "fatherName": "INDERPAL",
            "obtainedMarks": "599",
            "maxMarks": "800",
            "percentage": "74.88%",
            "cells": [
              "77",
              "16109430011",
              "MANJU",
              "INDERPAL",
              "599",
              "800",
              "74.88%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "16109430013",
            "name": "PRIYANKA",
            "fatherName": "MANOJ KUMAR",
            "obtainedMarks": "609",
            "maxMarks": "800",
            "percentage": "76.12%",
            "cells": [
              "78",
              "16109430013",
              "PRIYANKA",
              "MANOJ KUMAR",
              "609",
              "800",
              "76.12%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "16109430014",
            "name": "MANJEET KAUR",
            "fatherName": "PREM SINGH",
            "obtainedMarks": "592",
            "maxMarks": "800",
            "percentage": "74%",
            "cells": [
              "79",
              "16109430014",
              "MANJEET KAUR",
              "PREM SINGH",
              "592",
              "800",
              "74%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "16109430015",
            "name": "JYOTI PAREEK",
            "fatherName": "JINTENDER KUMAR",
            "obtainedMarks": "592",
            "maxMarks": "800",
            "percentage": "74%",
            "cells": [
              "80",
              "16109430015",
              "JYOTI PAREEK",
              "JINTENDER KUMAR",
              "592",
              "800",
              "74%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "16109430016",
            "name": "ANURADHA",
            "fatherName": "SITA RAM",
            "obtainedMarks": "574",
            "maxMarks": "800",
            "percentage": "71.75%",
            "cells": [
              "81",
              "16109430016",
              "ANURADHA",
              "SITA RAM",
              "574",
              "800",
              "71.75%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "16109430017",
            "name": "SUMAN",
            "fatherName": "SATBIR SINGH",
            "obtainedMarks": "640",
            "maxMarks": "800",
            "percentage": "80%",
            "cells": [
              "82",
              "16109430017",
              "SUMAN",
              "SATBIR SINGH",
              "640",
              "800",
              "80%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "16109430018",
            "name": "PARVEEN KUMARI",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "608",
            "maxMarks": "800",
            "percentage": "76%",
            "cells": [
              "83",
              "16109430018",
              "PARVEEN KUMARI",
              "BALBIR SINGH",
              "608",
              "800",
              "76%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "16109430020",
            "name": "MAMTA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "638",
            "maxMarks": "800",
            "percentage": "79.75%",
            "cells": [
              "84",
              "16109430020",
              "MAMTA",
              "OM PARKASH",
              "638",
              "800",
              "79.75%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "16109430021",
            "name": "PRITAM RANI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "569",
            "maxMarks": "800",
            "percentage": "71.12%",
            "cells": [
              "85",
              "16109430021",
              "PRITAM RANI",
              "RAJ KUMAR",
              "569",
              "800",
              "71.12%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "16109430023",
            "name": "POOJA",
            "fatherName": "BHARAT PACHAR",
            "obtainedMarks": "586",
            "maxMarks": "800",
            "percentage": "73.25%",
            "cells": [
              "86",
              "16109430023",
              "POOJA",
              "BHARAT PACHAR",
              "586",
              "800",
              "73.25%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "16109430024",
            "name": "LUXMI RANI",
            "fatherName": "MAL CHAND",
            "obtainedMarks": "587",
            "maxMarks": "800",
            "percentage": "73.38%",
            "cells": [
              "87",
              "16109430024",
              "LUXMI RANI",
              "MAL CHAND",
              "587",
              "800",
              "73.38%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "16109430025",
            "name": "PREEKSHA",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "637",
            "maxMarks": "800",
            "percentage": "79.62%",
            "cells": [
              "88",
              "16109430025",
              "PREEKSHA",
              "DAYA RAM",
              "637",
              "800",
              "79.62%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "16109430026",
            "name": "BINDU",
            "fatherName": "KANAHAIYA LAL",
            "obtainedMarks": "588",
            "maxMarks": "800",
            "percentage": "73.50%",
            "cells": [
              "89",
              "16109430026",
              "BINDU",
              "KANAHAIYA LAL",
              "588",
              "800",
              "73.50%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "16109430035",
            "name": "REKHA",
            "fatherName": "SURJIT SINGH",
            "obtainedMarks": "625",
            "maxMarks": "800",
            "percentage": "78.12%",
            "cells": [
              "90",
              "16109430035",
              "REKHA",
              "SURJIT SINGH",
              "625",
              "800",
              "78.12%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "16109430037",
            "name": "SANDHYA",
            "fatherName": "MEVA SINGH",
            "obtainedMarks": "644",
            "maxMarks": "800",
            "percentage": "80.50%",
            "cells": [
              "91",
              "16109430037",
              "SANDHYA",
              "MEVA SINGH",
              "644",
              "800",
              "80.50%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "16109430038",
            "name": "KOMAL",
            "fatherName": "CHARAN SINGH",
            "obtainedMarks": "566",
            "maxMarks": "800",
            "percentage": "70.75%",
            "cells": [
              "92",
              "16109430038",
              "KOMAL",
              "CHARAN SINGH",
              "566",
              "800",
              "70.75%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "16109430039",
            "name": "POOJA",
            "fatherName": "PREM PAL",
            "obtainedMarks": "580",
            "maxMarks": "800",
            "percentage": "72.50%",
            "cells": [
              "93",
              "16109430039",
              "POOJA",
              "PREM PAL",
              "580",
              "800",
              "72.50%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "16109430042",
            "name": "MONIKA",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "565",
            "maxMarks": "800",
            "percentage": "70.62%",
            "cells": [
              "94",
              "16109430042",
              "MONIKA",
              "RAI SINGH",
              "565",
              "800",
              "70.62%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "16109430047",
            "name": "PUNITA RANI",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "589",
            "maxMarks": "800",
            "percentage": "73.62%",
            "cells": [
              "95",
              "16109430047",
              "PUNITA RANI",
              "SUBHASH CHANDER",
              "589",
              "800",
              "73.62%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "16109430051",
            "name": "SIMRANJEET KAUR",
            "fatherName": "BALWINDER SINGH",
            "obtainedMarks": "609",
            "maxMarks": "800",
            "percentage": "76.12%",
            "cells": [
              "96",
              "16109430051",
              "SIMRANJEET KAUR",
              "BALWINDER SINGH",
              "609",
              "800",
              "76.12%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "16109430058",
            "name": "NITU KUMARI",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "613",
            "maxMarks": "800",
            "percentage": "76.62%",
            "cells": [
              "97",
              "16109430058",
              "NITU KUMARI",
              "MAHENDER SINGH",
              "613",
              "800",
              "76.62%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "16109430059",
            "name": "LOVEPREET KAUR",
            "fatherName": "AMARJEET SINGH",
            "obtainedMarks": "569",
            "maxMarks": "800",
            "percentage": "71.12%",
            "cells": [
              "98",
              "16109430059",
              "LOVEPREET KAUR",
              "AMARJEET SINGH",
              "569",
              "800",
              "71.12%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "16109430066",
            "name": "MONIKA",
            "fatherName": "SULTAN",
            "obtainedMarks": "593",
            "maxMarks": "800",
            "percentage": "74.12%",
            "cells": [
              "99",
              "16109430066",
              "MONIKA",
              "SULTAN",
              "593",
              "800",
              "74.12%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "16109430067",
            "name": "POOJA",
            "fatherName": "SUBE SINGH",
            "obtainedMarks": "630",
            "maxMarks": "800",
            "percentage": "78.75%",
            "cells": [
              "100",
              "16109430067",
              "POOJA",
              "SUBE SINGH",
              "630",
              "800",
              "78.75%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "16109430069",
            "name": "JULPHA",
            "fatherName": "IQBAL KHAN",
            "obtainedMarks": "603",
            "maxMarks": "800",
            "percentage": "75.38%",
            "cells": [
              "101",
              "16109430069",
              "JULPHA",
              "IQBAL KHAN",
              "603",
              "800",
              "75.38%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "16109430071",
            "name": "NEELAM KAUR",
            "fatherName": "GURCHARAN SINGH",
            "obtainedMarks": "636",
            "maxMarks": "800",
            "percentage": "79.50%",
            "cells": [
              "102",
              "16109430071",
              "NEELAM KAUR",
              "GURCHARAN SINGH",
              "636",
              "800",
              "79.50%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "16109430074",
            "name": "SIMRAN",
            "fatherName": "VIVEK KUMAR",
            "obtainedMarks": "697",
            "maxMarks": "800",
            "percentage": "87.12%",
            "cells": [
              "103",
              "16109430074",
              "SIMRAN",
              "VIVEK KUMAR",
              "697",
              "800",
              "87.12%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "16109430075",
            "name": "KANCHAN KUMAWAT",
            "fatherName": "NAND LAL KUMAWAT",
            "obtainedMarks": "617",
            "maxMarks": "800",
            "percentage": "77.12%",
            "cells": [
              "104",
              "16109430075",
              "KANCHAN KUMAWAT",
              "NAND LAL KUMAWAT",
              "617",
              "800",
              "77.12%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "16109430076",
            "name": "KAJAL YADAV",
            "fatherName": "RAM AVTAR YADAV",
            "obtainedMarks": "595",
            "maxMarks": "800",
            "percentage": "74.38%",
            "cells": [
              "105",
              "16109430076",
              "KAJAL YADAV",
              "RAM AVTAR YADAV",
              "595",
              "800",
              "74.38%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "16109430080",
            "name": "DAVINDER KAUR",
            "fatherName": "GURTEJ SINGH",
            "obtainedMarks": "591",
            "maxMarks": "800",
            "percentage": "73.88%",
            "cells": [
              "106",
              "16109430080",
              "DAVINDER KAUR",
              "GURTEJ SINGH",
              "591",
              "800",
              "73.88%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "16109430081",
            "name": "NISHA",
            "fatherName": "MAHAVIR SINGH",
            "obtainedMarks": "602",
            "maxMarks": "800",
            "percentage": "75.25%",
            "cells": [
              "107",
              "16109430081",
              "NISHA",
              "MAHAVIR SINGH",
              "602",
              "800",
              "75.25%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "16109430082",
            "name": "SHWETA",
            "fatherName": "RAM NARESH",
            "obtainedMarks": "582",
            "maxMarks": "800",
            "percentage": "72.75%",
            "cells": [
              "108",
              "16109430082",
              "SHWETA",
              "RAM NARESH",
              "582",
              "800",
              "72.75%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "16109430083",
            "name": "SANJU",
            "fatherName": "KRISHAN",
            "obtainedMarks": "637",
            "maxMarks": "800",
            "percentage": "79.62%",
            "cells": [
              "109",
              "16109430083",
              "SANJU",
              "KRISHAN",
              "637",
              "800",
              "79.62%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "16109430084",
            "name": "MANDEEP",
            "fatherName": "GURSEV SINGH",
            "obtainedMarks": "647",
            "maxMarks": "800",
            "percentage": "80.88%",
            "cells": [
              "110",
              "16109430084",
              "MANDEEP",
              "GURSEV SINGH",
              "647",
              "800",
              "80.88%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "16109430086",
            "name": "SIMRAN KAUR KHINDA",
            "fatherName": "BALBEER SINGH",
            "obtainedMarks": "637",
            "maxMarks": "800",
            "percentage": "79.62%",
            "cells": [
              "111",
              "16109430086",
              "SIMRAN KAUR KHINDA",
              "BALBEER SINGH",
              "637",
              "800",
              "79.62%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "16109430087",
            "name": "SANJU",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "574",
            "maxMarks": "800",
            "percentage": "71.75%",
            "cells": [
              "112",
              "16109430087",
              "SANJU",
              "RAM NIWAS",
              "574",
              "800",
              "71.75%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "16109430088",
            "name": "NAINA",
            "fatherName": "JOGINDER SINGH",
            "obtainedMarks": "574",
            "maxMarks": "800",
            "percentage": "71.75%",
            "cells": [
              "113",
              "16109430088",
              "NAINA",
              "JOGINDER SINGH",
              "574",
              "800",
              "71.75%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "16109430089",
            "name": "SHAINA",
            "fatherName": "VIPAN JINDAL",
            "obtainedMarks": "588",
            "maxMarks": "800",
            "percentage": "73.50%",
            "cells": [
              "114",
              "16109430089",
              "SHAINA",
              "VIPAN JINDAL",
              "588",
              "800",
              "73.50%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "16109430092",
            "name": "SAMI",
            "fatherName": "ATAM PARKASH",
            "obtainedMarks": "561",
            "maxMarks": "800",
            "percentage": "70.12%",
            "cells": [
              "115",
              "16109430092",
              "SAMI",
              "ATAM PARKASH",
              "561",
              "800",
              "70.12%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "16109430095",
            "name": "NAVNEET",
            "fatherName": "RAGHUBIR SINGH",
            "obtainedMarks": "625",
            "maxMarks": "800",
            "percentage": "78.12%",
            "cells": [
              "116",
              "16109430095",
              "NAVNEET",
              "RAGHUBIR SINGH",
              "625",
              "800",
              "78.12%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "16109430096",
            "name": "SHWETA",
            "fatherName": "SHO PARKASH",
            "obtainedMarks": "654",
            "maxMarks": "800",
            "percentage": "81.75%",
            "cells": [
              "117",
              "16109430096",
              "SHWETA",
              "SHO PARKASH",
              "654",
              "800",
              "81.75%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "16109430097",
            "name": "SUKHPREET KAUR",
            "fatherName": "GURTEJ SINGH",
            "obtainedMarks": "594",
            "maxMarks": "800",
            "percentage": "74.25%",
            "cells": [
              "118",
              "16109430097",
              "SUKHPREET KAUR",
              "GURTEJ SINGH",
              "594",
              "800",
              "74.25%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "16109430099",
            "name": "MUSKAN",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "565",
            "maxMarks": "800",
            "percentage": "70.62%",
            "cells": [
              "119",
              "16109430099",
              "MUSKAN",
              "SANJAY KUMAR",
              "565",
              "800",
              "70.62%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "16109430101",
            "name": "EKTA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "577",
            "maxMarks": "800",
            "percentage": "72.12%",
            "cells": [
              "120",
              "16109430101",
              "EKTA",
              "MADAN LAL",
              "577",
              "800",
              "72.12%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "16109430102",
            "name": "SHIVANI",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "646",
            "maxMarks": "800",
            "percentage": "80.75%",
            "cells": [
              "121",
              "16109430102",
              "SHIVANI",
              "RAJINDER SINGH",
              "646",
              "800",
              "80.75%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "16109430103",
            "name": "SONIA",
            "fatherName": "KULDEEP SINGH",
            "obtainedMarks": "579",
            "maxMarks": "800",
            "percentage": "72.38%",
            "cells": [
              "122",
              "16109430103",
              "SONIA",
              "KULDEEP SINGH",
              "579",
              "800",
              "72.38%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "16109430104",
            "name": "MANJU",
            "fatherName": "HAWA SINGH",
            "obtainedMarks": "578",
            "maxMarks": "800",
            "percentage": "72.25%",
            "cells": [
              "123",
              "16109430104",
              "MANJU",
              "HAWA SINGH",
              "578",
              "800",
              "72.25%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "16109430107",
            "name": "PRABHJOT KAUR",
            "fatherName": "SARJANT SINGH",
            "obtainedMarks": "628",
            "maxMarks": "800",
            "percentage": "78.50%",
            "cells": [
              "124",
              "16109430107",
              "PRABHJOT KAUR",
              "SARJANT SINGH",
              "628",
              "800",
              "78.50%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "16109430108",
            "name": "PARUL",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "588",
            "maxMarks": "800",
            "percentage": "73.50%",
            "cells": [
              "125",
              "16109430108",
              "PARUL",
              "SOHAN PAL",
              "588",
              "800",
              "73.50%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "16109430109",
            "name": "PUSHPA",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "599",
            "maxMarks": "800",
            "percentage": "74.88%",
            "cells": [
              "126",
              "16109430109",
              "PUSHPA",
              "DHARMPAL",
              "599",
              "800",
              "74.88%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "16109430117",
            "name": "EKTA",
            "fatherName": "RAM KUMAR",
            "obtainedMarks": "601",
            "maxMarks": "800",
            "percentage": "75.12%",
            "cells": [
              "127",
              "16109430117",
              "EKTA",
              "RAM KUMAR",
              "601",
              "800",
              "75.12%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "16109430118",
            "name": "SHASHI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "605",
            "maxMarks": "800",
            "percentage": "75.62%",
            "cells": [
              "128",
              "16109430118",
              "SHASHI",
              "SUNIL KUMAR",
              "605",
              "800",
              "75.62%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "16109430125",
            "name": "MONIKA",
            "fatherName": "BRIJ LAL",
            "obtainedMarks": "620",
            "maxMarks": "800",
            "percentage": "77.50%",
            "cells": [
              "129",
              "16109430125",
              "MONIKA",
              "BRIJ LAL",
              "620",
              "800",
              "77.50%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "16109430129",
            "name": "RENUKA CHAUDHARY",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "568",
            "maxMarks": "800",
            "percentage": "71%",
            "cells": [
              "130",
              "16109430129",
              "RENUKA CHAUDHARY",
              "VED PARKASH",
              "568",
              "800",
              "71%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "16109430136",
            "name": "RANI",
            "fatherName": "SUBHASH",
            "obtainedMarks": "644",
            "maxMarks": "800",
            "percentage": "80.50%",
            "cells": [
              "131",
              "16109430136",
              "RANI",
              "SUBHASH",
              "644",
              "800",
              "80.50%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "16109430138",
            "name": "AKKI KAUR",
            "fatherName": "BUTA SINGH",
            "obtainedMarks": "621",
            "maxMarks": "800",
            "percentage": "77.62%",
            "cells": [
              "132",
              "16109430138",
              "AKKI KAUR",
              "BUTA SINGH",
              "621",
              "800",
              "77.62%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "16109430143",
            "name": "MAHIMA ARORA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "579",
            "maxMarks": "800",
            "percentage": "72.38%",
            "cells": [
              "133",
              "16109430143",
              "MAHIMA ARORA",
              "RAJ KUMAR",
              "579",
              "800",
              "72.38%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "16109430144",
            "name": "MAYAWATI",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "634",
            "maxMarks": "800",
            "percentage": "79.25%",
            "cells": [
              "134",
              "16109430144",
              "MAYAWATI",
              "OM PRAKASH",
              "634",
              "800",
              "79.25%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "16109430145",
            "name": "PUSHPA DEVI",
            "fatherName": "JAGDISH",
            "obtainedMarks": "605",
            "maxMarks": "800",
            "percentage": "75.62%",
            "cells": [
              "135",
              "16109430145",
              "PUSHPA DEVI",
              "JAGDISH",
              "605",
              "800",
              "75.62%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "16109430146",
            "name": "ADESH",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "655",
            "maxMarks": "800",
            "percentage": "81.88%",
            "cells": [
              "136",
              "16109430146",
              "ADESH",
              "VED PARKASH",
              "655",
              "800",
              "81.88%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "16109430147",
            "name": "ANITA RANI",
            "fatherName": "SURENDER",
            "obtainedMarks": "635",
            "maxMarks": "800",
            "percentage": "79.38%",
            "cells": [
              "137",
              "16109430147",
              "ANITA RANI",
              "SURENDER",
              "635",
              "800",
              "79.38%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "16109430148",
            "name": "GURPRIT KOUR",
            "fatherName": "DHARMENDER SINGH",
            "obtainedMarks": "661",
            "maxMarks": "800",
            "percentage": "82.62%",
            "cells": [
              "138",
              "16109430148",
              "GURPRIT KOUR",
              "DHARMENDER SINGH",
              "661",
              "800",
              "82.62%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "16109430149",
            "name": "RAMANDEEP KAUR",
            "fatherName": "BALJEET SINGH",
            "obtainedMarks": "572",
            "maxMarks": "800",
            "percentage": "71.50%",
            "cells": [
              "139",
              "16109430149",
              "RAMANDEEP KAUR",
              "BALJEET SINGH",
              "572",
              "800",
              "71.50%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "16109430154",
            "name": "MANVEER KAUR",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "578",
            "maxMarks": "800",
            "percentage": "72.25%",
            "cells": [
              "140",
              "16109430154",
              "MANVEER KAUR",
              "RAM SINGH",
              "578",
              "800",
              "72.25%"
            ]
          },
          {
            "sNo": "141",
            "rollNo": "16109430156",
            "name": "MONIKA",
            "fatherName": "SHYAM SUNDER",
            "obtainedMarks": "629",
            "maxMarks": "800",
            "percentage": "78.62%",
            "cells": [
              "141",
              "16109430156",
              "MONIKA",
              "SHYAM SUNDER",
              "629",
              "800",
              "78.62%"
            ]
          }
        ]
      },
      {
        "courseName": "BSC NM(I + II SEM)",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "142",
            "rollNo": "180090442001",
            "name": "Kamya Aggarwal",
            "fatherName": "Sanjeev Kumar",
            "obtainedMarks": "860",
            "maxMarks": "1175",
            "percentage": "73.19%",
            "cells": [
              "142",
              "180090442001",
              "Kamya Aggarwal",
              "Sanjeev Kumar",
              "860",
              "1175",
              "73.19%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "180090442003",
            "name": "Renu",
            "fatherName": "Karansingh",
            "obtainedMarks": "846",
            "maxMarks": "1175",
            "percentage": "72%",
            "cells": [
              "143",
              "180090442003",
              "Renu",
              "Karansingh",
              "846",
              "1175",
              "72%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "180090442004",
            "name": "Monika",
            "fatherName": "Shishpal",
            "obtainedMarks": "973",
            "maxMarks": "1175",
            "percentage": "82.81%",
            "cells": [
              "144",
              "180090442004",
              "Monika",
              "Shishpal",
              "973",
              "1175",
              "82.81%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "180090442012",
            "name": "Neetu",
            "fatherName": "Ved Prakash",
            "obtainedMarks": "982",
            "maxMarks": "1175",
            "percentage": "83.57%",
            "cells": [
              "145",
              "180090442012",
              "Neetu",
              "Ved Prakash",
              "982",
              "1175",
              "83.57%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "180090442014",
            "name": "Himanshi",
            "fatherName": "Banwari Lal",
            "obtainedMarks": "828",
            "maxMarks": "1175",
            "percentage": "70.47%",
            "cells": [
              "146",
              "180090442014",
              "Himanshi",
              "Banwari Lal",
              "828",
              "1175",
              "70.47%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "180090442015",
            "name": "Manisha",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "948",
            "maxMarks": "1175",
            "percentage": "80.68%",
            "cells": [
              "147",
              "180090442015",
              "Manisha",
              "Vinod Kumar",
              "948",
              "1175",
              "80.68%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "180090442019",
            "name": "Simran",
            "fatherName": "Surender Singh",
            "obtainedMarks": "853",
            "maxMarks": "1175",
            "percentage": "72.60%",
            "cells": [
              "148",
              "180090442019",
              "Simran",
              "Surender Singh",
              "853",
              "1175",
              "72.60%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "149",
            "rollNo": "170090442006",
            "name": "GURPUNEET\n KAUR",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "919",
            "maxMarks": "1100",
            "percentage": "83.55%",
            "cells": [
              "149",
              "170090442006",
              "GURPUNEET\n KAUR",
              "RAM SINGH",
              "919",
              "1100",
              "83.55%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "170090442008",
            "name": "MANPREET KAUR",
            "fatherName": "CHAKOTAR SINGH",
            "obtainedMarks": "860",
            "maxMarks": "1100",
            "percentage": "78.18%",
            "cells": [
              "150",
              "170090442008",
              "MANPREET KAUR",
              "CHAKOTAR SINGH",
              "860",
              "1100",
              "78.18%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "170090442012",
            "name": "REEYA",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "932",
            "maxMarks": "1100",
            "percentage": "84.73%",
            "cells": [
              "151",
              "170090442012",
              "REEYA",
              "RAVINDER KUMAR",
              "932",
              "1100",
              "84.73%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "170090442017",
            "name": "BHAWNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "810",
            "maxMarks": "1100",
            "percentage": "73.64%",
            "cells": [
              "152",
              "170090442017",
              "BHAWNA",
              "KRISHAN KUMAR",
              "810",
              "1100",
              "73.64%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "170090442018",
            "name": "JEENU",
            "fatherName": "GORI SHANKAR",
            "obtainedMarks": "905",
            "maxMarks": "1100",
            "percentage": "82.27%",
            "cells": [
              "153",
              "170090442018",
              "JEENU",
              "GORI SHANKAR",
              "905",
              "1100",
              "82.27%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "170090442019",
            "name": "EKTA RANI",
            "fatherName": "AHEL CHAND",
            "obtainedMarks": "841",
            "maxMarks": "1100",
            "percentage": "76.45%",
            "cells": [
              "154",
              "170090442019",
              "EKTA RANI",
              "AHEL CHAND",
              "841",
              "1100",
              "76.45%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "170090442020",
            "name": "SHAKILA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "931",
            "maxMarks": "1100",
            "percentage": "84.64%",
            "cells": [
              "155",
              "170090442020",
              "SHAKILA",
              "MAHENDER SINGH",
              "931",
              "1100",
              "84.64%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "170090442021",
            "name": "PRITPAL KAUR",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "924",
            "maxMarks": "1100",
            "percentage": "84%",
            "cells": [
              "156",
              "170090442021",
              "PRITPAL KAUR",
              "RAJENDER SINGH",
              "924",
              "1100",
              "84%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "170090442022",
            "name": "NITESH RANI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "811",
            "maxMarks": "1100",
            "percentage": "73.73%",
            "cells": [
              "157",
              "170090442022",
              "NITESH RANI",
              "KRISHAN KUMAR",
              "811",
              "1100",
              "73.73%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "170090442023",
            "name": "ANKISHA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "888",
            "maxMarks": "1100",
            "percentage": "80.73%",
            "cells": [
              "158",
              "170090442023",
              "ANKISHA",
              "SHAMSHER SINGH",
              "888",
              "1100",
              "80.73%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "170090442025",
            "name": "KAMLESH",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "798",
            "maxMarks": "1100",
            "percentage": "72.55%",
            "cells": [
              "159",
              "170090442025",
              "KAMLESH",
              "KRISHAN KUMAR",
              "798",
              "1100",
              "72.55%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "170090442026",
            "name": "JYOTI",
            "fatherName": "RAMESH CHANDER",
            "obtainedMarks": "904",
            "maxMarks": "1100",
            "percentage": "82.18%",
            "cells": [
              "160",
              "170090442026",
              "JYOTI",
              "RAMESH CHANDER",
              "904",
              "1100",
              "82.18%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "170090442029",
            "name": "MONIKA",
            "fatherName": "KARAN SINGH",
            "obtainedMarks": "833",
            "maxMarks": "1100",
            "percentage": "75.73%",
            "cells": [
              "161",
              "170090442029",
              "MONIKA",
              "KARAN SINGH",
              "833",
              "1100",
              "75.73%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "170090442032",
            "name": "TAMANA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "803",
            "maxMarks": "1100",
            "percentage": "73%",
            "cells": [
              "162",
              "170090442032",
              "TAMANA",
              "VINOD KUMAR",
              "803",
              "1100",
              "73%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "170090442035",
            "name": "ANJU RANI",
            "fatherName": "RAJBIR",
            "obtainedMarks": "922",
            "maxMarks": "1100",
            "percentage": "83.82%",
            "cells": [
              "163",
              "170090442035",
              "ANJU RANI",
              "RAJBIR",
              "922",
              "1100",
              "83.82%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "170090442037",
            "name": "DIKSHA RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "828",
            "maxMarks": "1100",
            "percentage": "75.27%",
            "cells": [
              "164",
              "170090442037",
              "DIKSHA RANI",
              "GOPAL",
              "828",
              "1100",
              "75.27%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "170090442039",
            "name": "SUKHBHEJ KAUR",
            "fatherName": "BHUPINDER SINGH",
            "obtainedMarks": "816",
            "maxMarks": "1100",
            "percentage": "74.18%",
            "cells": [
              "165",
              "170090442039",
              "SUKHBHEJ KAUR",
              "BHUPINDER SINGH",
              "816",
              "1100",
              "74.18%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "166",
            "rollNo": "16109442002",
            "name": "ANNU",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "166",
              "16109442002",
              "ANNU",
              "VINOD KUMAR",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "16109442003",
            "name": "MANPREET KAUR",
            "fatherName": "JEET SINGH",
            "obtainedMarks": "725",
            "maxMarks": "900",
            "percentage": "80.56%",
            "cells": [
              "167",
              "16109442003",
              "MANPREET KAUR",
              "JEET SINGH",
              "725",
              "900",
              "80.56%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "16109442004",
            "name": "MAMTA",
            "fatherName": "HARI CHAND",
            "obtainedMarks": "600",
            "maxMarks": "900",
            "percentage": "66.67%",
            "cells": [
              "168",
              "16109442004",
              "MAMTA",
              "HARI CHAND",
              "600",
              "900",
              "66.67%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "16109442007",
            "name": "NISHA RANI",
            "fatherName": "SUKHWINDER KUMAR",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "169",
              "16109442007",
              "NISHA RANI",
              "SUKHWINDER KUMAR",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "16109442008",
            "name": "SHAINA GARG",
            "fatherName": "JAIPAL GARG",
            "obtainedMarks": "693",
            "maxMarks": "900",
            "percentage": "77%",
            "cells": [
              "170",
              "16109442008",
              "SHAINA GARG",
              "JAIPAL GARG",
              "693",
              "900",
              "77%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "16109442009",
            "name": "AARZOO",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.22%",
            "cells": [
              "171",
              "16109442009",
              "AARZOO",
              "RAVINDER KUMAR",
              "677",
              "900",
              "75.22%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "16109442014",
            "name": "PRIYANKA",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "172",
              "16109442014",
              "PRIYANKA",
              "RANBIR SINGH",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "16109442016",
            "name": "BEANT KAUR",
            "fatherName": "KAMIKAR SINGH",
            "obtainedMarks": "809",
            "maxMarks": "900",
            "percentage": "89.89%",
            "cells": [
              "173",
              "16109442016",
              "BEANT KAUR",
              "KAMIKAR SINGH",
              "809",
              "900",
              "89.89%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "16109442017",
            "name": "PRIYANKA RANI",
            "fatherName": "VINOD SHARMA",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.56%",
            "cells": [
              "174",
              "16109442017",
              "PRIYANKA RANI",
              "VINOD SHARMA",
              "680",
              "900",
              "75.56%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "16109442018",
            "name": "RIYA RAN",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "783",
            "maxMarks": "900",
            "percentage": "87%",
            "cells": [
              "175",
              "16109442018",
              "RIYA RAN",
              "ANAND KUMAR",
              "783",
              "900",
              "87%"
            ]
          },
          {
            "sNo": "176",
            "rollNo": "16109442023",
            "name": "KOMAL RANI",
            "fatherName": "MADAN SINGH",
            "obtainedMarks": "703",
            "maxMarks": "900",
            "percentage": "78.11%",
            "cells": [
              "176",
              "16109442023",
              "KOMAL RANI",
              "MADAN SINGH",
              "703",
              "900",
              "78.11%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "16109442024",
            "name": "SUNITA RANI",
            "fatherName": "GURDEV SINGH",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.78%",
            "cells": [
              "177",
              "16109442024",
              "SUNITA RANI",
              "GURDEV SINGH",
              "700",
              "900",
              "77.78%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "16109442035",
            "name": "KHUSBOO BANSAL",
            "fatherName": "DIWAN CHAND",
            "obtainedMarks": "671",
            "maxMarks": "900",
            "percentage": "74.56%",
            "cells": [
              "178",
              "16109442035",
              "KHUSBOO BANSAL",
              "DIWAN CHAND",
              "671",
              "900",
              "74.56%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "16109442037",
            "name": "PARUL",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "822",
            "maxMarks": "900",
            "percentage": "91.33%",
            "cells": [
              "179",
              "16109442037",
              "PARUL",
              "SUSHIL KUMAR",
              "822",
              "900",
              "91.33%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "16109442041",
            "name": "ANSHU",
            "fatherName": "GURMEET KUMAR",
            "obtainedMarks": "728",
            "maxMarks": "900",
            "percentage": "80.89%",
            "cells": [
              "180",
              "16109442041",
              "ANSHU",
              "GURMEET KUMAR",
              "728",
              "900",
              "80.89%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "16109442043",
            "name": "MANPREET KAUR",
            "fatherName": "JAGMOHAN SENGAL",
            "obtainedMarks": "755",
            "maxMarks": "900",
            "percentage": "83.89%",
            "cells": [
              "181",
              "16109442043",
              "MANPREET KAUR",
              "JAGMOHAN SENGAL",
              "755",
              "900",
              "83.89%"
            ]
          },
          {
            "sNo": "182",
            "rollNo": "16109442044",
            "name": "HARMEET KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "691",
            "maxMarks": "900",
            "percentage": "76.78%",
            "cells": [
              "182",
              "16109442044",
              "HARMEET KAUR",
              "JASPAL SINGH",
              "691",
              "900",
              "76.78%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "16109442047",
            "name": "NAVNEET",
            "fatherName": "GIAU CHAND",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "183",
              "16109442047",
              "NAVNEET",
              "GIAU CHAND",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "16109442048",
            "name": "NISHU",
            "fatherName": "SATISH CHAND",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.56%",
            "cells": [
              "184",
              "16109442048",
              "NISHU",
              "SATISH CHAND",
              "680",
              "900",
              "75.56%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "16109442052",
            "name": "ANU PRIYA",
            "fatherName": "PREHLAD",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "185",
              "16109442052",
              "ANU PRIYA",
              "PREHLAD",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "186",
            "rollNo": "16109442055",
            "name": "SHIVANI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "728",
            "maxMarks": "900",
            "percentage": "80.89%",
            "cells": [
              "186",
              "16109442055",
              "SHIVANI",
              "KEWAL KRISHAN",
              "728",
              "900",
              "80.89%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "16109442056",
            "name": "KOMAL RANI",
            "fatherName": "RAM CHAND",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "187",
              "16109442056",
              "KOMAL RANI",
              "RAM CHAND",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "16109442057",
            "name": "KRITIKA",
            "fatherName": "MEKH RAM",
            "obtainedMarks": "736",
            "maxMarks": "900",
            "percentage": "81.78%",
            "cells": [
              "188",
              "16109442057",
              "KRITIKA",
              "MEKH RAM",
              "736",
              "900",
              "81.78%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "189",
            "rollNo": "180090442001",
            "name": "KAMYA AGGARWAL",
            "fatherName": "SANJEEV KUMAR",
            "obtainedMarks": "919",
            "maxMarks": "1100",
            "percentage": "83.55%",
            "cells": [
              "189",
              "180090442001",
              "KAMYA AGGARWAL",
              "SANJEEV KUMAR",
              "919",
              "1100",
              "83.55%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "180090442004",
            "name": "MONIKA",
            "fatherName": "SHEESH PAL",
            "obtainedMarks": "832",
            "maxMarks": "1100",
            "percentage": "75.64%",
            "cells": [
              "190",
              "180090442004",
              "MONIKA",
              "SHEESH PAL",
              "832",
              "1100",
              "75.64%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "180090442005",
            "name": "PUSHPA",
            "fatherName": "BHIM SEN",
            "obtainedMarks": "771",
            "maxMarks": "1100",
            "percentage": "70.09%",
            "cells": [
              "191",
              "180090442005",
              "PUSHPA",
              "BHIM SEN",
              "771",
              "1100",
              "70.09%"
            ]
          },
          {
            "sNo": "192",
            "rollNo": "180090442006",
            "name": "SONU",
            "fatherName": "BALWAN",
            "obtainedMarks": "808",
            "maxMarks": "1100",
            "percentage": "73.45%",
            "cells": [
              "192",
              "180090442006",
              "SONU",
              "BALWAN",
              "808",
              "1100",
              "73.45%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "180090442010",
            "name": "USHA RANI",
            "fatherName": "DHARMINDER",
            "obtainedMarks": "909",
            "maxMarks": "1100",
            "percentage": "82.64%",
            "cells": [
              "193",
              "180090442010",
              "USHA RANI",
              "DHARMINDER",
              "909",
              "1100",
              "82.64%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) III + IV Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.Sc (CS) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "194",
            "rollNo": "16109440006",
            "name": "ANAMIKA",
            "fatherName": "MANGAT RAI",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.60%",
            "cells": [
              "194",
              "16109440006",
              "ANAMIKA",
              "MANGAT RAI",
              "654",
              "900",
              "72.60%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "16109440007",
            "name": "PRIYANKA",
            "fatherName": "MAHANDER SINGH",
            "obtainedMarks": "756",
            "maxMarks": "900",
            "percentage": "84%",
            "cells": [
              "195",
              "16109440007",
              "PRIYANKA",
              "MAHANDER SINGH",
              "756",
              "900",
              "84%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA I YEAR",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "196",
            "rollNo": "180090470008",
            "name": "SAPNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1265",
            "maxMarks": "1700",
            "percentage": "74.41%",
            "cells": [
              "196",
              "180090470008",
              "SAPNA",
              "KRISHAN KUMAR",
              "1265",
              "1700",
              "74.41%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "180090470012",
            "name": "ANCHAL SHARMA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1322",
            "maxMarks": "1700",
            "percentage": "77.76%",
            "cells": [
              "197",
              "180090470012",
              "ANCHAL SHARMA",
              "KRISHAN KUMAR",
              "1322",
              "1700",
              "77.76%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "198",
            "rollNo": "170090470001",
            "name": "POOJA",
            "fatherName": "MANI RAM",
            "obtainedMarks": "1268",
            "maxMarks": "1700",
            "percentage": "74.59%",
            "cells": [
              "198",
              "170090470001",
              "POOJA",
              "MANI RAM",
              "1268",
              "1700",
              "74.59%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "170090470004",
            "name": "VIJAY LAXMI",
            "fatherName": "RAM MURTI BISHNOI",
            "obtainedMarks": "1232",
            "maxMarks": "1700",
            "percentage": "72.47%",
            "cells": [
              "199",
              "170090470004",
              "VIJAY LAXMI",
              "RAM MURTI BISHNOI",
              "1232",
              "1700",
              "72.47%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "170090470010",
            "name": "SONALI",
            "fatherName": "SANT LAL",
            "obtainedMarks": "1344",
            "maxMarks": "1700",
            "percentage": "79.06%",
            "cells": [
              "200",
              "170090470010",
              "SONALI",
              "SANT LAL",
              "1344",
              "1700",
              "79.06%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "170090470012",
            "name": "GAZAL",
            "fatherName": "SATPAL SONI",
            "obtainedMarks": "1324",
            "maxMarks": "1700",
            "percentage": "77.88%",
            "cells": [
              "201",
              "170090470012",
              "GAZAL",
              "SATPAL SONI",
              "1324",
              "1700",
              "77.88%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "202",
            "rollNo": "16109470001",
            "name": "MANISH RANI",
            "fatherName": "Ranbir singh",
            "obtainedMarks": "1237",
            "maxMarks": "1600",
            "percentage": "77.31%",
            "cells": [
              "202",
              "16109470001",
              "MANISH RANI",
              "Ranbir singh",
              "1237",
              "1600",
              "77.31%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "16109470002",
            "name": "JEEVANJOT KAUR",
            "fatherName": "BHUPINDER SINGH",
            "obtainedMarks": "1222",
            "maxMarks": "1600",
            "percentage": "76.38%",
            "cells": [
              "203",
              "16109470002",
              "JEEVANJOT KAUR",
              "BHUPINDER SINGH",
              "1222",
              "1600",
              "76.38%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "16109470005",
            "name": "RAVEENA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1274",
            "maxMarks": "1600",
            "percentage": "79.62%",
            "cells": [
              "204",
              "16109470005",
              "RAVEENA",
              "MADAN LAL",
              "1274",
              "1600",
              "79.62%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "16109470006",
            "name": "HARPINDER KAUR",
            "fatherName": "BHOORA SINGH",
            "obtainedMarks": "1219",
            "maxMarks": "1600",
            "percentage": "76.19%",
            "cells": [
              "205",
              "16109470006",
              "HARPINDER KAUR",
              "BHOORA SINGH",
              "1219",
              "1600",
              "76.19%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "16109470007",
            "name": "LAKSHMI RANI",
            "fatherName": "GURUPARTAP SINGH",
            "obtainedMarks": "1163",
            "maxMarks": "1600",
            "percentage": "72.69%",
            "cells": [
              "206",
              "16109470007",
              "LAKSHMI RANI",
              "GURUPARTAP SINGH",
              "1163",
              "1600",
              "72.69%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "16109470008",
            "name": "KULDEEP KAUR",
            "fatherName": "BAKHSHISH SINGH",
            "obtainedMarks": "1240",
            "maxMarks": "1600",
            "percentage": "77.50%",
            "cells": [
              "207",
              "16109470008",
              "KULDEEP KAUR",
              "BAKHSHISH SINGH",
              "1240",
              "1600",
              "77.50%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "16109470009",
            "name": "RASHMI",
            "fatherName": "VEERBHAN",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "208",
              "16109470009",
              "RASHMI",
              "VEERBHAN",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "209",
            "rollNo": "16109470011",
            "name": "MANPREET KAUR",
            "fatherName": "MEHAR SINGH",
            "obtainedMarks": "1219",
            "maxMarks": "1600",
            "percentage": "76.19%",
            "cells": [
              "209",
              "16109470011",
              "MANPREET KAUR",
              "MEHAR SINGH",
              "1219",
              "1600",
              "76.19%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "16109470014",
            "name": "POONAM RANI",
            "fatherName": "HUKAM SINGH",
            "obtainedMarks": "1163",
            "maxMarks": "1600",
            "percentage": "72.69%",
            "cells": [
              "210",
              "16109470014",
              "POONAM RANI",
              "HUKAM SINGH",
              "1163",
              "1600",
              "72.69%"
            ]
          },
          {
            "sNo": "211",
            "rollNo": "16109470016",
            "name": "SAMIKSHA",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "1201",
            "maxMarks": "1600",
            "percentage": "75.06%",
            "cells": [
              "211",
              "16109470016",
              "SAMIKSHA",
              "DHARMPAL",
              "1201",
              "1600",
              "75.06%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "16109470017",
            "name": "SANGEETA",
            "fatherName": "DEVINDER KUMAR",
            "obtainedMarks": "1172",
            "maxMarks": "1600",
            "percentage": "73.25%",
            "cells": [
              "212",
              "16109470017",
              "SANGEETA",
              "DEVINDER KUMAR",
              "1172",
              "1600",
              "73.25%"
            ]
          }
        ]
      },
      {
        "courseName": "BAMC I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BAMC III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "213",
            "rollNo": "170090420002",
            "name": "SONIKA",
            "fatherName": "VIRENDER KUMAR",
            "obtainedMarks": "866",
            "maxMarks": "1100",
            "percentage": "78.73%",
            "cells": [
              "213",
              "170090420002",
              "SONIKA",
              "VIRENDER KUMAR",
              "866",
              "1100",
              "78.73%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "170090420003",
            "name": "SUSHMA",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "773",
            "maxMarks": "1100",
            "percentage": "70.27%",
            "cells": [
              "214",
              "170090420003",
              "SUSHMA",
              "SUBASH CHANDER",
              "773",
              "1100",
              "70.27%"
            ]
          }
        ]
      },
      {
        "courseName": "BAMC V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "215",
            "rollNo": "16109420003",
            "name": "KANCHAN BALA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "215",
              "16109420003",
              "KANCHAN BALA",
              "SURENDER KUMAR",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "16109420004",
            "name": "CHANCHAL RANI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "702",
            "maxMarks": "1000",
            "percentage": "70.20%",
            "cells": [
              "216",
              "16109420004",
              "CHANCHAL RANI",
              "SURENDER KUMAR",
              "702",
              "1000",
              "70.20%"
            ]
          },
          {
            "sNo": "217",
            "rollNo": "16109420007",
            "name": "POONAM RANI",
            "fatherName": "MOOL CHAND",
            "obtainedMarks": "762",
            "maxMarks": "1000",
            "percentage": "76.20%",
            "cells": [
              "217",
              "16109420007",
              "POONAM RANI",
              "MOOL CHAND",
              "762",
              "1000",
              "76.20%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "16109420008",
            "name": "KIRAN RANI",
            "fatherName": "GOPAL CHAND",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "218",
              "16109420008",
              "KIRAN RANI",
              "GOPAL CHAND",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "219",
            "rollNo": "16109420011",
            "name": "RIYA GOYAL",
            "fatherName": "BIMAL GOYAL",
            "obtainedMarks": "801",
            "maxMarks": "1000",
            "percentage": "80.10%",
            "cells": [
              "219",
              "16109420011",
              "RIYA GOYAL",
              "BIMAL GOYAL",
              "801",
              "1000",
              "80.10%"
            ]
          },
          {
            "sNo": "220",
            "rollNo": "16109420012",
            "name": "GURPREET",
            "fatherName": "JAI CHAND",
            "obtainedMarks": "763",
            "maxMarks": "1000",
            "percentage": "76.30%",
            "cells": [
              "220",
              "16109420012",
              "GURPREET",
              "JAI CHAND",
              "763",
              "1000",
              "76.30%"
            ]
          },
          {
            "sNo": "221",
            "rollNo": "16109420013",
            "name": "SIMRAN GANDHI",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "786",
            "maxMarks": "1000",
            "percentage": "78.60%",
            "cells": [
              "221",
              "16109420013",
              "SIMRAN GANDHI",
              "SANDEEP KUMAR",
              "786",
              "1000",
              "78.60%"
            ]
          },
          {
            "sNo": "222",
            "rollNo": "16109420016",
            "name": "REENA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "770",
            "maxMarks": "1000",
            "percentage": "77%",
            "cells": [
              "222",
              "16109420016",
              "REENA",
              "RAJENDER",
              "770",
              "1000",
              "77%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA III + IV Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA V+ IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "223",
            "rollNo": "16109480003",
            "name": "PARIVINKAL THIND",
            "fatherName": "HARJINDER  SINGH",
            "obtainedMarks": "900",
            "maxMarks": "1200",
            "percentage": "71.41%",
            "cells": [
              "223",
              "16109480003",
              "PARIVINKAL THIND",
              "HARJINDER  SINGH",
              "900",
              "1200",
              "71.41%"
            ]
          },
          {
            "sNo": "224",
            "rollNo": "16109480004",
            "name": "MANDEEP KAUR",
            "fatherName": "SUKHMINDER SINGH",
            "obtainedMarks": "966",
            "maxMarks": "1200",
            "percentage": "80.50%",
            "cells": [
              "224",
              "16109480004",
              "MANDEEP KAUR",
              "SUKHMINDER SINGH",
              "966",
              "1200",
              "80.50%"
            ]
          },
          {
            "sNo": "225",
            "rollNo": "16109480005",
            "name": "KHUSHPREET",
            "fatherName": "SARDUL SINGH",
            "obtainedMarks": "932",
            "maxMarks": "1200",
            "percentage": "72.41%",
            "cells": [
              "225",
              "16109480005",
              "KHUSHPREET",
              "SARDUL SINGH",
              "932",
              "1200",
              "72.41%"
            ]
          },
          {
            "sNo": "226",
            "rollNo": "16109480007",
            "name": "NAVPREET",
            "fatherName": "SARDUL SINGH",
            "obtainedMarks": "919",
            "maxMarks": "1200",
            "percentage": "76.58%",
            "cells": [
              "226",
              "16109480007",
              "NAVPREET",
              "SARDUL SINGH",
              "919",
              "1200",
              "76.58%"
            ]
          },
          {
            "sNo": "227",
            "rollNo": "16109480010",
            "name": "NAVJEET KAUR",
            "fatherName": "LAKHVINDER SINGH",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "73.41%",
            "cells": [
              "227",
              "16109480010",
              "NAVJEET KAUR",
              "LAKHVINDER SINGH",
              "896",
              "1200",
              "73.41%"
            ]
          },
          {
            "sNo": "228",
            "rollNo": "16109480011",
            "name": "NAVNEET KAUR",
            "fatherName": "GURPREET SINGH",
            "obtainedMarks": "909",
            "maxMarks": "1200",
            "percentage": "75.75%",
            "cells": [
              "228",
              "16109480011",
              "NAVNEET KAUR",
              "GURPREET SINGH",
              "909",
              "1200",
              "75.75%"
            ]
          },
          {
            "sNo": "229",
            "rollNo": "16109480015",
            "name": "SUKHMANPREET",
            "fatherName": "NAGINDER",
            "obtainedMarks": "915",
            "maxMarks": "1200",
            "percentage": "74.41%",
            "cells": [
              "229",
              "16109480015",
              "SUKHMANPREET",
              "NAGINDER",
              "915",
              "1200",
              "74.41%"
            ]
          },
          {
            "sNo": "230",
            "rollNo": "16109480017",
            "name": "ROOHJEET INSAN",
            "fatherName": "ST. GURMEET RAM RAHIM SINGH JI INASN",
            "obtainedMarks": "902",
            "maxMarks": "1200",
            "percentage": "75.17%",
            "cells": [
              "230",
              "16109480017",
              "ROOHJEET INSAN",
              "ST. GURMEET RAM RAHIM SINGH JI INASN",
              "902",
              "1200",
              "75.17%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "231",
            "rollNo": "180090460010",
            "name": "MOHINI",
            "fatherName": "SATPAL",
            "obtainedMarks": "819",
            "maxMarks": "1150",
            "percentage": "71.21%",
            "cells": [
              "231",
              "180090460010",
              "MOHINI",
              "SATPAL",
              "819",
              "1150",
              "71.21%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "232",
            "rollNo": "170090460002",
            "name": "KAMALPREET KAUR",
            "fatherName": "JASKARAN SINGH",
            "obtainedMarks": "1005",
            "maxMarks": "1250",
            "percentage": "80.40%",
            "cells": [
              "232",
              "170090460002",
              "KAMALPREET KAUR",
              "JASKARAN SINGH",
              "1005",
              "1250",
              "80.40%"
            ]
          },
          {
            "sNo": "233",
            "rollNo": "170090460003",
            "name": "SIMRAN",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "888",
            "maxMarks": "1250",
            "percentage": "71.04%",
            "cells": [
              "233",
              "170090460003",
              "SIMRAN",
              "SURENDER KUMAR",
              "888",
              "1250",
              "71.04%"
            ]
          },
          {
            "sNo": "234",
            "rollNo": "170090460005",
            "name": "ARMANPREET KAUR",
            "fatherName": "SURINDER SINGH",
            "obtainedMarks": "972",
            "maxMarks": "1250",
            "percentage": "77.76%",
            "cells": [
              "234",
              "170090460005",
              "ARMANPREET KAUR",
              "SURINDER SINGH",
              "972",
              "1250",
              "77.76%"
            ]
          },
          {
            "sNo": "235",
            "rollNo": "170090460006",
            "name": "GURPREET KAUR",
            "fatherName": "MANISH KUMAR",
            "obtainedMarks": "963",
            "maxMarks": "1250",
            "percentage": "77.04%",
            "cells": [
              "235",
              "170090460006",
              "GURPREET KAUR",
              "MANISH KUMAR",
              "963",
              "1250",
              "77.04%"
            ]
          },
          {
            "sNo": "236",
            "rollNo": "170090460007",
            "name": "MAMTA",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "972",
            "maxMarks": "1250",
            "percentage": "77.76%",
            "cells": [
              "236",
              "170090460007",
              "MAMTA",
              "BALBIR SINGH",
              "972",
              "1250",
              "77.76%"
            ]
          },
          {
            "sNo": "237",
            "rollNo": "170090460009",
            "name": "JANNAT ARORA",
            "fatherName": "PURUSHOTAM KUMAR",
            "obtainedMarks": "900",
            "maxMarks": "1250",
            "percentage": "72%",
            "cells": [
              "237",
              "170090460009",
              "JANNAT ARORA",
              "PURUSHOTAM KUMAR",
              "900",
              "1250",
              "72%"
            ]
          },
          {
            "sNo": "238",
            "rollNo": "170090460012",
            "name": "KOMAL BENIWAL",
            "fatherName": "PREM BENIWAL",
            "obtainedMarks": "901",
            "maxMarks": "1250",
            "percentage": "72.08%",
            "cells": [
              "238",
              "170090460012",
              "KOMAL BENIWAL",
              "PREM BENIWAL",
              "901",
              "1250",
              "72.08%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "239",
            "rollNo": "16109460007",
            "name": "MANIT",
            "fatherName": "CHHABIL DASS",
            "obtainedMarks": "954",
            "maxMarks": "1200",
            "percentage": "79.50%",
            "cells": [
              "239",
              "16109460007",
              "MANIT",
              "CHHABIL DASS",
              "954",
              "1200",
              "79.50%"
            ]
          },
          {
            "sNo": "240",
            "rollNo": "16109460011",
            "name": "SIMARJEET KAUR",
            "fatherName": "AMRIK SINGH",
            "obtainedMarks": "902",
            "maxMarks": "1200",
            "percentage": "75.17%",
            "cells": [
              "240",
              "16109460011",
              "SIMARJEET KAUR",
              "AMRIK SINGH",
              "902",
              "1200",
              "75.17%"
            ]
          },
          {
            "sNo": "241",
            "rollNo": "16109460014",
            "name": "PRIYANKA GARG",
            "fatherName": "ARJUN DAS",
            "obtainedMarks": "881",
            "maxMarks": "1200",
            "percentage": "73.42%",
            "cells": [
              "241",
              "16109460014",
              "PRIYANKA GARG",
              "ARJUN DAS",
              "881",
              "1200",
              "73.42%"
            ]
          },
          {
            "sNo": "242",
            "rollNo": "16109460020",
            "name": "KHUSHPREET KAUR",
            "fatherName": "BALKARAN SINGH",
            "obtainedMarks": "858",
            "maxMarks": "1200",
            "percentage": "71.50%",
            "cells": [
              "242",
              "16109460020",
              "KHUSHPREET KAUR",
              "BALKARAN SINGH",
              "858",
              "1200",
              "71.50%"
            ]
          },
          {
            "sNo": "243",
            "rollNo": "16109460022",
            "name": "MAMTA CHOYAL",
            "fatherName": "SURJEET CHOYAL",
            "obtainedMarks": "933",
            "maxMarks": "1200",
            "percentage": "77.75%",
            "cells": [
              "243",
              "16109460022",
              "MAMTA CHOYAL",
              "SURJEET CHOYAL",
              "933",
              "1200",
              "77.75%"
            ]
          },
          {
            "sNo": "244",
            "rollNo": "16109460023",
            "name": "NANCY GARG",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "1029",
            "maxMarks": "1200",
            "percentage": "85.75%",
            "cells": [
              "244",
              "16109460023",
              "NANCY GARG",
              "NARESH KUMAR",
              "1029",
              "1200",
              "85.75%"
            ]
          },
          {
            "sNo": "245",
            "rollNo": "16109460026",
            "name": "BHAWNA SONI",
            "fatherName": "KRISHAN SONI",
            "obtainedMarks": "937",
            "maxMarks": "1200",
            "percentage": "78.08%",
            "cells": [
              "245",
              "16109460026",
              "BHAWNA SONI",
              "KRISHAN SONI",
              "937",
              "1200",
              "78.08%"
            ]
          },
          {
            "sNo": "246",
            "rollNo": "16109460027",
            "name": "HEENA BHATIA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "876",
            "maxMarks": "1200",
            "percentage": "73%",
            "cells": [
              "246",
              "16109460027",
              "HEENA BHATIA",
              "VIJAY KUMAR",
              "876",
              "1200",
              "73%"
            ]
          },
          {
            "sNo": "247",
            "rollNo": "16109460028",
            "name": "PALAKPREET",
            "fatherName": "JAGDISH RAI",
            "obtainedMarks": "865",
            "maxMarks": "1200",
            "percentage": "72.08%",
            "cells": [
              "247",
              "16109460028",
              "PALAKPREET",
              "JAGDISH RAI",
              "865",
              "1200",
              "72.08%"
            ]
          },
          {
            "sNo": "248",
            "rollNo": "16109460038",
            "name": "HIMANI RATHORE",
            "fatherName": "BHARAT SINGH RATHORE",
            "obtainedMarks": "919",
            "maxMarks": "1200",
            "percentage": "76.58%",
            "cells": [
              "248",
              "16109460038",
              "HIMANI RATHORE",
              "BHARAT SINGH RATHORE",
              "919",
              "1200",
              "76.58%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "249",
            "rollNo": "180090450004",
            "name": "MONIKA",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "816",
            "maxMarks": "1150",
            "percentage": "70.96%",
            "cells": [
              "249",
              "180090450004",
              "MONIKA",
              "RAM SINGH",
              "816",
              "1150",
              "70.96%"
            ]
          },
          {
            "sNo": "250",
            "rollNo": "180090450004",
            "name": "POONAM",
            "fatherName": "PALA RAM",
            "obtainedMarks": "808",
            "maxMarks": "1150",
            "percentage": "70.26%",
            "cells": [
              "250",
              "180090450004",
              "POONAM",
              "PALA RAM",
              "808",
              "1150",
              "70.26%"
            ]
          },
          {
            "sNo": "251",
            "rollNo": "180090450004",
            "name": "PRIYANKA",
            "fatherName": "PTEM SINGH",
            "obtainedMarks": "848",
            "maxMarks": "1150",
            "percentage": "73.74%",
            "cells": [
              "251",
              "180090450004",
              "PRIYANKA",
              "PTEM SINGH",
              "848",
              "1150",
              "73.74%"
            ]
          },
          {
            "sNo": "252",
            "rollNo": "180090450004",
            "name": "MANJU",
            "fatherName": "SOHAN LAL",
            "obtainedMarks": "840",
            "maxMarks": "1150",
            "percentage": "73.04%",
            "cells": [
              "252",
              "180090450004",
              "MANJU",
              "SOHAN LAL",
              "840",
              "1150",
              "73.04%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "253",
            "rollNo": "170090450001",
            "name": "VANSHIKA GOYAL",
            "fatherName": "SUDHIR GOYAL",
            "obtainedMarks": "1008",
            "maxMarks": "1250",
            "percentage": "80.64%",
            "cells": [
              "253",
              "170090450001",
              "VANSHIKA GOYAL",
              "SUDHIR GOYAL",
              "1008",
              "1250",
              "80.64%"
            ]
          },
          {
            "sNo": "254",
            "rollNo": "170090450006",
            "name": "DIKSHA",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "905",
            "maxMarks": "1250",
            "percentage": "72.40%",
            "cells": [
              "254",
              "170090450006",
              "DIKSHA",
              "PAWAN KUMAR",
              "905",
              "1250",
              "72.40%"
            ]
          },
          {
            "sNo": "255",
            "rollNo": "170090450010",
            "name": "SHEETAL GARG",
            "fatherName": "RAMNADEEP GARG",
            "obtainedMarks": "913",
            "maxMarks": "1250",
            "percentage": "73.04%",
            "cells": [
              "255",
              "170090450010",
              "SHEETAL GARG",
              "RAMNADEEP GARG",
              "913",
              "1250",
              "73.04%"
            ]
          },
          {
            "sNo": "256",
            "rollNo": "170090450011",
            "name": "SNEHA KARWASRA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "1040",
            "maxMarks": "1250",
            "percentage": "83.20%",
            "cells": [
              "256",
              "170090450011",
              "SNEHA KARWASRA",
              "NARESH KUMAR",
              "1040",
              "1250",
              "83.20%"
            ]
          },
          {
            "sNo": "257",
            "rollNo": "170090450014",
            "name": "DEEPIKA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "923",
            "maxMarks": "1250",
            "percentage": "73.84%",
            "cells": [
              "257",
              "170090450014",
              "DEEPIKA",
              "VINOD KUMAR",
              "923",
              "1250",
              "73.84%"
            ]
          },
          {
            "sNo": "258",
            "rollNo": "170090450015",
            "name": "SHEELA RANI",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "896",
            "maxMarks": "1250",
            "percentage": "71.68%",
            "cells": [
              "258",
              "170090450015",
              "SHEELA RANI",
              "OM PRAKASH",
              "896",
              "1250",
              "71.68%"
            ]
          },
          {
            "sNo": "259",
            "rollNo": "170090450018",
            "name": "AARZOO",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "994",
            "maxMarks": "1250",
            "percentage": "79.52%",
            "cells": [
              "259",
              "170090450018",
              "AARZOO",
              "NARESH KUMAR",
              "994",
              "1250",
              "79.52%"
            ]
          },
          {
            "sNo": "260",
            "rollNo": "170090450019",
            "name": "PRACHI",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "882",
            "maxMarks": "1250",
            "percentage": "70.56%",
            "cells": [
              "260",
              "170090450019",
              "PRACHI",
              "PAWAN KUMAR",
              "882",
              "1250",
              "70.56%"
            ]
          },
          {
            "sNo": "261",
            "rollNo": "170090450021",
            "name": "SHEETAL GARG",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "875",
            "maxMarks": "1250",
            "percentage": "70%",
            "cells": [
              "261",
              "170090450021",
              "SHEETAL GARG",
              "BALWAN SINGH",
              "875",
              "1250",
              "70%"
            ]
          },
          {
            "sNo": "262",
            "rollNo": "170090450023",
            "name": "KIRANJANGRA",
            "fatherName": "NIKU RAM",
            "obtainedMarks": "916",
            "maxMarks": "1250",
            "percentage": "73.28%",
            "cells": [
              "262",
              "170090450023",
              "KIRANJANGRA",
              "NIKU RAM",
              "916",
              "1250",
              "73.28%"
            ]
          },
          {
            "sNo": "263",
            "rollNo": "170090450023",
            "name": "PREETI RANI",
            "fatherName": "RAM PRAKASH",
            "obtainedMarks": "947",
            "maxMarks": "1250",
            "percentage": "75.76%",
            "cells": [
              "263",
              "170090450023",
              "PREETI RANI",
              "RAM PRAKASH",
              "947",
              "1250",
              "75.76%"
            ]
          },
          {
            "sNo": "264",
            "rollNo": "170090450026",
            "name": "LOCHAN",
            "fatherName": "MURLI DHAR",
            "obtainedMarks": "896",
            "maxMarks": "1250",
            "percentage": "71.68%",
            "cells": [
              "264",
              "170090450026",
              "LOCHAN",
              "MURLI DHAR",
              "896",
              "1250",
              "71.68%"
            ]
          },
          {
            "sNo": "265",
            "rollNo": "170090450030",
            "name": "JYOTSANA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "1022",
            "maxMarks": "1250",
            "percentage": "81.76%",
            "cells": [
              "265",
              "170090450030",
              "JYOTSANA",
              "PREM KUMAR",
              "1022",
              "1250",
              "81.76%"
            ]
          },
          {
            "sNo": "266",
            "rollNo": "170090450033",
            "name": "JITENDER KANG",
            "fatherName": "HARJAP SINGH KANG",
            "obtainedMarks": "879",
            "maxMarks": "1250",
            "percentage": "70.32%",
            "cells": [
              "266",
              "170090450033",
              "JITENDER KANG",
              "HARJAP SINGH KANG",
              "879",
              "1250",
              "70.32%"
            ]
          },
          {
            "sNo": "267",
            "rollNo": "170090450034",
            "name": "RADHIKA KATARIA",
            "fatherName": "RAKESH KATARIA",
            "obtainedMarks": "835",
            "maxMarks": "1250",
            "percentage": "66.80%",
            "cells": [
              "267",
              "170090450034",
              "RADHIKA KATARIA",
              "RAKESH KATARIA",
              "835",
              "1250",
              "66.80%"
            ]
          },
          {
            "sNo": "268",
            "rollNo": "170090450036",
            "name": "PARNEET KAUR",
            "fatherName": "SARABJEET SINGH",
            "obtainedMarks": "927",
            "maxMarks": "1250",
            "percentage": "74.16%",
            "cells": [
              "268",
              "170090450036",
              "PARNEET KAUR",
              "SARABJEET SINGH",
              "927",
              "1250",
              "74.16%"
            ]
          },
          {
            "sNo": "269",
            "rollNo": "170090450037",
            "name": "AMANPREET KAUR",
            "fatherName": "CHANDI RAM",
            "obtainedMarks": "949",
            "maxMarks": "1250",
            "percentage": "75.92%",
            "cells": [
              "269",
              "170090450037",
              "AMANPREET KAUR",
              "CHANDI RAM",
              "949",
              "1250",
              "75.92%"
            ]
          },
          {
            "sNo": "270",
            "rollNo": "170090450041",
            "name": "SAPNA",
            "fatherName": "JAGIT SINGH",
            "obtainedMarks": "786",
            "maxMarks": "1250",
            "percentage": "62.88%",
            "cells": [
              "270",
              "170090450041",
              "SAPNA",
              "JAGIT SINGH",
              "786",
              "1250",
              "62.88%"
            ]
          },
          {
            "sNo": "271",
            "rollNo": "170090450042",
            "name": "HARJOT KAUR",
            "fatherName": "PARAMPAL SINGH",
            "obtainedMarks": "873",
            "maxMarks": "1250",
            "percentage": "69.84%",
            "cells": [
              "271",
              "170090450042",
              "HARJOT KAUR",
              "PARAMPAL SINGH",
              "873",
              "1250",
              "69.84%"
            ]
          },
          {
            "sNo": "272",
            "rollNo": "170090450043",
            "name": "PAYAL RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "882",
            "maxMarks": "1250",
            "percentage": "70.56%",
            "cells": [
              "272",
              "170090450043",
              "PAYAL RANI",
              "MADAN LAL",
              "882",
              "1250",
              "70.56%"
            ]
          },
          {
            "sNo": "273",
            "rollNo": "170090450044",
            "name": "NEHA KAMBOJ",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "896",
            "maxMarks": "1250",
            "percentage": "71.68%",
            "cells": [
              "273",
              "170090450044",
              "NEHA KAMBOJ",
              "OM PRAKASH",
              "896",
              "1250",
              "71.68%"
            ]
          },
          {
            "sNo": "274",
            "rollNo": "170090450046",
            "name": "SANJU KUMARI",
            "fatherName": "VASU DEV YADAV",
            "obtainedMarks": "947",
            "maxMarks": "1250",
            "percentage": "75.76%",
            "cells": [
              "274",
              "170090450046",
              "SANJU KUMARI",
              "VASU DEV YADAV",
              "947",
              "1250",
              "75.76%"
            ]
          },
          {
            "sNo": "275",
            "rollNo": "170090450048",
            "name": "KHUSHBOO",
            "fatherName": "NARESH",
            "obtainedMarks": "1060",
            "maxMarks": "1250",
            "percentage": "84.80%",
            "cells": [
              "275",
              "170090450048",
              "KHUSHBOO",
              "NARESH",
              "1060",
              "1250",
              "84.80%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "276",
            "rollNo": "16109450005",
            "name": "AARTI",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "857",
            "maxMarks": "1200",
            "percentage": "71.42%",
            "cells": [
              "276",
              "16109450005",
              "AARTI",
              "MOHAN LAL",
              "857",
              "1200",
              "71.42%"
            ]
          },
          {
            "sNo": "277",
            "rollNo": "16109450006",
            "name": "BALJEET KAUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "887",
            "maxMarks": "1200",
            "percentage": "73.92%",
            "cells": [
              "277",
              "16109450006",
              "BALJEET KAUR",
              "GURMAIL SINGH",
              "887",
              "1200",
              "73.92%"
            ]
          },
          {
            "sNo": "278",
            "rollNo": "16109450008",
            "name": "MAMTA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "872",
            "maxMarks": "1200",
            "percentage": "72.67%",
            "cells": [
              "278",
              "16109450008",
              "MAMTA",
              "SURESH KUMAR",
              "872",
              "1200",
              "72.67%"
            ]
          },
          {
            "sNo": "279",
            "rollNo": "16109450009",
            "name": "NISHA",
            "fatherName": "RAM BHAGAT",
            "obtainedMarks": "912",
            "maxMarks": "1200",
            "percentage": "76%",
            "cells": [
              "279",
              "16109450009",
              "NISHA",
              "RAM BHAGAT",
              "912",
              "1200",
              "76%"
            ]
          },
          {
            "sNo": "280",
            "rollNo": "16109450014",
            "name": "PINKI",
            "fatherName": "BHARAT SINGH",
            "obtainedMarks": "853",
            "maxMarks": "1200",
            "percentage": "71.08%",
            "cells": [
              "280",
              "16109450014",
              "PINKI",
              "BHARAT SINGH",
              "853",
              "1200",
              "71.08%"
            ]
          },
          {
            "sNo": "281",
            "rollNo": "16109450019",
            "name": "REEMU RANI",
            "fatherName": "DINESH SHARMA",
            "obtainedMarks": "844",
            "maxMarks": "1200",
            "percentage": "70.33%",
            "cells": [
              "281",
              "16109450019",
              "REEMU RANI",
              "DINESH SHARMA",
              "844",
              "1200",
              "70.33%"
            ]
          },
          {
            "sNo": "282",
            "rollNo": "16109450022",
            "name": "REKHA RANI",
            "fatherName": "SURJEET SINGH",
            "obtainedMarks": "877",
            "maxMarks": "1200",
            "percentage": "73.08%",
            "cells": [
              "282",
              "16109450022",
              "REKHA RANI",
              "SURJEET SINGH",
              "877",
              "1200",
              "73.08%"
            ]
          },
          {
            "sNo": "283",
            "rollNo": "16109450024",
            "name": "RACHANA DEVI",
            "fatherName": "UGARSAIN",
            "obtainedMarks": "864",
            "maxMarks": "1200",
            "percentage": "72%",
            "cells": [
              "283",
              "16109450024",
              "RACHANA DEVI",
              "UGARSAIN",
              "864",
              "1200",
              "72%"
            ]
          },
          {
            "sNo": "284",
            "rollNo": "16109450030",
            "name": "ISHU",
            "fatherName": "RAJENDER",
            "obtainedMarks": "902",
            "maxMarks": "1200",
            "percentage": "75.17%",
            "cells": [
              "284",
              "16109450030",
              "ISHU",
              "RAJENDER",
              "902",
              "1200",
              "75.17%"
            ]
          },
          {
            "sNo": "285",
            "rollNo": "16109450031",
            "name": "HARMANPREET KAUR",
            "fatherName": "GURCHET SINGH",
            "obtainedMarks": "871",
            "maxMarks": "1200",
            "percentage": "72.58%",
            "cells": [
              "285",
              "16109450031",
              "HARMANPREET KAUR",
              "GURCHET SINGH",
              "871",
              "1200",
              "72.58%"
            ]
          },
          {
            "sNo": "286",
            "rollNo": "16109450033",
            "name": "SONAM",
            "fatherName": "ASHOK GROVER",
            "obtainedMarks": "844",
            "maxMarks": "1200",
            "percentage": "70.33%",
            "cells": [
              "286",
              "16109450033",
              "SONAM",
              "ASHOK GROVER",
              "844",
              "1200",
              "70.33%"
            ]
          },
          {
            "sNo": "287",
            "rollNo": "16109450039",
            "name": "ANJALI",
            "fatherName": "RAMPAL",
            "obtainedMarks": "881",
            "maxMarks": "1200",
            "percentage": "73.42%",
            "cells": [
              "287",
              "16109450039",
              "ANJALI",
              "RAMPAL",
              "881",
              "1200",
              "73.42%"
            ]
          },
          {
            "sNo": "288",
            "rollNo": "16109450041",
            "name": "HARKAMALPREET KAUR",
            "fatherName": "GOGI SINGH",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.92%",
            "cells": [
              "288",
              "16109450041",
              "HARKAMALPREET KAUR",
              "GOGI SINGH",
              "863",
              "1200",
              "71.92%"
            ]
          },
          {
            "sNo": "289",
            "rollNo": "16109450043",
            "name": "ANKITA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "856",
            "maxMarks": "1200",
            "percentage": "71.33%",
            "cells": [
              "289",
              "16109450043",
              "ANKITA",
              "RAJ KUMAR",
              "856",
              "1200",
              "71.33%"
            ]
          },
          {
            "sNo": "290",
            "rollNo": "16109450044",
            "name": "UJJWAL RANI",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "883",
            "maxMarks": "1200",
            "percentage": "73.58%",
            "cells": [
              "290",
              "16109450044",
              "UJJWAL RANI",
              "JAGDISH KUMAR",
              "883",
              "1200",
              "73.58%"
            ]
          },
          {
            "sNo": "291",
            "rollNo": "16109450047",
            "name": "MONIKA ARORA",
            "fatherName": "SHAM LAL ARORA",
            "obtainedMarks": "920",
            "maxMarks": "1200",
            "percentage": "76.67%",
            "cells": [
              "291",
              "16109450047",
              "MONIKA ARORA",
              "SHAM LAL ARORA",
              "920",
              "1200",
              "76.67%"
            ]
          },
          {
            "sNo": "292",
            "rollNo": "16109450048",
            "name": "GURJOT",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "935",
            "maxMarks": "1200",
            "percentage": "77.92%",
            "cells": [
              "292",
              "16109450048",
              "GURJOT",
              "SUKHDEV SINGH",
              "935",
              "1200",
              "77.92%"
            ]
          },
          {
            "sNo": "293",
            "rollNo": "16109450051",
            "name": "GURVINDER KAUR",
            "fatherName": "HARBHAJAN",
            "obtainedMarks": "954",
            "maxMarks": "1200",
            "percentage": "79.50%",
            "cells": [
              "293",
              "16109450051",
              "GURVINDER KAUR",
              "HARBHAJAN",
              "954",
              "1200",
              "79.50%"
            ]
          },
          {
            "sNo": "294",
            "rollNo": "16109450054",
            "name": "ANURADHA",
            "fatherName": "PURAN SINGH",
            "obtainedMarks": "931",
            "maxMarks": "1200",
            "percentage": "77.58%",
            "cells": [
              "294",
              "16109450054",
              "ANURADHA",
              "PURAN SINGH",
              "931",
              "1200",
              "77.58%"
            ]
          },
          {
            "sNo": "295",
            "rollNo": "16109450057",
            "name": "ANJU",
            "fatherName": "AZAD SINGH",
            "obtainedMarks": "848",
            "maxMarks": "1200",
            "percentage": "70.67%",
            "cells": [
              "295",
              "16109450057",
              "ANJU",
              "AZAD SINGH",
              "848",
              "1200",
              "70.67%"
            ]
          },
          {
            "sNo": "296",
            "rollNo": "16109450058",
            "name": "KASHISH AGGARWAL",
            "fatherName": "KRISHAN GOPAL",
            "obtainedMarks": "858",
            "maxMarks": "1200",
            "percentage": "71.50%",
            "cells": [
              "296",
              "16109450058",
              "KASHISH AGGARWAL",
              "KRISHAN GOPAL",
              "858",
              "1200",
              "71.50%"
            ]
          },
          {
            "sNo": "297",
            "rollNo": "16109450060",
            "name": "GAZAL SONI",
            "fatherName": "LAJPAT RAI SONI",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.92%",
            "cells": [
              "297",
              "16109450060",
              "GAZAL SONI",
              "LAJPAT RAI SONI",
              "863",
              "1200",
              "71.92%"
            ]
          },
          {
            "sNo": "298",
            "rollNo": "16109450063",
            "name": "EKTA",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "74.67%",
            "cells": [
              "298",
              "16109450063",
              "EKTA",
              "JAGDISH KUMAR",
              "896",
              "1200",
              "74.67%"
            ]
          }
        ]
      },
      {
        "courseName": "DPED III+IV SEM",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "299",
            "rollNo": "170090640005",
            "name": "Neetu Bala",
            "fatherName": "Devi Lal Badhu",
            "obtainedMarks": "1057",
            "maxMarks": "1500",
            "percentage": "70.46%",
            "cells": [
              "299",
              "170090640005",
              "Neetu Bala",
              "Devi Lal Badhu",
              "1057",
              "1500",
              "70.46%"
            ]
          }
        ]
      },
      {
        "courseName": "M.sc II +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "180090140002",
            "name": "POOJA MONGA",
            "fatherName": "PREM MONGA",
            "obtainedMarks": "1038",
            "maxMarks": "1400",
            "percentage": "74.14%",
            "cells": [
              "1",
              "180090140002",
              "POOJA MONGA",
              "PREM MONGA",
              "1038",
              "1400",
              "74.14%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "180090140004",
            "name": "PRIYA MONGA",
            "fatherName": "PREM PARKASH",
            "obtainedMarks": "1061",
            "maxMarks": "1400",
            "percentage": "75.79%",
            "cells": [
              "2",
              "180090140004",
              "PRIYA MONGA",
              "PREM PARKASH",
              "1061",
              "1400",
              "75.79%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "180090140005",
            "name": "RAJNI",
            "fatherName": "RAM PARTAP",
            "obtainedMarks": "950",
            "maxMarks": "1400",
            "percentage": "67.86%",
            "cells": [
              "3",
              "180090140005",
              "RAJNI",
              "RAM PARTAP",
              "950",
              "1400",
              "67.86%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "180090140007",
            "name": "TANNU MONGA",
            "fatherName": "RAJ KUMAR MONGA",
            "obtainedMarks": "1054",
            "maxMarks": "1400",
            "percentage": "75.29%",
            "cells": [
              "4",
              "180090140007",
              "TANNU MONGA",
              "RAJ KUMAR MONGA",
              "1054",
              "1400",
              "75.29%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "180090140009",
            "name": "JYOTI",
            "fatherName": "NIHAL SINGH",
            "obtainedMarks": "906",
            "maxMarks": "1400",
            "percentage": "64.71%",
            "cells": [
              "5",
              "180090140009",
              "JYOTI",
              "NIHAL SINGH",
              "906",
              "1400",
              "64.71%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "180090140011",
            "name": "HARPREET KAUR",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "927",
            "maxMarks": "1400",
            "percentage": "66.21%",
            "cells": [
              "6",
              "180090140011",
              "HARPREET KAUR",
              "SURENDER SINGH",
              "927",
              "1400",
              "66.21%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "180090140012",
            "name": "RENU BALA",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1054",
            "maxMarks": "1400",
            "percentage": "75.29%",
            "cells": [
              "7",
              "180090140012",
              "RENU BALA",
              "OM PRAKASH",
              "1054",
              "1400",
              "75.29%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "180090140015",
            "name": "SANDHYA",
            "fatherName": "JAGAT PAL",
            "obtainedMarks": "955",
            "maxMarks": "1400",
            "percentage": "68.21%",
            "cells": [
              "8",
              "180090140015",
              "SANDHYA",
              "JAGAT PAL",
              "955",
              "1400",
              "68.21%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "180090140016",
            "name": "SUSHMA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "897",
            "maxMarks": "1400",
            "percentage": "64.07%",
            "cells": [
              "9",
              "180090140016",
              "SUSHMA",
              "RAJENDER",
              "897",
              "1400",
              "64.07%"
            ]
          }
        ]
      },
      {
        "courseName": "M.sc III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "10",
            "rollNo": "170090140001",
            "name": "NAVDEEP KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "867",
            "maxMarks": "1200",
            "percentage": "72.25%",
            "cells": [
              "10",
              "170090140001",
              "NAVDEEP KAUR",
              "JASPAL SINGH",
              "867",
              "1200",
              "72.25%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "170090140003",
            "name": "MANJU LATA",
            "fatherName": "TULSI DAS",
            "obtainedMarks": "870",
            "maxMarks": "1200",
            "percentage": "72.50%",
            "cells": [
              "11",
              "170090140003",
              "MANJU LATA",
              "TULSI DAS",
              "870",
              "1200",
              "72.50%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "170090140004",
            "name": "NEERU SONI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "817",
            "maxMarks": "1200",
            "percentage": "68.08%",
            "cells": [
              "12",
              "170090140004",
              "NEERU SONI",
              "KEWAL KRISHAN",
              "817",
              "1200",
              "68.08%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "170090140005",
            "name": "NANCY CHAWLA",
            "fatherName": "MR PREM PRAKASH",
            "obtainedMarks": "849",
            "maxMarks": "1200",
            "percentage": "70.75%",
            "cells": [
              "13",
              "170090140005",
              "NANCY CHAWLA",
              "MR PREM PRAKASH",
              "849",
              "1200",
              "70.75%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "170090140006",
            "name": "NISHU BALA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "804",
            "maxMarks": "1200",
            "percentage": "67%",
            "cells": [
              "14",
              "170090140006",
              "NISHU BALA",
              "RAKESH KUMAR",
              "804",
              "1200",
              "67%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "170090140007",
            "name": "DIKSHA RANI",
            "fatherName": "DEEPAK KUMAR",
            "obtainedMarks": "798",
            "maxMarks": "1200",
            "percentage": "66.50%",
            "cells": [
              "15",
              "170090140007",
              "DIKSHA RANI",
              "DEEPAK KUMAR",
              "798",
              "1200",
              "66.50%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "170090140009",
            "name": "SHELLY",
            "fatherName": "SANJEEV MUNJAL",
            "obtainedMarks": "853",
            "maxMarks": "1200",
            "percentage": "71.08%",
            "cells": [
              "16",
              "170090140009",
              "SHELLY",
              "SANJEEV MUNJAL",
              "853",
              "1200",
              "71.08%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "170090140010",
            "name": "NEHA DEVI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "914",
            "maxMarks": "1200",
            "percentage": "76.17%",
            "cells": [
              "17",
              "170090140010",
              "NEHA DEVI",
              "RAMESH KUMAR",
              "914",
              "1200",
              "76.17%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "170090140011",
            "name": "SANJOLI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "872",
            "maxMarks": "1200",
            "percentage": "72.67%",
            "cells": [
              "18",
              "170090140011",
              "SANJOLI",
              "SUNIL KUMAR",
              "872",
              "1200",
              "72.67%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "170090140012",
            "name": "PRIYANKA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "866",
            "maxMarks": "1200",
            "percentage": "72.17%",
            "cells": [
              "19",
              "170090140012",
              "PRIYANKA",
              "VINOD KUMAR",
              "866",
              "1200",
              "72.17%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "170090140014",
            "name": "SONIA TANEJA",
            "fatherName": "SANT LAL TANEJA",
            "obtainedMarks": "895",
            "maxMarks": "1200",
            "percentage": "74.58%",
            "cells": [
              "20",
              "170090140014",
              "SONIA TANEJA",
              "SANT LAL TANEJA",
              "895",
              "1200",
              "74.58%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "170090140015",
            "name": "KANIKA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "850",
            "maxMarks": "1200",
            "percentage": "70.83%",
            "cells": [
              "21",
              "170090140015",
              "KANIKA",
              "PREM KUMAR",
              "850",
              "1200",
              "70.83%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "170090140018",
            "name": "VEENU",
            "fatherName": "RAMESH PHUTELA",
            "obtainedMarks": "854",
            "maxMarks": "1200",
            "percentage": "71.17%",
            "cells": [
              "22",
              "170090140018",
              "VEENU",
              "RAMESH PHUTELA",
              "854",
              "1200",
              "71.17%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "170090140019",
            "name": "NEHA",
            "fatherName": "BHIM SAIN",
            "obtainedMarks": "880",
            "maxMarks": "1200",
            "percentage": "73.33%",
            "cells": [
              "23",
              "170090140019",
              "NEHA",
              "BHIM SAIN",
              "880",
              "1200",
              "73.33%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "170090140020",
            "name": "RAJWANT KAUR",
            "fatherName": "LABH SINGH",
            "obtainedMarks": "884",
            "maxMarks": "1200",
            "percentage": "73.67%",
            "cells": [
              "24",
              "170090140020",
              "RAJWANT KAUR",
              "LABH SINGH",
              "884",
              "1200",
              "73.67%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "170090140021",
            "name": "GURWINDER KAUR",
            "fatherName": "JASKARAN SINGH",
            "obtainedMarks": "974",
            "maxMarks": "1200",
            "percentage": "81.17%",
            "cells": [
              "25",
              "170090140021",
              "GURWINDER KAUR",
              "JASKARAN SINGH",
              "974",
              "1200",
              "81.17%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "170090140022",
            "name": "SHWETA",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "819",
            "maxMarks": "1200",
            "percentage": "68.25%",
            "cells": [
              "26",
              "170090140022",
              "SHWETA",
              "SATISH KUMAR",
              "819",
              "1200",
              "68.25%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "170090140023",
            "name": "TAMANNA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "860",
            "maxMarks": "1200",
            "percentage": "71.67%",
            "cells": [
              "27",
              "170090140023",
              "TAMANNA",
              "RAJENDER KUMAR",
              "860",
              "1200",
              "71.67%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "170090140024",
            "name": "SAWITRI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "822",
            "maxMarks": "1200",
            "percentage": "68.50%",
            "cells": [
              "28",
              "170090140024",
              "SAWITRI",
              "BANWARI LAL",
              "822",
              "1200",
              "68.50%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "170090140027",
            "name": "SHIVANI",
            "fatherName": "MANOHAR LAL",
            "obtainedMarks": "937",
            "maxMarks": "1200",
            "percentage": "78.08%",
            "cells": [
              "29",
              "170090140027",
              "SHIVANI",
              "MANOHAR LAL",
              "937",
              "1200",
              "78.08%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm. II +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "30",
            "rollNo": "180090260002",
            "name": "KAVITA",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "946",
            "maxMarks": "1400",
            "percentage": "67.57%",
            "cells": [
              "30",
              "180090260002",
              "KAVITA",
              "AMAR SINGH",
              "946",
              "1400",
              "67.57%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "180090260004",
            "name": "GEETA RANI",
            "fatherName": "HARI CHAND",
            "obtainedMarks": "1014",
            "maxMarks": "1400",
            "percentage": "72.43%",
            "cells": [
              "31",
              "180090260004",
              "GEETA RANI",
              "HARI CHAND",
              "1014",
              "1400",
              "72.43%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "180090260012",
            "name": "MEERA DEVI",
            "fatherName": "CHHOTU RAM",
            "obtainedMarks": "946",
            "maxMarks": "1400",
            "percentage": "67.57%",
            "cells": [
              "32",
              "180090260012",
              "MEERA DEVI",
              "CHHOTU RAM",
              "946",
              "1400",
              "67.57%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "180090260015",
            "name": "GUNITA",
            "fatherName": "JAI KISHAN",
            "obtainedMarks": "1001",
            "maxMarks": "1400",
            "percentage": "71.50%",
            "cells": [
              "33",
              "180090260015",
              "GUNITA",
              "JAI KISHAN",
              "1001",
              "1400",
              "71.50%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm. III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "34",
            "rollNo": "170090260001",
            "name": "SHEELA DEVI",
            "fatherName": "SHAMSHER KUNDU",
            "obtainedMarks": "837",
            "maxMarks": "1200",
            "percentage": "69.75%",
            "cells": [
              "34",
              "170090260001",
              "SHEELA DEVI",
              "SHAMSHER KUNDU",
              "837",
              "1200",
              "69.75%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "170090260002",
            "name": "MEENA RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "946",
            "maxMarks": "1200",
            "percentage": "78.83%",
            "cells": [
              "35",
              "170090260002",
              "MEENA RANI",
              "MADAN LAL",
              "946",
              "1200",
              "78.83%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "170090260004",
            "name": "SUNITA",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "889",
            "maxMarks": "1200",
            "percentage": "74.08%",
            "cells": [
              "36",
              "170090260004",
              "SUNITA",
              "RAM SINGH",
              "889",
              "1200",
              "74.08%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "170090260009",
            "name": "ANURADHA",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "915",
            "maxMarks": "1200",
            "percentage": "76.25%",
            "cells": [
              "37",
              "170090260009",
              "ANURADHA",
              "SAHAB RAM",
              "915",
              "1200",
              "76.25%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "170090260011",
            "name": "REEMA",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "937",
            "maxMarks": "1200",
            "percentage": "78.08%",
            "cells": [
              "38",
              "170090260011",
              "REEMA",
              "ASHOK KUMAR",
              "937",
              "1200",
              "78.08%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A English I +II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A English III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "39",
            "rollNo": "170090250002",
            "name": "SILOCHANA",
            "fatherName": "JAGDISH CHANDER",
            "obtainedMarks": "769",
            "maxMarks": "1200",
            "percentage": "64.08%",
            "cells": [
              "39",
              "170090250002",
              "SILOCHANA",
              "JAGDISH CHANDER",
              "769",
              "1200",
              "64.08%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "170090250003",
            "name": "SUPRIYA",
            "fatherName": "RAVINDER DHILLON",
            "obtainedMarks": "732",
            "maxMarks": "1200",
            "percentage": "61%",
            "cells": [
              "40",
              "170090250003",
              "SUPRIYA",
              "RAVINDER DHILLON",
              "732",
              "1200",
              "61%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "170090250005",
            "name": "ARSH DEEP KAUR",
            "fatherName": "RACHH PAL SINGH",
            "obtainedMarks": "790",
            "maxMarks": "1200",
            "percentage": "65.83%",
            "cells": [
              "41",
              "170090250005",
              "ARSH DEEP KAUR",
              "RACHH PAL SINGH",
              "790",
              "1200",
              "65.83%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "170090250009",
            "name": "KRISHNA DEVI",
            "fatherName": "JAGDISH",
            "obtainedMarks": "767",
            "maxMarks": "1200",
            "percentage": "63.92%",
            "cells": [
              "42",
              "170090250009",
              "KRISHNA DEVI",
              "JAGDISH",
              "767",
              "1200",
              "63.92%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "170090250010",
            "name": "PRIYA RANI",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "727",
            "maxMarks": "1200",
            "percentage": "60.58%",
            "cells": [
              "43",
              "170090250010",
              "PRIYA RANI",
              "ASHOK KUMAR",
              "727",
              "1200",
              "60.58%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "170090250011",
            "name": "BHARTI",
            "fatherName": "GAURI SHANKAR",
            "obtainedMarks": "746",
            "maxMarks": "1200",
            "percentage": "62.17%",
            "cells": [
              "44",
              "170090250011",
              "BHARTI",
              "GAURI SHANKAR",
              "746",
              "1200",
              "62.17%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "45",
            "rollNo": "180090240003",
            "name": "RUPA",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "977",
            "maxMarks": "1400",
            "percentage": "69.79%",
            "cells": [
              "45",
              "180090240003",
              "RUPA",
              "SOHAN PAL",
              "977",
              "1400",
              "69.79%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "180090240004",
            "name": "SUKHPREET KAUR",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "948",
            "maxMarks": "1400",
            "percentage": "67.71%",
            "cells": [
              "46",
              "180090240004",
              "SUKHPREET KAUR",
              "RANJEET SINGH",
              "948",
              "1400",
              "67.71%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "180090240005",
            "name": "RAMANDEEP RANI",
            "fatherName": "SURJEET RAM",
            "obtainedMarks": "1003",
            "maxMarks": "1400",
            "percentage": "71.64%",
            "cells": [
              "47",
              "180090240005",
              "RAMANDEEP RANI",
              "SURJEET RAM",
              "1003",
              "1400",
              "71.64%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "180090240006",
            "name": "POOJA RANI",
            "fatherName": "VED PRAKASH",
            "obtainedMarks": "1042",
            "maxMarks": "1400",
            "percentage": "74.43%",
            "cells": [
              "48",
              "180090240006",
              "POOJA RANI",
              "VED PRAKASH",
              "1042",
              "1400",
              "74.43%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "180090240007",
            "name": "SANDHYA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "991",
            "maxMarks": "1400",
            "percentage": "70.79%",
            "cells": [
              "49",
              "180090240007",
              "SANDHYA",
              "RAJ KUMAR",
              "991",
              "1400",
              "70.79%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "180090240008",
            "name": "SHALU",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "964",
            "maxMarks": "1400",
            "percentage": "68.86%",
            "cells": [
              "50",
              "180090240008",
              "SHALU",
              "RAJ KUMAR",
              "964",
              "1400",
              "68.86%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "180090240009",
            "name": "AANCHAL RANI",
            "fatherName": "RAMESH LAL",
            "obtainedMarks": "1024",
            "maxMarks": "1400",
            "percentage": "73.14%",
            "cells": [
              "51",
              "180090240009",
              "AANCHAL RANI",
              "RAMESH LAL",
              "1024",
              "1400",
              "73.14%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "180090240010",
            "name": "SUMAN RANI",
            "fatherName": "PREM CHNAD",
            "obtainedMarks": "916",
            "maxMarks": "1400",
            "percentage": "65.43%",
            "cells": [
              "52",
              "180090240010",
              "SUMAN RANI",
              "PREM CHNAD",
              "916",
              "1400",
              "65.43%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "180090240012",
            "name": "MANJU",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "942",
            "maxMarks": "1400",
            "percentage": "67.29%",
            "cells": [
              "53",
              "180090240012",
              "MANJU",
              "HANSRAJ",
              "942",
              "1400",
              "67.29%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "180090240013",
            "name": "RITIKA SONI",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "977",
            "maxMarks": "1400",
            "percentage": "69.79%",
            "cells": [
              "54",
              "180090240013",
              "RITIKA SONI",
              "SANJAY KUMAR",
              "977",
              "1400",
              "69.79%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "180090240014",
            "name": "RAJNI BALA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "970",
            "maxMarks": "1400",
            "percentage": "69.29%",
            "cells": [
              "55",
              "180090240014",
              "RAJNI BALA",
              "MADAN LAL",
              "970",
              "1400",
              "69.29%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "180090240018",
            "name": "MEENA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1034",
            "maxMarks": "1400",
            "percentage": "73.86%",
            "cells": [
              "56",
              "180090240018",
              "MEENA",
              "SURESH KUMAR",
              "1034",
              "1400",
              "73.86%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "180090240021",
            "name": "JYOTI",
            "fatherName": "SHAM LAL",
            "obtainedMarks": "1030",
            "maxMarks": "1400",
            "percentage": "73.57%",
            "cells": [
              "57",
              "180090240021",
              "JYOTI",
              "SHAM LAL",
              "1030",
              "1400",
              "73.57%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "180090240022",
            "name": "SONAL",
            "fatherName": "KEDAR NATH ARORA",
            "obtainedMarks": "1014",
            "maxMarks": "1400",
            "percentage": "72.43%",
            "cells": [
              "58",
              "180090240022",
              "SONAL",
              "KEDAR NATH ARORA",
              "1014",
              "1400",
              "72.43%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "180090240023",
            "name": "SAPNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "978",
            "maxMarks": "1400",
            "percentage": "69.86%",
            "cells": [
              "59",
              "180090240023",
              "SAPNA",
              "KRISHAN KUMAR",
              "978",
              "1400",
              "69.86%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "180090240024",
            "name": "RITU",
            "fatherName": "RAMPHAL YADAV",
            "obtainedMarks": "970",
            "maxMarks": "1400",
            "percentage": "69.29%",
            "cells": [
              "60",
              "180090240024",
              "RITU",
              "RAMPHAL YADAV",
              "970",
              "1400",
              "69.29%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "180090240026",
            "name": "MONIKA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "1030",
            "maxMarks": "1400",
            "percentage": "73.57%",
            "cells": [
              "61",
              "180090240026",
              "MONIKA",
              "RAJ KUMAR",
              "1030",
              "1400",
              "73.57%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "180090240027",
            "name": "SANDEEP RANI",
            "fatherName": "PIRTHVI SINGH",
            "obtainedMarks": "907",
            "maxMarks": "1400",
            "percentage": "64.79%",
            "cells": [
              "62",
              "180090240027",
              "SANDEEP RANI",
              "PIRTHVI SINGH",
              "907",
              "1400",
              "64.79%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "180090240028",
            "name": "RAJNI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "1039",
            "maxMarks": "1400",
            "percentage": "74.21%",
            "cells": [
              "63",
              "180090240028",
              "RAJNI",
              "KEWAL KRISHAN",
              "1039",
              "1400",
              "74.21%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "64",
            "rollNo": "170090240003",
            "name": "GURPREET",
            "fatherName": "SATPAL",
            "obtainedMarks": "955",
            "maxMarks": "1350",
            "percentage": "70.74%",
            "cells": [
              "64",
              "170090240003",
              "GURPREET",
              "SATPAL",
              "955",
              "1350",
              "70.74%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "170090240004",
            "name": "NISHA",
            "fatherName": "BEER SINGH",
            "obtainedMarks": "1028",
            "maxMarks": "1350",
            "percentage": "76.15%",
            "cells": [
              "65",
              "170090240004",
              "NISHA",
              "BEER SINGH",
              "1028",
              "1350",
              "76.15%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "170090240005",
            "name": "MADHU BALA",
            "fatherName": "SURJEET SINGH",
            "obtainedMarks": "1061",
            "maxMarks": "1350",
            "percentage": "78.59%",
            "cells": [
              "66",
              "170090240005",
              "MADHU BALA",
              "SURJEET SINGH",
              "1061",
              "1350",
              "78.59%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "170090240010",
            "name": "SONAL DHAKA",
            "fatherName": "RAJENDRA PRASAD",
            "obtainedMarks": "842",
            "maxMarks": "1350",
            "percentage": "62.37%",
            "cells": [
              "67",
              "170090240010",
              "SONAL DHAKA",
              "RAJENDRA PRASAD",
              "842",
              "1350",
              "62.37%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "170090240011",
            "name": "SUSHMA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "945",
            "maxMarks": "1350",
            "percentage": "70%",
            "cells": [
              "68",
              "170090240011",
              "SUSHMA",
              "KRISHAN KUMAR",
              "945",
              "1350",
              "70%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "170090240013",
            "name": "TANYA KATHPAL",
            "fatherName": "PAWAN KATHPAL",
            "obtainedMarks": "1033",
            "maxMarks": "1350",
            "percentage": "76.52%",
            "cells": [
              "69",
              "170090240013",
              "TANYA KATHPAL",
              "PAWAN KATHPAL",
              "1033",
              "1350",
              "76.52%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "170090240014",
            "name": "RAKHI",
            "fatherName": "SUKHNAM LUTHRA",
            "obtainedMarks": "937",
            "maxMarks": "1350",
            "percentage": "69.41%",
            "cells": [
              "70",
              "170090240014",
              "RAKHI",
              "SUKHNAM LUTHRA",
              "937",
              "1350",
              "69.41%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "170090240015",
            "name": "EKTA",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "942",
            "maxMarks": "1350",
            "percentage": "69.78%",
            "cells": [
              "71",
              "170090240015",
              "EKTA",
              "ASHOK KUMAR",
              "942",
              "1350",
              "69.78%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "170090240016",
            "name": "MANPREET KAUR",
            "fatherName": "PURAN CHAND",
            "obtainedMarks": "923",
            "maxMarks": "1350",
            "percentage": "68.37%",
            "cells": [
              "72",
              "170090240016",
              "MANPREET KAUR",
              "PURAN CHAND",
              "923",
              "1350",
              "68.37%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "170090240017",
            "name": "DIKSHA",
            "fatherName": "JAGDISH KAKKAR",
            "obtainedMarks": "972",
            "maxMarks": "1350",
            "percentage": "72%",
            "cells": [
              "73",
              "170090240017",
              "DIKSHA",
              "JAGDISH KAKKAR",
              "972",
              "1350",
              "72%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "170090240018",
            "name": "SHIVANI",
            "fatherName": "LAKSHMANDASS",
            "obtainedMarks": "1049",
            "maxMarks": "1350",
            "percentage": "77.70%",
            "cells": [
              "74",
              "170090240018",
              "SHIVANI",
              "LAKSHMANDASS",
              "1049",
              "1350",
              "77.70%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "170090240020",
            "name": "PAWANDEEP",
            "fatherName": "NIRMAL SINGH",
            "obtainedMarks": "814",
            "maxMarks": "1350",
            "percentage": "60.30%",
            "cells": [
              "75",
              "170090240020",
              "PAWANDEEP",
              "NIRMAL SINGH",
              "814",
              "1350",
              "60.30%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "170090240021",
            "name": "POONAM",
            "fatherName": "JAIVEER",
            "obtainedMarks": "1002",
            "maxMarks": "1350",
            "percentage": "74.22%",
            "cells": [
              "76",
              "170090240021",
              "POONAM",
              "JAIVEER",
              "1002",
              "1350",
              "74.22%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "170090240022",
            "name": "PRIYANKA",
            "fatherName": "SATYA NARAYAN",
            "obtainedMarks": "1002",
            "maxMarks": "1350",
            "percentage": "74.22%",
            "cells": [
              "77",
              "170090240022",
              "PRIYANKA",
              "SATYA NARAYAN",
              "1002",
              "1350",
              "74.22%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "170090240023",
            "name": "SARITA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "1041",
            "maxMarks": "1350",
            "percentage": "77.11%",
            "cells": [
              "78",
              "170090240023",
              "SARITA",
              "KULDEEP",
              "1041",
              "1350",
              "77.11%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "170090240024",
            "name": "HARDEEP KAUR",
            "fatherName": "GURMEET SINGH",
            "obtainedMarks": "971",
            "maxMarks": "1350",
            "percentage": "71.93%",
            "cells": [
              "79",
              "170090240024",
              "HARDEEP KAUR",
              "GURMEET SINGH",
              "971",
              "1350",
              "71.93%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "170090240025",
            "name": "KOMAL",
            "fatherName": "SATISH KUMAR MEHTA",
            "obtainedMarks": "900",
            "maxMarks": "1350",
            "percentage": "66.67%",
            "cells": [
              "80",
              "170090240025",
              "KOMAL",
              "SATISH KUMAR MEHTA",
              "900",
              "1350",
              "66.67%"
            ]
          }
        ]
      },
      {
        "courseName": "BPED I +II SEM",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "81",
            "rollNo": "18009051001",
            "name": "Manjeet kaur",
            "fatherName": "Gurnam Singh",
            "obtainedMarks": "1209",
            "maxMarks": "1600",
            "percentage": "75.56%",
            "cells": [
              "81",
              "18009051001",
              "Manjeet kaur",
              "Gurnam Singh",
              "1209",
              "1600",
              "75.56%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "18009051002",
            "name": "Pallavi",
            "fatherName": "Ram Pratap Insan",
            "obtainedMarks": "1248",
            "maxMarks": "1600",
            "percentage": "78%",
            "cells": [
              "82",
              "18009051002",
              "Pallavi",
              "Ram Pratap Insan",
              "1248",
              "1600",
              "78%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "18009051003",
            "name": "Kiran",
            "fatherName": "Rai Singh",
            "obtainedMarks": "1189",
            "maxMarks": "1600",
            "percentage": "74.31%",
            "cells": [
              "83",
              "18009051003",
              "Kiran",
              "Rai Singh",
              "1189",
              "1600",
              "74.31%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "18009051006",
            "name": "Manoj",
            "fatherName": "Satpal",
            "obtainedMarks": "1161",
            "maxMarks": "1600",
            "percentage": "72.56%",
            "cells": [
              "84",
              "18009051006",
              "Manoj",
              "Satpal",
              "1161",
              "1600",
              "72.56%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "18009051009",
            "name": "Preeti",
            "fatherName": "Dhrampal Singh",
            "obtainedMarks": "1366",
            "maxMarks": "1600",
            "percentage": "85.38%",
            "cells": [
              "85",
              "18009051009",
              "Preeti",
              "Dhrampal Singh",
              "1366",
              "1600",
              "85.38%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "180090510010",
            "name": "Manju",
            "fatherName": "Ram Niwas",
            "obtainedMarks": "1272",
            "maxMarks": "1600",
            "percentage": "79.50%",
            "cells": [
              "86",
              "180090510010",
              "Manju",
              "Ram Niwas",
              "1272",
              "1600",
              "79.50%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "180090510011",
            "name": "Sushma Devi",
            "fatherName": "Ram Singh",
            "obtainedMarks": "1298",
            "maxMarks": "1600",
            "percentage": "81.33%",
            "cells": [
              "87",
              "180090510011",
              "Sushma Devi",
              "Ram Singh",
              "1298",
              "1600",
              "81.33%"
            ]
          }
        ]
      },
      {
        "courseName": "BPED III+IV SEM",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "88",
            "rollNo": "170090510001",
            "name": "Parmeet Rani",
            "fatherName": "Madan Lal",
            "obtainedMarks": "1305",
            "maxMarks": "1600",
            "percentage": "81.56%",
            "cells": [
              "88",
              "170090510001",
              "Parmeet Rani",
              "Madan Lal",
              "1305",
              "1600",
              "81.56%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "170090510002",
            "name": "Jashandeep",
            "fatherName": "Chandar Parakash",
            "obtainedMarks": "1352",
            "maxMarks": "1600",
            "percentage": "84.50%",
            "cells": [
              "89",
              "170090510002",
              "Jashandeep",
              "Chandar Parakash",
              "1352",
              "1600",
              "84.50%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "170090510003",
            "name": "Kiran",
            "fatherName": "Nathuram",
            "obtainedMarks": "1165",
            "maxMarks": "1600",
            "percentage": "72.81%",
            "cells": [
              "90",
              "170090510003",
              "Kiran",
              "Nathuram",
              "1165",
              "1600",
              "72.81%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "170090510005",
            "name": "Gagandeep Kaur",
            "fatherName": "Sukhpal Singh",
            "obtainedMarks": "1316",
            "maxMarks": "1600",
            "percentage": "82.25%",
            "cells": [
              "91",
              "170090510005",
              "Gagandeep Kaur",
              "Sukhpal Singh",
              "1316",
              "1600",
              "82.25%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "170090510006",
            "name": "Paramjeet Kaur",
            "fatherName": "Kartar Singh",
            "obtainedMarks": "1318",
            "maxMarks": "1600",
            "percentage": "82.37%",
            "cells": [
              "92",
              "170090510006",
              "Paramjeet Kaur",
              "Kartar Singh",
              "1318",
              "1600",
              "82.37%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "170090510007",
            "name": "Kavita Rani",
            "fatherName": "Ranbir Singh",
            "obtainedMarks": "1333",
            "maxMarks": "1600",
            "percentage": "83.31%",
            "cells": [
              "93",
              "170090510007",
              "Kavita Rani",
              "Ranbir Singh",
              "1333",
              "1600",
              "83.31%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "170090510008",
            "name": "Ranju Rathee",
            "fatherName": "Ram Niwas",
            "obtainedMarks": "1217",
            "maxMarks": "1600",
            "percentage": "76.06%",
            "cells": [
              "94",
              "170090510008",
              "Ranju Rathee",
              "Ram Niwas",
              "1217",
              "1600",
              "76.06%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "170090510012",
            "name": "Navdeep",
            "fatherName": "Sukhdev Singh",
            "obtainedMarks": "1312",
            "maxMarks": "1600",
            "percentage": "82%",
            "cells": [
              "95",
              "170090510012",
              "Navdeep",
              "Sukhdev Singh",
              "1312",
              "1600",
              "82%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "170090510013",
            "name": "Savita",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "1277",
            "maxMarks": "1600",
            "percentage": "79.81%",
            "cells": [
              "96",
              "170090510013",
              "Savita",
              "Ramesh Kumar",
              "1277",
              "1600",
              "79.81%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2019-20",
    "courses": [
      {
        "courseName": "B.A I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "190090430004",
            "name": "ANCHAL",
            "fatherName": "SURISH KUMAR",
            "obtainedMarks": "723",
            "maxMarks": "975",
            "percentage": "74.15%",
            "cells": [
              "1",
              "190090430004",
              "ANCHAL",
              "SURISH KUMAR",
              "723",
              "975",
              "74.15%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "190090430005",
            "name": "ANJANI",
            "fatherName": "NORANG",
            "obtainedMarks": "694",
            "maxMarks": "975",
            "percentage": "71.18%",
            "cells": [
              "2",
              "190090430005",
              "ANJANI",
              "NORANG",
              "694",
              "975",
              "71.18%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "190090430006",
            "name": "ANNU",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "796",
            "maxMarks": "975",
            "percentage": "81.64%",
            "cells": [
              "3",
              "190090430006",
              "ANNU",
              "SURESH KUMAR",
              "796",
              "975",
              "81.64%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "190090430009",
            "name": "ARSHDEEP KAUR",
            "fatherName": "KIRPAL SINGH",
            "obtainedMarks": "766",
            "maxMarks": "975",
            "percentage": "78.56%",
            "cells": [
              "4",
              "190090430009",
              "ARSHDEEP KAUR",
              "KIRPAL SINGH",
              "766",
              "975",
              "78.56%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "190090430010",
            "name": "AARZOO KAMBOJ",
            "fatherName": "HARBANS LAL",
            "obtainedMarks": "770",
            "maxMarks": "975",
            "percentage": "78.97%",
            "cells": [
              "5",
              "190090430010",
              "AARZOO KAMBOJ",
              "HARBANS LAL",
              "770",
              "975",
              "78.97%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "190090430012",
            "name": "ASHA RANI",
            "fatherName": "DALEL",
            "obtainedMarks": "745",
            "maxMarks": "975",
            "percentage": "76.41%",
            "cells": [
              "6",
              "190090430012",
              "ASHA RANI",
              "DALEL",
              "745",
              "975",
              "76.41%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "190090430019",
            "name": "GURPREET",
            "fatherName": "DEVI PAL",
            "obtainedMarks": "750",
            "maxMarks": "975",
            "percentage": "76.92%",
            "cells": [
              "7",
              "190090430019",
              "GURPREET",
              "DEVI PAL",
              "750",
              "975",
              "76.92%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "190090430020",
            "name": "HARPREET KAUR",
            "fatherName": "GURCHARAN SINGH",
            "obtainedMarks": "741",
            "maxMarks": "975",
            "percentage": "76%",
            "cells": [
              "8",
              "190090430020",
              "HARPREET KAUR",
              "GURCHARAN SINGH",
              "741",
              "975",
              "76%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "190090430022",
            "name": "KAMLESH",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "750",
            "maxMarks": "975",
            "percentage": "76.92%",
            "cells": [
              "9",
              "190090430022",
              "KAMLESH",
              "MADAN LAL",
              "750",
              "975",
              "76.92%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "190090430024",
            "name": "KAVITA",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "808",
            "maxMarks": "975",
            "percentage": "82.87%",
            "cells": [
              "10",
              "190090430024",
              "KAVITA",
              "SUBASH CHANDER",
              "808",
              "975",
              "82.87%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "190090430027",
            "name": "KAVITA RANI",
            "fatherName": "RAM PARKASH",
            "obtainedMarks": "687",
            "maxMarks": "975",
            "percentage": "70.46%",
            "cells": [
              "11",
              "190090430027",
              "KAVITA RANI",
              "RAM PARKASH",
              "687",
              "975",
              "70.46%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "190090430030",
            "name": "KIRAN",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "815",
            "maxMarks": "975",
            "percentage": "83.59%",
            "cells": [
              "12",
              "190090430030",
              "KIRAN",
              "SAHAB RAM",
              "815",
              "975",
              "83.59%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "190090430032",
            "name": "KOMAL",
            "fatherName": "RAJBIR",
            "obtainedMarks": "817",
            "maxMarks": "975",
            "percentage": "83.79%",
            "cells": [
              "13",
              "190090430032",
              "KOMAL",
              "RAJBIR",
              "817",
              "975",
              "83.79%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "190090430034",
            "name": "KUSHALDEEP",
            "fatherName": "GRRMAIL SINGH",
            "obtainedMarks": "683",
            "maxMarks": "975",
            "percentage": "70.05%",
            "cells": [
              "14",
              "190090430034",
              "KUSHALDEEP",
              "GRRMAIL SINGH",
              "683",
              "975",
              "70.05%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "190090430035",
            "name": "LALITA",
            "fatherName": "SUGREEM CHAND",
            "obtainedMarks": "743",
            "maxMarks": "975",
            "percentage": "76.21%",
            "cells": [
              "15",
              "190090430035",
              "LALITA",
              "SUGREEM CHAND",
              "743",
              "975",
              "76.21%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "190090430037",
            "name": "MAMTA",
            "fatherName": "RAM CHANDER",
            "obtainedMarks": "745",
            "maxMarks": "975",
            "percentage": "76.41%",
            "cells": [
              "16",
              "190090430037",
              "MAMTA",
              "RAM CHANDER",
              "745",
              "975",
              "76.41%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "190090430038",
            "name": "MANISHA",
            "fatherName": "RAJESH",
            "obtainedMarks": "718",
            "maxMarks": "975",
            "percentage": "73.64%",
            "cells": [
              "17",
              "190090430038",
              "MANISHA",
              "RAJESH",
              "718",
              "975",
              "73.64%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "190090430041",
            "name": "MANJU",
            "fatherName": "RAMRAKH",
            "obtainedMarks": "719",
            "maxMarks": "975",
            "percentage": "73.74%",
            "cells": [
              "18",
              "190090430041",
              "MANJU",
              "RAMRAKH",
              "719",
              "975",
              "73.74%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "190090430044",
            "name": "MUSKAN",
            "fatherName": "MANOJ KUMAR",
            "obtainedMarks": "749",
            "maxMarks": "975",
            "percentage": "76.82%",
            "cells": [
              "19",
              "190090430044",
              "MUSKAN",
              "MANOJ KUMAR",
              "749",
              "975",
              "76.82%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "190090430045",
            "name": "NITASHA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "795",
            "maxMarks": "975",
            "percentage": "81.54%",
            "cells": [
              "20",
              "190090430045",
              "NITASHA",
              "MAHENDER SINGH",
              "795",
              "975",
              "81.54%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "190090430054",
            "name": "NISHA",
            "fatherName": "MANSWROOP",
            "obtainedMarks": "707",
            "maxMarks": "975",
            "percentage": "72.51%",
            "cells": [
              "21",
              "190090430054",
              "NISHA",
              "MANSWROOP",
              "707",
              "975",
              "72.51%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "190090430058",
            "name": "SIMRAN",
            "fatherName": "DHARMINDER",
            "obtainedMarks": "687",
            "maxMarks": "975",
            "percentage": "70.46%",
            "cells": [
              "22",
              "190090430058",
              "SIMRAN",
              "DHARMINDER",
              "687",
              "975",
              "70.46%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "190090430063",
            "name": "POOJA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "770",
            "maxMarks": "975",
            "percentage": "78.97%",
            "cells": [
              "23",
              "190090430063",
              "POOJA",
              "MAHENDER SINGH",
              "770",
              "975",
              "78.97%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "190090430065",
            "name": "POOJA",
            "fatherName": "SUBASH",
            "obtainedMarks": "688",
            "maxMarks": "975",
            "percentage": "70.56%",
            "cells": [
              "24",
              "190090430065",
              "POOJA",
              "SUBASH",
              "688",
              "975",
              "70.56%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "190090430070",
            "name": "PRAMILA",
            "fatherName": "RAVINDER SINGH",
            "obtainedMarks": "689",
            "maxMarks": "975",
            "percentage": "70.67%",
            "cells": [
              "25",
              "190090430070",
              "PRAMILA",
              "RAVINDER SINGH",
              "689",
              "975",
              "70.67%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "190090430073",
            "name": "PRITAM",
            "fatherName": "JAGDISH CHSAND",
            "obtainedMarks": "719",
            "maxMarks": "975",
            "percentage": "73.74%",
            "cells": [
              "26",
              "190090430073",
              "PRITAM",
              "JAGDISH CHSAND",
              "719",
              "975",
              "73.74%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "190090430075",
            "name": "PRIYANKA",
            "fatherName": "HARPAL SINGH",
            "obtainedMarks": "686",
            "maxMarks": "975",
            "percentage": "70.36%",
            "cells": [
              "27",
              "190090430075",
              "PRIYANKA",
              "HARPAL SINGH",
              "686",
              "975",
              "70.36%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "190090430081",
            "name": "RAJNI KAUR",
            "fatherName": "BINDER SINGH",
            "obtainedMarks": "759",
            "maxMarks": "975",
            "percentage": "77.85%",
            "cells": [
              "28",
              "190090430081",
              "RAJNI KAUR",
              "BINDER SINGH",
              "759",
              "975",
              "77.85%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "190090430086",
            "name": "RENU",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "765",
            "maxMarks": "975",
            "percentage": "78.46%",
            "cells": [
              "29",
              "190090430086",
              "RENU",
              "PRITHVI SINGH",
              "765",
              "975",
              "78.46%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "190090430087",
            "name": "RENU",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "695",
            "maxMarks": "975",
            "percentage": "71.28%",
            "cells": [
              "30",
              "190090430087",
              "RENU",
              "BANWARI LAL",
              "695",
              "975",
              "71.28%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "190090430093",
            "name": "RITU BALA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "683",
            "maxMarks": "975",
            "percentage": "70.05%",
            "cells": [
              "31",
              "190090430093",
              "RITU BALA",
              "RAJENDER KUMAR",
              "683",
              "975",
              "70.05%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "190090430095",
            "name": "SANDHYA",
            "fatherName": "AJMER SINGH",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.03%",
            "cells": [
              "32",
              "190090430095",
              "SANDHYA",
              "AJMER SINGH",
              "712",
              "975",
              "73.03%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "190090430096",
            "name": "SNEHA",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "743",
            "maxMarks": "975",
            "percentage": "76.21%",
            "cells": [
              "33",
              "190090430096",
              "SNEHA",
              "ANIL KUMAR",
              "743",
              "975",
              "76.21%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "190090430097",
            "name": "SANJANA",
            "fatherName": "ROHTASH KUMAR",
            "obtainedMarks": "785",
            "maxMarks": "975",
            "percentage": "80.51%",
            "cells": [
              "34",
              "190090430097",
              "SANJANA",
              "ROHTASH KUMAR",
              "785",
              "975",
              "80.51%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "190090430098",
            "name": "SANJANA",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "692",
            "maxMarks": "975",
            "percentage": "70.97%",
            "cells": [
              "35",
              "190090430098",
              "SANJANA",
              "RAM SINGH",
              "692",
              "975",
              "70.97%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "190090430100",
            "name": "SAROJ",
            "fatherName": "HANUMANN",
            "obtainedMarks": "698",
            "maxMarks": "975",
            "percentage": "71.59%",
            "cells": [
              "36",
              "190090430100",
              "SAROJ",
              "HANUMANN",
              "698",
              "975",
              "71.59%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "190090430103",
            "name": "SHALLU",
            "fatherName": "RAJ PAL",
            "obtainedMarks": "702",
            "maxMarks": "975",
            "percentage": "72%",
            "cells": [
              "37",
              "190090430103",
              "SHALLU",
              "RAJ PAL",
              "702",
              "975",
              "72%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "190090430106",
            "name": "SHEETAL",
            "fatherName": "BHAGWAN SINGH",
            "obtainedMarks": "789",
            "maxMarks": "975",
            "percentage": "80.92%",
            "cells": [
              "38",
              "190090430106",
              "SHEETAL",
              "BHAGWAN SINGH",
              "789",
              "975",
              "80.92%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "190090430109",
            "name": "SIMRAN",
            "fatherName": "SURENDER KHATTER",
            "obtainedMarks": "705",
            "maxMarks": "975",
            "percentage": "72.31%",
            "cells": [
              "39",
              "190090430109",
              "SIMRAN",
              "SURENDER KHATTER",
              "705",
              "975",
              "72.31%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "190090430110",
            "name": "SIMRAN MEHTA",
            "fatherName": "KANWAL MEHTA",
            "obtainedMarks": "725",
            "maxMarks": "975",
            "percentage": "74.36%",
            "cells": [
              "40",
              "190090430110",
              "SIMRAN MEHTA",
              "KANWAL MEHTA",
              "725",
              "975",
              "74.36%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "190090430111",
            "name": "SIYA",
            "fatherName": "DARA SINGH",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.03%",
            "cells": [
              "41",
              "190090430111",
              "SIYA",
              "DARA SINGH",
              "712",
              "975",
              "73.03%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "190090430113",
            "name": "SUKHPREET KAUR",
            "fatherName": "BALKOUR SINGH",
            "obtainedMarks": "709",
            "maxMarks": "975",
            "percentage": "72.72%",
            "cells": [
              "42",
              "190090430113",
              "SUKHPREET KAUR",
              "BALKOUR SINGH",
              "709",
              "975",
              "72.72%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "190090430114",
            "name": "SUMAN",
            "fatherName": "SATPAL",
            "obtainedMarks": "715",
            "maxMarks": "975",
            "percentage": "73.33%",
            "cells": [
              "43",
              "190090430114",
              "SUMAN",
              "SATPAL",
              "715",
              "975",
              "73.33%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "190090430124",
            "name": "SUSHILA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "763",
            "maxMarks": "975",
            "percentage": "78.26%",
            "cells": [
              "44",
              "190090430124",
              "SUSHILA",
              "MOHAN LAL",
              "763",
              "975",
              "78.26%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "45",
            "rollNo": "180090430004",
            "name": "KARISHMA",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.56%",
            "cells": [
              "45",
              "180090430004",
              "KARISHMA",
              "PRITHVI SINGH",
              "680",
              "900",
              "75.56%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "180090430011",
            "name": "PAYAL",
            "fatherName": "DARIYA SINGH",
            "obtainedMarks": "722",
            "maxMarks": "900",
            "percentage": "80.22%",
            "cells": [
              "46",
              "180090430011",
              "PAYAL",
              "DARIYA SINGH",
              "722",
              "900",
              "80.22%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "180090430013",
            "name": "KAPISHA POONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "738",
            "maxMarks": "900",
            "percentage": "82%",
            "cells": [
              "47",
              "180090430013",
              "KAPISHA POONIA",
              "SANJAY KUMAR",
              "738",
              "900",
              "82%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "180090430015",
            "name": "KIRAN",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "749",
            "maxMarks": "900",
            "percentage": "83.22%",
            "cells": [
              "48",
              "180090430015",
              "KIRAN",
              "RAJENDER SINGH",
              "749",
              "900",
              "83.22%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "180090430016",
            "name": "ANAMIKA",
            "fatherName": "NACHHATRA SINGH",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "49",
              "180090430016",
              "ANAMIKA",
              "NACHHATRA SINGH",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "180090430017",
            "name": "MONA RANI",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "690",
            "maxMarks": "900",
            "percentage": "76.67%",
            "cells": [
              "50",
              "180090430017",
              "MONA RANI",
              "SUBASH CHANDER",
              "690",
              "900",
              "76.67%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "180090430018",
            "name": "ANUJA",
            "fatherName": "VINOD",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "51",
              "180090430018",
              "ANUJA",
              "VINOD",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "180090430024",
            "name": "LAXMI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "52",
              "180090430024",
              "LAXMI",
              "VINOD KUMAR",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "180090430025",
            "name": "SANTOSH",
            "fatherName": "SOHAN LAL",
            "obtainedMarks": "691",
            "maxMarks": "900",
            "percentage": "76.78%",
            "cells": [
              "53",
              "180090430025",
              "SANTOSH",
              "SOHAN LAL",
              "691",
              "900",
              "76.78%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "180090430032",
            "name": "ISHA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "705",
            "maxMarks": "900",
            "percentage": "78.33%",
            "cells": [
              "54",
              "180090430032",
              "ISHA",
              "RAJESH KUMAR",
              "705",
              "900",
              "78.33%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "180090430033",
            "name": "SONAM POPLI",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "754",
            "maxMarks": "900",
            "percentage": "83.78%",
            "cells": [
              "55",
              "180090430033",
              "SONAM POPLI",
              "RAVINDER KUMAR",
              "754",
              "900",
              "83.78%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "180090430034",
            "name": "RAMANDEEP KAUR",
            "fatherName": "JAGTAR SINGH",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.78%",
            "cells": [
              "56",
              "180090430034",
              "RAMANDEEP KAUR",
              "JAGTAR SINGH",
              "655",
              "900",
              "72.78%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "180090430041",
            "name": "PRIYANKA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "57",
              "180090430041",
              "PRIYANKA",
              "RAKESH KUMAR",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "180090430045",
            "name": "ANJU",
            "fatherName": "BADRI PARSAD",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "58",
              "180090430045",
              "ANJU",
              "BADRI PARSAD",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "180090430046",
            "name": "UMA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "59",
              "180090430046",
              "UMA",
              "SUBHASH CHANDER",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "180090430048",
            "name": "PREMLATA",
            "fatherName": "SADHU RAM",
            "obtainedMarks": "686",
            "maxMarks": "900",
            "percentage": "76.22%",
            "cells": [
              "60",
              "180090430048",
              "PREMLATA",
              "SADHU RAM",
              "686",
              "900",
              "76.22%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "180090430055",
            "name": "EKTA",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "61",
              "180090430055",
              "EKTA",
              "AATMA RAM",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "180090430060",
            "name": "MAHIMA",
            "fatherName": "VIJESH KUMAR",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "62",
              "180090430060",
              "MAHIMA",
              "VIJESH KUMAR",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "180090430067",
            "name": "POOJA DEVI",
            "fatherName": "YAG DUTT",
            "obtainedMarks": "719",
            "maxMarks": "900",
            "percentage": "79.89%",
            "cells": [
              "63",
              "180090430067",
              "POOJA DEVI",
              "YAG DUTT",
              "719",
              "900",
              "79.89%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "180090430068",
            "name": "AMANPREET",
            "fatherName": "JAGSEER SINGH",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "64",
              "180090430068",
              "AMANPREET",
              "JAGSEER SINGH",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "180090430081",
            "name": "KIRTI INSAN",
            "fatherName": "RULDA INSAN",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "65",
              "180090430081",
              "KIRTI INSAN",
              "RULDA INSAN",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "180090430086",
            "name": "PREETI",
            "fatherName": "RAJINDER KUMAR",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "66",
              "180090430086",
              "PREETI",
              "RAJINDER KUMAR",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "180090430095",
            "name": "POONAM",
            "fatherName": "DAYANAND GIRI",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "67",
              "180090430095",
              "POONAM",
              "DAYANAND GIRI",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "180090430109",
            "name": "NIRMLA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "68",
              "180090430109",
              "NIRMLA",
              "KRISHAN KUMAR",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "180090430112",
            "name": "TEENA",
            "fatherName": "VED PAL",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "69",
              "180090430112",
              "TEENA",
              "VED PAL",
              "632",
              "900",
              "70.22%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "180090430118",
            "name": "RAVINA DEVI",
            "fatherName": "AJAY PAL",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.78%",
            "cells": [
              "70",
              "180090430118",
              "RAVINA DEVI",
              "AJAY PAL",
              "637",
              "900",
              "70.78%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "180090430122",
            "name": "RACHNA RANI",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "71",
              "180090430122",
              "RACHNA RANI",
              "NARESH KUMAR",
              "687",
              "900",
              "76.33%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "72",
            "rollNo": "170090430003",
            "name": "SAVINA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "698",
            "maxMarks": "900",
            "percentage": "77.56%",
            "cells": [
              "72",
              "170090430003",
              "SAVINA",
              "RAN SINGH",
              "698",
              "900",
              "77.56%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "170090430004",
            "name": "MANDEEP KAUR",
            "fatherName": "SURESH",
            "obtainedMarks": "649",
            "maxMarks": "900",
            "percentage": "72.11%",
            "cells": [
              "73",
              "170090430004",
              "MANDEEP KAUR",
              "SURESH",
              "649",
              "900",
              "72.11%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "170090430005",
            "name": "ANJU BALA",
            "fatherName": "RAMESH LAL",
            "obtainedMarks": "653",
            "maxMarks": "900",
            "percentage": "72.56%",
            "cells": [
              "74",
              "170090430005",
              "ANJU BALA",
              "RAMESH LAL",
              "653",
              "900",
              "72.56%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "170090430007",
            "name": "POOJA",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "644",
            "maxMarks": "900",
            "percentage": "71.56%",
            "cells": [
              "75",
              "170090430007",
              "POOJA",
              "DHARAMPAL",
              "644",
              "900",
              "71.56%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "170090430008",
            "name": "RINKU",
            "fatherName": "BALWANT SINGH",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "76",
              "170090430008",
              "RINKU",
              "BALWANT SINGH",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "170090430009",
            "name": "JASPREET KAUR",
            "fatherName": "DHARAM SINGH",
            "obtainedMarks": "708",
            "maxMarks": "900",
            "percentage": "78.67%",
            "cells": [
              "77",
              "170090430009",
              "JASPREET KAUR",
              "DHARAM SINGH",
              "708",
              "900",
              "78.67%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "170090430011",
            "name": "JASWINDER",
            "fatherName": "SH GULSHAN KUMAR",
            "obtainedMarks": "681",
            "maxMarks": "900",
            "percentage": "75.67%",
            "cells": [
              "78",
              "170090430011",
              "JASWINDER",
              "SH GULSHAN KUMAR",
              "681",
              "900",
              "75.67%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "170090430012",
            "name": "KAVITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "79",
              "170090430012",
              "KAVITA",
              "RAMESH KUMAR",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "170090430016",
            "name": "POOJA RANI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.78%",
            "cells": [
              "80",
              "170090430016",
              "POOJA RANI",
              "RAJESH KUMAR",
              "673",
              "900",
              "74.78%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "170090430017",
            "name": "POONAM THAKUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "81",
              "170090430017",
              "POONAM THAKUR",
              "GURMAIL SINGH",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "170090430019",
            "name": "SANDEEP KAUR",
            "fatherName": "GURBHAGAT SINGH",
            "obtainedMarks": "693",
            "maxMarks": "900",
            "percentage": "77%",
            "cells": [
              "82",
              "170090430019",
              "SANDEEP KAUR",
              "GURBHAGAT SINGH",
              "693",
              "900",
              "77%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "170090430022",
            "name": "ANJALI",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "83",
              "170090430022",
              "ANJALI",
              "SHYAM LAL",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "170090430025",
            "name": "RAMANDEEP KAUR",
            "fatherName": "SUKHMANDER SINGH",
            "obtainedMarks": "692",
            "maxMarks": "900",
            "percentage": "76.89%",
            "cells": [
              "84",
              "170090430025",
              "RAMANDEEP KAUR",
              "SUKHMANDER SINGH",
              "692",
              "900",
              "76.89%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "170090430027",
            "name": "PRIYA",
            "fatherName": "JAISRAJ",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "85",
              "170090430027",
              "PRIYA",
              "JAISRAJ",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "170090430028",
            "name": "ANNU",
            "fatherName": "CHANDER SHARMA",
            "obtainedMarks": "721",
            "maxMarks": "900",
            "percentage": "80.11%",
            "cells": [
              "86",
              "170090430028",
              "ANNU",
              "CHANDER SHARMA",
              "721",
              "900",
              "80.11%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "170090430032",
            "name": "RAVINA",
            "fatherName": "MR MAHESH KUMAR",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.56%",
            "cells": [
              "87",
              "170090430032",
              "RAVINA",
              "MR MAHESH KUMAR",
              "680",
              "900",
              "75.56%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "170090430034",
            "name": "KAJAL",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.78%",
            "cells": [
              "88",
              "170090430034",
              "KAJAL",
              "VED PARKASH",
              "637",
              "900",
              "70.78%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "170090430035",
            "name": "MUSKAN",
            "fatherName": "JASVIR",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "89",
              "170090430035",
              "MUSKAN",
              "JASVIR",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "170090430044",
            "name": "VIJETA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "731",
            "maxMarks": "900",
            "percentage": "81.22%",
            "cells": [
              "90",
              "170090430044",
              "VIJETA",
              "KULDEEP",
              "731",
              "900",
              "81.22%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "170090430050",
            "name": "RAJDEEP KAUR",
            "fatherName": "INDERJEET SINGH",
            "obtainedMarks": "696",
            "maxMarks": "900",
            "percentage": "77.33%",
            "cells": [
              "91",
              "170090430050",
              "RAJDEEP KAUR",
              "INDERJEET SINGH",
              "696",
              "900",
              "77.33%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "170090430051",
            "name": "ANJU",
            "fatherName": "BHUD RAM",
            "obtainedMarks": "649",
            "maxMarks": "900",
            "percentage": "72.11%",
            "cells": [
              "92",
              "170090430051",
              "ANJU",
              "BHUD RAM",
              "649",
              "900",
              "72.11%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "170090430053",
            "name": "NISHA SAINI",
            "fatherName": "PAWAN SAINI",
            "obtainedMarks": "744",
            "maxMarks": "900",
            "percentage": "82.67%",
            "cells": [
              "93",
              "170090430053",
              "NISHA SAINI",
              "PAWAN SAINI",
              "744",
              "900",
              "82.67%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "170090430059",
            "name": "NEELAM",
            "fatherName": "SALENDER SINGH",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "94",
              "170090430059",
              "NEELAM",
              "SALENDER SINGH",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "170090430061",
            "name": "SANJU KAMBOJ",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "744",
            "maxMarks": "900",
            "percentage": "82.67%",
            "cells": [
              "95",
              "170090430061",
              "SANJU KAMBOJ",
              "JAGDISH KUMAR",
              "744",
              "900",
              "82.67%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "170090430064",
            "name": "GARIMA",
            "fatherName": "BABU RAM",
            "obtainedMarks": "755",
            "maxMarks": "900",
            "percentage": "83.89%",
            "cells": [
              "96",
              "170090430064",
              "GARIMA",
              "BABU RAM",
              "755",
              "900",
              "83.89%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "170090430070",
            "name": "JYOTI RANI",
            "fatherName": "GANDHI RAM",
            "obtainedMarks": "698",
            "maxMarks": "900",
            "percentage": "77.56%",
            "cells": [
              "97",
              "170090430070",
              "JYOTI RANI",
              "GANDHI RAM",
              "698",
              "900",
              "77.56%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "170090430071",
            "name": "ARJU",
            "fatherName": "SANJEEV",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "98",
              "170090430071",
              "ARJU",
              "SANJEEV",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "170090430074",
            "name": "POONAM RANI",
            "fatherName": "BALRAJ SINGH",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "99",
              "170090430074",
              "POONAM RANI",
              "BALRAJ SINGH",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "170090430080",
            "name": "SONIKA",
            "fatherName": "RAMNIWASH",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "100",
              "170090430080",
              "SONIKA",
              "RAMNIWASH",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "170090430086",
            "name": "JAYANTI DEVI",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "101",
              "170090430086",
              "JAYANTI DEVI",
              "MOHAN LAL",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "170090430091",
            "name": "MONIKA",
            "fatherName": "KANHAIYALAL",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "102",
              "170090430091",
              "MONIKA",
              "KANHAIYALAL",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "170090430095",
            "name": "MANJU",
            "fatherName": "RAMESH SAHARAN",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "103",
              "170090430095",
              "MANJU",
              "RAMESH SAHARAN",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "170090430098",
            "name": "CHANDER KALA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.78%",
            "cells": [
              "104",
              "170090430098",
              "CHANDER KALA",
              "MOHAN LAL",
              "700",
              "900",
              "77.78%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "170090430100",
            "name": "JYOTI",
            "fatherName": "JAIPAL",
            "obtainedMarks": "734",
            "maxMarks": "900",
            "percentage": "81.56%",
            "cells": [
              "105",
              "170090430100",
              "JYOTI",
              "JAIPAL",
              "734",
              "900",
              "81.56%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "170090430111",
            "name": "PRITA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "106",
              "170090430111",
              "PRITA",
              "VINOD KUMAR",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "170090430112",
            "name": "SWATI",
            "fatherName": "SATBEER SINGH",
            "obtainedMarks": "688",
            "maxMarks": "900",
            "percentage": "76.44%",
            "cells": [
              "107",
              "170090430112",
              "SWATI",
              "SATBEER SINGH",
              "688",
              "900",
              "76.44%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "170090430114",
            "name": "RITU",
            "fatherName": "KARNI SINGH",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "108",
              "170090430114",
              "RITU",
              "KARNI SINGH",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "170090430115",
            "name": "RACHNA",
            "fatherName": "KHEM SINGH",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "109",
              "170090430115",
              "RACHNA",
              "KHEM SINGH",
              "652",
              "900",
              "72.44%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.Sc (NM) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "110",
            "rollNo": "180090442001",
            "name": "KAMYA",
            "fatherName": "SANJEEV KUMAR",
            "obtainedMarks": "781",
            "maxMarks": "1100",
            "percentage": "71%",
            "cells": [
              "110",
              "180090442001",
              "KAMYA",
              "SANJEEV KUMAR",
              "781",
              "1100",
              "71%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "180090442003",
            "name": "RENU",
            "fatherName": "KARAM SINGH",
            "obtainedMarks": "783",
            "maxMarks": "1100",
            "percentage": "71.18%",
            "cells": [
              "111",
              "180090442003",
              "RENU",
              "KARAM SINGH",
              "783",
              "1100",
              "71.18%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "180090442004",
            "name": "MONIKA",
            "fatherName": "SHISHPAL",
            "obtainedMarks": "884",
            "maxMarks": "1100",
            "percentage": "80.36%",
            "cells": [
              "112",
              "180090442004",
              "MONIKA",
              "SHISHPAL",
              "884",
              "1100",
              "80.36%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "180090442012",
            "name": "NEETU",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "877",
            "maxMarks": "1100",
            "percentage": "79.73%",
            "cells": [
              "113",
              "180090442012",
              "NEETU",
              "VED PARKASH",
              "877",
              "1100",
              "79.73%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "180090442014",
            "name": "HIMANSHI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "779",
            "maxMarks": "1100",
            "percentage": "70.82%",
            "cells": [
              "114",
              "180090442014",
              "HIMANSHI",
              "BANWARI LAL",
              "779",
              "1100",
              "70.82%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "180090442015",
            "name": "MANISHA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "889",
            "maxMarks": "1100",
            "percentage": "80.82%",
            "cells": [
              "115",
              "180090442015",
              "MANISHA",
              "VINOD KUMAR",
              "889",
              "1100",
              "80.82%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "180090442019",
            "name": "SIMRAN",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "809",
            "maxMarks": "1100",
            "percentage": "73.55%",
            "cells": [
              "116",
              "180090442019",
              "SIMRAN",
              "SURENDER SINGH",
              "809",
              "1100",
              "73.55%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "180090442020",
            "name": "PRERNA",
            "fatherName": "ROHTASH KUMAR",
            "obtainedMarks": "792",
            "maxMarks": "1100",
            "percentage": "72%",
            "cells": [
              "117",
              "180090442020",
              "PRERNA",
              "ROHTASH KUMAR",
              "792",
              "1100",
              "72%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "180090442022",
            "name": "AMANAT",
            "fatherName": "VINOD",
            "obtainedMarks": "793",
            "maxMarks": "1100",
            "percentage": "72.09%",
            "cells": [
              "118",
              "180090442022",
              "AMANAT",
              "VINOD",
              "793",
              "1100",
              "72.09%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "119",
            "rollNo": "170090442006",
            "name": "GURPUNEET\n KAUR",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "868",
            "maxMarks": "1000",
            "percentage": "86.80%",
            "cells": [
              "119",
              "170090442006",
              "GURPUNEET\n KAUR",
              "RAM SINGH",
              "868",
              "1000",
              "86.80%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "170090442008",
            "name": "MANPREET KAUR",
            "fatherName": "CHAKOTAR SINGH",
            "obtainedMarks": "765",
            "maxMarks": "1000",
            "percentage": "76.50%",
            "cells": [
              "120",
              "170090442008",
              "MANPREET KAUR",
              "CHAKOTAR SINGH",
              "765",
              "1000",
              "76.50%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "170090442012",
            "name": "REEYA",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "859",
            "maxMarks": "1000",
            "percentage": "85.90%",
            "cells": [
              "121",
              "170090442012",
              "REEYA",
              "RAVINDER KUMAR",
              "859",
              "1000",
              "85.90%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "170090442018",
            "name": "JEENU",
            "fatherName": "GORI SHANKAR",
            "obtainedMarks": "817",
            "maxMarks": "1000",
            "percentage": "81.70%",
            "cells": [
              "122",
              "170090442018",
              "JEENU",
              "GORI SHANKAR",
              "817",
              "1000",
              "81.70%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "170090442019",
            "name": "EKTA RANI",
            "fatherName": "AHEL CHAND",
            "obtainedMarks": "713",
            "maxMarks": "1000",
            "percentage": "71.30%",
            "cells": [
              "123",
              "170090442019",
              "EKTA RANI",
              "AHEL CHAND",
              "713",
              "1000",
              "71.30%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "170090442020",
            "name": "SHAKILA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "818",
            "maxMarks": "1000",
            "percentage": "81.80%",
            "cells": [
              "124",
              "170090442020",
              "SHAKILA",
              "MAHENDER SINGH",
              "818",
              "1000",
              "81.80%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "170090442021",
            "name": "PRITPAL KAUR",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "833",
            "maxMarks": "1000",
            "percentage": "83.30%",
            "cells": [
              "125",
              "170090442021",
              "PRITPAL KAUR",
              "RAJENDER SINGH",
              "833",
              "1000",
              "83.30%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "170090442023",
            "name": "ANKISHA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "797",
            "maxMarks": "1000",
            "percentage": "79.70%",
            "cells": [
              "126",
              "170090442023",
              "ANKISHA",
              "SHAMSHER SINGH",
              "797",
              "1000",
              "79.70%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "170090442025",
            "name": "KAMLESH",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "726",
            "maxMarks": "1000",
            "percentage": "72.60%",
            "cells": [
              "127",
              "170090442025",
              "KAMLESH",
              "KRISHAN KUMAR",
              "726",
              "1000",
              "72.60%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "170090442027",
            "name": "KAMLESH",
            "fatherName": "RAMESH CHANDER",
            "obtainedMarks": "873",
            "maxMarks": "1000",
            "percentage": "87.30%",
            "cells": [
              "128",
              "170090442027",
              "KAMLESH",
              "RAMESH CHANDER",
              "873",
              "1000",
              "87.30%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "170090442029",
            "name": "MONIKA",
            "fatherName": "KARAN SINGH",
            "obtainedMarks": "764",
            "maxMarks": "1000",
            "percentage": "76.40%",
            "cells": [
              "129",
              "170090442029",
              "MONIKA",
              "KARAN SINGH",
              "764",
              "1000",
              "76.40%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "170090442032",
            "name": "TAMANA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "713",
            "maxMarks": "1000",
            "percentage": "71.30%",
            "cells": [
              "130",
              "170090442032",
              "TAMANA",
              "VINOD KUMAR",
              "713",
              "1000",
              "71.30%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "170090442035",
            "name": "ANJU RANI",
            "fatherName": "RAJBIR",
            "obtainedMarks": "860",
            "maxMarks": "1000",
            "percentage": "86%",
            "cells": [
              "131",
              "170090442035",
              "ANJU RANI",
              "RAJBIR",
              "860",
              "1000",
              "86%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "170090442037",
            "name": "DIKSHA RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "783",
            "maxMarks": "1000",
            "percentage": "78.30%",
            "cells": [
              "132",
              "170090442037",
              "DIKSHA RANI",
              "GOPAL",
              "783",
              "1000",
              "78.30%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "170090442039",
            "name": "SUKHBHEJ KAUR",
            "fatherName": "BHUPINDER SINGH",
            "obtainedMarks": "744",
            "maxMarks": "1000",
            "percentage": "74.40%",
            "cells": [
              "133",
              "170090442039",
              "SUKHBHEJ KAUR",
              "BHUPINDER SINGH",
              "744",
              "1000",
              "74.40%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "134",
            "rollNo": "19009044001",
            "name": "ANCHAL",
            "fatherName": "KUSHAL CHAND",
            "obtainedMarks": "784",
            "maxMarks": "1100",
            "percentage": "71.27%",
            "cells": [
              "134",
              "19009044001",
              "ANCHAL",
              "KUSHAL CHAND",
              "784",
              "1100",
              "71.27%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "19009044003",
            "name": "LALITA",
            "fatherName": "SEVA SINGH",
            "obtainedMarks": "855",
            "maxMarks": "1100",
            "percentage": "77.73%",
            "cells": [
              "135",
              "19009044003",
              "LALITA",
              "SEVA SINGH",
              "855",
              "1100",
              "77.73%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "19009044006",
            "name": "NEETU",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "819",
            "maxMarks": "1100",
            "percentage": "74.45%",
            "cells": [
              "136",
              "19009044006",
              "NEETU",
              "RAMESH KUMAR",
              "819",
              "1100",
              "74.45%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "19009044010",
            "name": "REEYA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "809",
            "maxMarks": "1100",
            "percentage": "73.55%",
            "cells": [
              "137",
              "19009044010",
              "REEYA",
              "VIJAY KUMAR",
              "809",
              "1100",
              "73.55%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "138",
            "rollNo": "180090440001",
            "name": "NISHA",
            "fatherName": "RAM KUMAR",
            "obtainedMarks": "793",
            "maxMarks": "1100",
            "percentage": "72.09%",
            "cells": [
              "138",
              "180090440001",
              "NISHA",
              "RAM KUMAR",
              "793",
              "1100",
              "72.09%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "180090440004",
            "name": "PRIYANKA KUMARI",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "808",
            "maxMarks": "1100",
            "percentage": "73.45%",
            "cells": [
              "139",
              "180090440004",
              "PRIYANKA KUMARI",
              "OM PARKASH",
              "808",
              "1100",
              "73.45%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "180090440005",
            "name": "GURPREEET KAUR",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "800",
            "maxMarks": "1100",
            "percentage": "72.73%",
            "cells": [
              "140",
              "180090440005",
              "GURPREEET KAUR",
              "RAMESH KUMAR",
              "800",
              "1100",
              "72.73%"
            ]
          },
          {
            "sNo": "141",
            "rollNo": "180090440010",
            "name": "PRIYANKA",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "858",
            "maxMarks": "1100",
            "percentage": "78%",
            "cells": [
              "141",
              "180090440010",
              "PRIYANKA",
              "AMAR SINGH",
              "858",
              "1100",
              "78%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "142",
            "rollNo": "170090440006",
            "name": "SAROJ RANI",
            "fatherName": "SATPAL",
            "obtainedMarks": "754",
            "maxMarks": "1000",
            "percentage": "75.40%",
            "cells": [
              "142",
              "170090440006",
              "SAROJ RANI",
              "SATPAL",
              "754",
              "1000",
              "75.40%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "143",
            "rollNo": "190090470007",
            "name": "MANISHA RANI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "1336",
            "maxMarks": "1700",
            "percentage": "78.59%",
            "cells": [
              "143",
              "190090470007",
              "MANISHA RANI",
              "SUNIL KUMAR",
              "1336",
              "1700",
              "78.59%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "190090470009",
            "name": "NOOR",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1254",
            "maxMarks": "1700",
            "percentage": "73.76%",
            "cells": [
              "144",
              "190090470009",
              "NOOR",
              "DHARAMPAL",
              "1254",
              "1700",
              "73.76%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "190090470010",
            "name": "POOJA",
            "fatherName": "RAKESH",
            "obtainedMarks": "1243",
            "maxMarks": "1700",
            "percentage": "73.12%",
            "cells": [
              "145",
              "190090470010",
              "POOJA",
              "RAKESH",
              "1243",
              "1700",
              "73.12%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "190090470015",
            "name": "JYOTI",
            "fatherName": "KIRPA SINGH",
            "obtainedMarks": "1359",
            "maxMarks": "1700",
            "percentage": "79.94%",
            "cells": [
              "146",
              "190090470015",
              "JYOTI",
              "KIRPA SINGH",
              "1359",
              "1700",
              "79.94%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "147",
            "rollNo": "180090470008",
            "name": "SAPNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1234",
            "maxMarks": "1700",
            "percentage": "72.59%",
            "cells": [
              "147",
              "180090470008",
              "SAPNA",
              "KRISHAN KUMAR",
              "1234",
              "1700",
              "72.59%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "180090470012",
            "name": "ANCHAL SHARMA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1241",
            "maxMarks": "1700",
            "percentage": "73%",
            "cells": [
              "148",
              "180090470012",
              "ANCHAL SHARMA",
              "KRISHAN KUMAR",
              "1241",
              "1700",
              "73%"
            ]
          }
        ]
      },
      {
        "courseName": "BCAV + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "149",
            "rollNo": "170090470001",
            "name": "POOJA",
            "fatherName": "MANI RAM",
            "obtainedMarks": "1197",
            "maxMarks": "1700",
            "percentage": "70.41%",
            "cells": [
              "149",
              "170090470001",
              "POOJA",
              "MANI RAM",
              "1197",
              "1700",
              "70.41%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "170090470010",
            "name": "SONALI",
            "fatherName": "SANT LAL",
            "obtainedMarks": "1202",
            "maxMarks": "1700",
            "percentage": "70.71%",
            "cells": [
              "150",
              "170090470010",
              "SONALI",
              "SANT LAL",
              "1202",
              "1700",
              "70.71%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "170090470012",
            "name": "GAZAL",
            "fatherName": "SATPAL SONI",
            "obtainedMarks": "1251",
            "maxMarks": "1700",
            "percentage": "73.59%",
            "cells": [
              "151",
              "170090470012",
              "GAZAL",
              "SATPAL SONI",
              "1251",
              "1700",
              "73.59%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "152",
            "rollNo": "190090420002",
            "name": "BALJINDER KAUR",
            "fatherName": "AJMER SINGH",
            "obtainedMarks": "891",
            "maxMarks": "1175",
            "percentage": "75.82%",
            "cells": [
              "152",
              "190090420002",
              "BALJINDER KAUR",
              "AJMER SINGH",
              "891",
              "1175",
              "75.82%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "190090420005",
            "name": "HIMANI BISHNOI",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "870",
            "maxMarks": "1175",
            "percentage": "74.04%",
            "cells": [
              "153",
              "190090420005",
              "HIMANI BISHNOI",
              "SUBHASH CHANDER",
              "870",
              "1175",
              "74.04%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "1900904200010",
            "name": "PREETI",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "856",
            "maxMarks": "1175",
            "percentage": "72.85%",
            "cells": [
              "154",
              "1900904200010",
              "PREETI",
              "VED PARKASH",
              "856",
              "1175",
              "72.85%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "1900904200012",
            "name": "PRIYANKA",
            "fatherName": "BHARAT SINGH",
            "obtainedMarks": "854",
            "maxMarks": "1175",
            "percentage": "72.68%",
            "cells": [
              "155",
              "1900904200012",
              "PRIYANKA",
              "BHARAT SINGH",
              "854",
              "1175",
              "72.68%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "1900904200013",
            "name": "REHMAT",
            "fatherName": "NAVNEET KUMAR",
            "obtainedMarks": "826",
            "maxMarks": "1175",
            "percentage": "70.29%",
            "cells": [
              "156",
              "1900904200013",
              "REHMAT",
              "NAVNEET KUMAR",
              "826",
              "1175",
              "70.29%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "1900904200014",
            "name": "REKHA",
            "fatherName": "NANAK RAM",
            "obtainedMarks": "856",
            "maxMarks": "1175",
            "percentage": "72.85%",
            "cells": [
              "157",
              "1900904200014",
              "REKHA",
              "NANAK RAM",
              "856",
              "1175",
              "72.85%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "19009042000135",
            "name": "RIDHI",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "891",
            "maxMarks": "1175",
            "percentage": "75.82%",
            "cells": [
              "158",
              "19009042000135",
              "RIDHI",
              "RANBIR SINGH",
              "891",
              "1175",
              "75.82%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "159",
            "rollNo": "180090420005",
            "name": "POONAM RANI",
            "fatherName": "SURJEET",
            "obtainedMarks": "794",
            "maxMarks": "1100",
            "percentage": "72.18%",
            "cells": [
              "159",
              "180090420005",
              "POONAM RANI",
              "SURJEET",
              "794",
              "1100",
              "72.18%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "1800904200011",
            "name": "ARPANA",
            "fatherName": "SATYA NARAYAN",
            "obtainedMarks": "810",
            "maxMarks": "1100",
            "percentage": "73.63%",
            "cells": [
              "160",
              "1800904200011",
              "ARPANA",
              "SATYA NARAYAN",
              "810",
              "1100",
              "73.63%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "1800904200012",
            "name": "ANJU DEVI",
            "fatherName": "SANT LAL",
            "obtainedMarks": "622",
            "maxMarks": "1100",
            "percentage": "74.72%",
            "cells": [
              "161",
              "1800904200012",
              "ANJU DEVI",
              "SANT LAL",
              "622",
              "1100",
              "74.72%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "162",
            "rollNo": "170090420001",
            "name": "RAMANDEEP",
            "fatherName": "DILBAG SINGH",
            "obtainedMarks": "809",
            "maxMarks": "1100",
            "percentage": "73.55%",
            "cells": [
              "162",
              "170090420001",
              "RAMANDEEP",
              "DILBAG SINGH",
              "809",
              "1100",
              "73.55%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "170090420003",
            "name": "SUSHMA",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "800",
            "maxMarks": "1100",
            "percentage": "72.73%",
            "cells": [
              "163",
              "170090420003",
              "SUSHMA",
              "SUBASH CHANDER",
              "800",
              "1100",
              "72.73%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "170090420013",
            "name": "DEEPIKA",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "819",
            "maxMarks": "1100",
            "percentage": "74.45%",
            "cells": [
              "164",
              "170090420013",
              "DEEPIKA",
              "HANSRAJ",
              "819",
              "1100",
              "74.45%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "16109420003",
            "name": "KANCHAN BALA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "165",
              "16109420003",
              "KANCHAN BALA",
              "SURENDER KUMAR",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "16109420004",
            "name": "CHANCHAL RANI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "702",
            "maxMarks": "1000",
            "percentage": "70.20%",
            "cells": [
              "166",
              "16109420004",
              "CHANCHAL RANI",
              "SURENDER KUMAR",
              "702",
              "1000",
              "70.20%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "16109420007",
            "name": "POONAM RANI",
            "fatherName": "MOOL CHAND",
            "obtainedMarks": "762",
            "maxMarks": "1000",
            "percentage": "76.20%",
            "cells": [
              "167",
              "16109420007",
              "POONAM RANI",
              "MOOL CHAND",
              "762",
              "1000",
              "76.20%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "16109420008",
            "name": "KIRAN RANI",
            "fatherName": "GOPAL CHAND",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "168",
              "16109420008",
              "KIRAN RANI",
              "GOPAL CHAND",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "16109420011",
            "name": "RIYA GOYAL",
            "fatherName": "BIMAL GOYAL",
            "obtainedMarks": "801",
            "maxMarks": "1000",
            "percentage": "80.10%",
            "cells": [
              "169",
              "16109420011",
              "RIYA GOYAL",
              "BIMAL GOYAL",
              "801",
              "1000",
              "80.10%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "16109420012",
            "name": "GURPREET",
            "fatherName": "JAI CHAND",
            "obtainedMarks": "763",
            "maxMarks": "1000",
            "percentage": "76.30%",
            "cells": [
              "170",
              "16109420012",
              "GURPREET",
              "JAI CHAND",
              "763",
              "1000",
              "76.30%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "16109420013",
            "name": "SIMRAN GANDHI",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "786",
            "maxMarks": "1000",
            "percentage": "78.60%",
            "cells": [
              "171",
              "16109420013",
              "SIMRAN GANDHI",
              "SANDEEP KUMAR",
              "786",
              "1000",
              "78.60%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "16109420016",
            "name": "REENA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "770",
            "maxMarks": "1000",
            "percentage": "77%",
            "cells": [
              "172",
              "16109420016",
              "REENA",
              "RAJENDER",
              "770",
              "1000",
              "77%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "173",
            "rollNo": "180090480007",
            "name": "POONAM",
            "fatherName": "SHREE RAM",
            "obtainedMarks": "989",
            "maxMarks": "1350",
            "percentage": "73.25%",
            "cells": [
              "173",
              "180090480007",
              "POONAM",
              "SHREE RAM",
              "989",
              "1350",
              "73.25%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "180090480009",
            "name": "DEEPIKA",
            "fatherName": "MADHUSUDHAN",
            "obtainedMarks": "966",
            "maxMarks": "1350",
            "percentage": "71.55%",
            "cells": [
              "174",
              "180090480009",
              "DEEPIKA",
              "MADHUSUDHAN",
              "966",
              "1350",
              "71.55%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA V + VI Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.Com (Voc.) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "175",
            "rollNo": "190090460001",
            "name": "AKSHDEEP KAUR",
            "fatherName": "GURDAT SINGH",
            "obtainedMarks": "872",
            "maxMarks": "1150",
            "percentage": "75.82%",
            "cells": [
              "175",
              "190090460001",
              "AKSHDEEP KAUR",
              "GURDAT SINGH",
              "872",
              "1150",
              "75.82%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "176",
            "rollNo": "180090460010",
            "name": "MOHINI",
            "fatherName": "SATPAL",
            "obtainedMarks": "896",
            "maxMarks": "1250",
            "percentage": "71.68%",
            "cells": [
              "176",
              "180090460010",
              "MOHINI",
              "SATPAL",
              "896",
              "1250",
              "71.68%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) V+ VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "177",
            "rollNo": "170090460002",
            "name": "KAMALPREET KAUR",
            "fatherName": "JASKARAN SINGH",
            "obtainedMarks": "907",
            "maxMarks": "1250",
            "percentage": "72.56%",
            "cells": [
              "177",
              "170090460002",
              "KAMALPREET KAUR",
              "JASKARAN SINGH",
              "907",
              "1250",
              "72.56%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "170090460005",
            "name": "ARMANPREET KAUR",
            "fatherName": "SURINDER SINGH",
            "obtainedMarks": "904",
            "maxMarks": "1250",
            "percentage": "72.32%",
            "cells": [
              "178",
              "170090460005",
              "ARMANPREET KAUR",
              "SURINDER SINGH",
              "904",
              "1250",
              "72.32%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "170090460006",
            "name": "GURPREET KAUR",
            "fatherName": "MANISH KUMAR",
            "obtainedMarks": "914",
            "maxMarks": "1250",
            "percentage": "73.12%",
            "cells": [
              "179",
              "170090460006",
              "GURPREET KAUR",
              "MANISH KUMAR",
              "914",
              "1250",
              "73.12%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "170090460007",
            "name": "MAMTA",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "937",
            "maxMarks": "1250",
            "percentage": "74.96%",
            "cells": [
              "180",
              "170090460007",
              "MAMTA",
              "BALBIR SINGH",
              "937",
              "1250",
              "74.96%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "170090460009",
            "name": "JANNAT ARORA",
            "fatherName": "PURUSHOTAM KUMAR",
            "obtainedMarks": "905",
            "maxMarks": "1250",
            "percentage": "72.40%",
            "cells": [
              "181",
              "170090460009",
              "JANNAT ARORA",
              "PURUSHOTAM KUMAR",
              "905",
              "1250",
              "72.40%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "182",
            "rollNo": "190090450017",
            "name": "MAMTA RANI",
            "fatherName": "SUKHBIR SINGH",
            "obtainedMarks": "844",
            "maxMarks": "1150",
            "percentage": "73.39%",
            "cells": [
              "182",
              "190090450017",
              "MAMTA RANI",
              "SUKHBIR SINGH",
              "844",
              "1150",
              "73.39%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "190090450018",
            "name": "MANISHA RANI",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "875",
            "maxMarks": "1150",
            "percentage": "76.08%",
            "cells": [
              "183",
              "190090450018",
              "MANISHA RANI",
              "SURESH KUMAR",
              "875",
              "1150",
              "76.08%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "190090450028",
            "name": "SANDHYA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "927",
            "maxMarks": "1150",
            "percentage": "80.60%",
            "cells": [
              "184",
              "190090450028",
              "SANDHYA",
              "RAJESH KUMAR",
              "927",
              "1150",
              "80.60%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "190090450034",
            "name": "SUGANDH",
            "fatherName": "RAKESH KUMAR DHAWAN",
            "obtainedMarks": "962",
            "maxMarks": "1150",
            "percentage": "83.65%",
            "cells": [
              "185",
              "190090450034",
              "SUGANDH",
              "RAKESH KUMAR DHAWAN",
              "962",
              "1150",
              "83.65%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "186",
            "rollNo": "180090450008",
            "name": "poonam",
            "fatherName": "PALA RAM",
            "obtainedMarks": "903",
            "maxMarks": "1250",
            "percentage": "72.24%",
            "cells": [
              "186",
              "180090450008",
              "poonam",
              "PALA RAM",
              "903",
              "1250",
              "72.24%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "180090450017",
            "name": "shagun",
            "fatherName": "JITENDER PHUTELA",
            "obtainedMarks": "882",
            "maxMarks": "1250",
            "percentage": "70.56%",
            "cells": [
              "187",
              "180090450017",
              "shagun",
              "JITENDER PHUTELA",
              "882",
              "1250",
              "70.56%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "180090450018",
            "name": "AARZOO",
            "fatherName": "RAVI GABA",
            "obtainedMarks": "925",
            "maxMarks": "1250",
            "percentage": "74%",
            "cells": [
              "188",
              "180090450018",
              "AARZOO",
              "RAVI GABA",
              "925",
              "1250",
              "74%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "180090450021",
            "name": "PRIYANKA",
            "fatherName": "PREM SINGH",
            "obtainedMarks": "949",
            "maxMarks": "1250",
            "percentage": "75.92%",
            "cells": [
              "189",
              "180090450021",
              "PRIYANKA",
              "PREM SINGH",
              "949",
              "1250",
              "75.92%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "180090450026",
            "name": "MANJU",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "897",
            "maxMarks": "1250",
            "percentage": "71.76%",
            "cells": [
              "190",
              "180090450026",
              "MANJU",
              "SOHAN PAL",
              "897",
              "1250",
              "71.76%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "180650450001\nMigrated student",
            "name": "LAXMI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "889",
            "maxMarks": "1250",
            "percentage": "71.12%",
            "cells": [
              "191",
              "180650450001\nMigrated student",
              "LAXMI",
              "RAMESH KUMAR",
              "889",
              "1250",
              "71.12%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen.) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "192",
            "rollNo": "170090450001",
            "name": "VANSHIKA GOYAL",
            "fatherName": "SUDHIR GOYAL",
            "obtainedMarks": "1005",
            "maxMarks": "1200",
            "percentage": "83.75%",
            "cells": [
              "192",
              "170090450001",
              "VANSHIKA GOYAL",
              "SUDHIR GOYAL",
              "1005",
              "1200",
              "83.75%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "170090450004",
            "name": "RUCHIKA",
            "fatherName": "SURSH KUMAR",
            "obtainedMarks": "869",
            "maxMarks": "1200",
            "percentage": "72.42%",
            "cells": [
              "193",
              "170090450004",
              "RUCHIKA",
              "SURSH KUMAR",
              "869",
              "1200",
              "72.42%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "170090450010",
            "name": "SHEETAL GARG",
            "fatherName": "RAMANAND GARG",
            "obtainedMarks": "894",
            "maxMarks": "1200",
            "percentage": "74.50%",
            "cells": [
              "194",
              "170090450010",
              "SHEETAL GARG",
              "RAMANAND GARG",
              "894",
              "1200",
              "74.50%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "170090450011",
            "name": "SNEHA KARWASRA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "959",
            "maxMarks": "1200",
            "percentage": "79.92%",
            "cells": [
              "195",
              "170090450011",
              "SNEHA KARWASRA",
              "NARESH KUMAR",
              "959",
              "1200",
              "79.92%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "170090450015",
            "name": "SHEELA RANI",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "867",
            "maxMarks": "1200",
            "percentage": "72.25%",
            "cells": [
              "196",
              "170090450015",
              "SHEELA RANI",
              "OM PARKASH",
              "867",
              "1200",
              "72.25%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "170090450018",
            "name": "AARZOO",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "919",
            "maxMarks": "1200",
            "percentage": "76.58%",
            "cells": [
              "197",
              "170090450018",
              "AARZOO",
              "NARESH KUMAR",
              "919",
              "1200",
              "76.58%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "170090450019",
            "name": "PRACHI",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "852",
            "maxMarks": "1200",
            "percentage": "71%",
            "cells": [
              "198",
              "170090450019",
              "PRACHI",
              "PAWAN KUMAR",
              "852",
              "1200",
              "71%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "170090450020",
            "name": "SIMRANJEET KAUR",
            "fatherName": "SUKHWINDER SINGH",
            "obtainedMarks": "854",
            "maxMarks": "1200",
            "percentage": "71.17%",
            "cells": [
              "199",
              "170090450020",
              "SIMRANJEET KAUR",
              "SUKHWINDER SINGH",
              "854",
              "1200",
              "71.17%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "170090450023",
            "name": "KIRAN JANGRA",
            "fatherName": "NIKU RAM",
            "obtainedMarks": "886",
            "maxMarks": "1200",
            "percentage": "73.83%",
            "cells": [
              "200",
              "170090450023",
              "KIRAN JANGRA",
              "NIKU RAM",
              "886",
              "1200",
              "73.83%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "170090450029",
            "name": "PRIYANKA SONI",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "877",
            "maxMarks": "1200",
            "percentage": "73.08%",
            "cells": [
              "201",
              "170090450029",
              "PRIYANKA SONI",
              "SATISH KUMAR",
              "877",
              "1200",
              "73.08%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "170090450030",
            "name": "JYOTSANA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "968",
            "maxMarks": "1200",
            "percentage": "80.67%",
            "cells": [
              "202",
              "170090450030",
              "JYOTSANA",
              "PREM KUMAR",
              "968",
              "1200",
              "80.67%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "170090450033",
            "name": "JITENDER KANG",
            "fatherName": "HARJAP SINGH\nKANG",
            "obtainedMarks": "886",
            "maxMarks": "1200",
            "percentage": "73.83%",
            "cells": [
              "203",
              "170090450033",
              "JITENDER KANG",
              "HARJAP SINGH\nKANG",
              "886",
              "1200",
              "73.83%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "170090450036",
            "name": "PARNEET KAUR",
            "fatherName": "SARABJEET SINGH",
            "obtainedMarks": "898",
            "maxMarks": "1200",
            "percentage": "74.83%",
            "cells": [
              "204",
              "170090450036",
              "PARNEET KAUR",
              "SARABJEET SINGH",
              "898",
              "1200",
              "74.83%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "170090450037",
            "name": "AMANPREET KAUR",
            "fatherName": "CHANDI RAM",
            "obtainedMarks": "903",
            "maxMarks": "1200",
            "percentage": "75.25%",
            "cells": [
              "205",
              "170090450037",
              "AMANPREET KAUR",
              "CHANDI RAM",
              "903",
              "1200",
              "75.25%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "170090450043",
            "name": "PAYAL RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "868",
            "maxMarks": "1200",
            "percentage": "72.33%",
            "cells": [
              "206",
              "170090450043",
              "PAYAL RANI",
              "MADAN LAL",
              "868",
              "1200",
              "72.33%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "170090450046",
            "name": "SANJU KUMARI",
            "fatherName": "VASUDEV YADAV",
            "obtainedMarks": "845",
            "maxMarks": "1200",
            "percentage": "70.42%",
            "cells": [
              "207",
              "170090450046",
              "SANJU KUMARI",
              "VASUDEV YADAV",
              "845",
              "1200",
              "70.42%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "170090450048",
            "name": "KHUSHBOO",
            "fatherName": "NARESH",
            "obtainedMarks": "992",
            "maxMarks": "1200",
            "percentage": "82.67%",
            "cells": [
              "208",
              "170090450048",
              "KHUSHBOO",
              "NARESH",
              "992",
              "1200",
              "82.67%"
            ]
          }
        ]
      },
      {
        "courseName": "DPEd I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "209",
            "rollNo": "190090640001",
            "name": "AARTY DEVI",
            "fatherName": "SATPAL",
            "obtainedMarks": "1132",
            "maxMarks": "1500",
            "percentage": "75.47%",
            "cells": [
              "209",
              "190090640001",
              "AARTY DEVI",
              "SATPAL",
              "1132",
              "1500",
              "75.47%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "190090640002",
            "name": "BIJO DEVI",
            "fatherName": "BALWAAN",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "210",
              "190090640002",
              "BIJO DEVI",
              "BALWAAN",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "211",
            "rollNo": "190090640003",
            "name": "MAMTA",
            "fatherName": "GHEERU RAM",
            "obtainedMarks": "1117",
            "maxMarks": "1500",
            "percentage": "74.47%",
            "cells": [
              "211",
              "190090640003",
              "MAMTA",
              "GHEERU RAM",
              "1117",
              "1500",
              "74.47%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "190090640004",
            "name": "MAMTA",
            "fatherName": "LUXMAN DASS",
            "obtainedMarks": "1177",
            "maxMarks": "1500",
            "percentage": "78.47%",
            "cells": [
              "212",
              "190090640004",
              "MAMTA",
              "LUXMAN DASS",
              "1177",
              "1500",
              "78.47%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "190090640005",
            "name": "MANJEET KAUR",
            "fatherName": "PARGAT SINGH",
            "obtainedMarks": "1174",
            "maxMarks": "1500",
            "percentage": "78.27%",
            "cells": [
              "213",
              "190090640005",
              "MANJEET KAUR",
              "PARGAT SINGH",
              "1174",
              "1500",
              "78.27%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "190090640008",
            "name": "POOJA",
            "fatherName": "PRITAM SINGH",
            "obtainedMarks": "1090",
            "maxMarks": "1500",
            "percentage": "72.67%",
            "cells": [
              "214",
              "190090640008",
              "POOJA",
              "PRITAM SINGH",
              "1090",
              "1500",
              "72.67%"
            ]
          },
          {
            "sNo": "215",
            "rollNo": "190090640009",
            "name": "PRAVINA",
            "fatherName": "JAFAR KHAAN",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "215",
              "190090640009",
              "PRAVINA",
              "JAFAR KHAAN",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "190090640010",
            "name": "PRERNA",
            "fatherName": "ROHTASH",
            "obtainedMarks": "1070",
            "maxMarks": "1500",
            "percentage": "71.33%",
            "cells": [
              "216",
              "190090640010",
              "PRERNA",
              "ROHTASH",
              "1070",
              "1500",
              "71.33%"
            ]
          },
          {
            "sNo": "217",
            "rollNo": "190090640011",
            "name": "PRIYANKA",
            "fatherName": "UDAY SINGH",
            "obtainedMarks": "1081",
            "maxMarks": "1500",
            "percentage": "72.07%",
            "cells": [
              "217",
              "190090640011",
              "PRIYANKA",
              "UDAY SINGH",
              "1081",
              "1500",
              "72.07%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "190090640014",
            "name": "SUDESH",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "1139",
            "maxMarks": "1500",
            "percentage": "75.93%",
            "cells": [
              "218",
              "190090640014",
              "SUDESH",
              "DHARMPAL",
              "1139",
              "1500",
              "75.93%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A English I +II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A English III +IV Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.sc I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "190090140006",
            "name": "POONAM",
            "fatherName": "SUBASH CHANDER",
            "obtainedMarks": "1015",
            "maxMarks": "1400",
            "percentage": "72.50%",
            "cells": [
              "1",
              "190090140006",
              "POONAM",
              "SUBASH CHANDER",
              "1015",
              "1400",
              "72.50%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "190090140009",
            "name": "PRIYANKA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1044",
            "maxMarks": "1400",
            "percentage": "74.57%",
            "cells": [
              "2",
              "190090140009",
              "PRIYANKA",
              "MAHENDER SINGH",
              "1044",
              "1400",
              "74.57%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "190090140011",
            "name": "RITU",
            "fatherName": "BALWINDER SINGH",
            "obtainedMarks": "1061",
            "maxMarks": "1400",
            "percentage": "75.79%",
            "cells": [
              "3",
              "190090140011",
              "RITU",
              "BALWINDER SINGH",
              "1061",
              "1400",
              "75.79%"
            ]
          }
        ]
      },
      {
        "courseName": "M.sc III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "4",
            "rollNo": "180090140002",
            "name": "POOJA MONGA",
            "fatherName": "PREM MONGA",
            "obtainedMarks": "876",
            "maxMarks": "1200",
            "percentage": "73%",
            "cells": [
              "4",
              "180090140002",
              "POOJA MONGA",
              "PREM MONGA",
              "876",
              "1200",
              "73%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "180090140004",
            "name": "PRIYA MONGA",
            "fatherName": "PREM PARKASH",
            "obtainedMarks": "927",
            "maxMarks": "1200",
            "percentage": "77.25%",
            "cells": [
              "5",
              "180090140004",
              "PRIYA MONGA",
              "PREM PARKASH",
              "927",
              "1200",
              "77.25%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "180090140007",
            "name": "TANNU MONGA",
            "fatherName": "RAJ KUMAR MONGA",
            "obtainedMarks": "852",
            "maxMarks": "1200",
            "percentage": "71%",
            "cells": [
              "6",
              "180090140007",
              "TANNU MONGA",
              "RAJ KUMAR MONGA",
              "852",
              "1200",
              "71%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "180090140009",
            "name": "JYOTI",
            "fatherName": "NIHAL SINGH",
            "obtainedMarks": "849",
            "maxMarks": "1200",
            "percentage": "70.75%",
            "cells": [
              "7",
              "180090140009",
              "JYOTI",
              "NIHAL SINGH",
              "849",
              "1200",
              "70.75%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "180090140015",
            "name": "SANDHYA",
            "fatherName": "JAGAT PAL",
            "obtainedMarks": "880",
            "maxMarks": "1200",
            "percentage": "73.33%",
            "cells": [
              "8",
              "180090140015",
              "SANDHYA",
              "JAGAT PAL",
              "880",
              "1200",
              "73.33%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm. I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "9",
            "rollNo": "190090260001",
            "name": "ANU RANI",
            "fatherName": "KRISHAN LAL",
            "obtainedMarks": "1012",
            "maxMarks": "1400",
            "percentage": "72.29%",
            "cells": [
              "9",
              "190090260001",
              "ANU RANI",
              "KRISHAN LAL",
              "1012",
              "1400",
              "72.29%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "190090260008",
            "name": "REKHA RANI",
            "fatherName": "GIRDAHRI LAL",
            "obtainedMarks": "990",
            "maxMarks": "1400",
            "percentage": "70.71%",
            "cells": [
              "10",
              "190090260008",
              "REKHA RANI",
              "GIRDAHRI LAL",
              "990",
              "1400",
              "70.71%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "190090260011",
            "name": "SANJU",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "1050",
            "maxMarks": "1400",
            "percentage": "75%",
            "cells": [
              "11",
              "190090260011",
              "SANJU",
              "RAM NIWAS",
              "1050",
              "1400",
              "75%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "190090260012",
            "name": "SUNITA DEVI",
            "fatherName": "MANGE RAM",
            "obtainedMarks": "1059",
            "maxMarks": "1400",
            "percentage": "75.64%",
            "cells": [
              "12",
              "190090260012",
              "SUNITA DEVI",
              "MANGE RAM",
              "1059",
              "1400",
              "75.64%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm. III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "13",
            "rollNo": "180090260001",
            "name": "RAM,AN",
            "fatherName": "ISHWER SINGH",
            "obtainedMarks": "889",
            "maxMarks": "1200",
            "percentage": "74.08%",
            "cells": [
              "13",
              "180090260001",
              "RAM,AN",
              "ISHWER SINGH",
              "889",
              "1200",
              "74.08%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "180090260002",
            "name": "KAVITA",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "844",
            "maxMarks": "1200",
            "percentage": "70.33%",
            "cells": [
              "14",
              "180090260002",
              "KAVITA",
              "AMAR SINGH",
              "844",
              "1200",
              "70.33%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "180090260004",
            "name": "GEETA RANI",
            "fatherName": "HARI CHAND",
            "obtainedMarks": "885",
            "maxMarks": "1200",
            "percentage": "73.75%",
            "cells": [
              "15",
              "180090260004",
              "GEETA RANI",
              "HARI CHAND",
              "885",
              "1200",
              "73.75%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "180090260012",
            "name": "MEERA DEVI",
            "fatherName": "CHHOTU RAM",
            "obtainedMarks": "849",
            "maxMarks": "1200",
            "percentage": "70.75%",
            "cells": [
              "16",
              "180090260012",
              "MEERA DEVI",
              "CHHOTU RAM",
              "849",
              "1200",
              "70.75%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "180090260015",
            "name": "GUNITA",
            "fatherName": "JAI KISHAN",
            "obtainedMarks": "871",
            "maxMarks": "1200",
            "percentage": "72.58%",
            "cells": [
              "17",
              "180090260015",
              "GUNITA",
              "JAI KISHAN",
              "871",
              "1200",
              "72.58%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "18",
            "rollNo": "190090240002",
            "name": "BALJEET KAUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "1031",
            "maxMarks": "1400",
            "percentage": "73.64%",
            "cells": [
              "18",
              "190090240002",
              "BALJEET KAUR",
              "GURMAIL SINGH",
              "1031",
              "1400",
              "73.64%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "190090240003",
            "name": "GURJOT",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "1059",
            "maxMarks": "1400",
            "percentage": "75.64%",
            "cells": [
              "19",
              "190090240003",
              "GURJOT",
              "SUKHDEV SINGH",
              "1059",
              "1400",
              "75.64%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "190090240004",
            "name": "GURWINDER KAUR",
            "fatherName": "HARBAHJAN SINGH",
            "obtainedMarks": "1062",
            "maxMarks": "1400",
            "percentage": "75.86%",
            "cells": [
              "20",
              "190090240004",
              "GURWINDER KAUR",
              "HARBAHJAN SINGH",
              "1062",
              "1400",
              "75.86%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "190090240005",
            "name": "HINA",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "1027",
            "maxMarks": "1400",
            "percentage": "73.36%",
            "cells": [
              "21",
              "190090240005",
              "HINA",
              "SURINDER KUMAR",
              "1027",
              "1400",
              "73.36%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "190090240007",
            "name": "ISHU",
            "fatherName": "RAJENDER",
            "obtainedMarks": "1030",
            "maxMarks": "1400",
            "percentage": "73.57%",
            "cells": [
              "22",
              "190090240007",
              "ISHU",
              "RAJENDER",
              "1030",
              "1400",
              "73.57%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "190090240009",
            "name": "JASPREET KAUR",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "1035",
            "maxMarks": "1400",
            "percentage": "73.93%",
            "cells": [
              "23",
              "190090240009",
              "JASPREET KAUR",
              "HARI SINGH",
              "1035",
              "1400",
              "73.93%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "190090240011",
            "name": "MANJU",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "1001",
            "maxMarks": "1400",
            "percentage": "71.50%",
            "cells": [
              "24",
              "190090240011",
              "MANJU",
              "RAM SINGH",
              "1001",
              "1400",
              "71.50%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "190090240012",
            "name": "MONIKA ARORA",
            "fatherName": "SHAM LAL ARORA",
            "obtainedMarks": "1047",
            "maxMarks": "1400",
            "percentage": "74.79%",
            "cells": [
              "25",
              "190090240012",
              "MONIKA ARORA",
              "SHAM LAL ARORA",
              "1047",
              "1400",
              "74.79%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "190090240013",
            "name": "NANCY GARG",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "1117",
            "maxMarks": "1400",
            "percentage": "79.79%",
            "cells": [
              "26",
              "190090240013",
              "NANCY GARG",
              "NARESH KUMAR",
              "1117",
              "1400",
              "79.79%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "190090240017",
            "name": "SHIVANI",
            "fatherName": "SURINDER",
            "obtainedMarks": "1006",
            "maxMarks": "1400",
            "percentage": "71.86%",
            "cells": [
              "27",
              "190090240017",
              "SHIVANI",
              "SURINDER",
              "1006",
              "1400",
              "71.86%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "190090240019",
            "name": "SIMARJEET KAUR",
            "fatherName": "AMRIK SINGH",
            "obtainedMarks": "995",
            "maxMarks": "1400",
            "percentage": "71.07%",
            "cells": [
              "28",
              "190090240019",
              "SIMARJEET KAUR",
              "AMRIK SINGH",
              "995",
              "1400",
              "71.07%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "29",
            "rollNo": "180090240001",
            "name": "KOMAL RANI",
            "fatherName": "MOHAN KUMAR",
            "obtainedMarks": "950",
            "maxMarks": "1350",
            "percentage": "70.37%",
            "cells": [
              "29",
              "180090240001",
              "KOMAL RANI",
              "MOHAN KUMAR",
              "950",
              "1350",
              "70.37%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "180090240003",
            "name": "RUPA",
            "fatherName": "SOHAN PAL",
            "obtainedMarks": "963",
            "maxMarks": "1350",
            "percentage": "71.33%",
            "cells": [
              "30",
              "180090240003",
              "RUPA",
              "SOHAN PAL",
              "963",
              "1350",
              "71.33%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "180090240006",
            "name": "POOJA RANI",
            "fatherName": "VED PRAKASH",
            "obtainedMarks": "955",
            "maxMarks": "1350",
            "percentage": "70.74%",
            "cells": [
              "31",
              "180090240006",
              "POOJA RANI",
              "VED PRAKASH",
              "955",
              "1350",
              "70.74%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "180090240009",
            "name": "AANCHAL RANI",
            "fatherName": "RAMESH LAL",
            "obtainedMarks": "959",
            "maxMarks": "1350",
            "percentage": "71.04%",
            "cells": [
              "32",
              "180090240009",
              "AANCHAL RANI",
              "RAMESH LAL",
              "959",
              "1350",
              "71.04%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "180090240013",
            "name": "RITIKA SONI",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "962",
            "maxMarks": "1350",
            "percentage": "71.26%",
            "cells": [
              "33",
              "180090240013",
              "RITIKA SONI",
              "SANJAY KUMAR",
              "962",
              "1350",
              "71.26%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "180090240018",
            "name": "MEENA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "971",
            "maxMarks": "1350",
            "percentage": "71.93%",
            "cells": [
              "34",
              "180090240018",
              "MEENA",
              "SURESH KUMAR",
              "971",
              "1350",
              "71.93%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "180090240021",
            "name": "JYOTI",
            "fatherName": "SHAM LAL",
            "obtainedMarks": "952",
            "maxMarks": "1350",
            "percentage": "70.52%",
            "cells": [
              "35",
              "180090240021",
              "JYOTI",
              "SHAM LAL",
              "952",
              "1350",
              "70.52%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "180090240022",
            "name": "SONAL",
            "fatherName": "KEDAR NATH ARORA",
            "obtainedMarks": "1004",
            "maxMarks": "1350",
            "percentage": "74.37%",
            "cells": [
              "36",
              "180090240022",
              "SONAL",
              "KEDAR NATH ARORA",
              "1004",
              "1350",
              "74.37%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "180090240024",
            "name": "RITU",
            "fatherName": "RAMPHAL YADAV",
            "obtainedMarks": "959",
            "maxMarks": "1350",
            "percentage": "71.04%",
            "cells": [
              "37",
              "180090240024",
              "RITU",
              "RAMPHAL YADAV",
              "959",
              "1350",
              "71.04%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "180090240026",
            "name": "MONIKA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "966",
            "maxMarks": "1350",
            "percentage": "71.56%",
            "cells": [
              "38",
              "180090240026",
              "MONIKA",
              "RAJ KUMAR",
              "966",
              "1350",
              "71.56%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "180090240028",
            "name": "RAJNI",
            "fatherName": "KEWAL KRISHAN",
            "obtainedMarks": "991",
            "maxMarks": "1350",
            "percentage": "73.41%",
            "cells": [
              "39",
              "180090240028",
              "RAJNI",
              "KEWAL KRISHAN",
              "991",
              "1350",
              "73.41%"
            ]
          }
        ]
      },
      {
        "courseName": "BPEd I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "40",
            "rollNo": "190090510002",
            "name": "ANITA",
            "fatherName": "MANI RAM",
            "obtainedMarks": "1188",
            "maxMarks": "1600",
            "percentage": "74.25%",
            "cells": [
              "40",
              "190090510002",
              "ANITA",
              "MANI RAM",
              "1188",
              "1600",
              "74.25%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "190090510003",
            "name": "ANU RANI",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "1252",
            "maxMarks": "1600",
            "percentage": "78.25%",
            "cells": [
              "41",
              "190090510003",
              "ANU RANI",
              "VED PARKASH",
              "1252",
              "1600",
              "78.25%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "190090510005",
            "name": "MAMTA",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "42",
              "190090510005",
              "MAMTA",
              "SAHAB RAM",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "190090510006",
            "name": "MANJU KUMARI",
            "fatherName": "SUBASH",
            "obtainedMarks": "1216",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "43",
              "190090510006",
              "MANJU KUMARI",
              "SUBASH",
              "1216",
              "1600",
              "76%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "190090510007",
            "name": "MITU BALA",
            "fatherName": "DEVI LAL BHADU",
            "obtainedMarks": "1207",
            "maxMarks": "1600",
            "percentage": "75.44%",
            "cells": [
              "44",
              "190090510007",
              "MITU BALA",
              "DEVI LAL BHADU",
              "1207",
              "1600",
              "75.44%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "190090510008",
            "name": "PARDEEP",
            "fatherName": "BALDEV SINGH",
            "obtainedMarks": "1291",
            "maxMarks": "1600",
            "percentage": "80.69%",
            "cells": [
              "45",
              "190090510008",
              "PARDEEP",
              "BALDEV SINGH",
              "1291",
              "1600",
              "80.69%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "190090510009",
            "name": "POOJA",
            "fatherName": "BHARAT PACHAR",
            "obtainedMarks": "1261",
            "maxMarks": "1600",
            "percentage": "78.81%",
            "cells": [
              "46",
              "190090510009",
              "POOJA",
              "BHARAT PACHAR",
              "1261",
              "1600",
              "78.81%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "190090510010",
            "name": "POOJA BENIWAL",
            "fatherName": "VINOD BENIWAL",
            "obtainedMarks": "1178",
            "maxMarks": "1600",
            "percentage": "73.62%",
            "cells": [
              "47",
              "190090510010",
              "POOJA BENIWAL",
              "VINOD BENIWAL",
              "1178",
              "1600",
              "73.62%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "190090510011",
            "name": "POOJA PANDEY",
            "fatherName": "UMA SHANKAR PANDEY",
            "obtainedMarks": "1275",
            "maxMarks": "1600",
            "percentage": "79.69%",
            "cells": [
              "48",
              "190090510011",
              "POOJA PANDEY",
              "UMA SHANKAR PANDEY",
              "1275",
              "1600",
              "79.69%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "190090510013",
            "name": "PROMILA DEVI",
            "fatherName": "RAI SAHAB",
            "obtainedMarks": "1212",
            "maxMarks": "1600",
            "percentage": "75.75%",
            "cells": [
              "49",
              "190090510013",
              "PROMILA DEVI",
              "RAI SAHAB",
              "1212",
              "1600",
              "75.75%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "190090510014",
            "name": "RIYA SAIN",
            "fatherName": "PURAN CHAND",
            "obtainedMarks": "1142",
            "maxMarks": "1600",
            "percentage": "71.38%",
            "cells": [
              "50",
              "190090510014",
              "RIYA SAIN",
              "PURAN CHAND",
              "1142",
              "1600",
              "71.38%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "190090510015",
            "name": "SAPNA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "1122",
            "maxMarks": "1600",
            "percentage": "70.12%",
            "cells": [
              "51",
              "190090510015",
              "SAPNA",
              "SURENDER KUMAR",
              "1122",
              "1600",
              "70.12%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "190090510016",
            "name": "SARITA RANI",
            "fatherName": "ROSHAN LAL",
            "obtainedMarks": "1178",
            "maxMarks": "1600",
            "percentage": "73.62%",
            "cells": [
              "52",
              "190090510016",
              "SARITA RANI",
              "ROSHAN LAL",
              "1178",
              "1600",
              "73.62%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "190090510017",
            "name": "SAROJ BALA",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "1308",
            "maxMarks": "1600",
            "percentage": "81.75%",
            "cells": [
              "53",
              "190090510017",
              "SAROJ BALA",
              "HARI SINGH",
              "1308",
              "1600",
              "81.75%"
            ]
          }
        ]
      },
      {
        "courseName": "BPEd III +IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "54",
            "rollNo": "180090510001",
            "name": "MANJEET KAUR",
            "fatherName": "GURNAM SINGH",
            "obtainedMarks": "1158",
            "maxMarks": "1600",
            "percentage": "72.38%",
            "cells": [
              "54",
              "180090510001",
              "MANJEET KAUR",
              "GURNAM SINGH",
              "1158",
              "1600",
              "72.38%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "180090510002",
            "name": "PALLVI",
            "fatherName": "RAM PARTAP SINGH",
            "obtainedMarks": "1184",
            "maxMarks": "1600",
            "percentage": "74%",
            "cells": [
              "55",
              "180090510002",
              "PALLVI",
              "RAM PARTAP SINGH",
              "1184",
              "1600",
              "74%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "180090510003",
            "name": "KIRAN",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "1176",
            "maxMarks": "1600",
            "percentage": "73.50%",
            "cells": [
              "56",
              "180090510003",
              "KIRAN",
              "RAI SINGH",
              "1176",
              "1600",
              "73.50%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "180090510006",
            "name": "MANOJ",
            "fatherName": "SATPAL",
            "obtainedMarks": "1171",
            "maxMarks": "1600",
            "percentage": "73.19%",
            "cells": [
              "57",
              "180090510006",
              "MANOJ",
              "SATPAL",
              "1171",
              "1600",
              "73.19%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "180090510009",
            "name": "PREETI",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "1331",
            "maxMarks": "1600",
            "percentage": "83.19%",
            "cells": [
              "58",
              "180090510009",
              "PREETI",
              "DHARMPAL",
              "1331",
              "1600",
              "83.19%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2020-21",
    "courses": [
      {
        "courseName": "B.A I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "2009043006",
            "name": "ANKITA",
            "fatherName": "DRIYA SINGH",
            "obtainedMarks": "739",
            "maxMarks": "975",
            "percentage": "75.79%",
            "cells": [
              "1",
              "2009043006",
              "ANKITA",
              "DRIYA SINGH",
              "739",
              "975",
              "75.79%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "2009043010",
            "name": "ANU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "718",
            "maxMarks": "975",
            "percentage": "73.64%",
            "cells": [
              "2",
              "2009043010",
              "ANU",
              "PAWAN KUMAR",
              "718",
              "975",
              "73.64%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "2009043014",
            "name": "BALDEEP KAUR",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "766",
            "maxMarks": "975",
            "percentage": "78.56%",
            "cells": [
              "3",
              "2009043014",
              "BALDEEP KAUR",
              "HARI SINGH",
              "766",
              "975",
              "78.56%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "2009043020",
            "name": "CHETNA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "687",
            "maxMarks": "975",
            "percentage": "70.46%",
            "cells": [
              "4",
              "2009043020",
              "CHETNA",
              "SHAMSHER SINGH",
              "687",
              "975",
              "70.46%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "2009043024",
            "name": "EKTA",
            "fatherName": "PALVINDER",
            "obtainedMarks": "772",
            "maxMarks": "975",
            "percentage": "79.18%",
            "cells": [
              "5",
              "2009043024",
              "EKTA",
              "PALVINDER",
              "772",
              "975",
              "79.18%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "2009043025",
            "name": "ESHA CHOUDHARY",
            "fatherName": "DEEPAK KUMAR",
            "obtainedMarks": "685",
            "maxMarks": "975",
            "percentage": "70.26%",
            "cells": [
              "6",
              "2009043025",
              "ESHA CHOUDHARY",
              "DEEPAK KUMAR",
              "685",
              "975",
              "70.26%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "2009043031",
            "name": "HIMANSHU",
            "fatherName": "RADHE SHYAM",
            "obtainedMarks": "777",
            "maxMarks": "975",
            "percentage": "79.69%",
            "cells": [
              "7",
              "2009043031",
              "HIMANSHU",
              "RADHE SHYAM",
              "777",
              "975",
              "79.69%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "2009043033",
            "name": "JASPREET KAUR",
            "fatherName": "KRISHAN SINGH",
            "obtainedMarks": "692",
            "maxMarks": "975",
            "percentage": "70.97%",
            "cells": [
              "8",
              "2009043033",
              "JASPREET KAUR",
              "KRISHAN SINGH",
              "692",
              "975",
              "70.97%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "2009043035",
            "name": "JAYA",
            "fatherName": "JAGATPAL",
            "obtainedMarks": "733",
            "maxMarks": "975",
            "percentage": "75.18%",
            "cells": [
              "9",
              "2009043035",
              "JAYA",
              "JAGATPAL",
              "733",
              "975",
              "75.18%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "2009043036",
            "name": "JIGYASHA",
            "fatherName": "RAJNEESH KUMAR",
            "obtainedMarks": "778",
            "maxMarks": "975",
            "percentage": "79.79%",
            "cells": [
              "10",
              "2009043036",
              "JIGYASHA",
              "RAJNEESH KUMAR",
              "778",
              "975",
              "79.79%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "2009043038",
            "name": "JYOTI",
            "fatherName": "PRAHLAD",
            "obtainedMarks": "699",
            "maxMarks": "975",
            "percentage": "71.69%",
            "cells": [
              "11",
              "2009043038",
              "JYOTI",
              "PRAHLAD",
              "699",
              "975",
              "71.69%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "2009043040",
            "name": "KALPANA RANI",
            "fatherName": "RAJPAL",
            "obtainedMarks": "704",
            "maxMarks": "975",
            "percentage": "72.21%",
            "cells": [
              "12",
              "2009043040",
              "KALPANA RANI",
              "RAJPAL",
              "704",
              "975",
              "72.21%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "2009043042",
            "name": "KASHISH",
            "fatherName": "BHAJAN LAL",
            "obtainedMarks": "735",
            "maxMarks": "975",
            "percentage": "75.38%",
            "cells": [
              "13",
              "2009043042",
              "KASHISH",
              "BHAJAN LAL",
              "735",
              "975",
              "75.38%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "2009043049",
            "name": "KHUSHMAN",
            "fatherName": "PARAMPAL SINGH",
            "obtainedMarks": "694",
            "maxMarks": "975",
            "percentage": "71.18%",
            "cells": [
              "14",
              "2009043049",
              "KHUSHMAN",
              "PARAMPAL SINGH",
              "694",
              "975",
              "71.18%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "2009043058",
            "name": "LAXMI DEVI",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "714",
            "maxMarks": "975",
            "percentage": "73.23%",
            "cells": [
              "15",
              "2009043058",
              "LAXMI DEVI",
              "MAHENDER SINGH",
              "714",
              "975",
              "73.23%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "2009043062",
            "name": "MAMTA INSA",
            "fatherName": "SHIV DUTT INSA",
            "obtainedMarks": "711",
            "maxMarks": "975",
            "percentage": "72.92%",
            "cells": [
              "16",
              "2009043062",
              "MAMTA INSA",
              "SHIV DUTT INSA",
              "711",
              "975",
              "72.92%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "2009043065",
            "name": "MANISHA KAMBOJ",
            "fatherName": "SATNAM KAMBOJ",
            "obtainedMarks": "747",
            "maxMarks": "975",
            "percentage": "76.62%",
            "cells": [
              "17",
              "2009043065",
              "MANISHA KAMBOJ",
              "SATNAM KAMBOJ",
              "747",
              "975",
              "76.62%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "2009043071",
            "name": "MINAL",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "726",
            "maxMarks": "975",
            "percentage": "74.46%",
            "cells": [
              "18",
              "2009043071",
              "MINAL",
              "VED PARKASH",
              "726",
              "975",
              "74.46%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "2009043072",
            "name": "MONIKA",
            "fatherName": "DHARM SINGH",
            "obtainedMarks": "786",
            "maxMarks": "975",
            "percentage": "80.62%",
            "cells": [
              "19",
              "2009043072",
              "MONIKA",
              "DHARM SINGH",
              "786",
              "975",
              "80.62%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "2009043093",
            "name": "POOJA",
            "fatherName": "SUSHIL",
            "obtainedMarks": "717",
            "maxMarks": "975",
            "percentage": "73.54%",
            "cells": [
              "20",
              "2009043093",
              "POOJA",
              "SUSHIL",
              "717",
              "975",
              "73.54%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "2009043104",
            "name": "PRIYANKA",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "719",
            "maxMarks": "975",
            "percentage": "73.74%",
            "cells": [
              "21",
              "2009043104",
              "PRIYANKA",
              "DEVI LAL",
              "719",
              "975",
              "73.74%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "2009043113",
            "name": "RASHI KUMARI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "709",
            "maxMarks": "975",
            "percentage": "72.72%",
            "cells": [
              "22",
              "2009043113",
              "RASHI KUMARI",
              "SURENDER KUMAR",
              "709",
              "975",
              "72.72%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "2009043115",
            "name": "REKHA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "698",
            "maxMarks": "975",
            "percentage": "71.59%",
            "cells": [
              "23",
              "2009043115",
              "REKHA",
              "MOHAN LAL",
              "698",
              "975",
              "71.59%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "2009043118",
            "name": "RENU",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "684",
            "maxMarks": "975",
            "percentage": "70.15%",
            "cells": [
              "24",
              "2009043118",
              "RENU",
              "DEVI LAL",
              "684",
              "975",
              "70.15%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "2009043125",
            "name": "RITU BALA",
            "fatherName": "VEDPAL",
            "obtainedMarks": "688",
            "maxMarks": "975",
            "percentage": "70.56%",
            "cells": [
              "25",
              "2009043125",
              "RITU BALA",
              "VEDPAL",
              "688",
              "975",
              "70.56%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "2009043126",
            "name": "RUPINDER KAUR",
            "fatherName": "GURNAM SINGH",
            "obtainedMarks": "784",
            "maxMarks": "975",
            "percentage": "80.41%",
            "cells": [
              "26",
              "2009043126",
              "RUPINDER KAUR",
              "GURNAM SINGH",
              "784",
              "975",
              "80.41%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "2009043127",
            "name": "SAMESTA DEVI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "707",
            "maxMarks": "975",
            "percentage": "72.51%",
            "cells": [
              "27",
              "2009043127",
              "SAMESTA DEVI",
              "VINOD KUMAR",
              "707",
              "975",
              "72.51%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "2009043128",
            "name": "SANDEEP KAUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "713",
            "maxMarks": "975",
            "percentage": "73.13%",
            "cells": [
              "28",
              "2009043128",
              "SANDEEP KAUR",
              "GURMAIL SINGH",
              "713",
              "975",
              "73.13%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "2009043133",
            "name": "SAPNA KUMARI",
            "fatherName": "KEHAR SINGH",
            "obtainedMarks": "714",
            "maxMarks": "975",
            "percentage": "73.23%",
            "cells": [
              "29",
              "2009043133",
              "SAPNA KUMARI",
              "KEHAR SINGH",
              "714",
              "975",
              "73.23%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "2009043136",
            "name": "SARVMISHTHA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "763",
            "maxMarks": "975",
            "percentage": "78.26%",
            "cells": [
              "30",
              "2009043136",
              "SARVMISHTHA",
              "KRISHAN KUMAR",
              "763",
              "975",
              "78.26%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "2009043139",
            "name": "SHABNAM",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "720",
            "maxMarks": "975",
            "percentage": "73.85%",
            "cells": [
              "31",
              "2009043139",
              "SHABNAM",
              "PREM KUMAR",
              "720",
              "975",
              "73.85%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "2009043141",
            "name": "SHILPA",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "717",
            "maxMarks": "975",
            "percentage": "73.54%",
            "cells": [
              "32",
              "2009043141",
              "SHILPA",
              "PAWAN KUMAR",
              "717",
              "975",
              "73.54%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "2009043146",
            "name": "SIMRAN",
            "fatherName": "SURESH",
            "obtainedMarks": "733",
            "maxMarks": "975",
            "percentage": "75.18%",
            "cells": [
              "33",
              "2009043146",
              "SIMRAN",
              "SURESH",
              "733",
              "975",
              "75.18%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "2009043161",
            "name": "TAMANNA",
            "fatherName": "BALJIT SINGH",
            "obtainedMarks": "765",
            "maxMarks": "975",
            "percentage": "78.46%",
            "cells": [
              "34",
              "2009043161",
              "TAMANNA",
              "BALJIT SINGH",
              "765",
              "975",
              "78.46%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "35",
            "rollNo": "190090430005",
            "name": "Anjani",
            "fatherName": "Norang",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "35",
              "190090430005",
              "Anjani",
              "Norang",
              "631",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "190090430006",
            "name": "Annu",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "36",
              "190090430006",
              "Annu",
              "Suresh Kumar",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "190090430010",
            "name": "Aarzoo kamboj",
            "fatherName": "Harbans Lal",
            "obtainedMarks": "697",
            "maxMarks": "900",
            "percentage": "77.44%",
            "cells": [
              "37",
              "190090430010",
              "Aarzoo kamboj",
              "Harbans Lal",
              "697",
              "900",
              "77.44%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "190090430012",
            "name": "Asha Rani",
            "fatherName": "dalel",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.77%",
            "cells": [
              "38",
              "190090430012",
              "Asha Rani",
              "dalel",
              "646",
              "900",
              "71.77%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "190090430018",
            "name": "Garima Rani",
            "fatherName": "Surendra Kumar",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "72.88%",
            "cells": [
              "39",
              "190090430018",
              "Garima Rani",
              "Surendra Kumar",
              "659",
              "900",
              "72.88%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "190090430018.66699",
            "name": "Gurpreet",
            "fatherName": "Devi pal",
            "obtainedMarks": "690",
            "maxMarks": "900",
            "percentage": "76.66%",
            "cells": [
              "40",
              "190090430018.66699",
              "Gurpreet",
              "Devi pal",
              "690",
              "900",
              "76.66%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "190090430020",
            "name": "Harpreet kaur",
            "fatherName": "Guru Charan Singh",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.40%",
            "cells": [
              "41",
              "190090430020",
              "Harpreet kaur",
              "Guru Charan Singh",
              "670",
              "900",
              "74.40%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "190090430024.095",
            "name": "kavita",
            "fatherName": "Subhash Chandra",
            "obtainedMarks": "697",
            "maxMarks": "900",
            "percentage": "77.44%",
            "cells": [
              "42",
              "190090430024.095",
              "kavita",
              "Subhash Chandra",
              "697",
              "900",
              "77.44%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "190090430026.81",
            "name": "Kavita Rani",
            "fatherName": "Ram Prakash",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "43",
              "190090430026.81",
              "Kavita Rani",
              "Ram Prakash",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "190090430031",
            "name": "Kiran",
            "fatherName": "Ram Singh",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "44",
              "190090430031",
              "Kiran",
              "Ram Singh",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "190090430032.23801",
            "name": "Komal Rani",
            "fatherName": "Rajbir",
            "obtainedMarks": "713",
            "maxMarks": "900",
            "percentage": "79.22%",
            "cells": [
              "45",
              "190090430032.23801",
              "Komal Rani",
              "Rajbir",
              "713",
              "900",
              "79.22%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "190090430030",
            "name": "kiran",
            "fatherName": "Shah. Ram",
            "obtainedMarks": "752",
            "maxMarks": "900",
            "percentage": "83.55%",
            "cells": [
              "46",
              "190090430030",
              "kiran",
              "Shah. Ram",
              "752",
              "900",
              "83.55%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "190090430009",
            "name": "Arshdeep kaur",
            "fatherName": "kirpal Singh",
            "obtainedMarks": "722",
            "maxMarks": "900",
            "percentage": "80.22%",
            "cells": [
              "47",
              "190090430009",
              "Arshdeep kaur",
              "kirpal Singh",
              "722",
              "900",
              "80.22%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "190090430035",
            "name": "Lalita",
            "fatherName": "sugreem chand",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "48",
              "190090430035",
              "Lalita",
              "sugreem chand",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "190090430037",
            "name": "Mamta",
            "fatherName": "Ram chander",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "49",
              "190090430037",
              "Mamta",
              "Ram chander",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "190090430038",
            "name": "Manisha",
            "fatherName": "Rajesh",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "50",
              "190090430038",
              "Manisha",
              "Rajesh",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "190090430044",
            "name": "Muskan",
            "fatherName": "Manoj kumar",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.77%",
            "cells": [
              "51",
              "190090430044",
              "Muskan",
              "Manoj kumar",
              "700",
              "900",
              "77.77%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "190090430045",
            "name": "Natasha",
            "fatherName": "Mahender",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.77%",
            "cells": [
              "52",
              "190090430045",
              "Natasha",
              "Mahender",
              "700",
              "900",
              "77.77%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "190090430052",
            "name": "Nisha",
            "fatherName": "Dalip singh",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "53",
              "190090430052",
              "Nisha",
              "Dalip singh",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "190090430058",
            "name": "simran",
            "fatherName": "Dharmender",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "54",
              "190090430058",
              "simran",
              "Dharmender",
              "632",
              "900",
              "70.22%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "190090430063",
            "name": "Pooja",
            "fatherName": "Mahender",
            "obtainedMarks": "705",
            "maxMarks": "900",
            "percentage": "78.33%",
            "cells": [
              "55",
              "190090430063",
              "Pooja",
              "Mahender",
              "705",
              "900",
              "78.33%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "190090430064",
            "name": "Pooja",
            "fatherName": "Parmod",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "56",
              "190090430064",
              "Pooja",
              "Parmod",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "190090430064.81",
            "name": "Pooja",
            "fatherName": "subhash",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "57",
              "190090430064.81",
              "Pooja",
              "subhash",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "190090430069",
            "name": "Poonam",
            "fatherName": "subhash",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "58",
              "190090430069",
              "Poonam",
              "subhash",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "190090430070.23801",
            "name": "Pramila",
            "fatherName": "Ravinder",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "59",
              "190090430070.23801",
              "Pramila",
              "Ravinder",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "190090430072",
            "name": "Preetinder",
            "fatherName": "kuldeep",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "60",
              "190090430072",
              "Preetinder",
              "kuldeep",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "190090430073",
            "name": "Pritam",
            "fatherName": "Jagdish",
            "obtainedMarks": "664",
            "maxMarks": "900",
            "percentage": "73.77%",
            "cells": [
              "61",
              "190090430073",
              "Pritam",
              "Jagdish",
              "664",
              "900",
              "73.77%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "190090430081",
            "name": "Rajni kaur",
            "fatherName": "Binder",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "62",
              "190090430081",
              "Rajni kaur",
              "Binder",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "190090430083",
            "name": "Ramneet",
            "fatherName": "Satpal",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "63",
              "190090430083",
              "Ramneet",
              "Satpal",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "190090430086",
            "name": "Renu",
            "fatherName": "Prithvi",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.55%",
            "cells": [
              "64",
              "190090430086",
              "Renu",
              "Prithvi",
              "680",
              "900",
              "75.55%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "190090430087",
            "name": "Renu Bala",
            "fatherName": "Banwari Lal",
            "obtainedMarks": "665",
            "maxMarks": "900",
            "percentage": "73.86%",
            "cells": [
              "65",
              "190090430087",
              "Renu Bala",
              "Banwari Lal",
              "665",
              "900",
              "73.86%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "190090430096",
            "name": "saneha",
            "fatherName": "anil kumar",
            "obtainedMarks": "668",
            "maxMarks": "900",
            "percentage": "74.22%",
            "cells": [
              "66",
              "190090430096",
              "saneha",
              "anil kumar",
              "668",
              "900",
              "74.22%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "190090430097",
            "name": "Sanjana",
            "fatherName": "Rohtash kumar",
            "obtainedMarks": "724",
            "maxMarks": "900",
            "percentage": "80.44%",
            "cells": [
              "67",
              "190090430097",
              "Sanjana",
              "Rohtash kumar",
              "724",
              "900",
              "80.44%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "190090430098",
            "name": "Sanjana",
            "fatherName": "Ram singh",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "68",
              "190090430098",
              "Sanjana",
              "Ram singh",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "190090430103",
            "name": "Shalu Devi",
            "fatherName": "Rajpal",
            "obtainedMarks": "717",
            "maxMarks": "900",
            "percentage": "79.66%",
            "cells": [
              "69",
              "190090430103",
              "Shalu Devi",
              "Rajpal",
              "717",
              "900",
              "79.66%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "190090430106",
            "name": "sheetal",
            "fatherName": "Bhagwan",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "70",
              "190090430106",
              "sheetal",
              "Bhagwan",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "190090430107",
            "name": "Shweta",
            "fatherName": "Ghanshyam",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "71",
              "190090430107",
              "Shweta",
              "Ghanshyam",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "190090430109",
            "name": "simran",
            "fatherName": "surender",
            "obtainedMarks": "725",
            "maxMarks": "900",
            "percentage": "80.55%",
            "cells": [
              "72",
              "190090430109",
              "simran",
              "surender",
              "725",
              "900",
              "80.55%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "190090430110",
            "name": "Simran",
            "fatherName": "kamal Mehta",
            "obtainedMarks": "668",
            "maxMarks": "900",
            "percentage": "74.22%",
            "cells": [
              "73",
              "190090430110",
              "Simran",
              "kamal Mehta",
              "668",
              "900",
              "74.22%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "190090430114",
            "name": "Suman",
            "fatherName": "Satpal",
            "obtainedMarks": "648",
            "maxMarks": "900",
            "percentage": "72%",
            "cells": [
              "74",
              "190090430114",
              "Suman",
              "Satpal",
              "648",
              "900",
              "72%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "190090430124",
            "name": "Sushila",
            "fatherName": "Mohal Lal",
            "obtainedMarks": "725",
            "maxMarks": "900",
            "percentage": "80.55%",
            "cells": [
              "75",
              "190090430124",
              "Sushila",
              "Mohal Lal",
              "725",
              "900",
              "80.55%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "76",
            "rollNo": "18009043004",
            "name": "Karishma",
            "fatherName": "Prithvi Singh",
            "obtainedMarks": "717",
            "maxMarks": "900",
            "percentage": "79.67%",
            "cells": [
              "76",
              "18009043004",
              "Karishma",
              "Prithvi Singh",
              "717",
              "900",
              "79.67%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "18009043011",
            "name": "Payal",
            "fatherName": "Dariya Singh",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.78%",
            "cells": [
              "77",
              "18009043011",
              "Payal",
              "Dariya Singh",
              "700",
              "900",
              "77.78%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "18009043013",
            "name": "Kapisha Poonia",
            "fatherName": "Sanjay Poonia",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "78",
              "18009043013",
              "Kapisha Poonia",
              "Sanjay Poonia",
              "742",
              "900",
              "82.44%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "18009043015",
            "name": "Kiran",
            "fatherName": "Rajender Singh",
            "obtainedMarks": "759",
            "maxMarks": "900",
            "percentage": "84.33%",
            "cells": [
              "79",
              "18009043015",
              "Kiran",
              "Rajender Singh",
              "759",
              "900",
              "84.33%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "18009043016",
            "name": "Anamika",
            "fatherName": "Nachhatar Singh",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "80",
              "18009043016",
              "Anamika",
              "Nachhatar Singh",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "18009043018",
            "name": "Anuja",
            "fatherName": "Vinod",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "81",
              "18009043018",
              "Anuja",
              "Vinod",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "18009043021",
            "name": "Simran",
            "fatherName": "Gulshan",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "82",
              "18009043021",
              "Simran",
              "Gulshan",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "18009043023",
            "name": "Sanju",
            "fatherName": "Ranveer Singh",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "83",
              "18009043023",
              "Sanju",
              "Ranveer Singh",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "18009043024",
            "name": "Luxmi",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "84",
              "18009043024",
              "Luxmi",
              "Vinod Kumar",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "18009043025",
            "name": "Santosh",
            "fatherName": "Sohan Lal",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "85",
              "18009043025",
              "Santosh",
              "Sohan Lal",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "18009043032",
            "name": "Isha",
            "fatherName": "Rajesh Kumar",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "86",
              "18009043032",
              "Isha",
              "Rajesh Kumar",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "18009043033",
            "name": "Sonam Popli",
            "fatherName": "Ravinder Kuamar",
            "obtainedMarks": "751",
            "maxMarks": "900",
            "percentage": "83.44%",
            "cells": [
              "87",
              "18009043033",
              "Sonam Popli",
              "Ravinder Kuamar",
              "751",
              "900",
              "83.44%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "18009043035",
            "name": "Sujata Devi",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "88",
              "18009043035",
              "Sujata Devi",
              "Suresh Kumar",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "18009043040",
            "name": "Jyoti",
            "fatherName": "Bhim Sibgh",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "89",
              "18009043040",
              "Jyoti",
              "Bhim Sibgh",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "18009043041",
            "name": "Priyanka",
            "fatherName": "Rakesh Kumar",
            "obtainedMarks": "715",
            "maxMarks": "900",
            "percentage": "79.44%",
            "cells": [
              "90",
              "18009043041",
              "Priyanka",
              "Rakesh Kumar",
              "715",
              "900",
              "79.44%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "18009043045",
            "name": "Anju",
            "fatherName": "Badri pardad",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "91",
              "18009043045",
              "Anju",
              "Badri pardad",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "18009043046",
            "name": "Uma",
            "fatherName": "Subah Chander",
            "obtainedMarks": "713",
            "maxMarks": "900",
            "percentage": "79.22%",
            "cells": [
              "92",
              "18009043046",
              "Uma",
              "Subah Chander",
              "713",
              "900",
              "79.22%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "18009043048",
            "name": "Premlata",
            "fatherName": "Sadhu Ram",
            "obtainedMarks": "669",
            "maxMarks": "900",
            "percentage": "74.33%",
            "cells": [
              "93",
              "18009043048",
              "Premlata",
              "Sadhu Ram",
              "669",
              "900",
              "74.33%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "18009043053",
            "name": "Parveen Kaur",
            "fatherName": "Gurlal Singh",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "94",
              "18009043053",
              "Parveen Kaur",
              "Gurlal Singh",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "18009043054",
            "name": "Poonam",
            "fatherName": "Rajender Kumar",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "95",
              "18009043054",
              "Poonam",
              "Rajender Kumar",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "18009043055",
            "name": "Ekta",
            "fatherName": "Atma Ram",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.56%",
            "cells": [
              "96",
              "18009043055",
              "Ekta",
              "Atma Ram",
              "680",
              "900",
              "75.56%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "18009043058",
            "name": "Garima Rani",
            "fatherName": "Ajeet Singh",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "97",
              "18009043058",
              "Garima Rani",
              "Ajeet Singh",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "18009043060",
            "name": "Mahima",
            "fatherName": "Vijesh Singh",
            "obtainedMarks": "746",
            "maxMarks": "900",
            "percentage": "82.89%",
            "cells": [
              "98",
              "18009043060",
              "Mahima",
              "Vijesh Singh",
              "746",
              "900",
              "82.89%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "18009043062",
            "name": "Jyoti",
            "fatherName": "Damodar",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "99",
              "18009043062",
              "Jyoti",
              "Damodar",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "18009043067",
            "name": "Pooja Devi",
            "fatherName": "yOG Dutt",
            "obtainedMarks": "759",
            "maxMarks": "900",
            "percentage": "84.33%",
            "cells": [
              "100",
              "18009043067",
              "Pooja Devi",
              "yOG Dutt",
              "759",
              "900",
              "84.33%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "18009043068",
            "name": "Amanpreet Kaur",
            "fatherName": "Jagseer Singh",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "101",
              "18009043068",
              "Amanpreet Kaur",
              "Jagseer Singh",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "18009043072",
            "name": "Sheenu Rani",
            "fatherName": "Des Raj",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "102",
              "18009043072",
              "Sheenu Rani",
              "Des Raj",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "18009043078",
            "name": "Babita",
            "fatherName": "Ram Kishan",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "103",
              "18009043078",
              "Babita",
              "Ram Kishan",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "18009043081",
            "name": "Kirti Insan",
            "fatherName": "Rulda  ram",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "104",
              "18009043081",
              "Kirti Insan",
              "Rulda  ram",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "18009043086",
            "name": "Priti",
            "fatherName": "Rajender Kumar",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.78%",
            "cells": [
              "105",
              "18009043086",
              "Priti",
              "Rajender Kumar",
              "655",
              "900",
              "72.78%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "18009043093",
            "name": "Ankita Rani",
            "fatherName": "Manij Gir",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "106",
              "18009043093",
              "Ankita Rani",
              "Manij Gir",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "18009043095",
            "name": "Poonam",
            "fatherName": "Dayanand Giri",
            "obtainedMarks": "749",
            "maxMarks": "900",
            "percentage": "83.22%",
            "cells": [
              "107",
              "18009043095",
              "Poonam",
              "Dayanand Giri",
              "749",
              "900",
              "83.22%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "18009043106",
            "name": "Jyoti",
            "fatherName": "Karam Singh",
            "obtainedMarks": "674",
            "maxMarks": "900",
            "percentage": "74.89%",
            "cells": [
              "108",
              "18009043106",
              "Jyoti",
              "Karam Singh",
              "674",
              "900",
              "74.89%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "18009043107",
            "name": "Rajandeep",
            "fatherName": "Karnail Singh",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "109",
              "18009043107",
              "Rajandeep",
              "Karnail Singh",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "18009043109",
            "name": "Nirmala",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "110",
              "18009043109",
              "Nirmala",
              "Krishan Kumar",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "18009043110",
            "name": "Roshni",
            "fatherName": "Arjun",
            "obtainedMarks": "682",
            "maxMarks": "900",
            "percentage": "75.78%",
            "cells": [
              "111",
              "18009043110",
              "Roshni",
              "Arjun",
              "682",
              "900",
              "75.78%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "18009043114",
            "name": "Jyoti Kaswan",
            "fatherName": "Satbir",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "112",
              "18009043114",
              "Jyoti Kaswan",
              "Satbir",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "18009043122",
            "name": "Rachna Rani",
            "fatherName": "Naresh Kumar",
            "obtainedMarks": "730",
            "maxMarks": "900",
            "percentage": "81.11%",
            "cells": [
              "113",
              "18009043122",
              "Rachna Rani",
              "Naresh Kumar",
              "730",
              "900",
              "81.11%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BCA III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "114",
            "rollNo": "190090470007",
            "name": "Manisha Rani",
            "fatherName": "Sunil Kumar",
            "obtainedMarks": "1301",
            "maxMarks": "1700",
            "percentage": "76.53%",
            "cells": [
              "114",
              "190090470007",
              "Manisha Rani",
              "Sunil Kumar",
              "1301",
              "1700",
              "76.53%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "190090470010",
            "name": "Pooja",
            "fatherName": "Rakesh",
            "obtainedMarks": "1282",
            "maxMarks": "1700",
            "percentage": "75.41%",
            "cells": [
              "115",
              "190090470010",
              "Pooja",
              "Rakesh",
              "1282",
              "1700",
              "75.41%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "190090470015",
            "name": "Jyoti",
            "fatherName": "Kirpa Singh",
            "obtainedMarks": "1314",
            "maxMarks": "1700",
            "percentage": "77.29%",
            "cells": [
              "116",
              "190090470015",
              "Jyoti",
              "Kirpa Singh",
              "1314",
              "1700",
              "77.29%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA V + VI Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BAJMC I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "117",
            "rollNo": "200090420001",
            "name": "Bhawna",
            "fatherName": "Satveer",
            "obtainedMarks": "700",
            "maxMarks": "925",
            "percentage": "75.68%",
            "cells": [
              "117",
              "200090420001",
              "Bhawna",
              "Satveer",
              "700",
              "925",
              "75.68%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "200090420003",
            "name": "Harnoor",
            "fatherName": "BalKaran Singh",
            "obtainedMarks": "716",
            "maxMarks": "925",
            "percentage": "77.41%",
            "cells": [
              "118",
              "200090420003",
              "Harnoor",
              "BalKaran Singh",
              "716",
              "925",
              "77.41%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "200090420004",
            "name": "Kavita",
            "fatherName": "Subash",
            "obtainedMarks": "723",
            "maxMarks": "925",
            "percentage": "78.16%",
            "cells": [
              "119",
              "200090420004",
              "Kavita",
              "Subash",
              "723",
              "925",
              "78.16%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "200090420005",
            "name": "Kiran",
            "fatherName": "Ram Swroop",
            "obtainedMarks": "705",
            "maxMarks": "925",
            "percentage": "76.22%",
            "cells": [
              "120",
              "200090420005",
              "Kiran",
              "Ram Swroop",
              "705",
              "925",
              "76.22%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "200090420006",
            "name": "Kusum",
            "fatherName": "Vishnu Dev",
            "obtainedMarks": "680",
            "maxMarks": "925",
            "percentage": "73.51%",
            "cells": [
              "121",
              "200090420006",
              "Kusum",
              "Vishnu Dev",
              "680",
              "925",
              "73.51%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "200090420008",
            "name": "Monika",
            "fatherName": "Rajinder Kumar",
            "obtainedMarks": "742",
            "maxMarks": "925",
            "percentage": "80.22%",
            "cells": [
              "122",
              "200090420008",
              "Monika",
              "Rajinder Kumar",
              "742",
              "925",
              "80.22%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "200090420010",
            "name": "Nena",
            "fatherName": "Mantu Yadav",
            "obtainedMarks": "610",
            "maxMarks": "925",
            "percentage": "65.95%",
            "cells": [
              "123",
              "200090420010",
              "Nena",
              "Mantu Yadav",
              "610",
              "925",
              "65.95%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "200090420011",
            "name": "Nirmala",
            "fatherName": "Balwant Singh",
            "obtainedMarks": "665",
            "maxMarks": "925",
            "percentage": "71.89%",
            "cells": [
              "124",
              "200090420011",
              "Nirmala",
              "Balwant Singh",
              "665",
              "925",
              "71.89%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "200090420013",
            "name": "Poonam",
            "fatherName": "Rajinder Singh",
            "obtainedMarks": "659",
            "maxMarks": "925",
            "percentage": "71.24%",
            "cells": [
              "125",
              "200090420013",
              "Poonam",
              "Rajinder Singh",
              "659",
              "925",
              "71.24%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "200090420015",
            "name": "Rajni",
            "fatherName": "Sultan",
            "obtainedMarks": "674",
            "maxMarks": "925",
            "percentage": "72.86%",
            "cells": [
              "126",
              "200090420015",
              "Rajni",
              "Sultan",
              "674",
              "925",
              "72.86%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "200090420018",
            "name": "Renu",
            "fatherName": "Balwan Singh",
            "obtainedMarks": "664",
            "maxMarks": "925",
            "percentage": "71.78%",
            "cells": [
              "127",
              "200090420018",
              "Renu",
              "Balwan Singh",
              "664",
              "925",
              "71.78%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "200090420019",
            "name": "Renu Bala",
            "fatherName": "Dharma Ram",
            "obtainedMarks": "648",
            "maxMarks": "925",
            "percentage": "70.05%",
            "cells": [
              "128",
              "200090420019",
              "Renu Bala",
              "Dharma Ram",
              "648",
              "925",
              "70.05%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "200090420020",
            "name": "Samitra",
            "fatherName": "Om Parkash",
            "obtainedMarks": "665",
            "maxMarks": "925",
            "percentage": "71.89%",
            "cells": [
              "129",
              "200090420020",
              "Samitra",
              "Om Parkash",
              "665",
              "925",
              "71.89%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "200090420022",
            "name": "Suman",
            "fatherName": "Shish Pal",
            "obtainedMarks": "656",
            "maxMarks": "925",
            "percentage": "70.92%",
            "cells": [
              "130",
              "200090420022",
              "Suman",
              "Shish Pal",
              "656",
              "925",
              "70.92%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "200090420023",
            "name": "Vinod",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "711",
            "maxMarks": "925",
            "percentage": "76.86%",
            "cells": [
              "131",
              "200090420023",
              "Vinod",
              "Krishan Kumar",
              "711",
              "925",
              "76.86%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "200090420024",
            "name": "Priynka",
            "fatherName": "Jai Veer",
            "obtainedMarks": "687",
            "maxMarks": "925",
            "percentage": "74.27%",
            "cells": [
              "132",
              "200090420024",
              "Priynka",
              "Jai Veer",
              "687",
              "925",
              "74.27%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "133",
            "rollNo": "190090420002",
            "name": "Balijinder kaur",
            "fatherName": "Ajmer singh",
            "obtainedMarks": "801",
            "maxMarks": "1100",
            "percentage": "72.81%",
            "cells": [
              "133",
              "190090420002",
              "Balijinder kaur",
              "Ajmer singh",
              "801",
              "1100",
              "72.81%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "190090420012",
            "name": "Priyanka",
            "fatherName": "Bharat Singh",
            "obtainedMarks": "789",
            "maxMarks": "1100",
            "percentage": "71.72%",
            "cells": [
              "134",
              "190090420012",
              "Priyanka",
              "Bharat Singh",
              "789",
              "1100",
              "71.72%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "190090420013",
            "name": "Rehmat",
            "fatherName": "Navneet kumar",
            "obtainedMarks": "799",
            "maxMarks": "1100",
            "percentage": "72.63%",
            "cells": [
              "135",
              "190090420013",
              "Rehmat",
              "Navneet kumar",
              "799",
              "1100",
              "72.63%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "190090420014",
            "name": "Rekha",
            "fatherName": "Nanak Ram",
            "obtainedMarks": "785",
            "maxMarks": "1100",
            "percentage": "71.36%",
            "cells": [
              "136",
              "190090420014",
              "Rekha",
              "Nanak Ram",
              "785",
              "1100",
              "71.36%"
            ]
          }
        ]
      },
      {
        "courseName": "BAMC V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "137",
            "rollNo": "180090420005",
            "name": "Poonam Rani",
            "fatherName": "Surjeet",
            "obtainedMarks": "795",
            "maxMarks": "1100",
            "percentage": "72.27%",
            "cells": [
              "137",
              "180090420005",
              "Poonam Rani",
              "Surjeet",
              "795",
              "1100",
              "72.27%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "180090420011",
            "name": "Arpana",
            "fatherName": "Satya Naryan",
            "obtainedMarks": "839",
            "maxMarks": "1100",
            "percentage": "76.27%",
            "cells": [
              "138",
              "180090420011",
              "Arpana",
              "Satya Naryan",
              "839",
              "1100",
              "76.27%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "180090420012",
            "name": "Anju Devi",
            "fatherName": "Sant Lal",
            "obtainedMarks": "825",
            "maxMarks": "1100",
            "percentage": "75%",
            "cells": [
              "139",
              "180090420012",
              "Anju Devi",
              "Sant Lal",
              "825",
              "1100",
              "75%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA I+ II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA III + IV Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "140",
            "rollNo": "180090480007",
            "name": "Poonam",
            "fatherName": "Shri Ram",
            "obtainedMarks": "1050",
            "maxMarks": "1450",
            "percentage": "72.41%",
            "cells": [
              "140",
              "180090480007",
              "Poonam",
              "Shri Ram",
              "1050",
              "1450",
              "72.41%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (C.S) I + II Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.Sc (C.S) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "141",
            "rollNo": "190090440003",
            "name": "Lalita",
            "fatherName": "Seva Singh",
            "obtainedMarks": "860",
            "maxMarks": "1100",
            "percentage": "78.18%",
            "cells": [
              "141",
              "190090440003",
              "Lalita",
              "Seva Singh",
              "860",
              "1100",
              "78.18%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "190090440006",
            "name": "Neetu",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "787",
            "maxMarks": "1100",
            "percentage": "71.55%",
            "cells": [
              "142",
              "190090440006",
              "Neetu",
              "Ramesh Kumar",
              "787",
              "1100",
              "71.55%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "190090440010",
            "name": "Reeya",
            "fatherName": "Vijay Kumar",
            "obtainedMarks": "801",
            "maxMarks": "1100",
            "percentage": "72.82%",
            "cells": [
              "143",
              "190090440010",
              "Reeya",
              "Vijay Kumar",
              "801",
              "1100",
              "72.82%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (C.S) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "144",
            "rollNo": "180090440004",
            "name": "Priyanka Kumari",
            "fatherName": "Om Parkash",
            "obtainedMarks": "705",
            "maxMarks": "1000",
            "percentage": "70.50%",
            "cells": [
              "144",
              "180090440004",
              "Priyanka Kumari",
              "Om Parkash",
              "705",
              "1000",
              "70.50%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "180090440006",
            "name": "Sukhpreey",
            "fatherName": "Makhan Singh",
            "obtainedMarks": "808",
            "maxMarks": "1000",
            "percentage": "73.45%",
            "cells": [
              "145",
              "180090440006",
              "Sukhpreey",
              "Makhan Singh",
              "808",
              "1000",
              "73.45%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (N.M) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "146",
            "rollNo": "200090442010",
            "name": "Mahak",
            "fatherName": "Surender",
            "obtainedMarks": "877",
            "maxMarks": "1175",
            "percentage": "74.63%",
            "cells": [
              "146",
              "200090442010",
              "Mahak",
              "Surender",
              "877",
              "1175",
              "74.63%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "200090442020",
            "name": "Priynka",
            "fatherName": "Baljinder Kumar",
            "obtainedMarks": "861",
            "maxMarks": "1175",
            "percentage": "73.27%",
            "cells": [
              "147",
              "200090442020",
              "Priynka",
              "Baljinder Kumar",
              "861",
              "1175",
              "73.27%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "200090442022",
            "name": "Ramandeep Kaur",
            "fatherName": "Jagsir Singh",
            "obtainedMarks": "845",
            "maxMarks": "1175",
            "percentage": "71.91%",
            "cells": [
              "148",
              "200090442022",
              "Ramandeep Kaur",
              "Jagsir Singh",
              "845",
              "1175",
              "71.91%"
            ]
          },
          {
            "sNo": "149",
            "rollNo": "200090442028",
            "name": "Sneha",
            "fatherName": "Madan LAL",
            "obtainedMarks": "925",
            "maxMarks": "1175",
            "percentage": "78.63%",
            "cells": [
              "149",
              "200090442028",
              "Sneha",
              "Madan LAL",
              "925",
              "1175",
              "78.63%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (N.M) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "150",
            "rollNo": "190090442002",
            "name": "Anu Devi",
            "fatherName": "Umed Kumar",
            "obtainedMarks": "814",
            "maxMarks": "1100",
            "percentage": "74%",
            "cells": [
              "150",
              "190090442002",
              "Anu Devi",
              "Umed Kumar",
              "814",
              "1100",
              "74%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "190090442003",
            "name": "Arju",
            "fatherName": "Surender Kumar",
            "obtainedMarks": "830",
            "maxMarks": "1100",
            "percentage": "75.45%",
            "cells": [
              "151",
              "190090442003",
              "Arju",
              "Surender Kumar",
              "830",
              "1100",
              "75.45%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "190090442005",
            "name": "Kashish Insan",
            "fatherName": "Jai krishan",
            "obtainedMarks": "784",
            "maxMarks": "1100",
            "percentage": "71.27%",
            "cells": [
              "152",
              "190090442005",
              "Kashish Insan",
              "Jai krishan",
              "784",
              "1100",
              "71.27%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "190090442013",
            "name": "Priti",
            "fatherName": "Leelu Ram",
            "obtainedMarks": "866",
            "maxMarks": "1100",
            "percentage": "78.72%",
            "cells": [
              "153",
              "190090442013",
              "Priti",
              "Leelu Ram",
              "866",
              "1100",
              "78.72%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "190090442014",
            "name": "Sakshi",
            "fatherName": "Balbir",
            "obtainedMarks": "799",
            "maxMarks": "1100",
            "percentage": "72.63%",
            "cells": [
              "154",
              "190090442014",
              "Sakshi",
              "Balbir",
              "799",
              "1100",
              "72.63%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "190090442020",
            "name": "Sukhpyar",
            "fatherName": "Brij Lal",
            "obtainedMarks": "839",
            "maxMarks": "1100",
            "percentage": "76.27%",
            "cells": [
              "155",
              "190090442020",
              "Sukhpyar",
              "Brij Lal",
              "839",
              "1100",
              "76.27%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (N.M) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "156",
            "rollNo": "180090442004",
            "name": "Monika",
            "fatherName": "Shishpal",
            "obtainedMarks": "801",
            "maxMarks": "1000",
            "percentage": "80.10%",
            "cells": [
              "156",
              "180090442004",
              "Monika",
              "Shishpal",
              "801",
              "1000",
              "80.10%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "180090442012",
            "name": "Neetu",
            "fatherName": "Vrd Parkash",
            "obtainedMarks": "815",
            "maxMarks": "1000",
            "percentage": "81.50%",
            "cells": [
              "157",
              "180090442012",
              "Neetu",
              "Vrd Parkash",
              "815",
              "1000",
              "81.50%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "180090442015",
            "name": "Manisha",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "788",
            "maxMarks": "1000",
            "percentage": "78.80%",
            "cells": [
              "158",
              "180090442015",
              "Manisha",
              "Vinod Kumar",
              "788",
              "1000",
              "78.80%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "180090442019",
            "name": "Simran",
            "fatherName": "Surender Singh",
            "obtainedMarks": "749",
            "maxMarks": "1000",
            "percentage": "74.90%",
            "cells": [
              "159",
              "180090442019",
              "Simran",
              "Surender Singh",
              "749",
              "1000",
              "74.90%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "180090442020",
            "name": "Prerna",
            "fatherName": "Rohtash Kumar",
            "obtainedMarks": "706",
            "maxMarks": "1000",
            "percentage": "70.60%",
            "cells": [
              "160",
              "180090442020",
              "Prerna",
              "Rohtash Kumar",
              "706",
              "1000",
              "70.60%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "180090442022",
            "name": "Amanat Insan",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "750",
            "maxMarks": "1000",
            "percentage": "75%",
            "cells": [
              "161",
              "180090442022",
              "Amanat Insan",
              "Vinod Kumar",
              "750",
              "1000",
              "75%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen) I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "162",
            "rollNo": "200090450020",
            "name": "Samriti",
            "fatherName": "Rakesh",
            "obtainedMarks": "814",
            "maxMarks": "1150",
            "percentage": "70.78%",
            "cells": [
              "162",
              "200090450020",
              "Samriti",
              "Rakesh",
              "814",
              "1150",
              "70.78%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "200090450021",
            "name": "Sania",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "839",
            "maxMarks": "1150",
            "percentage": "72.96%",
            "cells": [
              "163",
              "200090450021",
              "Sania",
              "Vinod Kumar",
              "839",
              "1150",
              "72.96%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "200090450028",
            "name": "Sonam Kumari",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "811",
            "maxMarks": "1150",
            "percentage": "70.52%",
            "cells": [
              "164",
              "200090450028",
              "Sonam Kumari",
              "Suresh Kumar",
              "811",
              "1150",
              "70.52%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen) III + IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "165",
            "rollNo": "190090450001",
            "name": "Aditi",
            "fatherName": "Sanjay",
            "obtainedMarks": "912",
            "maxMarks": "1250",
            "percentage": "72.96%",
            "cells": [
              "165",
              "190090450001",
              "Aditi",
              "Sanjay",
              "912",
              "1250",
              "72.96%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "190090450005",
            "name": "Bhawna",
            "fatherName": "Amrish Kumar",
            "obtainedMarks": "934",
            "maxMarks": "1250",
            "percentage": "74.72%",
            "cells": [
              "166",
              "190090450005",
              "Bhawna",
              "Amrish Kumar",
              "934",
              "1250",
              "74.72%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "190090450012",
            "name": "Harmeet Kaur",
            "fatherName": "Shajinder Singh",
            "obtainedMarks": "962",
            "maxMarks": "1250",
            "percentage": "76.96%",
            "cells": [
              "167",
              "190090450012",
              "Harmeet Kaur",
              "Shajinder Singh",
              "962",
              "1250",
              "76.96%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "190090450017",
            "name": "Mamta Rani",
            "fatherName": "Sukhbir Singh",
            "obtainedMarks": "91",
            "maxMarks": "1250",
            "percentage": "7.28%",
            "cells": [
              "168",
              "190090450017",
              "Mamta Rani",
              "Sukhbir Singh",
              "91",
              "1250",
              "7.28%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "190090450018",
            "name": "Manisha Rani",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "946",
            "maxMarks": "1250",
            "percentage": "75.68%",
            "cells": [
              "169",
              "190090450018",
              "Manisha Rani",
              "Suresh Kumar",
              "946",
              "1250",
              "75.68%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "190090450025",
            "name": "Priyanka",
            "fatherName": "Pyare Lal",
            "obtainedMarks": "883",
            "maxMarks": "1250",
            "percentage": "70.64%",
            "cells": [
              "170",
              "190090450025",
              "Priyanka",
              "Pyare Lal",
              "883",
              "1250",
              "70.64%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "190090450028",
            "name": "Sandhya",
            "fatherName": "Rajesh Kumar",
            "obtainedMarks": "984",
            "maxMarks": "1250",
            "percentage": "78.72%",
            "cells": [
              "171",
              "190090450028",
              "Sandhya",
              "Rajesh Kumar",
              "984",
              "1250",
              "78.72%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "190090450032",
            "name": "Sefi",
            "fatherName": "Satpal Singh",
            "obtainedMarks": "881",
            "maxMarks": "1250",
            "percentage": "70.48%",
            "cells": [
              "172",
              "190090450032",
              "Sefi",
              "Satpal Singh",
              "881",
              "1250",
              "70.48%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "190090450034",
            "name": "Sugandh",
            "fatherName": "Rakesh Kumar Dhawan",
            "obtainedMarks": "975",
            "maxMarks": "1250",
            "percentage": "78%",
            "cells": [
              "173",
              "190090450034",
              "Sugandh",
              "Rakesh Kumar Dhawan",
              "975",
              "1250",
              "78%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "190090450037",
            "name": "Tanya",
            "fatherName": "Jagdish Kumar",
            "obtainedMarks": "875",
            "maxMarks": "1250",
            "percentage": "70%",
            "cells": [
              "174",
              "190090450037",
              "Tanya",
              "Jagdish Kumar",
              "875",
              "1250",
              "70%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "190090450038",
            "name": "Vaishali Soni",
            "fatherName": "Ashok Kumar",
            "obtainedMarks": "905",
            "maxMarks": "1250",
            "percentage": "72.40%",
            "cells": [
              "175",
              "190090450038",
              "Vaishali Soni",
              "Ashok Kumar",
              "905",
              "1250",
              "72.40%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Gen) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "176",
            "rollNo": "180090450002",
            "name": "Anchal Kamboj",
            "fatherName": "Hans Raj",
            "obtainedMarks": "881",
            "maxMarks": "1200",
            "percentage": "73.42%",
            "cells": [
              "176",
              "180090450002",
              "Anchal Kamboj",
              "Hans Raj",
              "881",
              "1200",
              "73.42%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "180090450004",
            "name": "Monika",
            "fatherName": "Ram Singh",
            "obtainedMarks": "905",
            "maxMarks": "1200",
            "percentage": "75.42%",
            "cells": [
              "177",
              "180090450004",
              "Monika",
              "Ram Singh",
              "905",
              "1200",
              "75.42%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "180090450006",
            "name": "Minakshi",
            "fatherName": "Hanuman Godara",
            "obtainedMarks": "862",
            "maxMarks": "1200",
            "percentage": "71.83%",
            "cells": [
              "178",
              "180090450006",
              "Minakshi",
              "Hanuman Godara",
              "862",
              "1200",
              "71.83%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "180090450008",
            "name": "Poonam",
            "fatherName": "Pala Ram",
            "obtainedMarks": "911",
            "maxMarks": "1200",
            "percentage": "75.92%",
            "cells": [
              "179",
              "180090450008",
              "Poonam",
              "Pala Ram",
              "911",
              "1200",
              "75.92%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "180090450010",
            "name": "Sonika Devi",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "847",
            "maxMarks": "1200",
            "percentage": "70.58%",
            "cells": [
              "180",
              "180090450010",
              "Sonika Devi",
              "Ramesh Kumar",
              "847",
              "1200",
              "70.58%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "180090450012",
            "name": "Karamdeep Insan",
            "fatherName": "Pardeep Insan",
            "obtainedMarks": "876",
            "maxMarks": "1200",
            "percentage": "73%",
            "cells": [
              "181",
              "180090450012",
              "Karamdeep Insan",
              "Pardeep Insan",
              "876",
              "1200",
              "73%"
            ]
          },
          {
            "sNo": "182",
            "rollNo": "180090450016",
            "name": "Arzoo",
            "fatherName": "Parveen Kumar",
            "obtainedMarks": "859",
            "maxMarks": "1200",
            "percentage": "71.58%",
            "cells": [
              "182",
              "180090450016",
              "Arzoo",
              "Parveen Kumar",
              "859",
              "1200",
              "71.58%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "180090450017",
            "name": "Shagun",
            "fatherName": "Jitender Phutela",
            "obtainedMarks": "907",
            "maxMarks": "1200",
            "percentage": "75.58%",
            "cells": [
              "183",
              "180090450017",
              "Shagun",
              "Jitender Phutela",
              "907",
              "1200",
              "75.58%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "180090450018",
            "name": "aRZOO",
            "fatherName": "Ravi Gaba",
            "obtainedMarks": "958",
            "maxMarks": "1200",
            "percentage": "79.83%",
            "cells": [
              "184",
              "180090450018",
              "aRZOO",
              "Ravi Gaba",
              "958",
              "1200",
              "79.83%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "180090450021",
            "name": "Priyanka",
            "fatherName": "Prem Singh",
            "obtainedMarks": "954",
            "maxMarks": "1200",
            "percentage": "79.50%",
            "cells": [
              "185",
              "180090450021",
              "Priyanka",
              "Prem Singh",
              "954",
              "1200",
              "79.50%"
            ]
          },
          {
            "sNo": "186",
            "rollNo": "180090450023",
            "name": "Manisha",
            "fatherName": "Subash Chander",
            "obtainedMarks": "856",
            "maxMarks": "1200",
            "percentage": "71.33%",
            "cells": [
              "186",
              "180090450023",
              "Manisha",
              "Subash Chander",
              "856",
              "1200",
              "71.33%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "180090450026",
            "name": "Manju",
            "fatherName": "Sohan Pal",
            "obtainedMarks": "929",
            "maxMarks": "1200",
            "percentage": "77.42%",
            "cells": [
              "187",
              "180090450026",
              "Manju",
              "Sohan Pal",
              "929",
              "1200",
              "77.42%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "180650450001\nMigrated",
            "name": "Luxmi",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "910",
            "maxMarks": "1200",
            "percentage": "75.83%",
            "cells": [
              "188",
              "180650450001\nMigrated",
              "Luxmi",
              "Ramesh Kumar",
              "910",
              "1200",
              "75.83%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com  (Voc.) I + II SEM)",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "189",
            "rollNo": "200090460006",
            "name": "LALISHA",
            "fatherName": "ANIL",
            "obtainedMarks": "865",
            "maxMarks": "1150",
            "percentage": "75.21%",
            "cells": [
              "189",
              "200090460006",
              "LALISHA",
              "ANIL",
              "865",
              "1150",
              "75.21%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com  (Voc.) III + IV SEM)",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "190",
            "rollNo": "190090460001",
            "name": "Akshdeep",
            "fatherName": "Gurdat Singh",
            "obtainedMarks": "968",
            "maxMarks": "1150",
            "percentage": "77.44%",
            "cells": [
              "190",
              "190090460001",
              "Akshdeep",
              "Gurdat Singh",
              "968",
              "1150",
              "77.44%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "190090460011",
            "name": "Rakhi",
            "fatherName": "Raj Kumar",
            "obtainedMarks": "908",
            "maxMarks": "1150",
            "percentage": "72.64%",
            "cells": [
              "191",
              "190090460011",
              "Rakhi",
              "Raj Kumar",
              "908",
              "1150",
              "72.64%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com (Voc.) V + VI Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "192",
            "rollNo": "180090460001",
            "name": "Simran",
            "fatherName": "Puran Chand",
            "obtainedMarks": "884",
            "maxMarks": "1250",
            "percentage": "70.72%",
            "cells": [
              "192",
              "180090460001",
              "Simran",
              "Puran Chand",
              "884",
              "1250",
              "70.72%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "180090460010",
            "name": "Mohini",
            "fatherName": "Satpal",
            "obtainedMarks": "931",
            "maxMarks": "1250",
            "percentage": "74.48%",
            "cells": [
              "193",
              "180090460010",
              "Mohini",
              "Satpal",
              "931",
              "1250",
              "74.48%"
            ]
          }
        ]
      },
      {
        "courseName": "DPED I + II SEM",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "194",
            "rollNo": "200090640003",
            "name": "ANISHA VERMA",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1120",
            "maxMarks": "1500",
            "percentage": "74.66%",
            "cells": [
              "194",
              "200090640003",
              "ANISHA VERMA",
              "ANAND KUMAR",
              "1120",
              "1500",
              "74.66%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "200090640007",
            "name": "ANU",
            "fatherName": "SUBHASH YADAV",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "195",
              "200090640007",
              "ANU",
              "SUBHASH YADAV",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "200090640008",
            "name": "ANU BALA",
            "fatherName": "DANA RAM",
            "obtainedMarks": "1054",
            "maxMarks": "1500",
            "percentage": "70.26%",
            "cells": [
              "196",
              "200090640008",
              "ANU BALA",
              "DANA RAM",
              "1054",
              "1500",
              "70.26%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "200090640012",
            "name": "CHHINDER PAL",
            "fatherName": "GURCHARAN",
            "obtainedMarks": "1069",
            "maxMarks": "1500",
            "percentage": "71.26%",
            "cells": [
              "197",
              "200090640012",
              "CHHINDER PAL",
              "GURCHARAN",
              "1069",
              "1500",
              "71.26%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "200090640013",
            "name": "DIMPAL",
            "fatherName": "SHIV RATAN",
            "obtainedMarks": "1099",
            "maxMarks": "1500",
            "percentage": "73.26%",
            "cells": [
              "198",
              "200090640013",
              "DIMPAL",
              "SHIV RATAN",
              "1099",
              "1500",
              "73.26%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "200090640014",
            "name": "EKTA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "1063",
            "maxMarks": "1500",
            "percentage": "70.86%",
            "cells": [
              "199",
              "200090640014",
              "EKTA",
              "MOHAN LAL",
              "1063",
              "1500",
              "70.86%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "200090640021",
            "name": "KIRAN SIYOL",
            "fatherName": "RAMU RAM",
            "obtainedMarks": "1152",
            "maxMarks": "1500",
            "percentage": "76.80%",
            "cells": [
              "200",
              "200090640021",
              "KIRAN SIYOL",
              "RAMU RAM",
              "1152",
              "1500",
              "76.80%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "200090640023",
            "name": "KOMAL",
            "fatherName": "BALWANT NAIN",
            "obtainedMarks": "1058",
            "maxMarks": "1500",
            "percentage": "70.53%",
            "cells": [
              "201",
              "200090640023",
              "KOMAL",
              "BALWANT NAIN",
              "1058",
              "1500",
              "70.53%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "200090640025",
            "name": "MEHAK PREET",
            "fatherName": "JANAK SINGH",
            "obtainedMarks": "1069",
            "maxMarks": "1500",
            "percentage": "71.26%",
            "cells": [
              "202",
              "200090640025",
              "MEHAK PREET",
              "JANAK SINGH",
              "1069",
              "1500",
              "71.26%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "200090640027",
            "name": "MAMTA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1140",
            "maxMarks": "1500",
            "percentage": "76%",
            "cells": [
              "203",
              "200090640027",
              "MAMTA",
              "KRISHAN KUMAR",
              "1140",
              "1500",
              "76%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "200090640028",
            "name": "MANINDER PAL",
            "fatherName": "JAGSEER SINGH",
            "obtainedMarks": "1131",
            "maxMarks": "1500",
            "percentage": "76.40%",
            "cells": [
              "204",
              "200090640028",
              "MANINDER PAL",
              "JAGSEER SINGH",
              "1131",
              "1500",
              "76.40%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "200090640029",
            "name": "MANISHA PAREEK",
            "fatherName": "VED PRAKASH",
            "obtainedMarks": "1083",
            "maxMarks": "1500",
            "percentage": "72.20%",
            "cells": [
              "205",
              "200090640029",
              "MANISHA PAREEK",
              "VED PRAKASH",
              "1083",
              "1500",
              "72.20%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "200090640031",
            "name": "MONIKA",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1019",
            "maxMarks": "1500",
            "percentage": "72.66%",
            "cells": [
              "206",
              "200090640031",
              "MONIKA",
              "BHOOP SINGH",
              "1019",
              "1500",
              "72.66%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "200090640032",
            "name": "NACHITA",
            "fatherName": "RAMU TAR",
            "obtainedMarks": "1153",
            "maxMarks": "1500",
            "percentage": "70.86%",
            "cells": [
              "207",
              "200090640032",
              "NACHITA",
              "RAMU TAR",
              "1153",
              "1500",
              "70.86%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "200090640034",
            "name": "NEETU",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1167",
            "maxMarks": "1500",
            "percentage": "77.80%",
            "cells": [
              "208",
              "200090640034",
              "NEETU",
              "BHOOP SINGH",
              "1167",
              "1500",
              "77.80%"
            ]
          },
          {
            "sNo": "209",
            "rollNo": "200090640048",
            "name": "SUMAN",
            "fatherName": "JAGDISH CHANDER",
            "obtainedMarks": "1167",
            "maxMarks": "1500",
            "percentage": "73.66%",
            "cells": [
              "209",
              "200090640048",
              "SUMAN",
              "JAGDISH CHANDER",
              "1167",
              "1500",
              "73.66%"
            ]
          }
        ]
      },
      {
        "courseName": "DPED III+ IV SEM",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.Com I + II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "200090240002",
            "name": "Amarpreet",
            "fatherName": "Gurmeet Singh",
            "obtainedMarks": "989",
            "maxMarks": "1400",
            "percentage": "70.64%",
            "cells": [
              "1",
              "200090240002",
              "Amarpreet",
              "Gurmeet Singh",
              "989",
              "1400",
              "70.64%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "200090240005",
            "name": "Damiyanti",
            "fatherName": "Dayanand",
            "obtainedMarks": "1052",
            "maxMarks": "1400",
            "percentage": "75.14%",
            "cells": [
              "2",
              "200090240005",
              "Damiyanti",
              "Dayanand",
              "1052",
              "1400",
              "75.14%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "200090240007",
            "name": "Jasmeen",
            "fatherName": "Naresh Kumar",
            "obtainedMarks": "985",
            "maxMarks": "1400",
            "percentage": "70.36%",
            "cells": [
              "3",
              "200090240007",
              "Jasmeen",
              "Naresh Kumar",
              "985",
              "1400",
              "70.36%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "200090240008",
            "name": "Jyotsana",
            "fatherName": "Prem Kumar",
            "obtainedMarks": "1095",
            "maxMarks": "1400",
            "percentage": "78.21%",
            "cells": [
              "4",
              "200090240008",
              "Jyotsana",
              "Prem Kumar",
              "1095",
              "1400",
              "78.21%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "200090240010",
            "name": "Khushboo",
            "fatherName": "Naresh",
            "obtainedMarks": "1094",
            "maxMarks": "1400",
            "percentage": "78.14%",
            "cells": [
              "5",
              "200090240010",
              "Khushboo",
              "Naresh",
              "1094",
              "1400",
              "78.14%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "200090240016",
            "name": "Preeti Rani",
            "fatherName": "Ram Parkash",
            "obtainedMarks": "983",
            "maxMarks": "1400",
            "percentage": "70.21%",
            "cells": [
              "6",
              "200090240016",
              "Preeti Rani",
              "Ram Parkash",
              "983",
              "1400",
              "70.21%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "200090240022",
            "name": "Sheela Rani",
            "fatherName": "Om Parkash",
            "obtainedMarks": "1006",
            "maxMarks": "1400",
            "percentage": "71.86%",
            "cells": [
              "7",
              "200090240022",
              "Sheela Rani",
              "Om Parkash",
              "1006",
              "1400",
              "71.86%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "200090240023",
            "name": "Sneha Karwasra",
            "fatherName": "Naresh Kumar",
            "obtainedMarks": "1103",
            "maxMarks": "1400",
            "percentage": "78.79%",
            "cells": [
              "8",
              "200090240023",
              "Sneha Karwasra",
              "Naresh Kumar",
              "1103",
              "1400",
              "78.79%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "200090240025",
            "name": "Tamanna",
            "fatherName": "Raj Kumar",
            "obtainedMarks": "987",
            "maxMarks": "1400",
            "percentage": "70.50%",
            "cells": [
              "9",
              "200090240025",
              "Tamanna",
              "Raj Kumar",
              "987",
              "1400",
              "70.50%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com III+IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "10",
            "rollNo": "190090240002",
            "name": "Baljeet Kaur",
            "fatherName": "Gurmail Singh",
            "obtainedMarks": "991",
            "maxMarks": "1350",
            "percentage": "73.41%",
            "cells": [
              "10",
              "190090240002",
              "Baljeet Kaur",
              "Gurmail Singh",
              "991",
              "1350",
              "73.41%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "190090240003",
            "name": "Gurjot",
            "fatherName": "Sukhdev Singh",
            "obtainedMarks": "1001",
            "maxMarks": "1350",
            "percentage": "74.15%",
            "cells": [
              "11",
              "190090240003",
              "Gurjot",
              "Sukhdev Singh",
              "1001",
              "1350",
              "74.15%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "190090240006",
            "name": "Heena Bhatia",
            "fatherName": "Vijay Kumar",
            "obtainedMarks": "951",
            "maxMarks": "1350",
            "percentage": "70.44%",
            "cells": [
              "12",
              "190090240006",
              "Heena Bhatia",
              "Vijay Kumar",
              "951",
              "1350",
              "70.44%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "190090240007",
            "name": "Ishu",
            "fatherName": "Rajender",
            "obtainedMarks": "993",
            "maxMarks": "1350",
            "percentage": "73.56%",
            "cells": [
              "13",
              "190090240007",
              "Ishu",
              "Rajender",
              "993",
              "1350",
              "73.56%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "190090240009",
            "name": "Jaspreet",
            "fatherName": "Hari Singh",
            "obtainedMarks": "1018",
            "maxMarks": "1350",
            "percentage": "75.41%",
            "cells": [
              "14",
              "190090240009",
              "Jaspreet",
              "Hari Singh",
              "1018",
              "1350",
              "75.41%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "190090240012",
            "name": "Monika",
            "fatherName": "Shamlal Arora",
            "obtainedMarks": "992",
            "maxMarks": "1350",
            "percentage": "73.48%",
            "cells": [
              "15",
              "190090240012",
              "Monika",
              "Shamlal Arora",
              "992",
              "1350",
              "73.48%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "190090240013",
            "name": "Nancy",
            "fatherName": "Naresh Kumar",
            "obtainedMarks": "1087",
            "maxMarks": "1350",
            "percentage": "80.52%",
            "cells": [
              "16",
              "190090240013",
              "Nancy",
              "Naresh Kumar",
              "1087",
              "1350",
              "80.52%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "190090240019",
            "name": "Simarjeet Kaur",
            "fatherName": "Amrik Singh",
            "obtainedMarks": "974",
            "maxMarks": "1350",
            "percentage": "72.15%",
            "cells": [
              "17",
              "190090240019",
              "Simarjeet Kaur",
              "Amrik Singh",
              "974",
              "1350",
              "72.15%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. English I+II",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A. English III+IV Sem",
        "hasMerit": false,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.Sc. Maths I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "18",
            "rollNo": "200090140001",
            "name": "Anshika",
            "fatherName": "Shamsher Singh",
            "obtainedMarks": "1101",
            "maxMarks": "1400",
            "percentage": "78.64%",
            "cells": [
              "18",
              "200090140001",
              "Anshika",
              "Shamsher Singh",
              "1101",
              "1400",
              "78.64%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "200090140002",
            "name": "Jasmeet Kaur Dang",
            "fatherName": "Mohinder Singh",
            "obtainedMarks": "1020",
            "maxMarks": "1400",
            "percentage": "72.85%",
            "cells": [
              "19",
              "200090140002",
              "Jasmeet Kaur Dang",
              "Mohinder Singh",
              "1020",
              "1400",
              "72.85%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "200090140011",
            "name": "Preetpal Kaur",
            "fatherName": "Rajender Singh",
            "obtainedMarks": "1048",
            "maxMarks": "1400",
            "percentage": "74.85%",
            "cells": [
              "20",
              "200090140011",
              "Preetpal Kaur",
              "Rajender Singh",
              "1048",
              "1400",
              "74.85%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "200090140016",
            "name": "Shakila",
            "fatherName": "Mahender Singh",
            "obtainedMarks": "1063",
            "maxMarks": "1400",
            "percentage": "75.92%",
            "cells": [
              "21",
              "200090140016",
              "Shakila",
              "Mahender Singh",
              "1063",
              "1400",
              "75.92%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Sc. Maths III+IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "22",
            "rollNo": "190090140005",
            "name": "Pooja rani",
            "fatherName": "Shyam Lal",
            "obtainedMarks": "861",
            "maxMarks": "1200",
            "percentage": "71.75%",
            "cells": [
              "22",
              "190090140005",
              "Pooja rani",
              "Shyam Lal",
              "861",
              "1200",
              "71.75%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "190090140006",
            "name": "Poonam",
            "fatherName": "Subhash Chander",
            "obtainedMarks": "902",
            "maxMarks": "1200",
            "percentage": "75.17%",
            "cells": [
              "23",
              "190090140006",
              "Poonam",
              "Subhash Chander",
              "902",
              "1200",
              "75.17%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "190090140009",
            "name": "Priyanka",
            "fatherName": "Mahender Singh",
            "obtainedMarks": "928",
            "maxMarks": "1200",
            "percentage": "77.33%",
            "cells": [
              "24",
              "190090140009",
              "Priyanka",
              "Mahender Singh",
              "928",
              "1200",
              "77.33%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "190090140010",
            "name": "Priyanka",
            "fatherName": "Ranbir Singh",
            "obtainedMarks": "900",
            "maxMarks": "1200",
            "percentage": "75%",
            "cells": [
              "25",
              "190090140010",
              "Priyanka",
              "Ranbir Singh",
              "900",
              "1200",
              "75%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "190090140011",
            "name": "Ritu",
            "fatherName": "Balwinder Singh",
            "obtainedMarks": "923",
            "maxMarks": "1200",
            "percentage": "76.92%",
            "cells": [
              "26",
              "190090140011",
              "Ritu",
              "Balwinder Singh",
              "923",
              "1200",
              "76.92%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. Pub. Adm. I+II",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "27",
            "rollNo": "200090260014",
            "name": "Ritu",
            "fatherName": "Karni Singh",
            "obtainedMarks": "1033",
            "maxMarks": "1400",
            "percentage": "73.78%",
            "cells": [
              "27",
              "200090260014",
              "Ritu",
              "Karni Singh",
              "1033",
              "1400",
              "73.78%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "200090260020",
            "name": "Savina",
            "fatherName": "Ran Singh",
            "obtainedMarks": "1028",
            "maxMarks": "1400",
            "percentage": "73.42%",
            "cells": [
              "28",
              "200090260020",
              "Savina",
              "Ran Singh",
              "1028",
              "1400",
              "73.42%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. Pub. Adm. III+IV",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "29",
            "rollNo": "190090260001",
            "name": "Anu Rani",
            "fatherName": "Krishan Lal",
            "obtainedMarks": "916",
            "maxMarks": "1200",
            "percentage": "76.33%",
            "cells": [
              "29",
              "190090260001",
              "Anu Rani",
              "Krishan Lal",
              "916",
              "1200",
              "76.33%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "190090260004",
            "name": "Meenakshi Grover",
            "fatherName": "Banarsi Dass",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "74.67%",
            "cells": [
              "30",
              "190090260004",
              "Meenakshi Grover",
              "Banarsi Dass",
              "896",
              "1200",
              "74.67%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "190090260006",
            "name": "Rajni Bai",
            "fatherName": "Amar Singh",
            "obtainedMarks": "929",
            "maxMarks": "1200",
            "percentage": "77.42%",
            "cells": [
              "31",
              "190090260006",
              "Rajni Bai",
              "Amar Singh",
              "929",
              "1200",
              "77.42%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "190090260008",
            "name": "Rekha Rani",
            "fatherName": "Girdhari Lal",
            "obtainedMarks": "905",
            "maxMarks": "1200",
            "percentage": "75.42%",
            "cells": [
              "32",
              "190090260008",
              "Rekha Rani",
              "Girdhari Lal",
              "905",
              "1200",
              "75.42%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "190090260009",
            "name": "Reenu Devi",
            "fatherName": "Krishan Singh",
            "obtainedMarks": "912",
            "maxMarks": "1200",
            "percentage": "76%",
            "cells": [
              "33",
              "190090260009",
              "Reenu Devi",
              "Krishan Singh",
              "912",
              "1200",
              "76%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "190090260011",
            "name": "Sanju",
            "fatherName": "Ram Niwas",
            "obtainedMarks": "933",
            "maxMarks": "1200",
            "percentage": "77.75%",
            "cells": [
              "34",
              "190090260011",
              "Sanju",
              "Ram Niwas",
              "933",
              "1200",
              "77.75%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "190090260012",
            "name": "Sunita",
            "fatherName": "Mange Ram",
            "obtainedMarks": "941",
            "maxMarks": "1200",
            "percentage": "78.42%",
            "cells": [
              "35",
              "190090260012",
              "Sunita",
              "Mange Ram",
              "941",
              "1200",
              "78.42%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "190090260013",
            "name": "Usha",
            "fatherName": "Nathu Ram",
            "obtainedMarks": "905",
            "maxMarks": "1200",
            "percentage": "75.42%",
            "cells": [
              "36",
              "190090260013",
              "Usha",
              "Nathu Ram",
              "905",
              "1200",
              "75.42%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. Hindi I +II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "37",
            "rollNo": "200090300001",
            "name": "Akki Kaur",
            "fatherName": "Buta Singh",
            "obtainedMarks": "1017",
            "maxMarks": "1300",
            "percentage": "78.23%",
            "cells": [
              "37",
              "200090300001",
              "Akki Kaur",
              "Buta Singh",
              "1017",
              "1300",
              "78.23%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "200090300002",
            "name": "Kanika",
            "fatherName": "Balwant Singh",
            "obtainedMarks": "965",
            "maxMarks": "1300",
            "percentage": "74.23%",
            "cells": [
              "38",
              "200090300002",
              "Kanika",
              "Balwant Singh",
              "965",
              "1300",
              "74.23%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "200090300007",
            "name": "Manita Rani",
            "fatherName": "Prithvi Raj",
            "obtainedMarks": "911",
            "maxMarks": "1300",
            "percentage": "70.08%",
            "cells": [
              "39",
              "200090300007",
              "Manita Rani",
              "Prithvi Raj",
              "911",
              "1300",
              "70.08%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "200090300009",
            "name": "Mewa Devi",
            "fatherName": "Ram Kumar",
            "obtainedMarks": "928",
            "maxMarks": "1300",
            "percentage": "71.38%",
            "cells": [
              "40",
              "200090300009",
              "Mewa Devi",
              "Ram Kumar",
              "928",
              "1300",
              "71.38%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "200090300012",
            "name": "Pooja Rani",
            "fatherName": "Bhagat Singh",
            "obtainedMarks": "1026",
            "maxMarks": "1300",
            "percentage": "78.92%",
            "cells": [
              "41",
              "200090300012",
              "Pooja Rani",
              "Bhagat Singh",
              "1026",
              "1300",
              "78.92%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "200090300014",
            "name": "Poonam",
            "fatherName": "Rajender Kumar",
            "obtainedMarks": "981",
            "maxMarks": "1300",
            "percentage": "75.46%",
            "cells": [
              "42",
              "200090300014",
              "Poonam",
              "Rajender Kumar",
              "981",
              "1300",
              "75.46%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "200090300016",
            "name": "Poonam Thakur",
            "fatherName": "Gurmail Singh",
            "obtainedMarks": "999",
            "maxMarks": "1300",
            "percentage": "76.84%",
            "cells": [
              "43",
              "200090300016",
              "Poonam Thakur",
              "Gurmail Singh",
              "999",
              "1300",
              "76.84%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "200090300017",
            "name": "Ritu",
            "fatherName": "Subash",
            "obtainedMarks": "946",
            "maxMarks": "1300",
            "percentage": "72.76%",
            "cells": [
              "44",
              "200090300017",
              "Ritu",
              "Subash",
              "946",
              "1300",
              "72.76%"
            ]
          }
        ]
      },
      {
        "courseName": "B.P.Ed. I+II Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "45",
            "rollNo": "20090510001",
            "name": "Arti",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "1197",
            "maxMarks": "1700",
            "percentage": "70.41%",
            "cells": [
              "45",
              "20090510001",
              "Arti",
              "Krishan Kumar",
              "1197",
              "1700",
              "70.41%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "20090510007",
            "name": "Jaswinder Kaur",
            "fatherName": "Gulshan Kumar",
            "obtainedMarks": "1235",
            "maxMarks": "1700",
            "percentage": "72.65%",
            "cells": [
              "46",
              "20090510007",
              "Jaswinder Kaur",
              "Gulshan Kumar",
              "1235",
              "1700",
              "72.65%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "20090510009",
            "name": "Kulwinder Kaur",
            "fatherName": "Darshan Singh",
            "obtainedMarks": "1240",
            "maxMarks": "1700",
            "percentage": "72.94%",
            "cells": [
              "47",
              "20090510009",
              "Kulwinder Kaur",
              "Darshan Singh",
              "1240",
              "1700",
              "72.94%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "20090510010",
            "name": "Kusum Rani",
            "fatherName": "Mahender Singh",
            "obtainedMarks": "1205",
            "maxMarks": "1700",
            "percentage": "70.88%",
            "cells": [
              "48",
              "20090510010",
              "Kusum Rani",
              "Mahender Singh",
              "1205",
              "1700",
              "70.88%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "20090510014",
            "name": "Nirmal",
            "fatherName": "Hawa Singh Punia",
            "obtainedMarks": "1274",
            "maxMarks": "1700",
            "percentage": "74.94%",
            "cells": [
              "49",
              "20090510014",
              "Nirmal",
              "Hawa Singh Punia",
              "1274",
              "1700",
              "74.94%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "20090510019",
            "name": "Poonam Rani",
            "fatherName": "Sunil Dutt",
            "obtainedMarks": "1194",
            "maxMarks": "1700",
            "percentage": "70.24%",
            "cells": [
              "50",
              "20090510019",
              "Poonam Rani",
              "Sunil Dutt",
              "1194",
              "1700",
              "70.24%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "20090510022",
            "name": "Priyanka",
            "fatherName": "Mewa Singh",
            "obtainedMarks": "1239",
            "maxMarks": "1700",
            "percentage": "72.88%",
            "cells": [
              "51",
              "20090510022",
              "Priyanka",
              "Mewa Singh",
              "1239",
              "1700",
              "72.88%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "20090510024",
            "name": "Rajbinder Kaur",
            "fatherName": "Major Singh",
            "obtainedMarks": "1242",
            "maxMarks": "1700",
            "percentage": "73.06%",
            "cells": [
              "52",
              "20090510024",
              "Rajbinder Kaur",
              "Major Singh",
              "1242",
              "1700",
              "73.06%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "20090510025",
            "name": "Ramrati",
            "fatherName": "Anoop Singh",
            "obtainedMarks": "1198",
            "maxMarks": "1700",
            "percentage": "70.47%",
            "cells": [
              "53",
              "20090510025",
              "Ramrati",
              "Anoop Singh",
              "1198",
              "1700",
              "70.47%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "20090510027",
            "name": "Ritu",
            "fatherName": "Ranvir Singh",
            "obtainedMarks": "1232",
            "maxMarks": "1700",
            "percentage": "72.47%",
            "cells": [
              "54",
              "20090510027",
              "Ritu",
              "Ranvir Singh",
              "1232",
              "1700",
              "72.47%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "20090510029",
            "name": "Sakshi",
            "fatherName": "Balram Sharma",
            "obtainedMarks": "1216",
            "maxMarks": "1700",
            "percentage": "71.53%",
            "cells": [
              "55",
              "20090510029",
              "Sakshi",
              "Balram Sharma",
              "1216",
              "1700",
              "71.53%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "20090510031",
            "name": "Sangeeta Duhan",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "1226",
            "maxMarks": "1700",
            "percentage": "72.12%",
            "cells": [
              "56",
              "20090510031",
              "Sangeeta Duhan",
              "Suresh Kumar",
              "1226",
              "1700",
              "72.12%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "20090510041",
            "name": "Urmila Godara",
            "fatherName": "Lichhi Ram",
            "obtainedMarks": "1191",
            "maxMarks": "1700",
            "percentage": "70.06%",
            "cells": [
              "57",
              "20090510041",
              "Urmila Godara",
              "Lichhi Ram",
              "1191",
              "1700",
              "70.06%"
            ]
          }
        ]
      },
      {
        "courseName": "B.P.Ed. III+IV Sem",
        "hasMerit": true,
        "headers": [
          "Sr. No",
          "Roll No.",
          "Name",
          "Father's Name",
          "Marks",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "58",
            "rollNo": "190090510003",
            "name": "Anu Rani",
            "fatherName": "Ved Parkash",
            "obtainedMarks": "1171",
            "maxMarks": "1600",
            "percentage": "73.19%",
            "cells": [
              "58",
              "190090510003",
              "Anu Rani",
              "Ved Parkash",
              "1171",
              "1600",
              "73.19%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "190090510008",
            "name": "Pardeep",
            "fatherName": "Baldev Singh",
            "obtainedMarks": "1197",
            "maxMarks": "1600",
            "percentage": "74.81%",
            "cells": [
              "59",
              "190090510008",
              "Pardeep",
              "Baldev Singh",
              "1197",
              "1600",
              "74.81%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "190090510011",
            "name": "Pooja Pandey",
            "fatherName": "Uma Shankar Pandey",
            "obtainedMarks": "1124",
            "maxMarks": "1600",
            "percentage": "70.25%",
            "cells": [
              "60",
              "190090510011",
              "Pooja Pandey",
              "Uma Shankar Pandey",
              "1124",
              "1600",
              "70.25%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "190090510012",
            "name": "preeti",
            "fatherName": "Satish",
            "obtainedMarks": "1147",
            "maxMarks": "1600",
            "percentage": "71.69%",
            "cells": [
              "61",
              "190090510012",
              "preeti",
              "Satish",
              "1147",
              "1600",
              "71.69%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "190090510017",
            "name": "Saroj Bala",
            "fatherName": "Hari Singh",
            "obtainedMarks": "1236",
            "maxMarks": "1600",
            "percentage": "77.25%",
            "cells": [
              "62",
              "190090510017",
              "Saroj Bala",
              "Hari Singh",
              "1236",
              "1600",
              "77.25%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2021-22",
    "courses": [
      {
        "courseName": "B.A 1st  YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "21009115430006",
            "name": "RITIKA",
            "fatherName": "LADU RAM",
            "obtainedMarks": "688",
            "maxMarks": "975",
            "percentage": "70.56%",
            "cells": [
              "1",
              "21009115430006",
              "RITIKA",
              "LADU RAM",
              "688",
              "975",
              "70.56%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "21009115430013",
            "name": "POONAM",
            "fatherName": "KRISHAN",
            "obtainedMarks": "746",
            "maxMarks": "975",
            "percentage": "76.51%",
            "cells": [
              "2",
              "21009115430013",
              "POONAM",
              "KRISHAN",
              "746",
              "975",
              "76.51%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "21009115430015",
            "name": "AARTI",
            "fatherName": "UGGARSAIN",
            "obtainedMarks": "772",
            "maxMarks": "975",
            "percentage": "79.18%",
            "cells": [
              "3",
              "21009115430015",
              "AARTI",
              "UGGARSAIN",
              "772",
              "975",
              "79.18%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "21009115430035",
            "name": "ANCHAL",
            "fatherName": "SHER SINGH",
            "obtainedMarks": "698",
            "maxMarks": "975",
            "percentage": "71.59%",
            "cells": [
              "4",
              "21009115430035",
              "ANCHAL",
              "SHER SINGH",
              "698",
              "975",
              "71.59%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "21009115430043",
            "name": "VARSHA RANI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "700",
            "maxMarks": "975",
            "percentage": "71.79%",
            "cells": [
              "5",
              "21009115430043",
              "VARSHA RANI",
              "VIJAY KUMAR",
              "700",
              "975",
              "71.79%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "21009115430046",
            "name": "URMILA",
            "fatherName": "BHAGAT RAM",
            "obtainedMarks": "737",
            "maxMarks": "975",
            "percentage": "75.59%",
            "cells": [
              "6",
              "21009115430046",
              "URMILA",
              "BHAGAT RAM",
              "737",
              "975",
              "75.59%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "21009115430047",
            "name": "NEHA",
            "fatherName": "ATMA RAM",
            "obtainedMarks": "704",
            "maxMarks": "975",
            "percentage": "72.21%",
            "cells": [
              "7",
              "21009115430047",
              "NEHA",
              "ATMA RAM",
              "704",
              "975",
              "72.21%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "21009115430051",
            "name": "NEELAM RANI",
            "fatherName": "LAXMAN DASS",
            "obtainedMarks": "713",
            "maxMarks": "975",
            "percentage": "73.13%",
            "cells": [
              "8",
              "21009115430051",
              "NEELAM RANI",
              "LAXMAN DASS",
              "713",
              "975",
              "73.13%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "21009115430063",
            "name": "PREETI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "747",
            "maxMarks": "975",
            "percentage": "76.62%",
            "cells": [
              "9",
              "21009115430063",
              "PREETI",
              "RAMESH KUMAR",
              "747",
              "975",
              "76.62%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "21009115430076",
            "name": "RAJNI",
            "fatherName": "RATTAN SINGH",
            "obtainedMarks": "756",
            "maxMarks": "975",
            "percentage": "77.54%",
            "cells": [
              "10",
              "21009115430076",
              "RAJNI",
              "RATTAN SINGH",
              "756",
              "975",
              "77.54%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "21009115430077",
            "name": "SIMRAN",
            "fatherName": "DOLAT RAM",
            "obtainedMarks": "812",
            "maxMarks": "975",
            "percentage": "83.28%",
            "cells": [
              "11",
              "21009115430077",
              "SIMRAN",
              "DOLAT RAM",
              "812",
              "975",
              "83.28%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "21009115430081",
            "name": "SHALU",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "736",
            "maxMarks": "975",
            "percentage": "75.49%",
            "cells": [
              "12",
              "21009115430081",
              "SHALU",
              "VINOD KUMAR",
              "736",
              "975",
              "75.49%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "21009115430091",
            "name": "JAITAL",
            "fatherName": "BAJRANG",
            "obtainedMarks": "690",
            "maxMarks": "975",
            "percentage": "70.77%",
            "cells": [
              "13",
              "21009115430091",
              "JAITAL",
              "BAJRANG",
              "690",
              "975",
              "70.77%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "21009115430092",
            "name": "USHA RANI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "689",
            "maxMarks": "975",
            "percentage": "70.67%",
            "cells": [
              "14",
              "21009115430092",
              "USHA RANI",
              "VINOD KUMAR",
              "689",
              "975",
              "70.67%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "21009115430093",
            "name": "MANISHA",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "742",
            "maxMarks": "975",
            "percentage": "76.10%",
            "cells": [
              "15",
              "21009115430093",
              "MANISHA",
              "BHIM SINGH",
              "742",
              "975",
              "76.10%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "21009115430101",
            "name": "ARJU",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "740",
            "maxMarks": "975",
            "percentage": "75.90%",
            "cells": [
              "16",
              "21009115430101",
              "ARJU",
              "MAHENDER SINGH",
              "740",
              "975",
              "75.90%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "21009115430102",
            "name": "POOJA DEVI",
            "fatherName": "BALVINDER SINGH",
            "obtainedMarks": "792",
            "maxMarks": "975",
            "percentage": "81.23%",
            "cells": [
              "17",
              "21009115430102",
              "POOJA DEVI",
              "BALVINDER SINGH",
              "792",
              "975",
              "81.23%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "21009115430105",
            "name": "PRIYANKA",
            "fatherName": "BHAGWANT",
            "obtainedMarks": "730",
            "maxMarks": "975",
            "percentage": "74.87%",
            "cells": [
              "18",
              "21009115430105",
              "PRIYANKA",
              "BHAGWANT",
              "730",
              "975",
              "74.87%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "21009115430113",
            "name": "JAMNA DEVI",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "735",
            "maxMarks": "975",
            "percentage": "75.38%",
            "cells": [
              "19",
              "21009115430113",
              "JAMNA DEVI",
              "SUBHASH CHANDER",
              "735",
              "975",
              "75.38%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "21009115430114",
            "name": "BHAWNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "789",
            "maxMarks": "975",
            "percentage": "80.92%",
            "cells": [
              "20",
              "21009115430114",
              "BHAWNA",
              "KRISHAN KUMAR",
              "789",
              "975",
              "80.92%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "21009115430169",
            "name": "PRABHJOT KAUR",
            "fatherName": "SARWAN SINGH",
            "obtainedMarks": "716",
            "maxMarks": "975",
            "percentage": "73.44%",
            "cells": [
              "21",
              "21009115430169",
              "PRABHJOT KAUR",
              "SARWAN SINGH",
              "716",
              "975",
              "73.44%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "21009115430171",
            "name": "KASHIS DEVI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "705",
            "maxMarks": "975",
            "percentage": "72.31%",
            "cells": [
              "22",
              "21009115430171",
              "KASHIS DEVI",
              "VIJAY KUMAR",
              "705",
              "975",
              "72.31%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "21009115430181",
            "name": "DAYAWANTI",
            "fatherName": "DAYANAND",
            "obtainedMarks": "791",
            "maxMarks": "975",
            "percentage": "81.13%",
            "cells": [
              "23",
              "21009115430181",
              "DAYAWANTI",
              "DAYANAND",
              "791",
              "975",
              "81.13%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "21009115430186",
            "name": "SANIA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "720",
            "maxMarks": "975",
            "percentage": "73.85%",
            "cells": [
              "24",
              "21009115430186",
              "SANIA",
              "RAJ KUMAR",
              "720",
              "975",
              "73.85%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "21009115430187",
            "name": "ASHANDEEP KAUR",
            "fatherName": "JOGINDER SINGH",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.03%",
            "cells": [
              "25",
              "21009115430187",
              "ASHANDEEP KAUR",
              "JOGINDER SINGH",
              "712",
              "975",
              "73.03%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "21009115430188",
            "name": "PUSHPA",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "771",
            "maxMarks": "975",
            "percentage": "79.07%",
            "cells": [
              "26",
              "21009115430188",
              "PUSHPA",
              "RAM NIWAS",
              "771",
              "975",
              "79.07%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "21009115430190",
            "name": "ARZ INSAN",
            "fatherName": "AMARJEET",
            "obtainedMarks": "729",
            "maxMarks": "975",
            "percentage": "74.77%",
            "cells": [
              "27",
              "21009115430190",
              "ARZ INSAN",
              "AMARJEET",
              "729",
              "975",
              "74.77%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "21009115430192",
            "name": "RUCHI",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "700",
            "maxMarks": "975",
            "percentage": "71.79%",
            "cells": [
              "28",
              "21009115430192",
              "RUCHI",
              "SURENDER SINGH",
              "700",
              "975",
              "71.79%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "21009115430193",
            "name": "LOVEPREET KAUR",
            "fatherName": "JASVIR SINGH",
            "obtainedMarks": "790",
            "maxMarks": "975",
            "percentage": "81.03%",
            "cells": [
              "29",
              "21009115430193",
              "LOVEPREET KAUR",
              "JASVIR SINGH",
              "790",
              "975",
              "81.03%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "21009115430194",
            "name": "ARZOO",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "810",
            "maxMarks": "975",
            "percentage": "83.08%",
            "cells": [
              "30",
              "21009115430194",
              "ARZOO",
              "ANIL KUMAR",
              "810",
              "975",
              "83.08%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "21009115430201",
            "name": "ASMI",
            "fatherName": "PARVEEN KUMAR",
            "obtainedMarks": "730",
            "maxMarks": "975",
            "percentage": "74.87%",
            "cells": [
              "31",
              "21009115430201",
              "ASMI",
              "PARVEEN KUMAR",
              "730",
              "975",
              "74.87%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "21009115430202",
            "name": "NISHU",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "759",
            "maxMarks": "975",
            "percentage": "77.85%",
            "cells": [
              "32",
              "21009115430202",
              "NISHU",
              "SUBHASH CHANDER",
              "759",
              "975",
              "77.85%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "21009115430204",
            "name": "KANISHKA",
            "fatherName": "INDERJEET",
            "obtainedMarks": "778",
            "maxMarks": "975",
            "percentage": "79.79%",
            "cells": [
              "33",
              "21009115430204",
              "KANISHKA",
              "INDERJEET",
              "778",
              "975",
              "79.79%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "21009115430208",
            "name": "MONIKA SHARMA",
            "fatherName": "MUKESH KUMAR",
            "obtainedMarks": "759",
            "maxMarks": "975",
            "percentage": "77.85%",
            "cells": [
              "34",
              "21009115430208",
              "MONIKA SHARMA",
              "MUKESH KUMAR",
              "759",
              "975",
              "77.85%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "21009115430211",
            "name": "SILVNEET SIDHU",
            "fatherName": "RANVIR SINGH RANA",
            "obtainedMarks": "739",
            "maxMarks": "975",
            "percentage": "75.79%",
            "cells": [
              "35",
              "21009115430211",
              "SILVNEET SIDHU",
              "RANVIR SINGH RANA",
              "739",
              "975",
              "75.79%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "21009115430212",
            "name": "DIKSHA",
            "fatherName": "PREM CHAND",
            "obtainedMarks": "705",
            "maxMarks": "975",
            "percentage": "72.31%",
            "cells": [
              "36",
              "21009115430212",
              "DIKSHA",
              "PREM CHAND",
              "705",
              "975",
              "72.31%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "21009115430214",
            "name": "HARJOT KAUR",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "739",
            "maxMarks": "975",
            "percentage": "75.79%",
            "cells": [
              "37",
              "21009115430214",
              "HARJOT KAUR",
              "GURJANT SINGH",
              "739",
              "975",
              "75.79%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "21009115430216",
            "name": "KOMAL RANI",
            "fatherName": "ARJUN DASS",
            "obtainedMarks": "713",
            "maxMarks": "975",
            "percentage": "73.13%",
            "cells": [
              "38",
              "21009115430216",
              "KOMAL RANI",
              "ARJUN DASS",
              "713",
              "975",
              "73.13%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "21009115430236",
            "name": "HARMANPREET KAUR",
            "fatherName": "BALJIT SINGH",
            "obtainedMarks": "749",
            "maxMarks": "975",
            "percentage": "76.82%",
            "cells": [
              "39",
              "21009115430236",
              "HARMANPREET KAUR",
              "BALJIT SINGH",
              "749",
              "975",
              "76.82%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "21009115430262",
            "name": "PARGATI",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "805",
            "maxMarks": "975",
            "percentage": "82.56%",
            "cells": [
              "40",
              "21009115430262",
              "PARGATI",
              "SURENDER SINGH",
              "805",
              "975",
              "82.56%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A 2ND YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "41",
            "rollNo": "00200090430006",
            "name": "ANKITA",
            "fatherName": "DRIYA SINGH",
            "obtainedMarks": "683",
            "maxMarks": "900",
            "percentage": "75.89%",
            "cells": [
              "41",
              "00200090430006",
              "ANKITA",
              "DRIYA SINGH",
              "683",
              "900",
              "75.89%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "00200090430010",
            "name": "ANU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "42",
              "00200090430010",
              "ANU",
              "PAWAN KUMAR",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "00200090430020",
            "name": "CHETNA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "644",
            "maxMarks": "900",
            "percentage": "71.56%",
            "cells": [
              "43",
              "00200090430020",
              "CHETNA",
              "SHAMSHER SINGH",
              "644",
              "900",
              "71.56%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "00200090430024",
            "name": "EKTA",
            "fatherName": "PALVINDER",
            "obtainedMarks": "719",
            "maxMarks": "900",
            "percentage": "79.89%",
            "cells": [
              "44",
              "00200090430024",
              "EKTA",
              "PALVINDER",
              "719",
              "900",
              "79.89%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "00200090430025",
            "name": "ESHA CHOUDHARY",
            "fatherName": "DEEPAK KUMAR",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "45",
              "00200090430025",
              "ESHA CHOUDHARY",
              "DEEPAK KUMAR",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "00200090430031",
            "name": "HIMANSHU",
            "fatherName": "RADHE SHYAM",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "46",
              "00200090430031",
              "HIMANSHU",
              "RADHE SHYAM",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "00200090430036",
            "name": "JIGYASHA",
            "fatherName": "RAJNEESH KUMAR",
            "obtainedMarks": "715",
            "maxMarks": "900",
            "percentage": "79.44%",
            "cells": [
              "47",
              "00200090430036",
              "JIGYASHA",
              "RAJNEESH KUMAR",
              "715",
              "900",
              "79.44%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "00200090430040",
            "name": "KALPANA RANI",
            "fatherName": "RAJPAL",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "48",
              "00200090430040",
              "KALPANA RANI",
              "RAJPAL",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "00200090430042",
            "name": "KASHISH",
            "fatherName": "BHAJAN LAL",
            "obtainedMarks": "668",
            "maxMarks": "900",
            "percentage": "74.22%",
            "cells": [
              "49",
              "00200090430042",
              "KASHISH",
              "BHAJAN LAL",
              "668",
              "900",
              "74.22%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "00200090430049",
            "name": "KHUSHMAN KAUR",
            "fatherName": "PARAMPAL SINGH",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "50",
              "00200090430049",
              "KHUSHMAN KAUR",
              "PARAMPAL SINGH",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "00200090430065",
            "name": "MANISHA KAMBOJ",
            "fatherName": "SATNAM CHAND",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "51",
              "00200090430065",
              "MANISHA KAMBOJ",
              "SATNAM CHAND",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "00200090430067",
            "name": "MANJU BALA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "52",
              "00200090430067",
              "MANJU BALA",
              "VIJAY SINGH",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "00200090430071",
            "name": "MINAL",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "686",
            "maxMarks": "900",
            "percentage": "76.22%",
            "cells": [
              "53",
              "00200090430071",
              "MINAL",
              "VED PARKASH",
              "686",
              "900",
              "76.22%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "00200090430072",
            "name": "MONIKA",
            "fatherName": "DHARM SINGH",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "54",
              "00200090430072",
              "MONIKA",
              "DHARM SINGH",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "00200090430075",
            "name": "MONIKA",
            "fatherName": "SURENDER",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "55",
              "00200090430075",
              "MONIKA",
              "SURENDER",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "00200090430087",
            "name": "NISHA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "56",
              "00200090430087",
              "NISHA",
              "RAJENDER",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "00200090430093",
            "name": "POOJA",
            "fatherName": "SUSHIL",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "57",
              "00200090430093",
              "POOJA",
              "SUSHIL",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "00200090430096",
            "name": "POONAM RANI",
            "fatherName": "CHARAN DASS",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "58",
              "00200090430096",
              "POONAM RANI",
              "CHARAN DASS",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "00200090430104",
            "name": "PRIYANKA",
            "fatherName": "DEVILAL",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "59",
              "00200090430104",
              "PRIYANKA",
              "DEVILAL",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "00200090430113",
            "name": "RASHI KUMARI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "60",
              "00200090430113",
              "RASHI KUMARI",
              "SURENDER KUMAR",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "00200090430115",
            "name": "REKHA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "61",
              "00200090430115",
              "REKHA",
              "MOHAN LAL",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "00200090430124",
            "name": "RITU",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "731",
            "maxMarks": "900",
            "percentage": "81.22%",
            "cells": [
              "62",
              "00200090430124",
              "RITU",
              "SUSHIL KUMAR",
              "731",
              "900",
              "81.22%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "00200090430125",
            "name": "RITU BALA",
            "fatherName": "VEDPAL",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "63",
              "00200090430125",
              "RITU BALA",
              "VEDPAL",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "00200090430127",
            "name": "SAMESTA DEVI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "64",
              "00200090430127",
              "SAMESTA DEVI",
              "VINOD KUMAR",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "00200090430128",
            "name": "SANDEEP KAUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.67%",
            "cells": [
              "65",
              "00200090430128",
              "SANDEEP KAUR",
              "GURMAIL SINGH",
              "645",
              "900",
              "71.67%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "00200090430131",
            "name": "SANJU",
            "fatherName": "SATVEER SINGH",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.78%",
            "cells": [
              "66",
              "00200090430131",
              "SANJU",
              "SATVEER SINGH",
              "700",
              "900",
              "77.78%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "00200090430135",
            "name": "SAROJ",
            "fatherName": "DALIP",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "67",
              "00200090430135",
              "SAROJ",
              "DALIP",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "00200090430136",
            "name": "SARVMISHTHA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "68",
              "00200090430136",
              "SARVMISHTHA",
              "KRISHAN KUMAR",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "00200090430137",
            "name": "SEEMA",
            "fatherName": "NARESH GOYAL",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "69",
              "00200090430137",
              "SEEMA",
              "NARESH GOYAL",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "00200090430146",
            "name": "SIMRAN",
            "fatherName": "SURESH",
            "obtainedMarks": "699",
            "maxMarks": "900",
            "percentage": "77.67%",
            "cells": [
              "70",
              "00200090430146",
              "SIMRAN",
              "SURESH",
              "699",
              "900",
              "77.67%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "00200090430161",
            "name": "TAMANNA",
            "fatherName": "BALJIT SINGH",
            "obtainedMarks": "688",
            "maxMarks": "900",
            "percentage": "76.44%",
            "cells": [
              "71",
              "00200090430161",
              "TAMANNA",
              "BALJIT SINGH",
              "688",
              "900",
              "76.44%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A 3RD YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "72",
            "rollNo": "00190090430006",
            "name": "ANNU",
            "fatherName": "SURESHKUMAR",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "72",
              "00190090430006",
              "ANNU",
              "SURESHKUMAR",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "00190090430009",
            "name": "ARSHDEEP KAUR",
            "fatherName": "KIRPAL SINGH",
            "obtainedMarks": "713",
            "maxMarks": "900",
            "percentage": "79.22%",
            "cells": [
              "73",
              "00190090430009",
              "ARSHDEEP KAUR",
              "KIRPAL SINGH",
              "713",
              "900",
              "79.22%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "00190090430012",
            "name": "ASHA RANI",
            "fatherName": "DALEL",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "74",
              "00190090430012",
              "ASHA RANI",
              "DALEL",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "00190090430018",
            "name": "GARIMA RANI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "644",
            "maxMarks": "900",
            "percentage": "71.56%",
            "cells": [
              "75",
              "00190090430018",
              "GARIMA RANI",
              "SURENDER KUMAR",
              "644",
              "900",
              "71.56%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "00190090430019",
            "name": "GURPREET",
            "fatherName": "DEVIPAL",
            "obtainedMarks": "710",
            "maxMarks": "900",
            "percentage": "78.89%",
            "cells": [
              "76",
              "00190090430019",
              "GURPREET",
              "DEVIPAL",
              "710",
              "900",
              "78.89%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "00190090430020",
            "name": "HARPREET KAUR",
            "fatherName": "GURCHARAN SINGH",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "77",
              "00190090430020",
              "HARPREET KAUR",
              "GURCHARAN SINGH",
              "632",
              "900",
              "70.22%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "00190090430024",
            "name": "KAVITA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "711",
            "maxMarks": "900",
            "percentage": "79%",
            "cells": [
              "78",
              "00190090430024",
              "KAVITA",
              "SUBHASH CHANDER",
              "711",
              "900",
              "79%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "00190090430027",
            "name": "KAVITA RANI",
            "fatherName": "RAM PRAKASH",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "79",
              "00190090430027",
              "KAVITA RANI",
              "RAM PRAKASH",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "00190090430030",
            "name": "KIRAN",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "735",
            "maxMarks": "900",
            "percentage": "81.67%",
            "cells": [
              "80",
              "00190090430030",
              "KIRAN",
              "SAHAB RAM",
              "735",
              "900",
              "81.67%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "00190090430031",
            "name": "KIRAN",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "81",
              "00190090430031",
              "KIRAN",
              "RAM SINGH",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "00190090430032",
            "name": "KOMAL RANI",
            "fatherName": "RAJBIR",
            "obtainedMarks": "732",
            "maxMarks": "900",
            "percentage": "81.33%",
            "cells": [
              "82",
              "00190090430032",
              "KOMAL RANI",
              "RAJBIR",
              "732",
              "900",
              "81.33%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "00190090430035",
            "name": "LALITA",
            "fatherName": "SUGREEM CHAND",
            "obtainedMarks": "683",
            "maxMarks": "900",
            "percentage": "75.89%",
            "cells": [
              "83",
              "00190090430035",
              "LALITA",
              "SUGREEM CHAND",
              "683",
              "900",
              "75.89%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "00190090430037",
            "name": "MAMTA RANI",
            "fatherName": "RAM CHANDER",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "84",
              "00190090430037",
              "MAMTA RANI",
              "RAM CHANDER",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "00190090430038",
            "name": "MANISHA",
            "fatherName": "RAJESH",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "85",
              "00190090430038",
              "MANISHA",
              "RAJESH",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "00190090430041",
            "name": "MANJU",
            "fatherName": "RAMRAKH",
            "obtainedMarks": "675",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "86",
              "00190090430041",
              "MANJU",
              "RAMRAKH",
              "675",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "00190090430044",
            "name": "MUSKAN INSAN",
            "fatherName": "MANOJ KUMAR",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "87",
              "00190090430044",
              "MUSKAN INSAN",
              "MANOJ KUMAR",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "00190090430054",
            "name": "NISHA",
            "fatherName": "MANSWAROOP",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "88",
              "00190090430054",
              "NISHA",
              "MANSWAROOP",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "00190090430058",
            "name": "SIMRAN",
            "fatherName": "DHARMINDER KUMAR",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.67%",
            "cells": [
              "89",
              "00190090430058",
              "SIMRAN",
              "DHARMINDER KUMAR",
              "645",
              "900",
              "71.67%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "00190090430063",
            "name": "POOJA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "90",
              "00190090430063",
              "POOJA",
              "MAHENDER SINGH",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "00190090430065",
            "name": "POOJA",
            "fatherName": "SUBASH",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "91",
              "00190090430065",
              "POOJA",
              "SUBASH",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "00190090430070",
            "name": "PRAMILA",
            "fatherName": "RAVINDER SINGH",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "92",
              "00190090430070",
              "PRAMILA",
              "RAVINDER SINGH",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "00190090430075",
            "name": "PRIYANKA",
            "fatherName": "HARPAL SINGH",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "93",
              "00190090430075",
              "PRIYANKA",
              "HARPAL SINGH",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "00190090430081",
            "name": "RAJNI KAUR",
            "fatherName": "BINDER SINGH",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "94",
              "00190090430081",
              "RAJNI KAUR",
              "BINDER SINGH",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "00190090430083",
            "name": "RAMNEET KAUR",
            "fatherName": "SATPAL SINGH",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "95",
              "00190090430083",
              "RAMNEET KAUR",
              "SATPAL SINGH",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "00190090430086",
            "name": "RENU",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "96",
              "00190090430086",
              "RENU",
              "PRITHVI SINGH",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "00190090430087",
            "name": "RENU BALA",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "97",
              "00190090430087",
              "RENU BALA",
              "BANWARI LAL",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "00190090430089",
            "name": "RINKI",
            "fatherName": "PARKASH KUMAR",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "98",
              "00190090430089",
              "RINKI",
              "PARKASH KUMAR",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "00190090430092",
            "name": "RITU",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "99",
              "00190090430092",
              "RITU",
              "SAHAB RAM",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "00190090430095",
            "name": "SANDHYA",
            "fatherName": "AJMER SINGH",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "100",
              "00190090430095",
              "SANDHYA",
              "AJMER SINGH",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "00190090430096",
            "name": "SANEHA",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "101",
              "00190090430096",
              "SANEHA",
              "ANIL KUMAR",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "00190090430097",
            "name": "SANJANA",
            "fatherName": "ROHTASH KUMAR",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "102",
              "00190090430097",
              "SANJANA",
              "ROHTASH KUMAR",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "00190090430098",
            "name": "SANJANA SINGH",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "699",
            "maxMarks": "900",
            "percentage": "77.67%",
            "cells": [
              "103",
              "00190090430098",
              "SANJANA SINGH",
              "RAN SINGH",
              "699",
              "900",
              "77.67%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "00190090430100",
            "name": "SAROJ",
            "fatherName": "HANUMAN",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "104",
              "00190090430100",
              "SAROJ",
              "HANUMAN",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "00190090430103",
            "name": "SHALU DEVI",
            "fatherName": "RAJPAL",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "105",
              "00190090430103",
              "SHALU DEVI",
              "RAJPAL",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "00190090430106",
            "name": "SHEETAL",
            "fatherName": "BHAGWAN SINGH",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "106",
              "00190090430106",
              "SHEETAL",
              "BHAGWAN SINGH",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "00190090430110",
            "name": "SIMRAN MEHTA",
            "fatherName": "KAMAL MEHTA",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "107",
              "00190090430110",
              "SIMRAN MEHTA",
              "KAMAL MEHTA",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "00190090430113",
            "name": "SUKHPREET KAUR",
            "fatherName": "BALKOUR SINGH",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "108",
              "00190090430113",
              "SUKHPREET KAUR",
              "BALKOUR SINGH",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "00190090430114",
            "name": "SUMAN",
            "fatherName": "SATPAL",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "109",
              "00190090430114",
              "SUMAN",
              "SATPAL",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "00190090430124",
            "name": "SUSHILA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "733",
            "maxMarks": "900",
            "percentage": "81.44%",
            "cells": [
              "110",
              "00190090430124",
              "SUSHILA",
              "MOHAN LAL",
              "733",
              "900",
              "81.44%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "111",
            "rollNo": "21009115442001",
            "name": "JYOTI",
            "fatherName": "MAHABIR",
            "obtainedMarks": "938",
            "maxMarks": "1175",
            "percentage": "79.83%",
            "cells": [
              "111",
              "21009115442001",
              "JYOTI",
              "MAHABIR",
              "938",
              "1175",
              "79.83%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "21009115442014",
            "name": "MONIKA",
            "fatherName": "SHALENDER KUMAR",
            "obtainedMarks": "924",
            "maxMarks": "1175",
            "percentage": "78.64%",
            "cells": [
              "112",
              "21009115442014",
              "MONIKA",
              "SHALENDER KUMAR",
              "924",
              "1175",
              "78.64%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "21009115442018",
            "name": "ANU",
            "fatherName": "SURESH",
            "obtainedMarks": "859",
            "maxMarks": "1175",
            "percentage": "73.11%",
            "cells": [
              "113",
              "21009115442018",
              "ANU",
              "SURESH",
              "859",
              "1175",
              "73.11%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "21009115442021",
            "name": "ANCHAL",
            "fatherName": "LALCHAND",
            "obtainedMarks": "870",
            "maxMarks": "1175",
            "percentage": "74.04%",
            "cells": [
              "114",
              "21009115442021",
              "ANCHAL",
              "LALCHAND",
              "870",
              "1175",
              "74.04%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "21009115442023",
            "name": "NEELAM",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "771",
            "maxMarks": "1175",
            "percentage": "65.62%",
            "cells": [
              "115",
              "21009115442023",
              "NEELAM",
              "RAKESH KUMAR",
              "771",
              "1175",
              "65.62%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "21009115442027",
            "name": "PUSHPA RANI",
            "fatherName": "BALDEV SINGH",
            "obtainedMarks": "942",
            "maxMarks": "1175",
            "percentage": "80.17%",
            "cells": [
              "116",
              "21009115442027",
              "PUSHPA RANI",
              "BALDEV SINGH",
              "942",
              "1175",
              "80.17%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "21009115442029",
            "name": "KALPANA DEVI",
            "fatherName": "JASWANT SINGH",
            "obtainedMarks": "865",
            "maxMarks": "1175",
            "percentage": "73.62%",
            "cells": [
              "117",
              "21009115442029",
              "KALPANA DEVI",
              "JASWANT SINGH",
              "865",
              "1175",
              "73.62%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "21009115442032",
            "name": "NATASHA",
            "fatherName": "PIARA LAL",
            "obtainedMarks": "807",
            "maxMarks": "1175",
            "percentage": "68.68%",
            "cells": [
              "118",
              "21009115442032",
              "NATASHA",
              "PIARA LAL",
              "807",
              "1175",
              "68.68%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "21009115442041",
            "name": "LAKSHIKA",
            "fatherName": "RAJBIR",
            "obtainedMarks": "848",
            "maxMarks": "1175",
            "percentage": "72.17%",
            "cells": [
              "119",
              "21009115442041",
              "LAKSHIKA",
              "RAJBIR",
              "848",
              "1175",
              "72.17%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "21009115442046",
            "name": "EKTA",
            "fatherName": "SADHU RAM",
            "obtainedMarks": "856",
            "maxMarks": "1175",
            "percentage": "72.85%",
            "cells": [
              "120",
              "21009115442046",
              "EKTA",
              "SADHU RAM",
              "856",
              "1175",
              "72.85%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "21009115442047",
            "name": "PRIYANKA",
            "fatherName": "BALDEV SINGH",
            "obtainedMarks": "882",
            "maxMarks": "1175",
            "percentage": "75.06%",
            "cells": [
              "121",
              "21009115442047",
              "PRIYANKA",
              "BALDEV SINGH",
              "882",
              "1175",
              "75.06%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc II Year (nm)",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "122",
            "rollNo": "00200090442001",
            "name": "ASHIMA",
            "fatherName": "JUG LAL",
            "obtainedMarks": "778",
            "maxMarks": "1100",
            "percentage": "70.73%",
            "cells": [
              "122",
              "00200090442001",
              "ASHIMA",
              "JUG LAL",
              "778",
              "1100",
              "70.73%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "00200090442004",
            "name": "ISHA",
            "fatherName": "INDERPAL",
            "obtainedMarks": "846",
            "maxMarks": "1100",
            "percentage": "76.91%",
            "cells": [
              "123",
              "00200090442004",
              "ISHA",
              "INDERPAL",
              "846",
              "1100",
              "76.91%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "00200090442010",
            "name": "MAHAK",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "840",
            "maxMarks": "1100",
            "percentage": "76.36%",
            "cells": [
              "124",
              "00200090442010",
              "MAHAK",
              "SURINDER KUMAR",
              "840",
              "1100",
              "76.36%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "00200090442018",
            "name": "NIPAKSHI SHARMA",
            "fatherName": "SHREE BHAGWAN",
            "obtainedMarks": "796",
            "maxMarks": "1100",
            "percentage": "72.36%",
            "cells": [
              "125",
              "00200090442018",
              "NIPAKSHI SHARMA",
              "SHREE BHAGWAN",
              "796",
              "1100",
              "72.36%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "00200090442020",
            "name": "PRIYANKA",
            "fatherName": "BALJINDER KUMAR",
            "obtainedMarks": "836",
            "maxMarks": "1100",
            "percentage": "76%",
            "cells": [
              "126",
              "00200090442020",
              "PRIYANKA",
              "BALJINDER KUMAR",
              "836",
              "1100",
              "76%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "00200090442022",
            "name": "RAMANDEEP KAUR",
            "fatherName": "JAGSIR SINGH",
            "obtainedMarks": "878",
            "maxMarks": "1100",
            "percentage": "79.82%",
            "cells": [
              "127",
              "00200090442022",
              "RAMANDEEP KAUR",
              "JAGSIR SINGH",
              "878",
              "1100",
              "79.82%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "00200090442027",
            "name": "SHIWANI",
            "fatherName": "LILU RAM",
            "obtainedMarks": "782",
            "maxMarks": "1100",
            "percentage": "71.09%",
            "cells": [
              "128",
              "00200090442027",
              "SHIWANI",
              "LILU RAM",
              "782",
              "1100",
              "71.09%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "00200090442028",
            "name": "SNEHA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "852",
            "maxMarks": "1100",
            "percentage": "77.45%",
            "cells": [
              "129",
              "00200090442028",
              "SNEHA",
              "MADAN LAL",
              "852",
              "1100",
              "77.45%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc(cs) II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "130",
            "rollNo": "200090440005",
            "name": "khushpreet kaur",
            "fatherName": "baljeet singh",
            "obtainedMarks": "801",
            "maxMarks": "1100",
            "percentage": "72.81%",
            "cells": [
              "130",
              "200090440005",
              "khushpreet kaur",
              "baljeet singh",
              "801",
              "1100",
              "72.81%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "131",
            "rollNo": "00190090442002",
            "name": "ANU DEVI",
            "fatherName": "UMED KUMAR",
            "obtainedMarks": "739",
            "maxMarks": "1000",
            "percentage": "73.90%",
            "cells": [
              "131",
              "00190090442002",
              "ANU DEVI",
              "UMED KUMAR",
              "739",
              "1000",
              "73.90%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "00190090442003",
            "name": "ARJU",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "758",
            "maxMarks": "1000",
            "percentage": "75.80%",
            "cells": [
              "132",
              "00190090442003",
              "ARJU",
              "SURENDER KUMAR",
              "758",
              "1000",
              "75.80%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "00190090442004",
            "name": "DURGA",
            "fatherName": "RATAN SINGH",
            "obtainedMarks": "727",
            "maxMarks": "1000",
            "percentage": "72.70%",
            "cells": [
              "133",
              "00190090442004",
              "DURGA",
              "RATAN SINGH",
              "727",
              "1000",
              "72.70%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "00190090442005",
            "name": "KASHISH INSAN",
            "fatherName": "JAI KISHAN",
            "obtainedMarks": "742",
            "maxMarks": "1000",
            "percentage": "74.20%",
            "cells": [
              "134",
              "00190090442005",
              "KASHISH INSAN",
              "JAI KISHAN",
              "742",
              "1000",
              "74.20%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "00190090442013",
            "name": "PRITI",
            "fatherName": "LEELU RAM",
            "obtainedMarks": "789",
            "maxMarks": "1000",
            "percentage": "78.90%",
            "cells": [
              "135",
              "00190090442013",
              "PRITI",
              "LEELU RAM",
              "789",
              "1000",
              "78.90%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "00190090442014",
            "name": "SAKSHI",
            "fatherName": "BALBIR",
            "obtainedMarks": "790",
            "maxMarks": "1000",
            "percentage": "79%",
            "cells": [
              "136",
              "00190090442014",
              "SAKSHI",
              "BALBIR",
              "790",
              "1000",
              "79%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "00190090442020",
            "name": "SUKHPYAR",
            "fatherName": "BRIJLAL",
            "obtainedMarks": "725",
            "maxMarks": "1000",
            "percentage": "72.50%",
            "cells": [
              "137",
              "00190090442020",
              "SUKHPYAR",
              "BRIJLAL",
              "725",
              "1000",
              "72.50%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (cs) III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "138",
            "rollNo": "00190090440006",
            "name": "NEETU",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "714",
            "maxMarks": "1000",
            "percentage": "71.40%",
            "cells": [
              "138",
              "00190090440006",
              "NEETU",
              "RAMESH KUMAR",
              "714",
              "1000",
              "71.40%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "00190090440010",
            "name": "REEYA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "717",
            "maxMarks": "1000",
            "percentage": "71.70%",
            "cells": [
              "139",
              "00190090440010",
              "REEYA",
              "VIJAY KUMAR",
              "717",
              "1000",
              "71.70%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "00190090440011",
            "name": "SUMAN BALA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "701",
            "maxMarks": "1000",
            "percentage": "70.10%",
            "cells": [
              "140",
              "00190090440011",
              "SUMAN BALA",
              "MAHENDER SINGH",
              "701",
              "1000",
              "70.10%"
            ]
          }
        ]
      },
      {
        "courseName": "b.com (Gen)1st Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "141",
            "rollNo": "21009115450005",
            "name": "SUMAN",
            "fatherName": "mahender pal",
            "obtainedMarks": "829",
            "maxMarks": "1150",
            "percentage": "72.08%",
            "cells": [
              "141",
              "21009115450005",
              "SUMAN",
              "mahender pal",
              "829",
              "1150",
              "72.08%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "21009115450006",
            "name": "kanisha",
            "fatherName": "bhim sain",
            "obtainedMarks": "848",
            "maxMarks": "1150",
            "percentage": "73.73%",
            "cells": [
              "142",
              "21009115450006",
              "kanisha",
              "bhim sain",
              "848",
              "1150",
              "73.73%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "21009115450012",
            "name": "surya",
            "fatherName": "subhash chander",
            "obtainedMarks": "861",
            "maxMarks": "1150",
            "percentage": "74.86%",
            "cells": [
              "143",
              "21009115450012",
              "surya",
              "subhash chander",
              "861",
              "1150",
              "74.86%"
            ]
          }
        ]
      },
      {
        "courseName": "B.com (Voc)1st Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "144",
            "rollNo": "21009115460015",
            "name": "parul",
            "fatherName": "kulbir",
            "obtainedMarks": "819",
            "maxMarks": "1150",
            "percentage": "71.21%",
            "cells": [
              "144",
              "21009115460015",
              "parul",
              "kulbir",
              "819",
              "1150",
              "71.21%"
            ]
          }
        ]
      },
      {
        "courseName": "B.com (Gen)2nd  Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.com (Voc)2nd  Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.com (Gen)3rd Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "145",
            "rollNo": "190090450005",
            "name": "bhawna",
            "fatherName": "amrish kumar",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "74.66%",
            "cells": [
              "145",
              "190090450005",
              "bhawna",
              "amrish kumar",
              "896",
              "1200",
              "74.66%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "190090450012",
            "name": "harmeet kaur",
            "fatherName": "shajinder singh",
            "obtainedMarks": "948",
            "maxMarks": "1200",
            "percentage": "79%",
            "cells": [
              "146",
              "190090450012",
              "harmeet kaur",
              "shajinder singh",
              "948",
              "1200",
              "79%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "190090450017",
            "name": "mamta rani",
            "fatherName": "sukhbir singh",
            "obtainedMarks": "878",
            "maxMarks": "1200",
            "percentage": "73.16%",
            "cells": [
              "147",
              "190090450017",
              "mamta rani",
              "sukhbir singh",
              "878",
              "1200",
              "73.16%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "190090450018",
            "name": "manisha rani",
            "fatherName": "suresh kumar",
            "obtainedMarks": "919",
            "maxMarks": "1200",
            "percentage": "76.58%",
            "cells": [
              "148",
              "190090450018",
              "manisha rani",
              "suresh kumar",
              "919",
              "1200",
              "76.58%"
            ]
          },
          {
            "sNo": "149",
            "rollNo": "190090450029",
            "name": "sandhaya",
            "fatherName": "rajesh kumar",
            "obtainedMarks": "937",
            "maxMarks": "1200",
            "percentage": "78.08%",
            "cells": [
              "149",
              "190090450029",
              "sandhaya",
              "rajesh kumar",
              "937",
              "1200",
              "78.08%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "190090450034",
            "name": "sugandh",
            "fatherName": "rakesh kumar dhawan",
            "obtainedMarks": "896",
            "maxMarks": "1200",
            "percentage": "74.06%",
            "cells": [
              "150",
              "190090450034",
              "sugandh",
              "rakesh kumar dhawan",
              "896",
              "1200",
              "74.06%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "190090450037",
            "name": "tanya",
            "fatherName": "jagdish kumar",
            "obtainedMarks": "852",
            "maxMarks": "1200",
            "percentage": "71%",
            "cells": [
              "151",
              "190090450037",
              "tanya",
              "jagdish kumar",
              "852",
              "1200",
              "71%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "190090450038",
            "name": "vaishali soni",
            "fatherName": "ashok kumar",
            "obtainedMarks": "866",
            "maxMarks": "1200",
            "percentage": "72.16%",
            "cells": [
              "152",
              "190090450038",
              "vaishali soni",
              "ashok kumar",
              "866",
              "1200",
              "72.16%"
            ]
          }
        ]
      },
      {
        "courseName": "B.com (Voc)3rd  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "153",
            "rollNo": "190090460001",
            "name": "akshdeep kaur",
            "fatherName": "gurdat singh",
            "obtainedMarks": "874",
            "maxMarks": "1150",
            "percentage": "76%",
            "cells": [
              "153",
              "190090460001",
              "akshdeep kaur",
              "gurdat singh",
              "874",
              "1150",
              "76%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "190090460011",
            "name": "rakhi",
            "fatherName": "raj kumar",
            "obtainedMarks": "818",
            "maxMarks": "1150",
            "percentage": "71.13%",
            "cells": [
              "154",
              "190090460011",
              "rakhi",
              "raj kumar",
              "818",
              "1150",
              "71.13%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC 1st Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "155",
            "rollNo": "21009115420001",
            "name": "TANNU",
            "fatherName": "AJMER",
            "obtainedMarks": "666",
            "maxMarks": "925",
            "percentage": "72%",
            "cells": [
              "155",
              "21009115420001",
              "TANNU",
              "AJMER",
              "666",
              "925",
              "72%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "21009115420003",
            "name": "TANU BALA",
            "fatherName": "LAXMI NARAYAN",
            "obtainedMarks": "683",
            "maxMarks": "925",
            "percentage": "73.84%",
            "cells": [
              "156",
              "21009115420003",
              "TANU BALA",
              "LAXMI NARAYAN",
              "683",
              "925",
              "73.84%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "21009115420014",
            "name": "SUMAN DEVI",
            "fatherName": "RAGHUBIR SINGH",
            "obtainedMarks": "675",
            "maxMarks": "925",
            "percentage": "72.97%",
            "cells": [
              "157",
              "21009115420014",
              "SUMAN DEVI",
              "RAGHUBIR SINGH",
              "675",
              "925",
              "72.97%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "21009115420015",
            "name": "KAJAL",
            "fatherName": "SATPAL",
            "obtainedMarks": "674",
            "maxMarks": "925",
            "percentage": "72.86%",
            "cells": [
              "158",
              "21009115420015",
              "KAJAL",
              "SATPAL",
              "674",
              "925",
              "72.86%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "21009115420017",
            "name": "MANISHA",
            "fatherName": "MADAL LAL",
            "obtainedMarks": "658",
            "maxMarks": "925",
            "percentage": "71.14%",
            "cells": [
              "159",
              "21009115420017",
              "MANISHA",
              "MADAL LAL",
              "658",
              "925",
              "71.14%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "21009115420018",
            "name": "JYOTI",
            "fatherName": "BALBIR",
            "obtainedMarks": "688",
            "maxMarks": "925",
            "percentage": "74.38%",
            "cells": [
              "160",
              "21009115420018",
              "JYOTI",
              "BALBIR",
              "688",
              "925",
              "74.38%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "21009115420019",
            "name": "RAVNEET KAUR",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "695",
            "maxMarks": "925",
            "percentage": "75.14%",
            "cells": [
              "161",
              "21009115420019",
              "RAVNEET KAUR",
              "SHYAM LAL",
              "695",
              "925",
              "75.14%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "21009115420020",
            "name": "BHAVNA MEHTA",
            "fatherName": "AJAY MEHTA",
            "obtainedMarks": "677",
            "maxMarks": "925",
            "percentage": "73.19%",
            "cells": [
              "162",
              "21009115420020",
              "BHAVNA MEHTA",
              "AJAY MEHTA",
              "677",
              "925",
              "73.19%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "21009115420021",
            "name": "HARSHITA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "685",
            "maxMarks": "925",
            "percentage": "74.05%",
            "cells": [
              "163",
              "21009115420021",
              "HARSHITA",
              "VINOD KUMAR",
              "685",
              "925",
              "74.05%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "21009115420024",
            "name": "NISHA",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "704",
            "maxMarks": "925",
            "percentage": "76.11%",
            "cells": [
              "164",
              "21009115420024",
              "NISHA",
              "RAM NIWAS",
              "704",
              "925",
              "76.11%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "21009115420027",
            "name": "MANISHA",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "684",
            "maxMarks": "925",
            "percentage": "73.95%",
            "cells": [
              "165",
              "21009115420027",
              "MANISHA",
              "RAI SINGH",
              "684",
              "925",
              "73.95%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "21009115420029",
            "name": "SHRUTI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "673",
            "maxMarks": "925",
            "percentage": "72.76%",
            "cells": [
              "166",
              "21009115420029",
              "SHRUTI",
              "SURENDER KUMAR",
              "673",
              "925",
              "72.76%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC 2nd Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "167",
            "rollNo": "00200090420003",
            "name": "HARNOOR BHATI",
            "fatherName": "BALKARAN SINGH",
            "obtainedMarks": "818",
            "maxMarks": "1150",
            "percentage": "71.13%",
            "cells": [
              "167",
              "00200090420003",
              "HARNOOR BHATI",
              "BALKARAN SINGH",
              "818",
              "1150",
              "71.13%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "00200090420008",
            "name": "MONIKA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "839",
            "maxMarks": "1150",
            "percentage": "72.95%",
            "cells": [
              "168",
              "00200090420008",
              "MONIKA",
              "RAJENDER KUMAR",
              "839",
              "1150",
              "72.95%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC3rd Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "169",
            "rollNo": "00190090420002",
            "name": "BALJINDER KAUR",
            "fatherName": "AJMER SINGH",
            "obtainedMarks": "837",
            "maxMarks": "1100",
            "percentage": "76.09%",
            "cells": [
              "169",
              "00190090420002",
              "BALJINDER KAUR",
              "AJMER SINGH",
              "837",
              "1100",
              "76.09%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "00190090420003",
            "name": "DIKSHA BHARTI",
            "fatherName": "CHANDER BHAN",
            "obtainedMarks": "807",
            "maxMarks": "1100",
            "percentage": "73.36%",
            "cells": [
              "170",
              "00190090420003",
              "DIKSHA BHARTI",
              "CHANDER BHAN",
              "807",
              "1100",
              "73.36%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "00190090420009",
            "name": "PREETAM",
            "fatherName": "DALIP SINGH",
            "obtainedMarks": "794",
            "maxMarks": "1100",
            "percentage": "72.18%",
            "cells": [
              "171",
              "00190090420009",
              "PREETAM",
              "DALIP SINGH",
              "794",
              "1100",
              "72.18%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "00190090420010",
            "name": "PREETI",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "787",
            "maxMarks": "1100",
            "percentage": "71.54%",
            "cells": [
              "172",
              "00190090420010",
              "PREETI",
              "VED PARKASH",
              "787",
              "1100",
              "71.54%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "00190090420012",
            "name": "PRIYANKA",
            "fatherName": "BHARAT SINGH",
            "obtainedMarks": "806",
            "maxMarks": "1100",
            "percentage": "73.27%",
            "cells": [
              "173",
              "00190090420012",
              "PRIYANKA",
              "BHARAT SINGH",
              "806",
              "1100",
              "73.27%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "00190090420014",
            "name": "REKHA",
            "fatherName": "NANAK RAM",
            "obtainedMarks": "817",
            "maxMarks": "1100",
            "percentage": "74.27%",
            "cells": [
              "174",
              "00190090420014",
              "REKHA",
              "NANAK RAM",
              "817",
              "1100",
              "74.27%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "00190090420015",
            "name": "RIDHI",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "810",
            "maxMarks": "1100",
            "percentage": "73.66%",
            "cells": [
              "175",
              "00190090420015",
              "RIDHI",
              "RANBIR SINGH",
              "810",
              "1100",
              "73.66%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA 1st Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "176",
            "rollNo": "21009115470002",
            "name": "pooja rani",
            "fatherName": "bhawan deen",
            "obtainedMarks": "1037",
            "maxMarks": "1300",
            "percentage": "79.76%",
            "cells": [
              "176",
              "21009115470002",
              "pooja rani",
              "bhawan deen",
              "1037",
              "1300",
              "79.76%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "21009115470003",
            "name": "komal rani",
            "fatherName": "shivcharan",
            "obtainedMarks": "963",
            "maxMarks": "1300",
            "percentage": "74.07%",
            "cells": [
              "177",
              "21009115470003",
              "komal rani",
              "shivcharan",
              "963",
              "1300",
              "74.07%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "21009115470010",
            "name": "kavita",
            "fatherName": "rakesh kumar",
            "obtainedMarks": "922",
            "maxMarks": "1300",
            "percentage": "70.92%",
            "cells": [
              "178",
              "21009115470010",
              "kavita",
              "rakesh kumar",
              "922",
              "1300",
              "70.92%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "21009115470015",
            "name": "poonam",
            "fatherName": "rajesh",
            "obtainedMarks": "921",
            "maxMarks": "1300",
            "percentage": "70.84%",
            "cells": [
              "179",
              "21009115470015",
              "poonam",
              "rajesh",
              "921",
              "1300",
              "70.84%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "21009115470022",
            "name": "Priyanka",
            "fatherName": "rajender pal",
            "obtainedMarks": "1097",
            "maxMarks": "1300",
            "percentage": "84.38%",
            "cells": [
              "180",
              "21009115470022",
              "Priyanka",
              "rajender pal",
              "1097",
              "1300",
              "84.38%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "21009115470028",
            "name": "simran",
            "fatherName": "harjeet singh",
            "obtainedMarks": "1000",
            "maxMarks": "1300",
            "percentage": "76.92%",
            "cells": [
              "181",
              "21009115470028",
              "simran",
              "harjeet singh",
              "1000",
              "1300",
              "76.92%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA 2nd Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "182",
            "rollNo": "200090470012",
            "name": "mamta",
            "fatherName": "subhash",
            "obtainedMarks": "1240",
            "maxMarks": "1700",
            "percentage": "72.94%",
            "cells": [
              "182",
              "200090470012",
              "mamta",
              "subhash",
              "1240",
              "1700",
              "72.94%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "200090470019",
            "name": "pooja",
            "fatherName": "pawan kumar",
            "obtainedMarks": "1194",
            "maxMarks": "1700",
            "percentage": "70.23%",
            "cells": [
              "183",
              "200090470019",
              "pooja",
              "pawan kumar",
              "1194",
              "1700",
              "70.23%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "200090470022",
            "name": "rajju",
            "fatherName": "jai kishan",
            "obtainedMarks": "1307",
            "maxMarks": "1700",
            "percentage": "76.88%",
            "cells": [
              "184",
              "200090470022",
              "rajju",
              "jai kishan",
              "1307",
              "1700",
              "76.88%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "200090470025",
            "name": "sandeep kaur",
            "fatherName": "manjeet singh",
            "obtainedMarks": "1264",
            "maxMarks": "1700",
            "percentage": "74.35%",
            "cells": [
              "185",
              "200090470025",
              "sandeep kaur",
              "manjeet singh",
              "1264",
              "1700",
              "74.35%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA 2nd Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "186",
            "rollNo": "190090470006",
            "name": "manisha",
            "fatherName": "ashok kumar",
            "obtainedMarks": "1354",
            "maxMarks": "1700",
            "percentage": "79.04%",
            "cells": [
              "186",
              "190090470006",
              "manisha",
              "ashok kumar",
              "1354",
              "1700",
              "79.04%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "190090470007",
            "name": "manisha rani",
            "fatherName": "sunil kumar",
            "obtainedMarks": "1387",
            "maxMarks": "1700",
            "percentage": "81.58%",
            "cells": [
              "187",
              "190090470007",
              "manisha rani",
              "sunil kumar",
              "1387",
              "1700",
              "81.58%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "190090470009",
            "name": "noor",
            "fatherName": "dharam pal",
            "obtainedMarks": "1371",
            "maxMarks": "1700",
            "percentage": "80.64%",
            "cells": [
              "188",
              "190090470009",
              "noor",
              "dharam pal",
              "1371",
              "1700",
              "80.64%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "190090470010",
            "name": "pooja",
            "fatherName": "rakesh",
            "obtainedMarks": "1293",
            "maxMarks": "1700",
            "percentage": "76.05%",
            "cells": [
              "189",
              "190090470010",
              "pooja",
              "rakesh",
              "1293",
              "1700",
              "76.05%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "190090470015",
            "name": "jyoti",
            "fatherName": "kirpa singh",
            "obtainedMarks": "1399",
            "maxMarks": "1700",
            "percentage": "82.29%",
            "cells": [
              "190",
              "190090470015",
              "jyoti",
              "kirpa singh",
              "1399",
              "1700",
              "82.29%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA 1st Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "191",
            "rollNo": "21009115480022",
            "name": "sonia",
            "fatherName": "dharam raj",
            "obtainedMarks": "995",
            "maxMarks": "1350",
            "percentage": "73.70%",
            "cells": [
              "191",
              "21009115480022",
              "sonia",
              "dharam raj",
              "995",
              "1350",
              "73.70%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA 2nd Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA 3rd Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "D.PED 1st year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "192",
            "rollNo": "21009225640001",
            "name": "RAJNI",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "1196",
            "maxMarks": "1500",
            "percentage": "79.73%",
            "cells": [
              "192",
              "21009225640001",
              "RAJNI",
              "BHIM SINGH",
              "1196",
              "1500",
              "79.73%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "21009225640002",
            "name": "LAKSHITA",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "1141",
            "maxMarks": "1500",
            "percentage": "76.06%",
            "cells": [
              "193",
              "21009225640002",
              "LAKSHITA",
              "BANSI LAL",
              "1141",
              "1500",
              "76.06%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "21009225640003",
            "name": "SANJU BALA",
            "fatherName": "CHANDER BHAN",
            "obtainedMarks": "1100",
            "maxMarks": "1500",
            "percentage": "73.30%",
            "cells": [
              "194",
              "21009225640003",
              "SANJU BALA",
              "CHANDER BHAN",
              "1100",
              "1500",
              "73.30%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "21009225640004",
            "name": "MAMTA",
            "fatherName": "JATAN SINGH",
            "obtainedMarks": "1086",
            "maxMarks": "1500",
            "percentage": "72.40%",
            "cells": [
              "195",
              "21009225640004",
              "MAMTA",
              "JATAN SINGH",
              "1086",
              "1500",
              "72.40%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "21009225640005",
            "name": "POONAM",
            "fatherName": "SURENDRA KUMAR",
            "obtainedMarks": "1106",
            "maxMarks": "1500",
            "percentage": "73.73%",
            "cells": [
              "196",
              "21009225640005",
              "POONAM",
              "SURENDRA KUMAR",
              "1106",
              "1500",
              "73.73%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "21009225640006",
            "name": "ANJU KANWAR",
            "fatherName": "MAHAVEER SINGH",
            "obtainedMarks": "1161",
            "maxMarks": "1500",
            "percentage": "77.40%",
            "cells": [
              "197",
              "21009225640006",
              "ANJU KANWAR",
              "MAHAVEER SINGH",
              "1161",
              "1500",
              "77.40%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "21009225640007",
            "name": "KOMAL",
            "fatherName": "JITENDRA JAKHAR",
            "obtainedMarks": "1120",
            "maxMarks": "1500",
            "percentage": "74.60%",
            "cells": [
              "198",
              "21009225640007",
              "KOMAL",
              "JITENDRA JAKHAR",
              "1120",
              "1500",
              "74.60%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "21009225640008",
            "name": "LOVEPREET",
            "fatherName": "MANDER RAM",
            "obtainedMarks": "1242",
            "maxMarks": "1500",
            "percentage": "82.80%",
            "cells": [
              "199",
              "21009225640008",
              "LOVEPREET",
              "MANDER RAM",
              "1242",
              "1500",
              "82.80%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "21009225640009",
            "name": "POOJA PRAJAPATI",
            "fatherName": "KAILASH CHANDRA PRAJAPATI",
            "obtainedMarks": "1178",
            "maxMarks": "1500",
            "percentage": "78.53%",
            "cells": [
              "200",
              "21009225640009",
              "POOJA PRAJAPATI",
              "KAILASH CHANDRA PRAJAPATI",
              "1178",
              "1500",
              "78.53%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "21009225640010",
            "name": "NEELAM",
            "fatherName": "MAHAVEER",
            "obtainedMarks": "1098",
            "maxMarks": "1500",
            "percentage": "73.20%",
            "cells": [
              "201",
              "21009225640010",
              "NEELAM",
              "MAHAVEER",
              "1098",
              "1500",
              "73.20%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "21009225640011",
            "name": "ARTI",
            "fatherName": "SHYOPAL",
            "obtainedMarks": "1146",
            "maxMarks": "1500",
            "percentage": "76.40%",
            "cells": [
              "202",
              "21009225640011",
              "ARTI",
              "SHYOPAL",
              "1146",
              "1500",
              "76.40%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "21009225640012",
            "name": "SUMAN",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1157",
            "maxMarks": "1500",
            "percentage": "77.13%",
            "cells": [
              "203",
              "21009225640012",
              "SUMAN",
              "DHARAMPAL",
              "1157",
              "1500",
              "77.13%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "21009225640013",
            "name": "POONAM",
            "fatherName": "BHANWAR LAL",
            "obtainedMarks": "1167",
            "maxMarks": "1500",
            "percentage": "77.80%",
            "cells": [
              "204",
              "21009225640013",
              "POONAM",
              "BHANWAR LAL",
              "1167",
              "1500",
              "77.80%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "21009225640014",
            "name": "PRIYANKA",
            "fatherName": "JAGDISH",
            "obtainedMarks": "1142",
            "maxMarks": "1500",
            "percentage": "76.13%",
            "cells": [
              "205",
              "21009225640014",
              "PRIYANKA",
              "JAGDISH",
              "1142",
              "1500",
              "76.13%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "21009225640015",
            "name": "KANTA",
            "fatherName": "KESARA RAM",
            "obtainedMarks": "1217",
            "maxMarks": "1500",
            "percentage": "81.13%",
            "cells": [
              "206",
              "21009225640015",
              "KANTA",
              "KESARA RAM",
              "1217",
              "1500",
              "81.13%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "21009225640016",
            "name": "MANISHA",
            "fatherName": "AMAR DEV",
            "obtainedMarks": "1110",
            "maxMarks": "1500",
            "percentage": "74%",
            "cells": [
              "207",
              "21009225640016",
              "MANISHA",
              "AMAR DEV",
              "1110",
              "1500",
              "74%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "21009225640017",
            "name": "PALLAVI",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1134",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "208",
              "21009225640017",
              "PALLAVI",
              "RAKESH KUMAR",
              "1134",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "209",
            "rollNo": "21009225640018",
            "name": "KANCHAN",
            "fatherName": "CHHINDERPAL",
            "obtainedMarks": "1185",
            "maxMarks": "1500",
            "percentage": "79%",
            "cells": [
              "209",
              "21009225640018",
              "KANCHAN",
              "CHHINDERPAL",
              "1185",
              "1500",
              "79%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "21009225640019",
            "name": "MANJU",
            "fatherName": "RAMSUKH",
            "obtainedMarks": "1155",
            "maxMarks": "1500",
            "percentage": "77%",
            "cells": [
              "210",
              "21009225640019",
              "MANJU",
              "RAMSUKH",
              "1155",
              "1500",
              "77%"
            ]
          },
          {
            "sNo": "211",
            "rollNo": "21009225640020",
            "name": "VIDISHA",
            "fatherName": "TILA RAM",
            "obtainedMarks": "1134",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "211",
              "21009225640020",
              "VIDISHA",
              "TILA RAM",
              "1134",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "21009225640021",
            "name": "KANTA SHARMA",
            "fatherName": "DEENDAYAL SHARMA",
            "obtainedMarks": "1150",
            "maxMarks": "1500",
            "percentage": "76.66%",
            "cells": [
              "212",
              "21009225640021",
              "KANTA SHARMA",
              "DEENDAYAL SHARMA",
              "1150",
              "1500",
              "76.66%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "21009225640022",
            "name": "SUMAN",
            "fatherName": "KAILASH RAM",
            "obtainedMarks": "1074",
            "maxMarks": "1500",
            "percentage": "71.60%",
            "cells": [
              "213",
              "21009225640022",
              "SUMAN",
              "KAILASH RAM",
              "1074",
              "1500",
              "71.60%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "21009225640023",
            "name": "PREM GOURA",
            "fatherName": "MADANLAL GOURA",
            "obtainedMarks": "1123",
            "maxMarks": "1500",
            "percentage": "74.86%",
            "cells": [
              "214",
              "21009225640023",
              "PREM GOURA",
              "MADANLAL GOURA",
              "1123",
              "1500",
              "74.86%"
            ]
          },
          {
            "sNo": "215",
            "rollNo": "21009225640026",
            "name": "SONU PRAJAPAT",
            "fatherName": "RAMJILAL PRAJAPAT",
            "obtainedMarks": "1152",
            "maxMarks": "1500",
            "percentage": "76.80%",
            "cells": [
              "215",
              "21009225640026",
              "SONU PRAJAPAT",
              "RAMJILAL PRAJAPAT",
              "1152",
              "1500",
              "76.80%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "21009225640028",
            "name": "POOJA",
            "fatherName": "SANTLAL",
            "obtainedMarks": "1121",
            "maxMarks": "1500",
            "percentage": "74.73%",
            "cells": [
              "216",
              "21009225640028",
              "POOJA",
              "SANTLAL",
              "1121",
              "1500",
              "74.73%"
            ]
          },
          {
            "sNo": "217",
            "rollNo": "21009225640030",
            "name": "FORANTA JAT",
            "fatherName": "SUVARAM JAT",
            "obtainedMarks": "1127",
            "maxMarks": "1500",
            "percentage": "75.13%",
            "cells": [
              "217",
              "21009225640030",
              "FORANTA JAT",
              "SUVARAM JAT",
              "1127",
              "1500",
              "75.13%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "21009225640031",
            "name": "KOMAL JOSHI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1089",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "218",
              "21009225640031",
              "KOMAL JOSHI",
              "KRISHAN KUMAR",
              "1089",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "219",
            "rollNo": "21009225640032",
            "name": "SANJU",
            "fatherName": "KURDARAM",
            "obtainedMarks": "1066",
            "maxMarks": "1500",
            "percentage": "71.06%",
            "cells": [
              "219",
              "21009225640032",
              "SANJU",
              "KURDARAM",
              "1066",
              "1500",
              "71.06%"
            ]
          },
          {
            "sNo": "220",
            "rollNo": "21009225640033",
            "name": "POOJA",
            "fatherName": "LICHHMAN RAM",
            "obtainedMarks": "1107",
            "maxMarks": "1500",
            "percentage": "73.80%",
            "cells": [
              "220",
              "21009225640033",
              "POOJA",
              "LICHHMAN RAM",
              "1107",
              "1500",
              "73.80%"
            ]
          },
          {
            "sNo": "221",
            "rollNo": "21009225640034",
            "name": "JYOTI",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "1097",
            "maxMarks": "1500",
            "percentage": "73.13%",
            "cells": [
              "221",
              "21009225640034",
              "JYOTI",
              "MOHAN LAL",
              "1097",
              "1500",
              "73.13%"
            ]
          },
          {
            "sNo": "222",
            "rollNo": "21009225640035",
            "name": "SUKHWANTI",
            "fatherName": "CHETAN RAM",
            "obtainedMarks": "1210",
            "maxMarks": "1500",
            "percentage": "80.60%",
            "cells": [
              "222",
              "21009225640035",
              "SUKHWANTI",
              "CHETAN RAM",
              "1210",
              "1500",
              "80.60%"
            ]
          },
          {
            "sNo": "223",
            "rollNo": "21009225640036",
            "name": "PRIYANKA",
            "fatherName": "MANGE RAM",
            "obtainedMarks": "1154",
            "maxMarks": "1500",
            "percentage": "76.90%",
            "cells": [
              "223",
              "21009225640036",
              "PRIYANKA",
              "MANGE RAM",
              "1154",
              "1500",
              "76.90%"
            ]
          },
          {
            "sNo": "224",
            "rollNo": "21009225640037",
            "name": "BALA KUMARI",
            "fatherName": "BABU LAL",
            "obtainedMarks": "1117",
            "maxMarks": "1500",
            "percentage": "74.46%",
            "cells": [
              "224",
              "21009225640037",
              "BALA KUMARI",
              "BABU LAL",
              "1117",
              "1500",
              "74.46%"
            ]
          },
          {
            "sNo": "225",
            "rollNo": "21009225640038",
            "name": "PUSHPA MAIYA",
            "fatherName": "NIMBARAM MAIYA",
            "obtainedMarks": "1089",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "225",
              "21009225640038",
              "PUSHPA MAIYA",
              "NIMBARAM MAIYA",
              "1089",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "226",
            "rollNo": "21009225640039",
            "name": "DIKSHA",
            "fatherName": "SHANKAR LAL",
            "obtainedMarks": "1138",
            "maxMarks": "1500",
            "percentage": "75.80%",
            "cells": [
              "226",
              "21009225640039",
              "DIKSHA",
              "SHANKAR LAL",
              "1138",
              "1500",
              "75.80%"
            ]
          },
          {
            "sNo": "227",
            "rollNo": "21009225640040",
            "name": "KANNU PRIYA",
            "fatherName": "SATVEER",
            "obtainedMarks": "1124",
            "maxMarks": "1500",
            "percentage": "74.93%",
            "cells": [
              "227",
              "21009225640040",
              "KANNU PRIYA",
              "SATVEER",
              "1124",
              "1500",
              "74.93%"
            ]
          },
          {
            "sNo": "228",
            "rollNo": "21009225640041",
            "name": "SAROJ CHAUDHARY",
            "fatherName": "GOPAL RAM",
            "obtainedMarks": "1080",
            "maxMarks": "1500",
            "percentage": "72%",
            "cells": [
              "228",
              "21009225640041",
              "SAROJ CHAUDHARY",
              "GOPAL RAM",
              "1080",
              "1500",
              "72%"
            ]
          },
          {
            "sNo": "229",
            "rollNo": "21009225640042",
            "name": "POOJA",
            "fatherName": "GOPI RAM",
            "obtainedMarks": "1134",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "229",
              "21009225640042",
              "POOJA",
              "GOPI RAM",
              "1134",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "230",
            "rollNo": "21009225640043",
            "name": "SONA GHASAL",
            "fatherName": "KANARAM GHASAL",
            "obtainedMarks": "1151",
            "maxMarks": "1500",
            "percentage": "76.73%",
            "cells": [
              "230",
              "21009225640043",
              "SONA GHASAL",
              "KANARAM GHASAL",
              "1151",
              "1500",
              "76.73%"
            ]
          },
          {
            "sNo": "231",
            "rollNo": "21009225640044",
            "name": "MAMTA",
            "fatherName": "SURENDRA SINGH",
            "obtainedMarks": "1091",
            "maxMarks": "1500",
            "percentage": "72.70%",
            "cells": [
              "231",
              "21009225640044",
              "MAMTA",
              "SURENDRA SINGH",
              "1091",
              "1500",
              "72.70%"
            ]
          },
          {
            "sNo": "232",
            "rollNo": "21009225640046",
            "name": "MAYA GEELA",
            "fatherName": "KAILASH GEELA",
            "obtainedMarks": "1126",
            "maxMarks": "1500",
            "percentage": "75.06%",
            "cells": [
              "232",
              "21009225640046",
              "MAYA GEELA",
              "KAILASH GEELA",
              "1126",
              "1500",
              "75.06%"
            ]
          },
          {
            "sNo": "233",
            "rollNo": "21009225640047",
            "name": "KHIVNI",
            "fatherName": "JETA RAM",
            "obtainedMarks": "1098",
            "maxMarks": "1500",
            "percentage": "73.20%",
            "cells": [
              "233",
              "21009225640047",
              "KHIVNI",
              "JETA RAM",
              "1098",
              "1500",
              "73.20%"
            ]
          },
          {
            "sNo": "234",
            "rollNo": "21009225640048",
            "name": "PRIYANKA",
            "fatherName": "BALBEER SINGH",
            "obtainedMarks": "1152",
            "maxMarks": "1500",
            "percentage": "76.08%",
            "cells": [
              "234",
              "21009225640048",
              "PRIYANKA",
              "BALBEER SINGH",
              "1152",
              "1500",
              "76.08%"
            ]
          },
          {
            "sNo": "235",
            "rollNo": "21009225640049",
            "name": "RACHANA",
            "fatherName": "LADURAM GODARA",
            "obtainedMarks": "1309",
            "maxMarks": "1500",
            "percentage": "87.26%",
            "cells": [
              "235",
              "21009225640049",
              "RACHANA",
              "LADURAM GODARA",
              "1309",
              "1500",
              "87.26%"
            ]
          },
          {
            "sNo": "236",
            "rollNo": "21009225640050",
            "name": "DEEPIKA",
            "fatherName": "DARIYA SINGH",
            "obtainedMarks": "1123",
            "maxMarks": "1500",
            "percentage": "74.86%",
            "cells": [
              "236",
              "21009225640050",
              "DEEPIKA",
              "DARIYA SINGH",
              "1123",
              "1500",
              "74.86%"
            ]
          }
        ]
      },
      {
        "courseName": "D.PED 2nd year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "237",
            "rollNo": "00200090640002",
            "name": "ANISHA",
            "fatherName": "OMPRAKASH",
            "obtainedMarks": "1080",
            "maxMarks": "1500",
            "percentage": "72%",
            "cells": [
              "237",
              "00200090640002",
              "ANISHA",
              "OMPRAKASH",
              "1080",
              "1500",
              "72%"
            ]
          },
          {
            "sNo": "238",
            "rollNo": "00200090640003",
            "name": "ANISHA VERMA",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1139",
            "maxMarks": "1500",
            "percentage": "75.93%",
            "cells": [
              "238",
              "00200090640003",
              "ANISHA VERMA",
              "ANAND KUMAR",
              "1139",
              "1500",
              "75.93%"
            ]
          },
          {
            "sNo": "239",
            "rollNo": "00200090640004",
            "name": "ANITA",
            "fatherName": "POONAM CHAND",
            "obtainedMarks": "1097",
            "maxMarks": "1500",
            "percentage": "73.13%",
            "cells": [
              "239",
              "00200090640004",
              "ANITA",
              "POONAM CHAND",
              "1097",
              "1500",
              "73.13%"
            ]
          },
          {
            "sNo": "240",
            "rollNo": "00200090640005",
            "name": "ANJILA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "1073",
            "maxMarks": "1500",
            "percentage": "71.53%",
            "cells": [
              "240",
              "00200090640005",
              "ANJILA",
              "VINOD KUMAR",
              "1073",
              "1500",
              "71.53%"
            ]
          },
          {
            "sNo": "241",
            "rollNo": "00200090640006",
            "name": "ANJU BALA",
            "fatherName": "RAMSWARUP",
            "obtainedMarks": "1085",
            "maxMarks": "1500",
            "percentage": "72.33%",
            "cells": [
              "241",
              "00200090640006",
              "ANJU BALA",
              "RAMSWARUP",
              "1085",
              "1500",
              "72.33%"
            ]
          },
          {
            "sNo": "242",
            "rollNo": "00200090640007",
            "name": "ANNU",
            "fatherName": "SUBHASH YADAV",
            "obtainedMarks": "1165",
            "maxMarks": "1500",
            "percentage": "77.67%",
            "cells": [
              "242",
              "00200090640007",
              "ANNU",
              "SUBHASH YADAV",
              "1165",
              "1500",
              "77.67%"
            ]
          },
          {
            "sNo": "243",
            "rollNo": "00200090640008",
            "name": "MS ANNU BALA",
            "fatherName": "DANA RAM",
            "obtainedMarks": "1130",
            "maxMarks": "1500",
            "percentage": "75.33%",
            "cells": [
              "243",
              "00200090640008",
              "MS ANNU BALA",
              "DANA RAM",
              "1130",
              "1500",
              "75.33%"
            ]
          },
          {
            "sNo": "244",
            "rollNo": "00200090640009",
            "name": "ANNU KUMARI",
            "fatherName": "SANT LAL JYANI",
            "obtainedMarks": "1089",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "244",
              "00200090640009",
              "ANNU KUMARI",
              "SANT LAL JYANI",
              "1089",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "245",
            "rollNo": "00200090640010",
            "name": "ANSHUIYA",
            "fatherName": "VIJAY PAL",
            "obtainedMarks": "1154",
            "maxMarks": "1500",
            "percentage": "76.93%",
            "cells": [
              "245",
              "00200090640010",
              "ANSHUIYA",
              "VIJAY PAL",
              "1154",
              "1500",
              "76.93%"
            ]
          },
          {
            "sNo": "246",
            "rollNo": "00200090640011",
            "name": "BASANTI",
            "fatherName": "MANIRAM",
            "obtainedMarks": "1119",
            "maxMarks": "1500",
            "percentage": "74.60%",
            "cells": [
              "246",
              "00200090640011",
              "BASANTI",
              "MANIRAM",
              "1119",
              "1500",
              "74.60%"
            ]
          },
          {
            "sNo": "247",
            "rollNo": "00200090640012",
            "name": "CHHINDAR PAL KAUR",
            "fatherName": "GURUCHARN",
            "obtainedMarks": "1150",
            "maxMarks": "1500",
            "percentage": "76.67%",
            "cells": [
              "247",
              "00200090640012",
              "CHHINDAR PAL KAUR",
              "GURUCHARN",
              "1150",
              "1500",
              "76.67%"
            ]
          },
          {
            "sNo": "248",
            "rollNo": "00200090640013",
            "name": "DIMPAL",
            "fatherName": "SHIVRATAN",
            "obtainedMarks": "1181",
            "maxMarks": "1500",
            "percentage": "78.73%",
            "cells": [
              "248",
              "00200090640013",
              "DIMPAL",
              "SHIVRATAN",
              "1181",
              "1500",
              "78.73%"
            ]
          },
          {
            "sNo": "249",
            "rollNo": "00200090640014",
            "name": "EKATA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "1169",
            "maxMarks": "1500",
            "percentage": "77.93%",
            "cells": [
              "249",
              "00200090640014",
              "EKATA",
              "MOHAN LAL",
              "1169",
              "1500",
              "77.93%"
            ]
          },
          {
            "sNo": "250",
            "rollNo": "00200090640015",
            "name": "GRIMA KUMARI",
            "fatherName": "ANGAD KUMAR",
            "obtainedMarks": "1078",
            "maxMarks": "1500",
            "percentage": "71.87%",
            "cells": [
              "250",
              "00200090640015",
              "GRIMA KUMARI",
              "ANGAD KUMAR",
              "1078",
              "1500",
              "71.87%"
            ]
          },
          {
            "sNo": "251",
            "rollNo": "00200090640016",
            "name": "HEERA BAI",
            "fatherName": "JAGDEESH PRASAD",
            "obtainedMarks": "1099",
            "maxMarks": "1500",
            "percentage": "73.27%",
            "cells": [
              "251",
              "00200090640016",
              "HEERA BAI",
              "JAGDEESH PRASAD",
              "1099",
              "1500",
              "73.27%"
            ]
          },
          {
            "sNo": "252",
            "rollNo": "00200090640018",
            "name": "KAVITA KUMARI",
            "fatherName": "GOPAL RAM",
            "obtainedMarks": "1126",
            "maxMarks": "1500",
            "percentage": "75.07%",
            "cells": [
              "252",
              "00200090640018",
              "KAVITA KUMARI",
              "GOPAL RAM",
              "1126",
              "1500",
              "75.07%"
            ]
          },
          {
            "sNo": "253",
            "rollNo": "00200090640019",
            "name": "KAVITA KUMARI",
            "fatherName": "RAJENDRA KUMAR",
            "obtainedMarks": "1113",
            "maxMarks": "1500",
            "percentage": "74.20%",
            "cells": [
              "253",
              "00200090640019",
              "KAVITA KUMARI",
              "RAJENDRA KUMAR",
              "1113",
              "1500",
              "74.20%"
            ]
          },
          {
            "sNo": "254",
            "rollNo": "00200090640020",
            "name": "KAVITA RANI",
            "fatherName": "BHALA RAM",
            "obtainedMarks": "1137",
            "maxMarks": "1500",
            "percentage": "75.80%",
            "cells": [
              "254",
              "00200090640020",
              "KAVITA RANI",
              "BHALA RAM",
              "1137",
              "1500",
              "75.80%"
            ]
          },
          {
            "sNo": "255",
            "rollNo": "00200090640021",
            "name": "KIRAN SIYOL",
            "fatherName": "RAMU RAM",
            "obtainedMarks": "1219",
            "maxMarks": "1500",
            "percentage": "81.27%",
            "cells": [
              "255",
              "00200090640021",
              "KIRAN SIYOL",
              "RAMU RAM",
              "1219",
              "1500",
              "81.27%"
            ]
          },
          {
            "sNo": "256",
            "rollNo": "00200090640022",
            "name": "KIRNA",
            "fatherName": "KALU RAM",
            "obtainedMarks": "1071",
            "maxMarks": "1500",
            "percentage": "71.40%",
            "cells": [
              "256",
              "00200090640022",
              "KIRNA",
              "KALU RAM",
              "1071",
              "1500",
              "71.40%"
            ]
          },
          {
            "sNo": "257",
            "rollNo": "00200090640023",
            "name": "KOMAL",
            "fatherName": "BALWANT NAIN",
            "obtainedMarks": "1174",
            "maxMarks": "1500",
            "percentage": "78.27%",
            "cells": [
              "257",
              "00200090640023",
              "KOMAL",
              "BALWANT NAIN",
              "1174",
              "1500",
              "78.27%"
            ]
          },
          {
            "sNo": "258",
            "rollNo": "00200090640024",
            "name": "MAFIYA KHATUN",
            "fatherName": "NOORNAVI",
            "obtainedMarks": "1110",
            "maxMarks": "1500",
            "percentage": "74%",
            "cells": [
              "258",
              "00200090640024",
              "MAFIYA KHATUN",
              "NOORNAVI",
              "1110",
              "1500",
              "74%"
            ]
          },
          {
            "sNo": "259",
            "rollNo": "00200090640025",
            "name": "MAHAKPREET KAUR",
            "fatherName": "JANAK SINGH",
            "obtainedMarks": "1159",
            "maxMarks": "1500",
            "percentage": "77.27%",
            "cells": [
              "259",
              "00200090640025",
              "MAHAKPREET KAUR",
              "JANAK SINGH",
              "1159",
              "1500",
              "77.27%"
            ]
          },
          {
            "sNo": "260",
            "rollNo": "00200090640026",
            "name": "MALKITO",
            "fatherName": "DARSHAN SINGH",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "260",
              "00200090640026",
              "MALKITO",
              "DARSHAN SINGH",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "261",
            "rollNo": "00200090640027",
            "name": "MAMTA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1195",
            "maxMarks": "1500",
            "percentage": "79.67%",
            "cells": [
              "261",
              "00200090640027",
              "MAMTA",
              "KRISHAN KUMAR",
              "1195",
              "1500",
              "79.67%"
            ]
          },
          {
            "sNo": "262",
            "rollNo": "00200090640028",
            "name": "MANINDER PAL KAUR",
            "fatherName": "JAGSEER SINGH",
            "obtainedMarks": "1145",
            "maxMarks": "1500",
            "percentage": "76.33%",
            "cells": [
              "262",
              "00200090640028",
              "MANINDER PAL KAUR",
              "JAGSEER SINGH",
              "1145",
              "1500",
              "76.33%"
            ]
          },
          {
            "sNo": "263",
            "rollNo": "00200090640029",
            "name": "MANISHA PAREEK",
            "fatherName": "VED PRAKASH",
            "obtainedMarks": "1194",
            "maxMarks": "1500",
            "percentage": "79.60%",
            "cells": [
              "263",
              "00200090640029",
              "MANISHA PAREEK",
              "VED PRAKASH",
              "1194",
              "1500",
              "79.60%"
            ]
          },
          {
            "sNo": "264",
            "rollNo": "00200090640031",
            "name": "MONIKA",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1150",
            "maxMarks": "1500",
            "percentage": "76.67%",
            "cells": [
              "264",
              "00200090640031",
              "MONIKA",
              "BHOOP SINGH",
              "1150",
              "1500",
              "76.67%"
            ]
          },
          {
            "sNo": "265",
            "rollNo": "00200090640032",
            "name": "NACHITA",
            "fatherName": "RAMAUTAR",
            "obtainedMarks": "1188",
            "maxMarks": "1500",
            "percentage": "79.20%",
            "cells": [
              "265",
              "00200090640032",
              "NACHITA",
              "RAMAUTAR",
              "1188",
              "1500",
              "79.20%"
            ]
          },
          {
            "sNo": "266",
            "rollNo": "00200090640033",
            "name": "MS NASIRA BIBI",
            "fatherName": "JUNAS ALI",
            "obtainedMarks": "1091",
            "maxMarks": "1500",
            "percentage": "72.73%",
            "cells": [
              "266",
              "00200090640033",
              "MS NASIRA BIBI",
              "JUNAS ALI",
              "1091",
              "1500",
              "72.73%"
            ]
          },
          {
            "sNo": "267",
            "rollNo": "00200090640034",
            "name": "NEETU",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1230",
            "maxMarks": "1500",
            "percentage": "82%",
            "cells": [
              "267",
              "00200090640034",
              "NEETU",
              "BHOOP SINGH",
              "1230",
              "1500",
              "82%"
            ]
          },
          {
            "sNo": "268",
            "rollNo": "00200090640035",
            "name": "NILAM",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1104",
            "maxMarks": "1500",
            "percentage": "73.60%",
            "cells": [
              "268",
              "00200090640035",
              "NILAM",
              "BHOOP SINGH",
              "1104",
              "1500",
              "73.60%"
            ]
          },
          {
            "sNo": "269",
            "rollNo": "00200090640036",
            "name": "NIRMLA",
            "fatherName": "JAS RAM",
            "obtainedMarks": "1098",
            "maxMarks": "1500",
            "percentage": "73.20%",
            "cells": [
              "269",
              "00200090640036",
              "NIRMLA",
              "JAS RAM",
              "1098",
              "1500",
              "73.20%"
            ]
          },
          {
            "sNo": "270",
            "rollNo": "00200090640037",
            "name": "MS. POOJA",
            "fatherName": "JAGJEET RAM",
            "obtainedMarks": "1147",
            "maxMarks": "1500",
            "percentage": "76.47%",
            "cells": [
              "270",
              "00200090640037",
              "MS. POOJA",
              "JAGJEET RAM",
              "1147",
              "1500",
              "76.47%"
            ]
          },
          {
            "sNo": "271",
            "rollNo": "00200090640038",
            "name": "MS POOJA",
            "fatherName": "SAGAR RAM",
            "obtainedMarks": "1081",
            "maxMarks": "1500",
            "percentage": "72.07%",
            "cells": [
              "271",
              "00200090640038",
              "MS POOJA",
              "SAGAR RAM",
              "1081",
              "1500",
              "72.07%"
            ]
          },
          {
            "sNo": "272",
            "rollNo": "00200090640039",
            "name": "POOJA DEVI",
            "fatherName": "SATPAL",
            "obtainedMarks": "1085",
            "maxMarks": "1500",
            "percentage": "72.33%",
            "cells": [
              "272",
              "00200090640039",
              "POOJA DEVI",
              "SATPAL",
              "1085",
              "1500",
              "72.33%"
            ]
          },
          {
            "sNo": "273",
            "rollNo": "00200090640040",
            "name": "MS POOJA GURJAR",
            "fatherName": "RAMKUNWAR GURJAR",
            "obtainedMarks": "1103",
            "maxMarks": "1500",
            "percentage": "73.53%",
            "cells": [
              "273",
              "00200090640040",
              "MS POOJA GURJAR",
              "RAMKUNWAR GURJAR",
              "1103",
              "1500",
              "73.53%"
            ]
          },
          {
            "sNo": "274",
            "rollNo": "00200090640041",
            "name": "POONAM",
            "fatherName": "JAIPRAKASH BUDANIA",
            "obtainedMarks": "1134",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "274",
              "00200090640041",
              "POONAM",
              "JAIPRAKASH BUDANIA",
              "1134",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "275",
            "rollNo": "00200090640042",
            "name": "MS PRIYNKA",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "1091",
            "maxMarks": "1500",
            "percentage": "72.73%",
            "cells": [
              "275",
              "00200090640042",
              "MS PRIYNKA",
              "BANWARI LAL",
              "1091",
              "1500",
              "72.73%"
            ]
          },
          {
            "sNo": "276",
            "rollNo": "00200090640043",
            "name": "MS RAJVEER KOUR",
            "fatherName": "DARSHAN SINGH",
            "obtainedMarks": "1120",
            "maxMarks": "1500",
            "percentage": "74.67%",
            "cells": [
              "276",
              "00200090640043",
              "MS RAJVEER KOUR",
              "DARSHAN SINGH",
              "1120",
              "1500",
              "74.67%"
            ]
          },
          {
            "sNo": "277",
            "rollNo": "00200090640044",
            "name": "SANDHYA",
            "fatherName": "TANSUKH RAM",
            "obtainedMarks": "1106",
            "maxMarks": "1500",
            "percentage": "73.73%",
            "cells": [
              "277",
              "00200090640044",
              "SANDHYA",
              "TANSUKH RAM",
              "1106",
              "1500",
              "73.73%"
            ]
          },
          {
            "sNo": "278",
            "rollNo": "00200090640045",
            "name": "MS SARASWATI",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1105",
            "maxMarks": "1500",
            "percentage": "73.67%",
            "cells": [
              "278",
              "00200090640045",
              "MS SARASWATI",
              "OM PRAKASH",
              "1105",
              "1500",
              "73.67%"
            ]
          },
          {
            "sNo": "279",
            "rollNo": "00200090640046",
            "name": "SONYA",
            "fatherName": "DESRAJ",
            "obtainedMarks": "1108",
            "maxMarks": "1500",
            "percentage": "73.87%",
            "cells": [
              "279",
              "00200090640046",
              "SONYA",
              "DESRAJ",
              "1108",
              "1500",
              "73.87%"
            ]
          },
          {
            "sNo": "280",
            "rollNo": "00200090640047",
            "name": "SUBHANA",
            "fatherName": "KASAM  ALI",
            "obtainedMarks": "1099",
            "maxMarks": "1500",
            "percentage": "73.27%",
            "cells": [
              "280",
              "00200090640047",
              "SUBHANA",
              "KASAM  ALI",
              "1099",
              "1500",
              "73.27%"
            ]
          },
          {
            "sNo": "281",
            "rollNo": "00200090640048",
            "name": "SUMAN",
            "fatherName": "JAGDISH CHANDER",
            "obtainedMarks": "1176",
            "maxMarks": "1500",
            "percentage": "78.40%",
            "cells": [
              "281",
              "00200090640048",
              "SUMAN",
              "JAGDISH CHANDER",
              "1176",
              "1500",
              "78.40%"
            ]
          },
          {
            "sNo": "282",
            "rollNo": "00200090640049",
            "name": "SUMAN KUMARI",
            "fatherName": "BHUP RAM",
            "obtainedMarks": "1069",
            "maxMarks": "1500",
            "percentage": "71.27%",
            "cells": [
              "282",
              "00200090640049",
              "SUMAN KUMARI",
              "BHUP RAM",
              "1069",
              "1500",
              "71.27%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com 1st year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "21009990080003",
            "name": "AKANKSHA",
            "fatherName": "ANOOP KUMAR",
            "obtainedMarks": "847",
            "maxMarks": "1200",
            "percentage": "70.50%",
            "cells": [
              "1",
              "21009990080003",
              "AKANKSHA",
              "ANOOP KUMAR",
              "847",
              "1200",
              "70.50%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "21009990080004",
            "name": "MANJU",
            "fatherName": "SOHANPAL",
            "obtainedMarks": "883",
            "maxMarks": "1200",
            "percentage": "73.50%",
            "cells": [
              "2",
              "21009990080004",
              "MANJU",
              "SOHANPAL",
              "883",
              "1200",
              "73.50%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "21009990080005",
            "name": "MANISHA",
            "fatherName": "DEEPAK MONGA",
            "obtainedMarks": "866",
            "maxMarks": "1200",
            "percentage": "72.10%",
            "cells": [
              "3",
              "21009990080005",
              "MANISHA",
              "DEEPAK MONGA",
              "866",
              "1200",
              "72.10%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "21009990080007",
            "name": "POONAM",
            "fatherName": "PALA RAM",
            "obtainedMarks": "864",
            "maxMarks": "1200",
            "percentage": "72%",
            "cells": [
              "4",
              "21009990080007",
              "POONAM",
              "PALA RAM",
              "864",
              "1200",
              "72%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com 2nd  year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "5",
            "rollNo": "00200090240001",
            "name": "AMANPREET KAUR",
            "fatherName": "CHANDI RAM",
            "obtainedMarks": "938",
            "maxMarks": "1350",
            "percentage": "69.50%",
            "cells": [
              "5",
              "00200090240001",
              "AMANPREET KAUR",
              "CHANDI RAM",
              "938",
              "1350",
              "69.50%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "00200090240005",
            "name": "DAMIYANTI",
            "fatherName": "DAYANAND",
            "obtainedMarks": "1013",
            "maxMarks": "1350",
            "percentage": "75%",
            "cells": [
              "6",
              "00200090240005",
              "DAMIYANTI",
              "DAYANAND",
              "1013",
              "1350",
              "75%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "00200090240008",
            "name": "JYOTSANA",
            "fatherName": "PREM KUMAR",
            "obtainedMarks": "1059",
            "maxMarks": "1350",
            "percentage": "78.40%",
            "cells": [
              "7",
              "00200090240008",
              "JYOTSANA",
              "PREM KUMAR",
              "1059",
              "1350",
              "78.40%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "00200090240010",
            "name": "KHUSHBOO",
            "fatherName": "NARESH",
            "obtainedMarks": "1057",
            "maxMarks": "1350",
            "percentage": "78.30%",
            "cells": [
              "8",
              "00200090240010",
              "KHUSHBOO",
              "NARESH",
              "1057",
              "1350",
              "78.30%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "00200090240014",
            "name": "PARNEET KAUR",
            "fatherName": "SARABJEET SINGH",
            "obtainedMarks": "965",
            "maxMarks": "1350",
            "percentage": "71.50%",
            "cells": [
              "9",
              "00200090240014",
              "PARNEET KAUR",
              "SARABJEET SINGH",
              "965",
              "1350",
              "71.50%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "00200090240022",
            "name": "SHEELA RANI",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "950",
            "maxMarks": "1350",
            "percentage": "70.40%",
            "cells": [
              "10",
              "00200090240022",
              "SHEELA RANI",
              "OM PARKASH",
              "950",
              "1350",
              "70.40%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "00200090240023",
            "name": "SNEHA KARWASRA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "1080",
            "maxMarks": "1350",
            "percentage": "80%",
            "cells": [
              "11",
              "00200090240023",
              "SNEHA KARWASRA",
              "NARESH KUMAR",
              "1080",
              "1350",
              "80%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "00200090240025",
            "name": "TAMANNA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "978",
            "maxMarks": "1350",
            "percentage": "72.40%",
            "cells": [
              "12",
              "00200090240025",
              "TAMANNA",
              "RAJ KUMAR",
              "978",
              "1350",
              "72.40%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Hindi 1st year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "13",
            "rollNo": "21009990200002",
            "name": "MANDEEP KAUR",
            "fatherName": "SATPAL",
            "obtainedMarks": "1008",
            "maxMarks": "1300",
            "percentage": "77.50%",
            "cells": [
              "13",
              "21009990200002",
              "MANDEEP KAUR",
              "SATPAL",
              "1008",
              "1300",
              "77.50%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "21009990200006",
            "name": "SAPNA",
            "fatherName": "JAI NARAYAN",
            "obtainedMarks": "972",
            "maxMarks": "1300",
            "percentage": "74.69%",
            "cells": [
              "14",
              "21009990200006",
              "SAPNA",
              "JAI NARAYAN",
              "972",
              "1300",
              "74.69%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "21009990200011",
            "name": "KANTA",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "917",
            "maxMarks": "1300",
            "percentage": "70.53%",
            "cells": [
              "15",
              "21009990200011",
              "KANTA",
              "RAI SINGH",
              "917",
              "1300",
              "70.53%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "21009990200014",
            "name": "KUMARI PRITI",
            "fatherName": "ATTAR SINGH",
            "obtainedMarks": "981",
            "maxMarks": "1300",
            "percentage": "75.46%",
            "cells": [
              "16",
              "21009990200014",
              "KUMARI PRITI",
              "ATTAR SINGH",
              "981",
              "1300",
              "75.46%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Hindi 2nd year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "17",
            "rollNo": "00200090300001",
            "name": "AKKI KAUR",
            "fatherName": "BUTA SINGH",
            "obtainedMarks": "1010",
            "maxMarks": "1300",
            "percentage": "77.69%",
            "cells": [
              "17",
              "00200090300001",
              "AKKI KAUR",
              "BUTA SINGH",
              "1010",
              "1300",
              "77.69%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "00200090300002",
            "name": "ASHA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "1006",
            "maxMarks": "1300",
            "percentage": "77.38%",
            "cells": [
              "18",
              "00200090300002",
              "ASHA",
              "VIJAY KUMAR",
              "1006",
              "1300",
              "77.38%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "00200090300003",
            "name": "KANIKA",
            "fatherName": "BALWANT SINGH",
            "obtainedMarks": "977",
            "maxMarks": "1300",
            "percentage": "75.15%",
            "cells": [
              "19",
              "00200090300003",
              "KANIKA",
              "BALWANT SINGH",
              "977",
              "1300",
              "75.15%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "00200090300004",
            "name": "KANTA",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1001",
            "maxMarks": "1300",
            "percentage": "77%",
            "cells": [
              "20",
              "00200090300004",
              "KANTA",
              "DHARAMPAL",
              "1001",
              "1300",
              "77%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "00200090300005",
            "name": "KIRAN BALA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "968",
            "maxMarks": "1300",
            "percentage": "74.46%",
            "cells": [
              "21",
              "00200090300005",
              "KIRAN BALA",
              "MAHENDER SINGH",
              "968",
              "1300",
              "74.46%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "00200090300007",
            "name": "MANITA RANI",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "949",
            "maxMarks": "1300",
            "percentage": "73%",
            "cells": [
              "22",
              "00200090300007",
              "MANITA RANI",
              "PRITHVI SINGH",
              "949",
              "1300",
              "73%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "00200090300011",
            "name": "POOJA RANI",
            "fatherName": "BANVARI LAL",
            "obtainedMarks": "913",
            "maxMarks": "1300",
            "percentage": "70.23%",
            "cells": [
              "23",
              "00200090300011",
              "POOJA RANI",
              "BANVARI LAL",
              "913",
              "1300",
              "70.23%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "00200090300012",
            "name": "POOJA RANI",
            "fatherName": "BHAGAT SINGH",
            "obtainedMarks": "1027",
            "maxMarks": "1300",
            "percentage": "79%",
            "cells": [
              "24",
              "00200090300012",
              "POOJA RANI",
              "BHAGAT SINGH",
              "1027",
              "1300",
              "79%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "00200090300014",
            "name": "POONAM",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "994",
            "maxMarks": "1300",
            "percentage": "76.46%",
            "cells": [
              "25",
              "00200090300014",
              "POONAM",
              "RAJENDER KUMAR",
              "994",
              "1300",
              "76.46%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "00200090300015",
            "name": "POONAM",
            "fatherName": "RAMCHANDER",
            "obtainedMarks": "992",
            "maxMarks": "1300",
            "percentage": "76.31%",
            "cells": [
              "26",
              "00200090300015",
              "POONAM",
              "RAMCHANDER",
              "992",
              "1300",
              "76.31%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "00200090300016",
            "name": "POONAM THAKUR",
            "fatherName": "GURMAIL SINGH",
            "obtainedMarks": "1013",
            "maxMarks": "1300",
            "percentage": "77.92%",
            "cells": [
              "27",
              "00200090300016",
              "POONAM THAKUR",
              "GURMAIL SINGH",
              "1013",
              "1300",
              "77.92%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "00200090300017",
            "name": "RITU",
            "fatherName": "SUBASH",
            "obtainedMarks": "923",
            "maxMarks": "1300",
            "percentage": "71%",
            "cells": [
              "28",
              "00200090300017",
              "RITU",
              "SUBASH",
              "923",
              "1300",
              "71%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "00200090300022",
            "name": "VANDNA",
            "fatherName": "CHANAN DASS",
            "obtainedMarks": "975",
            "maxMarks": "1300",
            "percentage": "75%",
            "cells": [
              "29",
              "00200090300022",
              "VANDNA",
              "CHANAN DASS",
              "975",
              "1300",
              "75%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Eng. 1st  year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A ENG. 2nd year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "30",
            "rollNo": "00200090250006",
            "name": "JYOTI",
            "fatherName": "JAIPAL SINGH",
            "obtainedMarks": "846",
            "maxMarks": "1200",
            "percentage": "70.50%",
            "cells": [
              "30",
              "00200090250006",
              "JYOTI",
              "JAIPAL SINGH",
              "846",
              "1200",
              "70.50%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A PUB.AD. 1ST YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "31",
            "rollNo": "21009990140001",
            "name": "KIRAN",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "1076",
            "maxMarks": "1300",
            "percentage": "82.77%",
            "cells": [
              "31",
              "21009990140001",
              "KIRAN",
              "RAJENDER SINGH",
              "1076",
              "1300",
              "82.77%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "21009990140002",
            "name": "RAVINA DEVI",
            "fatherName": "AJAY PAL",
            "obtainedMarks": "951",
            "maxMarks": "1300",
            "percentage": "73.15%",
            "cells": [
              "32",
              "21009990140002",
              "RAVINA DEVI",
              "AJAY PAL",
              "951",
              "1300",
              "73.15%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "21009990140003",
            "name": "BABITA",
            "fatherName": "RAM KISHAN",
            "obtainedMarks": "942",
            "maxMarks": "1300",
            "percentage": "72.46%",
            "cells": [
              "33",
              "21009990140003",
              "BABITA",
              "RAM KISHAN",
              "942",
              "1300",
              "72.46%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "21009990140004",
            "name": "REKHA",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "917",
            "maxMarks": "1300",
            "percentage": "70.54%",
            "cells": [
              "34",
              "21009990140004",
              "REKHA",
              "SHYAM LAL",
              "917",
              "1300",
              "70.54%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "21009990140006",
            "name": "MAMTA",
            "fatherName": "MAHER CHAND",
            "obtainedMarks": "972",
            "maxMarks": "1300",
            "percentage": "74.77%",
            "cells": [
              "35",
              "21009990140006",
              "MAMTA",
              "MAHER CHAND",
              "972",
              "1300",
              "74.77%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "21009990140007",
            "name": "MAHIMA",
            "fatherName": "VIJESH KUMAR",
            "obtainedMarks": "1079",
            "maxMarks": "1300",
            "percentage": "83%",
            "cells": [
              "36",
              "21009990140007",
              "MAHIMA",
              "VIJESH KUMAR",
              "1079",
              "1300",
              "83%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "21009990140008",
            "name": "ISHVER",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "924",
            "maxMarks": "1300",
            "percentage": "71.08%",
            "cells": [
              "37",
              "21009990140008",
              "ISHVER",
              "RANJEET SINGH",
              "924",
              "1300",
              "71.08%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "21009990140009",
            "name": "KAPISHA POONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "1066",
            "maxMarks": "1300",
            "percentage": "82%",
            "cells": [
              "38",
              "21009990140009",
              "KAPISHA POONIA",
              "SANJAY KUMAR",
              "1066",
              "1300",
              "82%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "21009990140014",
            "name": "SHRADHA",
            "fatherName": "ST GURMEET RAM RAHIM SINGH INSAN",
            "obtainedMarks": "962",
            "maxMarks": "1300",
            "percentage": "74%",
            "cells": [
              "39",
              "21009990140014",
              "SHRADHA",
              "ST GURMEET RAM RAHIM SINGH INSAN",
              "962",
              "1300",
              "74%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "21009990140015",
            "name": "JYOTI",
            "fatherName": "DAMODAR",
            "obtainedMarks": "985",
            "maxMarks": "1300",
            "percentage": "75.77%",
            "cells": [
              "40",
              "21009990140015",
              "JYOTI",
              "DAMODAR",
              "985",
              "1300",
              "75.77%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "21009990140016",
            "name": "ANJU DEVI",
            "fatherName": "RAM MURTI",
            "obtainedMarks": "924",
            "maxMarks": "1300",
            "percentage": "71.08%",
            "cells": [
              "41",
              "21009990140016",
              "ANJU DEVI",
              "RAM MURTI",
              "924",
              "1300",
              "71.08%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "21009990140017",
            "name": "PRIYANKA BALA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "990",
            "maxMarks": "1300",
            "percentage": "76.15%",
            "cells": [
              "42",
              "21009990140017",
              "PRIYANKA BALA",
              "MADAN LAL",
              "990",
              "1300",
              "76.15%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "21009990140018",
            "name": "SONU DEVI",
            "fatherName": "HARNARAYAN",
            "obtainedMarks": "919",
            "maxMarks": "1300",
            "percentage": "70.69%",
            "cells": [
              "43",
              "21009990140018",
              "SONU DEVI",
              "HARNARAYAN",
              "919",
              "1300",
              "70.69%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "21009990140019",
            "name": "NIDHI",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "1026",
            "maxMarks": "1300",
            "percentage": "78.92%",
            "cells": [
              "44",
              "21009990140019",
              "NIDHI",
              "RAJINDER SINGH",
              "1026",
              "1300",
              "78.92%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "21009990140020",
            "name": "POOJA",
            "fatherName": "RAJESH",
            "obtainedMarks": "980",
            "maxMarks": "1300",
            "percentage": "75.38%",
            "cells": [
              "45",
              "21009990140020",
              "POOJA",
              "RAJESH",
              "980",
              "1300",
              "75.38%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "21009990140021",
            "name": "MUNIYA",
            "fatherName": "NANHA RAM",
            "obtainedMarks": "911",
            "maxMarks": "1300",
            "percentage": "70.08%",
            "cells": [
              "46",
              "21009990140021",
              "MUNIYA",
              "NANHA RAM",
              "911",
              "1300",
              "70.08%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "21009990140024",
            "name": "SHIWANGI",
            "fatherName": "DEVI DYAL",
            "obtainedMarks": "1017",
            "maxMarks": "1300",
            "percentage": "78.23%",
            "cells": [
              "47",
              "21009990140024",
              "SHIWANGI",
              "DEVI DYAL",
              "1017",
              "1300",
              "78.23%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "21009990140026",
            "name": "SONU",
            "fatherName": "PALA RAM",
            "obtainedMarks": "937",
            "maxMarks": "1300",
            "percentage": "72.08%",
            "cells": [
              "48",
              "21009990140026",
              "SONU",
              "PALA RAM",
              "937",
              "1300",
              "72.08%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "21009990140028",
            "name": "NISHA RANI",
            "fatherName": "LAL CHAND",
            "obtainedMarks": "945",
            "maxMarks": "1300",
            "percentage": "72.69%",
            "cells": [
              "49",
              "21009990140028",
              "NISHA RANI",
              "LAL CHAND",
              "945",
              "1300",
              "72.69%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A PUB.AD. 2nd YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "50",
            "rollNo": "00200090260011",
            "name": "PRIYANKA",
            "fatherName": "BIHARI LAL",
            "obtainedMarks": "882",
            "maxMarks": "1200",
            "percentage": "73.50%",
            "cells": [
              "50",
              "00200090260011",
              "PRIYANKA",
              "BIHARI LAL",
              "882",
              "1200",
              "73.50%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "00200090260012",
            "name": "RAMBHATERI",
            "fatherName": "MIYAN SINGH",
            "obtainedMarks": "841",
            "maxMarks": "1200",
            "percentage": "70.08%",
            "cells": [
              "51",
              "00200090260012",
              "RAMBHATERI",
              "MIYAN SINGH",
              "841",
              "1200",
              "70.08%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "00200090260013",
            "name": "RENU SHARMA",
            "fatherName": "GANGA RAM",
            "obtainedMarks": "842",
            "maxMarks": "1200",
            "percentage": "70.17%",
            "cells": [
              "52",
              "00200090260013",
              "RENU SHARMA",
              "GANGA RAM",
              "842",
              "1200",
              "70.17%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "00200090260014",
            "name": "RITU",
            "fatherName": "KARNI SINGH",
            "obtainedMarks": "943",
            "maxMarks": "1200",
            "percentage": "78.58%",
            "cells": [
              "53",
              "00200090260014",
              "RITU",
              "KARNI SINGH",
              "943",
              "1200",
              "78.58%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "00200090260019",
            "name": "SAROJ",
            "fatherName": "SAHAB RAM",
            "obtainedMarks": "908",
            "maxMarks": "1200",
            "percentage": "75.67%",
            "cells": [
              "54",
              "00200090260019",
              "SAROJ",
              "SAHAB RAM",
              "908",
              "1200",
              "75.67%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "00200090260020",
            "name": "SAVINA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "971",
            "maxMarks": "1200",
            "percentage": "80.92%",
            "cells": [
              "55",
              "00200090260020",
              "SAVINA",
              "RAN SINGH",
              "971",
              "1200",
              "80.92%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "00200090260021",
            "name": "SUMAN DEVI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "930",
            "maxMarks": "1200",
            "percentage": "77.50%",
            "cells": [
              "56",
              "00200090260021",
              "SUMAN DEVI",
              "BANWARI LAL",
              "930",
              "1200",
              "77.50%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "00200090260023",
            "name": "TAMANNA",
            "fatherName": "VIRENDER",
            "obtainedMarks": "932",
            "maxMarks": "1200",
            "percentage": "77.67%",
            "cells": [
              "57",
              "00200090260023",
              "TAMANNA",
              "VIRENDER",
              "932",
              "1200",
              "77.67%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "00200090260024",
            "name": "VANDNA",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "911",
            "maxMarks": "1200",
            "percentage": "75.92%",
            "cells": [
              "58",
              "00200090260024",
              "VANDNA",
              "PRITHVI SINGH",
              "911",
              "1200",
              "75.92%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC MATHS 1ST YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "59",
            "rollNo": "21009993510004",
            "name": "RUPALI",
            "fatherName": "SANJEEV KHURANA",
            "obtainedMarks": "882",
            "maxMarks": "1250",
            "percentage": "70.16%",
            "cells": [
              "59",
              "21009993510004",
              "RUPALI",
              "SANJEEV KHURANA",
              "882",
              "1250",
              "70.16%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "21009993510007",
            "name": "MANPREET KAUR",
            "fatherName": "JEET SINGH",
            "obtainedMarks": "952",
            "maxMarks": "1250",
            "percentage": "76.16%",
            "cells": [
              "60",
              "21009993510007",
              "MANPREET KAUR",
              "JEET SINGH",
              "952",
              "1250",
              "76.16%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC MATHS 2ND YEAR",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "61",
            "rollNo": "00200090140001",
            "name": "ANKISHA",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "970",
            "maxMarks": "1200",
            "percentage": "80.83%",
            "cells": [
              "61",
              "00200090140001",
              "ANKISHA",
              "SHAMSHER SINGH",
              "970",
              "1200",
              "80.83%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "00200090140002",
            "name": "JASMEET KAUR DANG",
            "fatherName": "MOHINDER SINGH",
            "obtainedMarks": "854",
            "maxMarks": "1200",
            "percentage": "71.16%",
            "cells": [
              "62",
              "00200090140002",
              "JASMEET KAUR DANG",
              "MOHINDER SINGH",
              "854",
              "1200",
              "71.16%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "00200090140016",
            "name": "SHAKILA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "950",
            "maxMarks": "1200",
            "percentage": "79.16%",
            "cells": [
              "63",
              "00200090140016",
              "SHAKILA",
              "MAHENDER SINGH",
              "950",
              "1200",
              "79.16%"
            ]
          }
        ]
      },
      {
        "courseName": "B.ped 1st year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "64",
            "rollNo": "21009115510001",
            "name": "MANJU RANI",
            "fatherName": "RANDHIR SINGH",
            "obtainedMarks": "1306",
            "maxMarks": "1600",
            "percentage": "81.62%",
            "cells": [
              "64",
              "21009115510001",
              "MANJU RANI",
              "RANDHIR SINGH",
              "1306",
              "1600",
              "81.62%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "21009115510003",
            "name": "ANU",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "1190",
            "maxMarks": "1600",
            "percentage": "74.38%",
            "cells": [
              "65",
              "21009115510003",
              "ANU",
              "HARI SINGH",
              "1190",
              "1600",
              "74.38%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "21009115510004",
            "name": "RITU",
            "fatherName": "JAIBIR SINGH",
            "obtainedMarks": "1249",
            "maxMarks": "1600",
            "percentage": "78.06%",
            "cells": [
              "66",
              "21009115510004",
              "RITU",
              "JAIBIR SINGH",
              "1249",
              "1600",
              "78.06%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "21009115510005",
            "name": "LAXMI RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "67",
              "21009115510005",
              "LAXMI RANI",
              "GOPAL",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "21009115510006",
            "name": "POONAM RANI",
            "fatherName": "SURJEET",
            "obtainedMarks": "1268",
            "maxMarks": "1600",
            "percentage": "79.25%",
            "cells": [
              "68",
              "21009115510006",
              "POONAM RANI",
              "SURJEET",
              "1268",
              "1600",
              "79.25%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "21009115510007",
            "name": "JYOTI",
            "fatherName": "KARAN SINGH",
            "obtainedMarks": "1290",
            "maxMarks": "1600",
            "percentage": "80.62%",
            "cells": [
              "69",
              "21009115510007",
              "JYOTI",
              "KARAN SINGH",
              "1290",
              "1600",
              "80.62%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "21009115510008",
            "name": "AMANDEEP KAUR",
            "fatherName": "IQBAL SINGH",
            "obtainedMarks": "1275",
            "maxMarks": "1600",
            "percentage": "79.69%",
            "cells": [
              "70",
              "21009115510008",
              "AMANDEEP KAUR",
              "IQBAL SINGH",
              "1275",
              "1600",
              "79.69%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "21009115510009",
            "name": "POONAM",
            "fatherName": "SHANKAR LAL",
            "obtainedMarks": "1174",
            "maxMarks": "1600",
            "percentage": "73.38%",
            "cells": [
              "71",
              "21009115510009",
              "POONAM",
              "SHANKAR LAL",
              "1174",
              "1600",
              "73.38%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "21009115510010",
            "name": "NISHA RANI",
            "fatherName": "RAJKUMAR",
            "obtainedMarks": "1259",
            "maxMarks": "1600",
            "percentage": "78.69%",
            "cells": [
              "72",
              "21009115510010",
              "NISHA RANI",
              "RAJKUMAR",
              "1259",
              "1600",
              "78.69%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "21009115510011",
            "name": "DEEPANSHI",
            "fatherName": "DAULAT RAM",
            "obtainedMarks": "1172",
            "maxMarks": "1600",
            "percentage": "73.25%",
            "cells": [
              "73",
              "21009115510011",
              "DEEPANSHI",
              "DAULAT RAM",
              "1172",
              "1600",
              "73.25%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "21009115510013",
            "name": "AMRITA KUMARI",
            "fatherName": "ELIS GARG",
            "obtainedMarks": "1257",
            "maxMarks": "1600",
            "percentage": "78.56%",
            "cells": [
              "74",
              "21009115510013",
              "AMRITA KUMARI",
              "ELIS GARG",
              "1257",
              "1600",
              "78.56%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "21009115510014",
            "name": "RAVINA",
            "fatherName": "KRISHAN CHANDER",
            "obtainedMarks": "1216",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "75",
              "21009115510014",
              "RAVINA",
              "KRISHAN CHANDER",
              "1216",
              "1600",
              "76%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "21009115510015",
            "name": "MONIKA",
            "fatherName": "RAMNIWAS POONIA",
            "obtainedMarks": "1225",
            "maxMarks": "1600",
            "percentage": "76.56%",
            "cells": [
              "76",
              "21009115510015",
              "MONIKA",
              "RAMNIWAS POONIA",
              "1225",
              "1600",
              "76.56%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "21009115510016",
            "name": "NISHA DAVI",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "1223",
            "maxMarks": "1600",
            "percentage": "76.44%",
            "cells": [
              "77",
              "21009115510016",
              "NISHA DAVI",
              "VIJAY SINGH",
              "1223",
              "1600",
              "76.44%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "21009115510017",
            "name": "VIMLA KUMARI",
            "fatherName": "RAM SWROOP",
            "obtainedMarks": "1233",
            "maxMarks": "1600",
            "percentage": "77.06%",
            "cells": [
              "78",
              "21009115510017",
              "VIMLA KUMARI",
              "RAM SWROOP",
              "1233",
              "1600",
              "77.06%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "21009115510018",
            "name": "RACHANA",
            "fatherName": "TOTA RAM",
            "obtainedMarks": "1203",
            "maxMarks": "1600",
            "percentage": "75.19%",
            "cells": [
              "79",
              "21009115510018",
              "RACHANA",
              "TOTA RAM",
              "1203",
              "1600",
              "75.19%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "21009115510019",
            "name": "KAVITA",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "1145",
            "maxMarks": "1600",
            "percentage": "71.56%",
            "cells": [
              "80",
              "21009115510019",
              "KAVITA",
              "HANSRAJ",
              "1145",
              "1600",
              "71.56%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "21009115510020",
            "name": "NITU",
            "fatherName": "BRIJ LAL",
            "obtainedMarks": "1141",
            "maxMarks": "1600",
            "percentage": "71.31%",
            "cells": [
              "81",
              "21009115510020",
              "NITU",
              "BRIJ LAL",
              "1141",
              "1600",
              "71.31%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "21009115510022",
            "name": "SHARDA",
            "fatherName": "MANIRAM KASWAN",
            "obtainedMarks": "1246",
            "maxMarks": "1600",
            "percentage": "77.88%",
            "cells": [
              "82",
              "21009115510022",
              "SHARDA",
              "MANIRAM KASWAN",
              "1246",
              "1600",
              "77.88%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "21009115510023",
            "name": "SAROJ",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "1244",
            "maxMarks": "1600",
            "percentage": "77.75%",
            "cells": [
              "83",
              "21009115510023",
              "SAROJ",
              "BANWARI LAL",
              "1244",
              "1600",
              "77.75%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "21009115510024",
            "name": "SUSHEELA",
            "fatherName": "SATPAL",
            "obtainedMarks": "1233",
            "maxMarks": "1600",
            "percentage": "77.06%",
            "cells": [
              "84",
              "21009115510024",
              "SUSHEELA",
              "SATPAL",
              "1233",
              "1600",
              "77.06%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "21009115510025",
            "name": "MS. KIRAN PREET KAUR",
            "fatherName": "BALKARAN SINGH",
            "obtainedMarks": "1197",
            "maxMarks": "1600",
            "percentage": "74.81%",
            "cells": [
              "85",
              "21009115510025",
              "MS. KIRAN PREET KAUR",
              "BALKARAN SINGH",
              "1197",
              "1600",
              "74.81%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "21009115510026",
            "name": "VEERPAL KAUR",
            "fatherName": "JAGTAR SINGH",
            "obtainedMarks": "1168",
            "maxMarks": "1600",
            "percentage": "73%",
            "cells": [
              "86",
              "21009115510026",
              "VEERPAL KAUR",
              "JAGTAR SINGH",
              "1168",
              "1600",
              "73%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "21009115510027",
            "name": "BEANT KAUR",
            "fatherName": "SOHAN SINGH",
            "obtainedMarks": "1151",
            "maxMarks": "1600",
            "percentage": "71.94%",
            "cells": [
              "87",
              "21009115510027",
              "BEANT KAUR",
              "SOHAN SINGH",
              "1151",
              "1600",
              "71.94%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "21009115510028",
            "name": "SANJU JAKHAR",
            "fatherName": "ISHWAR SINGH",
            "obtainedMarks": "1175",
            "maxMarks": "1600",
            "percentage": "73.44%",
            "cells": [
              "88",
              "21009115510028",
              "SANJU JAKHAR",
              "ISHWAR SINGH",
              "1175",
              "1600",
              "73.44%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "21009115510029",
            "name": "SHASHI RANGA",
            "fatherName": "HARVEER RANGA",
            "obtainedMarks": "1169",
            "maxMarks": "1600",
            "percentage": "73.06%",
            "cells": [
              "89",
              "21009115510029",
              "SHASHI RANGA",
              "HARVEER RANGA",
              "1169",
              "1600",
              "73.06%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "21009115510030",
            "name": "SONIA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1288",
            "maxMarks": "1600",
            "percentage": "80.50%",
            "cells": [
              "90",
              "21009115510030",
              "SONIA",
              "KRISHAN KUMAR",
              "1288",
              "1600",
              "80.50%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "21009115510031",
            "name": "KIRAN DEEP",
            "fatherName": "MAKKHAN SINGH",
            "obtainedMarks": "1190",
            "maxMarks": "1600",
            "percentage": "74.38%",
            "cells": [
              "91",
              "21009115510031",
              "KIRAN DEEP",
              "MAKKHAN SINGH",
              "1190",
              "1600",
              "74.38%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "21009115510032",
            "name": "ANSHUL",
            "fatherName": "JOGINDER SINGH",
            "obtainedMarks": "1173",
            "maxMarks": "1600",
            "percentage": "73.31%",
            "cells": [
              "92",
              "21009115510032",
              "ANSHUL",
              "JOGINDER SINGH",
              "1173",
              "1600",
              "73.31%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "21009115510034",
            "name": "ANJU BALA",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "1260",
            "maxMarks": "1600",
            "percentage": "78.75%",
            "cells": [
              "93",
              "21009115510034",
              "ANJU BALA",
              "BANSI LAL",
              "1260",
              "1600",
              "78.75%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "21009115510035",
            "name": "VAISHNAVI SHARMA",
            "fatherName": "SARVOTTAM SHARMA",
            "obtainedMarks": "1239",
            "maxMarks": "1600",
            "percentage": "77.44%",
            "cells": [
              "94",
              "21009115510035",
              "VAISHNAVI SHARMA",
              "SARVOTTAM SHARMA",
              "1239",
              "1600",
              "77.44%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "21009115510037",
            "name": "KIRTI INSAN",
            "fatherName": "RULDA INSAN",
            "obtainedMarks": "1360",
            "maxMarks": "1600",
            "percentage": "85%",
            "cells": [
              "95",
              "21009115510037",
              "KIRTI INSAN",
              "RULDA INSAN",
              "1360",
              "1600",
              "85%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "21009115510039",
            "name": "PARMESHWARI",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "96",
              "21009115510039",
              "PARMESHWARI",
              "MAHENDER SINGH",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "21009115510040",
            "name": "USHA",
            "fatherName": "ROHTASH",
            "obtainedMarks": "1221",
            "maxMarks": "1600",
            "percentage": "76.31%",
            "cells": [
              "97",
              "21009115510040",
              "USHA",
              "ROHTASH",
              "1221",
              "1600",
              "76.31%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "21009115510041",
            "name": "KOMAL",
            "fatherName": "SUKHBIR SINGH",
            "obtainedMarks": "1329",
            "maxMarks": "1600",
            "percentage": "83.06%",
            "cells": [
              "98",
              "21009115510041",
              "KOMAL",
              "SUKHBIR SINGH",
              "1329",
              "1600",
              "83.06%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "21009115510042",
            "name": "POOJA",
            "fatherName": "BALWANT",
            "obtainedMarks": "1275",
            "maxMarks": "1600",
            "percentage": "79.69%",
            "cells": [
              "99",
              "21009115510042",
              "POOJA",
              "BALWANT",
              "1275",
              "1600",
              "79.69%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "21009115510043",
            "name": "SAVITA",
            "fatherName": "MAHENDER PAL",
            "obtainedMarks": "1251",
            "maxMarks": "1600",
            "percentage": "78.19%",
            "cells": [
              "100",
              "21009115510043",
              "SAVITA",
              "MAHENDER PAL",
              "1251",
              "1600",
              "78.19%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "21009115510047",
            "name": "KAVITA",
            "fatherName": "SHRI RAM",
            "obtainedMarks": "1188",
            "maxMarks": "1600",
            "percentage": "74.25%",
            "cells": [
              "101",
              "21009115510047",
              "KAVITA",
              "SHRI RAM",
              "1188",
              "1600",
              "74.25%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "21009115510048",
            "name": "KIRAN",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1172",
            "maxMarks": "1600",
            "percentage": "73.25%",
            "cells": [
              "102",
              "21009115510048",
              "KIRAN",
              "KRISHAN KUMAR",
              "1172",
              "1600",
              "73.25%"
            ]
          }
        ]
      },
      {
        "courseName": "B.ped 2nd year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "103",
            "rollNo": "00200090510001",
            "name": "AARTI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1304",
            "maxMarks": "1600",
            "percentage": "81.50%",
            "cells": [
              "103",
              "00200090510001",
              "AARTI",
              "KRISHAN KUMAR",
              "1304",
              "1600",
              "81.50%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "00200090510002",
            "name": "MS ALKA JAGARWAL",
            "fatherName": "SOHAN LAL JAGARWAL",
            "obtainedMarks": "1247",
            "maxMarks": "1600",
            "percentage": "77.94%",
            "cells": [
              "104",
              "00200090510002",
              "MS ALKA JAGARWAL",
              "SOHAN LAL JAGARWAL",
              "1247",
              "1600",
              "77.94%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "00200090510003",
            "name": "AMISHA PRAJAPATI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1215",
            "maxMarks": "1600",
            "percentage": "75.94%",
            "cells": [
              "105",
              "00200090510003",
              "AMISHA PRAJAPATI",
              "MADAN LAL",
              "1215",
              "1600",
              "75.94%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "00200090510004",
            "name": "ANITA KUMARI",
            "fatherName": "LAKHMI CHAND",
            "obtainedMarks": "1289",
            "maxMarks": "1600",
            "percentage": "80.56%",
            "cells": [
              "106",
              "00200090510004",
              "ANITA KUMARI",
              "LAKHMI CHAND",
              "1289",
              "1600",
              "80.56%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "00200090510005",
            "name": "ANJU",
            "fatherName": "HOSHIYAR SINGH",
            "obtainedMarks": "1247",
            "maxMarks": "1600",
            "percentage": "77.94%",
            "cells": [
              "107",
              "00200090510005",
              "ANJU",
              "HOSHIYAR SINGH",
              "1247",
              "1600",
              "77.94%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "00200090510006",
            "name": "BANSO RANI",
            "fatherName": "MAJOR SINGH",
            "obtainedMarks": "1239",
            "maxMarks": "1600",
            "percentage": "77.44%",
            "cells": [
              "108",
              "00200090510006",
              "BANSO RANI",
              "MAJOR SINGH",
              "1239",
              "1600",
              "77.44%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "00200090510007",
            "name": "JASWINDER KAUR",
            "fatherName": "GULSHAN KUMAR",
            "obtainedMarks": "1289",
            "maxMarks": "1600",
            "percentage": "80.56%",
            "cells": [
              "109",
              "00200090510007",
              "JASWINDER KAUR",
              "GULSHAN KUMAR",
              "1289",
              "1600",
              "80.56%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "00200090510008",
            "name": "KRISHNA KANWAR RANAWAT",
            "fatherName": "AJIT SINGH RANAWAT",
            "obtainedMarks": "1225",
            "maxMarks": "1600",
            "percentage": "76.56%",
            "cells": [
              "110",
              "00200090510008",
              "KRISHNA KANWAR RANAWAT",
              "AJIT SINGH RANAWAT",
              "1225",
              "1600",
              "76.56%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "00200090510009",
            "name": "KULWINDER KAUR",
            "fatherName": "DARSHAN SINGH",
            "obtainedMarks": "1305",
            "maxMarks": "1600",
            "percentage": "81.56%",
            "cells": [
              "111",
              "00200090510009",
              "KULWINDER KAUR",
              "DARSHAN SINGH",
              "1305",
              "1600",
              "81.56%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "00200090510010",
            "name": "KUSUM RANI",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1237",
            "maxMarks": "1600",
            "percentage": "77.31%",
            "cells": [
              "112",
              "00200090510010",
              "KUSUM RANI",
              "MAHENDER SINGH",
              "1237",
              "1600",
              "77.31%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "00200090510011",
            "name": "MANISHA",
            "fatherName": "HANUMAN PARSAD",
            "obtainedMarks": "1177",
            "maxMarks": "1600",
            "percentage": "73.56%",
            "cells": [
              "113",
              "00200090510011",
              "MANISHA",
              "HANUMAN PARSAD",
              "1177",
              "1600",
              "73.56%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "00200090510013",
            "name": "NEHA SHARMA",
            "fatherName": "MANGA RAM",
            "obtainedMarks": "1265",
            "maxMarks": "1600",
            "percentage": "79.06%",
            "cells": [
              "114",
              "00200090510013",
              "NEHA SHARMA",
              "MANGA RAM",
              "1265",
              "1600",
              "79.06%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "00200090510014",
            "name": "NIRMAL",
            "fatherName": "HAWA SINGH PUNIA",
            "obtainedMarks": "1294",
            "maxMarks": "1600",
            "percentage": "80.88%",
            "cells": [
              "115",
              "00200090510014",
              "NIRMAL",
              "HAWA SINGH PUNIA",
              "1294",
              "1600",
              "80.88%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "00200090510015",
            "name": "POOJA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1127",
            "maxMarks": "1600",
            "percentage": "70.44%",
            "cells": [
              "116",
              "00200090510015",
              "POOJA",
              "OM PARKASH",
              "1127",
              "1600",
              "70.44%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "00200090510017",
            "name": "POONAM",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1174",
            "maxMarks": "1600",
            "percentage": "73.38%",
            "cells": [
              "117",
              "00200090510017",
              "POONAM",
              "OM PARKASH",
              "1174",
              "1600",
              "73.38%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "00200090510018",
            "name": "POONAM RANI",
            "fatherName": "KRISHAN SINGH",
            "obtainedMarks": "1209",
            "maxMarks": "1600",
            "percentage": "75.56%",
            "cells": [
              "118",
              "00200090510018",
              "POONAM RANI",
              "KRISHAN SINGH",
              "1209",
              "1600",
              "75.56%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "00200090510019",
            "name": "POONAM RANI",
            "fatherName": "SUNIL DUTT",
            "obtainedMarks": "1256",
            "maxMarks": "1600",
            "percentage": "78.50%",
            "cells": [
              "119",
              "00200090510019",
              "POONAM RANI",
              "SUNIL DUTT",
              "1256",
              "1600",
              "78.50%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "00200090510020",
            "name": "PREMWATI",
            "fatherName": "SURAJ PAL",
            "obtainedMarks": "1203",
            "maxMarks": "1600",
            "percentage": "75.19%",
            "cells": [
              "120",
              "00200090510020",
              "PREMWATI",
              "SURAJ PAL",
              "1203",
              "1600",
              "75.19%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "00200090510021",
            "name": "PRIYANKA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1266",
            "maxMarks": "1600",
            "percentage": "79.12%",
            "cells": [
              "121",
              "00200090510021",
              "PRIYANKA",
              "KRISHAN KUMAR",
              "1266",
              "1600",
              "79.12%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "00200090510022",
            "name": "PRIYANKA",
            "fatherName": "MEWA SINGH",
            "obtainedMarks": "1304",
            "maxMarks": "1600",
            "percentage": "81.50%",
            "cells": [
              "122",
              "00200090510022",
              "PRIYANKA",
              "MEWA SINGH",
              "1304",
              "1600",
              "81.50%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "00200090510023",
            "name": "RAJBALA",
            "fatherName": "HANUMAN PARSAD",
            "obtainedMarks": "1322",
            "maxMarks": "1600",
            "percentage": "82.62%",
            "cells": [
              "123",
              "00200090510023",
              "RAJBALA",
              "HANUMAN PARSAD",
              "1322",
              "1600",
              "82.62%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "00200090510024",
            "name": "RAJBINDER KAUR",
            "fatherName": "MAJOR SINGH",
            "obtainedMarks": "1290",
            "maxMarks": "1600",
            "percentage": "80.62%",
            "cells": [
              "124",
              "00200090510024",
              "RAJBINDER KAUR",
              "MAJOR SINGH",
              "1290",
              "1600",
              "80.62%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "00200090510025",
            "name": "RAMRATI",
            "fatherName": "ANOOP SINGH",
            "obtainedMarks": "1225",
            "maxMarks": "1600",
            "percentage": "76.56%",
            "cells": [
              "125",
              "00200090510025",
              "RAMRATI",
              "ANOOP SINGH",
              "1225",
              "1600",
              "76.56%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "00200090510027",
            "name": "RITU",
            "fatherName": "RANVIR SINGH",
            "obtainedMarks": "1262",
            "maxMarks": "1600",
            "percentage": "78.88%",
            "cells": [
              "126",
              "00200090510027",
              "RITU",
              "RANVIR SINGH",
              "1262",
              "1600",
              "78.88%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "00200090510028",
            "name": "RUTESH KUMARI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "1255",
            "maxMarks": "1600",
            "percentage": "78.44%",
            "cells": [
              "127",
              "00200090510028",
              "RUTESH KUMARI",
              "RAJ KUMAR",
              "1255",
              "1600",
              "78.44%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "00200090510029",
            "name": "SAKSHI",
            "fatherName": "BAL RAM SHARMA",
            "obtainedMarks": "1278",
            "maxMarks": "1600",
            "percentage": "79.88%",
            "cells": [
              "128",
              "00200090510029",
              "SAKSHI",
              "BAL RAM SHARMA",
              "1278",
              "1600",
              "79.88%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "00200090510030",
            "name": "SAKSHI",
            "fatherName": "DEVENDER KUMAR",
            "obtainedMarks": "1180",
            "maxMarks": "1600",
            "percentage": "73.75%",
            "cells": [
              "129",
              "00200090510030",
              "SAKSHI",
              "DEVENDER KUMAR",
              "1180",
              "1600",
              "73.75%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "00200090510031",
            "name": "SANGEETA DUHAN",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1302",
            "maxMarks": "1600",
            "percentage": "81.38%",
            "cells": [
              "130",
              "00200090510031",
              "SANGEETA DUHAN",
              "SURESH KUMAR",
              "1302",
              "1600",
              "81.38%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "00200090510032",
            "name": "SATVEER KAUR",
            "fatherName": "LAKHWINDER SINGH",
            "obtainedMarks": "1281",
            "maxMarks": "1600",
            "percentage": "80.06%",
            "cells": [
              "131",
              "00200090510032",
              "SATVEER KAUR",
              "LAKHWINDER SINGH",
              "1281",
              "1600",
              "80.06%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "00200090510033",
            "name": "SEEMA RANI",
            "fatherName": "NANDLAL",
            "obtainedMarks": "1190",
            "maxMarks": "1600",
            "percentage": "74.38%",
            "cells": [
              "132",
              "00200090510033",
              "SEEMA RANI",
              "NANDLAL",
              "1190",
              "1600",
              "74.38%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "00200090510035",
            "name": "SHUBHAM",
            "fatherName": "HAWA SINGH PUNIA",
            "obtainedMarks": "1177",
            "maxMarks": "1600",
            "percentage": "73.56%",
            "cells": [
              "133",
              "00200090510035",
              "SHUBHAM",
              "HAWA SINGH PUNIA",
              "1177",
              "1600",
              "73.56%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "00200090510036",
            "name": "SONU",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "1288",
            "maxMarks": "1600",
            "percentage": "80.50%",
            "cells": [
              "134",
              "00200090510036",
              "SONU",
              "RAM NIWAS",
              "1288",
              "1600",
              "80.50%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "00200090510037",
            "name": "SULOCHANA",
            "fatherName": "BANWARI",
            "obtainedMarks": "1245",
            "maxMarks": "1600",
            "percentage": "77.81%",
            "cells": [
              "135",
              "00200090510037",
              "SULOCHANA",
              "BANWARI",
              "1245",
              "1600",
              "77.81%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "00200090510038",
            "name": "SUMAN DEVI",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1190",
            "maxMarks": "1600",
            "percentage": "74.38%",
            "cells": [
              "136",
              "00200090510038",
              "SUMAN DEVI",
              "OM PARKASH",
              "1190",
              "1600",
              "74.38%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "00200090510039",
            "name": "SUNITA KUMARI",
            "fatherName": "BHANI RAM",
            "obtainedMarks": "1251",
            "maxMarks": "1600",
            "percentage": "78.19%",
            "cells": [
              "137",
              "00200090510039",
              "SUNITA KUMARI",
              "BHANI RAM",
              "1251",
              "1600",
              "78.19%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "00200090510040",
            "name": "SUNITA RANI",
            "fatherName": "PYARE LAL",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "138",
              "00200090510040",
              "SUNITA RANI",
              "PYARE LAL",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "00200090510041",
            "name": "URMILA GODARA",
            "fatherName": "LICHHI RAM",
            "obtainedMarks": "1307",
            "maxMarks": "1600",
            "percentage": "81.69%",
            "cells": [
              "139",
              "00200090510041",
              "URMILA GODARA",
              "LICHHI RAM",
              "1307",
              "1600",
              "81.69%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2022-23",
    "courses": [
      {
        "courseName": "B.A. I year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "22009115430001",
            "name": "Rachna",
            "fatherName": "Om Parkash",
            "obtainedMarks": "746",
            "maxMarks": "975",
            "percentage": "76.51%",
            "cells": [
              "1",
              "22009115430001",
              "Rachna",
              "Om Parkash",
              "746",
              "975",
              "76.51%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "22009115430004",
            "name": "Dharampreet Kaur",
            "fatherName": "Bhola Singh",
            "obtainedMarks": "769",
            "maxMarks": "975",
            "percentage": "78.87%",
            "cells": [
              "2",
              "22009115430004",
              "Dharampreet Kaur",
              "Bhola Singh",
              "769",
              "975",
              "78.87%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "22009115430012",
            "name": "Parmila",
            "fatherName": "Panna Lal",
            "obtainedMarks": "791",
            "maxMarks": "975",
            "percentage": "86.75%",
            "cells": [
              "3",
              "22009115430012",
              "Parmila",
              "Panna Lal",
              "791",
              "975",
              "86.75%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "22009115430013",
            "name": "Arzoo",
            "fatherName": "Krishnan Kumar",
            "obtainedMarks": "779",
            "maxMarks": "975",
            "percentage": "79.89%",
            "cells": [
              "4",
              "22009115430013",
              "Arzoo",
              "Krishnan Kumar",
              "779",
              "975",
              "79.89%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "22009115430014",
            "name": "Harshdeep",
            "fatherName": "Mejar Singh",
            "obtainedMarks": "710",
            "maxMarks": "975",
            "percentage": "72.82%",
            "cells": [
              "5",
              "22009115430014",
              "Harshdeep",
              "Mejar Singh",
              "710",
              "975",
              "72.82%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "22009115430019",
            "name": "Sakshi",
            "fatherName": "Rajnesh",
            "obtainedMarks": "691",
            "maxMarks": "975",
            "percentage": "70.87%",
            "cells": [
              "6",
              "22009115430019",
              "Sakshi",
              "Rajnesh",
              "691",
              "975",
              "70.87%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "22009115430021",
            "name": "Lakshmi",
            "fatherName": "Harbhajan",
            "obtainedMarks": "759",
            "maxMarks": "975",
            "percentage": "77.84%",
            "cells": [
              "7",
              "22009115430021",
              "Lakshmi",
              "Harbhajan",
              "759",
              "975",
              "77.84%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "22009115430022",
            "name": "Khushpreet kaur",
            "fatherName": "Gursewak Singh",
            "obtainedMarks": "792",
            "maxMarks": "975",
            "percentage": "81.23%",
            "cells": [
              "8",
              "22009115430022",
              "Khushpreet kaur",
              "Gursewak Singh",
              "792",
              "975",
              "81.23%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "22009115430028",
            "name": "Nishu Rani",
            "fatherName": "Surender Kumar",
            "obtainedMarks": "708",
            "maxMarks": "975",
            "percentage": "72.61%",
            "cells": [
              "9",
              "22009115430028",
              "Nishu Rani",
              "Surender Kumar",
              "708",
              "975",
              "72.61%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "22009115430032",
            "name": "Nikita",
            "fatherName": "Bhanu Partap",
            "obtainedMarks": "718",
            "maxMarks": "975",
            "percentage": "73.64%",
            "cells": [
              "10",
              "22009115430032",
              "Nikita",
              "Bhanu Partap",
              "718",
              "975",
              "73.64%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "22009115430039",
            "name": "Jyoti",
            "fatherName": "Balwant Singh",
            "obtainedMarks": "695",
            "maxMarks": "975",
            "percentage": "71.28%",
            "cells": [
              "11",
              "22009115430039",
              "Jyoti",
              "Balwant Singh",
              "695",
              "975",
              "71.28%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "22009115430042",
            "name": "Shreya Devi",
            "fatherName": "Rajnesh Kumar",
            "obtainedMarks": "790",
            "maxMarks": "975",
            "percentage": "81.02%",
            "cells": [
              "12",
              "22009115430042",
              "Shreya Devi",
              "Rajnesh Kumar",
              "790",
              "975",
              "81.02%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "22009115430044",
            "name": "Pooja",
            "fatherName": "Krishnan Kumar",
            "obtainedMarks": "729",
            "maxMarks": "975",
            "percentage": "74.76%",
            "cells": [
              "13",
              "22009115430044",
              "Pooja",
              "Krishnan Kumar",
              "729",
              "975",
              "74.76%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "22009115430049",
            "name": "Into",
            "fatherName": "Jagdish",
            "obtainedMarks": "748",
            "maxMarks": "975",
            "percentage": "76.71%",
            "cells": [
              "14",
              "22009115430049",
              "Into",
              "Jagdish",
              "748",
              "975",
              "76.71%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "22009115430050",
            "name": "Suman Devi",
            "fatherName": "Bhoop Singh",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.02%",
            "cells": [
              "15",
              "22009115430050",
              "Suman Devi",
              "Bhoop Singh",
              "712",
              "975",
              "73.02%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "22009115430053",
            "name": "Amandeep Kaur",
            "fatherName": "Jagsir Singh",
            "obtainedMarks": "736",
            "maxMarks": "975",
            "percentage": "75.48%",
            "cells": [
              "16",
              "22009115430053",
              "Amandeep Kaur",
              "Jagsir Singh",
              "736",
              "975",
              "75.48%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "22009115430064",
            "name": "Deepi",
            "fatherName": "Vijay Pal",
            "obtainedMarks": "741",
            "maxMarks": "975",
            "percentage": "76%",
            "cells": [
              "17",
              "22009115430064",
              "Deepi",
              "Vijay Pal",
              "741",
              "975",
              "76%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "22009115430065",
            "name": "Saloni",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "714",
            "maxMarks": "975",
            "percentage": "73.23%",
            "cells": [
              "18",
              "22009115430065",
              "Saloni",
              "Vinod Kumar",
              "714",
              "975",
              "73.23%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "22009115430066",
            "name": "Sonia",
            "fatherName": "Sanjay Kumar",
            "obtainedMarks": "709",
            "maxMarks": "975",
            "percentage": "72.71%",
            "cells": [
              "19",
              "22009115430066",
              "Sonia",
              "Sanjay Kumar",
              "709",
              "975",
              "72.71%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "22009115430071",
            "name": "Monika",
            "fatherName": "Mange Ram",
            "obtainedMarks": "742",
            "maxMarks": "975",
            "percentage": "76.10%",
            "cells": [
              "20",
              "22009115430071",
              "Monika",
              "Mange Ram",
              "742",
              "975",
              "76.10%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "22009115430085",
            "name": "Sneha",
            "fatherName": "Surender",
            "obtainedMarks": "702",
            "maxMarks": "975",
            "percentage": "72%",
            "cells": [
              "21",
              "22009115430085",
              "Sneha",
              "Surender",
              "702",
              "975",
              "72%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "22009115430101",
            "name": "Nisha",
            "fatherName": "Surender Singh",
            "obtainedMarks": "738",
            "maxMarks": "975",
            "percentage": "75.69%",
            "cells": [
              "22",
              "22009115430101",
              "Nisha",
              "Surender Singh",
              "738",
              "975",
              "75.69%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "22009115430107",
            "name": "Monika",
            "fatherName": "Luxmi Narayan",
            "obtainedMarks": "723",
            "maxMarks": "975",
            "percentage": "74.15%",
            "cells": [
              "23",
              "22009115430107",
              "Monika",
              "Luxmi Narayan",
              "723",
              "975",
              "74.15%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "22009115430115",
            "name": "Neha",
            "fatherName": "Subhash Singh",
            "obtainedMarks": "734",
            "maxMarks": "975",
            "percentage": "75.28%",
            "cells": [
              "24",
              "22009115430115",
              "Neha",
              "Subhash Singh",
              "734",
              "975",
              "75.28%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "22009115430118",
            "name": "Twinkle",
            "fatherName": "Kashmir Lal",
            "obtainedMarks": "689",
            "maxMarks": "975",
            "percentage": "70.66%",
            "cells": [
              "25",
              "22009115430118",
              "Twinkle",
              "Kashmir Lal",
              "689",
              "975",
              "70.66%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "22009115430119",
            "name": "Mehak",
            "fatherName": "Kashmir Lal",
            "obtainedMarks": "790",
            "maxMarks": "975",
            "percentage": "81.02%",
            "cells": [
              "26",
              "22009115430119",
              "Mehak",
              "Kashmir Lal",
              "790",
              "975",
              "81.02%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "22009115430123",
            "name": "Barbie Babbar",
            "fatherName": "Rakesh Babbar",
            "obtainedMarks": "818",
            "maxMarks": "975",
            "percentage": "83.89%",
            "cells": [
              "27",
              "22009115430123",
              "Barbie Babbar",
              "Rakesh Babbar",
              "818",
              "975",
              "83.89%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "22009115430145",
            "name": "Jyoti",
            "fatherName": "Dharam Pal",
            "obtainedMarks": "703",
            "maxMarks": "975",
            "percentage": "72.10%",
            "cells": [
              "28",
              "22009115430145",
              "Jyoti",
              "Dharam Pal",
              "703",
              "975",
              "72.10%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "22009115430153",
            "name": "Sakshi Insa",
            "fatherName": "Hariom Insa",
            "obtainedMarks": "710",
            "maxMarks": "975",
            "percentage": "72.82%",
            "cells": [
              "29",
              "22009115430153",
              "Sakshi Insa",
              "Hariom Insa",
              "710",
              "975",
              "72.82%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "22009115430155",
            "name": "Amandeep Kaur",
            "fatherName": "Pawan Kumar",
            "obtainedMarks": "692",
            "maxMarks": "975",
            "percentage": "70.97%",
            "cells": [
              "30",
              "22009115430155",
              "Amandeep Kaur",
              "Pawan Kumar",
              "692",
              "975",
              "70.97%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "22009115430161",
            "name": "Mehak Sharma",
            "fatherName": "Sukhmander Pal",
            "obtainedMarks": "822",
            "maxMarks": "975",
            "percentage": "84.30%",
            "cells": [
              "31",
              "22009115430161",
              "Mehak Sharma",
              "Sukhmander Pal",
              "822",
              "975",
              "84.30%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "22009115430163",
            "name": "Deepasha",
            "fatherName": "Naresh kumar",
            "obtainedMarks": "712",
            "maxMarks": "975",
            "percentage": "73.02%",
            "cells": [
              "32",
              "22009115430163",
              "Deepasha",
              "Naresh kumar",
              "712",
              "975",
              "73.02%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "22009115430164",
            "name": "Garima",
            "fatherName": "Naresh kumar",
            "obtainedMarks": "729",
            "maxMarks": "975",
            "percentage": "74.76%",
            "cells": [
              "33",
              "22009115430164",
              "Garima",
              "Naresh kumar",
              "729",
              "975",
              "74.76%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "22009115430168",
            "name": "Pooja",
            "fatherName": "Lal Chand",
            "obtainedMarks": "715",
            "maxMarks": "975",
            "percentage": "73.33%",
            "cells": [
              "34",
              "22009115430168",
              "Pooja",
              "Lal Chand",
              "715",
              "975",
              "73.33%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "22009115430172",
            "name": "Aarti",
            "fatherName": "Karnail Singh",
            "obtainedMarks": "687",
            "maxMarks": "975",
            "percentage": "70.46%",
            "cells": [
              "35",
              "22009115430172",
              "Aarti",
              "Karnail Singh",
              "687",
              "975",
              "70.46%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "22009115430191",
            "name": "Tamanna",
            "fatherName": "Surjeet Singh",
            "obtainedMarks": "734",
            "maxMarks": "975",
            "percentage": "75.28%",
            "cells": [
              "36",
              "22009115430191",
              "Tamanna",
              "Surjeet Singh",
              "734",
              "975",
              "75.28%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A. II year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "37",
            "rollNo": "21009115430001",
            "name": "Tamanna",
            "fatherName": "Ram Kumar",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "37",
              "21009115430001",
              "Tamanna",
              "Ram Kumar",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "21009115430013",
            "name": "Poonam",
            "fatherName": "Krishan",
            "obtainedMarks": "686",
            "maxMarks": "900",
            "percentage": "76.22%",
            "cells": [
              "38",
              "21009115430013",
              "Poonam",
              "Krishan",
              "686",
              "900",
              "76.22%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "21009115430015",
            "name": "Aarti",
            "fatherName": "Uggarsain",
            "obtainedMarks": "724",
            "maxMarks": "900",
            "percentage": "80.44%",
            "cells": [
              "39",
              "21009115430015",
              "Aarti",
              "Uggarsain",
              "724",
              "900",
              "80.44%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "21009115430024",
            "name": "Manju Kumari",
            "fatherName": "Rattan Singh",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.77%",
            "cells": [
              "40",
              "21009115430024",
              "Manju Kumari",
              "Rattan Singh",
              "646",
              "900",
              "71.77%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "21009115430025",
            "name": "Kiran",
            "fatherName": "Kani Ram",
            "obtainedMarks": "701",
            "maxMarks": "900",
            "percentage": "77.88%",
            "cells": [
              "41",
              "21009115430025",
              "Kiran",
              "Kani Ram",
              "701",
              "900",
              "77.88%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "21009115430030",
            "name": "Tanisha",
            "fatherName": "Ved Parkash",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.66%",
            "cells": [
              "42",
              "21009115430030",
              "Tanisha",
              "Ved Parkash",
              "636",
              "900",
              "70.66%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "21009115430035",
            "name": "Anchal",
            "fatherName": "Sher Singh",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "43",
              "21009115430035",
              "Anchal",
              "Sher Singh",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "21009115430042",
            "name": "Poonam",
            "fatherName": "Lal Chand",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "44",
              "21009115430042",
              "Poonam",
              "Lal Chand",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "21009115430043",
            "name": "Varsha Rani",
            "fatherName": "Vijay Kumar",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "45",
              "21009115430043",
              "Varsha Rani",
              "Vijay Kumar",
              "632",
              "900",
              "70.22%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "21009115430046",
            "name": "Urmila",
            "fatherName": "Bhagat Ram",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "46",
              "21009115430046",
              "Urmila",
              "Bhagat Ram",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "21009115430047",
            "name": "Neha",
            "fatherName": "Aatma Ram",
            "obtainedMarks": "653",
            "maxMarks": "900",
            "percentage": "72.55%",
            "cells": [
              "47",
              "21009115430047",
              "Neha",
              "Aatma Ram",
              "653",
              "900",
              "72.55%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "21009115430051",
            "name": "Neelam Rani",
            "fatherName": "Laxman Dass",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "48",
              "21009115430051",
              "Neelam Rani",
              "Laxman Dass",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "21009115430052",
            "name": "Neetu",
            "fatherName": "Ramchander",
            "obtainedMarks": "686",
            "maxMarks": "900",
            "percentage": "76.22%",
            "cells": [
              "49",
              "21009115430052",
              "Neetu",
              "Ramchander",
              "686",
              "900",
              "76.22%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "21009115430054",
            "name": "Kavita",
            "fatherName": "Rampal",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.77%",
            "cells": [
              "50",
              "21009115430054",
              "Kavita",
              "Rampal",
              "637",
              "900",
              "70.77%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "21009115430061",
            "name": "Archna",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "51",
              "21009115430061",
              "Archna",
              "Vinod Kumar",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "21009115430062",
            "name": "Karanpal Kaur",
            "fatherName": "Gurdev Singh",
            "obtainedMarks": "661",
            "maxMarks": "900",
            "percentage": "73.44%",
            "cells": [
              "52",
              "21009115430062",
              "Karanpal Kaur",
              "Gurdev Singh",
              "661",
              "900",
              "73.44%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "21009115430063",
            "name": "Preeti",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "703",
            "maxMarks": "900",
            "percentage": "78.11%",
            "cells": [
              "53",
              "21009115430063",
              "Preeti",
              "Ramesh Kumar",
              "703",
              "900",
              "78.11%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "21009115430064",
            "name": "Kalpna",
            "fatherName": "atish Kumar",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "54",
              "21009115430064",
              "Kalpna",
              "atish Kumar",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "21009115430076",
            "name": "Rajini",
            "fatherName": "Rattan Singh",
            "obtainedMarks": "757",
            "maxMarks": "900",
            "percentage": "84.11%",
            "cells": [
              "55",
              "21009115430076",
              "Rajini",
              "Rattan Singh",
              "757",
              "900",
              "84.11%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "21009115430077",
            "name": "Simran",
            "fatherName": "Dolat Ram",
            "obtainedMarks": "786",
            "maxMarks": "900",
            "percentage": "87.33%",
            "cells": [
              "56",
              "21009115430077",
              "Simran",
              "Dolat Ram",
              "786",
              "900",
              "87.33%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "21009115430078",
            "name": "Divya",
            "fatherName": "Sandeep Kumar",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.77%",
            "cells": [
              "57",
              "21009115430078",
              "Divya",
              "Sandeep Kumar",
              "655",
              "900",
              "72.77%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "21009115430081",
            "name": "Shalu",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.77%",
            "cells": [
              "58",
              "21009115430081",
              "Shalu",
              "Vinod Kumar",
              "700",
              "900",
              "77.77%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "21009115430082",
            "name": "Manjeet Kaur",
            "fatherName": "Pargat Singh",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "59",
              "21009115430082",
              "Manjeet Kaur",
              "Pargat Singh",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "21009115430093",
            "name": "Manisha",
            "fatherName": "Bhim Singh",
            "obtainedMarks": "704",
            "maxMarks": "900",
            "percentage": "78.22%",
            "cells": [
              "60",
              "21009115430093",
              "Manisha",
              "Bhim Singh",
              "704",
              "900",
              "78.22%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "21009115430094",
            "name": "Muskan",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "61",
              "21009115430094",
              "Muskan",
              "Ramesh Kumar",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "21009115430101",
            "name": "Arju",
            "fatherName": "Mahender",
            "obtainedMarks": "720",
            "maxMarks": "900",
            "percentage": "80%",
            "cells": [
              "62",
              "21009115430101",
              "Arju",
              "Mahender",
              "720",
              "900",
              "80%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "21009115430102",
            "name": "Pooja Devi",
            "fatherName": "Balvinder Singh",
            "obtainedMarks": "761",
            "maxMarks": "900",
            "percentage": "84.55%",
            "cells": [
              "63",
              "21009115430102",
              "Pooja Devi",
              "Balvinder Singh",
              "761",
              "900",
              "84.55%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "21009115430105",
            "name": "Priyanka",
            "fatherName": "Bhagwant",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.77%",
            "cells": [
              "64",
              "21009115430105",
              "Priyanka",
              "Bhagwant",
              "709",
              "900",
              "78.77%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "21009115430111",
            "name": "Rachna",
            "fatherName": "Madan Lal",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "65",
              "21009115430111",
              "Rachna",
              "Madan Lal",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "21009115430113",
            "name": "Jamna devi",
            "fatherName": "Subhash Chander",
            "obtainedMarks": "702",
            "maxMarks": "900",
            "percentage": "78%",
            "cells": [
              "66",
              "21009115430113",
              "Jamna devi",
              "Subhash Chander",
              "702",
              "900",
              "78%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "21009115430114",
            "name": "Bhawna",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "706",
            "maxMarks": "900",
            "percentage": "84.44%",
            "cells": [
              "67",
              "21009115430114",
              "Bhawna",
              "Krishan Kumar",
              "706",
              "900",
              "84.44%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "21009115430119",
            "name": "Monika",
            "fatherName": "Rajesh",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.77%",
            "cells": [
              "68",
              "21009115430119",
              "Monika",
              "Rajesh",
              "655",
              "900",
              "72.77%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "21009115430120",
            "name": "Sonu",
            "fatherName": "Mahavir",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.55%",
            "cells": [
              "69",
              "21009115430120",
              "Sonu",
              "Mahavir",
              "635",
              "900",
              "70.55%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "21009115430124",
            "name": "Pooja",
            "fatherName": "Bhagat Singh",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.28%",
            "cells": [
              "70",
              "21009115430124",
              "Pooja",
              "Bhagat Singh",
              "659",
              "900",
              "73.28%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "21009115430139",
            "name": "Poonam Rani",
            "fatherName": "Duli Chand",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.77%",
            "cells": [
              "71",
              "21009115430139",
              "Poonam Rani",
              "Duli Chand",
              "655",
              "900",
              "72.77%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "21009115430146",
            "name": "Pooja Rani",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "72",
              "21009115430146",
              "Pooja Rani",
              "Ramesh Kumar",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "21009115430160",
            "name": "Cheenu",
            "fatherName": "Shiv Kumar",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "73",
              "21009115430160",
              "Cheenu",
              "Shiv Kumar",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "21009115430163",
            "name": "Ravita",
            "fatherName": "Satyvir Singh",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "74",
              "21009115430163",
              "Ravita",
              "Satyvir Singh",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "21009115430167",
            "name": "Nikita",
            "fatherName": "Inderpal",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.66%",
            "cells": [
              "75",
              "21009115430167",
              "Nikita",
              "Inderpal",
              "636",
              "900",
              "70.66%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "21009115430171",
            "name": "Kashish Devi",
            "fatherName": "Vijay Kumar",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "76",
              "21009115430171",
              "Kashish Devi",
              "Vijay Kumar",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "21009115430181",
            "name": "Dayawanti",
            "fatherName": "Dayanand",
            "obtainedMarks": "746",
            "maxMarks": "900",
            "percentage": "82.88%",
            "cells": [
              "77",
              "21009115430181",
              "Dayawanti",
              "Dayanand",
              "746",
              "900",
              "82.88%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "21009115430184",
            "name": "Sujata",
            "fatherName": "Satpal",
            "obtainedMarks": "662",
            "maxMarks": "900",
            "percentage": "73.55%",
            "cells": [
              "78",
              "21009115430184",
              "Sujata",
              "Satpal",
              "662",
              "900",
              "73.55%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "21009115430186",
            "name": "Sania",
            "fatherName": "Raj Kumar",
            "obtainedMarks": "731",
            "maxMarks": "900",
            "percentage": "81.22%",
            "cells": [
              "79",
              "21009115430186",
              "Sania",
              "Raj Kumar",
              "731",
              "900",
              "81.22%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "21009115430187",
            "name": "Ashandeep Kaur",
            "fatherName": "Joginder Kaur",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "80",
              "21009115430187",
              "Ashandeep Kaur",
              "Joginder Kaur",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "21009115430190",
            "name": "Arz Insan",
            "fatherName": "Amarjeet",
            "obtainedMarks": "748",
            "maxMarks": "900",
            "percentage": "83.11%",
            "cells": [
              "81",
              "21009115430190",
              "Arz Insan",
              "Amarjeet",
              "748",
              "900",
              "83.11%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "21009115430191",
            "name": "Alka Devi",
            "fatherName": "Rajesh Kumar",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "82",
              "21009115430191",
              "Alka Devi",
              "Rajesh Kumar",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "21009115430192",
            "name": "Ruchi",
            "fatherName": "Surender Singh",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "83",
              "21009115430192",
              "Ruchi",
              "Surender Singh",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "21009115430193",
            "name": "Lovepreet Kaur",
            "fatherName": "Jasvir Singh",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "84",
              "21009115430193",
              "Lovepreet Kaur",
              "Jasvir Singh",
              "742",
              "900",
              "82.44%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "21009115430194",
            "name": "Arzoo",
            "fatherName": "Anil Kumar",
            "obtainedMarks": "733",
            "maxMarks": "900",
            "percentage": "81.44%",
            "cells": [
              "85",
              "21009115430194",
              "Arzoo",
              "Anil Kumar",
              "733",
              "900",
              "81.44%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "21009115430201",
            "name": "Asmi",
            "fatherName": "Parveen Kumar",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.22%",
            "cells": [
              "86",
              "21009115430201",
              "Asmi",
              "Parveen Kumar",
              "677",
              "900",
              "75.22%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "21009115430202",
            "name": "Nishu",
            "fatherName": "Subhash Chander",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.88%",
            "cells": [
              "87",
              "21009115430202",
              "Nishu",
              "Subhash Chander",
              "737",
              "900",
              "81.88%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "21009115430203",
            "name": "Savina",
            "fatherName": "Ramesh",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.77%",
            "cells": [
              "88",
              "21009115430203",
              "Savina",
              "Ramesh",
              "673",
              "900",
              "74.77%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "21009115430204",
            "name": "Kanishka",
            "fatherName": "Inderjeet",
            "obtainedMarks": "741",
            "maxMarks": "900",
            "percentage": "82.33%",
            "cells": [
              "89",
              "21009115430204",
              "Kanishka",
              "Inderjeet",
              "741",
              "900",
              "82.33%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "21009115430208",
            "name": "Monika Sharma",
            "fatherName": "Mukesh Kumar",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "90",
              "21009115430208",
              "Monika Sharma",
              "Mukesh Kumar",
              "742",
              "900",
              "82.44%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "21009115430211",
            "name": "Silvneet Sidhu",
            "fatherName": "Ranvir Rana",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "91",
              "21009115430211",
              "Silvneet Sidhu",
              "Ranvir Rana",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "21009115430213",
            "name": "Ankita",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.66%",
            "cells": [
              "92",
              "21009115430213",
              "Ankita",
              "Ramesh Kumar",
              "663",
              "900",
              "73.66%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "21009115430214",
            "name": "Harjot Kaur",
            "fatherName": "Gurjant Singh",
            "obtainedMarks": "681",
            "maxMarks": "900",
            "percentage": "75.66%",
            "cells": [
              "93",
              "21009115430214",
              "Harjot Kaur",
              "Gurjant Singh",
              "681",
              "900",
              "75.66%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "21009115430216",
            "name": "Komal Rani",
            "fatherName": "Satpal",
            "obtainedMarks": "692",
            "maxMarks": "900",
            "percentage": "76.88%",
            "cells": [
              "94",
              "21009115430216",
              "Komal Rani",
              "Satpal",
              "692",
              "900",
              "76.88%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "21009115430223",
            "name": "Rekha Puwar",
            "fatherName": "Malkeet Singh",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "95",
              "21009115430223",
              "Rekha Puwar",
              "Malkeet Singh",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "21009115430236",
            "name": "Harmanpreet Kaur",
            "fatherName": "Baljit Singh",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "70.15%",
            "cells": [
              "96",
              "21009115430236",
              "Harmanpreet Kaur",
              "Baljit Singh",
              "684",
              "900",
              "70.15%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "21009115430238",
            "name": "Varsha",
            "fatherName": "Veer Singh",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "97",
              "21009115430238",
              "Varsha",
              "Veer Singh",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "21009115430244",
            "name": "Ravinder Kaur",
            "fatherName": "Tarsem Raj",
            "obtainedMarks": "662",
            "maxMarks": "900",
            "percentage": "73.55%",
            "cells": [
              "98",
              "21009115430244",
              "Ravinder Kaur",
              "Tarsem Raj",
              "662",
              "900",
              "73.55%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "21009115430255",
            "name": "Pooja",
            "fatherName": "Joginder yadav",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "99",
              "21009115430255",
              "Pooja",
              "Joginder yadav",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "21009115430262",
            "name": "Pragati",
            "fatherName": "Surender Singh",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.88%",
            "cells": [
              "100",
              "21009115430262",
              "Pragati",
              "Surender Singh",
              "737",
              "900",
              "81.88%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "21009115430234",
            "name": "Tamanna",
            "fatherName": "Rajbir Singh",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "101",
              "21009115430234",
              "Tamanna",
              "Rajbir Singh",
              "684",
              "900",
              "76%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A. III year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "102",
            "rollNo": "200090430006",
            "name": "Ankita",
            "fatherName": "Driya Singh",
            "obtainedMarks": "698",
            "maxMarks": "900",
            "percentage": "77.50%",
            "cells": [
              "102",
              "200090430006",
              "Ankita",
              "Driya Singh",
              "698",
              "900",
              "77.50%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "200090430020",
            "name": "Chetna",
            "fatherName": "Shamsher Singh",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.70%",
            "cells": [
              "103",
              "200090430020",
              "Chetna",
              "Shamsher Singh",
              "673",
              "900",
              "74.70%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "200090430024",
            "name": "Ekta",
            "fatherName": "Palvinder",
            "obtainedMarks": "705",
            "maxMarks": "900",
            "percentage": "78.30%",
            "cells": [
              "104",
              "200090430024",
              "Ekta",
              "Palvinder",
              "705",
              "900",
              "78.30%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "200090430025",
            "name": "Esha Choudhary",
            "fatherName": "Deepak Kumar",
            "obtainedMarks": "707",
            "maxMarks": "900",
            "percentage": "78.50%",
            "cells": [
              "105",
              "200090430025",
              "Esha Choudhary",
              "Deepak Kumar",
              "707",
              "900",
              "78.50%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "200090430031",
            "name": "Himanshu",
            "fatherName": "Radhe Shyam",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.20%",
            "cells": [
              "106",
              "200090430031",
              "Himanshu",
              "Radhe Shyam",
              "677",
              "900",
              "75.20%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "200090430035",
            "name": "Jaya",
            "fatherName": "Jagatpal",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.60%",
            "cells": [
              "107",
              "200090430035",
              "Jaya",
              "Jagatpal",
              "663",
              "900",
              "73.60%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "200090430036",
            "name": "Jigyasha",
            "fatherName": "Rajneesh Kumar",
            "obtainedMarks": "716",
            "maxMarks": "900",
            "percentage": "79.50%",
            "cells": [
              "108",
              "200090430036",
              "Jigyasha",
              "Rajneesh Kumar",
              "716",
              "900",
              "79.50%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "200090430037",
            "name": "Jyoti",
            "fatherName": "Fateh Singh",
            "obtainedMarks": "675",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "109",
              "200090430037",
              "Jyoti",
              "Fateh Singh",
              "675",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "200090430038",
            "name": "Jyoti",
            "fatherName": "Prahlad",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "110",
              "200090430038",
              "Jyoti",
              "Prahlad",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "200090430040",
            "name": "Kalpana Rani",
            "fatherName": "Rajpal",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.60%",
            "cells": [
              "111",
              "200090430040",
              "Kalpana Rani",
              "Rajpal",
              "663",
              "900",
              "73.60%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "200090430042",
            "name": "Kashish",
            "fatherName": "Bhajan Lal",
            "obtainedMarks": "697",
            "maxMarks": "900",
            "percentage": "77.40%",
            "cells": [
              "112",
              "200090430042",
              "Kashish",
              "Bhajan Lal",
              "697",
              "900",
              "77.40%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "200090430045",
            "name": "Kavita",
            "fatherName": "Naurang",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.70%",
            "cells": [
              "113",
              "200090430045",
              "Kavita",
              "Naurang",
              "673",
              "900",
              "74.70%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "200090430049",
            "name": "Khushman Kaur",
            "fatherName": "Parampal Singh",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.30%",
            "cells": [
              "114",
              "200090430049",
              "Khushman Kaur",
              "Parampal Singh",
              "642",
              "900",
              "71.30%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "200090430065",
            "name": "Manisha Kamboj",
            "fatherName": "Satnam Chand",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "115",
              "200090430065",
              "Manisha Kamboj",
              "Satnam Chand",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "200090430066",
            "name": "Manju Bala",
            "fatherName": "Banshi Lal",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.60%",
            "cells": [
              "116",
              "200090430066",
              "Manju Bala",
              "Banshi Lal",
              "645",
              "900",
              "71.60%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "200090430067",
            "name": "Manju Bala",
            "fatherName": "Vijay Singh",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.80%",
            "cells": [
              "117",
              "200090430067",
              "Manju Bala",
              "Vijay Singh",
              "638",
              "900",
              "70.80%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "200090430071",
            "name": "Minal",
            "fatherName": "Ved Parkash",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.50%",
            "cells": [
              "118",
              "200090430071",
              "Minal",
              "Ved Parkash",
              "680",
              "900",
              "75.50%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "200090430074",
            "name": "Monika",
            "fatherName": "Prabhu Ram",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.20%",
            "cells": [
              "119",
              "200090430074",
              "Monika",
              "Prabhu Ram",
              "632",
              "900",
              "70.20%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "200090430075",
            "name": "Monika",
            "fatherName": "Surender",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.40%",
            "cells": [
              "120",
              "200090430075",
              "Monika",
              "Surender",
              "670",
              "900",
              "74.40%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "200090430084",
            "name": "Neha",
            "fatherName": "Pawan Kumar",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.10%",
            "cells": [
              "121",
              "200090430084",
              "Neha",
              "Pawan Kumar",
              "667",
              "900",
              "74.10%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "200090430087",
            "name": "Nisha",
            "fatherName": "Rajender",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.70%",
            "cells": [
              "122",
              "200090430087",
              "Nisha",
              "Rajender",
              "655",
              "900",
              "72.70%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "200090430093",
            "name": "Pooja",
            "fatherName": "Sushil",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.30%",
            "cells": [
              "123",
              "200090430093",
              "Pooja",
              "Sushil",
              "687",
              "900",
              "76.30%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "200090430096",
            "name": "Poonam Rani",
            "fatherName": "Charan Dass",
            "obtainedMarks": "696",
            "maxMarks": "900",
            "percentage": "77.33%",
            "cells": [
              "124",
              "200090430096",
              "Poonam Rani",
              "Charan Dass",
              "696",
              "900",
              "77.33%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "200090430104",
            "name": "Priyanka",
            "fatherName": "Devilal",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.60%",
            "cells": [
              "125",
              "200090430104",
              "Priyanka",
              "Devilal",
              "672",
              "900",
              "74.60%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "200090430115",
            "name": "Rekha",
            "fatherName": "Mohan Lal",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "126",
              "200090430115",
              "Rekha",
              "Mohan Lal",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "200090430124",
            "name": "Ritu",
            "fatherName": "Sushil Kumar",
            "obtainedMarks": "721",
            "maxMarks": "900",
            "percentage": "80.11%",
            "cells": [
              "127",
              "200090430124",
              "Ritu",
              "Sushil Kumar",
              "721",
              "900",
              "80.11%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "200090430125",
            "name": "Ritu Bala",
            "fatherName": "Vedpal",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "128",
              "200090430125",
              "Ritu Bala",
              "Vedpal",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "200090430127",
            "name": "Samesta Devi",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "129",
              "200090430127",
              "Samesta Devi",
              "Vinod Kumar",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "200090430128",
            "name": "Sandeep Kaur",
            "fatherName": "Gurmail Singh",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.66%",
            "cells": [
              "130",
              "200090430128",
              "Sandeep Kaur",
              "Gurmail Singh",
              "636",
              "900",
              "70.66%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "200090430131",
            "name": "Sanju",
            "fatherName": "Satveer Singh",
            "obtainedMarks": "675",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "131",
              "200090430131",
              "Sanju",
              "Satveer Singh",
              "675",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "200090430135",
            "name": "Saroj",
            "fatherName": "Dalip",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.88%",
            "cells": [
              "132",
              "200090430135",
              "Saroj",
              "Dalip",
              "647",
              "900",
              "71.88%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "200090430136",
            "name": "Saravmishtha",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "680",
            "maxMarks": "900",
            "percentage": "75.55%",
            "cells": [
              "133",
              "200090430136",
              "Saravmishtha",
              "Krishan Kumar",
              "680",
              "900",
              "75.55%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "200090430139",
            "name": "Shabnam",
            "fatherName": "Prem Kumar",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "134",
              "200090430139",
              "Shabnam",
              "Prem Kumar",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "200090430146",
            "name": "Simran",
            "fatherName": "Suresh",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "135",
              "200090430146",
              "Simran",
              "Suresh",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "200090430152",
            "name": "Sonu",
            "fatherName": "Rajender",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.36%",
            "cells": [
              "136",
              "200090430152",
              "Sonu",
              "Rajender",
              "663",
              "900",
              "73.36%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "200090430161",
            "name": "Tamanna",
            "fatherName": "Baljit Singh",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.66%",
            "cells": [
              "137",
              "200090430161",
              "Tamanna",
              "Baljit Singh",
              "672",
              "900",
              "74.66%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Gen.I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "138",
            "rollNo": "22009115450014",
            "name": "Tejinder Kaur",
            "fatherName": "Chamkour Singh",
            "obtainedMarks": "851",
            "maxMarks": "1150",
            "percentage": "74%",
            "cells": [
              "138",
              "22009115450014",
              "Tejinder Kaur",
              "Chamkour Singh",
              "851",
              "1150",
              "74%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "22009115450020",
            "name": "Simranjot Kaur",
            "fatherName": "Ranveer Singh",
            "obtainedMarks": "859",
            "maxMarks": "1150",
            "percentage": "74.69%",
            "cells": [
              "139",
              "22009115450020",
              "Simranjot Kaur",
              "Ranveer Singh",
              "859",
              "1150",
              "74.69%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "22009115450021",
            "name": "Baljot Kaur",
            "fatherName": "Ranveer Singh",
            "obtainedMarks": "860",
            "maxMarks": "1150",
            "percentage": "74.78%",
            "cells": [
              "140",
              "22009115450021",
              "Baljot Kaur",
              "Ranveer Singh",
              "860",
              "1150",
              "74.78%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Gen.II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "141",
            "rollNo": "21009115450004",
            "name": "Ritu",
            "fatherName": "Dungarmal",
            "obtainedMarks": "875",
            "maxMarks": "1250",
            "percentage": "70%",
            "cells": [
              "141",
              "21009115450004",
              "Ritu",
              "Dungarmal",
              "875",
              "1250",
              "70%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "21009115450005",
            "name": "Suman",
            "fatherName": "Mahender Pal",
            "obtainedMarks": "985",
            "maxMarks": "1250",
            "percentage": "78.80%",
            "cells": [
              "142",
              "21009115450005",
              "Suman",
              "Mahender Pal",
              "985",
              "1250",
              "78.80%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "2100911545006",
            "name": "Kanisha",
            "fatherName": "Bhim Sen",
            "obtainedMarks": "982",
            "maxMarks": "1250",
            "percentage": "78.56%",
            "cells": [
              "143",
              "2100911545006",
              "Kanisha",
              "Bhim Sen",
              "982",
              "1250",
              "78.56%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "21009115450012",
            "name": "Surya",
            "fatherName": "Subhash Chander",
            "obtainedMarks": "975",
            "maxMarks": "1250",
            "percentage": "78%",
            "cells": [
              "144",
              "21009115450012",
              "Surya",
              "Subhash Chander",
              "975",
              "1250",
              "78%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "21009115450017",
            "name": "Lovepreet Kaur",
            "fatherName": "Avatar Singh",
            "obtainedMarks": "896",
            "maxMarks": "1250",
            "percentage": "71.68%",
            "cells": [
              "145",
              "21009115450017",
              "Lovepreet Kaur",
              "Avatar Singh",
              "896",
              "1250",
              "71.68%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "21009115450020",
            "name": "Aashu",
            "fatherName": "Karan Singh",
            "obtainedMarks": "815",
            "maxMarks": "1250",
            "percentage": "70.86%",
            "cells": [
              "146",
              "21009115450020",
              "Aashu",
              "Karan Singh",
              "815",
              "1250",
              "70.86%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Gen.III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "147",
            "rollNo": "200090450022",
            "name": "Saniya",
            "fatherName": "Satish Kumar",
            "obtainedMarks": "894",
            "maxMarks": "1200",
            "percentage": "74.50%",
            "cells": [
              "147",
              "200090450022",
              "Saniya",
              "Satish Kumar",
              "894",
              "1200",
              "74.50%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "200090450028",
            "name": "Sonam Kumari",
            "fatherName": "Sudesh Kumar",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.91%",
            "cells": [
              "148",
              "200090450028",
              "Sonam Kumari",
              "Sudesh Kumar",
              "863",
              "1200",
              "71.91%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Voc.I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "149",
            "rollNo": "22009115460003",
            "name": "Himanshi",
            "fatherName": "Vijay Kumar",
            "obtainedMarks": "987",
            "maxMarks": "1150",
            "percentage": "85.82%",
            "cells": [
              "149",
              "22009115460003",
              "Himanshi",
              "Vijay Kumar",
              "987",
              "1150",
              "85.82%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "22009115460010",
            "name": "Kanchan Bala",
            "fatherName": "Kishor Kumar Sharma",
            "obtainedMarks": "823",
            "maxMarks": "1150",
            "percentage": "71.56%",
            "cells": [
              "150",
              "22009115460010",
              "Kanchan Bala",
              "Kishor Kumar Sharma",
              "823",
              "1150",
              "71.56%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "22009115460013",
            "name": "Rebha Rani",
            "fatherName": "Gopi Ram",
            "obtainedMarks": "828",
            "maxMarks": "1150",
            "percentage": "72%",
            "cells": [
              "151",
              "22009115460013",
              "Rebha Rani",
              "Gopi Ram",
              "828",
              "1150",
              "72%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "22009115460014",
            "name": "Rebha",
            "fatherName": "Rohtash",
            "obtainedMarks": "833",
            "maxMarks": "1150",
            "percentage": "73.64%",
            "cells": [
              "152",
              "22009115460014",
              "Rebha",
              "Rohtash",
              "833",
              "1150",
              "73.64%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "22009115460015",
            "name": "Shafali Garg",
            "fatherName": "Sunil Kumar",
            "obtainedMarks": "870",
            "maxMarks": "1150",
            "percentage": "75.65%",
            "cells": [
              "153",
              "22009115460015",
              "Shafali Garg",
              "Sunil Kumar",
              "870",
              "1150",
              "75.65%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Voc.II Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.Com. Voc.III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "154",
            "rollNo": "200090460004",
            "name": "Jasleen Kaur",
            "fatherName": "Rajveer Singh",
            "obtainedMarks": "895",
            "maxMarks": "1250",
            "percentage": "71.60%",
            "cells": [
              "154",
              "200090460004",
              "Jasleen Kaur",
              "Rajveer Singh",
              "895",
              "1250",
              "71.60%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "200090460006",
            "name": "Lalisha",
            "fatherName": "Anil",
            "obtainedMarks": "955",
            "maxMarks": "1250",
            "percentage": "76.40%",
            "cells": [
              "155",
              "200090460006",
              "Lalisha",
              "Anil",
              "955",
              "1250",
              "76.40%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "200090460017",
            "name": "Sukhjeet",
            "fatherName": "Gurnaam Singh",
            "obtainedMarks": "887",
            "maxMarks": "1250",
            "percentage": "70.96%",
            "cells": [
              "156",
              "200090460017",
              "Sukhjeet",
              "Gurnaam Singh",
              "887",
              "1250",
              "70.96%"
            ]
          }
        ]
      },
      {
        "courseName": "B.B.A. I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "157",
            "rollNo": "22009115480022",
            "name": "Mehak Taneja",
            "fatherName": "Sant Lal",
            "obtainedMarks": "947",
            "maxMarks": "1350",
            "percentage": "70.14%",
            "cells": [
              "157",
              "22009115480022",
              "Mehak Taneja",
              "Sant Lal",
              "947",
              "1350",
              "70.14%"
            ]
          }
        ]
      },
      {
        "courseName": "B.B.A. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "158",
            "rollNo": "21009115480007",
            "name": "Bansal",
            "fatherName": "Balwan Singh",
            "obtainedMarks": "945",
            "maxMarks": "1350",
            "percentage": "70%",
            "cells": [
              "158",
              "21009115480007",
              "Bansal",
              "Balwan Singh",
              "945",
              "1350",
              "70%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "21009115480009",
            "name": "Vaishali",
            "fatherName": "Jai Parkash",
            "obtainedMarks": "1011",
            "maxMarks": "1350",
            "percentage": "74.88%",
            "cells": [
              "159",
              "21009115480009",
              "Vaishali",
              "Jai Parkash",
              "1011",
              "1350",
              "74.88%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "21009115480022",
            "name": "Sonia",
            "fatherName": "Dharam Raj",
            "obtainedMarks": "1022",
            "maxMarks": "1350",
            "percentage": "75.70%",
            "cells": [
              "160",
              "21009115480022",
              "Sonia",
              "Dharam Raj",
              "1022",
              "1350",
              "75.70%"
            ]
          }
        ]
      },
      {
        "courseName": "B.B.A. III Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "B.C.A. I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "161",
            "rollNo": "22009115470007",
            "name": "Tanu",
            "fatherName": "Ramesh Chand",
            "obtainedMarks": "1045",
            "maxMarks": "1300",
            "percentage": "80.38%",
            "cells": [
              "161",
              "22009115470007",
              "Tanu",
              "Ramesh Chand",
              "1045",
              "1300",
              "80.38%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "22009115470011",
            "name": "Avni",
            "fatherName": "Vinod Kumar",
            "obtainedMarks": "939",
            "maxMarks": "1300",
            "percentage": "72.23%",
            "cells": [
              "162",
              "22009115470011",
              "Avni",
              "Vinod Kumar",
              "939",
              "1300",
              "72.23%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "22009115470018",
            "name": "Upasna",
            "fatherName": "Rajender",
            "obtainedMarks": "941",
            "maxMarks": "1300",
            "percentage": "72.38%",
            "cells": [
              "163",
              "22009115470018",
              "Upasna",
              "Rajender",
              "941",
              "1300",
              "72.38%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "22009115470020",
            "name": "Kirti",
            "fatherName": "Prithvi Raj",
            "obtainedMarks": "526",
            "maxMarks": "1300",
            "percentage": "74%",
            "cells": [
              "164",
              "22009115470020",
              "Kirti",
              "Prithvi Raj",
              "526",
              "1300",
              "74%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "22009115470023",
            "name": "Vartika",
            "fatherName": "Vijay Singh",
            "obtainedMarks": "977",
            "maxMarks": "1300",
            "percentage": "75.15%",
            "cells": [
              "165",
              "22009115470023",
              "Vartika",
              "Vijay Singh",
              "977",
              "1300",
              "75.15%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "22009115470028",
            "name": "Mehak Garag",
            "fatherName": "Sanjay Kumar",
            "obtainedMarks": "1012",
            "maxMarks": "1300",
            "percentage": "77.84%",
            "cells": [
              "166",
              "22009115470028",
              "Mehak Garag",
              "Sanjay Kumar",
              "1012",
              "1300",
              "77.84%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "22009115470035",
            "name": "Kushmeet Kaur",
            "fatherName": "Jaspal Singh",
            "obtainedMarks": "932",
            "maxMarks": "1300",
            "percentage": "71.69%",
            "cells": [
              "167",
              "22009115470035",
              "Kushmeet Kaur",
              "Jaspal Singh",
              "932",
              "1300",
              "71.69%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "22009115470036",
            "name": "Aanchal Lakshotia",
            "fatherName": "Madan Lal",
            "obtainedMarks": "963",
            "maxMarks": "1300",
            "percentage": "74.07%",
            "cells": [
              "168",
              "22009115470036",
              "Aanchal Lakshotia",
              "Madan Lal",
              "963",
              "1300",
              "74.07%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "22009115470038",
            "name": "Sakshi",
            "fatherName": "Vinod Sharma",
            "obtainedMarks": "929",
            "maxMarks": "1300",
            "percentage": "71.46%",
            "cells": [
              "169",
              "22009115470038",
              "Sakshi",
              "Vinod Sharma",
              "929",
              "1300",
              "71.46%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "22009115470039",
            "name": "Komal",
            "fatherName": "Sanjay Kumar",
            "obtainedMarks": "917",
            "maxMarks": "1300",
            "percentage": "70.53%",
            "cells": [
              "170",
              "22009115470039",
              "Komal",
              "Sanjay Kumar",
              "917",
              "1300",
              "70.53%"
            ]
          }
        ]
      },
      {
        "courseName": "B.C.A. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "171",
            "rollNo": "21009115470001",
            "name": "Sayra Rani",
            "fatherName": "Jyoti Parkash",
            "obtainedMarks": "998",
            "maxMarks": "1300",
            "percentage": "76.76%",
            "cells": [
              "171",
              "21009115470001",
              "Sayra Rani",
              "Jyoti Parkash",
              "998",
              "1300",
              "76.76%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "21009115470002",
            "name": "Pooja Rani",
            "fatherName": "Bhawandeen",
            "obtainedMarks": "1138",
            "maxMarks": "1300",
            "percentage": "87.53%",
            "cells": [
              "172",
              "21009115470002",
              "Pooja Rani",
              "Bhawandeen",
              "1138",
              "1300",
              "87.53%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "21009115470003",
            "name": "Komal Rani",
            "fatherName": "Shivcharan",
            "obtainedMarks": "1128",
            "maxMarks": "1300",
            "percentage": "86.76%",
            "cells": [
              "173",
              "21009115470003",
              "Komal Rani",
              "Shivcharan",
              "1128",
              "1300",
              "86.76%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "21009115470007",
            "name": "Kiranpal kaur",
            "fatherName": "Jagsir Singh",
            "obtainedMarks": "957",
            "maxMarks": "1300",
            "percentage": "73.61%",
            "cells": [
              "174",
              "21009115470007",
              "Kiranpal kaur",
              "Jagsir Singh",
              "957",
              "1300",
              "73.61%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "21009115470009",
            "name": "Harleen Kaur",
            "fatherName": "Sukhwinder Singh",
            "obtainedMarks": "959",
            "maxMarks": "1300",
            "percentage": "73.76%",
            "cells": [
              "175",
              "21009115470009",
              "Harleen Kaur",
              "Sukhwinder Singh",
              "959",
              "1300",
              "73.76%"
            ]
          },
          {
            "sNo": "176",
            "rollNo": "21009115470010",
            "name": "Kavita",
            "fatherName": "Ramesh Kumar",
            "obtainedMarks": "1090",
            "maxMarks": "1300",
            "percentage": "83.84%",
            "cells": [
              "176",
              "21009115470010",
              "Kavita",
              "Ramesh Kumar",
              "1090",
              "1300",
              "83.84%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "21009115470015",
            "name": "Poonam",
            "fatherName": "Rajesh",
            "obtainedMarks": "1060",
            "maxMarks": "1300",
            "percentage": "81.53%",
            "cells": [
              "177",
              "21009115470015",
              "Poonam",
              "Rajesh",
              "1060",
              "1300",
              "81.53%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "21009115470028",
            "name": "Simran",
            "fatherName": "Harjeet Singh",
            "obtainedMarks": "1023",
            "maxMarks": "1300",
            "percentage": "78.69%",
            "cells": [
              "178",
              "21009115470028",
              "Simran",
              "Harjeet Singh",
              "1023",
              "1300",
              "78.69%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "21009115470030",
            "name": "Loveleen Kaur",
            "fatherName": "Jagraj Singh",
            "obtainedMarks": "917",
            "maxMarks": "1300",
            "percentage": "70.53%",
            "cells": [
              "179",
              "21009115470030",
              "Loveleen Kaur",
              "Jagraj Singh",
              "917",
              "1300",
              "70.53%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "21009115470033",
            "name": "Simran Kashyap",
            "fatherName": "Kaka Ram",
            "obtainedMarks": "971",
            "maxMarks": "1300",
            "percentage": "74.69%",
            "cells": [
              "180",
              "21009115470033",
              "Simran Kashyap",
              "Kaka Ram",
              "971",
              "1300",
              "74.69%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "21009115470034",
            "name": "Rinki Devi",
            "fatherName": "Balvir Singh",
            "obtainedMarks": "936",
            "maxMarks": "1300",
            "percentage": "72%",
            "cells": [
              "181",
              "21009115470034",
              "Rinki Devi",
              "Balvir Singh",
              "936",
              "1300",
              "72%"
            ]
          }
        ]
      },
      {
        "courseName": "B.C.A. III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "182",
            "rollNo": "200090470012",
            "name": "Mamta",
            "fatherName": "Subhash",
            "obtainedMarks": "1202",
            "maxMarks": "1700",
            "percentage": "70.70%",
            "cells": [
              "182",
              "200090470012",
              "Mamta",
              "Subhash",
              "1202",
              "1700",
              "70.70%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "200090470019",
            "name": "Pooja",
            "fatherName": "Pawan Kumar",
            "obtainedMarks": "1296",
            "maxMarks": "1700",
            "percentage": "76.23%",
            "cells": [
              "183",
              "200090470019",
              "Pooja",
              "Pawan Kumar",
              "1296",
              "1700",
              "76.23%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "200090470022",
            "name": "Rajju",
            "fatherName": "Jai Karishan",
            "obtainedMarks": "1250",
            "maxMarks": "1700",
            "percentage": "73.52%",
            "cells": [
              "184",
              "200090470022",
              "Rajju",
              "Jai Karishan",
              "1250",
              "1700",
              "73.52%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A.J.M.C. I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "185",
            "rollNo": "22009115420002",
            "name": "Raman Kaur",
            "fatherName": "Harjit Singh",
            "obtainedMarks": "683",
            "maxMarks": "925",
            "percentage": "73.83%",
            "cells": [
              "185",
              "22009115420002",
              "Raman Kaur",
              "Harjit Singh",
              "683",
              "925",
              "73.83%"
            ]
          },
          {
            "sNo": "186",
            "rollNo": "22009115420003",
            "name": "Renu",
            "fatherName": "Rajender Singh",
            "obtainedMarks": "667",
            "maxMarks": "925",
            "percentage": "72.10%",
            "cells": [
              "186",
              "22009115420003",
              "Renu",
              "Rajender Singh",
              "667",
              "925",
              "72.10%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "22009115420007",
            "name": "Manita",
            "fatherName": "Vijay Singh",
            "obtainedMarks": "661",
            "maxMarks": "925",
            "percentage": "71.45%",
            "cells": [
              "187",
              "22009115420007",
              "Manita",
              "Vijay Singh",
              "661",
              "925",
              "71.45%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "22009115420008",
            "name": "Jyoti",
            "fatherName": "Jagdeep",
            "obtainedMarks": "649",
            "maxMarks": "925",
            "percentage": "70.16%",
            "cells": [
              "188",
              "22009115420008",
              "Jyoti",
              "Jagdeep",
              "649",
              "925",
              "70.16%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "220091154200011",
            "name": "Alka",
            "fatherName": "Jai Prakash",
            "obtainedMarks": "705",
            "maxMarks": "925",
            "percentage": "76.21%",
            "cells": [
              "189",
              "220091154200011",
              "Alka",
              "Jai Prakash",
              "705",
              "925",
              "76.21%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "22009115420013",
            "name": "Yanshu Rani",
            "fatherName": "Devener",
            "obtainedMarks": "675",
            "maxMarks": "925",
            "percentage": "72.97%",
            "cells": [
              "190",
              "22009115420013",
              "Yanshu Rani",
              "Devener",
              "675",
              "925",
              "72.97%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "22009115420014",
            "name": "Reena Rani",
            "fatherName": "Shallender Kumar",
            "obtainedMarks": "682",
            "maxMarks": "925",
            "percentage": "73.72%",
            "cells": [
              "191",
              "22009115420014",
              "Reena Rani",
              "Shallender Kumar",
              "682",
              "925",
              "73.72%"
            ]
          },
          {
            "sNo": "192",
            "rollNo": "22009115420017",
            "name": "Suman",
            "fatherName": "Jetha Ram",
            "obtainedMarks": "703",
            "maxMarks": "925",
            "percentage": "76%",
            "cells": [
              "192",
              "22009115420017",
              "Suman",
              "Jetha Ram",
              "703",
              "925",
              "76%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "22009115420018",
            "name": "Anshika",
            "fatherName": "Punish kumar",
            "obtainedMarks": "727",
            "maxMarks": "925",
            "percentage": "78.59%",
            "cells": [
              "193",
              "22009115420018",
              "Anshika",
              "Punish kumar",
              "727",
              "925",
              "78.59%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "22009115420019",
            "name": "Mehak",
            "fatherName": "Suresh Kumar",
            "obtainedMarks": "655",
            "maxMarks": "925",
            "percentage": "70.81%",
            "cells": [
              "194",
              "22009115420019",
              "Mehak",
              "Suresh Kumar",
              "655",
              "925",
              "70.81%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "22009115420021",
            "name": "Ramanpreet Kaur",
            "fatherName": "Ranjit Singh",
            "obtainedMarks": "693",
            "maxMarks": "925",
            "percentage": "74.91%",
            "cells": [
              "195",
              "22009115420021",
              "Ramanpreet Kaur",
              "Ranjit Singh",
              "693",
              "925",
              "74.91%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "22009115420022",
            "name": "Kusum",
            "fatherName": "Gautam Soni",
            "obtainedMarks": "662",
            "maxMarks": "925",
            "percentage": "71.56%",
            "cells": [
              "196",
              "22009115420022",
              "Kusum",
              "Gautam Soni",
              "662",
              "925",
              "71.56%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "22009115420024",
            "name": "Richa",
            "fatherName": "Ved Parkash",
            "obtainedMarks": "652",
            "maxMarks": "925",
            "percentage": "70.48%",
            "cells": [
              "197",
              "22009115420024",
              "Richa",
              "Ved Parkash",
              "652",
              "925",
              "70.48%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A.J.M.C. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "198",
            "rollNo": "21009115420002",
            "name": "Varsha",
            "fatherName": "Maan Singh",
            "obtainedMarks": "819",
            "maxMarks": "1150",
            "percentage": "71.21%",
            "cells": [
              "198",
              "21009115420002",
              "Varsha",
              "Maan Singh",
              "819",
              "1150",
              "71.21%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "21009115420003",
            "name": "Tanu Bala",
            "fatherName": "Luxmi Narayan",
            "obtainedMarks": "833",
            "maxMarks": "1150",
            "percentage": "72.43%",
            "cells": [
              "199",
              "21009115420003",
              "Tanu Bala",
              "Luxmi Narayan",
              "833",
              "1150",
              "72.43%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "21009115420014",
            "name": "Suman Devi",
            "fatherName": "Raghubir Singh",
            "obtainedMarks": "822",
            "maxMarks": "1150",
            "percentage": "71.47%",
            "cells": [
              "200",
              "21009115420014",
              "Suman Devi",
              "Raghubir Singh",
              "822",
              "1150",
              "71.47%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "21009115420019",
            "name": "Ravneet Kaur",
            "fatherName": "Shyam Lal",
            "obtainedMarks": "893",
            "maxMarks": "1150",
            "percentage": "77.65%",
            "cells": [
              "201",
              "21009115420019",
              "Ravneet Kaur",
              "Shyam Lal",
              "893",
              "1150",
              "77.65%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "21009115420022",
            "name": "Pooja Rani",
            "fatherName": "Ranjeet Singh",
            "obtainedMarks": "807",
            "maxMarks": "1150",
            "percentage": "70.17%",
            "cells": [
              "202",
              "21009115420022",
              "Pooja Rani",
              "Ranjeet Singh",
              "807",
              "1150",
              "70.17%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "21009115420023",
            "name": "Kanchan",
            "fatherName": "Nihal Singh",
            "obtainedMarks": "858",
            "maxMarks": "1150",
            "percentage": "74.60%",
            "cells": [
              "203",
              "21009115420023",
              "Kanchan",
              "Nihal Singh",
              "858",
              "1150",
              "74.60%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "21009115420024",
            "name": "Nisha",
            "fatherName": "Ram Niwas",
            "obtainedMarks": "877",
            "maxMarks": "1150",
            "percentage": "76%",
            "cells": [
              "204",
              "21009115420024",
              "Nisha",
              "Ram Niwas",
              "877",
              "1150",
              "76%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "21009115420025",
            "name": "Kavita",
            "fatherName": "Jaibir",
            "obtainedMarks": "821",
            "maxMarks": "1150",
            "percentage": "71.39%",
            "cells": [
              "205",
              "21009115420025",
              "Kavita",
              "Jaibir",
              "821",
              "1150",
              "71.39%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "21009115420027",
            "name": "Manisha",
            "fatherName": "Rai Singh",
            "obtainedMarks": "806",
            "maxMarks": "1150",
            "percentage": "70.08%",
            "cells": [
              "206",
              "21009115420027",
              "Manisha",
              "Rai Singh",
              "806",
              "1150",
              "70.08%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "21009115420031",
            "name": "Gaytri",
            "fatherName": "Rohtash",
            "obtainedMarks": "844",
            "maxMarks": "1150",
            "percentage": "73.39%",
            "cells": [
              "207",
              "21009115420031",
              "Gaytri",
              "Rohtash",
              "844",
              "1150",
              "73.39%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "21009115420015",
            "name": "Mukesh",
            "fatherName": "Jai Pal",
            "obtainedMarks": "816",
            "maxMarks": "1150",
            "percentage": "70.95%",
            "cells": [
              "208",
              "21009115420015",
              "Mukesh",
              "Jai Pal",
              "816",
              "1150",
              "70.95%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A.J.M.C. III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "209",
            "rollNo": "200090420001",
            "name": "Bhawna",
            "fatherName": "Satveer",
            "obtainedMarks": "682",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "209",
              "200090420001",
              "Bhawna",
              "Satveer",
              "682",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "200090420003",
            "name": "Harnoor Bhati",
            "fatherName": "Balkaran Singh",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.77%",
            "cells": [
              "210",
              "200090420003",
              "Harnoor Bhati",
              "Balkaran Singh",
              "673",
              "900",
              "74.77%"
            ]
          },
          {
            "sNo": "211",
            "rollNo": "200090420004",
            "name": "Kavita Devi",
            "fatherName": "Shubhash",
            "obtainedMarks": "681",
            "maxMarks": "900",
            "percentage": "75.66%",
            "cells": [
              "211",
              "200090420004",
              "Kavita Devi",
              "Shubhash",
              "681",
              "900",
              "75.66%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "200090420005",
            "name": "Kiran",
            "fatherName": "Ramswaroop",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.88%",
            "cells": [
              "212",
              "200090420005",
              "Kiran",
              "Ramswaroop",
              "656",
              "900",
              "72.88%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "200090420006",
            "name": "Kusum Lata",
            "fatherName": "Vishnu Dev",
            "obtainedMarks": "648",
            "maxMarks": "900",
            "percentage": "72%",
            "cells": [
              "213",
              "200090420006",
              "Kusum Lata",
              "Vishnu Dev",
              "648",
              "900",
              "72%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "200090420010",
            "name": "Neha Kumari",
            "fatherName": "Mantu Yadav",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "214",
              "200090420010",
              "Neha Kumari",
              "Mantu Yadav",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "215",
            "rollNo": "200090420013",
            "name": "Poonam",
            "fatherName": "Rajender Singh",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "215",
              "200090420013",
              "Poonam",
              "Rajender Singh",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "200090420019",
            "name": "Renu Bala",
            "fatherName": "Dharam Ram",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "216",
              "200090420019",
              "Renu Bala",
              "Dharam Ram",
              "642",
              "900",
              "71.33%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "217",
            "rollNo": "22009115442009",
            "name": "Manjot Insan",
            "fatherName": "Mewa Ram",
            "obtainedMarks": "866",
            "maxMarks": "1175",
            "percentage": "73.70%",
            "cells": [
              "217",
              "22009115442009",
              "Manjot Insan",
              "Mewa Ram",
              "866",
              "1175",
              "73.70%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "22009115442014",
            "name": "Muskan",
            "fatherName": "Satish",
            "obtainedMarks": "858",
            "maxMarks": "1176",
            "percentage": "73.21%",
            "cells": [
              "218",
              "22009115442014",
              "Muskan",
              "Satish",
              "858",
              "1176",
              "73.21%"
            ]
          },
          {
            "sNo": "219",
            "rollNo": "22009115442027",
            "name": "Harmandeep Kaur",
            "fatherName": "Kulwinder Singh",
            "obtainedMarks": "840",
            "maxMarks": "1100",
            "percentage": "76.36%",
            "cells": [
              "219",
              "22009115442027",
              "Harmandeep Kaur",
              "Kulwinder Singh",
              "840",
              "1100",
              "76.36%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "220",
            "rollNo": "21009115442001",
            "name": "Jyoti",
            "fatherName": "Mahabir",
            "obtainedMarks": "896",
            "maxMarks": "1100",
            "percentage": "81.45%",
            "cells": [
              "220",
              "21009115442001",
              "Jyoti",
              "Mahabir",
              "896",
              "1100",
              "81.45%"
            ]
          },
          {
            "sNo": "221",
            "rollNo": "21009115442007",
            "name": "Sujata",
            "fatherName": "Sandeep Kumar",
            "obtainedMarks": "812",
            "maxMarks": "1100",
            "percentage": "73.82%",
            "cells": [
              "221",
              "21009115442007",
              "Sujata",
              "Sandeep Kumar",
              "812",
              "1100",
              "73.82%"
            ]
          },
          {
            "sNo": "222",
            "rollNo": "21009115442011",
            "name": "Luxmi",
            "fatherName": "mahavir",
            "obtainedMarks": "777",
            "maxMarks": "1100",
            "percentage": "70.64%",
            "cells": [
              "222",
              "21009115442011",
              "Luxmi",
              "mahavir",
              "777",
              "1100",
              "70.64%"
            ]
          },
          {
            "sNo": "223",
            "rollNo": "21009115442021",
            "name": "Anchal",
            "fatherName": "Lal Chand",
            "obtainedMarks": "854",
            "maxMarks": "1100",
            "percentage": "77.64%",
            "cells": [
              "223",
              "21009115442021",
              "Anchal",
              "Lal Chand",
              "854",
              "1100",
              "77.64%"
            ]
          },
          {
            "sNo": "224",
            "rollNo": "21009115442023",
            "name": "Neelam",
            "fatherName": "Rakesh Kumar",
            "obtainedMarks": "782",
            "maxMarks": "1100",
            "percentage": "71.09%",
            "cells": [
              "224",
              "21009115442023",
              "Neelam",
              "Rakesh Kumar",
              "782",
              "1100",
              "71.09%"
            ]
          },
          {
            "sNo": "225",
            "rollNo": "21009115442026",
            "name": "Diwanshi",
            "fatherName": "Mandeep Kumar",
            "obtainedMarks": "798",
            "maxMarks": "1100",
            "percentage": "72.55%",
            "cells": [
              "225",
              "21009115442026",
              "Diwanshi",
              "Mandeep Kumar",
              "798",
              "1100",
              "72.55%"
            ]
          },
          {
            "sNo": "226",
            "rollNo": "21009115442027",
            "name": "Pushpa Rani",
            "fatherName": "Baldev Singh",
            "obtainedMarks": "838",
            "maxMarks": "1100",
            "percentage": "76.18%",
            "cells": [
              "226",
              "21009115442027",
              "Pushpa Rani",
              "Baldev Singh",
              "838",
              "1100",
              "76.18%"
            ]
          },
          {
            "sNo": "227",
            "rollNo": "21009115442029",
            "name": "Kalpana Devi",
            "fatherName": "Jaswant Singh",
            "obtainedMarks": "849",
            "maxMarks": "1100",
            "percentage": "77.18%",
            "cells": [
              "227",
              "21009115442029",
              "Kalpana Devi",
              "Jaswant Singh",
              "849",
              "1100",
              "77.18%"
            ]
          },
          {
            "sNo": "228",
            "rollNo": "21009115442032",
            "name": "Natasha",
            "fatherName": "Piara Lal",
            "obtainedMarks": "812",
            "maxMarks": "1100",
            "percentage": "73.82%",
            "cells": [
              "228",
              "21009115442032",
              "Natasha",
              "Piara Lal",
              "812",
              "1100",
              "73.82%"
            ]
          },
          {
            "sNo": "229",
            "rollNo": "21009115442036",
            "name": "Neeru",
            "fatherName": "Rajbir",
            "obtainedMarks": "857",
            "maxMarks": "1100",
            "percentage": "77.91%",
            "cells": [
              "229",
              "21009115442036",
              "Neeru",
              "Rajbir",
              "857",
              "1100",
              "77.91%"
            ]
          },
          {
            "sNo": "230",
            "rollNo": "21009115442037",
            "name": "Manisha",
            "fatherName": "Sunil Kumar",
            "obtainedMarks": "771",
            "maxMarks": "1100",
            "percentage": "70.09%",
            "cells": [
              "230",
              "21009115442037",
              "Manisha",
              "Sunil Kumar",
              "771",
              "1100",
              "70.09%"
            ]
          },
          {
            "sNo": "231",
            "rollNo": "21009115442046",
            "name": "Ekta",
            "fatherName": "Sadhu Ram",
            "obtainedMarks": "866",
            "maxMarks": "1100",
            "percentage": "78.73%",
            "cells": [
              "231",
              "21009115442046",
              "Ekta",
              "Sadhu Ram",
              "866",
              "1100",
              "78.73%"
            ]
          },
          {
            "sNo": "232",
            "rollNo": "21009115442047",
            "name": "Priynka",
            "fatherName": "Baldev Singh",
            "obtainedMarks": "905",
            "maxMarks": "1100",
            "percentage": "82.27%",
            "cells": [
              "232",
              "21009115442047",
              "Priynka",
              "Baldev Singh",
              "905",
              "1100",
              "82.27%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (CS) III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "233",
            "rollNo": "2009115450002",
            "name": "iSHA",
            "fatherName": "Ish Kumar",
            "obtainedMarks": "720",
            "maxMarks": "1000",
            "percentage": "72%",
            "cells": [
              "233",
              "2009115450002",
              "iSHA",
              "Ish Kumar",
              "720",
              "1000",
              "72%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc (NM) III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "234",
            "rollNo": "2009115440001",
            "name": "Ashima",
            "fatherName": "jugLal",
            "obtainedMarks": "702",
            "maxMarks": "1000",
            "percentage": "70.20%",
            "cells": [
              "234",
              "2009115440001",
              "Ashima",
              "jugLal",
              "702",
              "1000",
              "70.20%"
            ]
          },
          {
            "sNo": "235",
            "rollNo": "2009115440004",
            "name": "Isha",
            "fatherName": "Inder Pal",
            "obtainedMarks": "753",
            "maxMarks": "1000",
            "percentage": "75.30%",
            "cells": [
              "235",
              "2009115440004",
              "Isha",
              "Inder Pal",
              "753",
              "1000",
              "75.30%"
            ]
          },
          {
            "sNo": "236",
            "rollNo": "2009115440020",
            "name": "Priyanka",
            "fatherName": "Baljinder Kumar",
            "obtainedMarks": "705",
            "maxMarks": "1000",
            "percentage": "70.50%",
            "cells": [
              "236",
              "2009115440020",
              "Priyanka",
              "Baljinder Kumar",
              "705",
              "1000",
              "70.50%"
            ]
          },
          {
            "sNo": "237",
            "rollNo": "2009115440022",
            "name": "Ramandeep Kaur",
            "fatherName": "Jagsir Singh",
            "obtainedMarks": "767",
            "maxMarks": "1000",
            "percentage": "76.70%",
            "cells": [
              "237",
              "2009115440022",
              "Ramandeep Kaur",
              "Jagsir Singh",
              "767",
              "1000",
              "76.70%"
            ]
          },
          {
            "sNo": "238",
            "rollNo": "2009115440027",
            "name": "Shiwani",
            "fatherName": "Lilu Ram",
            "obtainedMarks": "710",
            "maxMarks": "1000",
            "percentage": "71%",
            "cells": [
              "238",
              "2009115440027",
              "Shiwani",
              "Lilu Ram",
              "710",
              "1000",
              "71%"
            ]
          },
          {
            "sNo": "239",
            "rollNo": "2009115440028",
            "name": "Sneha",
            "fatherName": "Madan Lal",
            "obtainedMarks": "826",
            "maxMarks": "1000",
            "percentage": "82.60%",
            "cells": [
              "239",
              "2009115440028",
              "Sneha",
              "Madan Lal",
              "826",
              "1000",
              "82.60%"
            ]
          }
        ]
      },
      {
        "courseName": "Dped  I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "240",
            "rollNo": "22009225640001",
            "name": "RACHANA",
            "fatherName": "SARDUL",
            "obtainedMarks": "1090",
            "maxMarks": "1500",
            "percentage": "72.67%",
            "cells": [
              "240",
              "22009225640001",
              "RACHANA",
              "SARDUL",
              "1090",
              "1500",
              "72.67%"
            ]
          },
          {
            "sNo": "241",
            "rollNo": "22009225640002",
            "name": "ANJIKA",
            "fatherName": "RAMESH",
            "obtainedMarks": "1092",
            "maxMarks": "1500",
            "percentage": "72.80%",
            "cells": [
              "241",
              "22009225640002",
              "ANJIKA",
              "RAMESH",
              "1092",
              "1500",
              "72.80%"
            ]
          },
          {
            "sNo": "242",
            "rollNo": "22009225640003",
            "name": "MAMTA",
            "fatherName": "LILADHAR",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.27%",
            "cells": [
              "242",
              "22009225640003",
              "MAMTA",
              "LILADHAR",
              "1114",
              "1500",
              "74.27%"
            ]
          },
          {
            "sNo": "243",
            "rollNo": "22009225640004",
            "name": "SONU",
            "fatherName": "BALRAJ",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.93%",
            "cells": [
              "243",
              "22009225640004",
              "SONU",
              "BALRAJ",
              "1094",
              "1500",
              "72.93%"
            ]
          },
          {
            "sNo": "244",
            "rollNo": "22009225640005",
            "name": "SEEMA CHOUDHARY",
            "fatherName": "KALA RAM CHAUDHARY",
            "obtainedMarks": "1105",
            "maxMarks": "1500",
            "percentage": "73.67%",
            "cells": [
              "244",
              "22009225640005",
              "SEEMA CHOUDHARY",
              "KALA RAM CHAUDHARY",
              "1105",
              "1500",
              "73.67%"
            ]
          },
          {
            "sNo": "245",
            "rollNo": "22009225640006",
            "name": "DURGA KUMARI",
            "fatherName": "DEDA RAM",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "245",
              "22009225640006",
              "DURGA KUMARI",
              "DEDA RAM",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "246",
            "rollNo": "22009225640007",
            "name": "DHAPU",
            "fatherName": "FATA RAM",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.80%",
            "cells": [
              "246",
              "22009225640007",
              "DHAPU",
              "FATA RAM",
              "1122",
              "1500",
              "74.80%"
            ]
          },
          {
            "sNo": "247",
            "rollNo": "22009225640008",
            "name": "MS. PRIYNKA",
            "fatherName": "OMPRAKASH",
            "obtainedMarks": "1066",
            "maxMarks": "1500",
            "percentage": "71.07%",
            "cells": [
              "247",
              "22009225640008",
              "MS. PRIYNKA",
              "OMPRAKASH",
              "1066",
              "1500",
              "71.07%"
            ]
          },
          {
            "sNo": "248",
            "rollNo": "22009225640009",
            "name": "VIJAY LAXMI",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1132",
            "maxMarks": "1500",
            "percentage": "75.47%",
            "cells": [
              "248",
              "22009225640009",
              "VIJAY LAXMI",
              "RAN SINGH",
              "1132",
              "1500",
              "75.47%"
            ]
          },
          {
            "sNo": "249",
            "rollNo": "22009225640010",
            "name": "MS. RAVINA BISHNOI",
            "fatherName": "TEJA RAM",
            "obtainedMarks": "1082",
            "maxMarks": "1500",
            "percentage": "72.13%",
            "cells": [
              "249",
              "22009225640010",
              "MS. RAVINA BISHNOI",
              "TEJA RAM",
              "1082",
              "1500",
              "72.13%"
            ]
          },
          {
            "sNo": "250",
            "rollNo": "22009225640013",
            "name": "AYANA",
            "fatherName": "CHOKHA RAM",
            "obtainedMarks": "1058",
            "maxMarks": "1500",
            "percentage": "70.53%",
            "cells": [
              "250",
              "22009225640013",
              "AYANA",
              "CHOKHA RAM",
              "1058",
              "1500",
              "70.53%"
            ]
          },
          {
            "sNo": "251",
            "rollNo": "22009225640014",
            "name": "UJALA",
            "fatherName": "RAJESH KUMAR SIHAG",
            "obtainedMarks": "1103",
            "maxMarks": "1500",
            "percentage": "73.53%",
            "cells": [
              "251",
              "22009225640014",
              "UJALA",
              "RAJESH KUMAR SIHAG",
              "1103",
              "1500",
              "73.53%"
            ]
          },
          {
            "sNo": "252",
            "rollNo": "22009225640015",
            "name": "KANTA",
            "fatherName": "HET RAM",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.93%",
            "cells": [
              "252",
              "22009225640015",
              "KANTA",
              "HET RAM",
              "1094",
              "1500",
              "72.93%"
            ]
          },
          {
            "sNo": "253",
            "rollNo": "22009225640016",
            "name": "RACHANA",
            "fatherName": "JAGDISH PRASAD",
            "obtainedMarks": "1097",
            "maxMarks": "1500",
            "percentage": "73.13%",
            "cells": [
              "253",
              "22009225640016",
              "RACHANA",
              "JAGDISH PRASAD",
              "1097",
              "1500",
              "73.13%"
            ]
          },
          {
            "sNo": "254",
            "rollNo": "22009225640017",
            "name": "MS NIRMLA",
            "fatherName": "RAMLAL MEGHWAL",
            "obtainedMarks": "1137",
            "maxMarks": "1500",
            "percentage": "75.80%",
            "cells": [
              "254",
              "22009225640017",
              "MS NIRMLA",
              "RAMLAL MEGHWAL",
              "1137",
              "1500",
              "75.80%"
            ]
          },
          {
            "sNo": "255",
            "rollNo": "22009225640018",
            "name": "MONU",
            "fatherName": "LALA RAM",
            "obtainedMarks": "1143",
            "maxMarks": "1500",
            "percentage": "76.20%",
            "cells": [
              "255",
              "22009225640018",
              "MONU",
              "LALA RAM",
              "1143",
              "1500",
              "76.20%"
            ]
          },
          {
            "sNo": "256",
            "rollNo": "22009225640019",
            "name": "BASKARO",
            "fatherName": "BALVEER",
            "obtainedMarks": "1070",
            "maxMarks": "1500",
            "percentage": "71.33%",
            "cells": [
              "256",
              "22009225640019",
              "BASKARO",
              "BALVEER",
              "1070",
              "1500",
              "71.33%"
            ]
          },
          {
            "sNo": "257",
            "rollNo": "22009225640020",
            "name": "PREETI",
            "fatherName": "MAHENDRA SINGH",
            "obtainedMarks": "1116",
            "maxMarks": "1500",
            "percentage": "74.40%",
            "cells": [
              "257",
              "22009225640020",
              "PREETI",
              "MAHENDRA SINGH",
              "1116",
              "1500",
              "74.40%"
            ]
          },
          {
            "sNo": "258",
            "rollNo": "22009225640021",
            "name": "JYOTI",
            "fatherName": "OMPARAKASH",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.93%",
            "cells": [
              "258",
              "22009225640021",
              "JYOTI",
              "OMPARAKASH",
              "1094",
              "1500",
              "72.93%"
            ]
          },
          {
            "sNo": "259",
            "rollNo": "22009225640022",
            "name": "POONAM",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "1113",
            "maxMarks": "1500",
            "percentage": "74.20%",
            "cells": [
              "259",
              "22009225640022",
              "POONAM",
              "RAJESH KUMAR",
              "1113",
              "1500",
              "74.20%"
            ]
          },
          {
            "sNo": "260",
            "rollNo": "22009225640025",
            "name": "RACHNA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1157",
            "maxMarks": "1500",
            "percentage": "77.13%",
            "cells": [
              "260",
              "22009225640025",
              "RACHNA",
              "OM PARKASH",
              "1157",
              "1500",
              "77.13%"
            ]
          },
          {
            "sNo": "261",
            "rollNo": "22009225640026",
            "name": "ANU",
            "fatherName": "KARNAIL",
            "obtainedMarks": "1082",
            "maxMarks": "1500",
            "percentage": "72.13%",
            "cells": [
              "261",
              "22009225640026",
              "ANU",
              "KARNAIL",
              "1082",
              "1500",
              "72.13%"
            ]
          },
          {
            "sNo": "262",
            "rollNo": "22009225640027",
            "name": "RAVINA",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1182",
            "maxMarks": "1500",
            "percentage": "78.80%",
            "cells": [
              "262",
              "22009225640027",
              "RAVINA",
              "ANAND KUMAR",
              "1182",
              "1500",
              "78.80%"
            ]
          },
          {
            "sNo": "263",
            "rollNo": "22009225640028",
            "name": "VRMILA",
            "fatherName": "DALIP KUMAR",
            "obtainedMarks": "1061",
            "maxMarks": "1500",
            "percentage": "70.73%",
            "cells": [
              "263",
              "22009225640028",
              "VRMILA",
              "DALIP KUMAR",
              "1061",
              "1500",
              "70.73%"
            ]
          },
          {
            "sNo": "264",
            "rollNo": "22009225640029",
            "name": "KAVITA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1105",
            "maxMarks": "1500",
            "percentage": "73.67%",
            "cells": [
              "264",
              "22009225640029",
              "KAVITA",
              "RAKESH KUMAR",
              "1105",
              "1500",
              "73.67%"
            ]
          },
          {
            "sNo": "265",
            "rollNo": "22009225640031",
            "name": "KUMKUM",
            "fatherName": "RADHE SHYAM",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.27%",
            "cells": [
              "265",
              "22009225640031",
              "KUMKUM",
              "RADHE SHYAM",
              "1114",
              "1500",
              "74.27%"
            ]
          },
          {
            "sNo": "266",
            "rollNo": "22009225640032",
            "name": "SONU RANI",
            "fatherName": "MAN SINGH",
            "obtainedMarks": "1084",
            "maxMarks": "1500",
            "percentage": "72.27%",
            "cells": [
              "266",
              "22009225640032",
              "SONU RANI",
              "MAN SINGH",
              "1084",
              "1500",
              "72.27%"
            ]
          },
          {
            "sNo": "267",
            "rollNo": "22009225640033",
            "name": "SIMRAN",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1057",
            "maxMarks": "1500",
            "percentage": "70.47%",
            "cells": [
              "267",
              "22009225640033",
              "SIMRAN",
              "SURESH KUMAR",
              "1057",
              "1500",
              "70.47%"
            ]
          },
          {
            "sNo": "268",
            "rollNo": "22009225640034",
            "name": "AARJU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1153",
            "maxMarks": "1500",
            "percentage": "76.87%",
            "cells": [
              "268",
              "22009225640034",
              "AARJU",
              "PAWAN KUMAR",
              "1153",
              "1500",
              "76.87%"
            ]
          },
          {
            "sNo": "269",
            "rollNo": "22009225640035",
            "name": "SANJANA",
            "fatherName": "RAJESH VERMA",
            "obtainedMarks": "1166",
            "maxMarks": "1500",
            "percentage": "77.73%",
            "cells": [
              "269",
              "22009225640035",
              "SANJANA",
              "RAJESH VERMA",
              "1166",
              "1500",
              "77.73%"
            ]
          },
          {
            "sNo": "270",
            "rollNo": "22009225640036",
            "name": "KIRAN",
            "fatherName": "RAKESH",
            "obtainedMarks": "1074",
            "maxMarks": "1500",
            "percentage": "71.60%",
            "cells": [
              "270",
              "22009225640036",
              "KIRAN",
              "RAKESH",
              "1074",
              "1500",
              "71.60%"
            ]
          },
          {
            "sNo": "271",
            "rollNo": "22009225640037",
            "name": "MS. PRIYANKA KUMARI",
            "fatherName": "LUNA RAM",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.27%",
            "cells": [
              "271",
              "22009225640037",
              "MS. PRIYANKA KUMARI",
              "LUNA RAM",
              "1114",
              "1500",
              "74.27%"
            ]
          },
          {
            "sNo": "272",
            "rollNo": "22009225640038",
            "name": "MS. REETA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "1118",
            "maxMarks": "1500",
            "percentage": "74.53%",
            "cells": [
              "272",
              "22009225640038",
              "MS. REETA",
              "SUBHASH CHANDER",
              "1118",
              "1500",
              "74.53%"
            ]
          },
          {
            "sNo": "273",
            "rollNo": "22009225640039",
            "name": "NEETU",
            "fatherName": "RAMESH",
            "obtainedMarks": "1103",
            "maxMarks": "1500",
            "percentage": "73.53%",
            "cells": [
              "273",
              "22009225640039",
              "NEETU",
              "RAMESH",
              "1103",
              "1500",
              "73.53%"
            ]
          },
          {
            "sNo": "274",
            "rollNo": "22009225640040",
            "name": "MS.POONAM",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1080",
            "maxMarks": "1500",
            "percentage": "72%",
            "cells": [
              "274",
              "22009225640040",
              "MS.POONAM",
              "ANAND KUMAR",
              "1080",
              "1500",
              "72%"
            ]
          },
          {
            "sNo": "275",
            "rollNo": "22009225640041",
            "name": "SHIKSHA",
            "fatherName": "DEVINDER",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.80%",
            "cells": [
              "275",
              "22009225640041",
              "SHIKSHA",
              "DEVINDER",
              "1122",
              "1500",
              "74.80%"
            ]
          },
          {
            "sNo": "276",
            "rollNo": "22009225640042",
            "name": "MONIKA",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "1125",
            "maxMarks": "1500",
            "percentage": "75%",
            "cells": [
              "276",
              "22009225640042",
              "MONIKA",
              "SANDEEP KUMAR",
              "1125",
              "1500",
              "75%"
            ]
          },
          {
            "sNo": "277",
            "rollNo": "22009225640043",
            "name": "BINTU RANI",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1171",
            "maxMarks": "1500",
            "percentage": "78.07%",
            "cells": [
              "277",
              "22009225640043",
              "BINTU RANI",
              "RAN SINGH",
              "1171",
              "1500",
              "78.07%"
            ]
          },
          {
            "sNo": "278",
            "rollNo": "22009225640044",
            "name": "AARTI",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "1113",
            "maxMarks": "1500",
            "percentage": "74.20%",
            "cells": [
              "278",
              "22009225640044",
              "AARTI",
              "AMAR SINGH",
              "1113",
              "1500",
              "74.20%"
            ]
          },
          {
            "sNo": "279",
            "rollNo": "22009225640045",
            "name": "MS.BEYANT KOUR",
            "fatherName": "IKBAL SINGH",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "279",
              "22009225640045",
              "MS.BEYANT KOUR",
              "IKBAL SINGH",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "280",
            "rollNo": "22009225640046",
            "name": "MS.HURNIKA",
            "fatherName": "SHYOPAT SINGH",
            "obtainedMarks": "1172",
            "maxMarks": "1500",
            "percentage": "78.13%",
            "cells": [
              "280",
              "22009225640046",
              "MS.HURNIKA",
              "SHYOPAT SINGH",
              "1172",
              "1500",
              "78.13%"
            ]
          },
          {
            "sNo": "281",
            "rollNo": "22009225640047",
            "name": "MS.PRIYA SEN",
            "fatherName": "OMPRAKASH",
            "obtainedMarks": "1193",
            "maxMarks": "1500",
            "percentage": "79.53%",
            "cells": [
              "281",
              "22009225640047",
              "MS.PRIYA SEN",
              "OMPRAKASH",
              "1193",
              "1500",
              "79.53%"
            ]
          }
        ]
      },
      {
        "courseName": "Dped  I I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "282",
            "rollNo": "21009225640001",
            "name": "RAJNI",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "1134",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "282",
              "21009225640001",
              "RAJNI",
              "BHIM SINGH",
              "1134",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "283",
            "rollNo": "21009225640002",
            "name": "LAKSHITA",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "1160",
            "maxMarks": "1500",
            "percentage": "77.30%",
            "cells": [
              "283",
              "21009225640002",
              "LAKSHITA",
              "BANSI LAL",
              "1160",
              "1500",
              "77.30%"
            ]
          },
          {
            "sNo": "284",
            "rollNo": "21009225640003",
            "name": "SANJU BALA",
            "fatherName": "CHANDER BHAN",
            "obtainedMarks": "1116",
            "maxMarks": "1500",
            "percentage": "74.40%",
            "cells": [
              "284",
              "21009225640003",
              "SANJU BALA",
              "CHANDER BHAN",
              "1116",
              "1500",
              "74.40%"
            ]
          },
          {
            "sNo": "285",
            "rollNo": "21009225640004",
            "name": "MAMTA",
            "fatherName": "JATAN SINGH",
            "obtainedMarks": "1109",
            "maxMarks": "1500",
            "percentage": "73.90%",
            "cells": [
              "285",
              "21009225640004",
              "MAMTA",
              "JATAN SINGH",
              "1109",
              "1500",
              "73.90%"
            ]
          },
          {
            "sNo": "286",
            "rollNo": "21009225640006",
            "name": "ANJU KANWAR",
            "fatherName": "MAHAVEER SINGH",
            "obtainedMarks": "1179",
            "maxMarks": "1500",
            "percentage": "78.60%",
            "cells": [
              "286",
              "21009225640006",
              "ANJU KANWAR",
              "MAHAVEER SINGH",
              "1179",
              "1500",
              "78.60%"
            ]
          },
          {
            "sNo": "287",
            "rollNo": "21009225640007",
            "name": "KOMAL",
            "fatherName": "JITENDRA JAKHAR",
            "obtainedMarks": "1052",
            "maxMarks": "1500",
            "percentage": "70.10%",
            "cells": [
              "287",
              "21009225640007",
              "KOMAL",
              "JITENDRA JAKHAR",
              "1052",
              "1500",
              "70.10%"
            ]
          },
          {
            "sNo": "288",
            "rollNo": "21009225640008",
            "name": "LOVEPREET",
            "fatherName": "MANDER RAM",
            "obtainedMarks": "1213",
            "maxMarks": "1500",
            "percentage": "80.80%",
            "cells": [
              "288",
              "21009225640008",
              "LOVEPREET",
              "MANDER RAM",
              "1213",
              "1500",
              "80.80%"
            ]
          },
          {
            "sNo": "289",
            "rollNo": "21009225640009",
            "name": "POOJA PRAJAPATI",
            "fatherName": "KAILASH CHANDRA PRAJAPATI",
            "obtainedMarks": "1149",
            "maxMarks": "1500",
            "percentage": "76.60%",
            "cells": [
              "289",
              "21009225640009",
              "POOJA PRAJAPATI",
              "KAILASH CHANDRA PRAJAPATI",
              "1149",
              "1500",
              "76.60%"
            ]
          },
          {
            "sNo": "290",
            "rollNo": "21009225640010",
            "name": "NEELAM",
            "fatherName": "MAHAVEER",
            "obtainedMarks": "1096",
            "maxMarks": "1500",
            "percentage": "73.06%",
            "cells": [
              "290",
              "21009225640010",
              "NEELAM",
              "MAHAVEER",
              "1096",
              "1500",
              "73.06%"
            ]
          },
          {
            "sNo": "291",
            "rollNo": "21009225640011",
            "name": "ARTI",
            "fatherName": "SHYOPAL",
            "obtainedMarks": "1145",
            "maxMarks": "1500",
            "percentage": "76.30%",
            "cells": [
              "291",
              "21009225640011",
              "ARTI",
              "SHYOPAL",
              "1145",
              "1500",
              "76.30%"
            ]
          },
          {
            "sNo": "292",
            "rollNo": "21009225640012",
            "name": "SUMAN",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1164",
            "maxMarks": "1500",
            "percentage": "77.60%",
            "cells": [
              "292",
              "21009225640012",
              "SUMAN",
              "DHARAMPAL",
              "1164",
              "1500",
              "77.60%"
            ]
          },
          {
            "sNo": "293",
            "rollNo": "21009225640013",
            "name": "POONAM",
            "fatherName": "BHANWAR LAL",
            "obtainedMarks": "1186",
            "maxMarks": "1500",
            "percentage": "79.06%",
            "cells": [
              "293",
              "21009225640013",
              "POONAM",
              "BHANWAR LAL",
              "1186",
              "1500",
              "79.06%"
            ]
          },
          {
            "sNo": "294",
            "rollNo": "21009225640014",
            "name": "PRIYANKA",
            "fatherName": "JAGDISH",
            "obtainedMarks": "1130",
            "maxMarks": "1500",
            "percentage": "75.33%",
            "cells": [
              "294",
              "21009225640014",
              "PRIYANKA",
              "JAGDISH",
              "1130",
              "1500",
              "75.33%"
            ]
          },
          {
            "sNo": "295",
            "rollNo": "21009225640015",
            "name": "KANTA",
            "fatherName": "KESARA RAM",
            "obtainedMarks": "1200",
            "maxMarks": "1500",
            "percentage": "80%",
            "cells": [
              "295",
              "21009225640015",
              "KANTA",
              "KESARA RAM",
              "1200",
              "1500",
              "80%"
            ]
          },
          {
            "sNo": "296",
            "rollNo": "21009225640016",
            "name": "MANISHA",
            "fatherName": "AMAR DEV",
            "obtainedMarks": "1060",
            "maxMarks": "1500",
            "percentage": "70.60%",
            "cells": [
              "296",
              "21009225640016",
              "MANISHA",
              "AMAR DEV",
              "1060",
              "1500",
              "70.60%"
            ]
          },
          {
            "sNo": "297",
            "rollNo": "21009225640017",
            "name": "PALLAVI",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1076",
            "maxMarks": "1500",
            "percentage": "71.70%",
            "cells": [
              "297",
              "21009225640017",
              "PALLAVI",
              "RAKESH KUMAR",
              "1076",
              "1500",
              "71.70%"
            ]
          },
          {
            "sNo": "298",
            "rollNo": "21009225640018",
            "name": "KANCHAN",
            "fatherName": "CHHINDERPAL",
            "obtainedMarks": "1189",
            "maxMarks": "1500",
            "percentage": "79.20%",
            "cells": [
              "298",
              "21009225640018",
              "KANCHAN",
              "CHHINDERPAL",
              "1189",
              "1500",
              "79.20%"
            ]
          },
          {
            "sNo": "299",
            "rollNo": "21009225640019",
            "name": "MANJU",
            "fatherName": "RAMSUKH",
            "obtainedMarks": "1138",
            "maxMarks": "1500",
            "percentage": "75.80%",
            "cells": [
              "299",
              "21009225640019",
              "MANJU",
              "RAMSUKH",
              "1138",
              "1500",
              "75.80%"
            ]
          },
          {
            "sNo": "300",
            "rollNo": "21009225640020",
            "name": "VIDISHA",
            "fatherName": "TILA RAM",
            "obtainedMarks": "1100",
            "maxMarks": "1500",
            "percentage": "73.30%",
            "cells": [
              "300",
              "21009225640020",
              "VIDISHA",
              "TILA RAM",
              "1100",
              "1500",
              "73.30%"
            ]
          },
          {
            "sNo": "301",
            "rollNo": "21009225640021",
            "name": "KANTA SHARMA",
            "fatherName": "DEENDAYAL SHARMA",
            "obtainedMarks": "1111",
            "maxMarks": "1500",
            "percentage": "74.06%",
            "cells": [
              "301",
              "21009225640021",
              "KANTA SHARMA",
              "DEENDAYAL SHARMA",
              "1111",
              "1500",
              "74.06%"
            ]
          },
          {
            "sNo": "302",
            "rollNo": "21009225640022",
            "name": "SUMAN",
            "fatherName": "KAILASH RAM",
            "obtainedMarks": "1090",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "302",
              "21009225640022",
              "SUMAN",
              "KAILASH RAM",
              "1090",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "303",
            "rollNo": "21009225640023",
            "name": "PREM GOURA",
            "fatherName": "MADANLAL GOURA",
            "obtainedMarks": "1126",
            "maxMarks": "1500",
            "percentage": "75.06%",
            "cells": [
              "303",
              "21009225640023",
              "PREM GOURA",
              "MADANLAL GOURA",
              "1126",
              "1500",
              "75.06%"
            ]
          },
          {
            "sNo": "304",
            "rollNo": "21009225640024",
            "name": "AASTHA SHARMA",
            "fatherName": "OM PRAKASH SHARMA",
            "obtainedMarks": "1213",
            "maxMarks": "1500",
            "percentage": "80.86%",
            "cells": [
              "304",
              "21009225640024",
              "AASTHA SHARMA",
              "OM PRAKASH SHARMA",
              "1213",
              "1500",
              "80.86%"
            ]
          },
          {
            "sNo": "305",
            "rollNo": "21009225640026",
            "name": "SONU PRAJAPAT",
            "fatherName": "RAMJILAL PRAJAPAT",
            "obtainedMarks": "1146",
            "maxMarks": "1500",
            "percentage": "76.40%",
            "cells": [
              "305",
              "21009225640026",
              "SONU PRAJAPAT",
              "RAMJILAL PRAJAPAT",
              "1146",
              "1500",
              "76.40%"
            ]
          },
          {
            "sNo": "306",
            "rollNo": "21009225640028",
            "name": "POOJA",
            "fatherName": "SANTLAL",
            "obtainedMarks": "1125",
            "maxMarks": "1500",
            "percentage": "75%",
            "cells": [
              "306",
              "21009225640028",
              "POOJA",
              "SANTLAL",
              "1125",
              "1500",
              "75%"
            ]
          },
          {
            "sNo": "307",
            "rollNo": "21009225640029",
            "name": "APURVA",
            "fatherName": "KRISHAN",
            "obtainedMarks": "1106",
            "maxMarks": "1500",
            "percentage": "73.70%",
            "cells": [
              "307",
              "21009225640029",
              "APURVA",
              "KRISHAN",
              "1106",
              "1500",
              "73.70%"
            ]
          },
          {
            "sNo": "308",
            "rollNo": "21009225640030",
            "name": "FORANTA JAT",
            "fatherName": "SUVARAM JAT",
            "obtainedMarks": "1088",
            "maxMarks": "1500",
            "percentage": "72.50%",
            "cells": [
              "308",
              "21009225640030",
              "FORANTA JAT",
              "SUVARAM JAT",
              "1088",
              "1500",
              "72.50%"
            ]
          },
          {
            "sNo": "309",
            "rollNo": "21009225640031",
            "name": "KOMAL JOSHI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1095",
            "maxMarks": "1500",
            "percentage": "73%",
            "cells": [
              "309",
              "21009225640031",
              "KOMAL JOSHI",
              "KRISHAN KUMAR",
              "1095",
              "1500",
              "73%"
            ]
          },
          {
            "sNo": "310",
            "rollNo": "21009225640032",
            "name": "SANJU",
            "fatherName": "KURDARAM",
            "obtainedMarks": "1106",
            "maxMarks": "1500",
            "percentage": "73.70%",
            "cells": [
              "310",
              "21009225640032",
              "SANJU",
              "KURDARAM",
              "1106",
              "1500",
              "73.70%"
            ]
          },
          {
            "sNo": "311",
            "rollNo": "21009225640033",
            "name": "POOJA",
            "fatherName": "LICHHMAN RAM",
            "obtainedMarks": "1174",
            "maxMarks": "1500",
            "percentage": "78.20%",
            "cells": [
              "311",
              "21009225640033",
              "POOJA",
              "LICHHMAN RAM",
              "1174",
              "1500",
              "78.20%"
            ]
          },
          {
            "sNo": "312",
            "rollNo": "21009225640034",
            "name": "JYOTI",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "1163",
            "maxMarks": "1500",
            "percentage": "77.50%",
            "cells": [
              "312",
              "21009225640034",
              "JYOTI",
              "MOHAN LAL",
              "1163",
              "1500",
              "77.50%"
            ]
          },
          {
            "sNo": "313",
            "rollNo": "21009225640035",
            "name": "SUKHWANTI",
            "fatherName": "CHETAN RAM",
            "obtainedMarks": "1210",
            "maxMarks": "1500",
            "percentage": "80.60%",
            "cells": [
              "313",
              "21009225640035",
              "SUKHWANTI",
              "CHETAN RAM",
              "1210",
              "1500",
              "80.60%"
            ]
          },
          {
            "sNo": "314",
            "rollNo": "21009225640036",
            "name": "PRIYANKA",
            "fatherName": "MANGE RAM",
            "obtainedMarks": "1169",
            "maxMarks": "1500",
            "percentage": "77.90%",
            "cells": [
              "314",
              "21009225640036",
              "PRIYANKA",
              "MANGE RAM",
              "1169",
              "1500",
              "77.90%"
            ]
          },
          {
            "sNo": "315",
            "rollNo": "21009225640037",
            "name": "BALA KUMARI",
            "fatherName": "BABU LAL",
            "obtainedMarks": "1128",
            "maxMarks": "1500",
            "percentage": "75.20%",
            "cells": [
              "315",
              "21009225640037",
              "BALA KUMARI",
              "BABU LAL",
              "1128",
              "1500",
              "75.20%"
            ]
          },
          {
            "sNo": "316",
            "rollNo": "21009225640038",
            "name": "PUSHPA MAIYA",
            "fatherName": "NIMBARAM MAIYA",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.90%",
            "cells": [
              "316",
              "21009225640038",
              "PUSHPA MAIYA",
              "NIMBARAM MAIYA",
              "1094",
              "1500",
              "72.90%"
            ]
          },
          {
            "sNo": "317",
            "rollNo": "21009225640039",
            "name": "DIKSHA",
            "fatherName": "SHANKAR LAL",
            "obtainedMarks": "1156",
            "maxMarks": "1500",
            "percentage": "77.06%",
            "cells": [
              "317",
              "21009225640039",
              "DIKSHA",
              "SHANKAR LAL",
              "1156",
              "1500",
              "77.06%"
            ]
          },
          {
            "sNo": "318",
            "rollNo": "21009225640040",
            "name": "KANNU PRIYA",
            "fatherName": "SATVEER",
            "obtainedMarks": "1147",
            "maxMarks": "1500",
            "percentage": "76.40%",
            "cells": [
              "318",
              "21009225640040",
              "KANNU PRIYA",
              "SATVEER",
              "1147",
              "1500",
              "76.40%"
            ]
          },
          {
            "sNo": "319",
            "rollNo": "21009225640041",
            "name": "SAROJ CHAUDHARY",
            "fatherName": "GOPAL RAM",
            "obtainedMarks": "1119",
            "maxMarks": "1500",
            "percentage": "74.60%",
            "cells": [
              "319",
              "21009225640041",
              "SAROJ CHAUDHARY",
              "GOPAL RAM",
              "1119",
              "1500",
              "74.60%"
            ]
          },
          {
            "sNo": "320",
            "rollNo": "21009225640042",
            "name": "POOJA",
            "fatherName": "GOPI RAM",
            "obtainedMarks": "1121",
            "maxMarks": "1500",
            "percentage": "74.70%",
            "cells": [
              "320",
              "21009225640042",
              "POOJA",
              "GOPI RAM",
              "1121",
              "1500",
              "74.70%"
            ]
          },
          {
            "sNo": "321",
            "rollNo": "21009225640043",
            "name": "SONA GHASAL",
            "fatherName": "KANARAM GHASAL",
            "obtainedMarks": "1156",
            "maxMarks": "1500",
            "percentage": "77.06%",
            "cells": [
              "321",
              "21009225640043",
              "SONA GHASAL",
              "KANARAM GHASAL",
              "1156",
              "1500",
              "77.06%"
            ]
          },
          {
            "sNo": "322",
            "rollNo": "21009225640045",
            "name": "CHANCHAL PRAJAPAT",
            "fatherName": "SITARAM KUMHAR",
            "obtainedMarks": "1191",
            "maxMarks": "1500",
            "percentage": "79.40%",
            "cells": [
              "322",
              "21009225640045",
              "CHANCHAL PRAJAPAT",
              "SITARAM KUMHAR",
              "1191",
              "1500",
              "79.40%"
            ]
          },
          {
            "sNo": "323",
            "rollNo": "21009225640046",
            "name": "MAYA GEELA",
            "fatherName": "KAILASH GEELA",
            "obtainedMarks": "1152",
            "maxMarks": "1500",
            "percentage": "76.80%",
            "cells": [
              "323",
              "21009225640046",
              "MAYA GEELA",
              "KAILASH GEELA",
              "1152",
              "1500",
              "76.80%"
            ]
          },
          {
            "sNo": "324",
            "rollNo": "21009225640047",
            "name": "KHIVNI",
            "fatherName": "JETA RAM",
            "obtainedMarks": "1135",
            "maxMarks": "1500",
            "percentage": "75.60%",
            "cells": [
              "324",
              "21009225640047",
              "KHIVNI",
              "JETA RAM",
              "1135",
              "1500",
              "75.60%"
            ]
          },
          {
            "sNo": "325",
            "rollNo": "21009225640048",
            "name": "PRIYANKA",
            "fatherName": "BALBEER SINGH",
            "obtainedMarks": "1110",
            "maxMarks": "1500",
            "percentage": "74%",
            "cells": [
              "325",
              "21009225640048",
              "PRIYANKA",
              "BALBEER SINGH",
              "1110",
              "1500",
              "74%"
            ]
          },
          {
            "sNo": "326",
            "rollNo": "21009225640049",
            "name": "RACHANA",
            "fatherName": "LADURAM GODARA",
            "obtainedMarks": "1125",
            "maxMarks": "1500",
            "percentage": "75%",
            "cells": [
              "326",
              "21009225640049",
              "RACHANA",
              "LADURAM GODARA",
              "1125",
              "1500",
              "75%"
            ]
          },
          {
            "sNo": "327",
            "rollNo": "21009225640050",
            "name": "DEEPIKA",
            "fatherName": "DARIYA SINGH",
            "obtainedMarks": "1078",
            "maxMarks": "1500",
            "percentage": "71.80%",
            "cells": [
              "327",
              "21009225640050",
              "DEEPIKA",
              "DARIYA SINGH",
              "1078",
              "1500",
              "71.80%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm.. I year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "22009990140002",
            "name": "MANISHA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "922",
            "maxMarks": "1300",
            "percentage": "70.92%",
            "cells": [
              "1",
              "22009990140002",
              "MANISHA",
              "VINOD KUMAR",
              "922",
              "1300",
              "70.92%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "22009990140003",
            "name": "DEVKI",
            "fatherName": "CHAND RAM",
            "obtainedMarks": "982",
            "maxMarks": "1300",
            "percentage": "75.54%",
            "cells": [
              "2",
              "22009990140003",
              "DEVKI",
              "CHAND RAM",
              "982",
              "1300",
              "75.54%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "22009990140005",
            "name": "ANURADHA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "973",
            "maxMarks": "1300",
            "percentage": "74.85%",
            "cells": [
              "3",
              "22009990140005",
              "ANURADHA",
              "MOHAN LAL",
              "973",
              "1300",
              "74.85%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "22009990140008",
            "name": "LOVE PREET KAUR",
            "fatherName": "SHAMSHER SINGH",
            "obtainedMarks": "964",
            "maxMarks": "1300",
            "percentage": "74.15%",
            "cells": [
              "4",
              "22009990140008",
              "LOVE PREET KAUR",
              "SHAMSHER SINGH",
              "964",
              "1300",
              "74.15%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "22009990140009",
            "name": "SHARMEEELA",
            "fatherName": "PREET SINGH",
            "obtainedMarks": "932",
            "maxMarks": "1300",
            "percentage": "71.69%",
            "cells": [
              "5",
              "22009990140009",
              "SHARMEEELA",
              "PREET SINGH",
              "932",
              "1300",
              "71.69%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "22009990140010",
            "name": "Ramandeep",
            "fatherName": "DILBAG SINGH",
            "obtainedMarks": "943",
            "maxMarks": "1300",
            "percentage": "72.54%",
            "cells": [
              "6",
              "22009990140010",
              "Ramandeep",
              "DILBAG SINGH",
              "943",
              "1300",
              "72.54%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "22009990140012",
            "name": "RIYA",
            "fatherName": "SATYANARYAN",
            "obtainedMarks": "996",
            "maxMarks": "1300",
            "percentage": "76.62%",
            "cells": [
              "7",
              "22009990140012",
              "RIYA",
              "SATYANARYAN",
              "996",
              "1300",
              "76.62%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "22009990140014",
            "name": "NAMAN",
            "fatherName": "AJAY TANWAR",
            "obtainedMarks": "999",
            "maxMarks": "1300",
            "percentage": "76.85%",
            "cells": [
              "8",
              "22009990140014",
              "NAMAN",
              "AJAY TANWAR",
              "999",
              "1300",
              "76.85%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "22009990140015",
            "name": "KAMLESH",
            "fatherName": "SUKHA RAM",
            "obtainedMarks": "953",
            "maxMarks": "1300",
            "percentage": "73.31%",
            "cells": [
              "9",
              "22009990140015",
              "KAMLESH",
              "SUKHA RAM",
              "953",
              "1300",
              "73.31%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "22009990140017",
            "name": "PARMOD RANI",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "934",
            "maxMarks": "1300",
            "percentage": "71.85%",
            "cells": [
              "10",
              "22009990140017",
              "PARMOD RANI",
              "RAJENDER KUMAR",
              "934",
              "1300",
              "71.85%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "22009990140018",
            "name": "NIDHI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "960",
            "maxMarks": "1300",
            "percentage": "73.85%",
            "cells": [
              "11",
              "22009990140018",
              "NIDHI",
              "RAJ KUMAR",
              "960",
              "1300",
              "73.85%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "22009990140020",
            "name": "SUMMI",
            "fatherName": "LAXMAN",
            "obtainedMarks": "495",
            "maxMarks": "1300",
            "percentage": "38.08%",
            "cells": [
              "12",
              "22009990140020",
              "SUMMI",
              "LAXMAN",
              "495",
              "1300",
              "38.08%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "22009990140024",
            "name": "MONIKA",
            "fatherName": "Bhale Singh",
            "obtainedMarks": "981",
            "maxMarks": "1300",
            "percentage": "75.46%",
            "cells": [
              "13",
              "22009990140024",
              "MONIKA",
              "Bhale Singh",
              "981",
              "1300",
              "75.46%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A Pub. Adm.. II year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "14",
            "rollNo": "21009990140001",
            "name": "KIRAN",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "954",
            "maxMarks": "1200",
            "percentage": "79.50%",
            "cells": [
              "14",
              "21009990140001",
              "KIRAN",
              "RAJENDER SINGH",
              "954",
              "1200",
              "79.50%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "21009990140002",
            "name": "RAVINA",
            "fatherName": "AJAY PAL",
            "obtainedMarks": "854",
            "maxMarks": "1201",
            "percentage": "71.11%",
            "cells": [
              "15",
              "21009990140002",
              "RAVINA",
              "AJAY PAL",
              "854",
              "1201",
              "71.11%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "21009990140004",
            "name": "REKHA",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "910",
            "maxMarks": "1202",
            "percentage": "75.71%",
            "cells": [
              "16",
              "21009990140004",
              "REKHA",
              "SHYAM LAL",
              "910",
              "1202",
              "75.71%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "21009990140007",
            "name": "MAHIMA",
            "fatherName": "VIJESH KUMAR",
            "obtainedMarks": "925",
            "maxMarks": "1203",
            "percentage": "76.89%",
            "cells": [
              "17",
              "21009990140007",
              "MAHIMA",
              "VIJESH KUMAR",
              "925",
              "1203",
              "76.89%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "21009990140009",
            "name": "KAPISHA POONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "938",
            "maxMarks": "1204",
            "percentage": "77.91%",
            "cells": [
              "18",
              "21009990140009",
              "KAPISHA POONIA",
              "SANJAY KUMAR",
              "938",
              "1204",
              "77.91%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "21009990140014",
            "name": "SHARDHA",
            "fatherName": "SAINT GURMEET RAM RAHIM SINGH",
            "obtainedMarks": "855",
            "maxMarks": "1205",
            "percentage": "70.95%",
            "cells": [
              "19",
              "21009990140014",
              "SHARDHA",
              "SAINT GURMEET RAM RAHIM SINGH",
              "855",
              "1205",
              "70.95%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "21009990140015",
            "name": "JYOTI",
            "fatherName": "DAMODAR",
            "obtainedMarks": "858",
            "maxMarks": "1206",
            "percentage": "71.14%",
            "cells": [
              "20",
              "21009990140015",
              "JYOTI",
              "DAMODAR",
              "858",
              "1206",
              "71.14%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "21009990140017",
            "name": "PRIYANKA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "865",
            "maxMarks": "1207",
            "percentage": "71.67%",
            "cells": [
              "21",
              "21009990140017",
              "PRIYANKA",
              "MADAN LAL",
              "865",
              "1207",
              "71.67%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "21009990140019",
            "name": "NIDHI",
            "fatherName": "RAJINDER SINGH",
            "obtainedMarks": "906",
            "maxMarks": "1208",
            "percentage": "75%",
            "cells": [
              "22",
              "21009990140019",
              "NIDHI",
              "RAJINDER SINGH",
              "906",
              "1208",
              "75%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "21009990140020",
            "name": "POOJA",
            "fatherName": "RAJESH",
            "obtainedMarks": "874",
            "maxMarks": "1209",
            "percentage": "72.29%",
            "cells": [
              "23",
              "21009990140020",
              "POOJA",
              "RAJESH",
              "874",
              "1209",
              "72.29%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "21009990140024",
            "name": "SHIWANGI",
            "fatherName": "DEVI DAYAL",
            "obtainedMarks": "921",
            "maxMarks": "1210",
            "percentage": "76.12%",
            "cells": [
              "24",
              "21009990140024",
              "SHIWANGI",
              "DEVI DAYAL",
              "921",
              "1210",
              "76.12%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "21009990140029",
            "name": "MAHAK",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "855",
            "maxMarks": "1212",
            "percentage": "70.54%",
            "cells": [
              "25",
              "21009990140029",
              "MAHAK",
              "RAKESH KUMAR",
              "855",
              "1212",
              "70.54%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A HINDI. I year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "26",
            "rollNo": "22009990120003",
            "name": "RENU",
            "fatherName": "RANBIR",
            "obtainedMarks": "962",
            "maxMarks": "1300",
            "percentage": "74%",
            "cells": [
              "26",
              "22009990120003",
              "RENU",
              "RANBIR",
              "962",
              "1300",
              "74%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "22009990120004",
            "name": "KAVITA",
            "fatherName": "RAMPARKASH",
            "obtainedMarks": "981",
            "maxMarks": "1301",
            "percentage": "75.40%",
            "cells": [
              "27",
              "22009990120004",
              "KAVITA",
              "RAMPARKASH",
              "981",
              "1301",
              "75.40%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "22009990120005",
            "name": "RAMNEET",
            "fatherName": "SATPAL",
            "obtainedMarks": "983",
            "maxMarks": "1302",
            "percentage": "75.50%",
            "cells": [
              "28",
              "22009990120005",
              "RAMNEET",
              "SATPAL",
              "983",
              "1302",
              "75.50%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "22009990120008",
            "name": "KIRAN",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "985",
            "maxMarks": "1303",
            "percentage": "75.59%",
            "cells": [
              "29",
              "22009990120008",
              "KIRAN",
              "RAM SINGH",
              "985",
              "1303",
              "75.59%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "22009990120009",
            "name": "RITU",
            "fatherName": "SAHAB SINGH",
            "obtainedMarks": "990",
            "maxMarks": "1304",
            "percentage": "75.92%",
            "cells": [
              "30",
              "22009990120009",
              "RITU",
              "SAHAB SINGH",
              "990",
              "1304",
              "75.92%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "22009990120010",
            "name": "PUNITA",
            "fatherName": "HARI RAM",
            "obtainedMarks": "975",
            "maxMarks": "1305",
            "percentage": "74.71%",
            "cells": [
              "31",
              "22009990120010",
              "PUNITA",
              "HARI RAM",
              "975",
              "1305",
              "74.71%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "22009990120011",
            "name": "MANJU",
            "fatherName": "RAM RAKH",
            "obtainedMarks": "1023",
            "maxMarks": "1306",
            "percentage": "78.33%",
            "cells": [
              "32",
              "22009990120011",
              "MANJU",
              "RAM RAKH",
              "1023",
              "1306",
              "78.33%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "22009990120012",
            "name": "SANTOSH",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "920",
            "maxMarks": "1307",
            "percentage": "70.39%",
            "cells": [
              "33",
              "22009990120012",
              "SANTOSH",
              "RAMESH KUMAR",
              "920",
              "1307",
              "70.39%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "22009990120013",
            "name": "SUKHVEER",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "976",
            "maxMarks": "1308",
            "percentage": "74.62%",
            "cells": [
              "34",
              "22009990120013",
              "SUKHVEER",
              "SUKHDEV SINGH",
              "976",
              "1308",
              "74.62%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "22009990120014",
            "name": "NANKI",
            "fatherName": "AJAYAB SINGH",
            "obtainedMarks": "970",
            "maxMarks": "1309",
            "percentage": "74.10%",
            "cells": [
              "35",
              "22009990120014",
              "NANKI",
              "AJAYAB SINGH",
              "970",
              "1309",
              "74.10%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "22009990120015",
            "name": "PHULLSIKANDA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "972",
            "maxMarks": "1310",
            "percentage": "74.20%",
            "cells": [
              "36",
              "22009990120015",
              "PHULLSIKANDA",
              "RAMESH KUMAR",
              "972",
              "1310",
              "74.20%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "22009990120021",
            "name": "MANDEEP",
            "fatherName": "GURDHIYAN SINGH",
            "obtainedMarks": "946",
            "maxMarks": "1311",
            "percentage": "72.16%",
            "cells": [
              "37",
              "22009990120021",
              "MANDEEP",
              "GURDHIYAN SINGH",
              "946",
              "1311",
              "72.16%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A HINDI. II year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "38",
            "rollNo": "21009990120002",
            "name": "MANDEEP",
            "fatherName": "SATPAL",
            "obtainedMarks": "925",
            "maxMarks": "1200",
            "percentage": "77.08%",
            "cells": [
              "38",
              "21009990120002",
              "MANDEEP",
              "SATPAL",
              "925",
              "1200",
              "77.08%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "21009990120004",
            "name": "DAMYANTI",
            "fatherName": "JAI GOPAL",
            "obtainedMarks": "844",
            "maxMarks": "1202",
            "percentage": "70.22%",
            "cells": [
              "39",
              "21009990120004",
              "DAMYANTI",
              "JAI GOPAL",
              "844",
              "1202",
              "70.22%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "21009990120005",
            "name": "POONAM",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "890",
            "maxMarks": "1203",
            "percentage": "73.98%",
            "cells": [
              "40",
              "21009990120005",
              "POONAM",
              "MAHENDER SINGH",
              "890",
              "1203",
              "73.98%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "21009990120006",
            "name": "SAPNA",
            "fatherName": "JAI NARYAN",
            "obtainedMarks": "910",
            "maxMarks": "1204",
            "percentage": "75.58%",
            "cells": [
              "41",
              "21009990120006",
              "SAPNA",
              "JAI NARYAN",
              "910",
              "1204",
              "75.58%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "21009990120009",
            "name": "NEHA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "900",
            "maxMarks": "1205",
            "percentage": "74.69%",
            "cells": [
              "42",
              "21009990120009",
              "NEHA",
              "MADAN LAL",
              "900",
              "1205",
              "74.69%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "21009990120010",
            "name": "SONIA",
            "fatherName": "GURJEET",
            "obtainedMarks": "923",
            "maxMarks": "1206",
            "percentage": "76.53%",
            "cells": [
              "43",
              "21009990120010",
              "SONIA",
              "GURJEET",
              "923",
              "1206",
              "76.53%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "21009990120011",
            "name": "KANTA",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "857",
            "maxMarks": "1207",
            "percentage": "71%",
            "cells": [
              "44",
              "21009990120011",
              "KANTA",
              "RAI SINGH",
              "857",
              "1207",
              "71%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "21009990120014",
            "name": "KUMARI PRITI",
            "fatherName": "ATTAR SINGH",
            "obtainedMarks": "892",
            "maxMarks": "1208",
            "percentage": "73.84%",
            "cells": [
              "45",
              "21009990120014",
              "KUMARI PRITI",
              "ATTAR SINGH",
              "892",
              "1208",
              "73.84%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A English I year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A English 2 year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.Sc Maths. I year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "46",
            "rollNo": "22009993510001",
            "name": "ARJU",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "887",
            "maxMarks": "1250",
            "percentage": "70.96%",
            "cells": [
              "46",
              "22009993510001",
              "ARJU",
              "SURENDER KUMAR",
              "887",
              "1250",
              "70.96%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Sc Maths. II year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.Com. I year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "47",
            "rollNo": "22009990180002",
            "name": "SEFI",
            "fatherName": "SATPAL",
            "obtainedMarks": "882",
            "maxMarks": "1200",
            "percentage": "73.50%",
            "cells": [
              "47",
              "22009990180002",
              "SEFI",
              "SATPAL",
              "882",
              "1200",
              "73.50%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "22009990180006",
            "name": "YASMINE",
            "fatherName": "RAMPAL",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.92%",
            "cells": [
              "48",
              "22009990180006",
              "YASMINE",
              "RAMPAL",
              "863",
              "1200",
              "71.92%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "22009990180010",
            "name": "SIMRAN",
            "fatherName": "KRISHAN LAL",
            "obtainedMarks": "851",
            "maxMarks": "1200",
            "percentage": "70.92%",
            "cells": [
              "49",
              "22009990180010",
              "SIMRAN",
              "KRISHAN LAL",
              "851",
              "1200",
              "70.92%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "22009990180011",
            "name": "SIMRAN",
            "fatherName": "PAWAN",
            "obtainedMarks": "875",
            "maxMarks": "1200",
            "percentage": "72.92%",
            "cells": [
              "50",
              "22009990180011",
              "SIMRAN",
              "PAWAN",
              "875",
              "1200",
              "72.92%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "22009990180012",
            "name": "POOJA",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "855",
            "maxMarks": "1200",
            "percentage": "71.25%",
            "cells": [
              "51",
              "22009990180012",
              "POOJA",
              "HARI SINGH",
              "855",
              "1200",
              "71.25%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "22009990180015",
            "name": "MANPREET",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.92%",
            "cells": [
              "52",
              "22009990180015",
              "MANPREET",
              "AVTAR SINGH",
              "863",
              "1200",
              "71.92%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Com. II year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "53",
            "rollNo": "21009990180002",
            "name": "PRIYNKA",
            "fatherName": "PREM SINGH",
            "obtainedMarks": "1017",
            "maxMarks": "1400",
            "percentage": "72.64%",
            "cells": [
              "53",
              "21009990180002",
              "PRIYNKA",
              "PREM SINGH",
              "1017",
              "1400",
              "72.64%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "21009990180004",
            "name": "MANJU",
            "fatherName": "SOHAN LAL",
            "obtainedMarks": "1071",
            "maxMarks": "1400",
            "percentage": "76.50%",
            "cells": [
              "54",
              "21009990180004",
              "MANJU",
              "SOHAN LAL",
              "1071",
              "1400",
              "76.50%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "21009990180007",
            "name": "POONAM",
            "fatherName": "PALA RAM",
            "obtainedMarks": "1030",
            "maxMarks": "1400",
            "percentage": "73.57%",
            "cells": [
              "55",
              "21009990180007",
              "POONAM",
              "PALA RAM",
              "1030",
              "1400",
              "73.57%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "21009990180010",
            "name": "DEEPIKA",
            "fatherName": "MADHU SUDAN",
            "obtainedMarks": "986",
            "maxMarks": "1400",
            "percentage": "70.43%",
            "cells": [
              "56",
              "21009990180010",
              "DEEPIKA",
              "MADHU SUDAN",
              "986",
              "1400",
              "70.43%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "21009990180012",
            "name": "HARITA",
            "fatherName": "PREM PAL",
            "obtainedMarks": "911",
            "maxMarks": "1400",
            "percentage": "65.07%",
            "cells": [
              "57",
              "21009990180012",
              "HARITA",
              "PREM PAL",
              "911",
              "1400",
              "65.07%"
            ]
          }
        ]
      },
      {
        "courseName": "Bped  I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "58",
            "rollNo": "22009115510002",
            "name": "SILOCHNA",
            "fatherName": "RAMKISHAN",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "58",
              "22009115510002",
              "SILOCHNA",
              "RAMKISHAN",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "22009115510003",
            "name": "RUBY",
            "fatherName": "JAGWANT",
            "obtainedMarks": "1268",
            "maxMarks": "1600",
            "percentage": "79.25%",
            "cells": [
              "59",
              "22009115510003",
              "RUBY",
              "JAGWANT",
              "1268",
              "1600",
              "79.25%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "22009115510005",
            "name": "NIKITA",
            "fatherName": "VIRENDRA SINGH",
            "obtainedMarks": "1268",
            "maxMarks": "1600",
            "percentage": "79.25%",
            "cells": [
              "60",
              "22009115510005",
              "NIKITA",
              "VIRENDRA SINGH",
              "1268",
              "1600",
              "79.25%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "22009115510006",
            "name": "KIRAN",
            "fatherName": "DAYAL SINGH",
            "obtainedMarks": "1255",
            "maxMarks": "1600",
            "percentage": "78.44%",
            "cells": [
              "61",
              "22009115510006",
              "KIRAN",
              "DAYAL SINGH",
              "1255",
              "1600",
              "78.44%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "22009115510007",
            "name": "PREETI",
            "fatherName": "PRATAP SINGH",
            "obtainedMarks": "1231",
            "maxMarks": "1600",
            "percentage": "76.94%",
            "cells": [
              "62",
              "22009115510007",
              "PREETI",
              "PRATAP SINGH",
              "1231",
              "1600",
              "76.94%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "22009115510008",
            "name": "POONAM",
            "fatherName": "DINESH KUMAR",
            "obtainedMarks": "1216",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "63",
              "22009115510008",
              "POONAM",
              "DINESH KUMAR",
              "1216",
              "1600",
              "76%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "22009115510009",
            "name": "SUMANDEEP",
            "fatherName": "JAGSEER RAM",
            "obtainedMarks": "1182",
            "maxMarks": "1600",
            "percentage": "73.88%",
            "cells": [
              "64",
              "22009115510009",
              "SUMANDEEP",
              "JAGSEER RAM",
              "1182",
              "1600",
              "73.88%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "22009115510010",
            "name": "PARVIN",
            "fatherName": "KRISHAN",
            "obtainedMarks": "1144",
            "maxMarks": "1600",
            "percentage": "71.50%",
            "cells": [
              "65",
              "22009115510010",
              "PARVIN",
              "KRISHAN",
              "1144",
              "1600",
              "71.50%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "22009115510011",
            "name": "PRIYANKA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "1302",
            "maxMarks": "1600",
            "percentage": "81.38%",
            "cells": [
              "66",
              "22009115510011",
              "PRIYANKA",
              "SUBHASH CHANDER",
              "1302",
              "1600",
              "81.38%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "22009115510012",
            "name": "KOMEL KANWAR",
            "fatherName": "FETEH SINGH",
            "obtainedMarks": "1177",
            "maxMarks": "1600",
            "percentage": "73.56%",
            "cells": [
              "67",
              "22009115510012",
              "KOMEL KANWAR",
              "FETEH SINGH",
              "1177",
              "1600",
              "73.56%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "22009115510013",
            "name": "MAMTA",
            "fatherName": "BHIM  SINGH",
            "obtainedMarks": "1216",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "68",
              "22009115510013",
              "MAMTA",
              "BHIM  SINGH",
              "1216",
              "1600",
              "76%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "22009115510014",
            "name": "SEEMA",
            "fatherName": "SATYAWAN",
            "obtainedMarks": "1234",
            "maxMarks": "1600",
            "percentage": "77.12%",
            "cells": [
              "69",
              "22009115510014",
              "SEEMA",
              "SATYAWAN",
              "1234",
              "1600",
              "77.12%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "22009115510015",
            "name": "MONIKA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "1290",
            "maxMarks": "1600",
            "percentage": "80.62%",
            "cells": [
              "70",
              "22009115510015",
              "MONIKA",
              "VIJAY SINGH",
              "1290",
              "1600",
              "80.62%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "22009115510016",
            "name": "ANSHIKA",
            "fatherName": "YASH VEER",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "71",
              "22009115510016",
              "ANSHIKA",
              "YASH VEER",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "22009115510017",
            "name": "AMARJEET KAUR",
            "fatherName": "SITA RAM",
            "obtainedMarks": "1287",
            "maxMarks": "1600",
            "percentage": "80.44%",
            "cells": [
              "72",
              "22009115510017",
              "AMARJEET KAUR",
              "SITA RAM",
              "1287",
              "1600",
              "80.44%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "22009115510018",
            "name": "PRIYNKA",
            "fatherName": "ROSHAN LAL",
            "obtainedMarks": "1273",
            "maxMarks": "1600",
            "percentage": "79.56%",
            "cells": [
              "73",
              "22009115510018",
              "PRIYNKA",
              "ROSHAN LAL",
              "1273",
              "1600",
              "79.56%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "22009115510019",
            "name": "SUMAN DEVI",
            "fatherName": "CHHABIL DASS",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "74",
              "22009115510019",
              "SUMAN DEVI",
              "CHHABIL DASS",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "22009115510020",
            "name": "SUMAN VERMA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1253",
            "maxMarks": "1600",
            "percentage": "78.31%",
            "cells": [
              "75",
              "22009115510020",
              "SUMAN VERMA",
              "OM PARKASH",
              "1253",
              "1600",
              "78.31%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "22009115510021",
            "name": "MANITA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1235",
            "maxMarks": "1600",
            "percentage": "77.19%",
            "cells": [
              "76",
              "22009115510021",
              "MANITA",
              "SURESH KUMAR",
              "1235",
              "1600",
              "77.19%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "22009115510023",
            "name": "SANDEEP RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "1235",
            "maxMarks": "1600",
            "percentage": "77.19%",
            "cells": [
              "77",
              "22009115510023",
              "SANDEEP RANI",
              "GOPAL",
              "1235",
              "1600",
              "77.19%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "22009115510024",
            "name": "POONAM",
            "fatherName": "SURENDER",
            "obtainedMarks": "1224",
            "maxMarks": "1600",
            "percentage": "76.50%",
            "cells": [
              "78",
              "22009115510024",
              "POONAM",
              "SURENDER",
              "1224",
              "1600",
              "76.50%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "22009115510025",
            "name": "MUNISHA RANI",
            "fatherName": "MANSA SINGH",
            "obtainedMarks": "1264",
            "maxMarks": "1600",
            "percentage": "79%",
            "cells": [
              "79",
              "22009115510025",
              "MUNISHA RANI",
              "MANSA SINGH",
              "1264",
              "1600",
              "79%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "22009115510026",
            "name": "PRIYANKA",
            "fatherName": "BIHARI LAL",
            "obtainedMarks": "1242",
            "maxMarks": "1600",
            "percentage": "77.62%",
            "cells": [
              "80",
              "22009115510026",
              "PRIYANKA",
              "BIHARI LAL",
              "1242",
              "1600",
              "77.62%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "22009115510027",
            "name": "POOJA",
            "fatherName": "SHER SINGH",
            "obtainedMarks": "1222",
            "maxMarks": "1600",
            "percentage": "76.38%",
            "cells": [
              "81",
              "22009115510027",
              "POOJA",
              "SHER SINGH",
              "1222",
              "1600",
              "76.38%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "22009115510028",
            "name": "RAVINA",
            "fatherName": "SUBHASH",
            "obtainedMarks": "1259",
            "maxMarks": "1600",
            "percentage": "78.69%",
            "cells": [
              "82",
              "22009115510028",
              "RAVINA",
              "SUBHASH",
              "1259",
              "1600",
              "78.69%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "22009115510029",
            "name": "SIMAKSHI",
            "fatherName": "RAMESH",
            "obtainedMarks": "1155",
            "maxMarks": "1600",
            "percentage": "72.19%",
            "cells": [
              "83",
              "22009115510029",
              "SIMAKSHI",
              "RAMESH",
              "1155",
              "1600",
              "72.19%"
            ]
          }
        ]
      },
      {
        "courseName": "Bped  II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "Total Obt. Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "84",
            "rollNo": "21009115510001",
            "name": "Manju Rani",
            "fatherName": "Randhir Singh",
            "obtainedMarks": "1273",
            "maxMarks": "1600",
            "percentage": "79.56%",
            "cells": [
              "84",
              "21009115510001",
              "Manju Rani",
              "Randhir Singh",
              "1273",
              "1600",
              "79.56%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "21009115510002",
            "name": "Harbans Kaur",
            "fatherName": "Manjor Singh",
            "obtainedMarks": "1250",
            "maxMarks": "1600",
            "percentage": "78.12%",
            "cells": [
              "85",
              "21009115510002",
              "Harbans Kaur",
              "Manjor Singh",
              "1250",
              "1600",
              "78.12%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "21009115510003",
            "name": "Anu",
            "fatherName": "Hari Singh",
            "obtainedMarks": "1149",
            "maxMarks": "1600",
            "percentage": "71.81%",
            "cells": [
              "86",
              "21009115510003",
              "Anu",
              "Hari Singh",
              "1149",
              "1600",
              "71.81%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "21009115510004",
            "name": "Ritu",
            "fatherName": "Jaibir Singh",
            "obtainedMarks": "1206",
            "maxMarks": "1600",
            "percentage": "75.38%",
            "cells": [
              "87",
              "21009115510004",
              "Ritu",
              "Jaibir Singh",
              "1206",
              "1600",
              "75.38%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "21009115510005",
            "name": "Laxmi Rani",
            "fatherName": "Gopal",
            "obtainedMarks": "1170",
            "maxMarks": "1600",
            "percentage": "73.12%",
            "cells": [
              "88",
              "21009115510005",
              "Laxmi Rani",
              "Gopal",
              "1170",
              "1600",
              "73.12%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "21009115510006",
            "name": "Poonam Rani",
            "fatherName": "Surjeet",
            "obtainedMarks": "1240",
            "maxMarks": "1600",
            "percentage": "77.50%",
            "cells": [
              "89",
              "21009115510006",
              "Poonam Rani",
              "Surjeet",
              "1240",
              "1600",
              "77.50%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "21009115510007",
            "name": "Jyoti",
            "fatherName": "Karan Singh",
            "obtainedMarks": "1261",
            "maxMarks": "1600",
            "percentage": "78.81%",
            "cells": [
              "90",
              "21009115510007",
              "Jyoti",
              "Karan Singh",
              "1261",
              "1600",
              "78.81%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "21009115510008",
            "name": "Amandeep Kaur",
            "fatherName": "Iqbal Singh",
            "obtainedMarks": "1281",
            "maxMarks": "1600",
            "percentage": "80.06%",
            "cells": [
              "91",
              "21009115510008",
              "Amandeep Kaur",
              "Iqbal Singh",
              "1281",
              "1600",
              "80.06%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "21009115510009",
            "name": "Poonam",
            "fatherName": "Shankar Lal",
            "obtainedMarks": "1166",
            "maxMarks": "1600",
            "percentage": "72.88%",
            "cells": [
              "92",
              "21009115510009",
              "Poonam",
              "Shankar Lal",
              "1166",
              "1600",
              "72.88%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "21009115510010",
            "name": "Nisha",
            "fatherName": "Raj Kumar",
            "obtainedMarks": "1229",
            "maxMarks": "1600",
            "percentage": "76.81%",
            "cells": [
              "93",
              "21009115510010",
              "Nisha",
              "Raj Kumar",
              "1229",
              "1600",
              "76.81%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "21009115510011",
            "name": "Deepanshi",
            "fatherName": "Daulat Ram",
            "obtainedMarks": "1143",
            "maxMarks": "1600",
            "percentage": "71.44%",
            "cells": [
              "94",
              "21009115510011",
              "Deepanshi",
              "Daulat Ram",
              "1143",
              "1600",
              "71.44%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "21009115510013",
            "name": "Amrita Kumari",
            "fatherName": "Elis Garg",
            "obtainedMarks": "1245",
            "maxMarks": "1600",
            "percentage": "77.81%",
            "cells": [
              "95",
              "21009115510013",
              "Amrita Kumari",
              "Elis Garg",
              "1245",
              "1600",
              "77.81%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "21009115510014",
            "name": "Ravina",
            "fatherName": "Krishnan Chandar",
            "obtainedMarks": "1193",
            "maxMarks": "1600",
            "percentage": "74.56%",
            "cells": [
              "96",
              "21009115510014",
              "Ravina",
              "Krishnan Chandar",
              "1193",
              "1600",
              "74.56%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "21009115510015",
            "name": "Monika",
            "fatherName": "Ramniwas Poonia",
            "obtainedMarks": "1217",
            "maxMarks": "1600",
            "percentage": "76.06%",
            "cells": [
              "97",
              "21009115510015",
              "Monika",
              "Ramniwas Poonia",
              "1217",
              "1600",
              "76.06%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "21009115510016",
            "name": "Nisha Devi",
            "fatherName": "Vijay Singh",
            "obtainedMarks": "1204",
            "maxMarks": "1600",
            "percentage": "75.25%",
            "cells": [
              "98",
              "21009115510016",
              "Nisha Devi",
              "Vijay Singh",
              "1204",
              "1600",
              "75.25%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "21009115510017",
            "name": "Vimal Kumari",
            "fatherName": "Ram Swaroop",
            "obtainedMarks": "1232",
            "maxMarks": "1600",
            "percentage": "77%",
            "cells": [
              "99",
              "21009115510017",
              "Vimal Kumari",
              "Ram Swaroop",
              "1232",
              "1600",
              "77%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "21009115510018",
            "name": "Rachna",
            "fatherName": "Tota Ram",
            "obtainedMarks": "1139",
            "maxMarks": "1600",
            "percentage": "71.19%",
            "cells": [
              "100",
              "21009115510018",
              "Rachna",
              "Tota Ram",
              "1139",
              "1600",
              "71.19%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "21009115510019",
            "name": "Kavita",
            "fatherName": "Hansraj",
            "obtainedMarks": "1135",
            "maxMarks": "1600",
            "percentage": "70.94%",
            "cells": [
              "101",
              "21009115510019",
              "Kavita",
              "Hansraj",
              "1135",
              "1600",
              "70.94%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "21009115510020",
            "name": "Nitu",
            "fatherName": "Brij Lal",
            "obtainedMarks": "1122",
            "maxMarks": "1600",
            "percentage": "70.12%",
            "cells": [
              "102",
              "21009115510020",
              "Nitu",
              "Brij Lal",
              "1122",
              "1600",
              "70.12%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "21009115510022",
            "name": "Sharda",
            "fatherName": "Maniram Kaswan",
            "obtainedMarks": "1228",
            "maxMarks": "1600",
            "percentage": "76.75%",
            "cells": [
              "103",
              "21009115510022",
              "Sharda",
              "Maniram Kaswan",
              "1228",
              "1600",
              "76.75%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "21009115510023",
            "name": "Saroj",
            "fatherName": "Banwari lal",
            "obtainedMarks": "1143",
            "maxMarks": "1600",
            "percentage": "71.44%",
            "cells": [
              "104",
              "21009115510023",
              "Saroj",
              "Banwari lal",
              "1143",
              "1600",
              "71.44%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "21009115510024",
            "name": "Susheel",
            "fatherName": "Satpal",
            "obtainedMarks": "1182",
            "maxMarks": "1600",
            "percentage": "73.88%",
            "cells": [
              "105",
              "21009115510024",
              "Susheel",
              "Satpal",
              "1182",
              "1600",
              "73.88%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "21009115510025",
            "name": "Kiranpreet",
            "fatherName": "Balkaran Singh",
            "obtainedMarks": "1158",
            "maxMarks": "1600",
            "percentage": "72.38%",
            "cells": [
              "106",
              "21009115510025",
              "Kiranpreet",
              "Balkaran Singh",
              "1158",
              "1600",
              "72.38%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "21009115510027",
            "name": "Beant Kaur",
            "fatherName": "Sohan Singh",
            "obtainedMarks": "1126",
            "maxMarks": "1600",
            "percentage": "70.38%",
            "cells": [
              "107",
              "21009115510027",
              "Beant Kaur",
              "Sohan Singh",
              "1126",
              "1600",
              "70.38%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "21009115510028",
            "name": "Sanju Jakhar",
            "fatherName": "Ishwar Singh",
            "obtainedMarks": "1183",
            "maxMarks": "1600",
            "percentage": "73.94%",
            "cells": [
              "108",
              "21009115510028",
              "Sanju Jakhar",
              "Ishwar Singh",
              "1183",
              "1600",
              "73.94%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "21009115510030",
            "name": "Sonia",
            "fatherName": "Krishnan Kumar",
            "obtainedMarks": "1266",
            "maxMarks": "1600",
            "percentage": "79.12%",
            "cells": [
              "109",
              "21009115510030",
              "Sonia",
              "Krishnan Kumar",
              "1266",
              "1600",
              "79.12%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "21009115510031",
            "name": "Kiran Deep",
            "fatherName": "Makkhan Singh",
            "obtainedMarks": "1138",
            "maxMarks": "1600",
            "percentage": "71.12%",
            "cells": [
              "110",
              "21009115510031",
              "Kiran Deep",
              "Makkhan Singh",
              "1138",
              "1600",
              "71.12%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "21009115510032",
            "name": "Anshul",
            "fatherName": "Joginder Singh",
            "obtainedMarks": "1173",
            "maxMarks": "1600",
            "percentage": "73.31%",
            "cells": [
              "111",
              "21009115510032",
              "Anshul",
              "Joginder Singh",
              "1173",
              "1600",
              "73.31%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "21009115510034",
            "name": "Anju Bala",
            "fatherName": "Bansi Lal",
            "obtainedMarks": "1278",
            "maxMarks": "1600",
            "percentage": "79.88%",
            "cells": [
              "112",
              "21009115510034",
              "Anju Bala",
              "Bansi Lal",
              "1278",
              "1600",
              "79.88%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "21009115510035",
            "name": "Vaishnavi Sharma",
            "fatherName": "Sarvottam Sharma",
            "obtainedMarks": "1240",
            "maxMarks": "1600",
            "percentage": "77.50%",
            "cells": [
              "113",
              "21009115510035",
              "Vaishnavi Sharma",
              "Sarvottam Sharma",
              "1240",
              "1600",
              "77.50%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "21009115510037",
            "name": "Kirti Insan",
            "fatherName": "Rulda Ram",
            "obtainedMarks": "1326",
            "maxMarks": "1600",
            "percentage": "82.88%",
            "cells": [
              "114",
              "21009115510037",
              "Kirti Insan",
              "Rulda Ram",
              "1326",
              "1600",
              "82.88%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "21009115510039",
            "name": "Parameshwari",
            "fatherName": "Mahender Singh",
            "obtainedMarks": "1200",
            "maxMarks": "1600",
            "percentage": "75%",
            "cells": [
              "115",
              "21009115510039",
              "Parameshwari",
              "Mahender Singh",
              "1200",
              "1600",
              "75%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "21009115510040",
            "name": "Usha",
            "fatherName": "Rohtash",
            "obtainedMarks": "1203",
            "maxMarks": "1600",
            "percentage": "75.19%",
            "cells": [
              "116",
              "21009115510040",
              "Usha",
              "Rohtash",
              "1203",
              "1600",
              "75.19%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "21009115510041",
            "name": "Komal",
            "fatherName": "Sukhbir Singh",
            "obtainedMarks": "1248",
            "maxMarks": "1600",
            "percentage": "78%",
            "cells": [
              "117",
              "21009115510041",
              "Komal",
              "Sukhbir Singh",
              "1248",
              "1600",
              "78%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "21009115510042",
            "name": "Pooja",
            "fatherName": "Balwant",
            "obtainedMarks": "1248",
            "maxMarks": "1600",
            "percentage": "78%",
            "cells": [
              "118",
              "21009115510042",
              "Pooja",
              "Balwant",
              "1248",
              "1600",
              "78%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "21009115510043",
            "name": "Savita",
            "fatherName": "Mahender Pal",
            "obtainedMarks": "1309",
            "maxMarks": "1600",
            "percentage": "81.81%",
            "cells": [
              "119",
              "21009115510043",
              "Savita",
              "Mahender Pal",
              "1309",
              "1600",
              "81.81%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "21009115510047",
            "name": "Kavita",
            "fatherName": "Shri Ram",
            "obtainedMarks": "1231",
            "maxMarks": "1600",
            "percentage": "76.94%",
            "cells": [
              "120",
              "21009115510047",
              "Kavita",
              "Shri Ram",
              "1231",
              "1600",
              "76.94%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "21009115510048",
            "name": "Kiran",
            "fatherName": "Krishan Kumar",
            "obtainedMarks": "1179",
            "maxMarks": "1600",
            "percentage": "73.69%",
            "cells": [
              "121",
              "21009115510048",
              "Kiran",
              "Krishan Kumar",
              "1179",
              "1600",
              "73.69%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2023-24",
    "courses": [
      {
        "courseName": "B.Sc.  NM & CS  I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "23009115442006",
            "name": "MONIKA",
            "fatherName": "INDRAJ",
            "obtainedMarks": "935",
            "maxMarks": "1175",
            "percentage": "79.57%",
            "cells": [
              "1",
              "23009115442006",
              "MONIKA",
              "INDRAJ",
              "935",
              "1175",
              "79.57%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "23009115442009",
            "name": "SIMRATPAL KAUR",
            "fatherName": "VEER SINGH",
            "obtainedMarks": "882",
            "maxMarks": "1175",
            "percentage": "75.06%",
            "cells": [
              "2",
              "23009115442009",
              "SIMRATPAL KAUR",
              "VEER SINGH",
              "882",
              "1175",
              "75.06%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "23009115442010",
            "name": "GEETA RANI",
            "fatherName": "SHISHPAL",
            "obtainedMarks": "872",
            "maxMarks": "1175",
            "percentage": "74.21%",
            "cells": [
              "3",
              "23009115442010",
              "GEETA RANI",
              "SHISHPAL",
              "872",
              "1175",
              "74.21%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "23009115442016",
            "name": "KRITIKA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "989",
            "maxMarks": "1175",
            "percentage": "84.17%",
            "cells": [
              "4",
              "23009115442016",
              "KRITIKA",
              "RAJESH KUMAR",
              "989",
              "1175",
              "84.17%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "23009115442017",
            "name": "POONAM",
            "fatherName": "JAIN",
            "obtainedMarks": "858",
            "maxMarks": "1175",
            "percentage": "73.02%",
            "cells": [
              "5",
              "23009115442017",
              "POONAM",
              "JAIN",
              "858",
              "1175",
              "73.02%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "23009115442019",
            "name": "MANISHA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "867",
            "maxMarks": "1175",
            "percentage": "73.78%",
            "cells": [
              "6",
              "23009115442019",
              "MANISHA",
              "KRISHAN KUMAR",
              "867",
              "1175",
              "73.78%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "23009115442023",
            "name": "SAVITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "823",
            "maxMarks": "1050",
            "percentage": "78.38%",
            "cells": [
              "7",
              "23009115442023",
              "SAVITA",
              "RAMESH KUMAR",
              "823",
              "1050",
              "78.38%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "23009115442030",
            "name": "KIRATPREET KAUR",
            "fatherName": "CHHAMANDEEP SINGH",
            "obtainedMarks": "838",
            "maxMarks": "1050",
            "percentage": "79.80%",
            "cells": [
              "8",
              "23009115442030",
              "KIRATPREET KAUR",
              "CHHAMANDEEP SINGH",
              "838",
              "1050",
              "79.80%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Sc.  NM & CS  II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "9",
            "rollNo": "22009115442009",
            "name": "MANJOT INSAN",
            "fatherName": "MEWA RAM",
            "obtainedMarks": "834",
            "maxMarks": "1100",
            "percentage": "75.81%",
            "cells": [
              "9",
              "22009115442009",
              "MANJOT INSAN",
              "MEWA RAM",
              "834",
              "1100",
              "75.81%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "22009115442014",
            "name": "MUSKAN",
            "fatherName": "SATISH",
            "obtainedMarks": "784",
            "maxMarks": "1100",
            "percentage": "71.27%",
            "cells": [
              "10",
              "22009115442014",
              "MUSKAN",
              "SATISH",
              "784",
              "1100",
              "71.27%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "22009115442027",
            "name": "HARMANDEEP KAUR",
            "fatherName": "KULWINDER SINGH",
            "obtainedMarks": "910",
            "maxMarks": "1100",
            "percentage": "82.72%",
            "cells": [
              "11",
              "22009115442027",
              "HARMANDEEP KAUR",
              "KULWINDER SINGH",
              "910",
              "1100",
              "82.72%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "22009115442031",
            "name": "RABINA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "811",
            "maxMarks": "1100",
            "percentage": "73.72%",
            "cells": [
              "12",
              "22009115442031",
              "RABINA",
              "RAJESH KUMAR",
              "811",
              "1100",
              "73.72%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "22009115442033",
            "name": "KIRNA",
            "fatherName": "KRISHAN LAL",
            "obtainedMarks": "777",
            "maxMarks": "1100",
            "percentage": "70.63%",
            "cells": [
              "13",
              "22009115442033",
              "KIRNA",
              "KRISHAN LAL",
              "777",
              "1100",
              "70.63%"
            ]
          }
        ]
      },
      {
        "courseName": "B.SC  NM & CS  III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "14",
            "rollNo": "21009115442001",
            "name": "JYOTI",
            "fatherName": "MAHABIR",
            "obtainedMarks": "773",
            "maxMarks": "1000",
            "percentage": "77.30%",
            "cells": [
              "14",
              "21009115442001",
              "JYOTI",
              "MAHABIR",
              "773",
              "1000",
              "77.30%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "21009115442041",
            "name": "LAKSHIKA",
            "fatherName": "RAJBIR",
            "obtainedMarks": "740",
            "maxMarks": "1000",
            "percentage": "74%",
            "cells": [
              "15",
              "21009115442041",
              "LAKSHIKA",
              "RAJBIR",
              "740",
              "1000",
              "74%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "21009115442036",
            "name": "NEERU",
            "fatherName": "RAJBIR",
            "obtainedMarks": "723",
            "maxMarks": "1000",
            "percentage": "72.30%",
            "cells": [
              "16",
              "21009115442036",
              "NEERU",
              "RAJBIR",
              "723",
              "1000",
              "72.30%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "21009115442046",
            "name": "EKTA",
            "fatherName": "SADHU RAM",
            "obtainedMarks": "763",
            "maxMarks": "1000",
            "percentage": "76.30%",
            "cells": [
              "17",
              "21009115442046",
              "EKTA",
              "SADHU RAM",
              "763",
              "1000",
              "76.30%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "21009115442047",
            "name": "PRIYANKA",
            "fatherName": "BALDEV SINGH",
            "obtainedMarks": "799",
            "maxMarks": "1000",
            "percentage": "79.90%",
            "cells": [
              "18",
              "21009115442047",
              "PRIYANKA",
              "BALDEV SINGH",
              "799",
              "1000",
              "79.90%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA  I Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "BBA  II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "19",
            "rollNo": "22009115480019",
            "name": "POONAM",
            "fatherName": "SATVIR",
            "obtainedMarks": "1004",
            "maxMarks": "1350",
            "percentage": "74.37%",
            "cells": [
              "19",
              "22009115480019",
              "POONAM",
              "SATVIR",
              "1004",
              "1350",
              "74.37%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "22009115480022",
            "name": "MEHAK TANEJA",
            "fatherName": "SANT LAL",
            "obtainedMarks": "1015",
            "maxMarks": "1350",
            "percentage": "75.19%",
            "cells": [
              "20",
              "22009115480022",
              "MEHAK TANEJA",
              "SANT LAL",
              "1015",
              "1350",
              "75.19%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA  III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "21",
            "rollNo": "21009115480007",
            "name": "BASAL",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "1074",
            "maxMarks": "1450",
            "percentage": "74.07%",
            "cells": [
              "21",
              "21009115480007",
              "BASAL",
              "BALWAN SINGH",
              "1074",
              "1450",
              "74.07%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "21009115480009",
            "name": "VAISAHLI",
            "fatherName": "JAI PARKASH",
            "obtainedMarks": "1098",
            "maxMarks": "1450",
            "percentage": "75.72%",
            "cells": [
              "22",
              "21009115480009",
              "VAISAHLI",
              "JAI PARKASH",
              "1098",
              "1450",
              "75.72%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "21009115480010",
            "name": "KUDRAT BANO",
            "fatherName": "VEDPARKASH",
            "obtainedMarks": "1078",
            "maxMarks": "1450",
            "percentage": "74.34%",
            "cells": [
              "23",
              "21009115480010",
              "KUDRAT BANO",
              "VEDPARKASH",
              "1078",
              "1450",
              "74.34%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "21009115480022",
            "name": "SONIA",
            "fatherName": "DHARAM RAJ",
            "obtainedMarks": "1148",
            "maxMarks": "1450",
            "percentage": "79.17%",
            "cells": [
              "24",
              "21009115480022",
              "SONIA",
              "DHARAM RAJ",
              "1148",
              "1450",
              "79.17%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.VOC. I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "25",
            "rollNo": "23009115460006",
            "name": "ANAMI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "866",
            "maxMarks": "1150",
            "percentage": "75.30%",
            "cells": [
              "25",
              "23009115460006",
              "ANAMI",
              "VIJAY KUMAR",
              "866",
              "1150",
              "75.30%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "23009115460010",
            "name": "VARSHA",
            "fatherName": "RAMNIWAS",
            "obtainedMarks": "817",
            "maxMarks": "1150",
            "percentage": "71.04%",
            "cells": [
              "26",
              "23009115460010",
              "VARSHA",
              "RAMNIWAS",
              "817",
              "1150",
              "71.04%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "23009115460011",
            "name": "ANKITA",
            "fatherName": "PARDEEP KUMAR",
            "obtainedMarks": "826",
            "maxMarks": "1150",
            "percentage": "71.82%",
            "cells": [
              "27",
              "23009115460011",
              "ANKITA",
              "PARDEEP KUMAR",
              "826",
              "1150",
              "71.82%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.VOC. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "28",
            "rollNo": "22009115460001",
            "name": "MAHAK",
            "fatherName": "AMANDEEP",
            "obtainedMarks": "883",
            "maxMarks": "1250",
            "percentage": "70.64%",
            "cells": [
              "28",
              "22009115460001",
              "MAHAK",
              "AMANDEEP",
              "883",
              "1250",
              "70.64%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "22009115460002",
            "name": "RIYA RANI",
            "fatherName": "NIRMEL SINGH",
            "obtainedMarks": "903",
            "maxMarks": "1250",
            "percentage": "72.24%",
            "cells": [
              "29",
              "22009115460002",
              "RIYA RANI",
              "NIRMEL SINGH",
              "903",
              "1250",
              "72.24%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "22009115460003",
            "name": "HIMANSHI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "1057",
            "maxMarks": "1250",
            "percentage": "84.56%",
            "cells": [
              "30",
              "22009115460003",
              "HIMANSHI",
              "VIJAY KUMAR",
              "1057",
              "1250",
              "84.56%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "22009115460010",
            "name": "KANCHAN BALA",
            "fatherName": "KISHOR KUMAR SHARMA",
            "obtainedMarks": "946",
            "maxMarks": "1250",
            "percentage": "75.68%",
            "cells": [
              "31",
              "22009115460010",
              "KANCHAN BALA",
              "KISHOR KUMAR SHARMA",
              "946",
              "1250",
              "75.68%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "22009115460013",
            "name": "REKHA RANI",
            "fatherName": "GOPI RAM",
            "obtainedMarks": "926",
            "maxMarks": "1250",
            "percentage": "74.08%",
            "cells": [
              "32",
              "22009115460013",
              "REKHA RANI",
              "GOPI RAM",
              "926",
              "1250",
              "74.08%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "22009115460014",
            "name": "REKHA",
            "fatherName": "ROHTASH",
            "obtainedMarks": "915",
            "maxMarks": "1250",
            "percentage": "73.20%",
            "cells": [
              "33",
              "22009115460014",
              "REKHA",
              "ROHTASH",
              "915",
              "1250",
              "73.20%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "22009115460015",
            "name": "SHAFALI GARG",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "1011",
            "maxMarks": "1250",
            "percentage": "80.88%",
            "cells": [
              "34",
              "22009115460015",
              "SHAFALI GARG",
              "SUNIL KUMAR",
              "1011",
              "1250",
              "80.88%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.VOC. III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "35",
            "rollNo": "21009115460008",
            "name": "POOJA",
            "fatherName": "RAKESH",
            "obtainedMarks": "914",
            "maxMarks": "1250",
            "percentage": "73.12%",
            "cells": [
              "35",
              "21009115460008",
              "POOJA",
              "RAKESH",
              "914",
              "1250",
              "73.12%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "21009115460010",
            "name": "AMBIKA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "884",
            "maxMarks": "1250",
            "percentage": "70.72%",
            "cells": [
              "36",
              "21009115460010",
              "AMBIKA",
              "OM PARKASH",
              "884",
              "1250",
              "70.72%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "21009115460012",
            "name": "PREETI RANI",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "889",
            "maxMarks": "1250",
            "percentage": "71.92%",
            "cells": [
              "37",
              "21009115460012",
              "PREETI RANI",
              "VIJAY SINGH",
              "889",
              "1250",
              "71.92%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "21009115460013",
            "name": "POOJA",
            "fatherName": "SURJEET SINGH",
            "obtainedMarks": "1010",
            "maxMarks": "1250",
            "percentage": "80.80%",
            "cells": [
              "38",
              "21009115460013",
              "POOJA",
              "SURJEET SINGH",
              "1010",
              "1250",
              "80.80%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.GEN. I Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "39",
            "rollNo": "23009115450001",
            "name": "JASMINE",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "956",
            "maxMarks": "1150",
            "percentage": "83.13%",
            "cells": [
              "39",
              "23009115450001",
              "JASMINE",
              "SURINDER KUMAR",
              "956",
              "1150",
              "83.13%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "23009115450007",
            "name": "ALISHA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "865",
            "maxMarks": "1150",
            "percentage": "75.21%",
            "cells": [
              "40",
              "23009115450007",
              "ALISHA",
              "RAJ KUMAR",
              "865",
              "1150",
              "75.21%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "23009115450014",
            "name": "POOJA RANI",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "883",
            "maxMarks": "1150",
            "percentage": "76.78%",
            "cells": [
              "41",
              "23009115450014",
              "POOJA RANI",
              "RAM SINGH",
              "883",
              "1150",
              "76.78%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "23009115450018",
            "name": "RIMPI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "890",
            "maxMarks": "1150",
            "percentage": "77.39%",
            "cells": [
              "42",
              "23009115450018",
              "RIMPI",
              "SURENDER KUMAR",
              "890",
              "1150",
              "77.39%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "23009115450019",
            "name": "POOJA",
            "fatherName": "MOHIT",
            "obtainedMarks": "927",
            "maxMarks": "1150",
            "percentage": "80.60%",
            "cells": [
              "43",
              "23009115450019",
              "POOJA",
              "MOHIT",
              "927",
              "1150",
              "80.60%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.GEN. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "44",
            "rollNo": "22009115450004",
            "name": "KOMAL",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "891",
            "maxMarks": "1250",
            "percentage": "71.28%",
            "cells": [
              "44",
              "22009115450004",
              "KOMAL",
              "BANSI LAL",
              "891",
              "1250",
              "71.28%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "22009115450014",
            "name": "TEJINDER KAUR",
            "fatherName": "CHAMKOUR SINGH",
            "obtainedMarks": "954",
            "maxMarks": "1250",
            "percentage": "76.32%",
            "cells": [
              "45",
              "22009115450014",
              "TEJINDER KAUR",
              "CHAMKOUR SINGH",
              "954",
              "1250",
              "76.32%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "22009115450016",
            "name": "BHOOMI TYAGI",
            "fatherName": "DEVENDER",
            "obtainedMarks": "921",
            "maxMarks": "1250",
            "percentage": "73.68%",
            "cells": [
              "46",
              "22009115450016",
              "BHOOMI TYAGI",
              "DEVENDER",
              "921",
              "1250",
              "73.68%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "22009115450020",
            "name": "SIMRANJOT KAUR",
            "fatherName": "RANVEER SINGH",
            "obtainedMarks": "959",
            "maxMarks": "1250",
            "percentage": "76.72%",
            "cells": [
              "47",
              "22009115450020",
              "SIMRANJOT KAUR",
              "RANVEER SINGH",
              "959",
              "1250",
              "76.72%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "22009115450021",
            "name": "BALJOT KAUR",
            "fatherName": "RANVEER SINGH",
            "obtainedMarks": "963",
            "maxMarks": "1250",
            "percentage": "77.04%",
            "cells": [
              "48",
              "22009115450021",
              "BALJOT KAUR",
              "RANVEER SINGH",
              "963",
              "1250",
              "77.04%"
            ]
          }
        ]
      },
      {
        "courseName": "B.Com. Gen.  III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "49",
            "rollNo": "21009115450001",
            "name": "PARAMJEET KAUR",
            "fatherName": "MAHINDERPAL",
            "obtainedMarks": "881",
            "maxMarks": "1200",
            "percentage": "73.41%",
            "cells": [
              "49",
              "21009115450001",
              "PARAMJEET KAUR",
              "MAHINDERPAL",
              "881",
              "1200",
              "73.41%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "21009115450005",
            "name": "SUMAN",
            "fatherName": "MAHENDER PAL",
            "obtainedMarks": "949",
            "maxMarks": "1200",
            "percentage": "79.08%",
            "cells": [
              "50",
              "21009115450005",
              "SUMAN",
              "MAHENDER PAL",
              "949",
              "1200",
              "79.08%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "21009115450006",
            "name": "KANISHA",
            "fatherName": "BHIM SAIN",
            "obtainedMarks": "982",
            "maxMarks": "1200",
            "percentage": "81.83%",
            "cells": [
              "51",
              "21009115450006",
              "KANISHA",
              "BHIM SAIN",
              "982",
              "1200",
              "81.83%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "21009115450012",
            "name": "SURYA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "972",
            "maxMarks": "1200",
            "percentage": "81%",
            "cells": [
              "52",
              "21009115450012",
              "SURYA",
              "SUBHASH CHANDER",
              "972",
              "1200",
              "81%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "21009115450014",
            "name": "RITIKA",
            "fatherName": "MILKH RAJ",
            "obtainedMarks": "863",
            "maxMarks": "1200",
            "percentage": "71.91%",
            "cells": [
              "53",
              "21009115450014",
              "RITIKA",
              "MILKH RAJ",
              "863",
              "1200",
              "71.91%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "21009115450016",
            "name": "PREETI",
            "fatherName": "HARPAL SINGH",
            "obtainedMarks": "947",
            "maxMarks": "1200",
            "percentage": "78.91%",
            "cells": [
              "54",
              "21009115450016",
              "PREETI",
              "HARPAL SINGH",
              "947",
              "1200",
              "78.91%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "21009115450017",
            "name": "LOVEPREET KAUR",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "859",
            "maxMarks": "1200",
            "percentage": "71.58%",
            "cells": [
              "55",
              "21009115450017",
              "LOVEPREET KAUR",
              "AVTAR SINGH",
              "859",
              "1200",
              "71.58%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "21009115450018",
            "name": "KOMAL",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "882",
            "maxMarks": "1200",
            "percentage": "73.50%",
            "cells": [
              "56",
              "21009115450018",
              "KOMAL",
              "AMAR SINGH",
              "882",
              "1200",
              "73.50%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "57",
            "rollNo": "23009115420001",
            "name": "SUMAN",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "433",
            "maxMarks": "525",
            "percentage": "82.48%",
            "cells": [
              "57",
              "23009115420001",
              "SUMAN",
              "KRISHAN KUMAR",
              "433",
              "525",
              "82.48%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "23009115420002",
            "name": "SANTOSH",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "424",
            "maxMarks": "525",
            "percentage": "80.76%",
            "cells": [
              "58",
              "23009115420002",
              "SANTOSH",
              "DHARMPAL",
              "424",
              "525",
              "80.76%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "23009115420003",
            "name": "SARA",
            "fatherName": "BHAGIRATH",
            "obtainedMarks": "416",
            "maxMarks": "525",
            "percentage": "79.24%",
            "cells": [
              "59",
              "23009115420003",
              "SARA",
              "BHAGIRATH",
              "416",
              "525",
              "79.24%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "23009115420004",
            "name": "SAMESHTA",
            "fatherName": "RAVINDER",
            "obtainedMarks": "409",
            "maxMarks": "525",
            "percentage": "77.90%",
            "cells": [
              "60",
              "23009115420004",
              "SAMESHTA",
              "RAVINDER",
              "409",
              "525",
              "77.90%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "23009115420016",
            "name": "PARINAZ",
            "fatherName": "JANGIR CHAND",
            "obtainedMarks": "410",
            "maxMarks": "525",
            "percentage": "78.10%",
            "cells": [
              "61",
              "23009115420016",
              "PARINAZ",
              "JANGIR CHAND",
              "410",
              "525",
              "78.10%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "62",
            "rollNo": "22009115420001",
            "name": "GEETA RANI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "886",
            "maxMarks": "1150",
            "percentage": "77.04%",
            "cells": [
              "62",
              "22009115420001",
              "GEETA RANI",
              "VINOD KUMAR",
              "886",
              "1150",
              "77.04%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "22009115420002",
            "name": "RAMAN KAUR",
            "fatherName": "HARJIT SINGH",
            "obtainedMarks": "897",
            "maxMarks": "1150",
            "percentage": "78%",
            "cells": [
              "63",
              "22009115420002",
              "RAMAN KAUR",
              "HARJIT SINGH",
              "897",
              "1150",
              "78%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "22009115420003",
            "name": "RENU",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "855",
            "maxMarks": "1150",
            "percentage": "74.35%",
            "cells": [
              "64",
              "22009115420003",
              "RENU",
              "RAJENDER SINGH",
              "855",
              "1150",
              "74.35%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "22009115420007",
            "name": "MANITA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "817",
            "maxMarks": "1150",
            "percentage": "71.04%",
            "cells": [
              "65",
              "22009115420007",
              "MANITA",
              "VIJAY SINGH",
              "817",
              "1150",
              "71.04%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "22009115420011",
            "name": "ALKA",
            "fatherName": "JAIPARKASH",
            "obtainedMarks": "851",
            "maxMarks": "1150",
            "percentage": "74%",
            "cells": [
              "66",
              "22009115420011",
              "ALKA",
              "JAIPARKASH",
              "851",
              "1150",
              "74%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "22009115420013",
            "name": "YANSHU RANI",
            "fatherName": "DEVENDER",
            "obtainedMarks": "897",
            "maxMarks": "1150",
            "percentage": "78%",
            "cells": [
              "67",
              "22009115420013",
              "YANSHU RANI",
              "DEVENDER",
              "897",
              "1150",
              "78%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "22009115420014",
            "name": "REENA RANI",
            "fatherName": "SHALLENDER KUMAR",
            "obtainedMarks": "903",
            "maxMarks": "1150",
            "percentage": "78.52%",
            "cells": [
              "68",
              "22009115420014",
              "REENA RANI",
              "SHALLENDER KUMAR",
              "903",
              "1150",
              "78.52%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "22009115420017",
            "name": "SUMAN",
            "fatherName": "JETHU RAM",
            "obtainedMarks": "855",
            "maxMarks": "1150",
            "percentage": "74.35%",
            "cells": [
              "69",
              "22009115420017",
              "SUMAN",
              "JETHU RAM",
              "855",
              "1150",
              "74.35%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "22009115420018",
            "name": "ANSHIKA",
            "fatherName": "PUNISH KUMAR",
            "obtainedMarks": "939",
            "maxMarks": "1150",
            "percentage": "81.65%",
            "cells": [
              "70",
              "22009115420018",
              "ANSHIKA",
              "PUNISH KUMAR",
              "939",
              "1150",
              "81.65%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "22009115420021",
            "name": "RAMANPREET KAUR",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "870",
            "maxMarks": "1150",
            "percentage": "75.65%",
            "cells": [
              "71",
              "22009115420021",
              "RAMANPREET KAUR",
              "RANJEET SINGH",
              "870",
              "1150",
              "75.65%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "22009115420022",
            "name": "KUSUM",
            "fatherName": "GAUTAM SONI",
            "obtainedMarks": "866",
            "maxMarks": "1150",
            "percentage": "75.30%",
            "cells": [
              "72",
              "22009115420022",
              "KUSUM",
              "GAUTAM SONI",
              "866",
              "1150",
              "75.30%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "73",
            "rollNo": "21009115420001",
            "name": "TANNU",
            "fatherName": "AJMER",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "73",
              "21009115420001",
              "TANNU",
              "AJMER",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "21009115420002",
            "name": "VARSHA",
            "fatherName": "MAN SINGH",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "74",
              "21009115420002",
              "VARSHA",
              "MAN SINGH",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "21009115420003",
            "name": "TANU BALA",
            "fatherName": "LAXMI NARAYAN",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "75",
              "21009115420003",
              "TANU BALA",
              "LAXMI NARAYAN",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "21009115420008",
            "name": "SNEHA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "76",
              "21009115420008",
              "SNEHA",
              "RAMESH KUMAR",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "21009115420013",
            "name": "RAVINA",
            "fatherName": "RAGHUVEER",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "77",
              "21009115420013",
              "RAVINA",
              "RAGHUVEER",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "21009115420014",
            "name": "SUMAN DEVI",
            "fatherName": "RAGHUBIR SINGH",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.22%",
            "cells": [
              "78",
              "21009115420014",
              "SUMAN DEVI",
              "RAGHUBIR SINGH",
              "677",
              "900",
              "75.22%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "21009115420015",
            "name": "kajal",
            "fatherName": "satpal",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "79",
              "21009115420015",
              "kajal",
              "satpal",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "21009115420018",
            "name": "JYOTI",
            "fatherName": "BALBIR",
            "obtainedMarks": "690",
            "maxMarks": "900",
            "percentage": "76.67%",
            "cells": [
              "80",
              "21009115420018",
              "JYOTI",
              "BALBIR",
              "690",
              "900",
              "76.67%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "21009115420019",
            "name": "Ravneet kaur",
            "fatherName": "shyam lal",
            "obtainedMarks": "722",
            "maxMarks": "900",
            "percentage": "80.22%",
            "cells": [
              "81",
              "21009115420019",
              "Ravneet kaur",
              "shyam lal",
              "722",
              "900",
              "80.22%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "82",
            "rollNo": "21009115420020",
            "name": "BHAVNA MEHTA",
            "fatherName": "AJAY MEHTA",
            "obtainedMarks": "688",
            "maxMarks": "900",
            "percentage": "76.44%",
            "cells": [
              "82",
              "21009115420020",
              "BHAVNA MEHTA",
              "AJAY MEHTA",
              "688",
              "900",
              "76.44%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "21009115420022",
            "name": "POOJA RANI",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "83",
              "21009115420022",
              "POOJA RANI",
              "RANJEET SINGH",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "21009115420023",
            "name": "KANCHAN",
            "fatherName": "NIHAL SINGH",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "84",
              "21009115420023",
              "KANCHAN",
              "NIHAL SINGH",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "21009115420024",
            "name": "NISHA",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "714",
            "maxMarks": "900",
            "percentage": "79.33%",
            "cells": [
              "85",
              "21009115420024",
              "NISHA",
              "RAM NIWAS",
              "714",
              "900",
              "79.33%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "21009115420027",
            "name": "MANISHA",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "662",
            "maxMarks": "900",
            "percentage": "73.56%",
            "cells": [
              "86",
              "21009115420027",
              "MANISHA",
              "RAI SINGH",
              "662",
              "900",
              "73.56%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "21009115420029",
            "name": "SHRUTI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "87",
              "21009115420029",
              "SHRUTI",
              "SURENDER KUMAR",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "21009115420031",
            "name": "GAYTRI",
            "fatherName": "ROHTASH",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "88",
              "21009115420031",
              "GAYTRI",
              "ROHTASH",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "21009115420032",
            "name": "MUKESH",
            "fatherName": "JAIPAL",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "89",
              "21009115420032",
              "MUKESH",
              "JAIPAL",
              "659",
              "900",
              "73.22%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA  I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "90",
            "rollNo": "23009115470010",
            "name": "VANDANA",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "929",
            "maxMarks": "1300",
            "percentage": "71.46%",
            "cells": [
              "90",
              "23009115470010",
              "VANDANA",
              "BALWAN SINGH",
              "929",
              "1300",
              "71.46%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "23009115470014",
            "name": "SONU RANI",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "913",
            "maxMarks": "1300",
            "percentage": "70.23%",
            "cells": [
              "91",
              "23009115470014",
              "SONU RANI",
              "SUSHIL KUMAR",
              "913",
              "1300",
              "70.23%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "23009115470019",
            "name": "ARSHPREET KAUR",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "925",
            "maxMarks": "1300",
            "percentage": "71.15%",
            "cells": [
              "92",
              "23009115470019",
              "ARSHPREET KAUR",
              "SURENDER SINGH",
              "925",
              "1300",
              "71.15%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "23009115470040",
            "name": "AANCHAL RANI",
            "fatherName": "KALA RAM",
            "obtainedMarks": "990",
            "maxMarks": "1300",
            "percentage": "76.15%",
            "cells": [
              "93",
              "23009115470040",
              "AANCHAL RANI",
              "KALA RAM",
              "990",
              "1300",
              "76.15%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "94",
            "rollNo": "22009115470002",
            "name": "MEENU",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "939",
            "maxMarks": "1300",
            "percentage": "72.23%",
            "cells": [
              "94",
              "22009115470002",
              "MEENU",
              "SURENDER KUMAR",
              "939",
              "1300",
              "72.23%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "22009115470004",
            "name": "SIMRANPREET KAUR",
            "fatherName": "BEANT SINGH",
            "obtainedMarks": "947",
            "maxMarks": "1300",
            "percentage": "72.84%",
            "cells": [
              "95",
              "22009115470004",
              "SIMRANPREET KAUR",
              "BEANT SINGH",
              "947",
              "1300",
              "72.84%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "22009115470006",
            "name": "NEHA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "949",
            "maxMarks": "1300",
            "percentage": "73%",
            "cells": [
              "96",
              "22009115470006",
              "NEHA",
              "RAMESH KUMAR",
              "949",
              "1300",
              "73%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "22009115470007",
            "name": "TANNU",
            "fatherName": "RAMESH CHAND",
            "obtainedMarks": "1026",
            "maxMarks": "1300",
            "percentage": "78.92%",
            "cells": [
              "97",
              "22009115470007",
              "TANNU",
              "RAMESH CHAND",
              "1026",
              "1300",
              "78.92%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "22009115470014",
            "name": "DIKSHA",
            "fatherName": "PREM CHAND",
            "obtainedMarks": "935",
            "maxMarks": "1300",
            "percentage": "71.90%",
            "cells": [
              "98",
              "22009115470014",
              "DIKSHA",
              "PREM CHAND",
              "935",
              "1300",
              "71.90%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "22009115470018",
            "name": "UPASNA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "997",
            "maxMarks": "1300",
            "percentage": "76.69%",
            "cells": [
              "99",
              "22009115470018",
              "UPASNA",
              "RAJENDER",
              "997",
              "1300",
              "76.69%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "22009115470020",
            "name": "KIRTI",
            "fatherName": "PRITHVI RAJ",
            "obtainedMarks": "990",
            "maxMarks": "1300",
            "percentage": "76.15%",
            "cells": [
              "100",
              "22009115470020",
              "KIRTI",
              "PRITHVI RAJ",
              "990",
              "1300",
              "76.15%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "22009115470028",
            "name": "MEHAK GARG",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "1042",
            "maxMarks": "1300",
            "percentage": "81.15%",
            "cells": [
              "101",
              "22009115470028",
              "MEHAK GARG",
              "SANJAY KUMAR",
              "1042",
              "1300",
              "81.15%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "22009115470035",
            "name": "KHUSHMEET KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "971",
            "maxMarks": "1300",
            "percentage": "74.69%",
            "cells": [
              "102",
              "22009115470035",
              "KHUSHMEET KAUR",
              "JASPAL SINGH",
              "971",
              "1300",
              "74.69%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "22009115470036",
            "name": "MS AANCHAL LAKHOTIA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1051",
            "maxMarks": "1300",
            "percentage": "80.84%",
            "cells": [
              "103",
              "22009115470036",
              "MS AANCHAL LAKHOTIA",
              "MADAN LAL",
              "1051",
              "1300",
              "80.84%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "22009115470038",
            "name": "SAKSHI",
            "fatherName": "VINOD SHARMA",
            "obtainedMarks": "984",
            "maxMarks": "1300",
            "percentage": "75.69%",
            "cells": [
              "104",
              "22009115470038",
              "SAKSHI",
              "VINOD SHARMA",
              "984",
              "1300",
              "75.69%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA III Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "105",
            "rollNo": "21009115470001",
            "name": "SAYRA SONI",
            "fatherName": "JYOTI PRAKASH",
            "obtainedMarks": "963",
            "maxMarks": "1300",
            "percentage": "74%",
            "cells": [
              "105",
              "21009115470001",
              "SAYRA SONI",
              "JYOTI PRAKASH",
              "963",
              "1300",
              "74%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "21009115470003",
            "name": "KOMAL RANI",
            "fatherName": "SHIV CHARAN",
            "obtainedMarks": "1053",
            "maxMarks": "1300",
            "percentage": "81%",
            "cells": [
              "106",
              "21009115470003",
              "KOMAL RANI",
              "SHIV CHARAN",
              "1053",
              "1300",
              "81%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "21009115470010",
            "name": "KAVITA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1015",
            "maxMarks": "1300",
            "percentage": "78%",
            "cells": [
              "107",
              "21009115470010",
              "KAVITA",
              "RAKESH KUMAR",
              "1015",
              "1300",
              "78%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "21009115470015",
            "name": "POONAM",
            "fatherName": "RAJESH",
            "obtainedMarks": "940",
            "maxMarks": "1300",
            "percentage": "72.30%",
            "cells": [
              "108",
              "21009115470015",
              "POONAM",
              "RAJESH",
              "940",
              "1300",
              "72.30%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "21009115470022",
            "name": "PRIYANKA",
            "fatherName": "RAJINDER PAL",
            "obtainedMarks": "1050",
            "maxMarks": "1300",
            "percentage": "80.70%",
            "cells": [
              "109",
              "21009115470022",
              "PRIYANKA",
              "RAJINDER PAL",
              "1050",
              "1300",
              "80.70%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "21009115470028",
            "name": "SIMRAN",
            "fatherName": "HARJEET SINGH",
            "obtainedMarks": "982",
            "maxMarks": "1300",
            "percentage": "75.50%",
            "cells": [
              "110",
              "21009115470028",
              "SIMRAN",
              "HARJEET SINGH",
              "982",
              "1300",
              "75.50%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "21009115470035",
            "name": "SIMRANJEET",
            "fatherName": "SWARAN SINGH",
            "obtainedMarks": "919",
            "maxMarks": "1300",
            "percentage": "70.69%",
            "cells": [
              "111",
              "21009115470035",
              "SIMRANJEET",
              "SWARAN SINGH",
              "919",
              "1300",
              "70.69%"
            ]
          }
        ]
      },
      {
        "courseName": "D.P.Ed.I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "112",
            "rollNo": "23009225640001",
            "name": "MANJU",
            "fatherName": "RAM LAL",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "112",
              "23009225640001",
              "MANJU",
              "RAM LAL",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "23009225640004",
            "name": "ASHMEET KAUR",
            "fatherName": "LAKHWINDER SINGH",
            "obtainedMarks": "1097",
            "maxMarks": "1500",
            "percentage": "73.13%",
            "cells": [
              "113",
              "23009225640004",
              "ASHMEET KAUR",
              "LAKHWINDER SINGH",
              "1097",
              "1500",
              "73.13%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "23009225640006",
            "name": "MONIKA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1075",
            "maxMarks": "1500",
            "percentage": "71.66%",
            "cells": [
              "114",
              "23009225640006",
              "MONIKA",
              "RAN SINGH",
              "1075",
              "1500",
              "71.66%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "23009225640007",
            "name": "MANISHA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1191",
            "maxMarks": "1500",
            "percentage": "79.40%",
            "cells": [
              "115",
              "23009225640007",
              "MANISHA",
              "RAMESH KUMAR",
              "1191",
              "1500",
              "79.40%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "23009225640008",
            "name": "POONAM",
            "fatherName": "SATPAL",
            "obtainedMarks": "1100",
            "maxMarks": "1500",
            "percentage": "73.33%",
            "cells": [
              "116",
              "23009225640008",
              "POONAM",
              "SATPAL",
              "1100",
              "1500",
              "73.33%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "23009225640009",
            "name": "ANITA",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "117",
              "23009225640009",
              "ANITA",
              "BHOOP SINGH",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "23009225640010",
            "name": "POOJA",
            "fatherName": "BALWAN",
            "obtainedMarks": "1162",
            "maxMarks": "1500",
            "percentage": "77.46%",
            "cells": [
              "118",
              "23009225640010",
              "POOJA",
              "BALWAN",
              "1162",
              "1500",
              "77.46%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "23009225640012",
            "name": "RUKMANI",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "119",
              "23009225640012",
              "RUKMANI",
              "HANSRAJ",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "23009225640013",
            "name": "AARJOO",
            "fatherName": "SATBIR",
            "obtainedMarks": "1107",
            "maxMarks": "1500",
            "percentage": "73.80%",
            "cells": [
              "120",
              "23009225640013",
              "AARJOO",
              "SATBIR",
              "1107",
              "1500",
              "73.80%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "23009225640014",
            "name": "REETU",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "1089",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "121",
              "23009225640014",
              "REETU",
              "DAYA RAM",
              "1089",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "23009225640015",
            "name": "DIKSHA",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "1137",
            "maxMarks": "1500",
            "percentage": "75.80%",
            "cells": [
              "122",
              "23009225640015",
              "DIKSHA",
              "BALWAN SINGH",
              "1137",
              "1500",
              "75.80%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "23009225640016",
            "name": "SARITA",
            "fatherName": "JAISINGH",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "123",
              "23009225640016",
              "SARITA",
              "JAISINGH",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "23009225640019",
            "name": "POOJA",
            "fatherName": "SATVIR",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.93%",
            "cells": [
              "124",
              "23009225640019",
              "POOJA",
              "SATVIR",
              "1094",
              "1500",
              "72.93%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "23009225640021",
            "name": "MANJU",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "993",
            "maxMarks": "1500",
            "percentage": "66.20%",
            "cells": [
              "125",
              "23009225640021",
              "MANJU",
              "DAYA RAM",
              "993",
              "1500",
              "66.20%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "23009225640022",
            "name": "SANGEETA",
            "fatherName": "SATVEER",
            "obtainedMarks": "1169",
            "maxMarks": "1500",
            "percentage": "77.93%",
            "cells": [
              "126",
              "23009225640022",
              "SANGEETA",
              "SATVEER",
              "1169",
              "1500",
              "77.93%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "23009225640023",
            "name": "PARMILA",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "1129",
            "maxMarks": "1500",
            "percentage": "75.26%",
            "cells": [
              "127",
              "23009225640023",
              "PARMILA",
              "SANDEEP KUMAR",
              "1129",
              "1500",
              "75.26%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "23009225640024",
            "name": "POOJA KUMARI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "1132",
            "maxMarks": "1500",
            "percentage": "75.46%",
            "cells": [
              "128",
              "23009225640024",
              "POOJA KUMARI",
              "BANWARI LAL",
              "1132",
              "1500",
              "75.46%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "23009225640025",
            "name": "ANURADHA",
            "fatherName": "RAVI DUTT",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.80%",
            "cells": [
              "129",
              "23009225640025",
              "ANURADHA",
              "RAVI DUTT",
              "1122",
              "1500",
              "74.80%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "23009225640026",
            "name": "NEHA",
            "fatherName": "KISHAN SINGH",
            "obtainedMarks": "1117",
            "maxMarks": "1500",
            "percentage": "74.46%",
            "cells": [
              "130",
              "23009225640026",
              "NEHA",
              "KISHAN SINGH",
              "1117",
              "1500",
              "74.46%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "23009225640027",
            "name": "NEETU KUMARI",
            "fatherName": "DEBURAM",
            "obtainedMarks": "1136",
            "maxMarks": "1500",
            "percentage": "75.73%",
            "cells": [
              "131",
              "23009225640027",
              "NEETU KUMARI",
              "DEBURAM",
              "1136",
              "1500",
              "75.73%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "23009225640028",
            "name": "DEEPA KUMARI",
            "fatherName": "GORDHAN RAM",
            "obtainedMarks": "1109",
            "maxMarks": "1500",
            "percentage": "73.93%",
            "cells": [
              "132",
              "23009225640028",
              "DEEPA KUMARI",
              "GORDHAN RAM",
              "1109",
              "1500",
              "73.93%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "23009225640030",
            "name": "MONIKA BENIWAL",
            "fatherName": "SUGNA RAM BENIWAL",
            "obtainedMarks": "1153",
            "maxMarks": "1500",
            "percentage": "76.86%",
            "cells": [
              "133",
              "23009225640030",
              "MONIKA BENIWAL",
              "SUGNA RAM BENIWAL",
              "1153",
              "1500",
              "76.86%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "23009225640031",
            "name": "PREETI",
            "fatherName": "RAMESH",
            "obtainedMarks": "1169",
            "maxMarks": "1500",
            "percentage": "77.93%",
            "cells": [
              "134",
              "23009225640031",
              "PREETI",
              "RAMESH",
              "1169",
              "1500",
              "77.93%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "23009225640032",
            "name": "DROPADI BENIWAL",
            "fatherName": "GOWARDHAN LAL BENIWAL",
            "obtainedMarks": "1131",
            "maxMarks": "1500",
            "percentage": "75.40%",
            "cells": [
              "135",
              "23009225640032",
              "DROPADI BENIWAL",
              "GOWARDHAN LAL BENIWAL",
              "1131",
              "1500",
              "75.40%"
            ]
          },
          {
            "sNo": "136",
            "rollNo": "23009225640033",
            "name": "KAVITA",
            "fatherName": "RAKESH",
            "obtainedMarks": "1117",
            "maxMarks": "1500",
            "percentage": "74.46%",
            "cells": [
              "136",
              "23009225640033",
              "KAVITA",
              "RAKESH",
              "1117",
              "1500",
              "74.46%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "23009225640034",
            "name": "KAUSHLYA",
            "fatherName": "BHAGI RAM",
            "obtainedMarks": "1206",
            "maxMarks": "1500",
            "percentage": "80.40%",
            "cells": [
              "137",
              "23009225640034",
              "KAUSHLYA",
              "BHAGI RAM",
              "1206",
              "1500",
              "80.40%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "23009225640035",
            "name": "GARIMA",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "1192",
            "maxMarks": "1500",
            "percentage": "79.46%",
            "cells": [
              "138",
              "23009225640035",
              "GARIMA",
              "SATISH KUMAR",
              "1192",
              "1500",
              "79.46%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "23009225640036",
            "name": "SALONI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1189",
            "maxMarks": "1500",
            "percentage": "79.26%",
            "cells": [
              "139",
              "23009225640036",
              "SALONI",
              "RAMESH KUMAR",
              "1189",
              "1500",
              "79.26%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "23009225640039",
            "name": "MONIKA",
            "fatherName": "BHAL SINGH",
            "obtainedMarks": "1111",
            "maxMarks": "1500",
            "percentage": "74.06%",
            "cells": [
              "140",
              "23009225640039",
              "MONIKA",
              "BHAL SINGH",
              "1111",
              "1500",
              "74.06%"
            ]
          },
          {
            "sNo": "141",
            "rollNo": "23009225640040",
            "name": "MANISHA",
            "fatherName": "SAHABRAM",
            "obtainedMarks": "1182",
            "maxMarks": "1500",
            "percentage": "78.80%",
            "cells": [
              "141",
              "23009225640040",
              "MANISHA",
              "SAHABRAM",
              "1182",
              "1500",
              "78.80%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "23009225640043",
            "name": "RENUKA",
            "fatherName": "RAMKUMAR",
            "obtainedMarks": "1142",
            "maxMarks": "1500",
            "percentage": "76.13%",
            "cells": [
              "142",
              "23009225640043",
              "RENUKA",
              "RAMKUMAR",
              "1142",
              "1500",
              "76.13%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "23009225640044",
            "name": "KAMNA",
            "fatherName": "PARDEEP KUMAR",
            "obtainedMarks": "1161",
            "maxMarks": "1500",
            "percentage": "77.40%",
            "cells": [
              "143",
              "23009225640044",
              "KAMNA",
              "PARDEEP KUMAR",
              "1161",
              "1500",
              "77.40%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "23009225640045",
            "name": "SULOCHANA",
            "fatherName": "KISHANLAL",
            "obtainedMarks": "1145",
            "maxMarks": "1500",
            "percentage": "76.33%",
            "cells": [
              "144",
              "23009225640045",
              "SULOCHANA",
              "KISHANLAL",
              "1145",
              "1500",
              "76.33%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "23009225640046",
            "name": "POOJA",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1093",
            "maxMarks": "1500",
            "percentage": "72.86%",
            "cells": [
              "145",
              "23009225640046",
              "POOJA",
              "OM PRAKASH",
              "1093",
              "1500",
              "72.86%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "23009225640047",
            "name": "KAVITA",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.80%",
            "cells": [
              "146",
              "23009225640047",
              "KAVITA",
              "HANSRAJ",
              "1122",
              "1500",
              "74.80%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "23009225640048",
            "name": "KAMALA",
            "fatherName": "CHUNA RAM",
            "obtainedMarks": "1076",
            "maxMarks": "1500",
            "percentage": "71.73%",
            "cells": [
              "147",
              "23009225640048",
              "KAMALA",
              "CHUNA RAM",
              "1076",
              "1500",
              "71.73%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "23009225640049",
            "name": "REETU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.80%",
            "cells": [
              "148",
              "23009225640049",
              "REETU",
              "PAWAN KUMAR",
              "1122",
              "1500",
              "74.80%"
            ]
          }
        ]
      },
      {
        "courseName": "D.P.Ed. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "149",
            "rollNo": "22009225640001",
            "name": "RACHANA",
            "fatherName": "SARDUL",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.26%",
            "cells": [
              "149",
              "22009225640001",
              "RACHANA",
              "SARDUL",
              "1114",
              "1500",
              "74.26%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "22009225640002",
            "name": "ANJIKA",
            "fatherName": "RAMESH",
            "obtainedMarks": "1135",
            "maxMarks": "1500",
            "percentage": "75.66%",
            "cells": [
              "150",
              "22009225640002",
              "ANJIKA",
              "RAMESH",
              "1135",
              "1500",
              "75.66%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "22009225640003",
            "name": "MAMTA",
            "fatherName": "LILADHAR",
            "obtainedMarks": "1138",
            "maxMarks": "1500",
            "percentage": "75.86%",
            "cells": [
              "151",
              "22009225640003",
              "MAMTA",
              "LILADHAR",
              "1138",
              "1500",
              "75.86%"
            ]
          },
          {
            "sNo": "152",
            "rollNo": "22009225640004",
            "name": "SONU",
            "fatherName": "BALRAJ",
            "obtainedMarks": "1144",
            "maxMarks": "1500",
            "percentage": "76.26%",
            "cells": [
              "152",
              "22009225640004",
              "SONU",
              "BALRAJ",
              "1144",
              "1500",
              "76.26%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "22009225640007",
            "name": "DHAPU",
            "fatherName": "FATA RAM",
            "obtainedMarks": "1118",
            "maxMarks": "1500",
            "percentage": "74.53%",
            "cells": [
              "153",
              "22009225640007",
              "DHAPU",
              "FATA RAM",
              "1118",
              "1500",
              "74.53%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "22009225640009",
            "name": "VIJAY LAXMI",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1111",
            "maxMarks": "1500",
            "percentage": "74.06%",
            "cells": [
              "154",
              "22009225640009",
              "VIJAY LAXMI",
              "RAN SINGH",
              "1111",
              "1500",
              "74.06%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "22009225640014",
            "name": "Ujala",
            "fatherName": "Rajesh Kumar Sihag",
            "obtainedMarks": "1056",
            "maxMarks": "1500",
            "percentage": "70.40%",
            "cells": [
              "155",
              "22009225640014",
              "Ujala",
              "Rajesh Kumar Sihag",
              "1056",
              "1500",
              "70.40%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "22009225640015",
            "name": "KANTA",
            "fatherName": "HET RAM",
            "obtainedMarks": "1110",
            "maxMarks": "1500",
            "percentage": "74%",
            "cells": [
              "156",
              "22009225640015",
              "KANTA",
              "HET RAM",
              "1110",
              "1500",
              "74%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "22009225640017",
            "name": "MS NIRMLA",
            "fatherName": "RAMLAL MEGHWAL",
            "obtainedMarks": "1130",
            "maxMarks": "1500",
            "percentage": "75.33%",
            "cells": [
              "157",
              "22009225640017",
              "MS NIRMLA",
              "RAMLAL MEGHWAL",
              "1130",
              "1500",
              "75.33%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "22009225640018",
            "name": "MONU",
            "fatherName": "LALA RAM",
            "obtainedMarks": "1089",
            "maxMarks": "1500",
            "percentage": "72.60%",
            "cells": [
              "158",
              "22009225640018",
              "MONU",
              "LALA RAM",
              "1089",
              "1500",
              "72.60%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "22009225640020",
            "name": "PREETI",
            "fatherName": "MAHENDRA SINGH",
            "obtainedMarks": "1081",
            "maxMarks": "1500",
            "percentage": "72.06%",
            "cells": [
              "159",
              "22009225640020",
              "PREETI",
              "MAHENDRA SINGH",
              "1081",
              "1500",
              "72.06%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "22009225640022",
            "name": "POONAM",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "1090",
            "maxMarks": "1500",
            "percentage": "72.66%",
            "cells": [
              "160",
              "22009225640022",
              "POONAM",
              "RAJESH KUMAR",
              "1090",
              "1500",
              "72.66%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "22009225640025",
            "name": "RACHNA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "161",
              "22009225640025",
              "RACHNA",
              "OM PARKASH",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "22009225640026",
            "name": "Anu",
            "fatherName": "Karnail",
            "obtainedMarks": "1066",
            "maxMarks": "1500",
            "percentage": "71.06%",
            "cells": [
              "162",
              "22009225640026",
              "Anu",
              "Karnail",
              "1066",
              "1500",
              "71.06%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "22009225640027",
            "name": "RAVINA",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1116",
            "maxMarks": "1500",
            "percentage": "74.40%",
            "cells": [
              "163",
              "22009225640027",
              "RAVINA",
              "ANAND KUMAR",
              "1116",
              "1500",
              "74.40%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "22009225640029",
            "name": "KAVITA",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1130",
            "maxMarks": "1500",
            "percentage": "75.33%",
            "cells": [
              "164",
              "22009225640029",
              "KAVITA",
              "RAKESH KUMAR",
              "1130",
              "1500",
              "75.33%"
            ]
          },
          {
            "sNo": "165",
            "rollNo": "22009225640033",
            "name": "SIMRAN",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1082",
            "maxMarks": "1500",
            "percentage": "72.13%",
            "cells": [
              "165",
              "22009225640033",
              "SIMRAN",
              "SURESH KUMAR",
              "1082",
              "1500",
              "72.13%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "22009225640034",
            "name": "AARJU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1112",
            "maxMarks": "1500",
            "percentage": "74.13%",
            "cells": [
              "166",
              "22009225640034",
              "AARJU",
              "PAWAN KUMAR",
              "1112",
              "1500",
              "74.13%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "22009225640035",
            "name": "SANJANA",
            "fatherName": "RAJESH VERMA",
            "obtainedMarks": "1171",
            "maxMarks": "1500",
            "percentage": "78.06%",
            "cells": [
              "167",
              "22009225640035",
              "SANJANA",
              "RAJESH VERMA",
              "1171",
              "1500",
              "78.06%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "22009225640037",
            "name": "MS. PRIYANKA KUMARI",
            "fatherName": "LUNA RAM",
            "obtainedMarks": "1094",
            "maxMarks": "1500",
            "percentage": "72.93%",
            "cells": [
              "168",
              "22009225640037",
              "MS. PRIYANKA KUMARI",
              "LUNA RAM",
              "1094",
              "1500",
              "72.93%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "22009225640041",
            "name": "SHIKSHA",
            "fatherName": "DEVINDER",
            "obtainedMarks": "1148",
            "maxMarks": "1500",
            "percentage": "76.53%",
            "cells": [
              "169",
              "22009225640041",
              "SHIKSHA",
              "DEVINDER",
              "1148",
              "1500",
              "76.53%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "22009225640043",
            "name": "BINTU RANI",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1131",
            "maxMarks": "1500",
            "percentage": "75.40%",
            "cells": [
              "170",
              "22009225640043",
              "BINTU RANI",
              "RAN SINGH",
              "1131",
              "1500",
              "75.40%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "22009225640044",
            "name": "AARTI",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "1092",
            "maxMarks": "1500",
            "percentage": "72.80%",
            "cells": [
              "171",
              "22009225640044",
              "AARTI",
              "AMAR SINGH",
              "1092",
              "1500",
              "72.80%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "22009225640046",
            "name": "HURNIKA",
            "fatherName": "SHYOPAT",
            "obtainedMarks": "1122",
            "maxMarks": "1500",
            "percentage": "74.81%",
            "cells": [
              "172",
              "22009225640046",
              "HURNIKA",
              "SHYOPAT",
              "1122",
              "1500",
              "74.81%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "22009225640047",
            "name": "PRIYA SEN",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1170",
            "maxMarks": "1500",
            "percentage": "78%",
            "cells": [
              "173",
              "22009225640047",
              "PRIYA SEN",
              "OM PARKASH",
              "1170",
              "1500",
              "78%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A. (SEM.I +II)",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "174",
            "rollNo": "23009115430004",
            "name": "MUSKAN",
            "fatherName": "BHAL CHAND",
            "obtainedMarks": "764",
            "maxMarks": "975",
            "percentage": "78.36%",
            "cells": [
              "174",
              "23009115430004",
              "MUSKAN",
              "BHAL CHAND",
              "764",
              "975",
              "78.36%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "23009115430010",
            "name": "RENU",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "720",
            "maxMarks": "975",
            "percentage": "73.85%",
            "cells": [
              "175",
              "23009115430010",
              "RENU",
              "VIJAY KUMAR",
              "720",
              "975",
              "73.85%"
            ]
          },
          {
            "sNo": "176",
            "rollNo": "23009115430049",
            "name": "BHAWNA",
            "fatherName": "RAJKUMAR",
            "obtainedMarks": "689",
            "maxMarks": "975",
            "percentage": "70.67%",
            "cells": [
              "176",
              "23009115430049",
              "BHAWNA",
              "RAJKUMAR",
              "689",
              "975",
              "70.67%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "23009115430051",
            "name": "PRIYANKA",
            "fatherName": "PARHLAD",
            "obtainedMarks": "688",
            "maxMarks": "975",
            "percentage": "70.56%",
            "cells": [
              "177",
              "23009115430051",
              "PRIYANKA",
              "PARHLAD",
              "688",
              "975",
              "70.56%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "23009115430056",
            "name": "MANISHA",
            "fatherName": "MAHENDER",
            "obtainedMarks": "768",
            "maxMarks": "975",
            "percentage": "78.77%",
            "cells": [
              "178",
              "23009115430056",
              "MANISHA",
              "MAHENDER",
              "768",
              "975",
              "78.77%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "23009115430057",
            "name": "SHIVALI",
            "fatherName": "WAZIR CHAND",
            "obtainedMarks": "769",
            "maxMarks": "975",
            "percentage": "78.87%",
            "cells": [
              "179",
              "23009115430057",
              "SHIVALI",
              "WAZIR CHAND",
              "769",
              "975",
              "78.87%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "23009115430059",
            "name": "YASH BHARTI",
            "fatherName": "DEV RAJ",
            "obtainedMarks": "702",
            "maxMarks": "975",
            "percentage": "72%",
            "cells": [
              "180",
              "23009115430059",
              "YASH BHARTI",
              "DEV RAJ",
              "702",
              "975",
              "72%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "23009115430060",
            "name": "SHOBHNA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "806",
            "maxMarks": "975",
            "percentage": "82.67%",
            "cells": [
              "181",
              "23009115430060",
              "SHOBHNA",
              "SURESH KUMAR",
              "806",
              "975",
              "82.67%"
            ]
          },
          {
            "sNo": "182",
            "rollNo": "23009115430061",
            "name": "PRIYANKA",
            "fatherName": "PARBHU SINGH",
            "obtainedMarks": "727",
            "maxMarks": "975",
            "percentage": "74.56%",
            "cells": [
              "182",
              "23009115430061",
              "PRIYANKA",
              "PARBHU SINGH",
              "727",
              "975",
              "74.56%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "23009115430062",
            "name": "KAVERI",
            "fatherName": "PARVEEN KUMAR",
            "obtainedMarks": "718",
            "maxMarks": "975",
            "percentage": "73.64%",
            "cells": [
              "183",
              "23009115430062",
              "KAVERI",
              "PARVEEN KUMAR",
              "718",
              "975",
              "73.64%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "23009115430064",
            "name": "SUHANI",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "761",
            "maxMarks": "975",
            "percentage": "78.05%",
            "cells": [
              "184",
              "23009115430064",
              "SUHANI",
              "ANIL KUMAR",
              "761",
              "975",
              "78.05%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "23009115430066",
            "name": "GURPREET KAUR",
            "fatherName": "HARMEET SINGH",
            "obtainedMarks": "707",
            "maxMarks": "975",
            "percentage": "72.51%",
            "cells": [
              "185",
              "23009115430066",
              "GURPREET KAUR",
              "HARMEET SINGH",
              "707",
              "975",
              "72.51%"
            ]
          },
          {
            "sNo": "186",
            "rollNo": "23009115430068",
            "name": "RITIKA",
            "fatherName": "SANJAY",
            "obtainedMarks": "794",
            "maxMarks": "975",
            "percentage": "81.44%",
            "cells": [
              "186",
              "23009115430068",
              "RITIKA",
              "SANJAY",
              "794",
              "975",
              "81.44%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "23009115430070",
            "name": "ARAVI",
            "fatherName": "JAGDISH LAL",
            "obtainedMarks": "725",
            "maxMarks": "975",
            "percentage": "74.36%",
            "cells": [
              "187",
              "23009115430070",
              "ARAVI",
              "JAGDISH LAL",
              "725",
              "975",
              "74.36%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "23009115430074",
            "name": "ARSHDEEP KAUR",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "704",
            "maxMarks": "975",
            "percentage": "72.21%",
            "cells": [
              "188",
              "23009115430074",
              "ARSHDEEP KAUR",
              "GURJANT SINGH",
              "704",
              "975",
              "72.21%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "23009115430075",
            "name": "JASMINE BAWA",
            "fatherName": "JAGSIR SINGH",
            "obtainedMarks": "763",
            "maxMarks": "975",
            "percentage": "78.26%",
            "cells": [
              "189",
              "23009115430075",
              "JASMINE BAWA",
              "JAGSIR SINGH",
              "763",
              "975",
              "78.26%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "23009115430078",
            "name": "DEEPIKA",
            "fatherName": "SUMEET KUMAR",
            "obtainedMarks": "824",
            "maxMarks": "975",
            "percentage": "84.51%",
            "cells": [
              "190",
              "23009115430078",
              "DEEPIKA",
              "SUMEET KUMAR",
              "824",
              "975",
              "84.51%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "23009115430082",
            "name": "MUSKAN",
            "fatherName": "MUKESH KUMAR",
            "obtainedMarks": "726",
            "maxMarks": "975",
            "percentage": "74.46%",
            "cells": [
              "191",
              "23009115430082",
              "MUSKAN",
              "MUKESH KUMAR",
              "726",
              "975",
              "74.46%"
            ]
          },
          {
            "sNo": "192",
            "rollNo": "23009115430089",
            "name": "ISHU",
            "fatherName": "RAJNEESH KUMAR",
            "obtainedMarks": "797",
            "maxMarks": "975",
            "percentage": "81.74%",
            "cells": [
              "192",
              "23009115430089",
              "ISHU",
              "RAJNEESH KUMAR",
              "797",
              "975",
              "81.74%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "23009115430090",
            "name": "KHUSHI",
            "fatherName": "GULSHAN KUMAR",
            "obtainedMarks": "717",
            "maxMarks": "975",
            "percentage": "73.54%",
            "cells": [
              "193",
              "23009115430090",
              "KHUSHI",
              "GULSHAN KUMAR",
              "717",
              "975",
              "73.54%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "23009115430093",
            "name": "SUKHMEET KAUR",
            "fatherName": "KULDEEP SINGH",
            "obtainedMarks": "691",
            "maxMarks": "975",
            "percentage": "70.87%",
            "cells": [
              "194",
              "23009115430093",
              "SUKHMEET KAUR",
              "KULDEEP SINGH",
              "691",
              "975",
              "70.87%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "23009115430096",
            "name": "SIMRANJEET KAUR",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "737",
            "maxMarks": "975",
            "percentage": "75.59%",
            "cells": [
              "195",
              "23009115430096",
              "SIMRANJEET KAUR",
              "AVTAR SINGH",
              "737",
              "975",
              "75.59%"
            ]
          },
          {
            "sNo": "196",
            "rollNo": "23009115430103",
            "name": "SNEHA",
            "fatherName": "SATISH BHARTI",
            "obtainedMarks": "698",
            "maxMarks": "975",
            "percentage": "71.59%",
            "cells": [
              "196",
              "23009115430103",
              "SNEHA",
              "SATISH BHARTI",
              "698",
              "975",
              "71.59%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "23009115430105",
            "name": "PAYAL RANI",
            "fatherName": "JAGDISH",
            "obtainedMarks": "696",
            "maxMarks": "975",
            "percentage": "71.38%",
            "cells": [
              "197",
              "23009115430105",
              "PAYAL RANI",
              "JAGDISH",
              "696",
              "975",
              "71.38%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "23009115430107",
            "name": "SIMRAN",
            "fatherName": "DEEPAK KUMAR",
            "obtainedMarks": "670",
            "maxMarks": "975",
            "percentage": "68.72%",
            "cells": [
              "198",
              "23009115430107",
              "SIMRAN",
              "DEEPAK KUMAR",
              "670",
              "975",
              "68.72%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "23009115430108",
            "name": "MUSKAN",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "698",
            "maxMarks": "975",
            "percentage": "71.59%",
            "cells": [
              "199",
              "23009115430108",
              "MUSKAN",
              "SANJAY KUMAR",
              "698",
              "975",
              "71.59%"
            ]
          },
          {
            "sNo": "200",
            "rollNo": "23009115430115",
            "name": "SAKSHI DEVI",
            "fatherName": "SUSHIL",
            "obtainedMarks": "714",
            "maxMarks": "975",
            "percentage": "73.23%",
            "cells": [
              "200",
              "23009115430115",
              "SAKSHI DEVI",
              "SUSHIL",
              "714",
              "975",
              "73.23%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "23009115430119",
            "name": "MANOJ",
            "fatherName": "RATAN SINGH",
            "obtainedMarks": "798",
            "maxMarks": "975",
            "percentage": "81.85%",
            "cells": [
              "201",
              "23009115430119",
              "MANOJ",
              "RATAN SINGH",
              "798",
              "975",
              "81.85%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "23009115430120",
            "name": "MONIKA",
            "fatherName": "ANUP KUMAR",
            "obtainedMarks": "685",
            "maxMarks": "975",
            "percentage": "70.26%",
            "cells": [
              "202",
              "23009115430120",
              "MONIKA",
              "ANUP KUMAR",
              "685",
              "975",
              "70.26%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "23009115430121",
            "name": "RIDHI",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "705",
            "maxMarks": "975",
            "percentage": "72.31%",
            "cells": [
              "203",
              "23009115430121",
              "RIDHI",
              "SANDEEP KUMAR",
              "705",
              "975",
              "72.31%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "23009115430122",
            "name": "SIMRAN",
            "fatherName": "MALKEET SINGH",
            "obtainedMarks": "779",
            "maxMarks": "975",
            "percentage": "79.90%",
            "cells": [
              "204",
              "23009115430122",
              "SIMRAN",
              "MALKEET SINGH",
              "779",
              "975",
              "79.90%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "23009115430124",
            "name": "GAYTRI",
            "fatherName": "RISHI KUMAR",
            "obtainedMarks": "704",
            "maxMarks": "975",
            "percentage": "72.20%",
            "cells": [
              "205",
              "23009115430124",
              "GAYTRI",
              "RISHI KUMAR",
              "704",
              "975",
              "72.20%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "23009115430135",
            "name": "RITIKA",
            "fatherName": "MANGAT RAM",
            "obtainedMarks": "671",
            "maxMarks": "975",
            "percentage": "68.82%",
            "cells": [
              "206",
              "23009115430135",
              "RITIKA",
              "MANGAT RAM",
              "671",
              "975",
              "68.82%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "23009115430146",
            "name": "NAVDEEP KAUR",
            "fatherName": "AMARJEET SINGH",
            "obtainedMarks": "679",
            "maxMarks": "975",
            "percentage": "69.64%",
            "cells": [
              "207",
              "23009115430146",
              "NAVDEEP KAUR",
              "AMARJEET SINGH",
              "679",
              "975",
              "69.64%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "23009115430168",
            "name": "DILSHAN KOUR",
            "fatherName": "NIRBHAY SINGH",
            "obtainedMarks": "734",
            "maxMarks": "975",
            "percentage": "75.28%",
            "cells": [
              "208",
              "23009115430168",
              "DILSHAN KOUR",
              "NIRBHAY SINGH",
              "734",
              "975",
              "75.28%"
            ]
          },
          {
            "sNo": "209",
            "rollNo": "23009115430177",
            "name": "KOMAL",
            "fatherName": "SURENDER",
            "obtainedMarks": "682",
            "maxMarks": "975",
            "percentage": "69.95%",
            "cells": [
              "209",
              "23009115430177",
              "KOMAL",
              "SURENDER",
              "682",
              "975",
              "69.95%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "23009115430194",
            "name": "PRIYANKA",
            "fatherName": "BIRBHAN",
            "obtainedMarks": "677",
            "maxMarks": "975",
            "percentage": "69.44%",
            "cells": [
              "210",
              "23009115430194",
              "PRIYANKA",
              "BIRBHAN",
              "677",
              "975",
              "69.44%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A. (SEM.III +IV)",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "211",
            "rollNo": "22009115430001",
            "name": "RACHNA",
            "fatherName": "OMPARKASH",
            "obtainedMarks": "720",
            "maxMarks": "900",
            "percentage": "80%",
            "cells": [
              "211",
              "22009115430001",
              "RACHNA",
              "OMPARKASH",
              "720",
              "900",
              "80%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "22009115430004",
            "name": "DHARAMPREET KAUR",
            "fatherName": "BHOLA SINGH",
            "obtainedMarks": "704",
            "maxMarks": "900",
            "percentage": "78.22%",
            "cells": [
              "212",
              "22009115430004",
              "DHARAMPREET KAUR",
              "BHOLA SINGH",
              "704",
              "900",
              "78.22%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "22009115430008",
            "name": "SNEHA",
            "fatherName": "KULDEEP KUMAR",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.55%",
            "cells": [
              "213",
              "22009115430008",
              "SNEHA",
              "KULDEEP KUMAR",
              "635",
              "900",
              "70.55%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "22009115430010",
            "name": "POONAM",
            "fatherName": "LALA RAM",
            "obtainedMarks": "648",
            "maxMarks": "900",
            "percentage": "72%",
            "cells": [
              "214",
              "22009115430010",
              "POONAM",
              "LALA RAM",
              "648",
              "900",
              "72%"
            ]
          },
          {
            "sNo": "215",
            "rollNo": "22009115430012",
            "name": "PARMILA",
            "fatherName": "PANNA LAL",
            "obtainedMarks": "745",
            "maxMarks": "900",
            "percentage": "82.78%",
            "cells": [
              "215",
              "22009115430012",
              "PARMILA",
              "PANNA LAL",
              "745",
              "900",
              "82.78%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "22009115430013",
            "name": "ARZOO",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.89%",
            "cells": [
              "216",
              "22009115430013",
              "ARZOO",
              "KRISHAN KUMAR",
              "737",
              "900",
              "81.89%"
            ]
          },
          {
            "sNo": "217",
            "rollNo": "22009115430014",
            "name": "HARSHDEEP",
            "fatherName": "MEJAR SINGH",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "217",
              "22009115430014",
              "HARSHDEEP",
              "MEJAR SINGH",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "22009115430021",
            "name": "LASHMI",
            "fatherName": "HARBHAJAN",
            "obtainedMarks": "692",
            "maxMarks": "900",
            "percentage": "76.89%",
            "cells": [
              "218",
              "22009115430021",
              "LASHMI",
              "HARBHAJAN",
              "692",
              "900",
              "76.89%"
            ]
          },
          {
            "sNo": "219",
            "rollNo": "22009115430022",
            "name": "KHUSHPREET KAUR",
            "fatherName": "GURSEWAK SINGH",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "219",
              "22009115430022",
              "KHUSHPREET KAUR",
              "GURSEWAK SINGH",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "220",
            "rollNo": "22009115430028",
            "name": "NISHU RANI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "220",
              "22009115430028",
              "NISHU RANI",
              "SURENDER KUMAR",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "221",
            "rollNo": "22009115430039",
            "name": "JYOTI",
            "fatherName": "BALWANT SINGH",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "221",
              "22009115430039",
              "JYOTI",
              "BALWANT SINGH",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "222",
            "rollNo": "22009115430041",
            "name": "POOJA",
            "fatherName": "MAGH RAJ",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "222",
              "22009115430041",
              "POOJA",
              "MAGH RAJ",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "223",
            "rollNo": "22009115430042",
            "name": "SHREYA DEVI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "738",
            "maxMarks": "900",
            "percentage": "82%",
            "cells": [
              "223",
              "22009115430042",
              "SHREYA DEVI",
              "RAJESH KUMAR",
              "738",
              "900",
              "82%"
            ]
          },
          {
            "sNo": "224",
            "rollNo": "22009115430044",
            "name": "POOJA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "780",
            "maxMarks": "900",
            "percentage": "86.67%",
            "cells": [
              "224",
              "22009115430044",
              "POOJA",
              "KRISHAN KUMAR",
              "780",
              "900",
              "86.67%"
            ]
          },
          {
            "sNo": "225",
            "rollNo": "22009115430047",
            "name": "MUSKAN",
            "fatherName": "JAIPAL",
            "obtainedMarks": "739",
            "maxMarks": "900",
            "percentage": "82.11%",
            "cells": [
              "225",
              "22009115430047",
              "MUSKAN",
              "JAIPAL",
              "739",
              "900",
              "82.11%"
            ]
          },
          {
            "sNo": "226",
            "rollNo": "22009115430048",
            "name": "BHARTI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "226",
              "22009115430048",
              "BHARTI",
              "KRISHAN KUMAR",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "227",
            "rollNo": "22009115430049",
            "name": "INTO",
            "fatherName": "JAGDISH",
            "obtainedMarks": "702",
            "maxMarks": "900",
            "percentage": "78%",
            "cells": [
              "227",
              "22009115430049",
              "INTO",
              "JAGDISH",
              "702",
              "900",
              "78%"
            ]
          },
          {
            "sNo": "228",
            "rollNo": "22009115430050",
            "name": "SUMAN DEVI",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "228",
              "22009115430050",
              "SUMAN DEVI",
              "BHOOP SINGH",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "229",
            "rollNo": "22009115430051",
            "name": "SIMRAN KAUR",
            "fatherName": "HARJIT  SINGH",
            "obtainedMarks": "682",
            "maxMarks": "900",
            "percentage": "75.78%",
            "cells": [
              "229",
              "22009115430051",
              "SIMRAN KAUR",
              "HARJIT  SINGH",
              "682",
              "900",
              "75.78%"
            ]
          },
          {
            "sNo": "230",
            "rollNo": "22009115430053",
            "name": "AMANDEEP KAUR",
            "fatherName": "JAGSIR SINGH",
            "obtainedMarks": "701",
            "maxMarks": "900",
            "percentage": "77.89%",
            "cells": [
              "230",
              "22009115430053",
              "AMANDEEP KAUR",
              "JAGSIR SINGH",
              "701",
              "900",
              "77.89%"
            ]
          },
          {
            "sNo": "231",
            "rollNo": "22009115430064",
            "name": "DEEPI",
            "fatherName": "VIJAY PAL",
            "obtainedMarks": "720",
            "maxMarks": "900",
            "percentage": "80%",
            "cells": [
              "231",
              "22009115430064",
              "DEEPI",
              "VIJAY PAL",
              "720",
              "900",
              "80%"
            ]
          },
          {
            "sNo": "232",
            "rollNo": "22009115430065",
            "name": "SALONI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "673",
            "maxMarks": "900",
            "percentage": "74.78%",
            "cells": [
              "232",
              "22009115430065",
              "SALONI",
              "VINOD KUMAR",
              "673",
              "900",
              "74.78%"
            ]
          },
          {
            "sNo": "233",
            "rollNo": "22009115430066",
            "name": "SONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "233",
              "22009115430066",
              "SONIA",
              "SANJAY KUMAR",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "234",
            "rollNo": "22009115430071",
            "name": "MONIKA",
            "fatherName": "MANGE RAM",
            "obtainedMarks": "732",
            "maxMarks": "900",
            "percentage": "81.33%",
            "cells": [
              "234",
              "22009115430071",
              "MONIKA",
              "MANGE RAM",
              "732",
              "900",
              "81.33%"
            ]
          },
          {
            "sNo": "235",
            "rollNo": "22009115430076",
            "name": "MANISHA",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.67%",
            "cells": [
              "235",
              "22009115430076",
              "MANISHA",
              "ANIL KUMAR",
              "636",
              "900",
              "70.67%"
            ]
          },
          {
            "sNo": "236",
            "rollNo": "22009115430087",
            "name": "SNEHA",
            "fatherName": "CHARAN SINGH",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.67%",
            "cells": [
              "236",
              "22009115430087",
              "SNEHA",
              "CHARAN SINGH",
              "663",
              "900",
              "73.67%"
            ]
          },
          {
            "sNo": "237",
            "rollNo": "22009115430091",
            "name": "NEETU",
            "fatherName": "RAJ SINGH",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "237",
              "22009115430091",
              "NEETU",
              "RAJ SINGH",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "238",
            "rollNo": "22009115430101",
            "name": "NISHA",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "238",
              "22009115430101",
              "NISHA",
              "SURENDER SINGH",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "239",
            "rollNo": "22009115430107",
            "name": "MONIKA",
            "fatherName": "LUXMI NARAYAN",
            "obtainedMarks": "690",
            "maxMarks": "900",
            "percentage": "76.67%",
            "cells": [
              "239",
              "22009115430107",
              "MONIKA",
              "LUXMI NARAYAN",
              "690",
              "900",
              "76.67%"
            ]
          },
          {
            "sNo": "240",
            "rollNo": "22009115430115",
            "name": "NEHA",
            "fatherName": "SUBHASH SINGH",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "240",
              "22009115430115",
              "NEHA",
              "SUBHASH SINGH",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "241",
            "rollNo": "22009115430118",
            "name": "TWINKLE",
            "fatherName": "KASHMIRI LAL",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.78%",
            "cells": [
              "241",
              "22009115430118",
              "TWINKLE",
              "KASHMIRI LAL",
              "655",
              "900",
              "72.78%"
            ]
          },
          {
            "sNo": "242",
            "rollNo": "22009115430119",
            "name": "MEHAK",
            "fatherName": "KASHMIRI LAL",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "242",
              "22009115430119",
              "MEHAK",
              "KASHMIRI LAL",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "243",
            "rollNo": "22009115430120",
            "name": "RITIKA",
            "fatherName": "RAM CHANDER",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "243",
              "22009115430120",
              "RITIKA",
              "RAM CHANDER",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "244",
            "rollNo": "22009115430123",
            "name": "BARBIE BABBAR",
            "fatherName": "RAKESH BABBAR",
            "obtainedMarks": "788",
            "maxMarks": "900",
            "percentage": "87.56%",
            "cells": [
              "244",
              "22009115430123",
              "BARBIE BABBAR",
              "RAKESH BABBAR",
              "788",
              "900",
              "87.56%"
            ]
          },
          {
            "sNo": "245",
            "rollNo": "22009115430129",
            "name": "AANCHAL",
            "fatherName": "SARAV MITAR",
            "obtainedMarks": "724",
            "maxMarks": "900",
            "percentage": "80.44%",
            "cells": [
              "245",
              "22009115430129",
              "AANCHAL",
              "SARAV MITAR",
              "724",
              "900",
              "80.44%"
            ]
          },
          {
            "sNo": "246",
            "rollNo": "22009115430137",
            "name": "NEHA",
            "fatherName": "MANGAT RAM",
            "obtainedMarks": "706",
            "maxMarks": "900",
            "percentage": "78.44%",
            "cells": [
              "246",
              "22009115430137",
              "NEHA",
              "MANGAT RAM",
              "706",
              "900",
              "78.44%"
            ]
          },
          {
            "sNo": "247",
            "rollNo": "22009115430145",
            "name": "JYOTI",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "648",
            "maxMarks": "900",
            "percentage": "72%",
            "cells": [
              "247",
              "22009115430145",
              "JYOTI",
              "DHARAMPAL",
              "648",
              "900",
              "72%"
            ]
          },
          {
            "sNo": "248",
            "rollNo": "22009115430146",
            "name": "RAMA RANI",
            "fatherName": "PARDEEP KUMAR",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "248",
              "22009115430146",
              "RAMA RANI",
              "PARDEEP KUMAR",
              "676",
              "900",
              "75.11%"
            ]
          },
          {
            "sNo": "249",
            "rollNo": "22009115430153",
            "name": "SAKSHI INSA",
            "fatherName": "HARIOM INSA",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "249",
              "22009115430153",
              "SAKSHI INSA",
              "HARIOM INSA",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "250",
            "rollNo": "22009115430155",
            "name": "AMANDEEP KAUR",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "683",
            "maxMarks": "900",
            "percentage": "75.89%",
            "cells": [
              "250",
              "22009115430155",
              "AMANDEEP KAUR",
              "PAWAN KUMAR",
              "683",
              "900",
              "75.89%"
            ]
          },
          {
            "sNo": "251",
            "rollNo": "22009115430161",
            "name": "MEHAK SHARMA",
            "fatherName": "SUKHMANDER PAL",
            "obtainedMarks": "786",
            "maxMarks": "900",
            "percentage": "87.33%",
            "cells": [
              "251",
              "22009115430161",
              "MEHAK SHARMA",
              "SUKHMANDER PAL",
              "786",
              "900",
              "87.33%"
            ]
          },
          {
            "sNo": "252",
            "rollNo": "22009115430163",
            "name": "DEEPASHA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "620",
            "maxMarks": "900",
            "percentage": "68.89%",
            "cells": [
              "252",
              "22009115430163",
              "DEEPASHA",
              "NARESH KUMAR",
              "620",
              "900",
              "68.89%"
            ]
          },
          {
            "sNo": "253",
            "rollNo": "22009115430164",
            "name": "GARIMA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "253",
              "22009115430164",
              "GARIMA",
              "NARESH KUMAR",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "254",
            "rollNo": "22009115430168",
            "name": "POOJA",
            "fatherName": "LAL CHAND",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "254",
              "22009115430168",
              "POOJA",
              "LAL CHAND",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "255",
            "rollNo": "22009115430172",
            "name": "AARTI",
            "fatherName": "KARNAIL SINGH",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.67%",
            "cells": [
              "255",
              "22009115430172",
              "AARTI",
              "KARNAIL SINGH",
              "645",
              "900",
              "71.67%"
            ]
          },
          {
            "sNo": "256",
            "rollNo": "22009115430176",
            "name": "POOJA RANI",
            "fatherName": "BALWINDER SINGH",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.56%",
            "cells": [
              "256",
              "22009115430176",
              "POOJA RANI",
              "BALWINDER SINGH",
              "635",
              "900",
              "70.56%"
            ]
          },
          {
            "sNo": "257",
            "rollNo": "22009115430187",
            "name": "RAMANDEEP KAUR",
            "fatherName": "NIRMAL SINGH",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "257",
              "22009115430187",
              "RAMANDEEP KAUR",
              "NIRMAL SINGH",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "258",
            "rollNo": "22009115430189",
            "name": "RAVINA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "670",
            "maxMarks": "900",
            "percentage": "74.44%",
            "cells": [
              "258",
              "22009115430189",
              "RAVINA",
              "RAMESH KUMAR",
              "670",
              "900",
              "74.44%"
            ]
          },
          {
            "sNo": "259",
            "rollNo": "22009115430191",
            "name": "TAMANNA",
            "fatherName": "SURJEET SINGH",
            "obtainedMarks": "706",
            "maxMarks": "900",
            "percentage": "78.44%",
            "cells": [
              "259",
              "22009115430191",
              "TAMANNA",
              "SURJEET SINGH",
              "706",
              "900",
              "78.44%"
            ]
          },
          {
            "sNo": "260",
            "rollNo": "22009115430194",
            "name": "MUSKAAN",
            "fatherName": "NARINDER PAL",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "260",
              "22009115430194",
              "MUSKAAN",
              "NARINDER PAL",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "261",
            "rollNo": "22009115430196",
            "name": "SNEHA",
            "fatherName": "PREETPAL",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "261",
              "22009115430196",
              "SNEHA",
              "PREETPAL",
              "632",
              "900",
              "70.22%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A. (SEM.V +VI)",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "262",
            "rollNo": "21009115430002",
            "name": "SARITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "262",
              "21009115430002",
              "SARITA",
              "RAMESH KUMAR",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "263",
            "rollNo": "21009115430006",
            "name": "RITIKA",
            "fatherName": "LADU RAM",
            "obtainedMarks": "669",
            "maxMarks": "900",
            "percentage": "74.33%",
            "cells": [
              "263",
              "21009115430006",
              "RITIKA",
              "LADU RAM",
              "669",
              "900",
              "74.33%"
            ]
          },
          {
            "sNo": "264",
            "rollNo": "21009115430009",
            "name": "MAMTA",
            "fatherName": "NAURANG",
            "obtainedMarks": "628",
            "maxMarks": "900",
            "percentage": "69.78%",
            "cells": [
              "264",
              "21009115430009",
              "MAMTA",
              "NAURANG",
              "628",
              "900",
              "69.78%"
            ]
          },
          {
            "sNo": "265",
            "rollNo": "21009115430013",
            "name": "POONAM",
            "fatherName": "KRISHAN",
            "obtainedMarks": "702",
            "maxMarks": "900",
            "percentage": "78%",
            "cells": [
              "265",
              "21009115430013",
              "POONAM",
              "KRISHAN",
              "702",
              "900",
              "78%"
            ]
          },
          {
            "sNo": "266",
            "rollNo": "21009115430015",
            "name": "AARTI",
            "fatherName": "UGGARSAIN",
            "obtainedMarks": "725",
            "maxMarks": "900",
            "percentage": "80.56%",
            "cells": [
              "266",
              "21009115430015",
              "AARTI",
              "UGGARSAIN",
              "725",
              "900",
              "80.56%"
            ]
          },
          {
            "sNo": "267",
            "rollNo": "21009115430023",
            "name": "KHUSHBOO",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "267",
              "21009115430023",
              "KHUSHBOO",
              "KRISHAN KUMAR",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "268",
            "rollNo": "21009115430024",
            "name": "MANJU KUMARI",
            "fatherName": "RATTAN SINGH",
            "obtainedMarks": "651",
            "maxMarks": "900",
            "percentage": "72.33%",
            "cells": [
              "268",
              "21009115430024",
              "MANJU KUMARI",
              "RATTAN SINGH",
              "651",
              "900",
              "72.33%"
            ]
          },
          {
            "sNo": "269",
            "rollNo": "21009115430025",
            "name": "KIRAN",
            "fatherName": "KANI RAM",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "269",
              "21009115430025",
              "KIRAN",
              "KANI RAM",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "270",
            "rollNo": "21009115430030",
            "name": "TANISHA",
            "fatherName": "VED PRAKASH",
            "obtainedMarks": "624",
            "maxMarks": "900",
            "percentage": "69.33%",
            "cells": [
              "270",
              "21009115430030",
              "TANISHA",
              "VED PRAKASH",
              "624",
              "900",
              "69.33%"
            ]
          },
          {
            "sNo": "271",
            "rollNo": "21009115430035",
            "name": "ANCHAL",
            "fatherName": "SHER SINGH",
            "obtainedMarks": "709",
            "maxMarks": "900",
            "percentage": "78.78%",
            "cells": [
              "271",
              "21009115430035",
              "ANCHAL",
              "SHER SINGH",
              "709",
              "900",
              "78.78%"
            ]
          },
          {
            "sNo": "272",
            "rollNo": "21009115430043",
            "name": "VARSHA RANI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "272",
              "21009115430043",
              "VARSHA RANI",
              "VIJAY KUMAR",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "273",
            "rollNo": "21009115430046",
            "name": "URMILA",
            "fatherName": "BHAGAT RAM",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "273",
              "21009115430046",
              "URMILA",
              "BHAGAT RAM",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "274",
            "rollNo": "21009115430047",
            "name": "NEHA",
            "fatherName": "ATMA RAM",
            "obtainedMarks": "693",
            "maxMarks": "900",
            "percentage": "77%",
            "cells": [
              "274",
              "21009115430047",
              "NEHA",
              "ATMA RAM",
              "693",
              "900",
              "77%"
            ]
          },
          {
            "sNo": "275",
            "rollNo": "21009115430048",
            "name": "MONIKA RANI",
            "fatherName": "VIJENDER KUMAR",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.67%",
            "cells": [
              "275",
              "21009115430048",
              "MONIKA RANI",
              "VIJENDER KUMAR",
              "645",
              "900",
              "71.67%"
            ]
          },
          {
            "sNo": "276",
            "rollNo": "21009115430051",
            "name": "NEELAM RANI",
            "fatherName": "LAXMAN DASS",
            "obtainedMarks": "687",
            "maxMarks": "900",
            "percentage": "76.33%",
            "cells": [
              "276",
              "21009115430051",
              "NEELAM RANI",
              "LAXMAN DASS",
              "687",
              "900",
              "76.33%"
            ]
          },
          {
            "sNo": "277",
            "rollNo": "21009115430052",
            "name": "NEETU",
            "fatherName": "RAMCHANDER",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "277",
              "21009115430052",
              "NEETU",
              "RAMCHANDER",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "278",
            "rollNo": "21009115430055",
            "name": "PRIYANKA",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "278",
              "21009115430055",
              "PRIYANKA",
              "BALBIR SINGH",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "279",
            "rollNo": "21009115430063",
            "name": "PREETI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "674",
            "maxMarks": "900",
            "percentage": "74.89%",
            "cells": [
              "279",
              "21009115430063",
              "PREETI",
              "RAMESH KUMAR",
              "674",
              "900",
              "74.89%"
            ]
          },
          {
            "sNo": "280",
            "rollNo": "21009115430064",
            "name": "KALPANA",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "650",
            "maxMarks": "900",
            "percentage": "72.22%",
            "cells": [
              "280",
              "21009115430064",
              "KALPANA",
              "SATISH KUMAR",
              "650",
              "900",
              "72.22%"
            ]
          },
          {
            "sNo": "281",
            "rollNo": "21009115430076",
            "name": "RAJNI",
            "fatherName": "RATTAN SINGH",
            "obtainedMarks": "720",
            "maxMarks": "900",
            "percentage": "80%",
            "cells": [
              "281",
              "21009115430076",
              "RAJNI",
              "RATTAN SINGH",
              "720",
              "900",
              "80%"
            ]
          },
          {
            "sNo": "282",
            "rollNo": "21009115430077",
            "name": "SIMRAN",
            "fatherName": "DOLAT RAM",
            "obtainedMarks": "783",
            "maxMarks": "900",
            "percentage": "87%",
            "cells": [
              "282",
              "21009115430077",
              "SIMRAN",
              "DOLAT RAM",
              "783",
              "900",
              "87%"
            ]
          },
          {
            "sNo": "283",
            "rollNo": "21009115430082",
            "name": "MANJEET KAUR",
            "fatherName": "PARGAT SINGH",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "283",
              "21009115430082",
              "MANJEET KAUR",
              "PARGAT SINGH",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "284",
            "rollNo": "21009115430091",
            "name": "JAITAL",
            "fatherName": "BAJRANG",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "284",
              "21009115430091",
              "JAITAL",
              "BAJRANG",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "285",
            "rollNo": "21009115430093",
            "name": "MANISHA",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "734",
            "maxMarks": "900",
            "percentage": "81.56%",
            "cells": [
              "285",
              "21009115430093",
              "MANISHA",
              "BHIM SINGH",
              "734",
              "900",
              "81.56%"
            ]
          },
          {
            "sNo": "286",
            "rollNo": "21009115430101",
            "name": "ARJU",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "286",
              "21009115430101",
              "ARJU",
              "MAHENDER SINGH",
              "742",
              "900",
              "82.44%"
            ]
          },
          {
            "sNo": "287",
            "rollNo": "21009115430102",
            "name": "POOJA DEVI",
            "fatherName": "BALVINDER SINGH",
            "obtainedMarks": "738",
            "maxMarks": "900",
            "percentage": "82%",
            "cells": [
              "287",
              "21009115430102",
              "POOJA DEVI",
              "BALVINDER SINGH",
              "738",
              "900",
              "82%"
            ]
          },
          {
            "sNo": "288",
            "rollNo": "21009115430105",
            "name": "PRIYANKA",
            "fatherName": "BHAGWANT",
            "obtainedMarks": "720",
            "maxMarks": "900",
            "percentage": "80%",
            "cells": [
              "288",
              "21009115430105",
              "PRIYANKA",
              "BHAGWANT",
              "720",
              "900",
              "80%"
            ]
          },
          {
            "sNo": "289",
            "rollNo": "21009115430111",
            "name": "RACHNA",
            "fatherName": "MADAN  LAL",
            "obtainedMarks": "664",
            "maxMarks": "900",
            "percentage": "73.78%",
            "cells": [
              "289",
              "21009115430111",
              "RACHNA",
              "MADAN  LAL",
              "664",
              "900",
              "73.78%"
            ]
          },
          {
            "sNo": "290",
            "rollNo": "21009115430113",
            "name": "JAMNA DEVI",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "668",
            "maxMarks": "900",
            "percentage": "74.22%",
            "cells": [
              "290",
              "21009115430113",
              "JAMNA DEVI",
              "SUBHASH CHANDER",
              "668",
              "900",
              "74.22%"
            ]
          },
          {
            "sNo": "291",
            "rollNo": "21009115430114",
            "name": "BHAWNA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "730",
            "maxMarks": "900",
            "percentage": "81.11%",
            "cells": [
              "291",
              "21009115430114",
              "BHAWNA",
              "KRISHAN KUMAR",
              "730",
              "900",
              "81.11%"
            ]
          },
          {
            "sNo": "292",
            "rollNo": "21009115430119",
            "name": "MONIKA",
            "fatherName": "RAJESH",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "292",
              "21009115430119",
              "MONIKA",
              "RAJESH",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "293",
            "rollNo": "21009115430120",
            "name": "SONU",
            "fatherName": "MAHAVIR",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "293",
              "21009115430120",
              "SONU",
              "MAHAVIR",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "294",
            "rollNo": "21009115430124",
            "name": "POOJA",
            "fatherName": "BHAGAT SINGH",
            "obtainedMarks": "628",
            "maxMarks": "900",
            "percentage": "69.78%",
            "cells": [
              "294",
              "21009115430124",
              "POOJA",
              "BHAGAT SINGH",
              "628",
              "900",
              "69.78%"
            ]
          },
          {
            "sNo": "295",
            "rollNo": "21009115430127",
            "name": "NEELAM",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "628",
            "maxMarks": "900",
            "percentage": "69.78%",
            "cells": [
              "295",
              "21009115430127",
              "NEELAM",
              "SUKHDEV SINGH",
              "628",
              "900",
              "69.78%"
            ]
          },
          {
            "sNo": "296",
            "rollNo": "21009115430137",
            "name": "ANITA",
            "fatherName": "JAIVIR SINGH",
            "obtainedMarks": "627",
            "maxMarks": "900",
            "percentage": "69.67%",
            "cells": [
              "296",
              "21009115430137",
              "ANITA",
              "JAIVIR SINGH",
              "627",
              "900",
              "69.67%"
            ]
          },
          {
            "sNo": "297",
            "rollNo": "21009115430144",
            "name": "ADITI",
            "fatherName": "SODAGAR SETHI",
            "obtainedMarks": "633",
            "maxMarks": "900",
            "percentage": "70.33%",
            "cells": [
              "297",
              "21009115430144",
              "ADITI",
              "SODAGAR SETHI",
              "633",
              "900",
              "70.33%"
            ]
          },
          {
            "sNo": "298",
            "rollNo": "21009115430146",
            "name": "POOJA RANI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "679",
            "maxMarks": "900",
            "percentage": "75.44%",
            "cells": [
              "298",
              "21009115430146",
              "POOJA RANI",
              "RAMESH KUMAR",
              "679",
              "900",
              "75.44%"
            ]
          },
          {
            "sNo": "299",
            "rollNo": "21009115430149",
            "name": "KHUSHI",
            "fatherName": "RAI SINGH",
            "obtainedMarks": "669",
            "maxMarks": "900",
            "percentage": "74.33%",
            "cells": [
              "299",
              "21009115430149",
              "KHUSHI",
              "RAI SINGH",
              "669",
              "900",
              "74.33%"
            ]
          },
          {
            "sNo": "300",
            "rollNo": "21009115430163",
            "name": "RAVINA",
            "fatherName": "SATYVIR SINGH",
            "obtainedMarks": "662",
            "maxMarks": "900",
            "percentage": "73.56%",
            "cells": [
              "300",
              "21009115430163",
              "RAVINA",
              "SATYVIR SINGH",
              "662",
              "900",
              "73.56%"
            ]
          },
          {
            "sNo": "301",
            "rollNo": "21009115430165",
            "name": "AARTI DEVI",
            "fatherName": "SATPAL",
            "obtainedMarks": "647",
            "maxMarks": "900",
            "percentage": "71.89%",
            "cells": [
              "301",
              "21009115430165",
              "AARTI DEVI",
              "SATPAL",
              "647",
              "900",
              "71.89%"
            ]
          },
          {
            "sNo": "302",
            "rollNo": "21009115430169",
            "name": "PRABHJOT KAUR",
            "fatherName": "SARWAN SINGH",
            "obtainedMarks": "631",
            "maxMarks": "900",
            "percentage": "70.11%",
            "cells": [
              "302",
              "21009115430169",
              "PRABHJOT KAUR",
              "SARWAN SINGH",
              "631",
              "900",
              "70.11%"
            ]
          },
          {
            "sNo": "303",
            "rollNo": "21009115430171",
            "name": "KASHIS DEVI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.89%",
            "cells": [
              "303",
              "21009115430171",
              "KASHIS DEVI",
              "VIJAY KUMAR",
              "638",
              "900",
              "70.89%"
            ]
          },
          {
            "sNo": "304",
            "rollNo": "21009115430172",
            "name": "ANKITA RANI",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "653",
            "maxMarks": "900",
            "percentage": "72.56%",
            "cells": [
              "304",
              "21009115430172",
              "ANKITA RANI",
              "RAKESH KUMAR",
              "653",
              "900",
              "72.56%"
            ]
          },
          {
            "sNo": "305",
            "rollNo": "21009115430181",
            "name": "DAYAWANTI",
            "fatherName": "DAYANAND",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "305",
              "21009115430181",
              "DAYAWANTI",
              "DAYANAND",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "306",
            "rollNo": "21009115430184",
            "name": "SUJATA",
            "fatherName": "SATPAL",
            "obtainedMarks": "645",
            "maxMarks": "900",
            "percentage": "71.67%",
            "cells": [
              "306",
              "21009115430184",
              "SUJATA",
              "SATPAL",
              "645",
              "900",
              "71.67%"
            ]
          },
          {
            "sNo": "307",
            "rollNo": "21009115430186",
            "name": "SANIA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "724",
            "maxMarks": "900",
            "percentage": "80.44%",
            "cells": [
              "307",
              "21009115430186",
              "SANIA",
              "RAJ KUMAR",
              "724",
              "900",
              "80.44%"
            ]
          },
          {
            "sNo": "308",
            "rollNo": "21009115430187",
            "name": "ASHANDEEP KAUR",
            "fatherName": "JOGINDER SINGH",
            "obtainedMarks": "698",
            "maxMarks": "900",
            "percentage": "77.56%",
            "cells": [
              "308",
              "21009115430187",
              "ASHANDEEP KAUR",
              "JOGINDER SINGH",
              "698",
              "900",
              "77.56%"
            ]
          },
          {
            "sNo": "309",
            "rollNo": "21009115430188",
            "name": "PUSHPA",
            "fatherName": "RAM NIWAS",
            "obtainedMarks": "743",
            "maxMarks": "900",
            "percentage": "82.56%",
            "cells": [
              "309",
              "21009115430188",
              "PUSHPA",
              "RAM NIWAS",
              "743",
              "900",
              "82.56%"
            ]
          },
          {
            "sNo": "310",
            "rollNo": "21009115430190",
            "name": "ARZ INSAN",
            "fatherName": "AMARJEET",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "310",
              "21009115430190",
              "ARZ INSAN",
              "AMARJEET",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "311",
            "rollNo": "21009115430192",
            "name": "RUCHI",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "652",
            "maxMarks": "900",
            "percentage": "72.44%",
            "cells": [
              "311",
              "21009115430192",
              "RUCHI",
              "SURENDER SINGH",
              "652",
              "900",
              "72.44%"
            ]
          },
          {
            "sNo": "312",
            "rollNo": "21009115430193",
            "name": "LOVEPREET KAUR",
            "fatherName": "JASVIR SINGH",
            "obtainedMarks": "706",
            "maxMarks": "900",
            "percentage": "78.44%",
            "cells": [
              "312",
              "21009115430193",
              "LOVEPREET KAUR",
              "JASVIR SINGH",
              "706",
              "900",
              "78.44%"
            ]
          },
          {
            "sNo": "313",
            "rollNo": "21009115430194",
            "name": "ARZOO",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "727",
            "maxMarks": "900",
            "percentage": "80.78%",
            "cells": [
              "313",
              "21009115430194",
              "ARZOO",
              "ANIL KUMAR",
              "727",
              "900",
              "80.78%"
            ]
          },
          {
            "sNo": "314",
            "rollNo": "21009115430197",
            "name": "KIRAN",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "657",
            "maxMarks": "900",
            "percentage": "73%",
            "cells": [
              "314",
              "21009115430197",
              "KIRAN",
              "MADAN LAL",
              "657",
              "900",
              "73%"
            ]
          },
          {
            "sNo": "315",
            "rollNo": "21009115430199",
            "name": "AASTHA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "315",
              "21009115430199",
              "AASTHA",
              "NARESH KUMAR",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "316",
            "rollNo": "21009115430201",
            "name": "ASMI",
            "fatherName": "PARVEEN KUMAR",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "316",
              "21009115430201",
              "ASMI",
              "PARVEEN KUMAR",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "317",
            "rollNo": "21009115430202",
            "name": "NISHU",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "317",
              "21009115430202",
              "NISHU",
              "SUBHASH CHANDER",
              "742",
              "900",
              "82.44%"
            ]
          },
          {
            "sNo": "318",
            "rollNo": "21009115430203",
            "name": "SAVINA",
            "fatherName": "RAMESH",
            "obtainedMarks": "672",
            "maxMarks": "900",
            "percentage": "74.67%",
            "cells": [
              "318",
              "21009115430203",
              "SAVINA",
              "RAMESH",
              "672",
              "900",
              "74.67%"
            ]
          },
          {
            "sNo": "319",
            "rollNo": "21009115430204",
            "name": "KANISHKA",
            "fatherName": "INDERJEET",
            "obtainedMarks": "740",
            "maxMarks": "900",
            "percentage": "82.22%",
            "cells": [
              "319",
              "21009115430204",
              "KANISHKA",
              "INDERJEET",
              "740",
              "900",
              "82.22%"
            ]
          },
          {
            "sNo": "320",
            "rollNo": "21009115430208",
            "name": "MONIKA SHARMA",
            "fatherName": "MUKESH KUMAR",
            "obtainedMarks": "731",
            "maxMarks": "900",
            "percentage": "81.22%",
            "cells": [
              "320",
              "21009115430208",
              "MONIKA SHARMA",
              "MUKESH KUMAR",
              "731",
              "900",
              "81.22%"
            ]
          },
          {
            "sNo": "321",
            "rollNo": "21009115430209",
            "name": "HARSHMAN SANDHU",
            "fatherName": "TARSEM SINGH",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "321",
              "21009115430209",
              "HARSHMAN SANDHU",
              "TARSEM SINGH",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "322",
            "rollNo": "21009115430211",
            "name": "SILVNEET SIDHU",
            "fatherName": "RANVIR SINGH RANA",
            "obtainedMarks": "663",
            "maxMarks": "900",
            "percentage": "73.67%",
            "cells": [
              "322",
              "21009115430211",
              "SILVNEET SIDHU",
              "RANVIR SINGH RANA",
              "663",
              "900",
              "73.67%"
            ]
          },
          {
            "sNo": "323",
            "rollNo": "21009115430213",
            "name": "ANKITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "654",
            "maxMarks": "900",
            "percentage": "72.67%",
            "cells": [
              "323",
              "21009115430213",
              "ANKITA",
              "RAMESH KUMAR",
              "654",
              "900",
              "72.67%"
            ]
          },
          {
            "sNo": "324",
            "rollNo": "21009115430214",
            "name": "HARJOT KAUR",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "324",
              "21009115430214",
              "HARJOT KAUR",
              "GURJANT SINGH",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "325",
            "rollNo": "21009115430216",
            "name": "KOMAL RANI",
            "fatherName": "ARJUN DASS",
            "obtainedMarks": "666",
            "maxMarks": "900",
            "percentage": "74%",
            "cells": [
              "325",
              "21009115430216",
              "KOMAL RANI",
              "ARJUN DASS",
              "666",
              "900",
              "74%"
            ]
          },
          {
            "sNo": "326",
            "rollNo": "21009115430218",
            "name": "HASANPREET KAUR",
            "fatherName": "GURWINDER SINGH",
            "obtainedMarks": "655",
            "maxMarks": "900",
            "percentage": "72.78%",
            "cells": [
              "326",
              "21009115430218",
              "HASANPREET KAUR",
              "GURWINDER SINGH",
              "655",
              "900",
              "72.78%"
            ]
          },
          {
            "sNo": "327",
            "rollNo": "21009115430221",
            "name": "MONIKA PUNIYA",
            "fatherName": "SATYAVEER SINGH PUNIYA",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "327",
              "21009115430221",
              "MONIKA PUNIYA",
              "SATYAVEER SINGH PUNIYA",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "328",
            "rollNo": "21009115430223",
            "name": "REKHA PUWAR",
            "fatherName": "MALKEET SINGH",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "328",
              "21009115430223",
              "REKHA PUWAR",
              "MALKEET SINGH",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "329",
            "rollNo": "21009115430234",
            "name": "TAMANNA VERMA",
            "fatherName": "RAJBIR SINGH",
            "obtainedMarks": "692",
            "maxMarks": "900",
            "percentage": "76.89%",
            "cells": [
              "329",
              "21009115430234",
              "TAMANNA VERMA",
              "RAJBIR SINGH",
              "692",
              "900",
              "76.89%"
            ]
          },
          {
            "sNo": "330",
            "rollNo": "21009115430236",
            "name": "HARMANPREET KAUR",
            "fatherName": "BALJIT SINGH",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "330",
              "21009115430236",
              "HARMANPREET KAUR",
              "BALJIT SINGH",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "331",
            "rollNo": "21009115430238",
            "name": "VARSHA",
            "fatherName": "VEER SINGH",
            "obtainedMarks": "656",
            "maxMarks": "900",
            "percentage": "72.89%",
            "cells": [
              "331",
              "21009115430238",
              "VARSHA",
              "VEER SINGH",
              "656",
              "900",
              "72.89%"
            ]
          },
          {
            "sNo": "332",
            "rollNo": "21009115430244",
            "name": "RAVINDER KAUR",
            "fatherName": "TARSEM RAJ",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "332",
              "21009115430244",
              "RAVINDER KAUR",
              "TARSEM RAJ",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "333",
            "rollNo": "21009115430262",
            "name": "PARGATI",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "742",
            "maxMarks": "900",
            "percentage": "82.44%",
            "cells": [
              "333",
              "21009115430262",
              "PARGATI",
              "SURENDER SINGH",
              "742",
              "900",
              "82.44%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. ENGLISH I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "23009990300001",
            "name": "GURPREET",
            "fatherName": "DEVIPAL",
            "obtainedMarks": "916",
            "maxMarks": "1300",
            "percentage": "70.46%",
            "cells": [
              "1",
              "23009990300001",
              "GURPREET",
              "DEVIPAL",
              "916",
              "1300",
              "70.46%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. ENGLISH II Year",
        "hasMerit": false,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": []
      },
      {
        "courseName": "M.A. HINDI  I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "2",
            "rollNo": "23009990200001",
            "name": "KIRAN BALA",
            "fatherName": "BIRU RAM",
            "obtainedMarks": "978",
            "maxMarks": "1300",
            "percentage": "75.23%",
            "cells": [
              "2",
              "23009990200001",
              "KIRAN BALA",
              "BIRU RAM",
              "978",
              "1300",
              "75.23%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "23009990200004",
            "name": "SHAKUNTLA",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "1051",
            "maxMarks": "1300",
            "percentage": "80.85%",
            "cells": [
              "3",
              "23009990200004",
              "SHAKUNTLA",
              "RAJENDER SINGH",
              "1051",
              "1300",
              "80.85%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "23009990200005",
            "name": "SUNITA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "983",
            "maxMarks": "1300",
            "percentage": "75.62%",
            "cells": [
              "4",
              "23009990200005",
              "SUNITA",
              "RAJENDER",
              "983",
              "1300",
              "75.62%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "23009990200008",
            "name": "SEEMA DEVI",
            "fatherName": "DALBIR",
            "obtainedMarks": "997",
            "maxMarks": "1300",
            "percentage": "76.69%",
            "cells": [
              "5",
              "23009990200008",
              "SEEMA DEVI",
              "DALBIR",
              "997",
              "1300",
              "76.69%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "23009990200009",
            "name": "SEEMA RANI",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "991",
            "maxMarks": "1300",
            "percentage": "76.23%",
            "cells": [
              "6",
              "23009990200009",
              "SEEMA RANI",
              "GURJANT SINGH",
              "991",
              "1300",
              "76.23%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "23009990200010",
            "name": "SHURABHI",
            "fatherName": "MAHENDER",
            "obtainedMarks": "1071",
            "maxMarks": "1300",
            "percentage": "82.38%",
            "cells": [
              "7",
              "23009990200010",
              "SHURABHI",
              "MAHENDER",
              "1071",
              "1300",
              "82.38%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "23009990200012",
            "name": "POONAM",
            "fatherName": "SUBASH",
            "obtainedMarks": "1060",
            "maxMarks": "1300",
            "percentage": "81.54%",
            "cells": [
              "8",
              "23009990200012",
              "POONAM",
              "SUBASH",
              "1060",
              "1300",
              "81.54%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "23009990200013",
            "name": "PRIYANKA",
            "fatherName": "NARESH",
            "obtainedMarks": "999",
            "maxMarks": "1300",
            "percentage": "76.85%",
            "cells": [
              "9",
              "23009990200013",
              "PRIYANKA",
              "NARESH",
              "999",
              "1300",
              "76.85%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "23009990200014",
            "name": "SANDEEP KUMARI",
            "fatherName": "SUBESINGH",
            "obtainedMarks": "989",
            "maxMarks": "1300",
            "percentage": "76.08%",
            "cells": [
              "10",
              "23009990200014",
              "SANDEEP KUMARI",
              "SUBESINGH",
              "989",
              "1300",
              "76.08%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "23009990200016",
            "name": "POOJA",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1052",
            "maxMarks": "1300",
            "percentage": "80.92%",
            "cells": [
              "11",
              "23009990200016",
              "POOJA",
              "MAHENDER SINGH",
              "1052",
              "1300",
              "80.92%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "23009990200017",
            "name": "RENU",
            "fatherName": "MAHAVIR",
            "obtainedMarks": "1062",
            "maxMarks": "1300",
            "percentage": "81.69%",
            "cells": [
              "12",
              "23009990200017",
              "RENU",
              "MAHAVIR",
              "1062",
              "1300",
              "81.69%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "23009990200019",
            "name": "SUJATA RANI",
            "fatherName": "NATHU RAM",
            "obtainedMarks": "998",
            "maxMarks": "1300",
            "percentage": "76.77%",
            "cells": [
              "13",
              "23009990200019",
              "SUJATA RANI",
              "NATHU RAM",
              "998",
              "1300",
              "76.77%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "23009990200020",
            "name": "RITU RANI",
            "fatherName": "BINDER RAM",
            "obtainedMarks": "969",
            "maxMarks": "1300",
            "percentage": "74.54%",
            "cells": [
              "14",
              "23009990200020",
              "RITU RANI",
              "BINDER RAM",
              "969",
              "1300",
              "74.54%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A.HINDI II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "15",
            "rollNo": "22009990200001",
            "name": "PRITAM RANI",
            "fatherName": "JAGDISH CHAND",
            "obtainedMarks": "978",
            "maxMarks": "1200",
            "percentage": "81.50%",
            "cells": [
              "15",
              "22009990200001",
              "PRITAM RANI",
              "JAGDISH CHAND",
              "978",
              "1200",
              "81.50%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "22009990200003",
            "name": "RENU",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "964",
            "maxMarks": "1200",
            "percentage": "80.33%",
            "cells": [
              "16",
              "22009990200003",
              "RENU",
              "RANBIR SINGH",
              "964",
              "1200",
              "80.33%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "22009990200004",
            "name": "KAVITA  RANI",
            "fatherName": "RAM  PRAKASH",
            "obtainedMarks": "934",
            "maxMarks": "1200",
            "percentage": "77.83%",
            "cells": [
              "17",
              "22009990200004",
              "KAVITA  RANI",
              "RAM  PRAKASH",
              "934",
              "1200",
              "77.83%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "22009990200005",
            "name": "RAMNEET KAUR",
            "fatherName": "SATPAL SINGH",
            "obtainedMarks": "950",
            "maxMarks": "1200",
            "percentage": "79.17%",
            "cells": [
              "18",
              "22009990200005",
              "RAMNEET KAUR",
              "SATPAL SINGH",
              "950",
              "1200",
              "79.17%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "22009990200008",
            "name": "KIRAN",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "940",
            "maxMarks": "1200",
            "percentage": "78.33%",
            "cells": [
              "19",
              "22009990200008",
              "KIRAN",
              "RAM SINGH",
              "940",
              "1200",
              "78.33%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "22009990200009",
            "name": "RITU",
            "fatherName": "SAHAB  RAM",
            "obtainedMarks": "948",
            "maxMarks": "1200",
            "percentage": "79%",
            "cells": [
              "20",
              "22009990200009",
              "RITU",
              "SAHAB  RAM",
              "948",
              "1200",
              "79%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "22009990200011",
            "name": "MANJU",
            "fatherName": "RAMRAKH",
            "obtainedMarks": "998",
            "maxMarks": "1200",
            "percentage": "83.17%",
            "cells": [
              "21",
              "22009990200011",
              "MANJU",
              "RAMRAKH",
              "998",
              "1200",
              "83.17%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "22009990200012",
            "name": "SANTOSH RANI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "909",
            "maxMarks": "1200",
            "percentage": "75.75%",
            "cells": [
              "22",
              "22009990200012",
              "SANTOSH RANI",
              "RAMESH KUMAR",
              "909",
              "1200",
              "75.75%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "22009990200013",
            "name": "SUKHVEERPAL KAUR",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "931",
            "maxMarks": "1200",
            "percentage": "77.58%",
            "cells": [
              "23",
              "22009990200013",
              "SUKHVEERPAL KAUR",
              "SUKHDEV SINGH",
              "931",
              "1200",
              "77.58%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "22009990200014",
            "name": "NANKI",
            "fatherName": "AJAYAB SINGH",
            "obtainedMarks": "956",
            "maxMarks": "1200",
            "percentage": "79.67%",
            "cells": [
              "24",
              "22009990200014",
              "NANKI",
              "AJAYAB SINGH",
              "956",
              "1200",
              "79.67%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "22009990200015",
            "name": "PHULLSIKANDA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "966",
            "maxMarks": "1200",
            "percentage": "80.50%",
            "cells": [
              "25",
              "22009990200015",
              "PHULLSIKANDA",
              "RAMESH KUMAR",
              "966",
              "1200",
              "80.50%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "22009990200020",
            "name": "SHEETAL DEVI",
            "fatherName": "DARSHAN  LAL",
            "obtainedMarks": "961",
            "maxMarks": "1200",
            "percentage": "80.08%",
            "cells": [
              "26",
              "22009990200020",
              "SHEETAL DEVI",
              "DARSHAN  LAL",
              "961",
              "1200",
              "80.08%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "22009990200021",
            "name": "MANDEEP  KAUR",
            "fatherName": "GURDHIYAN  SINGH",
            "obtainedMarks": "950",
            "maxMarks": "1200",
            "percentage": "79.17%",
            "cells": [
              "27",
              "22009990200021",
              "MANDEEP  KAUR",
              "GURDHIYAN  SINGH",
              "950",
              "1200",
              "79.17%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC.MATHS I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "28",
            "rollNo": "23009993510003",
            "name": "POOJA",
            "fatherName": "SURENDER",
            "obtainedMarks": "994",
            "maxMarks": "1250",
            "percentage": "79.52%",
            "cells": [
              "28",
              "23009993510003",
              "POOJA",
              "SURENDER",
              "994",
              "1250",
              "79.52%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "23009993510006",
            "name": "KHUSHPREET",
            "fatherName": "BALJEET SINGH",
            "obtainedMarks": "967",
            "maxMarks": "1250",
            "percentage": "77.36%",
            "cells": [
              "29",
              "23009993510006",
              "KHUSHPREET",
              "BALJEET SINGH",
              "967",
              "1250",
              "77.36%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC.MATHS II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "30",
            "rollNo": "22009993510001",
            "name": "ARJU",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "1109",
            "maxMarks": "1300",
            "percentage": "85.30%",
            "cells": [
              "30",
              "22009993510001",
              "ARJU",
              "SURENDER KUMAR",
              "1109",
              "1300",
              "85.30%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "22009993510003",
            "name": "REENU RANI",
            "fatherName": "NARINDER KUMAR",
            "obtainedMarks": "987",
            "maxMarks": "1300",
            "percentage": "75.92%",
            "cells": [
              "31",
              "22009993510003",
              "REENU RANI",
              "NARINDER KUMAR",
              "987",
              "1300",
              "75.92%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "22009993510005",
            "name": "DARSHANA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "954",
            "maxMarks": "1300",
            "percentage": "73%",
            "cells": [
              "32",
              "22009993510005",
              "DARSHANA",
              "SURENDER KUMAR",
              "954",
              "1300",
              "73%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "22009993510012",
            "name": "KAVITA",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "945",
            "maxMarks": "1300",
            "percentage": "72%",
            "cells": [
              "33",
              "22009993510012",
              "KAVITA",
              "DEVI LAL",
              "945",
              "1300",
              "72%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A.PUB.ADM.  I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "34",
            "rollNo": "23009990140002",
            "name": "DIVYA DHOLIA",
            "fatherName": "PAWAN KUMAR DHOLIA",
            "obtainedMarks": "919",
            "maxMarks": "1300",
            "percentage": "70.69%",
            "cells": [
              "34",
              "23009990140002",
              "DIVYA DHOLIA",
              "PAWAN KUMAR DHOLIA",
              "919",
              "1300",
              "70.69%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "23009990140003",
            "name": "ANISHA",
            "fatherName": "DALBIR SINGH",
            "obtainedMarks": "1094",
            "maxMarks": "1300",
            "percentage": "84.15%",
            "cells": [
              "35",
              "23009990140003",
              "ANISHA",
              "DALBIR SINGH",
              "1094",
              "1300",
              "84.15%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "23009990140004",
            "name": "MS. KOMAL",
            "fatherName": "ROHTASH KUMAR",
            "obtainedMarks": "942",
            "maxMarks": "1300",
            "percentage": "72.46%",
            "cells": [
              "36",
              "23009990140004",
              "MS. KOMAL",
              "ROHTASH KUMAR",
              "942",
              "1300",
              "72.46%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "23009990140005",
            "name": "NEELAM",
            "fatherName": "SUBHASH",
            "obtainedMarks": "918",
            "maxMarks": "1300",
            "percentage": "70.62%",
            "cells": [
              "37",
              "23009990140005",
              "NEELAM",
              "SUBHASH",
              "918",
              "1300",
              "70.62%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "23009990140007",
            "name": "NEETU",
            "fatherName": "RAM KUMAR",
            "obtainedMarks": "911",
            "maxMarks": "1300",
            "percentage": "70.08%",
            "cells": [
              "38",
              "23009990140007",
              "NEETU",
              "RAM KUMAR",
              "911",
              "1300",
              "70.08%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "23009990140008",
            "name": "POOJA RANI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "918",
            "maxMarks": "1300",
            "percentage": "70.62%",
            "cells": [
              "39",
              "23009990140008",
              "POOJA RANI",
              "VINOD KUMAR",
              "918",
              "1300",
              "70.62%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "23009990140009",
            "name": "ANITA RANI",
            "fatherName": "RAJENDER PRASAD",
            "obtainedMarks": "979",
            "maxMarks": "1300",
            "percentage": "75.31%",
            "cells": [
              "40",
              "23009990140009",
              "ANITA RANI",
              "RAJENDER PRASAD",
              "979",
              "1300",
              "75.31%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "23009990140014",
            "name": "KAVITA DEVI",
            "fatherName": "SUBHASH",
            "obtainedMarks": "1062",
            "maxMarks": "1300",
            "percentage": "81.69%",
            "cells": [
              "41",
              "23009990140014",
              "KAVITA DEVI",
              "SUBHASH",
              "1062",
              "1300",
              "81.69%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "23009990140015",
            "name": "PRIYANKA",
            "fatherName": "SATVIR SINGH",
            "obtainedMarks": "936",
            "maxMarks": "1300",
            "percentage": "72%",
            "cells": [
              "42",
              "23009990140015",
              "PRIYANKA",
              "SATVIR SINGH",
              "936",
              "1300",
              "72%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "23009990140016",
            "name": "BHAWNA",
            "fatherName": "SATVEER",
            "obtainedMarks": "1048",
            "maxMarks": "1300",
            "percentage": "80.62%",
            "cells": [
              "43",
              "23009990140016",
              "BHAWNA",
              "SATVEER",
              "1048",
              "1300",
              "80.62%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "23009990140017",
            "name": "RENU BALA",
            "fatherName": "DHARMA RAM",
            "obtainedMarks": "986",
            "maxMarks": "1300",
            "percentage": "75.85%",
            "cells": [
              "44",
              "23009990140017",
              "RENU BALA",
              "DHARMA RAM",
              "986",
              "1300",
              "75.85%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "23009990140018",
            "name": "PARWATI",
            "fatherName": "RAMAN KUMAR",
            "obtainedMarks": "957",
            "maxMarks": "1300",
            "percentage": "73.62%",
            "cells": [
              "45",
              "23009990140018",
              "PARWATI",
              "RAMAN KUMAR",
              "957",
              "1300",
              "73.62%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "23009990140021",
            "name": "RACHNA",
            "fatherName": "HAWA SINGH",
            "obtainedMarks": "939",
            "maxMarks": "1300",
            "percentage": "72.23%",
            "cells": [
              "46",
              "23009990140021",
              "RACHNA",
              "HAWA SINGH",
              "939",
              "1300",
              "72.23%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "23009990140023",
            "name": "SHOBHA",
            "fatherName": "RAJNEESH",
            "obtainedMarks": "937",
            "maxMarks": "1300",
            "percentage": "72.08%",
            "cells": [
              "47",
              "23009990140023",
              "SHOBHA",
              "RAJNEESH",
              "937",
              "1300",
              "72.08%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "23009990140026",
            "name": "MONIKA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "988",
            "maxMarks": "1300",
            "percentage": "76%",
            "cells": [
              "48",
              "23009990140026",
              "MONIKA",
              "RAJENDER KUMAR",
              "988",
              "1300",
              "76%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "22009990140003",
            "name": "DEVKI",
            "fatherName": "CHAND RAM",
            "obtainedMarks": "873",
            "maxMarks": "1200",
            "percentage": "72.75%",
            "cells": [
              "49",
              "22009990140003",
              "DEVKI",
              "CHAND RAM",
              "873",
              "1200",
              "72.75%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "22009990140005",
            "name": "ANURADHA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "846",
            "maxMarks": "1200",
            "percentage": "70.50%",
            "cells": [
              "50",
              "22009990140005",
              "ANURADHA",
              "MOHAN LAL",
              "846",
              "1200",
              "70.50%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "22009990140012",
            "name": "RIYA",
            "fatherName": "SATYA NARYAN",
            "obtainedMarks": "879",
            "maxMarks": "1200",
            "percentage": "73.25%",
            "cells": [
              "51",
              "22009990140012",
              "RIYA",
              "SATYA NARYAN",
              "879",
              "1200",
              "73.25%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "22009990140014",
            "name": "NAMAN",
            "fatherName": "AJAY  TANWAR",
            "obtainedMarks": "900",
            "maxMarks": "1200",
            "percentage": "75%",
            "cells": [
              "52",
              "22009990140014",
              "NAMAN",
              "AJAY  TANWAR",
              "900",
              "1200",
              "75%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "22009990140019",
            "name": "SAROJ RANI",
            "fatherName": "GURMEET SINGH",
            "obtainedMarks": "845",
            "maxMarks": "1200",
            "percentage": "70.42%",
            "cells": [
              "53",
              "22009990140019",
              "SAROJ RANI",
              "GURMEET SINGH",
              "845",
              "1200",
              "70.42%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM  I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "54",
            "rollNo": "23009990080002",
            "name": "SANDUJA",
            "fatherName": "LEELU RAM",
            "obtainedMarks": "942",
            "maxMarks": "1200",
            "percentage": "78.50%",
            "cells": [
              "54",
              "23009990080002",
              "SANDUJA",
              "LEELU RAM",
              "942",
              "1200",
              "78.50%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "23009990080006",
            "name": "TARANPREET KAUR",
            "fatherName": "SATNAM SINGH",
            "obtainedMarks": "894",
            "maxMarks": "1200",
            "percentage": "74.50%",
            "cells": [
              "55",
              "23009990080006",
              "TARANPREET KAUR",
              "SATNAM SINGH",
              "894",
              "1200",
              "74.50%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "23009990080008",
            "name": "JASLEEN KAUR",
            "fatherName": "RAJVEER SINGH",
            "obtainedMarks": "880",
            "maxMarks": "1200",
            "percentage": "73.33%",
            "cells": [
              "56",
              "23009990080008",
              "JASLEEN KAUR",
              "RAJVEER SINGH",
              "880",
              "1200",
              "73.33%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "23009990080010",
            "name": "AASHIMA",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "901",
            "maxMarks": "1200",
            "percentage": "75.08%",
            "cells": [
              "57",
              "23009990080010",
              "AASHIMA",
              "DHARAMPAL",
              "901",
              "1200",
              "75.08%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "23009990080011",
            "name": "RIYA ARORA",
            "fatherName": "TARSEM KUMAR",
            "obtainedMarks": "866",
            "maxMarks": "1200",
            "percentage": "72.17%",
            "cells": [
              "58",
              "23009990080011",
              "RIYA ARORA",
              "TARSEM KUMAR",
              "866",
              "1200",
              "72.17%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "23009990080012",
            "name": "NAVDEEP KAUR",
            "fatherName": "PARMPREET SINGH",
            "obtainedMarks": "878",
            "maxMarks": "1200",
            "percentage": "73.17%",
            "cells": [
              "59",
              "23009990080012",
              "NAVDEEP KAUR",
              "PARMPREET SINGH",
              "878",
              "1200",
              "73.17%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "23009990080013",
            "name": "SONAM KUMARI",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "845",
            "maxMarks": "1200",
            "percentage": "70.42%",
            "cells": [
              "60",
              "23009990080013",
              "SONAM KUMARI",
              "SURESH KUMAR",
              "845",
              "1200",
              "70.42%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "23009990080014",
            "name": "NISHTHA INSAN",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "890",
            "maxMarks": "1200",
            "percentage": "74.17%",
            "cells": [
              "61",
              "23009990080014",
              "NISHTHA INSAN",
              "PAWAN KUMAR",
              "890",
              "1200",
              "74.17%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM  II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "62",
            "rollNo": "22009990080001",
            "name": "RENU SONAM",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "1050",
            "maxMarks": "1400",
            "percentage": "75%",
            "cells": [
              "62",
              "22009990080001",
              "RENU SONAM",
              "SUSHIL KUMAR",
              "1050",
              "1400",
              "75%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "22009990080002",
            "name": "KOMAL",
            "fatherName": "LAJPAT RAI",
            "obtainedMarks": "1032",
            "maxMarks": "1400",
            "percentage": "73.71%",
            "cells": [
              "63",
              "22009990080002",
              "KOMAL",
              "LAJPAT RAI",
              "1032",
              "1400",
              "73.71%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "22009990080003",
            "name": "SEFI",
            "fatherName": "SATPAL",
            "obtainedMarks": "1029",
            "maxMarks": "1400",
            "percentage": "73.50%",
            "cells": [
              "64",
              "22009990080003",
              "SEFI",
              "SATPAL",
              "1029",
              "1400",
              "73.50%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "22009990080003",
            "name": "KOMAL",
            "fatherName": "OMPARKASH",
            "obtainedMarks": "998",
            "maxMarks": "1400",
            "percentage": "71.29%",
            "cells": [
              "65",
              "22009990080003",
              "KOMAL",
              "OMPARKASH",
              "998",
              "1400",
              "71.29%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "22009990080006",
            "name": "YASMINE",
            "fatherName": "RAMPAL SAINI",
            "obtainedMarks": "1020",
            "maxMarks": "1400",
            "percentage": "72.86%",
            "cells": [
              "66",
              "22009990080006",
              "YASMINE",
              "RAMPAL SAINI",
              "1020",
              "1400",
              "72.86%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "22009990080007",
            "name": "SURBI RANI",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "1038",
            "maxMarks": "1400",
            "percentage": "74.14%",
            "cells": [
              "67",
              "22009990080007",
              "SURBI RANI",
              "BANSI LAL",
              "1038",
              "1400",
              "74.14%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "22009990080010",
            "name": "SIMRAN",
            "fatherName": "KRISHAN  LAL",
            "obtainedMarks": "1005",
            "maxMarks": "1400",
            "percentage": "71.79%",
            "cells": [
              "68",
              "22009990080010",
              "SIMRAN",
              "KRISHAN  LAL",
              "1005",
              "1400",
              "71.79%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "22009990080011",
            "name": "SIMRAN",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1087",
            "maxMarks": "1400",
            "percentage": "77.64%",
            "cells": [
              "69",
              "22009990080011",
              "SIMRAN",
              "PAWAN KUMAR",
              "1087",
              "1400",
              "77.64%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "22009990080012",
            "name": "POOJA RANI",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "982",
            "maxMarks": "1400",
            "percentage": "70.14%",
            "cells": [
              "70",
              "22009990080012",
              "POOJA RANI",
              "HARI SINGH",
              "982",
              "1400",
              "70.14%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "22009990080014",
            "name": "NISHU RANI",
            "fatherName": "SURENDER PAL",
            "obtainedMarks": "997",
            "maxMarks": "1400",
            "percentage": "71.21%",
            "cells": [
              "71",
              "22009990080014",
              "NISHU RANI",
              "SURENDER PAL",
              "997",
              "1400",
              "71.21%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "22009990080015",
            "name": "MANPREET",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "1082",
            "maxMarks": "1400",
            "percentage": "77.29%",
            "cells": [
              "72",
              "22009990080015",
              "MANPREET",
              "AVTAR SINGH",
              "1082",
              "1400",
              "77.29%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "22009990080017",
            "name": "SEEMA",
            "fatherName": "SURENDER",
            "obtainedMarks": "1024",
            "maxMarks": "1400",
            "percentage": "73.14%",
            "cells": [
              "73",
              "22009990080017",
              "SEEMA",
              "SURENDER",
              "1024",
              "1400",
              "73.14%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "22009990080018",
            "name": "SIMRAN INSA",
            "fatherName": "SATYA DEV INSA",
            "obtainedMarks": "1063",
            "maxMarks": "1400",
            "percentage": "75.93%",
            "cells": [
              "74",
              "22009990080018",
              "SIMRAN INSA",
              "SATYA DEV INSA",
              "1063",
              "1400",
              "75.93%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "22009990080021",
            "name": "POOJA",
            "fatherName": "SATBIR",
            "obtainedMarks": "985",
            "maxMarks": "1400",
            "percentage": "70.36%",
            "cells": [
              "75",
              "22009990080021",
              "POOJA",
              "SATBIR",
              "985",
              "1400",
              "70.36%"
            ]
          }
        ]
      },
      {
        "courseName": "B.P.Ed. I  Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "76",
            "rollNo": "23009115510001",
            "name": "POONAM",
            "fatherName": "LEELU RAM",
            "obtainedMarks": "1296",
            "maxMarks": "1600",
            "percentage": "81%",
            "cells": [
              "76",
              "23009115510001",
              "POONAM",
              "LEELU RAM",
              "1296",
              "1600",
              "81%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "23009115510002",
            "name": "KAMALDEEP KAUR",
            "fatherName": "MALKIT SINGH",
            "obtainedMarks": "1203",
            "maxMarks": "1600",
            "percentage": "75.18%",
            "cells": [
              "77",
              "23009115510002",
              "KAMALDEEP KAUR",
              "MALKIT SINGH",
              "1203",
              "1600",
              "75.18%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "23009115510004",
            "name": "MAMTA",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "1264",
            "maxMarks": "1600",
            "percentage": "79%",
            "cells": [
              "78",
              "23009115510004",
              "MAMTA",
              "AMAR SINGH",
              "1264",
              "1600",
              "79%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "23009115510005",
            "name": "SUNITA",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1261",
            "maxMarks": "1600",
            "percentage": "78.81%",
            "cells": [
              "79",
              "23009115510005",
              "SUNITA",
              "BHOOP SINGH",
              "1261",
              "1600",
              "78.81%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "23009115510006",
            "name": "SUMAN BALA",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "1155",
            "maxMarks": "1600",
            "percentage": "72.18%",
            "cells": [
              "80",
              "23009115510006",
              "SUMAN BALA",
              "AATMA RAM",
              "1155",
              "1600",
              "72.18%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "23009115510008",
            "name": "AANCHAL",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "1240",
            "maxMarks": "1600",
            "percentage": "77.50%",
            "cells": [
              "81",
              "23009115510008",
              "AANCHAL",
              "SATISH KUMAR",
              "1240",
              "1600",
              "77.50%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "23009115510009",
            "name": "PRIYANKA",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "1269",
            "maxMarks": "1600",
            "percentage": "79.31%",
            "cells": [
              "82",
              "23009115510009",
              "PRIYANKA",
              "DEVI LAL",
              "1269",
              "1600",
              "79.31%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "23009115510010",
            "name": "SARIKA BISHNOI",
            "fatherName": "SUBHASH CHANDER GODARA",
            "obtainedMarks": "1239",
            "maxMarks": "1600",
            "percentage": "77.43%",
            "cells": [
              "83",
              "23009115510010",
              "SARIKA BISHNOI",
              "SUBHASH CHANDER GODARA",
              "1239",
              "1600",
              "77.43%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "23009115510012",
            "name": "DHAPA",
            "fatherName": "SURAJ BHAN",
            "obtainedMarks": "1149",
            "maxMarks": "1600",
            "percentage": "71.81%",
            "cells": [
              "84",
              "23009115510012",
              "DHAPA",
              "SURAJ BHAN",
              "1149",
              "1600",
              "71.81%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "23009115510014",
            "name": "KAVITA",
            "fatherName": "KRISHNA KUMAR",
            "obtainedMarks": "1166",
            "maxMarks": "1600",
            "percentage": "72.87%",
            "cells": [
              "85",
              "23009115510014",
              "KAVITA",
              "KRISHNA KUMAR",
              "1166",
              "1600",
              "72.87%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "23009115510017",
            "name": "NISHA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "86",
              "23009115510017",
              "NISHA",
              "SUBHASH CHANDER",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "23009115510018",
            "name": "NIRMA",
            "fatherName": "HARISINGH",
            "obtainedMarks": "1246",
            "maxMarks": "1600",
            "percentage": "77.87%",
            "cells": [
              "87",
              "23009115510018",
              "NIRMA",
              "HARISINGH",
              "1246",
              "1600",
              "77.87%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "23009115510020",
            "name": "SUMAN",
            "fatherName": "DAYACHAND",
            "obtainedMarks": "1143",
            "maxMarks": "1600",
            "percentage": "71.40%",
            "cells": [
              "88",
              "23009115510020",
              "SUMAN",
              "DAYACHAND",
              "1143",
              "1600",
              "71.40%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "23009115510021",
            "name": "REENA",
            "fatherName": "KRISHAN LAL",
            "obtainedMarks": "1319",
            "maxMarks": "1600",
            "percentage": "82.43%",
            "cells": [
              "89",
              "23009115510021",
              "REENA",
              "KRISHAN LAL",
              "1319",
              "1600",
              "82.43%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "23009115510022",
            "name": "MANJU RANI",
            "fatherName": "LAL CHAND",
            "obtainedMarks": "1231",
            "maxMarks": "1600",
            "percentage": "76.93%",
            "cells": [
              "90",
              "23009115510022",
              "MANJU RANI",
              "LAL CHAND",
              "1231",
              "1600",
              "76.93%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "23009115510023",
            "name": "KAVITA",
            "fatherName": "RATI RAM",
            "obtainedMarks": "1223",
            "maxMarks": "1600",
            "percentage": "76.43%",
            "cells": [
              "91",
              "23009115510023",
              "KAVITA",
              "RATI RAM",
              "1223",
              "1600",
              "76.43%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "23009115510024",
            "name": "RAVINA DEVI",
            "fatherName": "SULTAN RAM",
            "obtainedMarks": "1194",
            "maxMarks": "1600",
            "percentage": "74.62%",
            "cells": [
              "92",
              "23009115510024",
              "RAVINA DEVI",
              "SULTAN RAM",
              "1194",
              "1600",
              "74.62%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "23009115510025",
            "name": "MANISHA",
            "fatherName": "BALBEER",
            "obtainedMarks": "1274",
            "maxMarks": "1600",
            "percentage": "79.62%",
            "cells": [
              "93",
              "23009115510025",
              "MANISHA",
              "BALBEER",
              "1274",
              "1600",
              "79.62%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "23009115510026",
            "name": "MINAL",
            "fatherName": "BAL KRISHAN",
            "obtainedMarks": "1264",
            "maxMarks": "1600",
            "percentage": "79%",
            "cells": [
              "94",
              "23009115510026",
              "MINAL",
              "BAL KRISHAN",
              "1264",
              "1600",
              "79%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "23009115510027",
            "name": "RAJNI",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "1235",
            "maxMarks": "1600",
            "percentage": "77.18%",
            "cells": [
              "95",
              "23009115510027",
              "RAJNI",
              "BHIM SINGH",
              "1235",
              "1600",
              "77.18%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "23009115510028",
            "name": "RINKU",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "1239",
            "maxMarks": "1600",
            "percentage": "77.43%",
            "cells": [
              "96",
              "23009115510028",
              "RINKU",
              "RAJENDER SINGH",
              "1239",
              "1600",
              "77.43%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "23009115510029",
            "name": "RENU",
            "fatherName": "PRAHALAD",
            "obtainedMarks": "1258",
            "maxMarks": "1600",
            "percentage": "78.62%",
            "cells": [
              "97",
              "23009115510029",
              "RENU",
              "PRAHALAD",
              "1258",
              "1600",
              "78.62%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "23009115510030",
            "name": "KOMAL BANO",
            "fatherName": "JANAB ALI",
            "obtainedMarks": "1212",
            "maxMarks": "1600",
            "percentage": "75.75%",
            "cells": [
              "98",
              "23009115510030",
              "KOMAL BANO",
              "JANAB ALI",
              "1212",
              "1600",
              "75.75%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "23009115510031",
            "name": "SUKHWANTI",
            "fatherName": "CHETAN RAM",
            "obtainedMarks": "1280",
            "maxMarks": "1600",
            "percentage": "80%",
            "cells": [
              "99",
              "23009115510031",
              "SUKHWANTI",
              "CHETAN RAM",
              "1280",
              "1600",
              "80%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "23009115510032",
            "name": "POONAM",
            "fatherName": "DILBAG",
            "obtainedMarks": "1176",
            "maxMarks": "1600",
            "percentage": "73.50%",
            "cells": [
              "100",
              "23009115510032",
              "POONAM",
              "DILBAG",
              "1176",
              "1600",
              "73.50%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "23009115510033",
            "name": "VIRPAL KAUR SRA",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "1259",
            "maxMarks": "1600",
            "percentage": "78.68%",
            "cells": [
              "101",
              "23009115510033",
              "VIRPAL KAUR SRA",
              "SUKHDEV SINGH",
              "1259",
              "1600",
              "78.68%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "23009115510035",
            "name": "SHITAL",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "1141",
            "maxMarks": "1600",
            "percentage": "71.31%",
            "cells": [
              "102",
              "23009115510035",
              "SHITAL",
              "AATMA RAM",
              "1141",
              "1600",
              "71.31%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "23009115510037",
            "name": "NIKITA",
            "fatherName": "OMPARKASH",
            "obtainedMarks": "1332",
            "maxMarks": "1600",
            "percentage": "83.25%",
            "cells": [
              "103",
              "23009115510037",
              "NIKITA",
              "OMPARKASH",
              "1332",
              "1600",
              "83.25%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "23009115510038",
            "name": "NAVNEET KAUR",
            "fatherName": "JASVEER SINGH",
            "obtainedMarks": "1266",
            "maxMarks": "1600",
            "percentage": "79.12%",
            "cells": [
              "104",
              "23009115510038",
              "NAVNEET KAUR",
              "JASVEER SINGH",
              "1266",
              "1600",
              "79.12%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "23009115510040",
            "name": "SUSHILA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1172",
            "maxMarks": "1600",
            "percentage": "73.25%",
            "cells": [
              "105",
              "23009115510040",
              "SUSHILA",
              "KRISHAN KUMAR",
              "1172",
              "1600",
              "73.25%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "23009115510041",
            "name": "NEETU",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1238",
            "maxMarks": "1600",
            "percentage": "77.37%",
            "cells": [
              "106",
              "23009115510041",
              "NEETU",
              "BHOOP SINGH",
              "1238",
              "1600",
              "77.37%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "23009115510043",
            "name": "PARVEEN BALA",
            "fatherName": "LEKH RAJ",
            "obtainedMarks": "1192",
            "maxMarks": "1600",
            "percentage": "74.50%",
            "cells": [
              "107",
              "23009115510043",
              "PARVEEN BALA",
              "LEKH RAJ",
              "1192",
              "1600",
              "74.50%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "23009115510048",
            "name": "POONAM",
            "fatherName": "DHARAM PAL",
            "obtainedMarks": "1224",
            "maxMarks": "1600",
            "percentage": "76.50%",
            "cells": [
              "108",
              "23009115510048",
              "POONAM",
              "DHARAM PAL",
              "1224",
              "1600",
              "76.50%"
            ]
          }
        ]
      },
      {
        "courseName": "B.P.Ed. II Year",
        "hasMerit": true,
        "headers": [
          "S.No.",
          "Roll No.",
          "Student Name",
          "Father's Name",
          "Total Obtain Marks",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "109",
            "rollNo": "22009115510001",
            "name": "MAINA PAREEK",
            "fatherName": "BHAGIRATH PAREEK",
            "obtainedMarks": "1286",
            "maxMarks": "1600",
            "percentage": "80.37%",
            "cells": [
              "109",
              "22009115510001",
              "MAINA PAREEK",
              "BHAGIRATH PAREEK",
              "1286",
              "1600",
              "80.37%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "22009115510002",
            "name": "SILOCHNA",
            "fatherName": "RAMKISHAN",
            "obtainedMarks": "1243",
            "maxMarks": "1600",
            "percentage": "77.68%",
            "cells": [
              "110",
              "22009115510002",
              "SILOCHNA",
              "RAMKISHAN",
              "1243",
              "1600",
              "77.68%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "22009115510003",
            "name": "RUBI",
            "fatherName": "JAGWANT",
            "obtainedMarks": "1214",
            "maxMarks": "1600",
            "percentage": "75.87%",
            "cells": [
              "111",
              "22009115510003",
              "RUBI",
              "JAGWANT",
              "1214",
              "1600",
              "75.87%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "22009115510005",
            "name": "NIKITA",
            "fatherName": "VIRENDRA SINGH",
            "obtainedMarks": "1245",
            "maxMarks": "1600",
            "percentage": "77.81%",
            "cells": [
              "112",
              "22009115510005",
              "NIKITA",
              "VIRENDRA SINGH",
              "1245",
              "1600",
              "77.81%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "22009115510006",
            "name": "KIRAN",
            "fatherName": "DAYAL SINGH",
            "obtainedMarks": "1247",
            "maxMarks": "1600",
            "percentage": "77.93%",
            "cells": [
              "113",
              "22009115510006",
              "KIRAN",
              "DAYAL SINGH",
              "1247",
              "1600",
              "77.93%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "22009115510007",
            "name": "PREETI",
            "fatherName": "PRATAP SINGH",
            "obtainedMarks": "1236",
            "maxMarks": "1600",
            "percentage": "77.25%",
            "cells": [
              "114",
              "22009115510007",
              "PREETI",
              "PRATAP SINGH",
              "1236",
              "1600",
              "77.25%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "22009115510008",
            "name": "POONAM",
            "fatherName": "DINESH KUMAR",
            "obtainedMarks": "1279",
            "maxMarks": "1600",
            "percentage": "79.93%",
            "cells": [
              "115",
              "22009115510008",
              "POONAM",
              "DINESH KUMAR",
              "1279",
              "1600",
              "79.93%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "22009115510009",
            "name": "SUMANDEEP",
            "fatherName": "JAGSEER RAM",
            "obtainedMarks": "1134",
            "maxMarks": "1600",
            "percentage": "70.87%",
            "cells": [
              "116",
              "22009115510009",
              "SUMANDEEP",
              "JAGSEER RAM",
              "1134",
              "1600",
              "70.87%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "22009115510011",
            "name": "PRIYANKA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "1300",
            "maxMarks": "1600",
            "percentage": "81.25%",
            "cells": [
              "117",
              "22009115510011",
              "PRIYANKA",
              "SUBHASH CHANDER",
              "1300",
              "1600",
              "81.25%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "22009115510012",
            "name": "KOMEL KANWAR",
            "fatherName": "FETEH SINGH",
            "obtainedMarks": "1163",
            "maxMarks": "1600",
            "percentage": "72.68%",
            "cells": [
              "118",
              "22009115510012",
              "KOMEL KANWAR",
              "FETEH SINGH",
              "1163",
              "1600",
              "72.68%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "22009115510013",
            "name": "MAMTA",
            "fatherName": "BHIM  SINGH",
            "obtainedMarks": "1187",
            "maxMarks": "1600",
            "percentage": "74.88%",
            "cells": [
              "119",
              "22009115510013",
              "MAMTA",
              "BHIM  SINGH",
              "1187",
              "1600",
              "74.88%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "22009115510014",
            "name": "SEEMA",
            "fatherName": "SATYAWAN",
            "obtainedMarks": "1200",
            "maxMarks": "1600",
            "percentage": "75%",
            "cells": [
              "120",
              "22009115510014",
              "SEEMA",
              "SATYAWAN",
              "1200",
              "1600",
              "75%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "22009115510015",
            "name": "MONIKA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "1287",
            "maxMarks": "1600",
            "percentage": "80.43%",
            "cells": [
              "121",
              "22009115510015",
              "MONIKA",
              "VIJAY SINGH",
              "1287",
              "1600",
              "80.43%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "22009115510016",
            "name": "ANSHIKA",
            "fatherName": "YASH VEER",
            "obtainedMarks": "1224",
            "maxMarks": "1600",
            "percentage": "76.50%",
            "cells": [
              "122",
              "22009115510016",
              "ANSHIKA",
              "YASH VEER",
              "1224",
              "1600",
              "76.50%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "22009115510017",
            "name": "AMARJEET KAUR",
            "fatherName": "SITA RAM",
            "obtainedMarks": "1311",
            "maxMarks": "1600",
            "percentage": "81.93%",
            "cells": [
              "123",
              "22009115510017",
              "AMARJEET KAUR",
              "SITA RAM",
              "1311",
              "1600",
              "81.93%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "22009115510018",
            "name": "PRIYANKA",
            "fatherName": "ROSHAN LAL",
            "obtainedMarks": "1299",
            "maxMarks": "1600",
            "percentage": "81.18%",
            "cells": [
              "124",
              "22009115510018",
              "PRIYANKA",
              "ROSHAN LAL",
              "1299",
              "1600",
              "81.18%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "22009115510019",
            "name": "SUMAN DEVI",
            "fatherName": "CHHABIL DASS",
            "obtainedMarks": "1244",
            "maxMarks": "1600",
            "percentage": "77.75%",
            "cells": [
              "125",
              "22009115510019",
              "SUMAN DEVI",
              "CHHABIL DASS",
              "1244",
              "1600",
              "77.75%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "22009115510020",
            "name": "SUMAN VERMA",
            "fatherName": "OM PARKASH",
            "obtainedMarks": "1280",
            "maxMarks": "1600",
            "percentage": "80%",
            "cells": [
              "126",
              "22009115510020",
              "SUMAN VERMA",
              "OM PARKASH",
              "1280",
              "1600",
              "80%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "22009115510021",
            "name": "MANITA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "1214",
            "maxMarks": "1600",
            "percentage": "75.87%",
            "cells": [
              "127",
              "22009115510021",
              "MANITA",
              "SURESH KUMAR",
              "1214",
              "1600",
              "75.87%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "22009115510023",
            "name": "SANDEEP RANI",
            "fatherName": "GOPAL",
            "obtainedMarks": "1231",
            "maxMarks": "1600",
            "percentage": "76.93%",
            "cells": [
              "128",
              "22009115510023",
              "SANDEEP RANI",
              "GOPAL",
              "1231",
              "1600",
              "76.93%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "22009115510024",
            "name": "POONAM",
            "fatherName": "SURENDER",
            "obtainedMarks": "1260",
            "maxMarks": "1600",
            "percentage": "78.75%",
            "cells": [
              "129",
              "22009115510024",
              "POONAM",
              "SURENDER",
              "1260",
              "1600",
              "78.75%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "22009115510025",
            "name": "MUNISHA RANI",
            "fatherName": "MANSA SINGH",
            "obtainedMarks": "1305",
            "maxMarks": "1600",
            "percentage": "81.56%",
            "cells": [
              "130",
              "22009115510025",
              "MUNISHA RANI",
              "MANSA SINGH",
              "1305",
              "1600",
              "81.56%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "22009115510026",
            "name": "PRIYANKA",
            "fatherName": "BIHARI LAL",
            "obtainedMarks": "1263",
            "maxMarks": "1600",
            "percentage": "78.93%",
            "cells": [
              "131",
              "22009115510026",
              "PRIYANKA",
              "BIHARI LAL",
              "1263",
              "1600",
              "78.93%"
            ]
          },
          {
            "sNo": "132",
            "rollNo": "22009115510027",
            "name": "POOJA",
            "fatherName": "SHER SINGH",
            "obtainedMarks": "1241",
            "maxMarks": "1600",
            "percentage": "77.56%",
            "cells": [
              "132",
              "22009115510027",
              "POOJA",
              "SHER SINGH",
              "1241",
              "1600",
              "77.56%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "22009115510028",
            "name": "RAVINA",
            "fatherName": "SUBHASH",
            "obtainedMarks": "1292",
            "maxMarks": "1600",
            "percentage": "80.75%",
            "cells": [
              "133",
              "22009115510028",
              "RAVINA",
              "SUBHASH",
              "1292",
              "1600",
              "80.75%"
            ]
          }
        ]
      }
    ]
  },
  {
    "session": "Session 2024-25",
    "courses": [
      {
        "courseName": "BA 1ST YEAR",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I SEM Out of Marks  600",
          "II SEM Out of Marks  600",
          "1+II SEM",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "24009115430004",
            "name": "KOMAL",
            "fatherName": "MUKESH",
            "obtainedMarks": "920",
            "maxMarks": "1200",
            "percentage": "76.66%",
            "cells": [
              "1",
              "24009115430004",
              "KOMAL",
              "MUKESH",
              "476",
              "444",
              "920",
              "1200",
              "76.66%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "24009115430015",
            "name": "KALPNA",
            "fatherName": "GULAB SINGH",
            "obtainedMarks": "967",
            "maxMarks": "1200",
            "percentage": "80.58%",
            "cells": [
              "2",
              "24009115430015",
              "KALPNA",
              "GULAB SINGH",
              "509",
              "458",
              "967",
              "1200",
              "80.58%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "24009115430016",
            "name": "AARTI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "879",
            "maxMarks": "1200",
            "percentage": "73.25%",
            "cells": [
              "3",
              "24009115430016",
              "AARTI",
              "KRISHAN KUMAR",
              "454",
              "425",
              "879",
              "1200",
              "73.25%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "24009115430021",
            "name": "POOJA",
            "fatherName": "BALWAN",
            "obtainedMarks": "885",
            "maxMarks": "1200",
            "percentage": "73.75%",
            "cells": [
              "4",
              "24009115430021",
              "POOJA",
              "BALWAN",
              "463",
              "422",
              "885",
              "1200",
              "73.75%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "24009115430029",
            "name": "AMBIKA",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "957",
            "maxMarks": "1200",
            "percentage": "79.75%",
            "cells": [
              "5",
              "24009115430029",
              "AMBIKA",
              "SUNIL KUMAR",
              "507",
              "450",
              "957",
              "1200",
              "79.75%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "24009115430032",
            "name": "PRANJALI SAHU",
            "fatherName": "DILAVER SAHU",
            "obtainedMarks": "840",
            "maxMarks": "1200",
            "percentage": "70%",
            "cells": [
              "6",
              "24009115430032",
              "PRANJALI SAHU",
              "DILAVER SAHU",
              "433",
              "407",
              "840",
              "1200",
              "70%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "24009115430037",
            "name": "AENA INSAN",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "892",
            "maxMarks": "1200",
            "percentage": "74.33%",
            "cells": [
              "7",
              "24009115430037",
              "AENA INSAN",
              "RAJ KUMAR",
              "456",
              "436",
              "892",
              "1200",
              "74.33%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "24009115430038",
            "name": "NISHA",
            "fatherName": "ATMA RAM",
            "obtainedMarks": "984",
            "maxMarks": "1200",
            "percentage": "82%",
            "cells": [
              "8",
              "24009115430038",
              "NISHA",
              "ATMA RAM",
              "519",
              "465",
              "984",
              "1200",
              "82%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "24009115430039",
            "name": "ESHA SONI",
            "fatherName": "SATISH SONI",
            "obtainedMarks": "877",
            "maxMarks": "1200",
            "percentage": "73.08%",
            "cells": [
              "9",
              "24009115430039",
              "ESHA SONI",
              "SATISH SONI",
              "459",
              "418",
              "877",
              "1200",
              "73.08%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "24009115430040",
            "name": "SMAYRA",
            "fatherName": "NAVEEN",
            "obtainedMarks": "978",
            "maxMarks": "1200",
            "percentage": "81.50%",
            "cells": [
              "10",
              "24009115430040",
              "SMAYRA",
              "NAVEEN",
              "518",
              "460",
              "978",
              "1200",
              "81.50%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "24009115430041",
            "name": "SUKHMANPREET",
            "fatherName": "MANJODH SINGH",
            "obtainedMarks": "897",
            "maxMarks": "1200",
            "percentage": "74.75%",
            "cells": [
              "11",
              "24009115430041",
              "SUKHMANPREET",
              "MANJODH SINGH",
              "459",
              "438",
              "897",
              "1200",
              "74.75%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "24009115430043",
            "name": "MONIKA VERMA",
            "fatherName": "CHANDER PAL",
            "obtainedMarks": "911",
            "maxMarks": "1200",
            "percentage": "75.91%",
            "cells": [
              "12",
              "24009115430043",
              "MONIKA VERMA",
              "CHANDER PAL",
              "484",
              "427",
              "911",
              "1200",
              "75.91%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "24009115430044",
            "name": "AARJU",
            "fatherName": "SATVIR",
            "obtainedMarks": "886",
            "maxMarks": "1200",
            "percentage": "73.83%",
            "cells": [
              "13",
              "24009115430044",
              "AARJU",
              "SATVIR",
              "452",
              "434",
              "886",
              "1200",
              "73.83%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "24009115430047",
            "name": "SEEMA",
            "fatherName": "SATPAL",
            "obtainedMarks": "921",
            "maxMarks": "1200",
            "percentage": "76.75%",
            "cells": [
              "14",
              "24009115430047",
              "SEEMA",
              "SATPAL",
              "479",
              "442",
              "921",
              "1200",
              "76.75%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "24009115430048",
            "name": "JAYA RANI",
            "fatherName": "CHANDER MOHAN",
            "obtainedMarks": "897",
            "maxMarks": "1200",
            "percentage": "74.75%",
            "cells": [
              "15",
              "24009115430048",
              "JAYA RANI",
              "CHANDER MOHAN",
              "477",
              "420",
              "897",
              "1200",
              "74.75%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "24009115430056",
            "name": "AISHWARYA GODARA",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "965",
            "maxMarks": "1200",
            "percentage": "80.41%",
            "cells": [
              "16",
              "24009115430056",
              "AISHWARYA GODARA",
              "RANBIR SINGH",
              "486",
              "479",
              "965",
              "1200",
              "80.41%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "24009115430060",
            "name": "RAMAJDEEP INSAN",
            "fatherName": "GURPAS SINGH",
            "obtainedMarks": "945",
            "maxMarks": "1200",
            "percentage": "78.75%",
            "cells": [
              "17",
              "24009115430060",
              "RAMAJDEEP INSAN",
              "GURPAS SINGH",
              "484",
              "461",
              "945",
              "1200",
              "78.75%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "24009115430062",
            "name": "SALONI",
            "fatherName": "CHANDER PAL",
            "obtainedMarks": "927",
            "maxMarks": "1200",
            "percentage": "77.25%",
            "cells": [
              "18",
              "24009115430062",
              "SALONI",
              "CHANDER PAL",
              "493",
              "434",
              "927",
              "1200",
              "77.25%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "24009115430065",
            "name": "TANVI SINGH",
            "fatherName": "JAGDISH KUMAR",
            "obtainedMarks": "923",
            "maxMarks": "1200",
            "percentage": "76.91%",
            "cells": [
              "19",
              "24009115430065",
              "TANVI SINGH",
              "JAGDISH KUMAR",
              "469",
              "454",
              "923",
              "1200",
              "76.91%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "24009115430066",
            "name": "SANGEETA",
            "fatherName": "BALRAM",
            "obtainedMarks": "955",
            "maxMarks": "1200",
            "percentage": "79.58%",
            "cells": [
              "20",
              "24009115430066",
              "SANGEETA",
              "BALRAM",
              "499",
              "456",
              "955",
              "1200",
              "79.58%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "24009115430067",
            "name": "RITIKA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "870",
            "maxMarks": "1200",
            "percentage": "72.50%",
            "cells": [
              "21",
              "24009115430067",
              "RITIKA",
              "RAJ KUMAR",
              "465",
              "405",
              "870",
              "1200",
              "72.50%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "24009115430072",
            "name": "DHANPREET KAUR",
            "fatherName": "HARBANS SINGH",
            "obtainedMarks": "889",
            "maxMarks": "1200",
            "percentage": "74.08%",
            "cells": [
              "22",
              "24009115430072",
              "DHANPREET KAUR",
              "HARBANS SINGH",
              "473",
              "416",
              "889",
              "1200",
              "74.08%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "24009115430077",
            "name": "GAGANDEEP KAMBOJ",
            "fatherName": "GOVIND RAM",
            "obtainedMarks": "878",
            "maxMarks": "1200",
            "percentage": "73.16%",
            "cells": [
              "23",
              "24009115430077",
              "GAGANDEEP KAMBOJ",
              "GOVIND RAM",
              "472",
              "406",
              "878",
              "1200",
              "73.16%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "24009115430078",
            "name": "SAKINA",
            "fatherName": "SATPAL",
            "obtainedMarks": "840",
            "maxMarks": "1200",
            "percentage": "70%",
            "cells": [
              "24",
              "24009115430078",
              "SAKINA",
              "SATPAL",
              "451",
              "389",
              "840",
              "1200",
              "70%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "24009115430082",
            "name": "KOMAL BHADANA",
            "fatherName": "KAILASH CHANDRA",
            "obtainedMarks": "855",
            "maxMarks": "1200",
            "percentage": "71.25%",
            "cells": [
              "25",
              "24009115430082",
              "KOMAL BHADANA",
              "KAILASH CHANDRA",
              "422",
              "433",
              "855",
              "1200",
              "71.25%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "24009115430109",
            "name": "SIMARJEET",
            "fatherName": "HARNEK SINGH",
            "obtainedMarks": "906",
            "maxMarks": "1200",
            "percentage": "75.50%",
            "cells": [
              "26",
              "24009115430109",
              "SIMARJEET",
              "HARNEK SINGH",
              "470",
              "436",
              "906",
              "1200",
              "75.50%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "24009115430113",
            "name": "JASHANPREET KAUR",
            "fatherName": "SUKHWINDER SINGH",
            "obtainedMarks": "881",
            "maxMarks": "1200",
            "percentage": "73.41%",
            "cells": [
              "27",
              "24009115430113",
              "JASHANPREET KAUR",
              "SUKHWINDER SINGH",
              "458",
              "423",
              "881",
              "1200",
              "73.41%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "24009115430122",
            "name": "ANMOL",
            "fatherName": "JAGDEEP SINGH",
            "obtainedMarks": "938",
            "maxMarks": "1200",
            "percentage": "78.16%",
            "cells": [
              "28",
              "24009115430122",
              "ANMOL",
              "JAGDEEP SINGH",
              "459",
              "479",
              "938",
              "1200",
              "78.16%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "24009115430131",
            "name": "MAMTA",
            "fatherName": "RANBIR SINGH",
            "obtainedMarks": "853",
            "maxMarks": "1200",
            "percentage": "71.08%",
            "cells": [
              "29",
              "24009115430131",
              "MAMTA",
              "RANBIR SINGH",
              "460",
              "393",
              "853",
              "1200",
              "71.08%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "24009115430143",
            "name": "NAINA",
            "fatherName": "DARSHAN SINGH",
            "obtainedMarks": "884",
            "maxMarks": "1200",
            "percentage": "73.66%",
            "cells": [
              "30",
              "24009115430143",
              "NAINA",
              "DARSHAN SINGH",
              "476",
              "408",
              "884",
              "1200",
              "73.66%"
            ]
          }
        ]
      },
      {
        "courseName": "B. A. II Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 400",
          "IV Sem Marks out of 500",
          "III+IV Sem",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "31",
            "rollNo": "23009115430004",
            "name": "MUSKAN",
            "fatherName": "BHAL CHAND",
            "obtainedMarks": "747",
            "maxMarks": "900",
            "percentage": "83%",
            "cells": [
              "31",
              "23009115430004",
              "MUSKAN",
              "BHAL CHAND",
              "334",
              "413",
              "747",
              "900",
              "83%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "23009115430007",
            "name": "KANCHAN",
            "fatherName": "SUBHASH",
            "obtainedMarks": "638",
            "maxMarks": "900",
            "percentage": "70.88%",
            "cells": [
              "32",
              "23009115430007",
              "KANCHAN",
              "SUBHASH",
              "281",
              "357",
              "638",
              "900",
              "70.88%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "23009115430008",
            "name": "KOMAL",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "642",
            "maxMarks": "900",
            "percentage": "71.33%",
            "cells": [
              "33",
              "23009115430008",
              "KOMAL",
              "BALBIR SINGH",
              "278",
              "364",
              "642",
              "900",
              "71.33%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "23009115430010",
            "name": "RENU",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "725",
            "maxMarks": "900",
            "percentage": "80.33%",
            "cells": [
              "34",
              "23009115430010",
              "RENU",
              "VIJAY KUMAR",
              "328",
              "397",
              "725",
              "900",
              "80.33%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "23009115430012",
            "name": "RAVITA",
            "fatherName": "MAHAVIR SINGH",
            "obtainedMarks": "632",
            "maxMarks": "900",
            "percentage": "70.22%",
            "cells": [
              "35",
              "23009115430012",
              "RAVITA",
              "MAHAVIR SINGH",
              "264",
              "368",
              "632",
              "900",
              "70.22%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "23009115430048",
            "name": "DIKSHA",
            "fatherName": "CHARAN SINGH",
            "obtainedMarks": "636",
            "maxMarks": "900",
            "percentage": "70.66%",
            "cells": [
              "36",
              "23009115430048",
              "DIKSHA",
              "CHARAN SINGH",
              "292",
              "344",
              "636",
              "900",
              "70.66%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "23009115430051",
            "name": "PRIYANKA",
            "fatherName": "PARHLAD",
            "obtainedMarks": "660",
            "maxMarks": "900",
            "percentage": "73.33%",
            "cells": [
              "37",
              "23009115430051",
              "PRIYANKA",
              "PARHLAD",
              "306",
              "354",
              "660",
              "900",
              "73.33%"
            ]
          },
          {
            "sNo": "38",
            "rollNo": "23009115430055",
            "name": "AMANDEEP KAUR",
            "fatherName": "RANGA SINGH",
            "obtainedMarks": "637",
            "maxMarks": "900",
            "percentage": "70.77%",
            "cells": [
              "38",
              "23009115430055",
              "AMANDEEP KAUR",
              "RANGA SINGH",
              "304",
              "333",
              "637",
              "900",
              "70.77%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "23009115430056",
            "name": "MANISHA",
            "fatherName": "MAHENDER",
            "obtainedMarks": "737",
            "maxMarks": "900",
            "percentage": "81.88%",
            "cells": [
              "39",
              "23009115430056",
              "MANISHA",
              "MAHENDER",
              "317",
              "420",
              "737",
              "900",
              "81.88%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "23009115430057",
            "name": "SHIVALI",
            "fatherName": "WAZIR CHAND",
            "obtainedMarks": "707",
            "maxMarks": "900",
            "percentage": "78.55%",
            "cells": [
              "40",
              "23009115430057",
              "SHIVALI",
              "WAZIR CHAND",
              "330",
              "377",
              "707",
              "900",
              "78.55%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "23009115430059",
            "name": "YASH BHARTI",
            "fatherName": "DEV RAJ",
            "obtainedMarks": "658",
            "maxMarks": "900",
            "percentage": "73.11%",
            "cells": [
              "41",
              "23009115430059",
              "YASH BHARTI",
              "DEV RAJ",
              "282",
              "376",
              "658",
              "900",
              "73.11%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "23009115430060",
            "name": "SHOBHNA",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "752",
            "maxMarks": "900",
            "percentage": "83.55%",
            "cells": [
              "42",
              "23009115430060",
              "SHOBHNA",
              "SURESH KUMAR",
              "342",
              "410",
              "752",
              "900",
              "83.55%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "23009115430061",
            "name": "PRIYANKA",
            "fatherName": "PARBHU SINGH",
            "obtainedMarks": "685",
            "maxMarks": "900",
            "percentage": "76.11%",
            "cells": [
              "43",
              "23009115430061",
              "PRIYANKA",
              "PARBHU SINGH",
              "304",
              "381",
              "685",
              "900",
              "76.11%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "23009115430062",
            "name": "KAVERI",
            "fatherName": "PARVEEN KUMAR",
            "obtainedMarks": "696",
            "maxMarks": "900",
            "percentage": "77.33%",
            "cells": [
              "44",
              "23009115430062",
              "KAVERI",
              "PARVEEN KUMAR",
              "309",
              "387",
              "696",
              "900",
              "77.33%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "23009115430064",
            "name": "SUHANI",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "705",
            "maxMarks": "900",
            "percentage": "78.33%",
            "cells": [
              "45",
              "23009115430064",
              "SUHANI",
              "ANIL KUMAR",
              "327",
              "378",
              "705",
              "900",
              "78.33%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "23009115430065",
            "name": "ASTHA",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "46",
              "23009115430065",
              "ASTHA",
              "SUSHIL KUMAR",
              "283",
              "357",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "23009115430066",
            "name": "GURPREET KAUR",
            "fatherName": "HARMEET SINGH",
            "obtainedMarks": "721",
            "maxMarks": "900",
            "percentage": "80.11%",
            "cells": [
              "47",
              "23009115430066",
              "GURPREET KAUR",
              "HARMEET SINGH",
              "321",
              "400",
              "721",
              "900",
              "80.11%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "23009115430067",
            "name": "AARTI",
            "fatherName": "SAWARAN SINGH",
            "obtainedMarks": "630",
            "maxMarks": "900",
            "percentage": "70%",
            "cells": [
              "48",
              "23009115430067",
              "AARTI",
              "SAWARAN SINGH",
              "273",
              "357",
              "630",
              "900",
              "70%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "23009115430068",
            "name": "RITIKA",
            "fatherName": "SANJAY",
            "obtainedMarks": "738",
            "maxMarks": "900",
            "percentage": "82%",
            "cells": [
              "49",
              "23009115430068",
              "RITIKA",
              "SANJAY",
              "326",
              "412",
              "738",
              "900",
              "82%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "23009115430070",
            "name": "ARAVI",
            "fatherName": "JAGDISH LAL",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "50",
              "23009115430070",
              "ARAVI",
              "JAGDISH LAL",
              "284",
              "375",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "23009115430074",
            "name": "ARSHDEEP KAUR",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "674",
            "maxMarks": "900",
            "percentage": "74.88%",
            "cells": [
              "51",
              "23009115430074",
              "ARSHDEEP KAUR",
              "GURJANT SINGH",
              "303",
              "371",
              "674",
              "900",
              "74.88%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "23009115430075",
            "name": "JASMINE BAWA",
            "fatherName": "JAGSIR SINGH",
            "obtainedMarks": "750",
            "maxMarks": "900",
            "percentage": "83.33%",
            "cells": [
              "52",
              "23009115430075",
              "JASMINE BAWA",
              "JAGSIR SINGH",
              "332",
              "418",
              "750",
              "900",
              "83.33%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "23009115430077",
            "name": "PALAK",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "635",
            "maxMarks": "900",
            "percentage": "70.55%",
            "cells": [
              "53",
              "23009115430077",
              "PALAK",
              "SATISH KUMAR",
              "271",
              "364",
              "635",
              "900",
              "70.55%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "23009115430078",
            "name": "DEEPIKA",
            "fatherName": "SUMEET KUMAR",
            "obtainedMarks": "788",
            "maxMarks": "900",
            "percentage": "87.55%",
            "cells": [
              "54",
              "23009115430078",
              "DEEPIKA",
              "SUMEET KUMAR",
              "342",
              "446",
              "788",
              "900",
              "87.55%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "23009115430082",
            "name": "MUSKAN",
            "fatherName": "MUKESH KUMAR",
            "obtainedMarks": "714",
            "maxMarks": "900",
            "percentage": "79.33%",
            "cells": [
              "55",
              "23009115430082",
              "MUSKAN",
              "MUKESH KUMAR",
              "321",
              "393",
              "714",
              "900",
              "79.33%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "23009115430083",
            "name": "MUSKAN GABA",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "56",
              "23009115430083",
              "MUSKAN GABA",
              "SUNIL KUMAR",
              "282",
              "358",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "23009115430086",
            "name": "PALAK",
            "fatherName": "PRITAM CHAND",
            "obtainedMarks": "695",
            "maxMarks": "900",
            "percentage": "77.22%",
            "cells": [
              "57",
              "23009115430086",
              "PALAK",
              "PRITAM CHAND",
              "287",
              "408",
              "695",
              "900",
              "77.22%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "23009115430088",
            "name": "RADHA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "643",
            "maxMarks": "900",
            "percentage": "71.44%",
            "cells": [
              "58",
              "23009115430088",
              "RADHA",
              "NARESH KUMAR",
              "275",
              "368",
              "643",
              "900",
              "71.44%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "23009115430089",
            "name": "ISHU",
            "fatherName": "RAJNEESH KUMAR",
            "obtainedMarks": "773",
            "maxMarks": "900",
            "percentage": "85.88%",
            "cells": [
              "59",
              "23009115430089",
              "ISHU",
              "RAJNEESH KUMAR",
              "347",
              "426",
              "773",
              "900",
              "85.88%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "23009115430090",
            "name": "KHUSHI",
            "fatherName": "GULSHAN KUMAR",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "60",
              "23009115430090",
              "KHUSHI",
              "GULSHAN KUMAR",
              "312",
              "347",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "23009115430093",
            "name": "SUKHMEET KAUR",
            "fatherName": "KULDEEP SINGH",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "61",
              "23009115430093",
              "SUKHMEET KAUR",
              "KULDEEP SINGH",
              "283",
              "356",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "23009115430096",
            "name": "SIMRANJEET KAUR",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "693",
            "maxMarks": "900",
            "percentage": "77%",
            "cells": [
              "62",
              "23009115430096",
              "SIMRANJEET KAUR",
              "AVTAR SINGH",
              "313",
              "380",
              "693",
              "900",
              "77%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "23009115430103",
            "name": "SNEHA",
            "fatherName": "SATISH BHARTI",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.77%",
            "cells": [
              "63",
              "23009115430103",
              "SNEHA",
              "SATISH BHARTI",
              "298",
              "402",
              "700",
              "900",
              "77.77%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "23009115430108",
            "name": "MUSKAN",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "675",
            "maxMarks": "900",
            "percentage": "75%",
            "cells": [
              "64",
              "23009115430108",
              "MUSKAN",
              "SANJAY KUMAR",
              "286",
              "389",
              "675",
              "900",
              "75%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "23009115430112",
            "name": "KAVITA",
            "fatherName": "BALBIR SINGH",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "65",
              "23009115430112",
              "KAVITA",
              "BALBIR SINGH",
              "299",
              "368",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "23009115430115",
            "name": "SAKSHI DEVI",
            "fatherName": "SUSHIL",
            "obtainedMarks": "640",
            "maxMarks": "900",
            "percentage": "71.11%",
            "cells": [
              "66",
              "23009115430115",
              "SAKSHI DEVI",
              "SUSHIL",
              "296",
              "344",
              "640",
              "900",
              "71.11%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "23009115430119",
            "name": "MANOJ",
            "fatherName": "RATAN SINGH",
            "obtainedMarks": "723",
            "maxMarks": "900",
            "percentage": "80.33%",
            "cells": [
              "67",
              "23009115430119",
              "MANOJ",
              "RATAN SINGH",
              "334",
              "389",
              "723",
              "900",
              "80.33%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "23009115430120",
            "name": "MONIKA",
            "fatherName": "ANUP KUMAR",
            "obtainedMarks": "634",
            "maxMarks": "900",
            "percentage": "70.44%",
            "cells": [
              "68",
              "23009115430120",
              "MONIKA",
              "ANUP KUMAR",
              "286",
              "348",
              "634",
              "900",
              "70.44%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "23009115430121",
            "name": "RIDHI",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "639",
            "maxMarks": "900",
            "percentage": "71%",
            "cells": [
              "69",
              "23009115430121",
              "RIDHI",
              "SANDEEP KUMAR",
              "301",
              "338",
              "639",
              "900",
              "71%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "23009115430122",
            "name": "SIMRAN",
            "fatherName": "MALKEET SINGH",
            "obtainedMarks": "781",
            "maxMarks": "900",
            "percentage": "86.77%",
            "cells": [
              "70",
              "23009115430122",
              "SIMRAN",
              "MALKEET SINGH",
              "351",
              "430",
              "781",
              "900",
              "86.77%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "23009115430123",
            "name": "KOMAL",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "677",
            "maxMarks": "900",
            "percentage": "75.22%",
            "cells": [
              "71",
              "23009115430123",
              "KOMAL",
              "ASHOK KUMAR",
              "297",
              "380",
              "677",
              "900",
              "75.22%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "23009115430135",
            "name": "RITIKA",
            "fatherName": "MANGAT RAM",
            "obtainedMarks": "641",
            "maxMarks": "900",
            "percentage": "71.22%",
            "cells": [
              "72",
              "23009115430135",
              "RITIKA",
              "MANGAT RAM",
              "291",
              "350",
              "641",
              "900",
              "71.22%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "23009115430146",
            "name": "NAVDEEP KAUR",
            "fatherName": "AMARJEET SINGH",
            "obtainedMarks": "700",
            "maxMarks": "900",
            "percentage": "77.77%",
            "cells": [
              "73",
              "23009115430146",
              "NAVDEEP KAUR",
              "AMARJEET SINGH",
              "312",
              "388",
              "700",
              "900",
              "77.77%"
            ]
          },
          {
            "sNo": "74",
            "rollNo": "23009115430168",
            "name": "DILSHAN KOUR",
            "fatherName": "NIRBHAY SINGH",
            "obtainedMarks": "684",
            "maxMarks": "900",
            "percentage": "76%",
            "cells": [
              "74",
              "23009115430168",
              "DILSHAN KOUR",
              "NIRBHAY SINGH",
              "286",
              "398",
              "684",
              "900",
              "76%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "23009115430194",
            "name": "PRIYANKA",
            "fatherName": "BIRBHAN",
            "obtainedMarks": "689",
            "maxMarks": "900",
            "percentage": "76.55%",
            "cells": [
              "75",
              "23009115430194",
              "PRIYANKA",
              "BIRBHAN",
              "291",
              "398",
              "689",
              "900",
              "76.55%"
            ]
          },
          {
            "sNo": "76",
            "rollNo": "23009115430196",
            "name": "HONEYPREET INSAN",
            "fatherName": "MUKHAY SHISHAY V DHARAM KI BETI SAINT GURMEET RAM RAHIM SINGH INSAN",
            "obtainedMarks": "767",
            "maxMarks": "900",
            "percentage": "85.22%",
            "cells": [
              "76",
              "23009115430196",
              "HONEYPREET INSAN",
              "MUKHAY SHISHAY V DHARAM KI BETI SAINT GURMEET RAM RAHIM SINGH INSAN",
              "338",
              "429",
              "767",
              "900",
              "85.22%"
            ]
          }
        ]
      },
      {
        "courseName": "B.A  III year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Registration No:",
          "Student Name",
          "Father Name",
          "V SEM",
          "VI SEM",
          "V+ VI SEM",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "77",
            "rollNo": "22009115430004",
            "name": "DHARAMPREET KAUR",
            "fatherName": "BHOLA SINGH",
            "obtainedMarks": "759",
            "maxMarks": "1000",
            "percentage": "75.90%",
            "cells": [
              "77",
              "22009115430004",
              "DHARAMPREET KAUR",
              "BHOLA SINGH",
              "382",
              "377",
              "759",
              "1000",
              "75.90%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "22009115430005",
            "name": "SUSHILA",
            "fatherName": "AMI LAL",
            "obtainedMarks": "706",
            "maxMarks": "1000",
            "percentage": "70.60%",
            "cells": [
              "78",
              "22009115430005",
              "SUSHILA",
              "AMI LAL",
              "352",
              "354",
              "706",
              "1000",
              "70.60%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "22009115430006",
            "name": "GURPREET KAUR",
            "fatherName": "BALKAR SINGH",
            "obtainedMarks": "726",
            "maxMarks": "1000",
            "percentage": "72.60%",
            "cells": [
              "79",
              "22009115430006",
              "GURPREET KAUR",
              "BALKAR SINGH",
              "364",
              "362",
              "726",
              "1000",
              "72.60%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "22009115430011",
            "name": "JYOTI",
            "fatherName": "AJMER SINGH",
            "obtainedMarks": "734",
            "maxMarks": "1000",
            "percentage": "73.40%",
            "cells": [
              "80",
              "22009115430011",
              "JYOTI",
              "AJMER SINGH",
              "370",
              "364",
              "734",
              "1000",
              "73.40%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "22009115430012",
            "name": "PARMILA",
            "fatherName": "PANNA LAL",
            "obtainedMarks": "773",
            "maxMarks": "1000",
            "percentage": "77.30%",
            "cells": [
              "81",
              "22009115430012",
              "PARMILA",
              "PANNA LAL",
              "385",
              "388",
              "773",
              "1000",
              "77.30%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "22009115430013",
            "name": "ARZOO",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "746",
            "maxMarks": "1000",
            "percentage": "74.60%",
            "cells": [
              "82",
              "22009115430013",
              "ARZOO",
              "KRISHAN KUMAR",
              "373",
              "373",
              "746",
              "1000",
              "74.60%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "22009115430015",
            "name": "MONIKA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "725",
            "maxMarks": "1000",
            "percentage": "72.50%",
            "cells": [
              "83",
              "22009115430015",
              "MONIKA",
              "RAMESH KUMAR",
              "365",
              "360",
              "725",
              "1000",
              "72.50%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "22009115430018",
            "name": "KHUSHBOO",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "730",
            "maxMarks": "1000",
            "percentage": "73.00%",
            "cells": [
              "84",
              "22009115430018",
              "KHUSHBOO",
              "RAJESH KUMAR",
              "365",
              "365",
              "730",
              "1000",
              "73.00%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "22009115430021",
            "name": "LASHMI",
            "fatherName": "HARBHAJAN",
            "obtainedMarks": "805",
            "maxMarks": "1050",
            "percentage": "76.67%",
            "cells": [
              "85",
              "22009115430021",
              "LASHMI",
              "HARBHAJAN",
              "410",
              "395",
              "805",
              "1050",
              "76.67%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "22009115430022",
            "name": "KHUSHPREET KAUR",
            "fatherName": "GURSEWAK SINGH",
            "obtainedMarks": "837",
            "maxMarks": "1000",
            "percentage": "83.70%",
            "cells": [
              "86",
              "22009115430022",
              "KHUSHPREET KAUR",
              "GURSEWAK SINGH",
              "425",
              "412",
              "837",
              "1000",
              "83.70%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "22009115430029",
            "name": "MANDEEP KAUR",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "725",
            "maxMarks": "1000",
            "percentage": "72.50%",
            "cells": [
              "87",
              "22009115430029",
              "MANDEEP KAUR",
              "SUKHDEV SINGH",
              "367",
              "358",
              "725",
              "1000",
              "72.50%"
            ]
          },
          {
            "sNo": "88",
            "rollNo": "22009115430030",
            "name": "PARVEEN KAUR",
            "fatherName": "LAKHWINDER SINGH",
            "obtainedMarks": "719",
            "maxMarks": "1000",
            "percentage": "71.90%",
            "cells": [
              "88",
              "22009115430030",
              "PARVEEN KAUR",
              "LAKHWINDER SINGH",
              "361",
              "358",
              "719",
              "1000",
              "71.90%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "22009115430042",
            "name": "SHREYA DEVI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "815",
            "maxMarks": "1050",
            "percentage": "77.62%",
            "cells": [
              "89",
              "22009115430042",
              "SHREYA DEVI",
              "RAJESH KUMAR",
              "412",
              "403",
              "815",
              "1050",
              "77.62%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "22009115430044",
            "name": "POOJA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "744",
            "maxMarks": "1000",
            "percentage": "74.40%",
            "cells": [
              "90",
              "22009115430044",
              "POOJA",
              "KRISHAN KUMAR",
              "374",
              "370",
              "744",
              "1000",
              "74.40%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "22009115430047",
            "name": "MUSKAN",
            "fatherName": "JAIPAL",
            "obtainedMarks": "805",
            "maxMarks": "1000",
            "percentage": "80.50%",
            "cells": [
              "91",
              "22009115430047",
              "MUSKAN",
              "JAIPAL",
              "408",
              "397",
              "805",
              "1000",
              "80.50%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "22009115430051",
            "name": "SIMRAN KAUR",
            "fatherName": "HARJIT SINGH",
            "obtainedMarks": "795",
            "maxMarks": "1000",
            "percentage": "79.50%",
            "cells": [
              "92",
              "22009115430051",
              "SIMRAN KAUR",
              "HARJIT SINGH",
              "402",
              "393",
              "795",
              "1000",
              "79.50%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "22009115430053",
            "name": "AMANDEEP KAUR",
            "fatherName": "JAGSIR SINGH",
            "obtainedMarks": "771",
            "maxMarks": "1000",
            "percentage": "77.10%",
            "cells": [
              "93",
              "22009115430053",
              "AMANDEEP KAUR",
              "JAGSIR SINGH",
              "389",
              "382",
              "771",
              "1000",
              "77.10%"
            ]
          },
          {
            "sNo": "94",
            "rollNo": "22009115430058",
            "name": "POOJA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "708",
            "maxMarks": "1000",
            "percentage": "70.80%",
            "cells": [
              "94",
              "22009115430058",
              "POOJA",
              "VIJAY KUMAR",
              "354",
              "354",
              "708",
              "1000",
              "70.80%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "22009115430064",
            "name": "TAMANNA",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "716",
            "maxMarks": "1000",
            "percentage": "71.60%",
            "cells": [
              "95",
              "22009115430064",
              "TAMANNA",
              "SATISH KUMAR",
              "359",
              "357",
              "716",
              "1000",
              "71.60%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "22009115430066",
            "name": "SONIA",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "736",
            "maxMarks": "1000",
            "percentage": "73.60%",
            "cells": [
              "96",
              "22009115430066",
              "SONIA",
              "SANJAY KUMAR",
              "369",
              "367",
              "736",
              "1000",
              "73.60%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "22009115430070",
            "name": "SANJU",
            "fatherName": "MANIRAM",
            "obtainedMarks": "728",
            "maxMarks": "1000",
            "percentage": "72.80%",
            "cells": [
              "97",
              "22009115430070",
              "SANJU",
              "MANIRAM",
              "364",
              "364",
              "728",
              "1000",
              "72.80%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "22009115430087",
            "name": "SNEHA",
            "fatherName": "CHARAN SINGH",
            "obtainedMarks": "737",
            "maxMarks": "1000",
            "percentage": "73.70%",
            "cells": [
              "98",
              "22009115430087",
              "SNEHA",
              "CHARAN SINGH",
              "371",
              "366",
              "737",
              "1000",
              "73.70%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "22009115430096",
            "name": "NAVNEET KAUR",
            "fatherName": "BALDEV SINGH",
            "obtainedMarks": "722",
            "maxMarks": "1000",
            "percentage": "72.20%",
            "cells": [
              "99",
              "22009115430096",
              "NAVNEET KAUR",
              "BALDEV SINGH",
              "364",
              "358",
              "722",
              "1000",
              "72.20%"
            ]
          },
          {
            "sNo": "100",
            "rollNo": "22009115430101",
            "name": "NISHA",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "739",
            "maxMarks": "1000",
            "percentage": "73.90%",
            "cells": [
              "100",
              "22009115430101",
              "NISHA",
              "SURENDER SINGH",
              "372",
              "367",
              "739",
              "1000",
              "73.90%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "22009115430102",
            "name": "MANISHA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "101",
              "22009115430102",
              "MANISHA",
              "VINOD KUMAR",
              "356",
              "353",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "102",
            "rollNo": "22009115430104",
            "name": "ANJU RANI",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "720",
            "maxMarks": "1000",
            "percentage": "72.00%",
            "cells": [
              "102",
              "22009115430104",
              "ANJU RANI",
              "MAHENDER SINGH",
              "360",
              "360",
              "720",
              "1000",
              "72.00%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "22009115430107",
            "name": "MONIKA",
            "fatherName": "LUXMI NARAYAN",
            "obtainedMarks": "748",
            "maxMarks": "1000",
            "percentage": "74.80%",
            "cells": [
              "103",
              "22009115430107",
              "MONIKA",
              "LUXMI NARAYAN",
              "374",
              "374",
              "748",
              "1000",
              "74.80%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "22009115430112",
            "name": "KUSUM",
            "fatherName": "MANGE RAM",
            "obtainedMarks": "711",
            "maxMarks": "1000",
            "percentage": "71.10%",
            "cells": [
              "104",
              "22009115430112",
              "KUSUM",
              "MANGE RAM",
              "357",
              "354",
              "711",
              "1000",
              "71.10%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "22009115430118",
            "name": "TWINKLE",
            "fatherName": "KASHMIRI LAL",
            "obtainedMarks": "741",
            "maxMarks": "1000",
            "percentage": "74.10%",
            "cells": [
              "105",
              "22009115430118",
              "TWINKLE",
              "KASHMIRI LAL",
              "370",
              "371",
              "741",
              "1000",
              "74.10%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "22009115430119",
            "name": "MEHAK",
            "fatherName": "KASHMIRI LAL",
            "obtainedMarks": "791",
            "maxMarks": "1000",
            "percentage": "79.10%",
            "cells": [
              "106",
              "22009115430119",
              "MEHAK",
              "KASHMIRI LAL",
              "398",
              "393",
              "791",
              "1000",
              "79.10%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "22009115430122",
            "name": "MANPREET KAUR",
            "fatherName": "SUKHMANDER SINGH",
            "obtainedMarks": "732",
            "maxMarks": "1000",
            "percentage": "73.20%",
            "cells": [
              "107",
              "22009115430122",
              "MANPREET KAUR",
              "SUKHMANDER SINGH",
              "367",
              "365",
              "732",
              "1000",
              "73.20%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "22009115430123",
            "name": "BARBIE BABBAR",
            "fatherName": "RAKESH BABBAR",
            "obtainedMarks": "787",
            "maxMarks": "1000",
            "percentage": "78.70%",
            "cells": [
              "108",
              "22009115430123",
              "BARBIE BABBAR",
              "RAKESH BABBAR",
              "395",
              "392",
              "787",
              "1000",
              "78.70%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "22009115430130",
            "name": "BHAVNA",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "713",
            "maxMarks": "1000",
            "percentage": "71.30%",
            "cells": [
              "109",
              "22009115430130",
              "BHAVNA",
              "VIJAY KUMAR",
              "358",
              "355",
              "713",
              "1000",
              "71.30%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "22009115430132",
            "name": "SHIKSHA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "707",
            "maxMarks": "1000",
            "percentage": "70.70%",
            "cells": [
              "110",
              "22009115430132",
              "SHIKSHA",
              "KULDEEP",
              "355",
              "352",
              "707",
              "1000",
              "70.70%"
            ]
          },
          {
            "sNo": "111",
            "rollNo": "22009115430140",
            "name": "KIRNA",
            "fatherName": "SHISH PAL",
            "obtainedMarks": "707",
            "maxMarks": "1000",
            "percentage": "70.70%",
            "cells": [
              "111",
              "22009115430140",
              "KIRNA",
              "SHISH PAL",
              "353",
              "354",
              "707",
              "1000",
              "70.70%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "22009115430141",
            "name": "MEHAK",
            "fatherName": "SURAJ BHAN",
            "obtainedMarks": "737",
            "maxMarks": "1000",
            "percentage": "73.70%",
            "cells": [
              "112",
              "22009115430141",
              "MEHAK",
              "SURAJ BHAN",
              "373",
              "364",
              "737",
              "1000",
              "73.70%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "22009115430146",
            "name": "RAMA RANI",
            "fatherName": "PARDEEP KUMAR",
            "obtainedMarks": "818",
            "maxMarks": "1000",
            "percentage": "81.80%",
            "cells": [
              "113",
              "22009115430146",
              "RAMA RANI",
              "PARDEEP KUMAR",
              "411",
              "407",
              "818",
              "1000",
              "81.80%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "22009115430152",
            "name": "SUKHDEEP KAUR",
            "fatherName": "GURMEL SINGH",
            "obtainedMarks": "705",
            "maxMarks": "1000",
            "percentage": "70.50%",
            "cells": [
              "114",
              "22009115430152",
              "SUKHDEEP KAUR",
              "GURMEL SINGH",
              "351",
              "354",
              "705",
              "1000",
              "70.50%"
            ]
          },
          {
            "sNo": "115",
            "rollNo": "22009115430154",
            "name": "LOVEPREET KAUR",
            "fatherName": "BALKAR SINGH",
            "obtainedMarks": "709",
            "maxMarks": "1000",
            "percentage": "70.90%",
            "cells": [
              "115",
              "22009115430154",
              "LOVEPREET KAUR",
              "BALKAR SINGH",
              "355",
              "354",
              "709",
              "1000",
              "70.90%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "22009115430160",
            "name": "SUMAN RANI",
            "fatherName": "RAJENDER PRASAD",
            "obtainedMarks": "700",
            "maxMarks": "1000",
            "percentage": "70.00%",
            "cells": [
              "116",
              "22009115430160",
              "SUMAN RANI",
              "RAJENDER PRASAD",
              "350",
              "350",
              "700",
              "1000",
              "70.00%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "22009115430161",
            "name": "MEHAK SHARMA",
            "fatherName": "SUKHMANDER PAL",
            "obtainedMarks": "872",
            "maxMarks": "1000",
            "percentage": "87.20%",
            "cells": [
              "117",
              "22009115430161",
              "MEHAK SHARMA",
              "SUKHMANDER PAL",
              "443",
              "429",
              "872",
              "1000",
              "87.20%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "22009115430163",
            "name": "DEEPASHA",
            "fatherName": "NARESH KUMAR",
            "obtainedMarks": "756",
            "maxMarks": "1000",
            "percentage": "75.60%",
            "cells": [
              "118",
              "22009115430163",
              "DEEPASHA",
              "NARESH KUMAR",
              "386",
              "370",
              "756",
              "1000",
              "75.60%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA 1Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "1 Sem Out of Marks  600",
          "II Sem Out of Marks  600",
          "I+II Sem",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "119",
            "rollNo": "24009115480006",
            "name": "EKTA",
            "fatherName": "JAIBEER",
            "obtainedMarks": "985",
            "maxMarks": "1200",
            "percentage": "82.08%",
            "cells": [
              "119",
              "24009115480006",
              "EKTA",
              "JAIBEER",
              "478",
              "507",
              "985",
              "1200",
              "82.08%"
            ]
          },
          {
            "sNo": "120",
            "rollNo": "24009115480008",
            "name": "ANSHDEEP",
            "fatherName": "ATMA RAM",
            "obtainedMarks": "930",
            "maxMarks": "1200",
            "percentage": "77.50%",
            "cells": [
              "120",
              "24009115480008",
              "ANSHDEEP",
              "ATMA RAM",
              "468",
              "462",
              "930",
              "1200",
              "77.50%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "24009115480009",
            "name": "KAMNA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "857",
            "maxMarks": "1200",
            "percentage": "71.42%",
            "cells": [
              "121",
              "24009115480009",
              "KAMNA",
              "RAMESH KUMAR",
              "446",
              "411",
              "857",
              "1200",
              "71.42%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "24009115480012",
            "name": "ANJU",
            "fatherName": "PARM SINGH",
            "obtainedMarks": "818",
            "maxMarks": "1200",
            "percentage": "68.17%",
            "cells": [
              "122",
              "24009115480012",
              "ANJU",
              "PARM SINGH",
              "401",
              "417",
              "818",
              "1200",
              "68.17%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "24009115480013",
            "name": "EKAMJOT",
            "fatherName": "PARKASH SINGH",
            "obtainedMarks": "817",
            "maxMarks": "1200",
            "percentage": "68.08%",
            "cells": [
              "123",
              "24009115480013",
              "EKAMJOT",
              "PARKASH SINGH",
              "413",
              "404",
              "817",
              "1200",
              "68.08%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "24009115480016",
            "name": "JASHANDEEP",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "944",
            "maxMarks": "1200",
            "percentage": "78.67%",
            "cells": [
              "124",
              "24009115480016",
              "JASHANDEEP",
              "RAKESH KUMAR",
              "480",
              "464",
              "944",
              "1200",
              "78.67%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "24009115480018",
            "name": "VINOD DEVI",
            "fatherName": "RAM KUMAR",
            "obtainedMarks": "771",
            "maxMarks": "1200",
            "percentage": "64.25%",
            "cells": [
              "125",
              "24009115480018",
              "VINOD DEVI",
              "RAM KUMAR",
              "385",
              "386",
              "771",
              "1200",
              "64.25%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "24009115480025",
            "name": "RISHITA",
            "fatherName": "LALIT KUMAR",
            "obtainedMarks": "931",
            "maxMarks": "1200",
            "percentage": "77.58%",
            "cells": [
              "126",
              "24009115480025",
              "RISHITA",
              "LALIT KUMAR",
              "459",
              "472",
              "931",
              "1200",
              "77.58%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "24009115480028",
            "name": "KHUSHBOO",
            "fatherName": "SHER SINGH",
            "obtainedMarks": "797",
            "maxMarks": "1200",
            "percentage": "66.42%",
            "cells": [
              "127",
              "24009115480028",
              "KHUSHBOO",
              "SHER SINGH",
              "393",
              "404",
              "797",
              "1200",
              "66.42%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "24009115480030",
            "name": "PREETI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "913",
            "maxMarks": "1200",
            "percentage": "76.08%",
            "cells": [
              "128",
              "24009115480030",
              "PREETI",
              "VINOD KUMAR",
              "441",
              "472",
              "913",
              "1200",
              "76.08%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "24009115480032",
            "name": "MUSKAN",
            "fatherName": "MADAN PURI",
            "obtainedMarks": "879",
            "maxMarks": "1200",
            "percentage": "73.25%",
            "cells": [
              "129",
              "24009115480032",
              "MUSKAN",
              "MADAN PURI",
              "440",
              "439",
              "879",
              "1200",
              "73.25%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA 1I Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 600",
          "IV Sem Marks out of 750",
          "III +IV Sem",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "130",
            "rollNo": "23009115480012",
            "name": "PRIYANKA",
            "fatherName": "CHOKE LAL",
            "obtainedMarks": "969",
            "maxMarks": "1350",
            "percentage": "71.77%",
            "cells": [
              "130",
              "23009115480012",
              "PRIYANKA",
              "CHOKE LAL",
              "406",
              "563",
              "969",
              "1350",
              "71.77%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "23009115480015",
            "name": "SWEETY",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "948",
            "maxMarks": "1350",
            "percentage": "70.22%",
            "cells": [
              "131",
              "23009115480015",
              "SWEETY",
              "SUNIL KUMAR",
              "416",
              "532",
              "948",
              "1350",
              "70.22%"
            ]
          }
        ]
      },
      {
        "courseName": "BBA 1II Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Registration No:",
          "Student Name",
          "Father Name",
          "V SEM   Marks out of 700",
          "VI SEM  Marks out of 750",
          "V+VI SEM",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "132",
            "rollNo": "22009115480005",
            "name": "ANMOLDEEP KAUR",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "1081",
            "maxMarks": "1450",
            "percentage": "74.55%",
            "cells": [
              "132",
              "22009115480005",
              "ANMOLDEEP KAUR",
              "SUKHDEV SINGH",
              "507",
              "574",
              "1081",
              "1450",
              "74.55%"
            ]
          },
          {
            "sNo": "133",
            "rollNo": "22009115480019",
            "name": "POONAM",
            "fatherName": "SATVIR",
            "obtainedMarks": "1132",
            "maxMarks": "1450",
            "percentage": "78.07%",
            "cells": [
              "133",
              "22009115480019",
              "POONAM",
              "SATVIR",
              "546",
              "586",
              "1132",
              "1450",
              "78.07%"
            ]
          },
          {
            "sNo": "134",
            "rollNo": "22009115480021",
            "name": "MANJU",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1035",
            "maxMarks": "1450",
            "percentage": "71.38%",
            "cells": [
              "134",
              "22009115480021",
              "MANJU",
              "RAKESH KUMAR",
              "488",
              "547",
              "1035",
              "1450",
              "71.38%"
            ]
          },
          {
            "sNo": "135",
            "rollNo": "22009115480022",
            "name": "MEHAK TANEJA",
            "fatherName": "SANT LAL",
            "obtainedMarks": "1042",
            "maxMarks": "1450",
            "percentage": "71.86%",
            "cells": [
              "135",
              "22009115480022",
              "MEHAK TANEJA",
              "SANT LAL",
              "490",
              "552",
              "1042",
              "1450",
              "71.86%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA 1 Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "1 Sem Out of Marks 550",
          "II Sem Out of Marks  550",
          "I + II Sem",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "136",
            "rollNo": "24009115470002",
            "name": "TEENA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "795",
            "maxMarks": "1100",
            "percentage": "78.18%",
            "cells": [
              "136",
              "24009115470002",
              "TEENA",
              "KRISHAN KUMAR",
              "418",
              "377",
              "795",
              "1100",
              "78.18%"
            ]
          },
          {
            "sNo": "137",
            "rollNo": "24009115470006",
            "name": "AARJU",
            "fatherName": "SATPAL",
            "obtainedMarks": "800",
            "maxMarks": "1100",
            "percentage": "72.36%",
            "cells": [
              "137",
              "24009115470006",
              "AARJU",
              "SATPAL",
              "396",
              "404",
              "800",
              "1100",
              "72.36%"
            ]
          },
          {
            "sNo": "138",
            "rollNo": "24009115470009",
            "name": "PALAK RANI",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "746",
            "maxMarks": "1100",
            "percentage": "68.09%",
            "cells": [
              "138",
              "24009115470009",
              "PALAK RANI",
              "SATISH KUMAR",
              "370",
              "376",
              "746",
              "1100",
              "68.09%"
            ]
          },
          {
            "sNo": "139",
            "rollNo": "24009115470010",
            "name": "HARMANDEEP KAUR",
            "fatherName": "BALJINDER SINGH",
            "obtainedMarks": "860",
            "maxMarks": "1100",
            "percentage": "74.45%",
            "cells": [
              "139",
              "24009115470010",
              "HARMANDEEP KAUR",
              "BALJINDER SINGH",
              "423",
              "437",
              "860",
              "1100",
              "74.45%"
            ]
          },
          {
            "sNo": "140",
            "rollNo": "24009115470013",
            "name": "DRISHTI",
            "fatherName": "NAVEEN KUMAR",
            "obtainedMarks": "796",
            "maxMarks": "1100",
            "percentage": "82.73%",
            "cells": [
              "140",
              "24009115470013",
              "DRISHTI",
              "NAVEEN KUMAR",
              "406",
              "390",
              "796",
              "1100",
              "82.73%"
            ]
          },
          {
            "sNo": "141",
            "rollNo": "24009115470015",
            "name": "PAYAL",
            "fatherName": "SUKHDEV RAJ",
            "obtainedMarks": "749",
            "maxMarks": "1100",
            "percentage": "72.73%",
            "cells": [
              "141",
              "24009115470015",
              "PAYAL",
              "SUKHDEV RAJ",
              "394",
              "355",
              "749",
              "1100",
              "72.73%"
            ]
          },
          {
            "sNo": "142",
            "rollNo": "24009115470017",
            "name": "HARSHITA",
            "fatherName": "SATISH KUMAR BHATIA",
            "obtainedMarks": "819",
            "maxMarks": "1100",
            "percentage": "79.27%",
            "cells": [
              "142",
              "24009115470017",
              "HARSHITA",
              "SATISH KUMAR BHATIA",
              "403",
              "416",
              "819",
              "1100",
              "79.27%"
            ]
          },
          {
            "sNo": "143",
            "rollNo": "24009115470019",
            "name": "NAZUK",
            "fatherName": "JAGAT PARKASH",
            "obtainedMarks": "910",
            "maxMarks": "1100",
            "percentage": "76.82%",
            "cells": [
              "143",
              "24009115470019",
              "NAZUK",
              "JAGAT PARKASH",
              "439",
              "471",
              "910",
              "1100",
              "76.82%"
            ]
          },
          {
            "sNo": "144",
            "rollNo": "24009115470020",
            "name": "PRIYA",
            "fatherName": "BHAIRO  SINGH",
            "obtainedMarks": "800",
            "maxMarks": "1100",
            "percentage": "74%",
            "cells": [
              "144",
              "24009115470020",
              "PRIYA",
              "BHAIRO  SINGH",
              "412",
              "388",
              "800",
              "1100",
              "74%"
            ]
          },
          {
            "sNo": "145",
            "rollNo": "24009115470023",
            "name": "SIMRAN",
            "fatherName": "ANIL KUMAR",
            "obtainedMarks": "872",
            "maxMarks": "1100",
            "percentage": "71.45%",
            "cells": [
              "145",
              "24009115470023",
              "SIMRAN",
              "ANIL KUMAR",
              "426",
              "446",
              "872",
              "1100",
              "71.45%"
            ]
          },
          {
            "sNo": "146",
            "rollNo": "24009115470028",
            "name": "MEHAK",
            "fatherName": "VED PRAKASH CHUGH",
            "obtainedMarks": "845",
            "maxMarks": "1100",
            "percentage": "75.18%",
            "cells": [
              "146",
              "24009115470028",
              "MEHAK",
              "VED PRAKASH CHUGH",
              "415",
              "430",
              "845",
              "1100",
              "75.18%"
            ]
          },
          {
            "sNo": "147",
            "rollNo": "24009115470029",
            "name": "SONALI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "814",
            "maxMarks": "1100",
            "percentage": "72.27%",
            "cells": [
              "147",
              "24009115470029",
              "SONALI",
              "SUNIL KUMAR",
              "404",
              "410",
              "814",
              "1100",
              "72.27%"
            ]
          },
          {
            "sNo": "148",
            "rollNo": "24009115470036",
            "name": "PAYAL",
            "fatherName": "RAMKUMAR",
            "obtainedMarks": "786",
            "maxMarks": "1100",
            "percentage": "83%",
            "cells": [
              "148",
              "24009115470036",
              "PAYAL",
              "RAMKUMAR",
              "403",
              "383",
              "786",
              "1100",
              "83%"
            ]
          },
          {
            "sNo": "149",
            "rollNo": "24009115470038",
            "name": "VANDANA",
            "fatherName": "SUNAM CHAND",
            "obtainedMarks": "827",
            "maxMarks": "1100",
            "percentage": "75.18%",
            "cells": [
              "149",
              "24009115470038",
              "VANDANA",
              "SUNAM CHAND",
              "403",
              "424",
              "827",
              "1100",
              "75.18%"
            ]
          },
          {
            "sNo": "150",
            "rollNo": "24009115470042",
            "name": "JASPREET KAUR",
            "fatherName": "MANGAL SINGH",
            "obtainedMarks": "795",
            "maxMarks": "1100",
            "percentage": "72.27%",
            "cells": [
              "150",
              "24009115470042",
              "JASPREET KAUR",
              "MANGAL SINGH",
              "394",
              "401",
              "795",
              "1100",
              "72.27%"
            ]
          },
          {
            "sNo": "151",
            "rollNo": "24009115470049",
            "name": "NISHA",
            "fatherName": "MANGAT RAM",
            "obtainedMarks": "913",
            "maxMarks": "1100",
            "percentage": "83%",
            "cells": [
              "151",
              "24009115470049",
              "NISHA",
              "MANGAT RAM",
              "432",
              "481",
              "913",
              "1100",
              "83%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA I1 Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 600",
          "IV Sem Marks out of 700",
          "III Sem +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "152",
            "rollNo": "23009115470003",
            "name": "SNEHA",
            "fatherName": "SUKHDEV SINGH",
            "obtainedMarks": "988",
            "maxMarks": "1300",
            "percentage": "76%",
            "cells": [
              "152",
              "23009115470003",
              "SNEHA",
              "SUKHDEV SINGH",
              "435",
              "553",
              "988",
              "1300",
              "76%"
            ]
          },
          {
            "sNo": "153",
            "rollNo": "23009115470008",
            "name": "SIMRAN  KAUR",
            "fatherName": "TARLOCHAN SINGH",
            "obtainedMarks": "925",
            "maxMarks": "1300",
            "percentage": "71.15%",
            "cells": [
              "153",
              "23009115470008",
              "SIMRAN  KAUR",
              "TARLOCHAN SINGH",
              "426",
              "499",
              "925",
              "1300",
              "71.15%"
            ]
          },
          {
            "sNo": "154",
            "rollNo": "23009115470010",
            "name": "VANDANA",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "935",
            "maxMarks": "1300",
            "percentage": "71.92%",
            "cells": [
              "154",
              "23009115470010",
              "VANDANA",
              "BALWAN SINGH",
              "418",
              "517",
              "935",
              "1300",
              "71.92%"
            ]
          },
          {
            "sNo": "155",
            "rollNo": "23009115470011",
            "name": "SHRUTI",
            "fatherName": "VIRBHAN",
            "obtainedMarks": "944",
            "maxMarks": "1300",
            "percentage": "72.61%",
            "cells": [
              "155",
              "23009115470011",
              "SHRUTI",
              "VIRBHAN",
              "404",
              "540",
              "944",
              "1300",
              "72.61%"
            ]
          },
          {
            "sNo": "156",
            "rollNo": "23009115470014",
            "name": "SONU RANI",
            "fatherName": "SUSHIL KUMAR",
            "obtainedMarks": "1021",
            "maxMarks": "1300",
            "percentage": "78.53%",
            "cells": [
              "156",
              "23009115470014",
              "SONU RANI",
              "SUSHIL KUMAR",
              "451",
              "570",
              "1021",
              "1300",
              "78.53%"
            ]
          },
          {
            "sNo": "157",
            "rollNo": "23009115470016",
            "name": "RIYA",
            "fatherName": "NIRMAL",
            "obtainedMarks": "991",
            "maxMarks": "1300",
            "percentage": "76.23%",
            "cells": [
              "157",
              "23009115470016",
              "RIYA",
              "NIRMAL",
              "422",
              "569",
              "991",
              "1300",
              "76.23%"
            ]
          },
          {
            "sNo": "158",
            "rollNo": "23009115470018",
            "name": "JYOTI",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "947",
            "maxMarks": "1300",
            "percentage": "72.84%",
            "cells": [
              "158",
              "23009115470018",
              "JYOTI",
              "SANJAY KUMAR",
              "396",
              "551",
              "947",
              "1300",
              "72.84%"
            ]
          },
          {
            "sNo": "159",
            "rollNo": "23009115470019",
            "name": "ARSHPREET KAUR",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "1045",
            "maxMarks": "1300",
            "percentage": "80.38%",
            "cells": [
              "159",
              "23009115470019",
              "ARSHPREET KAUR",
              "SURENDER SINGH",
              "475",
              "570",
              "1045",
              "1300",
              "80.38%"
            ]
          },
          {
            "sNo": "160",
            "rollNo": "23009115470025",
            "name": "ANAMIKA DEVI",
            "fatherName": "SUKHDEV",
            "obtainedMarks": "942",
            "maxMarks": "1300",
            "percentage": "72.46%",
            "cells": [
              "160",
              "23009115470025",
              "ANAMIKA DEVI",
              "SUKHDEV",
              "416",
              "526",
              "942",
              "1300",
              "72.46%"
            ]
          },
          {
            "sNo": "161",
            "rollNo": "23009115470035",
            "name": "NEHA",
            "fatherName": "SHREE RAM",
            "obtainedMarks": "929",
            "maxMarks": "1300",
            "percentage": "71.46%",
            "cells": [
              "161",
              "23009115470035",
              "NEHA",
              "SHREE RAM",
              "407",
              "522",
              "929",
              "1300",
              "71.46%"
            ]
          },
          {
            "sNo": "162",
            "rollNo": "23009115470036",
            "name": "RIYA",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "964",
            "maxMarks": "1300",
            "percentage": "74.15%",
            "cells": [
              "162",
              "23009115470036",
              "RIYA",
              "SUNIL KUMAR",
              "433",
              "531",
              "964",
              "1300",
              "74.15%"
            ]
          },
          {
            "sNo": "163",
            "rollNo": "23009115470040",
            "name": "AANCHAL RANI",
            "fatherName": "KALA RAM",
            "obtainedMarks": "1114",
            "maxMarks": "1300",
            "percentage": "85.69%",
            "cells": [
              "163",
              "23009115470040",
              "AANCHAL RANI",
              "KALA RAM",
              "509",
              "605",
              "1114",
              "1300",
              "85.69%"
            ]
          },
          {
            "sNo": "164",
            "rollNo": "23009115470043",
            "name": "ARJU RANI",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "919",
            "maxMarks": "1300",
            "percentage": "70.69%",
            "cells": [
              "164",
              "23009115470043",
              "ARJU RANI",
              "SUBHASH CHANDER",
              "404",
              "515",
              "919",
              "1300",
              "70.69%"
            ]
          }
        ]
      },
      {
        "courseName": "BCA II1 Year",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "V SEM Marks out of 600",
          "VI SEM Marks out of 700",
          "V+VI SEM",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "165",
            "rollNo": "22009115470001",
            "name": "SANYA",
            "fatherName": "DASHRATH KUMAR",
            "obtainedMarks": "953",
            "maxMarks": "1300",
            "percentage": "73.31%",
            "cells": [
              "165",
              "22009115470001",
              "SANYA",
              "DASHRATH KUMAR",
              "425",
              "528",
              "953",
              "1300",
              "73.31%"
            ]
          },
          {
            "sNo": "166",
            "rollNo": "22009115470002",
            "name": "MEENU",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "1002",
            "maxMarks": "1300",
            "percentage": "77.08%",
            "cells": [
              "166",
              "22009115470002",
              "MEENU",
              "SURENDER KUMAR",
              "455",
              "547",
              "1002",
              "1300",
              "77.08%"
            ]
          },
          {
            "sNo": "167",
            "rollNo": "22009115470004",
            "name": "SIMRANPREET KAUR",
            "fatherName": "BEANT SINGH",
            "obtainedMarks": "983",
            "maxMarks": "1300",
            "percentage": "75.62%",
            "cells": [
              "167",
              "22009115470004",
              "SIMRANPREET KAUR",
              "BEANT SINGH",
              "438",
              "545",
              "983",
              "1300",
              "75.62%"
            ]
          },
          {
            "sNo": "168",
            "rollNo": "22009115470006",
            "name": "NEHA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "966",
            "maxMarks": "1300",
            "percentage": "74.31%",
            "cells": [
              "168",
              "22009115470006",
              "NEHA",
              "RAMESH KUMAR",
              "441",
              "525",
              "966",
              "1300",
              "74.31%"
            ]
          },
          {
            "sNo": "169",
            "rollNo": "22009115470007",
            "name": "TANNU",
            "fatherName": "RAMESH CHAND",
            "obtainedMarks": "1069",
            "maxMarks": "1300",
            "percentage": "82.23%",
            "cells": [
              "169",
              "22009115470007",
              "TANNU",
              "RAMESH CHAND",
              "479",
              "590",
              "1069",
              "1300",
              "82.23%"
            ]
          },
          {
            "sNo": "170",
            "rollNo": "22009115470008",
            "name": "LOVELEEN KAUR",
            "fatherName": "JAGJEET SINGH",
            "obtainedMarks": "944",
            "maxMarks": "1300",
            "percentage": "72.62%",
            "cells": [
              "170",
              "22009115470008",
              "LOVELEEN KAUR",
              "JAGJEET SINGH",
              "455",
              "489",
              "944",
              "1300",
              "72.62%"
            ]
          },
          {
            "sNo": "171",
            "rollNo": "22009115470011",
            "name": "AVNI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "1017",
            "maxMarks": "1300",
            "percentage": "78.23%",
            "cells": [
              "171",
              "22009115470011",
              "AVNI",
              "VINOD KUMAR",
              "447",
              "570",
              "1017",
              "1300",
              "78.23%"
            ]
          },
          {
            "sNo": "172",
            "rollNo": "22009115470012",
            "name": "KAVITA",
            "fatherName": "JAGDISH",
            "obtainedMarks": "1002",
            "maxMarks": "1300",
            "percentage": "77.08%",
            "cells": [
              "172",
              "22009115470012",
              "KAVITA",
              "JAGDISH",
              "433",
              "569",
              "1002",
              "1300",
              "77.08%"
            ]
          },
          {
            "sNo": "173",
            "rollNo": "22009115470015",
            "name": "AASHIMA",
            "fatherName": "RAVINDER KUMAR",
            "obtainedMarks": "1012",
            "maxMarks": "1300",
            "percentage": "77.85%",
            "cells": [
              "173",
              "22009115470015",
              "AASHIMA",
              "RAVINDER KUMAR",
              "441",
              "571",
              "1012",
              "1300",
              "77.85%"
            ]
          },
          {
            "sNo": "174",
            "rollNo": "22009115470017",
            "name": "NANCY",
            "fatherName": "ASHOK KUMAR",
            "obtainedMarks": "932",
            "maxMarks": "1300",
            "percentage": "71.69%",
            "cells": [
              "174",
              "22009115470017",
              "NANCY",
              "ASHOK KUMAR",
              "406",
              "526",
              "932",
              "1300",
              "71.69%"
            ]
          },
          {
            "sNo": "175",
            "rollNo": "22009115470018",
            "name": "UPASNA",
            "fatherName": "RAJENDER",
            "obtainedMarks": "965",
            "maxMarks": "1300",
            "percentage": "74.23%",
            "cells": [
              "175",
              "22009115470018",
              "UPASNA",
              "RAJENDER",
              "441",
              "524",
              "965",
              "1300",
              "74.23%"
            ]
          },
          {
            "sNo": "176",
            "rollNo": "22009115470020",
            "name": "KIRTI",
            "fatherName": "PRITHVI RAJ",
            "obtainedMarks": "978",
            "maxMarks": "1300",
            "percentage": "75.23%",
            "cells": [
              "176",
              "22009115470020",
              "KIRTI",
              "PRITHVI RAJ",
              "421",
              "557",
              "978",
              "1300",
              "75.23%"
            ]
          },
          {
            "sNo": "177",
            "rollNo": "22009115470024",
            "name": "PALAK JINDAL",
            "fatherName": "JEEWAN KUMAR",
            "obtainedMarks": "978",
            "maxMarks": "1300",
            "percentage": "75.23%",
            "cells": [
              "177",
              "22009115470024",
              "PALAK JINDAL",
              "JEEWAN KUMAR",
              "436",
              "542",
              "978",
              "1300",
              "75.23%"
            ]
          },
          {
            "sNo": "178",
            "rollNo": "22009115470025",
            "name": "ARTI",
            "fatherName": "RAM CHANDER",
            "obtainedMarks": "953",
            "maxMarks": "1300",
            "percentage": "73.31%",
            "cells": [
              "178",
              "22009115470025",
              "ARTI",
              "RAM CHANDER",
              "422",
              "531",
              "953",
              "1300",
              "73.31%"
            ]
          },
          {
            "sNo": "179",
            "rollNo": "22009115470028",
            "name": "MEHAK GARG",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "1056",
            "maxMarks": "1300",
            "percentage": "81.23%",
            "cells": [
              "179",
              "22009115470028",
              "MEHAK GARG",
              "SANJAY KUMAR",
              "480",
              "576",
              "1056",
              "1300",
              "81.23%"
            ]
          },
          {
            "sNo": "180",
            "rollNo": "22009115470030",
            "name": "ANJALI",
            "fatherName": "JAIPRAKASH",
            "obtainedMarks": "932",
            "maxMarks": "1300",
            "percentage": "71.69%",
            "cells": [
              "180",
              "22009115470030",
              "ANJALI",
              "JAIPRAKASH",
              "424",
              "508",
              "932",
              "1300",
              "71.69%"
            ]
          },
          {
            "sNo": "181",
            "rollNo": "22009115470034",
            "name": "NEHA",
            "fatherName": "MAJER SINGH",
            "obtainedMarks": "970",
            "maxMarks": "1300",
            "percentage": "74.62%",
            "cells": [
              "181",
              "22009115470034",
              "NEHA",
              "MAJER SINGH",
              "423",
              "547",
              "970",
              "1300",
              "74.62%"
            ]
          },
          {
            "sNo": "182",
            "rollNo": "22009115470035",
            "name": "KHUSHMEET KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "967",
            "maxMarks": "1300",
            "percentage": "74.38%",
            "cells": [
              "182",
              "22009115470035",
              "KHUSHMEET KAUR",
              "JASPAL SINGH",
              "432",
              "535",
              "967",
              "1300",
              "74.38%"
            ]
          },
          {
            "sNo": "183",
            "rollNo": "22009115470036",
            "name": "MS AANCHAL LAKHOTIA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1067",
            "maxMarks": "1300",
            "percentage": "82.08%",
            "cells": [
              "183",
              "22009115470036",
              "MS AANCHAL LAKHOTIA",
              "MADAN LAL",
              "498",
              "569",
              "1067",
              "1300",
              "82.08%"
            ]
          },
          {
            "sNo": "184",
            "rollNo": "22009115470038",
            "name": "SAKSHI",
            "fatherName": "VINOD SHARMA",
            "obtainedMarks": "969",
            "maxMarks": "1300",
            "percentage": "74.54%",
            "cells": [
              "184",
              "22009115470038",
              "SAKSHI",
              "VINOD SHARMA",
              "422",
              "547",
              "969",
              "1300",
              "74.54%"
            ]
          },
          {
            "sNo": "185",
            "rollNo": "22009115470039",
            "name": "KOMAL",
            "fatherName": "SANJAY KUMAR",
            "obtainedMarks": "971",
            "maxMarks": "1300",
            "percentage": "74.69%",
            "cells": [
              "185",
              "22009115470039",
              "KOMAL",
              "SANJAY KUMAR",
              "398",
              "573",
              "971",
              "1300",
              "74.69%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC 1 YEAR",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  550",
          "II Sem Out of Marks  550",
          "I + II Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "186",
            "rollNo": "24009115420001",
            "name": "ASHPREET KAUR",
            "fatherName": "BALRAJ SINGH",
            "obtainedMarks": "933",
            "maxMarks": "1100",
            "percentage": "84.81%",
            "cells": [
              "186",
              "24009115420001",
              "ASHPREET KAUR",
              "BALRAJ SINGH",
              "448",
              "485",
              "933",
              "1100",
              "84.81%"
            ]
          },
          {
            "sNo": "187",
            "rollNo": "24009115420003",
            "name": "SAPNA",
            "fatherName": "MOHAN LAL",
            "obtainedMarks": "781",
            "maxMarks": "1100",
            "percentage": "71%",
            "cells": [
              "187",
              "24009115420003",
              "SAPNA",
              "MOHAN LAL",
              "394",
              "387",
              "781",
              "1100",
              "71%"
            ]
          },
          {
            "sNo": "188",
            "rollNo": "24009115420005",
            "name": "GEETA RANI",
            "fatherName": "JAGDISH CHAND",
            "obtainedMarks": "802",
            "maxMarks": "1100",
            "percentage": "72.09%",
            "cells": [
              "188",
              "24009115420005",
              "GEETA RANI",
              "JAGDISH CHAND",
              "414",
              "388",
              "802",
              "1100",
              "72.09%"
            ]
          },
          {
            "sNo": "189",
            "rollNo": "24009115420006",
            "name": "JYOTI",
            "fatherName": "DALIP KUMAR",
            "obtainedMarks": "786",
            "maxMarks": "1100",
            "percentage": "71.45%",
            "cells": [
              "189",
              "24009115420006",
              "JYOTI",
              "DALIP KUMAR",
              "393",
              "393",
              "786",
              "1100",
              "71.45%"
            ]
          },
          {
            "sNo": "190",
            "rollNo": "24009115420007",
            "name": "RITU",
            "fatherName": "PAWAN",
            "obtainedMarks": "870",
            "maxMarks": "1100",
            "percentage": "79.09%",
            "cells": [
              "190",
              "24009115420007",
              "RITU",
              "PAWAN",
              "424",
              "446",
              "870",
              "1100",
              "79.09%"
            ]
          },
          {
            "sNo": "191",
            "rollNo": "24009115420008",
            "name": "TANISHA SONI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "777",
            "maxMarks": "1100",
            "percentage": "70.63%",
            "cells": [
              "191",
              "24009115420008",
              "TANISHA SONI",
              "VINOD KUMAR",
              "394",
              "383",
              "777",
              "1100",
              "70.63%"
            ]
          },
          {
            "sNo": "192",
            "rollNo": "24009115420009",
            "name": "SAPNA",
            "fatherName": "SUBE SINGH",
            "obtainedMarks": "851",
            "maxMarks": "1100",
            "percentage": "77.36%",
            "cells": [
              "192",
              "24009115420009",
              "SAPNA",
              "SUBE SINGH",
              "415",
              "436",
              "851",
              "1100",
              "77.36%"
            ]
          },
          {
            "sNo": "193",
            "rollNo": "24009115420010",
            "name": "KIRAN",
            "fatherName": "DESHRAJ",
            "obtainedMarks": "836",
            "maxMarks": "1100",
            "percentage": "76%",
            "cells": [
              "193",
              "24009115420010",
              "KIRAN",
              "DESHRAJ",
              "397",
              "439",
              "836",
              "1100",
              "76%"
            ]
          },
          {
            "sNo": "194",
            "rollNo": "24009115420016",
            "name": "RENU",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "785",
            "maxMarks": "1100",
            "percentage": "71.36%",
            "cells": [
              "194",
              "24009115420016",
              "RENU",
              "RAJESH KUMAR",
              "390",
              "395",
              "785",
              "1100",
              "71.36%"
            ]
          },
          {
            "sNo": "195",
            "rollNo": "24009115420021",
            "name": "KHUSHI NYOL",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "854",
            "maxMarks": "1100",
            "percentage": "77.60%",
            "cells": [
              "195",
              "24009115420021",
              "KHUSHI NYOL",
              "RAKESH KUMAR",
              "417",
              "437",
              "854",
              "1100",
              "77.60%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC 1I YEAR",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 550",
          "IV Sem Marks out of 600",
          "III +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "196",
            "rollNo": "23009115420001",
            "name": "SUMAN",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "926",
            "maxMarks": "1150",
            "percentage": "80.52%",
            "cells": [
              "196",
              "23009115420001",
              "SUMAN",
              "KRISHAN KUMAR",
              "451",
              "475",
              "926",
              "1150",
              "80.52%"
            ]
          },
          {
            "sNo": "197",
            "rollNo": "23009115420016",
            "name": "PARINAZ",
            "fatherName": "JANGIR CHAND",
            "obtainedMarks": "916",
            "maxMarks": "1150",
            "percentage": "79.65%",
            "cells": [
              "197",
              "23009115420016",
              "PARINAZ",
              "JANGIR CHAND",
              "453",
              "463",
              "916",
              "1150",
              "79.65%"
            ]
          },
          {
            "sNo": "198",
            "rollNo": "23009115420019",
            "name": "TISHA",
            "fatherName": "AMIT KUMAR",
            "obtainedMarks": "940",
            "maxMarks": "1150",
            "percentage": "81.73%",
            "cells": [
              "198",
              "23009115420019",
              "TISHA",
              "AMIT KUMAR",
              "460",
              "480",
              "940",
              "1150",
              "81.73%"
            ]
          },
          {
            "sNo": "199",
            "rollNo": "23009115420033",
            "name": "SWATI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "832",
            "maxMarks": "1150",
            "percentage": "72.34%",
            "cells": [
              "199",
              "23009115420033",
              "SWATI",
              "KRISHAN KUMAR",
              "421",
              "411",
              "832",
              "1150",
              "72.34%"
            ]
          }
        ]
      },
      {
        "courseName": "BAJMC 1II YEAR",
        "hasMerit": true,
        "headers": [
          "S.No",
          "Registration No:",
          "Student Name",
          "Father Name",
          "V SEM Marks out of  400",
          "VI SEMMarks out of 500",
          "V+VI SEM",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "200",
            "rollNo": "22009115420001",
            "name": "GEETA RANI",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "646",
            "maxMarks": "900",
            "percentage": "71.78%",
            "cells": [
              "200",
              "22009115420001",
              "GEETA RANI",
              "VINOD KUMAR",
              "275",
              "371",
              "646",
              "900",
              "71.78%"
            ]
          },
          {
            "sNo": "201",
            "rollNo": "22009115420002",
            "name": "RAMAN KAUR",
            "fatherName": "HARJIT SINGH",
            "obtainedMarks": "717",
            "maxMarks": "900",
            "percentage": "79.67%",
            "cells": [
              "201",
              "22009115420002",
              "RAMAN KAUR",
              "HARJIT SINGH",
              "305",
              "412",
              "717",
              "900",
              "79.67%"
            ]
          },
          {
            "sNo": "202",
            "rollNo": "22009115420007",
            "name": "MANITA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "678",
            "maxMarks": "900",
            "percentage": "75.33%",
            "cells": [
              "202",
              "22009115420007",
              "MANITA",
              "VIJAY SINGH",
              "299",
              "379",
              "678",
              "900",
              "75.33%"
            ]
          },
          {
            "sNo": "203",
            "rollNo": "22009115420008",
            "name": "JYOTI",
            "fatherName": "JAGDEEP",
            "obtainedMarks": "659",
            "maxMarks": "900",
            "percentage": "73.22%",
            "cells": [
              "203",
              "22009115420008",
              "JYOTI",
              "JAGDEEP",
              "291",
              "368",
              "659",
              "900",
              "73.22%"
            ]
          },
          {
            "sNo": "204",
            "rollNo": "22009115420010",
            "name": "AMANAT",
            "fatherName": "KULDEEP KUMAR",
            "obtainedMarks": "667",
            "maxMarks": "900",
            "percentage": "74.11%",
            "cells": [
              "204",
              "22009115420010",
              "AMANAT",
              "KULDEEP KUMAR",
              "277",
              "390",
              "667",
              "900",
              "74.11%"
            ]
          },
          {
            "sNo": "205",
            "rollNo": "22009115420011",
            "name": "ALKA",
            "fatherName": "JAIPARKASH",
            "obtainedMarks": "694",
            "maxMarks": "900",
            "percentage": "77.11%",
            "cells": [
              "205",
              "22009115420011",
              "ALKA",
              "JAIPARKASH",
              "304",
              "390",
              "694",
              "900",
              "77.11%"
            ]
          },
          {
            "sNo": "206",
            "rollNo": "22009115420013",
            "name": "YANSHU RANI",
            "fatherName": "DEVENDER",
            "obtainedMarks": "697",
            "maxMarks": "900",
            "percentage": "77.44%",
            "cells": [
              "206",
              "22009115420013",
              "YANSHU RANI",
              "DEVENDER",
              "300",
              "397",
              "697",
              "900",
              "77.44%"
            ]
          },
          {
            "sNo": "207",
            "rollNo": "22009115420018",
            "name": "ANSHIKA",
            "fatherName": "PUNISH KUMAR",
            "obtainedMarks": "698",
            "maxMarks": "900",
            "percentage": "77.56%",
            "cells": [
              "207",
              "22009115420018",
              "ANSHIKA",
              "PUNISH KUMAR",
              "306",
              "392",
              "698",
              "900",
              "77.56%"
            ]
          },
          {
            "sNo": "208",
            "rollNo": "22009115420021",
            "name": "RAMANPREET KAUR",
            "fatherName": "RANJEET SINGH",
            "obtainedMarks": "683",
            "maxMarks": "900",
            "percentage": "75.89%",
            "cells": [
              "208",
              "22009115420021",
              "RAMANPREET KAUR",
              "RANJEET SINGH",
              "302",
              "381",
              "683",
              "900",
              "75.89%"
            ]
          },
          {
            "sNo": "209",
            "rollNo": "22009115420022",
            "name": "KUSUM",
            "fatherName": "GAUTAM SONI",
            "obtainedMarks": "704",
            "maxMarks": "900",
            "percentage": "78.22%",
            "cells": [
              "209",
              "22009115420022",
              "KUSUM",
              "GAUTAM SONI",
              "314",
              "390",
              "704",
              "900",
              "78.22%"
            ]
          },
          {
            "sNo": "210",
            "rollNo": "22009115420024",
            "name": "RICHA",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "676",
            "maxMarks": "900",
            "percentage": "75.11%",
            "cells": [
              "210",
              "22009115420024",
              "RICHA",
              "VED PARKASH",
              "295",
              "381",
              "676",
              "900",
              "75.11%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM 1st Year",
        "hasMerit": true,
        "headers": [
          "Sr no.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  600",
          "II Sem Out of Marks  600",
          "I +II Sem",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "211",
            "rollNo": "24009115450008",
            "name": "JASHANDEEP KAUR",
            "fatherName": "MAJOR SINGH",
            "obtainedMarks": "914",
            "maxMarks": "1200",
            "percentage": "76.17%",
            "cells": [
              "211",
              "24009115450008",
              "JASHANDEEP KAUR",
              "MAJOR SINGH",
              "455",
              "459",
              "914",
              "1200",
              "76.17%"
            ]
          },
          {
            "sNo": "212",
            "rollNo": "24009115450009",
            "name": "SAVITA",
            "fatherName": "BALWAN",
            "obtainedMarks": "874",
            "maxMarks": "1200",
            "percentage": "72.83%",
            "cells": [
              "212",
              "24009115450009",
              "SAVITA",
              "BALWAN",
              "425",
              "449",
              "874",
              "1200",
              "72.83%"
            ]
          },
          {
            "sNo": "213",
            "rollNo": "24009115450027",
            "name": "SHIVANI INSAN",
            "fatherName": "PRITHVI SINGH",
            "obtainedMarks": "857",
            "maxMarks": "1200",
            "percentage": "71.42%",
            "cells": [
              "213",
              "24009115450027",
              "SHIVANI INSAN",
              "PRITHVI SINGH",
              "425",
              "432",
              "857",
              "1200",
              "71.42%"
            ]
          },
          {
            "sNo": "214",
            "rollNo": "24009115450031",
            "name": "JASMEET KAUR",
            "fatherName": "BUTA SINGH",
            "obtainedMarks": "867",
            "maxMarks": "1200",
            "percentage": "72.25%",
            "cells": [
              "214",
              "24009115450031",
              "JASMEET KAUR",
              "BUTA SINGH",
              "423",
              "444",
              "867",
              "1200",
              "72.25%"
            ]
          },
          {
            "sNo": "215",
            "rollNo": "24009115450032",
            "name": "GURJOT KAUR",
            "fatherName": "GURCHARAN SINGH",
            "obtainedMarks": "953",
            "maxMarks": "1200",
            "percentage": "79.42%",
            "cells": [
              "215",
              "24009115450032",
              "GURJOT KAUR",
              "GURCHARAN SINGH",
              "480",
              "473",
              "953",
              "1200",
              "79.42%"
            ]
          },
          {
            "sNo": "216",
            "rollNo": "24009115450034",
            "name": "SAGANDEEP",
            "fatherName": "RANJIT SINGH",
            "obtainedMarks": "914",
            "maxMarks": "1200",
            "percentage": "76.17%",
            "cells": [
              "216",
              "24009115450034",
              "SAGANDEEP",
              "RANJIT SINGH",
              "457",
              "457",
              "914",
              "1200",
              "76.17%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.VOC II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 550",
          "IV Sem Marks out of 700",
          "III +IV Sem",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "217",
            "rollNo": "23009115460005",
            "name": "ANKITA",
            "fatherName": "RAVINDER",
            "obtainedMarks": "895",
            "maxMarks": "1250",
            "percentage": "71.60%",
            "cells": [
              "217",
              "23009115460005",
              "ANKITA",
              "RAVINDER",
              "397",
              "498",
              "895",
              "1250",
              "71.60%"
            ]
          },
          {
            "sNo": "218",
            "rollNo": "23009115460006",
            "name": "ANAMI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "945",
            "maxMarks": "1250",
            "percentage": "75.60%",
            "cells": [
              "218",
              "23009115460006",
              "ANAMI",
              "VIJAY KUMAR",
              "409",
              "536",
              "945",
              "1250",
              "75.60%"
            ]
          },
          {
            "sNo": "219",
            "rollNo": "23009115460008",
            "name": "SIMRAN",
            "fatherName": "BALWANT SINGH",
            "obtainedMarks": "919",
            "maxMarks": "1250",
            "percentage": "73.52%",
            "cells": [
              "219",
              "23009115460008",
              "SIMRAN",
              "BALWANT SINGH",
              "402",
              "517",
              "919",
              "1250",
              "73.52%"
            ]
          },
          {
            "sNo": "220",
            "rollNo": "23009115460010",
            "name": "VARSHA",
            "fatherName": "RAMNIWAS",
            "obtainedMarks": "924",
            "maxMarks": "1250",
            "percentage": "73.92%",
            "cells": [
              "220",
              "23009115460010",
              "VARSHA",
              "RAMNIWAS",
              "408",
              "516",
              "924",
              "1250",
              "73.92%"
            ]
          },
          {
            "sNo": "221",
            "rollNo": "23009115460011",
            "name": "ANKITA",
            "fatherName": "PARDEEP KUMAR",
            "obtainedMarks": "876",
            "maxMarks": "1250",
            "percentage": "70.08%",
            "cells": [
              "221",
              "23009115460011",
              "ANKITA",
              "PARDEEP KUMAR",
              "389",
              "487",
              "876",
              "1250",
              "70.08%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM.GEN. II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 550",
          "IV Sem Marks out of 700",
          "III +IV Sem",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "222",
            "rollNo": "23009115450001",
            "name": "JASMINE",
            "fatherName": "SURINDER KUMAR",
            "obtainedMarks": "1017",
            "maxMarks": "1250",
            "percentage": "81.36%",
            "cells": [
              "222",
              "23009115450001",
              "JASMINE",
              "SURINDER KUMAR",
              "465",
              "552",
              "1017",
              "1250",
              "81.36%"
            ]
          },
          {
            "sNo": "223",
            "rollNo": "23009115450006",
            "name": "KHUSHPREET KAUR",
            "fatherName": "LAKHVIR SINGH",
            "obtainedMarks": "944",
            "maxMarks": "1250",
            "percentage": "75.52%",
            "cells": [
              "223",
              "23009115450006",
              "KHUSHPREET KAUR",
              "LAKHVIR SINGH",
              "421",
              "523",
              "944",
              "1250",
              "75.52%"
            ]
          },
          {
            "sNo": "224",
            "rollNo": "23009115450007",
            "name": "ALISHA",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "991",
            "maxMarks": "1250",
            "percentage": "79.28%",
            "cells": [
              "224",
              "23009115450007",
              "ALISHA",
              "RAJ KUMAR",
              "455",
              "536",
              "991",
              "1250",
              "79.28%"
            ]
          },
          {
            "sNo": "225",
            "rollNo": "23009115450010",
            "name": "LEENA",
            "fatherName": "RAVI KUMAR",
            "obtainedMarks": "890",
            "maxMarks": "1250",
            "percentage": "71.20%",
            "cells": [
              "225",
              "23009115450010",
              "LEENA",
              "RAVI KUMAR",
              "398",
              "492",
              "890",
              "1250",
              "71.20%"
            ]
          },
          {
            "sNo": "226",
            "rollNo": "23009115450011",
            "name": "LUCKY",
            "fatherName": "MADHUSUDHAN",
            "obtainedMarks": "908",
            "maxMarks": "1250",
            "percentage": "72.64%",
            "cells": [
              "226",
              "23009115450011",
              "LUCKY",
              "MADHUSUDHAN",
              "403",
              "505",
              "908",
              "1250",
              "72.64%"
            ]
          },
          {
            "sNo": "227",
            "rollNo": "23009115450014",
            "name": "POOJA RANI",
            "fatherName": "RAM SINGH",
            "obtainedMarks": "972",
            "maxMarks": "1250",
            "percentage": "77.76%",
            "cells": [
              "227",
              "23009115450014",
              "POOJA RANI",
              "RAM SINGH",
              "445",
              "527",
              "972",
              "1250",
              "77.76%"
            ]
          },
          {
            "sNo": "228",
            "rollNo": "23009115450018",
            "name": "RIMPI",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "931",
            "maxMarks": "1250",
            "percentage": "74.48%",
            "cells": [
              "228",
              "23009115450018",
              "RIMPI",
              "SURENDER KUMAR",
              "418",
              "513",
              "931",
              "1250",
              "74.48%"
            ]
          },
          {
            "sNo": "229",
            "rollNo": "23009115450019",
            "name": "POOJA",
            "fatherName": "MOHIT",
            "obtainedMarks": "963",
            "maxMarks": "1250",
            "percentage": "77.04%",
            "cells": [
              "229",
              "23009115450019",
              "POOJA",
              "MOHIT",
              "426",
              "537",
              "963",
              "1250",
              "77.04%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM(VOC) III YEAR",
        "hasMerit": true,
        "headers": [
          "SR.NO",
          "Registration No:",
          "Student Name",
          "Father Name",
          "5th Sem Marks out of 600",
          "6th Sem  Marks out of 650",
          "5TH+6TH",
          "Total Max Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "230",
            "rollNo": "22009115460002",
            "name": "RIYA RANI",
            "fatherName": "NIRMEL SINGH",
            "obtainedMarks": "893",
            "maxMarks": "1250",
            "percentage": "71.44%",
            "cells": [
              "230",
              "22009115460002",
              "RIYA RANI",
              "NIRMEL SINGH",
              "426",
              "467",
              "893",
              "1250",
              "71.44%"
            ]
          },
          {
            "sNo": "231",
            "rollNo": "22009115460003",
            "name": "HIMANSHI",
            "fatherName": "VIJAY KUMAR",
            "obtainedMarks": "1056",
            "maxMarks": "1250",
            "percentage": "84.48%",
            "cells": [
              "231",
              "22009115460003",
              "HIMANSHI",
              "VIJAY KUMAR",
              "518",
              "538",
              "1056",
              "1250",
              "84.48%"
            ]
          },
          {
            "sNo": "232",
            "rollNo": "22009115460010",
            "name": "KANCHAN BALA",
            "fatherName": "KISHOR KUMAR SHARMA",
            "obtainedMarks": "1008",
            "maxMarks": "1250",
            "percentage": "80.64%",
            "cells": [
              "232",
              "22009115460010",
              "KANCHAN BALA",
              "KISHOR KUMAR SHARMA",
              "473",
              "535",
              "1008",
              "1250",
              "80.64%"
            ]
          },
          {
            "sNo": "233",
            "rollNo": "22009115460013",
            "name": "REKHA RANI",
            "fatherName": "GOPI RAM",
            "obtainedMarks": "928",
            "maxMarks": "1250",
            "percentage": "74.24%",
            "cells": [
              "233",
              "22009115460013",
              "REKHA RANI",
              "GOPI RAM",
              "456",
              "472",
              "928",
              "1250",
              "74.24%"
            ]
          },
          {
            "sNo": "234",
            "rollNo": "22009115460014",
            "name": "REKHA",
            "fatherName": "ROHTASH",
            "obtainedMarks": "948",
            "maxMarks": "1250",
            "percentage": "75.84%",
            "cells": [
              "234",
              "22009115460014",
              "REKHA",
              "ROHTASH",
              "467",
              "481",
              "948",
              "1250",
              "75.84%"
            ]
          },
          {
            "sNo": "235",
            "rollNo": "22009115460015",
            "name": "SHAFALI GARG",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "1014",
            "maxMarks": "1250",
            "percentage": "81.12%",
            "cells": [
              "235",
              "22009115460015",
              "SHAFALI GARG",
              "SUNIL KUMAR",
              "489",
              "525",
              "1014",
              "1250",
              "81.12%"
            ]
          }
        ]
      },
      {
        "courseName": "B.COM(GEN) III YEAR",
        "hasMerit": true,
        "headers": [
          "SR.NO",
          "Registration No:",
          "Student Name",
          "Father Name",
          "5th Sem Marks out of 550",
          "6th sem  Marks out of 650",
          "5TH+6TH",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "236",
            "rollNo": "22009115450004",
            "name": "KOMAL",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "902",
            "maxMarks": "1200",
            "percentage": "75.17%",
            "cells": [
              "236",
              "22009115450004",
              "KOMAL",
              "BANSI LAL",
              "404",
              "498",
              "902",
              "1200",
              "75.17%"
            ]
          },
          {
            "sNo": "237",
            "rollNo": "22009115450014",
            "name": "TEJINDER KAUR",
            "fatherName": "CHAMKOUR SINGH",
            "obtainedMarks": "946",
            "maxMarks": "1200",
            "percentage": "78.83%",
            "cells": [
              "237",
              "22009115450014",
              "TEJINDER KAUR",
              "CHAMKOUR SINGH",
              "440",
              "506",
              "946",
              "1200",
              "78.83%"
            ]
          },
          {
            "sNo": "238",
            "rollNo": "22009115450016",
            "name": "BHOOMI TYAGI",
            "fatherName": "DEVENDER",
            "obtainedMarks": "898",
            "maxMarks": "1200",
            "percentage": "74.83%",
            "cells": [
              "238",
              "22009115450016",
              "BHOOMI TYAGI",
              "DEVENDER",
              "383",
              "515",
              "898",
              "1200",
              "74.83%"
            ]
          },
          {
            "sNo": "239",
            "rollNo": "22009115450020",
            "name": "SIMRANJOT KAUR",
            "fatherName": "RANVEER SINGH",
            "obtainedMarks": "927",
            "maxMarks": "1200",
            "percentage": "77.25%",
            "cells": [
              "239",
              "22009115450020",
              "SIMRANJOT KAUR",
              "RANVEER SINGH",
              "435",
              "492",
              "927",
              "1200",
              "77.25%"
            ]
          },
          {
            "sNo": "240",
            "rollNo": "22009115450021",
            "name": "BALJOT KAUR",
            "fatherName": "RANVEER SINGH",
            "obtainedMarks": "932",
            "maxMarks": "1200",
            "percentage": "77.67%",
            "cells": [
              "240",
              "22009115450021",
              "BALJOT KAUR",
              "RANVEER SINGH",
              "428",
              "504",
              "932",
              "1200",
              "77.67%"
            ]
          }
        ]
      },
      {
        "courseName": "BSC 1st Year",
        "hasMerit": true,
        "headers": [
          "Sr no.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  600",
          "II Sem Out of Marks  600",
          "I +II Sem",
          "Total Max Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "241",
            "rollNo": "24009115120012",
            "name": "CHESTA",
            "fatherName": "VIKAS ARORA",
            "obtainedMarks": "890",
            "maxMarks": "1200",
            "percentage": "74.17%",
            "cells": [
              "241",
              "24009115120012",
              "CHESTA",
              "VIKAS ARORA",
              "421",
              "469",
              "890",
              "1200",
              "74.17%"
            ]
          },
          {
            "sNo": "242",
            "rollNo": "24009115120019",
            "name": "PRIYANSHU",
            "fatherName": "KARAMBIR",
            "obtainedMarks": "842",
            "maxMarks": "1200",
            "percentage": "70.17%",
            "cells": [
              "242",
              "24009115120019",
              "PRIYANSHU",
              "KARAMBIR",
              "412",
              "430",
              "842",
              "1200",
              "70.17%"
            ]
          }
        ]
      },
      {
        "courseName": "B.SC.NON.MED.+CS II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 400",
          "IV Sem Marks out of 700",
          "III +IV Sem",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "243",
            "rollNo": "23009115442006",
            "name": "MONIKA",
            "fatherName": "INDRAJ",
            "obtainedMarks": "880",
            "maxMarks": "1100",
            "percentage": "80%",
            "cells": [
              "243",
              "23009115442006",
              "MONIKA",
              "INDRAJ",
              "313",
              "567",
              "880",
              "1100",
              "80%"
            ]
          },
          {
            "sNo": "244",
            "rollNo": "23009115442009",
            "name": "SIMRATPAL KAUR",
            "fatherName": "VEER SINGH",
            "obtainedMarks": "789",
            "maxMarks": "1100",
            "percentage": "71.72%",
            "cells": [
              "244",
              "23009115442009",
              "SIMRATPAL KAUR",
              "VEER SINGH",
              "278",
              "511",
              "789",
              "1100",
              "71.72%"
            ]
          },
          {
            "sNo": "245",
            "rollNo": "23009115442010",
            "name": "GEETA RANI",
            "fatherName": "SHISHPAL",
            "obtainedMarks": "842",
            "maxMarks": "1100",
            "percentage": "76.54%",
            "cells": [
              "245",
              "23009115442010",
              "GEETA RANI",
              "SHISHPAL",
              "299",
              "543",
              "842",
              "1100",
              "76.54%"
            ]
          },
          {
            "sNo": "246",
            "rollNo": "23009115442014",
            "name": "RACHNA",
            "fatherName": "DUNI RAM",
            "obtainedMarks": "816",
            "maxMarks": "1100",
            "percentage": "74.18%",
            "cells": [
              "246",
              "23009115442014",
              "RACHNA",
              "DUNI RAM",
              "273",
              "543",
              "816",
              "1100",
              "74.18%"
            ]
          },
          {
            "sNo": "247",
            "rollNo": "23009115442016",
            "name": "KRITIKA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "905",
            "maxMarks": "1100",
            "percentage": "82.27%",
            "cells": [
              "247",
              "23009115442016",
              "KRITIKA",
              "RAJESH KUMAR",
              "329",
              "576",
              "905",
              "1100",
              "82.27%"
            ]
          },
          {
            "sNo": "248",
            "rollNo": "23009115442017",
            "name": "POONAM",
            "fatherName": "JAIN",
            "obtainedMarks": "816",
            "maxMarks": "1100",
            "percentage": "74.18%",
            "cells": [
              "248",
              "23009115442017",
              "POONAM",
              "JAIN",
              "268",
              "548",
              "816",
              "1100",
              "74.18%"
            ]
          },
          {
            "sNo": "249",
            "rollNo": "23009115442019",
            "name": "MANISHA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "870",
            "maxMarks": "1100",
            "percentage": "79.09%",
            "cells": [
              "249",
              "23009115442019",
              "MANISHA",
              "KRISHAN KUMAR",
              "303",
              "567",
              "870",
              "1100",
              "79.09%"
            ]
          },
          {
            "sNo": "250",
            "rollNo": "23009115442023",
            "name": "SAVITA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "857",
            "maxMarks": "1100",
            "percentage": "77.90%",
            "cells": [
              "250",
              "23009115442023",
              "SAVITA",
              "RAMESH KUMAR",
              "359",
              "498",
              "857",
              "1100",
              "77.90%"
            ]
          },
          {
            "sNo": "251",
            "rollNo": "23009115442024",
            "name": "JASMEET KAUR",
            "fatherName": "GURMEJ SINGH",
            "obtainedMarks": "777",
            "maxMarks": "1100",
            "percentage": "70.63%",
            "cells": [
              "251",
              "23009115442024",
              "JASMEET KAUR",
              "GURMEJ SINGH",
              "296",
              "481",
              "777",
              "1100",
              "70.63%"
            ]
          }
        ]
      },
      {
        "courseName": "B.SC.NON.MED +CS.III Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "V SEM Sem  Marks out of 350",
          "VI SEM Sem  Marks out of 650",
          "V+VI SEM",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "252",
            "rollNo": "22009115442009",
            "name": "MANJOT INSAN",
            "fatherName": "MEWA RAM",
            "obtainedMarks": "776",
            "maxMarks": "1000",
            "percentage": "77.60%",
            "cells": [
              "252",
              "22009115442009",
              "MANJOT INSAN",
              "MEWA RAM",
              "250",
              "526",
              "776",
              "1000",
              "77.60%"
            ]
          },
          {
            "sNo": "253",
            "rollNo": "22009115442023",
            "name": "SAKSHI",
            "fatherName": "BANSI LAL",
            "obtainedMarks": "760",
            "maxMarks": "1000",
            "percentage": "76%",
            "cells": [
              "253",
              "22009115442023",
              "SAKSHI",
              "BANSI LAL",
              "238",
              "522",
              "760",
              "1000",
              "76%"
            ]
          },
          {
            "sNo": "254",
            "rollNo": "22009115442027",
            "name": "HARMANDEEP KAUR",
            "fatherName": "KULWINDER SINGH",
            "obtainedMarks": "754",
            "maxMarks": "1000",
            "percentage": "75.40%",
            "cells": [
              "254",
              "22009115442027",
              "HARMANDEEP KAUR",
              "KULWINDER SINGH",
              "279/400",
              "475/650",
              "754",
              "1000",
              "75.40%"
            ]
          }
        ]
      },
      {
        "courseName": "D.PED 1ST YEAR",
        "hasMerit": true,
        "headers": [
          "SR.NO.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "3RD SEM Out Of MARKS 745",
          "4TH SEM Out Of MARKS 755",
          "1ST+2ND SEM",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "255",
            "rollNo": "24009225640001",
            "name": "SAROJ",
            "fatherName": "MEGHA RAM PADRA",
            "obtainedMarks": "1170",
            "maxMarks": "1500",
            "percentage": "78%",
            "cells": [
              "255",
              "24009225640001",
              "SAROJ",
              "MEGHA RAM PADRA",
              "563",
              "607",
              "1170",
              "1500",
              "78%"
            ]
          },
          {
            "sNo": "256",
            "rollNo": "24009225640002",
            "name": "POONAM",
            "fatherName": "PRAHLADRAM SUNDA",
            "obtainedMarks": "1110",
            "maxMarks": "1500",
            "percentage": "74%",
            "cells": [
              "256",
              "24009225640002",
              "POONAM",
              "PRAHLADRAM SUNDA",
              "524",
              "586",
              "1110",
              "1500",
              "74%"
            ]
          },
          {
            "sNo": "257",
            "rollNo": "24009225640003",
            "name": "CHANDRAWATI CHOUDHARY",
            "fatherName": "PURKHARAM CHOUDHARY",
            "obtainedMarks": "1130",
            "maxMarks": "1500",
            "percentage": "75.33%",
            "cells": [
              "257",
              "24009225640003",
              "CHANDRAWATI CHOUDHARY",
              "PURKHARAM CHOUDHARY",
              "537",
              "593",
              "1130",
              "1500",
              "75.33%"
            ]
          },
          {
            "sNo": "258",
            "rollNo": "24009225640005",
            "name": "SUNITA",
            "fatherName": "RAMA RAM",
            "obtainedMarks": "1082",
            "maxMarks": "1500",
            "percentage": "72.13%",
            "cells": [
              "258",
              "24009225640005",
              "SUNITA",
              "RAMA RAM",
              "518",
              "564",
              "1082",
              "1500",
              "72.13%"
            ]
          },
          {
            "sNo": "259",
            "rollNo": "24009225640006",
            "name": "KAMNA",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1140",
            "maxMarks": "1500",
            "percentage": "76%",
            "cells": [
              "259",
              "24009225640006",
              "KAMNA",
              "DHARAMPAL",
              "550",
              "590",
              "1140",
              "1500",
              "76%"
            ]
          },
          {
            "sNo": "260",
            "rollNo": "24009225640008",
            "name": "KIRANDEEP KOUR",
            "fatherName": "SARVJEET SINGH",
            "obtainedMarks": "1136",
            "maxMarks": "1500",
            "percentage": "75.73%",
            "cells": [
              "260",
              "24009225640008",
              "KIRANDEEP KOUR",
              "SARVJEET SINGH",
              "551",
              "585",
              "1136",
              "1500",
              "75.73%"
            ]
          },
          {
            "sNo": "261",
            "rollNo": "24009225640009",
            "name": "POONAM",
            "fatherName": "SHAILENDRA KUMAR",
            "obtainedMarks": "1111",
            "maxMarks": "1500",
            "percentage": "74.07%",
            "cells": [
              "261",
              "24009225640009",
              "POONAM",
              "SHAILENDRA KUMAR",
              "547",
              "564",
              "1111",
              "1500",
              "74.07%"
            ]
          },
          {
            "sNo": "262",
            "rollNo": "24009225640011",
            "name": "USHA",
            "fatherName": "SISHPAL",
            "obtainedMarks": "1109",
            "maxMarks": "1500",
            "percentage": "73.93%",
            "cells": [
              "262",
              "24009225640011",
              "USHA",
              "SISHPAL",
              "531",
              "578",
              "1109",
              "1500",
              "73.93%"
            ]
          },
          {
            "sNo": "263",
            "rollNo": "24009225640012",
            "name": "RAVINA",
            "fatherName": "SHYAM LAL",
            "obtainedMarks": "1105",
            "maxMarks": "1500",
            "percentage": "73.67%",
            "cells": [
              "263",
              "24009225640012",
              "RAVINA",
              "SHYAM LAL",
              "550",
              "555",
              "1105",
              "1500",
              "73.67%"
            ]
          },
          {
            "sNo": "264",
            "rollNo": "24009225640013",
            "name": "ANKITA",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "1091",
            "maxMarks": "1500",
            "percentage": "72.73%",
            "cells": [
              "264",
              "24009225640013",
              "ANKITA",
              "SURENDER KUMAR",
              "529",
              "562",
              "1091",
              "1500",
              "72.73%"
            ]
          },
          {
            "sNo": "265",
            "rollNo": "24009225640014",
            "name": "ANKITA KUMARI",
            "fatherName": "MAHAVEER SINGH",
            "obtainedMarks": "1147",
            "maxMarks": "1500",
            "percentage": "76.47%",
            "cells": [
              "265",
              "24009225640014",
              "ANKITA KUMARI",
              "MAHAVEER SINGH",
              "533",
              "614",
              "1147",
              "1500",
              "76.47%"
            ]
          },
          {
            "sNo": "266",
            "rollNo": "24009225640015",
            "name": "RITU",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1123",
            "maxMarks": "1500",
            "percentage": "74.87%",
            "cells": [
              "266",
              "24009225640015",
              "RITU",
              "RAMESH KUMAR",
              "531",
              "592",
              "1123",
              "1500",
              "74.87%"
            ]
          },
          {
            "sNo": "267",
            "rollNo": "24009225640016",
            "name": "SNEHA",
            "fatherName": "VEDPRAKASH",
            "obtainedMarks": "1153",
            "maxMarks": "1500",
            "percentage": "76.87%",
            "cells": [
              "267",
              "24009225640016",
              "SNEHA",
              "VEDPRAKASH",
              "538",
              "615",
              "1153",
              "1500",
              "76.87%"
            ]
          },
          {
            "sNo": "268",
            "rollNo": "24009225640017",
            "name": "PRIYANKA GODARA",
            "fatherName": "MANSHA RAM",
            "obtainedMarks": "1201",
            "maxMarks": "1500",
            "percentage": "80.07%",
            "cells": [
              "268",
              "24009225640017",
              "PRIYANKA GODARA",
              "MANSHA RAM",
              "577",
              "624",
              "1201",
              "1500",
              "80.07%"
            ]
          },
          {
            "sNo": "269",
            "rollNo": "24009225640018",
            "name": "SANJU",
            "fatherName": "SANTLAL",
            "obtainedMarks": "1053",
            "maxMarks": "1500",
            "percentage": "70.20%",
            "cells": [
              "269",
              "24009225640018",
              "SANJU",
              "SANTLAL",
              "514",
              "539",
              "1053",
              "1500",
              "70.20%"
            ]
          },
          {
            "sNo": "270",
            "rollNo": "24009225640019",
            "name": "ANJU",
            "fatherName": "SANTLAL",
            "obtainedMarks": "1098",
            "maxMarks": "1500",
            "percentage": "73.20%",
            "cells": [
              "270",
              "24009225640019",
              "ANJU",
              "SANTLAL",
              "540",
              "558",
              "1098",
              "1500",
              "73.20%"
            ]
          },
          {
            "sNo": "271",
            "rollNo": "24009225640020",
            "name": "PRITAM",
            "fatherName": "SOHANLAL",
            "obtainedMarks": "1162",
            "maxMarks": "1500",
            "percentage": "77.47%",
            "cells": [
              "271",
              "24009225640020",
              "PRITAM",
              "SOHANLAL",
              "564",
              "598",
              "1162",
              "1500",
              "77.47%"
            ]
          },
          {
            "sNo": "272",
            "rollNo": "24009225640021",
            "name": "RACHANA GURJAR",
            "fatherName": "BHAGCHAND GURJAR",
            "obtainedMarks": "1095",
            "maxMarks": "1500",
            "percentage": "73%",
            "cells": [
              "272",
              "24009225640021",
              "RACHANA GURJAR",
              "BHAGCHAND GURJAR",
              "524",
              "571",
              "1095",
              "1500",
              "73%"
            ]
          },
          {
            "sNo": "273",
            "rollNo": "24009225640022",
            "name": "MONA GHASAL",
            "fatherName": "UMRAV GHASAL",
            "obtainedMarks": "1056",
            "maxMarks": "1500",
            "percentage": "70.40%",
            "cells": [
              "273",
              "24009225640022",
              "MONA GHASAL",
              "UMRAV GHASAL",
              "506",
              "550",
              "1056",
              "1500",
              "70.40%"
            ]
          },
          {
            "sNo": "274",
            "rollNo": "24009225640023",
            "name": "KAMLA",
            "fatherName": "VEERA RAM",
            "obtainedMarks": "1132",
            "maxMarks": "1500",
            "percentage": "75.47%",
            "cells": [
              "274",
              "24009225640023",
              "KAMLA",
              "VEERA RAM",
              "539",
              "593",
              "1132",
              "1500",
              "75.47%"
            ]
          },
          {
            "sNo": "275",
            "rollNo": "24009225640024",
            "name": "USHA",
            "fatherName": "SATPAL",
            "obtainedMarks": "1119",
            "maxMarks": "1500",
            "percentage": "74.60%",
            "cells": [
              "275",
              "24009225640024",
              "USHA",
              "SATPAL",
              "534",
              "585",
              "1119",
              "1500",
              "74.60%"
            ]
          },
          {
            "sNo": "276",
            "rollNo": "24009225640026",
            "name": "KOMAL",
            "fatherName": "SUKHDEV",
            "obtainedMarks": "1140",
            "maxMarks": "1500",
            "percentage": "76%",
            "cells": [
              "276",
              "24009225640026",
              "KOMAL",
              "SUKHDEV",
              "550",
              "590",
              "1140",
              "1500",
              "76%"
            ]
          },
          {
            "sNo": "277",
            "rollNo": "24009225640027",
            "name": "AARJOO",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.27%",
            "cells": [
              "277",
              "24009225640027",
              "AARJOO",
              "KRISHAN KUMAR",
              "546",
              "568",
              "1114",
              "1500",
              "74.27%"
            ]
          },
          {
            "sNo": "278",
            "rollNo": "24009225640028",
            "name": "AARJU",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "1074",
            "maxMarks": "1500",
            "percentage": "71.60%",
            "cells": [
              "278",
              "24009225640028",
              "AARJU",
              "SANDEEP KUMAR",
              "524",
              "550",
              "1074",
              "1500",
              "71.60%"
            ]
          },
          {
            "sNo": "279",
            "rollNo": "24009225640029",
            "name": "NEHA CHOUDHARY",
            "fatherName": "RAMESH",
            "obtainedMarks": "1095",
            "maxMarks": "1500",
            "percentage": "73%",
            "cells": [
              "279",
              "24009225640029",
              "NEHA CHOUDHARY",
              "RAMESH",
              "533",
              "562",
              "1095",
              "1500",
              "73%"
            ]
          },
          {
            "sNo": "280",
            "rollNo": "24009225640030",
            "name": "KHUSHBU",
            "fatherName": "BALRAJ",
            "obtainedMarks": "1076",
            "maxMarks": "1500",
            "percentage": "71.73%",
            "cells": [
              "280",
              "24009225640030",
              "KHUSHBU",
              "BALRAJ",
              "523",
              "553",
              "1076",
              "1500",
              "71.73%"
            ]
          },
          {
            "sNo": "281",
            "rollNo": "24009225640031",
            "name": "KIRNA",
            "fatherName": "LIKHAMI RAM",
            "obtainedMarks": "1144",
            "maxMarks": "1500",
            "percentage": "76.27%",
            "cells": [
              "281",
              "24009225640031",
              "KIRNA",
              "LIKHAMI RAM",
              "548",
              "596",
              "1144",
              "1500",
              "76.27%"
            ]
          },
          {
            "sNo": "282",
            "rollNo": "24009225640033",
            "name": "KANCHAN",
            "fatherName": "VIKRAM SINGH",
            "obtainedMarks": "1101",
            "maxMarks": "1500",
            "percentage": "73.40%",
            "cells": [
              "282",
              "24009225640033",
              "KANCHAN",
              "VIKRAM SINGH",
              "538",
              "563",
              "1101",
              "1500",
              "73.40%"
            ]
          },
          {
            "sNo": "283",
            "rollNo": "24009225640035",
            "name": "DEEPIKA",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1067",
            "maxMarks": "1500",
            "percentage": "71.13%",
            "cells": [
              "283",
              "24009225640035",
              "DEEPIKA",
              "MADAN LAL",
              "519",
              "548",
              "1067",
              "1500",
              "71.13%"
            ]
          },
          {
            "sNo": "284",
            "rollNo": "24009225640037",
            "name": "NISHA",
            "fatherName": "SATPAL",
            "obtainedMarks": "1115",
            "maxMarks": "1500",
            "percentage": "74.33%",
            "cells": [
              "284",
              "24009225640037",
              "NISHA",
              "SATPAL",
              "536",
              "579",
              "1115",
              "1500",
              "74.33%"
            ]
          },
          {
            "sNo": "285",
            "rollNo": "24009225640040",
            "name": "PRIYA",
            "fatherName": "RAMSWAROOP GODARA",
            "obtainedMarks": "1097",
            "maxMarks": "1500",
            "percentage": "73.13%",
            "cells": [
              "285",
              "24009225640040",
              "PRIYA",
              "RAMSWAROOP GODARA",
              "517",
              "580",
              "1097",
              "1500",
              "73.13%"
            ]
          },
          {
            "sNo": "286",
            "rollNo": "24009225640041",
            "name": "MAMTA RANI",
            "fatherName": "MAHAVIR SINGH",
            "obtainedMarks": "1118",
            "maxMarks": "1500",
            "percentage": "74.53%",
            "cells": [
              "286",
              "24009225640041",
              "MAMTA RANI",
              "MAHAVIR SINGH",
              "538",
              "580",
              "1118",
              "1500",
              "74.53%"
            ]
          },
          {
            "sNo": "287",
            "rollNo": "24009225640042",
            "name": "SANTOSH",
            "fatherName": "GOPI RAM",
            "obtainedMarks": "1091",
            "maxMarks": "1500",
            "percentage": "72.73%",
            "cells": [
              "287",
              "24009225640042",
              "SANTOSH",
              "GOPI RAM",
              "518",
              "573",
              "1091",
              "1500",
              "72.73%"
            ]
          },
          {
            "sNo": "288",
            "rollNo": "24009225640049",
            "name": "AARTI",
            "fatherName": "MANGI LAL",
            "obtainedMarks": "1077",
            "maxMarks": "1500",
            "percentage": "71.80%",
            "cells": [
              "288",
              "24009225640049",
              "AARTI",
              "MANGI LAL",
              "512",
              "565",
              "1077",
              "1500",
              "71.80%"
            ]
          }
        ]
      },
      {
        "courseName": "D.PED II year",
        "hasMerit": true,
        "headers": [
          "SR.NO.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "3RD SEM Out Of MARKS 745",
          "4TH SEM Out Of MARKS 755",
          "3rd+4th",
          "Total  Marks",
          "Percentage"
        ],
        "students": [
          {
            "sNo": "289",
            "rollNo": "23009225640001",
            "name": "MANJU",
            "fatherName": "RAM LAL",
            "obtainedMarks": "1140",
            "maxMarks": "1500",
            "percentage": "76%",
            "cells": [
              "289",
              "23009225640001",
              "MANJU",
              "RAM LAL",
              "552",
              "588",
              "1140",
              "1500",
              "76%"
            ]
          },
          {
            "sNo": "290",
            "rollNo": "23009225640003",
            "name": "POONAM BIJARNIYA",
            "fatherName": "SAJJAN SINGH",
            "obtainedMarks": "1135",
            "maxMarks": "1500",
            "percentage": "75.67%",
            "cells": [
              "290",
              "23009225640003",
              "POONAM BIJARNIYA",
              "SAJJAN SINGH",
              "557",
              "578",
              "1135",
              "1500",
              "75.67%"
            ]
          },
          {
            "sNo": "291",
            "rollNo": "23009225640004",
            "name": "ASHMEET KAUR",
            "fatherName": "LAKHWINDER SINGH",
            "obtainedMarks": "1162",
            "maxMarks": "1500",
            "percentage": "77.47%",
            "cells": [
              "291",
              "23009225640004",
              "ASHMEET KAUR",
              "LAKHWINDER SINGH",
              "563",
              "599",
              "1162",
              "1500",
              "77.47%"
            ]
          },
          {
            "sNo": "292",
            "rollNo": "23009225640005",
            "name": "MANISHA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "1154",
            "maxMarks": "1500",
            "percentage": "76.93%",
            "cells": [
              "292",
              "23009225640005",
              "MANISHA",
              "RAJENDER KUMAR",
              "576",
              "578",
              "1154",
              "1500",
              "76.93%"
            ]
          },
          {
            "sNo": "293",
            "rollNo": "23009225640006",
            "name": "MONIKA",
            "fatherName": "RAN SINGH",
            "obtainedMarks": "1131",
            "maxMarks": "1500",
            "percentage": "75.40%",
            "cells": [
              "293",
              "23009225640006",
              "MONIKA",
              "RAN SINGH",
              "556",
              "575",
              "1131",
              "1500",
              "75.40%"
            ]
          },
          {
            "sNo": "294",
            "rollNo": "23009225640007",
            "name": "MANISHA",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1241",
            "maxMarks": "1500",
            "percentage": "82.73%",
            "cells": [
              "294",
              "23009225640007",
              "MANISHA",
              "RAMESH KUMAR",
              "608",
              "633",
              "1241",
              "1500",
              "82.73%"
            ]
          },
          {
            "sNo": "295",
            "rollNo": "23009225640008",
            "name": "POONAM",
            "fatherName": "SATPAL",
            "obtainedMarks": "1186",
            "maxMarks": "1500",
            "percentage": "79.07%",
            "cells": [
              "295",
              "23009225640008",
              "POONAM",
              "SATPAL",
              "587",
              "599",
              "1186",
              "1500",
              "79.07%"
            ]
          },
          {
            "sNo": "296",
            "rollNo": "23009225640009",
            "name": "ANITA",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1177",
            "maxMarks": "1500",
            "percentage": "78.47%",
            "cells": [
              "296",
              "23009225640009",
              "ANITA",
              "BHOOP SINGH",
              "576",
              "601",
              "1177",
              "1500",
              "78.47%"
            ]
          },
          {
            "sNo": "297",
            "rollNo": "23009225640010",
            "name": "POOJA",
            "fatherName": "BALWAN",
            "obtainedMarks": "1267",
            "maxMarks": "1500",
            "percentage": "84.47%",
            "cells": [
              "297",
              "23009225640010",
              "POOJA",
              "BALWAN",
              "623",
              "644",
              "1267",
              "1500",
              "84.47%"
            ]
          },
          {
            "sNo": "298",
            "rollNo": "23009225640011",
            "name": "POOJA",
            "fatherName": "HAWA SINGH",
            "obtainedMarks": "1205",
            "maxMarks": "1500",
            "percentage": "80.33%",
            "cells": [
              "298",
              "23009225640011",
              "POOJA",
              "HAWA SINGH",
              "583",
              "622",
              "1205",
              "1500",
              "80.33%"
            ]
          },
          {
            "sNo": "299",
            "rollNo": "23009225640012",
            "name": "RUKMANI",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "1221",
            "maxMarks": "1500",
            "percentage": "81.40%",
            "cells": [
              "299",
              "23009225640012",
              "RUKMANI",
              "HANSRAJ",
              "604",
              "617",
              "1221",
              "1500",
              "81.40%"
            ]
          },
          {
            "sNo": "300",
            "rollNo": "23009225640013",
            "name": "AARJOO",
            "fatherName": "SATBIR",
            "obtainedMarks": "1244",
            "maxMarks": "1500",
            "percentage": "82.93%",
            "cells": [
              "300",
              "23009225640013",
              "AARJOO",
              "SATBIR",
              "606",
              "638",
              "1244",
              "1500",
              "82.93%"
            ]
          },
          {
            "sNo": "301",
            "rollNo": "23009225640014",
            "name": "REETU",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "1155",
            "maxMarks": "1500",
            "percentage": "77%",
            "cells": [
              "301",
              "23009225640014",
              "REETU",
              "DAYA RAM",
              "562",
              "593",
              "1155",
              "1500",
              "77%"
            ]
          },
          {
            "sNo": "302",
            "rollNo": "23009225640015",
            "name": "DIKSHA",
            "fatherName": "BALWAN SINGH",
            "obtainedMarks": "1211",
            "maxMarks": "1500",
            "percentage": "80.73%",
            "cells": [
              "302",
              "23009225640015",
              "DIKSHA",
              "BALWAN SINGH",
              "578",
              "633",
              "1211",
              "1500",
              "80.73%"
            ]
          },
          {
            "sNo": "303",
            "rollNo": "23009225640016",
            "name": "SARITA",
            "fatherName": "JAISINGH",
            "obtainedMarks": "1170",
            "maxMarks": "1500",
            "percentage": "78%",
            "cells": [
              "303",
              "23009225640016",
              "SARITA",
              "JAISINGH",
              "550",
              "620",
              "1170",
              "1500",
              "78%"
            ]
          },
          {
            "sNo": "304",
            "rollNo": "23009225640017",
            "name": "BHAWANA",
            "fatherName": "BALDEV",
            "obtainedMarks": "1103",
            "maxMarks": "1500",
            "percentage": "73.53%",
            "cells": [
              "304",
              "23009225640017",
              "BHAWANA",
              "BALDEV",
              "525",
              "578",
              "1103",
              "1500",
              "73.53%"
            ]
          },
          {
            "sNo": "305",
            "rollNo": "23009225640018",
            "name": "GARIMA KANWAR",
            "fatherName": "MAHENDRA SINGH",
            "obtainedMarks": "1138",
            "maxMarks": "1500",
            "percentage": "75.87%",
            "cells": [
              "305",
              "23009225640018",
              "GARIMA KANWAR",
              "MAHENDRA SINGH",
              "550",
              "588",
              "1138",
              "1500",
              "75.87%"
            ]
          },
          {
            "sNo": "306",
            "rollNo": "23009225640019",
            "name": "POOJA",
            "fatherName": "SATVIR",
            "obtainedMarks": "1177",
            "maxMarks": "1500",
            "percentage": "78.47%",
            "cells": [
              "306",
              "23009225640019",
              "POOJA",
              "SATVIR",
              "581",
              "596",
              "1177",
              "1500",
              "78.47%"
            ]
          },
          {
            "sNo": "307",
            "rollNo": "23009225640020",
            "name": "DARSHANA",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "1114",
            "maxMarks": "1500",
            "percentage": "74.27%",
            "cells": [
              "307",
              "23009225640020",
              "DARSHANA",
              "DAYA RAM",
              "542",
              "572",
              "1114",
              "1500",
              "74.27%"
            ]
          },
          {
            "sNo": "308",
            "rollNo": "23009225640021",
            "name": "MANJU",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "1172",
            "maxMarks": "1500",
            "percentage": "78.13%",
            "cells": [
              "308",
              "23009225640021",
              "MANJU",
              "DAYA RAM",
              "568",
              "604",
              "1172",
              "1500",
              "78.13%"
            ]
          },
          {
            "sNo": "309",
            "rollNo": "23009225640022",
            "name": "SANGEETA",
            "fatherName": "SATVEER",
            "obtainedMarks": "1151",
            "maxMarks": "1500",
            "percentage": "76.73%",
            "cells": [
              "309",
              "23009225640022",
              "SANGEETA",
              "SATVEER",
              "562",
              "589",
              "1151",
              "1500",
              "76.73%"
            ]
          },
          {
            "sNo": "310",
            "rollNo": "23009225640023",
            "name": "PARMILA",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "1182",
            "maxMarks": "1500",
            "percentage": "78.80%",
            "cells": [
              "310",
              "23009225640023",
              "PARMILA",
              "SANDEEP KUMAR",
              "576",
              "606",
              "1182",
              "1500",
              "78.80%"
            ]
          },
          {
            "sNo": "311",
            "rollNo": "23009225640024",
            "name": "POOJA KUMARI",
            "fatherName": "BANWARI LAL",
            "obtainedMarks": "1160",
            "maxMarks": "1500",
            "percentage": "77.33%",
            "cells": [
              "311",
              "23009225640024",
              "POOJA KUMARI",
              "BANWARI LAL",
              "568",
              "592",
              "1160",
              "1500",
              "77.33%"
            ]
          },
          {
            "sNo": "312",
            "rollNo": "23009225640025",
            "name": "ANURADHA",
            "fatherName": "RAVI DUTT",
            "obtainedMarks": "1168",
            "maxMarks": "1500",
            "percentage": "77.87%",
            "cells": [
              "312",
              "23009225640025",
              "ANURADHA",
              "RAVI DUTT",
              "571",
              "597",
              "1168",
              "1500",
              "77.87%"
            ]
          },
          {
            "sNo": "313",
            "rollNo": "23009225640026",
            "name": "NEHA",
            "fatherName": "KISHAN SINGH",
            "obtainedMarks": "1176",
            "maxMarks": "1500",
            "percentage": "78.40%",
            "cells": [
              "313",
              "23009225640026",
              "NEHA",
              "KISHAN SINGH",
              "573",
              "603",
              "1176",
              "1500",
              "78.40%"
            ]
          },
          {
            "sNo": "314",
            "rollNo": "23009225640027",
            "name": "NEETU KUMARI",
            "fatherName": "DEBURAM",
            "obtainedMarks": "1167",
            "maxMarks": "1500",
            "percentage": "77.80%",
            "cells": [
              "314",
              "23009225640027",
              "NEETU KUMARI",
              "DEBURAM",
              "572",
              "595",
              "1167",
              "1500",
              "77.80%"
            ]
          },
          {
            "sNo": "315",
            "rollNo": "23009225640028",
            "name": "DEEPA KUMARI",
            "fatherName": "GORDHAN RAM",
            "obtainedMarks": "1157",
            "maxMarks": "1500",
            "percentage": "77.13%",
            "cells": [
              "315",
              "23009225640028",
              "DEEPA KUMARI",
              "GORDHAN RAM",
              "567",
              "590",
              "1157",
              "1500",
              "77.13%"
            ]
          },
          {
            "sNo": "316",
            "rollNo": "23009225640029",
            "name": "MANOJ KHICHAR",
            "fatherName": "SUBHASH CHANDRA KHICHAR",
            "obtainedMarks": "1141",
            "maxMarks": "1500",
            "percentage": "76.07%",
            "cells": [
              "316",
              "23009225640029",
              "MANOJ KHICHAR",
              "SUBHASH CHANDRA KHICHAR",
              "551",
              "590",
              "1141",
              "1500",
              "76.07%"
            ]
          },
          {
            "sNo": "317",
            "rollNo": "23009225640030",
            "name": "MONIKA BENIWAL",
            "fatherName": "SUGNA RAM BENIWAL",
            "obtainedMarks": "1174",
            "maxMarks": "1500",
            "percentage": "78.27%",
            "cells": [
              "317",
              "23009225640030",
              "MONIKA BENIWAL",
              "SUGNA RAM BENIWAL",
              "581",
              "593",
              "1174",
              "1500",
              "78.27%"
            ]
          },
          {
            "sNo": "318",
            "rollNo": "23009225640031",
            "name": "PREETI",
            "fatherName": "RAMESH",
            "obtainedMarks": "1197",
            "maxMarks": "1500",
            "percentage": "79.80%",
            "cells": [
              "318",
              "23009225640031",
              "PREETI",
              "RAMESH",
              "582",
              "615",
              "1197",
              "1500",
              "79.80%"
            ]
          },
          {
            "sNo": "319",
            "rollNo": "23009225640032",
            "name": "DROPADI BENIWAL",
            "fatherName": "GOWARDHAN LAL BENIWAL",
            "obtainedMarks": "1147",
            "maxMarks": "1500",
            "percentage": "76.47%",
            "cells": [
              "319",
              "23009225640032",
              "DROPADI BENIWAL",
              "GOWARDHAN LAL BENIWAL",
              "556",
              "591",
              "1147",
              "1500",
              "76.47%"
            ]
          },
          {
            "sNo": "320",
            "rollNo": "23009225640033",
            "name": "KAVITA",
            "fatherName": "RAKESH",
            "obtainedMarks": "1150",
            "maxMarks": "1500",
            "percentage": "76.67%",
            "cells": [
              "320",
              "23009225640033",
              "KAVITA",
              "RAKESH",
              "561",
              "589",
              "1150",
              "1500",
              "76.67%"
            ]
          },
          {
            "sNo": "321",
            "rollNo": "23009225640034",
            "name": "KAUSHLYA",
            "fatherName": "BHAGI RAM",
            "obtainedMarks": "1184",
            "maxMarks": "1500",
            "percentage": "78.93%",
            "cells": [
              "321",
              "23009225640034",
              "KAUSHLYA",
              "BHAGI RAM",
              "583",
              "601",
              "1184",
              "1500",
              "78.93%"
            ]
          },
          {
            "sNo": "322",
            "rollNo": "23009225640035",
            "name": "GARIMA",
            "fatherName": "SATISH KUMAR",
            "obtainedMarks": "1199",
            "maxMarks": "1500",
            "percentage": "79.93%",
            "cells": [
              "322",
              "23009225640035",
              "GARIMA",
              "SATISH KUMAR",
              "587",
              "612",
              "1199",
              "1500",
              "79.93%"
            ]
          },
          {
            "sNo": "323",
            "rollNo": "23009225640036",
            "name": "SALONI",
            "fatherName": "RAMESH KUMAR",
            "obtainedMarks": "1244",
            "maxMarks": "1500",
            "percentage": "82.93%",
            "cells": [
              "323",
              "23009225640036",
              "SALONI",
              "RAMESH KUMAR",
              "610",
              "634",
              "1244",
              "1500",
              "82.93%"
            ]
          },
          {
            "sNo": "324",
            "rollNo": "23009225640037",
            "name": "INDRA",
            "fatherName": "JAGDISH CHANDRA",
            "obtainedMarks": "1148",
            "maxMarks": "1500",
            "percentage": "76.53%",
            "cells": [
              "324",
              "23009225640037",
              "INDRA",
              "JAGDISH CHANDRA",
              "542",
              "606",
              "1148",
              "1500",
              "76.53%"
            ]
          },
          {
            "sNo": "325",
            "rollNo": "23009225640039",
            "name": "MONIKA",
            "fatherName": "BHAL SINGH",
            "obtainedMarks": "1213",
            "maxMarks": "1500",
            "percentage": "80.87%",
            "cells": [
              "325",
              "23009225640039",
              "MONIKA",
              "BHAL SINGH",
              "558",
              "655",
              "1213",
              "1500",
              "80.87%"
            ]
          },
          {
            "sNo": "326",
            "rollNo": "23009225640040",
            "name": "MANISHA",
            "fatherName": "SAHABRAM",
            "obtainedMarks": "1259",
            "maxMarks": "1500",
            "percentage": "83.93%",
            "cells": [
              "326",
              "23009225640040",
              "MANISHA",
              "SAHABRAM",
              "611",
              "648",
              "1259",
              "1500",
              "83.93%"
            ]
          },
          {
            "sNo": "327",
            "rollNo": "23009225640041",
            "name": "NISHA",
            "fatherName": "VIJAY SINGH",
            "obtainedMarks": "1149",
            "maxMarks": "1500",
            "percentage": "76.60%",
            "cells": [
              "327",
              "23009225640041",
              "NISHA",
              "VIJAY SINGH",
              "557",
              "592",
              "1149",
              "1500",
              "76.60%"
            ]
          },
          {
            "sNo": "328",
            "rollNo": "23009225640042",
            "name": "ROSHANI",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1149",
            "maxMarks": "1500",
            "percentage": "76.60%",
            "cells": [
              "328",
              "23009225640042",
              "ROSHANI",
              "KRISHAN KUMAR",
              "566",
              "583",
              "1149",
              "1500",
              "76.60%"
            ]
          },
          {
            "sNo": "329",
            "rollNo": "23009225640043",
            "name": "RENUKA",
            "fatherName": "RAMKUMAR",
            "obtainedMarks": "1143",
            "maxMarks": "1500",
            "percentage": "76.20%",
            "cells": [
              "329",
              "23009225640043",
              "RENUKA",
              "RAMKUMAR",
              "562",
              "581",
              "1143",
              "1500",
              "76.20%"
            ]
          },
          {
            "sNo": "330",
            "rollNo": "23009225640044",
            "name": "KAMNA",
            "fatherName": "PRADEEP KUMAR",
            "obtainedMarks": "1231",
            "maxMarks": "1500",
            "percentage": "82.07%",
            "cells": [
              "330",
              "23009225640044",
              "KAMNA",
              "PRADEEP KUMAR",
              "601",
              "630",
              "1231",
              "1500",
              "82.07%"
            ]
          },
          {
            "sNo": "331",
            "rollNo": "23009225640045",
            "name": "SULOCHANA",
            "fatherName": "KISHANLAL",
            "obtainedMarks": "1200",
            "maxMarks": "1500",
            "percentage": "80%",
            "cells": [
              "331",
              "23009225640045",
              "SULOCHANA",
              "KISHANLAL",
              "597",
              "603",
              "1200",
              "1500",
              "80%"
            ]
          },
          {
            "sNo": "332",
            "rollNo": "23009225640046",
            "name": "POOJA",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1149",
            "maxMarks": "1500",
            "percentage": "76.60%",
            "cells": [
              "332",
              "23009225640046",
              "POOJA",
              "OM PRAKASH",
              "576",
              "573",
              "1149",
              "1500",
              "76.60%"
            ]
          },
          {
            "sNo": "333",
            "rollNo": "23009225640047",
            "name": "KAVITA",
            "fatherName": "HANSRAJ",
            "obtainedMarks": "1181",
            "maxMarks": "1500",
            "percentage": "78.73%",
            "cells": [
              "333",
              "23009225640047",
              "KAVITA",
              "HANSRAJ",
              "568",
              "613",
              "1181",
              "1500",
              "78.73%"
            ]
          },
          {
            "sNo": "334",
            "rollNo": "23009225640048",
            "name": "KAMALA",
            "fatherName": "CHUNA RAM",
            "obtainedMarks": "1139",
            "maxMarks": "1500",
            "percentage": "75.93%",
            "cells": [
              "334",
              "23009225640048",
              "KAMALA",
              "CHUNA RAM",
              "559",
              "580",
              "1139",
              "1500",
              "75.93%"
            ]
          },
          {
            "sNo": "335",
            "rollNo": "23009225640049",
            "name": "REETU",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1165",
            "maxMarks": "1500",
            "percentage": "77.67%",
            "cells": [
              "335",
              "23009225640049",
              "REETU",
              "PAWAN KUMAR",
              "565",
              "600",
              "1165",
              "1500",
              "77.67%"
            ]
          }
        ]
      },
      {
        "courseName": "B.PED I YEAR",
        "hasMerit": true,
        "headers": [
          "SR.NO",
          "Roll No:",
          "Student Name",
          "Father Name",
          "I SEM  Out of Marks  800",
          "II SEM Out of Marks  800",
          "1+II SEM",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "1",
            "rollNo": "24009115510001",
            "name": "PRIYANKA",
            "fatherName": "DHARMPAL",
            "obtainedMarks": "1237",
            "maxMarks": "1600",
            "percentage": "77.31%",
            "cells": [
              "1",
              "24009115510001",
              "PRIYANKA",
              "DHARMPAL",
              "603",
              "634",
              "1237",
              "1600",
              "77.31%"
            ]
          },
          {
            "sNo": "2",
            "rollNo": "24009115510002",
            "name": "NISHA",
            "fatherName": "DAYARAM",
            "obtainedMarks": "1197",
            "maxMarks": "1600",
            "percentage": "74.81%",
            "cells": [
              "2",
              "24009115510002",
              "NISHA",
              "DAYARAM",
              "574",
              "623",
              "1197",
              "1600",
              "74.81%"
            ]
          },
          {
            "sNo": "3",
            "rollNo": "24009115510003",
            "name": "SITA DEVI",
            "fatherName": "HARPAL",
            "obtainedMarks": "1247",
            "maxMarks": "1600",
            "percentage": "77.94%",
            "cells": [
              "3",
              "24009115510003",
              "SITA DEVI",
              "HARPAL",
              "610",
              "637",
              "1247",
              "1600",
              "77.94%"
            ]
          },
          {
            "sNo": "4",
            "rollNo": "24009115510004",
            "name": "BALA KUMARI",
            "fatherName": "JUGLAL",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "4",
              "24009115510004",
              "BALA KUMARI",
              "JUGLAL",
              "579",
              "623",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "5",
            "rollNo": "24009115510005",
            "name": "PARUL RANI",
            "fatherName": "LEKH RAJ",
            "obtainedMarks": "1233",
            "maxMarks": "1600",
            "percentage": "77.06%",
            "cells": [
              "5",
              "24009115510005",
              "PARUL RANI",
              "LEKH RAJ",
              "612",
              "621",
              "1233",
              "1600",
              "77.06%"
            ]
          },
          {
            "sNo": "6",
            "rollNo": "24009115510006",
            "name": "JASHNDEEP KAUR",
            "fatherName": "JASPAL SINGH",
            "obtainedMarks": "1270",
            "maxMarks": "1600",
            "percentage": "79.38%",
            "cells": [
              "6",
              "24009115510006",
              "JASHNDEEP KAUR",
              "JASPAL SINGH",
              "619",
              "651",
              "1270",
              "1600",
              "79.38%"
            ]
          },
          {
            "sNo": "7",
            "rollNo": "24009115510007",
            "name": "AMISHA RANI",
            "fatherName": "SUNIL KUMAR",
            "obtainedMarks": "1278",
            "maxMarks": "1600",
            "percentage": "79.88%",
            "cells": [
              "7",
              "24009115510007",
              "AMISHA RANI",
              "SUNIL KUMAR",
              "627",
              "651",
              "1278",
              "1600",
              "79.88%"
            ]
          },
          {
            "sNo": "8",
            "rollNo": "24009115510008",
            "name": "POOJA",
            "fatherName": "HARI SINGH",
            "obtainedMarks": "1213",
            "maxMarks": "1600",
            "percentage": "75.81%",
            "cells": [
              "8",
              "24009115510008",
              "POOJA",
              "HARI SINGH",
              "601",
              "612",
              "1213",
              "1600",
              "75.81%"
            ]
          },
          {
            "sNo": "9",
            "rollNo": "24009115510009",
            "name": "REKHA",
            "fatherName": "LAKSHMAN SINGH",
            "obtainedMarks": "1259",
            "maxMarks": "1600",
            "percentage": "78.69%",
            "cells": [
              "9",
              "24009115510009",
              "REKHA",
              "LAKSHMAN SINGH",
              "614",
              "645",
              "1259",
              "1600",
              "78.69%"
            ]
          },
          {
            "sNo": "10",
            "rollNo": "24009115510010",
            "name": "MUKESH RANI",
            "fatherName": "NOPAT RAM",
            "obtainedMarks": "1106",
            "maxMarks": "1600",
            "percentage": "69.12%",
            "cells": [
              "10",
              "24009115510010",
              "MUKESH RANI",
              "NOPAT RAM",
              "551",
              "555",
              "1106",
              "1600",
              "69.12%"
            ]
          },
          {
            "sNo": "11",
            "rollNo": "24009115510011",
            "name": "KAJAL",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "1205",
            "maxMarks": "1600",
            "percentage": "75.31%",
            "cells": [
              "11",
              "24009115510011",
              "KAJAL",
              "VINOD KUMAR",
              "613",
              "592",
              "1205",
              "1600",
              "75.31%"
            ]
          },
          {
            "sNo": "12",
            "rollNo": "24009115510012",
            "name": "RAVITA",
            "fatherName": "MANGTU RAM",
            "obtainedMarks": "1230",
            "maxMarks": "1600",
            "percentage": "76.88%",
            "cells": [
              "12",
              "24009115510012",
              "RAVITA",
              "MANGTU RAM",
              "608",
              "622",
              "1230",
              "1600",
              "76.88%"
            ]
          },
          {
            "sNo": "13",
            "rollNo": "24009115510013",
            "name": "MONIKA",
            "fatherName": "RAJENDER KUMAR",
            "obtainedMarks": "1171",
            "maxMarks": "1600",
            "percentage": "73.19%",
            "cells": [
              "13",
              "24009115510013",
              "MONIKA",
              "RAJENDER KUMAR",
              "576",
              "595",
              "1171",
              "1600",
              "73.19%"
            ]
          },
          {
            "sNo": "14",
            "rollNo": "24009115510015",
            "name": "SONALI",
            "fatherName": "LADHU RAM",
            "obtainedMarks": "1220",
            "maxMarks": "1600",
            "percentage": "76.25%",
            "cells": [
              "14",
              "24009115510015",
              "SONALI",
              "LADHU RAM",
              "574",
              "646",
              "1220",
              "1600",
              "76.25%"
            ]
          },
          {
            "sNo": "15",
            "rollNo": "24009115510017",
            "name": "PRITI",
            "fatherName": "KRISHAN",
            "obtainedMarks": "1206",
            "maxMarks": "1600",
            "percentage": "75.38%",
            "cells": [
              "15",
              "24009115510017",
              "PRITI",
              "KRISHAN",
              "583",
              "623",
              "1206",
              "1600",
              "75.38%"
            ]
          },
          {
            "sNo": "16",
            "rollNo": "24009115510018",
            "name": "RITA",
            "fatherName": "BRIJ LAL",
            "obtainedMarks": "1146",
            "maxMarks": "1600",
            "percentage": "71.62%",
            "cells": [
              "16",
              "24009115510018",
              "RITA",
              "BRIJ LAL",
              "553",
              "593",
              "1146",
              "1600",
              "71.62%"
            ]
          },
          {
            "sNo": "17",
            "rollNo": "24009115510019",
            "name": "BHARTI",
            "fatherName": "SAHAB SINGH",
            "obtainedMarks": "1236",
            "maxMarks": "1600",
            "percentage": "77.25%",
            "cells": [
              "17",
              "24009115510019",
              "BHARTI",
              "SAHAB SINGH",
              "614",
              "622",
              "1236",
              "1600",
              "77.25%"
            ]
          },
          {
            "sNo": "18",
            "rollNo": "24009115510020",
            "name": "MANVI",
            "fatherName": "RAKESH KUMAR",
            "obtainedMarks": "1137",
            "maxMarks": "1600",
            "percentage": "71.06%",
            "cells": [
              "18",
              "24009115510020",
              "MANVI",
              "RAKESH KUMAR",
              "568",
              "569",
              "1137",
              "1600",
              "71.06%"
            ]
          },
          {
            "sNo": "19",
            "rollNo": "24009115510021",
            "name": "REKHA",
            "fatherName": "SAHABRAM",
            "obtainedMarks": "1184",
            "maxMarks": "1600",
            "percentage": "74%",
            "cells": [
              "19",
              "24009115510021",
              "REKHA",
              "SAHABRAM",
              "586",
              "598",
              "1184",
              "1600",
              "74%"
            ]
          },
          {
            "sNo": "20",
            "rollNo": "24009115510022",
            "name": "SHURABHI",
            "fatherName": "MAHENDER",
            "obtainedMarks": "1195",
            "maxMarks": "1600",
            "percentage": "74.69%",
            "cells": [
              "20",
              "24009115510022",
              "SHURABHI",
              "MAHENDER",
              "596",
              "599",
              "1195",
              "1600",
              "74.69%"
            ]
          },
          {
            "sNo": "21",
            "rollNo": "24009115510023",
            "name": "HARVEER KAUR",
            "fatherName": "HARMAIL SINGH",
            "obtainedMarks": "1180",
            "maxMarks": "1600",
            "percentage": "73.75%",
            "cells": [
              "21",
              "24009115510023",
              "HARVEER KAUR",
              "HARMAIL SINGH",
              "585",
              "595",
              "1180",
              "1600",
              "73.75%"
            ]
          },
          {
            "sNo": "22",
            "rollNo": "24009115510024",
            "name": "AARTI DEVI",
            "fatherName": "SATPAL",
            "obtainedMarks": "1221",
            "maxMarks": "1600",
            "percentage": "76.31%",
            "cells": [
              "22",
              "24009115510024",
              "AARTI DEVI",
              "SATPAL",
              "619",
              "602",
              "1221",
              "1600",
              "76.31%"
            ]
          },
          {
            "sNo": "23",
            "rollNo": "24009115510025",
            "name": "SAROJ BALA",
            "fatherName": "VED PARKASH",
            "obtainedMarks": "1174",
            "maxMarks": "1600",
            "percentage": "73.38%",
            "cells": [
              "23",
              "24009115510025",
              "SAROJ BALA",
              "VED PARKASH",
              "584",
              "590",
              "1174",
              "1600",
              "73.38%"
            ]
          },
          {
            "sNo": "24",
            "rollNo": "24009115510028",
            "name": "GAYATRI DEVI",
            "fatherName": "DAYA RAM",
            "obtainedMarks": "1211",
            "maxMarks": "1600",
            "percentage": "75.69%",
            "cells": [
              "24",
              "24009115510028",
              "GAYATRI DEVI",
              "DAYA RAM",
              "602",
              "609",
              "1211",
              "1600",
              "75.69%"
            ]
          },
          {
            "sNo": "25",
            "rollNo": "24009115510029",
            "name": "SEEMA UPADHYAY",
            "fatherName": "NAND LAL UPADHYAY",
            "obtainedMarks": "1176",
            "maxMarks": "1600",
            "percentage": "73.50%",
            "cells": [
              "25",
              "24009115510029",
              "SEEMA UPADHYAY",
              "NAND LAL UPADHYAY",
              "595",
              "581",
              "1176",
              "1600",
              "73.50%"
            ]
          },
          {
            "sNo": "26",
            "rollNo": "24009115510030",
            "name": "ANJLI MAHAVEER CHAUDHARY",
            "fatherName": "MAHAVEER CHAUDHARY",
            "obtainedMarks": "1166",
            "maxMarks": "1600",
            "percentage": "72.88%",
            "cells": [
              "26",
              "24009115510030",
              "ANJLI MAHAVEER CHAUDHARY",
              "MAHAVEER CHAUDHARY",
              "597",
              "569",
              "1166",
              "1600",
              "72.88%"
            ]
          },
          {
            "sNo": "27",
            "rollNo": "24009115510034",
            "name": "PUSHPA",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "1229",
            "maxMarks": "1600",
            "percentage": "76.81%",
            "cells": [
              "27",
              "24009115510034",
              "PUSHPA",
              "RAJESH KUMAR",
              "606",
              "623",
              "1229",
              "1600",
              "76.81%"
            ]
          },
          {
            "sNo": "28",
            "rollNo": "24009115510035",
            "name": "SANTRO",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1204",
            "maxMarks": "1600",
            "percentage": "75.25%",
            "cells": [
              "28",
              "24009115510035",
              "SANTRO",
              "OM PRAKASH",
              "603",
              "601",
              "1204",
              "1600",
              "75.25%"
            ]
          },
          {
            "sNo": "29",
            "rollNo": "24009115510036",
            "name": "SUSHILA KUMARI",
            "fatherName": "SATYAVEER SINGH",
            "obtainedMarks": "1139",
            "maxMarks": "1600",
            "percentage": "71.19%",
            "cells": [
              "29",
              "24009115510036",
              "SUSHILA KUMARI",
              "SATYAVEER SINGH",
              "568",
              "571",
              "1139",
              "1600",
              "71.19%"
            ]
          },
          {
            "sNo": "30",
            "rollNo": "24009115510037",
            "name": "REKHA",
            "fatherName": "DIWAN SINGH",
            "obtainedMarks": "1126",
            "maxMarks": "1600",
            "percentage": "70.38%",
            "cells": [
              "30",
              "24009115510037",
              "REKHA",
              "DIWAN SINGH",
              "559",
              "567",
              "1126",
              "1600",
              "70.38%"
            ]
          },
          {
            "sNo": "31",
            "rollNo": "24009115510040",
            "name": "NEHA",
            "fatherName": "RAJESH",
            "obtainedMarks": "1162",
            "maxMarks": "1600",
            "percentage": "72.62%",
            "cells": [
              "31",
              "24009115510040",
              "NEHA",
              "RAJESH",
              "576",
              "586",
              "1162",
              "1600",
              "72.62%"
            ]
          },
          {
            "sNo": "32",
            "rollNo": "24009115510042",
            "name": "KHUSHBOO",
            "fatherName": "KANHAIYA LAL",
            "obtainedMarks": "1173",
            "maxMarks": "1600",
            "percentage": "73.31%",
            "cells": [
              "32",
              "24009115510042",
              "KHUSHBOO",
              "KANHAIYA LAL",
              "573",
              "600",
              "1173",
              "1600",
              "73.31%"
            ]
          },
          {
            "sNo": "33",
            "rollNo": "24009115510045",
            "name": "SONIA",
            "fatherName": "SUKHVIR",
            "obtainedMarks": "1198",
            "maxMarks": "1600",
            "percentage": "74.88%",
            "cells": [
              "33",
              "24009115510045",
              "SONIA",
              "SUKHVIR",
              "607",
              "591",
              "1198",
              "1600",
              "74.88%"
            ]
          },
          {
            "sNo": "34",
            "rollNo": "24009115510046",
            "name": "APOORVA",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "1224",
            "maxMarks": "1600",
            "percentage": "76.50%",
            "cells": [
              "34",
              "24009115510046",
              "APOORVA",
              "SURENDER SINGH",
              "607",
              "617",
              "1224",
              "1600",
              "76.50%"
            ]
          },
          {
            "sNo": "35",
            "rollNo": "24009115510047",
            "name": "MAMTA RANI",
            "fatherName": "MADAN LAL",
            "obtainedMarks": "1259",
            "maxMarks": "1600",
            "percentage": "78.69%",
            "cells": [
              "35",
              "24009115510047",
              "MAMTA RANI",
              "MADAN LAL",
              "620",
              "639",
              "1259",
              "1600",
              "78.69%"
            ]
          },
          {
            "sNo": "36",
            "rollNo": "24009115510049",
            "name": "TAMANNA",
            "fatherName": "VINOD KUMAR",
            "obtainedMarks": "1206",
            "maxMarks": "1600",
            "percentage": "75.38%",
            "cells": [
              "36",
              "24009115510049",
              "TAMANNA",
              "VINOD KUMAR",
              "613",
              "593",
              "1206",
              "1600",
              "75.38%"
            ]
          },
          {
            "sNo": "37",
            "rollNo": "24009115510050",
            "name": "JYOTI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "1146",
            "maxMarks": "1600",
            "percentage": "71.62%",
            "cells": [
              "37",
              "24009115510050",
              "JYOTI",
              "RAJESH KUMAR",
              "558",
              "588",
              "1146",
              "1600",
              "71.62%"
            ]
          }
        ]
      },
      {
        "courseName": "B.PED II YEAR",
        "hasMerit": true,
        "headers": [
          "SR.NO",
          "Roll No:",
          "Student Name",
          "Father Name",
          "III SEM out of Marks 800",
          "IV SEM out of Marks 800",
          "1II+IV SEM",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "38",
            "rollNo": "23009115510001",
            "name": "POONAM",
            "fatherName": "LEELU RAM",
            "obtainedMarks": "1337",
            "maxMarks": "1600",
            "percentage": "83.56%",
            "cells": [
              "38",
              "23009115510001",
              "POONAM",
              "LEELU RAM",
              "672",
              "665",
              "1337",
              "1600",
              "83.56%"
            ]
          },
          {
            "sNo": "39",
            "rollNo": "23009115510002",
            "name": "KAMALDEEP KAUR",
            "fatherName": "MALKIT SINGH",
            "obtainedMarks": "1202",
            "maxMarks": "1600",
            "percentage": "75.12%",
            "cells": [
              "39",
              "23009115510002",
              "KAMALDEEP KAUR",
              "MALKIT SINGH",
              "608",
              "594",
              "1202",
              "1600",
              "75.12%"
            ]
          },
          {
            "sNo": "40",
            "rollNo": "23009115510004",
            "name": "MAMTA",
            "fatherName": "AMAR SINGH",
            "obtainedMarks": "1283",
            "maxMarks": "1600",
            "percentage": "80.19%",
            "cells": [
              "40",
              "23009115510004",
              "MAMTA",
              "AMAR SINGH",
              "636",
              "647",
              "1283",
              "1600",
              "80.19%"
            ]
          },
          {
            "sNo": "41",
            "rollNo": "23009115510006",
            "name": "SUMAN BALA",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "1119",
            "maxMarks": "1600",
            "percentage": "69.94%",
            "cells": [
              "41",
              "23009115510006",
              "SUMAN BALA",
              "AATMA RAM",
              "547",
              "572",
              "1119",
              "1600",
              "69.94%"
            ]
          },
          {
            "sNo": "42",
            "rollNo": "23009115510007",
            "name": "RITU",
            "fatherName": "SITA RAM",
            "obtainedMarks": "1158",
            "maxMarks": "1600",
            "percentage": "72.38%",
            "cells": [
              "42",
              "23009115510007",
              "RITU",
              "SITA RAM",
              "566",
              "592",
              "1158",
              "1600",
              "72.38%"
            ]
          },
          {
            "sNo": "43",
            "rollNo": "23009115510009",
            "name": "PRIYANKA",
            "fatherName": "DEVI LAL",
            "obtainedMarks": "1235",
            "maxMarks": "1600",
            "percentage": "77.19%",
            "cells": [
              "43",
              "23009115510009",
              "PRIYANKA",
              "DEVI LAL",
              "612",
              "623",
              "1235",
              "1600",
              "77.19%"
            ]
          },
          {
            "sNo": "44",
            "rollNo": "23009115510010",
            "name": "SARIKA BISHNOI",
            "fatherName": "SUBHASH CHANDER GODARA",
            "obtainedMarks": "1267",
            "maxMarks": "1600",
            "percentage": "79.19%",
            "cells": [
              "44",
              "23009115510010",
              "SARIKA BISHNOI",
              "SUBHASH CHANDER GODARA",
              "628",
              "639",
              "1267",
              "1600",
              "79.19%"
            ]
          },
          {
            "sNo": "45",
            "rollNo": "23009115510014",
            "name": "KAVITA",
            "fatherName": "KRISHNA KUMAR",
            "obtainedMarks": "1159",
            "maxMarks": "1600",
            "percentage": "72.44%",
            "cells": [
              "45",
              "23009115510014",
              "KAVITA",
              "KRISHNA KUMAR",
              "572",
              "587",
              "1159",
              "1600",
              "72.44%"
            ]
          },
          {
            "sNo": "46",
            "rollNo": "23009115510015",
            "name": "MANISHA YADAV",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1125",
            "maxMarks": "1600",
            "percentage": "70.31%",
            "cells": [
              "46",
              "23009115510015",
              "MANISHA YADAV",
              "MAHENDER SINGH",
              "556",
              "569",
              "1125",
              "1600",
              "70.31%"
            ]
          },
          {
            "sNo": "47",
            "rollNo": "23009115510016",
            "name": "SAMATA",
            "fatherName": "KRISHNA LAL",
            "obtainedMarks": "1163",
            "maxMarks": "1600",
            "percentage": "72.69%",
            "cells": [
              "47",
              "23009115510016",
              "SAMATA",
              "KRISHNA LAL",
              "556",
              "607",
              "1163",
              "1600",
              "72.69%"
            ]
          },
          {
            "sNo": "48",
            "rollNo": "23009115510017",
            "name": "NISHA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "1219",
            "maxMarks": "1600",
            "percentage": "76.19%",
            "cells": [
              "48",
              "23009115510017",
              "NISHA",
              "SUBHASH CHANDER",
              "608",
              "611",
              "1219",
              "1600",
              "76.19%"
            ]
          },
          {
            "sNo": "49",
            "rollNo": "23009115510018",
            "name": "NIRMA",
            "fatherName": "HARISINGH",
            "obtainedMarks": "1201",
            "maxMarks": "1600",
            "percentage": "75.06%",
            "cells": [
              "49",
              "23009115510018",
              "NIRMA",
              "HARISINGH",
              "570",
              "631",
              "1201",
              "1600",
              "75.06%"
            ]
          },
          {
            "sNo": "50",
            "rollNo": "23009115510019",
            "name": "VANITA",
            "fatherName": "ANAND KUMAR",
            "obtainedMarks": "1195",
            "maxMarks": "1600",
            "percentage": "74.69%",
            "cells": [
              "50",
              "23009115510019",
              "VANITA",
              "ANAND KUMAR",
              "587",
              "608",
              "1195",
              "1600",
              "74.69%"
            ]
          },
          {
            "sNo": "51",
            "rollNo": "23009115510020",
            "name": "SUMAN",
            "fatherName": "DAYACHAND",
            "obtainedMarks": "1122",
            "maxMarks": "1600",
            "percentage": "70.12%",
            "cells": [
              "51",
              "23009115510020",
              "SUMAN",
              "DAYACHAND",
              "548",
              "574",
              "1122",
              "1600",
              "70.12%"
            ]
          },
          {
            "sNo": "52",
            "rollNo": "23009115510021",
            "name": "REENA",
            "fatherName": "KRISHAN LAL",
            "obtainedMarks": "1306",
            "maxMarks": "1600",
            "percentage": "81.62%",
            "cells": [
              "52",
              "23009115510021",
              "REENA",
              "KRISHAN LAL",
              "643",
              "663",
              "1306",
              "1600",
              "81.62%"
            ]
          },
          {
            "sNo": "53",
            "rollNo": "23009115510022",
            "name": "MANJU RANI",
            "fatherName": "LAL CHAND",
            "obtainedMarks": "1216",
            "maxMarks": "1600",
            "percentage": "76%",
            "cells": [
              "53",
              "23009115510022",
              "MANJU RANI",
              "LAL CHAND",
              "576",
              "640",
              "1216",
              "1600",
              "76%"
            ]
          },
          {
            "sNo": "54",
            "rollNo": "23009115510023",
            "name": "KAVITA",
            "fatherName": "RATI RAM",
            "obtainedMarks": "1204",
            "maxMarks": "1600",
            "percentage": "75.25%",
            "cells": [
              "54",
              "23009115510023",
              "KAVITA",
              "RATI RAM",
              "585",
              "619",
              "1204",
              "1600",
              "75.25%"
            ]
          },
          {
            "sNo": "55",
            "rollNo": "23009115510024",
            "name": "RAVINA DEVI",
            "fatherName": "SULTAN RAM",
            "obtainedMarks": "1129",
            "maxMarks": "1600",
            "percentage": "70.56%",
            "cells": [
              "55",
              "23009115510024",
              "RAVINA DEVI",
              "SULTAN RAM",
              "560",
              "569",
              "1129",
              "1600",
              "70.56%"
            ]
          },
          {
            "sNo": "56",
            "rollNo": "23009115510025",
            "name": "MANISHA",
            "fatherName": "BALBEER",
            "obtainedMarks": "1261",
            "maxMarks": "1600",
            "percentage": "78.81%",
            "cells": [
              "56",
              "23009115510025",
              "MANISHA",
              "BALBEER",
              "622",
              "639",
              "1261",
              "1600",
              "78.81%"
            ]
          },
          {
            "sNo": "57",
            "rollNo": "23009115510026",
            "name": "MINAL",
            "fatherName": "BAL KRISHAN",
            "obtainedMarks": "1240",
            "maxMarks": "1600",
            "percentage": "77.50%",
            "cells": [
              "57",
              "23009115510026",
              "MINAL",
              "BAL KRISHAN",
              "619",
              "621",
              "1240",
              "1600",
              "77.50%"
            ]
          },
          {
            "sNo": "58",
            "rollNo": "23009115510027",
            "name": "RAJNI",
            "fatherName": "BHIM SINGH",
            "obtainedMarks": "1194",
            "maxMarks": "1600",
            "percentage": "74.62%",
            "cells": [
              "58",
              "23009115510027",
              "RAJNI",
              "BHIM SINGH",
              "595",
              "599",
              "1194",
              "1600",
              "74.62%"
            ]
          },
          {
            "sNo": "59",
            "rollNo": "23009115510028",
            "name": "RINKU",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "1152",
            "maxMarks": "1600",
            "percentage": "72%",
            "cells": [
              "59",
              "23009115510028",
              "RINKU",
              "RAJENDER SINGH",
              "569",
              "583",
              "1152",
              "1600",
              "72%"
            ]
          },
          {
            "sNo": "60",
            "rollNo": "23009115510029",
            "name": "RENU",
            "fatherName": "PRAHALAD",
            "obtainedMarks": "1232",
            "maxMarks": "1600",
            "percentage": "77%",
            "cells": [
              "60",
              "23009115510029",
              "RENU",
              "PRAHALAD",
              "599",
              "633",
              "1232",
              "1600",
              "77%"
            ]
          },
          {
            "sNo": "61",
            "rollNo": "23009115510030",
            "name": "KOMAL BANO",
            "fatherName": "JANAB ALI",
            "obtainedMarks": "1176",
            "maxMarks": "1600",
            "percentage": "73.50%",
            "cells": [
              "61",
              "23009115510030",
              "KOMAL BANO",
              "JANAB ALI",
              "577",
              "599",
              "1176",
              "1600",
              "73.50%"
            ]
          },
          {
            "sNo": "62",
            "rollNo": "23009115510031",
            "name": "SUKHWANTI",
            "fatherName": "CHETAN RAM",
            "obtainedMarks": "1273",
            "maxMarks": "1600",
            "percentage": "79.56%",
            "cells": [
              "62",
              "23009115510031",
              "SUKHWANTI",
              "CHETAN RAM",
              "650",
              "623",
              "1273",
              "1600",
              "79.56%"
            ]
          },
          {
            "sNo": "63",
            "rollNo": "23009115510032",
            "name": "POONAM",
            "fatherName": "DILBAG",
            "obtainedMarks": "1153",
            "maxMarks": "1600",
            "percentage": "72.06%",
            "cells": [
              "63",
              "23009115510032",
              "POONAM",
              "DILBAG",
              "573",
              "580",
              "1153",
              "1600",
              "72.06%"
            ]
          },
          {
            "sNo": "64",
            "rollNo": "23009115510035",
            "name": "SHITAL",
            "fatherName": "AATMA RAM",
            "obtainedMarks": "1120",
            "maxMarks": "1600",
            "percentage": "70%",
            "cells": [
              "64",
              "23009115510035",
              "SHITAL",
              "AATMA RAM",
              "540",
              "580",
              "1120",
              "1600",
              "70%"
            ]
          },
          {
            "sNo": "65",
            "rollNo": "23009115510036",
            "name": "ANJALI",
            "fatherName": "VEERBHAN",
            "obtainedMarks": "1219",
            "maxMarks": "1600",
            "percentage": "76.19%",
            "cells": [
              "65",
              "23009115510036",
              "ANJALI",
              "VEERBHAN",
              "605",
              "614",
              "1219",
              "1600",
              "76.19%"
            ]
          },
          {
            "sNo": "66",
            "rollNo": "23009115510037",
            "name": "NIKITA",
            "fatherName": "OMPARKASH",
            "obtainedMarks": "1285",
            "maxMarks": "1600",
            "percentage": "80.31%",
            "cells": [
              "66",
              "23009115510037",
              "NIKITA",
              "OMPARKASH",
              "636",
              "649",
              "1285",
              "1600",
              "80.31%"
            ]
          },
          {
            "sNo": "67",
            "rollNo": "23009115510039",
            "name": "PRIYANKA",
            "fatherName": "KULDEEP",
            "obtainedMarks": "1166",
            "maxMarks": "1600",
            "percentage": "72.88%",
            "cells": [
              "67",
              "23009115510039",
              "PRIYANKA",
              "KULDEEP",
              "570",
              "596",
              "1166",
              "1600",
              "72.88%"
            ]
          },
          {
            "sNo": "68",
            "rollNo": "23009115510040",
            "name": "SUSHILA",
            "fatherName": "KRISHAN KUMAR",
            "obtainedMarks": "1172",
            "maxMarks": "1600",
            "percentage": "73.25%",
            "cells": [
              "68",
              "23009115510040",
              "SUSHILA",
              "KRISHAN KUMAR",
              "581",
              "591",
              "1172",
              "1600",
              "73.25%"
            ]
          },
          {
            "sNo": "69",
            "rollNo": "23009115510041",
            "name": "NEETU",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1192",
            "maxMarks": "1600",
            "percentage": "74.50%",
            "cells": [
              "69",
              "23009115510041",
              "NEETU",
              "BHOOP SINGH",
              "602",
              "590",
              "1192",
              "1600",
              "74.50%"
            ]
          },
          {
            "sNo": "70",
            "rollNo": "23009115510042",
            "name": "NIKITA SONI",
            "fatherName": "AMIT SONI",
            "obtainedMarks": "1138",
            "maxMarks": "1600",
            "percentage": "71.12%",
            "cells": [
              "70",
              "23009115510042",
              "NIKITA SONI",
              "AMIT SONI",
              "577",
              "561",
              "1138",
              "1600",
              "71.12%"
            ]
          },
          {
            "sNo": "71",
            "rollNo": "23009115510043",
            "name": "PARVEEN BALA",
            "fatherName": "LEKH RAJ",
            "obtainedMarks": "1135",
            "maxMarks": "1600",
            "percentage": "70.94%",
            "cells": [
              "71",
              "23009115510043",
              "PARVEEN BALA",
              "LEKH RAJ",
              "558",
              "577",
              "1135",
              "1600",
              "70.94%"
            ]
          },
          {
            "sNo": "72",
            "rollNo": "23009115510044",
            "name": "PAYAL",
            "fatherName": "LAXMI NARAYAN",
            "obtainedMarks": "1146",
            "maxMarks": "1600",
            "percentage": "71.62%",
            "cells": [
              "72",
              "23009115510044",
              "PAYAL",
              "LAXMI NARAYAN",
              "567",
              "579",
              "1146",
              "1600",
              "71.62%"
            ]
          },
          {
            "sNo": "73",
            "rollNo": "23009115510048",
            "name": "POONAM",
            "fatherName": "DHARAM PAL",
            "obtainedMarks": "1220",
            "maxMarks": "1600",
            "percentage": "76.25%",
            "cells": [
              "73",
              "23009115510048",
              "POONAM",
              "DHARAM PAL",
              "596",
              "624",
              "1220",
              "1600",
              "76.25%"
            ]
          }
        ]
      },
      {
        "courseName": "MA ENGLISH 1Year",
        "hasMerit": true,
        "headers": [
          "Sr No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  600",
          "II Sem Out of Marks  700",
          "I +II Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "74",
            "rollNo": "24009990300004",
            "name": "PARGATI",
            "fatherName": "SURENDER SINGH",
            "obtainedMarks": "953",
            "maxMarks": "1300",
            "percentage": "73.31%",
            "cells": [
              "74",
              "24009990300004",
              "PARGATI",
              "SURENDER SINGH",
              "434",
              "519",
              "953",
              "1300",
              "73.31%"
            ]
          },
          {
            "sNo": "75",
            "rollNo": "24009990300021",
            "name": "SHEETAL GARG",
            "fatherName": "SAJJAN KUMAR",
            "obtainedMarks": "944",
            "maxMarks": "1300",
            "percentage": "72.62%",
            "cells": [
              "75",
              "24009990300021",
              "SHEETAL GARG",
              "SAJJAN KUMAR",
              "431",
              "513",
              "944",
              "1300",
              "72.62%"
            ]
          }
        ]
      },
      {
        "courseName": "MA ENGLISH  IIYear",
        "hasMerit": false,
        "headers": [],
        "students": []
      },
      {
        "courseName": "MA HINDI 1Year",
        "hasMerit": true,
        "headers": [
          "Sr No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  600",
          "II Sem Out of Marks  700",
          "I +II Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "76",
            "rollNo": "24009990200001",
            "name": "SUMAN LATA",
            "fatherName": "LILU RAM",
            "obtainedMarks": "918",
            "maxMarks": "1300",
            "percentage": "70.62%",
            "cells": [
              "76",
              "24009990200001",
              "SUMAN LATA",
              "LILU RAM",
              "419",
              "499",
              "918",
              "1300",
              "70.62%"
            ]
          },
          {
            "sNo": "77",
            "rollNo": "24009990200002",
            "name": "MITHO DEVI",
            "fatherName": "BIKAR SINGH",
            "obtainedMarks": "1040",
            "maxMarks": "1300",
            "percentage": "80%",
            "cells": [
              "77",
              "24009990200002",
              "MITHO DEVI",
              "BIKAR SINGH",
              "485",
              "555",
              "1040",
              "1300",
              "80%"
            ]
          },
          {
            "sNo": "78",
            "rollNo": "24009990200004",
            "name": "SANDEEP KAUR",
            "fatherName": "MAHENDER SINGH",
            "obtainedMarks": "1022",
            "maxMarks": "1300",
            "percentage": "78.62%",
            "cells": [
              "78",
              "24009990200004",
              "SANDEEP KAUR",
              "MAHENDER SINGH",
              "459",
              "563",
              "1022",
              "1300",
              "78.62%"
            ]
          },
          {
            "sNo": "79",
            "rollNo": "24009990200005",
            "name": "MANORMA",
            "fatherName": "OM PRAKASH",
            "obtainedMarks": "1063",
            "maxMarks": "1300",
            "percentage": "81.77%",
            "cells": [
              "79",
              "24009990200005",
              "MANORMA",
              "OM PRAKASH",
              "479",
              "584",
              "1063",
              "1300",
              "81.77%"
            ]
          },
          {
            "sNo": "80",
            "rollNo": "24009990200006",
            "name": "KAJAL",
            "fatherName": "AJAY KUMAR",
            "obtainedMarks": "986",
            "maxMarks": "1300",
            "percentage": "75.85%",
            "cells": [
              "80",
              "24009990200006",
              "KAJAL",
              "AJAY KUMAR",
              "443",
              "543",
              "986",
              "1300",
              "75.85%"
            ]
          },
          {
            "sNo": "81",
            "rollNo": "24009990200007",
            "name": "SUMAN",
            "fatherName": "BHOOP SINGH",
            "obtainedMarks": "1021",
            "maxMarks": "1300",
            "percentage": "78.54%",
            "cells": [
              "81",
              "24009990200007",
              "SUMAN",
              "BHOOP SINGH",
              "458",
              "563",
              "1021",
              "1300",
              "78.54%"
            ]
          },
          {
            "sNo": "82",
            "rollNo": "24009990200008",
            "name": "KOMAL",
            "fatherName": "SUBHASH",
            "obtainedMarks": "971",
            "maxMarks": "1300",
            "percentage": "74.69%",
            "cells": [
              "82",
              "24009990200008",
              "KOMAL",
              "SUBHASH",
              "439",
              "532",
              "971",
              "1300",
              "74.69%"
            ]
          },
          {
            "sNo": "83",
            "rollNo": "24009990200009",
            "name": "POONAM RANI",
            "fatherName": "SUBHASH",
            "obtainedMarks": "1029",
            "maxMarks": "1300",
            "percentage": "79.15%",
            "cells": [
              "83",
              "24009990200009",
              "POONAM RANI",
              "SUBHASH",
              "457",
              "572",
              "1029",
              "1300",
              "79.15%"
            ]
          },
          {
            "sNo": "84",
            "rollNo": "24009990200011",
            "name": "RAMKASHI KUMARI",
            "fatherName": "RAMBADAN DAS",
            "obtainedMarks": "1032",
            "maxMarks": "1300",
            "percentage": "79.38%",
            "cells": [
              "84",
              "24009990200011",
              "RAMKASHI KUMARI",
              "RAMBADAN DAS",
              "453",
              "579",
              "1032",
              "1300",
              "79.38%"
            ]
          },
          {
            "sNo": "85",
            "rollNo": "24009990200014",
            "name": "KOMAL",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "987",
            "maxMarks": "1300",
            "percentage": "75.92%",
            "cells": [
              "85",
              "24009990200014",
              "KOMAL",
              "SUBHASH CHANDER",
              "442",
              "545",
              "987",
              "1300",
              "75.92%"
            ]
          },
          {
            "sNo": "86",
            "rollNo": "24009990200015",
            "name": "BINDER KAUR",
            "fatherName": "GURJANT SINGH",
            "obtainedMarks": "958",
            "maxMarks": "1300",
            "percentage": "73.69%",
            "cells": [
              "86",
              "24009990200015",
              "BINDER KAUR",
              "GURJANT SINGH",
              "424",
              "534",
              "958",
              "1300",
              "73.69%"
            ]
          },
          {
            "sNo": "87",
            "rollNo": "24009990200016",
            "name": "PRIYANKA",
            "fatherName": "DULI CHAND",
            "obtainedMarks": "953",
            "maxMarks": "1300",
            "percentage": "73.30%",
            "cells": [
              "87",
              "24009990200016",
              "PRIYANKA",
              "DULI CHAND",
              "427",
              "526",
              "953",
              "1300",
              "73.30%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A. HINDI  II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 700",
          "IV Sem Marks out of 500",
          "III +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "88",
            "rollNo": "23009990200001",
            "name": "KIRAN BALA",
            "fatherName": "BIRU RAM",
            "obtainedMarks": "976",
            "maxMarks": "1300",
            "percentage": "75.07%",
            "cells": [
              "88",
              "23009990200001",
              "KIRAN BALA",
              "BIRU RAM",
              "567",
              "409",
              "976",
              "1300",
              "75.07%"
            ]
          },
          {
            "sNo": "89",
            "rollNo": "23009990200004",
            "name": "SHAKUNTLA",
            "fatherName": "RAJENDER SINGH",
            "obtainedMarks": "990",
            "maxMarks": "1300",
            "percentage": "76.15%",
            "cells": [
              "89",
              "23009990200004",
              "SHAKUNTLA",
              "RAJENDER SINGH",
              "566",
              "424",
              "990",
              "1300",
              "76.15%"
            ]
          },
          {
            "sNo": "90",
            "rollNo": "23009990200008",
            "name": "SEEMA DEVI",
            "fatherName": "DALBIR",
            "obtainedMarks": "932",
            "maxMarks": "1300",
            "percentage": "71.69%",
            "cells": [
              "90",
              "23009990200008",
              "SEEMA DEVI",
              "DALBIR",
              "536",
              "396",
              "932",
              "1300",
              "71.69%"
            ]
          },
          {
            "sNo": "91",
            "rollNo": "23009990200013",
            "name": "PRIYANKA",
            "fatherName": "NARESH",
            "obtainedMarks": "916",
            "maxMarks": "1300",
            "percentage": "70.46%",
            "cells": [
              "91",
              "23009990200013",
              "PRIYANKA",
              "NARESH",
              "526",
              "390",
              "916",
              "1300",
              "70.46%"
            ]
          },
          {
            "sNo": "92",
            "rollNo": "23009990200017",
            "name": "RENU",
            "fatherName": "MAHAVIR",
            "obtainedMarks": "967",
            "maxMarks": "1300",
            "percentage": "74.38%",
            "cells": [
              "92",
              "23009990200017",
              "RENU",
              "MAHAVIR",
              "570",
              "397",
              "967",
              "1300",
              "74.38%"
            ]
          },
          {
            "sNo": "93",
            "rollNo": "23009990200019",
            "name": "SUJATA RANI",
            "fatherName": "NATHU RAM",
            "obtainedMarks": "925",
            "maxMarks": "1300",
            "percentage": "71.15%",
            "cells": [
              "93",
              "23009990200019",
              "SUJATA RANI",
              "NATHU RAM",
              "539",
              "386",
              "925",
              "1300",
              "71.15%"
            ]
          }
        ]
      },
      {
        "courseName": "MA PUB ADM  1Year",
        "hasMerit": true,
        "headers": [
          "Sr No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  600",
          "II Sem Out of Marks  700",
          "I +II Sem",
          "Total  Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "94",
            "rollNo": "24009990140002",
            "name": "DAYAWANTI",
            "fatherName": "DAYANAND",
            "obtainedMarks": "1098",
            "maxMarks": "1300",
            "percentage": "84.46%",
            "cells": [
              "94",
              "24009990140002",
              "DAYAWANTI",
              "DAYANAND",
              "604",
              "494",
              "1098",
              "1300",
              "84.46%"
            ]
          },
          {
            "sNo": "95",
            "rollNo": "24009990140004",
            "name": "URMILA",
            "fatherName": "BHAGAT RAM",
            "obtainedMarks": "1039",
            "maxMarks": "1300",
            "percentage": "79.92%",
            "cells": [
              "95",
              "24009990140004",
              "URMILA",
              "BHAGAT RAM",
              "579",
              "460",
              "1039",
              "1300",
              "79.92%"
            ]
          },
          {
            "sNo": "96",
            "rollNo": "24009990140006",
            "name": "KOMAL",
            "fatherName": "BRIJ LAL",
            "obtainedMarks": "1015",
            "maxMarks": "1300",
            "percentage": "78.08%",
            "cells": [
              "96",
              "24009990140006",
              "KOMAL",
              "BRIJ LAL",
              "571",
              "444",
              "1015",
              "1300",
              "78.08%"
            ]
          },
          {
            "sNo": "97",
            "rollNo": "24009990140010",
            "name": "RITIKA",
            "fatherName": "LADU RAM",
            "obtainedMarks": "1026",
            "maxMarks": "1300",
            "percentage": "78.92%",
            "cells": [
              "97",
              "24009990140010",
              "RITIKA",
              "LADU RAM",
              "572",
              "454",
              "1026",
              "1300",
              "78.92%"
            ]
          },
          {
            "sNo": "98",
            "rollNo": "24009990140011",
            "name": "MONIKA RANI",
            "fatherName": "DUNI RAM",
            "obtainedMarks": "1006",
            "maxMarks": "1300",
            "percentage": "77.38%",
            "cells": [
              "98",
              "24009990140011",
              "MONIKA RANI",
              "DUNI RAM",
              "577",
              "429",
              "1006",
              "1300",
              "77.38%"
            ]
          },
          {
            "sNo": "99",
            "rollNo": "24009990140017",
            "name": "SUSHMA DEVI",
            "fatherName": "JAIPAL",
            "obtainedMarks": "977",
            "maxMarks": "1300",
            "percentage": "75.15%",
            "cells": [
              "99",
              "24009990140017",
              "SUSHMA DEVI",
              "JAIPAL",
              "550",
              "427",
              "977",
              "1300",
              "75.15%"
            ]
          }
        ]
      },
      {
        "courseName": "M.A.PUB.ADM.  II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 700",
          "IV Sem Marks out of 600",
          "III +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "100",
            "rollNo": "23009990140003",
            "name": "ANISHA",
            "fatherName": "DALBIR SINGH",
            "obtainedMarks": "963",
            "maxMarks": "1300",
            "percentage": "74.07%",
            "cells": [
              "100",
              "23009990140003",
              "ANISHA",
              "DALBIR SINGH",
              "541",
              "422",
              "963",
              "1300",
              "74.07%"
            ]
          },
          {
            "sNo": "101",
            "rollNo": "23009990140016",
            "name": "BHAWNA",
            "fatherName": "SATVEER",
            "obtainedMarks": "916",
            "maxMarks": "1300",
            "percentage": "70.46%",
            "cells": [
              "101",
              "23009990140016",
              "BHAWNA",
              "SATVEER",
              "511",
              "405",
              "916",
              "1300",
              "70.46%"
            ]
          }
        ]
      },
      {
        "courseName": "M.Sc.Math 1Year",
        "hasMerit": true,
        "headers": [
          "Sr No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "I Sem Out of Marks  550",
          "II Sem Out of Marks  700",
          "I +II Sem",
          "Total Max Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "102",
            "rollNo": "24009993510001",
            "name": "ARZ INSAN",
            "fatherName": "AMARJEET",
            "obtainedMarks": "976",
            "maxMarks": "1250",
            "percentage": "78.08%",
            "cells": [
              "102",
              "24009993510001",
              "ARZ INSAN",
              "AMARJEET",
              "452",
              "524",
              "976",
              "1250",
              "78.08%"
            ]
          },
          {
            "sNo": "103",
            "rollNo": "24009993510002",
            "name": "VISHAKHA",
            "fatherName": "SUBHASH CHANDER",
            "obtainedMarks": "932",
            "maxMarks": "1250",
            "percentage": "74.56%",
            "cells": [
              "103",
              "24009993510002",
              "VISHAKHA",
              "SUBHASH CHANDER",
              "423",
              "509",
              "932",
              "1250",
              "74.56%"
            ]
          },
          {
            "sNo": "104",
            "rollNo": "24009993510003",
            "name": "MANJU",
            "fatherName": "SHRI RAM",
            "obtainedMarks": "905",
            "maxMarks": "1250",
            "percentage": "72.40%",
            "cells": [
              "104",
              "24009993510003",
              "MANJU",
              "SHRI RAM",
              "401",
              "504",
              "905",
              "1250",
              "72.40%"
            ]
          },
          {
            "sNo": "105",
            "rollNo": "24009993510004",
            "name": "PRIYANKA",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "986",
            "maxMarks": "1250",
            "percentage": "78.88%",
            "cells": [
              "105",
              "24009993510004",
              "PRIYANKA",
              "PAWAN KUMAR",
              "437",
              "549",
              "986",
              "1250",
              "78.88%"
            ]
          },
          {
            "sNo": "106",
            "rollNo": "24009993510005",
            "name": "NEELAM RANI",
            "fatherName": "LAXMAN DASS",
            "obtainedMarks": "933",
            "maxMarks": "1250",
            "percentage": "74.64%",
            "cells": [
              "106",
              "24009993510005",
              "NEELAM RANI",
              "LAXMAN DASS",
              "415",
              "518",
              "933",
              "1250",
              "74.64%"
            ]
          },
          {
            "sNo": "107",
            "rollNo": "24009993510008",
            "name": "JYOTI",
            "fatherName": "MAHABIR",
            "obtainedMarks": "928",
            "maxMarks": "1250",
            "percentage": "74.24%",
            "cells": [
              "107",
              "24009993510008",
              "JYOTI",
              "MAHABIR",
              "407",
              "521",
              "928",
              "1250",
              "74.24%"
            ]
          },
          {
            "sNo": "108",
            "rollNo": "24009993510009",
            "name": "HIMANSHI",
            "fatherName": "DEEPAK",
            "obtainedMarks": "949",
            "maxMarks": "1250",
            "percentage": "75.92%",
            "cells": [
              "108",
              "24009993510009",
              "HIMANSHI",
              "DEEPAK",
              "406",
              "543",
              "949",
              "1250",
              "75.92%"
            ]
          },
          {
            "sNo": "109",
            "rollNo": "24009993510011",
            "name": "RENU",
            "fatherName": "RAM NARAYAN",
            "obtainedMarks": "945",
            "maxMarks": "1250",
            "percentage": "75.60%",
            "cells": [
              "109",
              "24009993510011",
              "RENU",
              "RAM NARAYAN",
              "398",
              "547",
              "945",
              "1250",
              "75.60%"
            ]
          },
          {
            "sNo": "110",
            "rollNo": "24009993510012",
            "name": "DIVYA",
            "fatherName": "SANDEEP KUMAR",
            "obtainedMarks": "882",
            "maxMarks": "1250",
            "percentage": "70.56%",
            "cells": [
              "110",
              "24009993510012",
              "DIVYA",
              "SANDEEP KUMAR",
              "382",
              "500",
              "882",
              "1250",
              "70.56%"
            ]
          }
        ]
      },
      {
        "courseName": "M.SC.MATHS  II Year",
        "hasMerit": true,
        "headers": [
          "Sr. No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 700",
          "IV Sem Marks out of 600",
          "III +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "111",
            "rollNo": "23009993510003",
            "name": "POOJA",
            "fatherName": "SURENDER",
            "obtainedMarks": "1027",
            "maxMarks": "1300",
            "percentage": "79%",
            "cells": [
              "111",
              "23009993510003",
              "POOJA",
              "SURENDER",
              "539",
              "488",
              "1027",
              "1300",
              "79%"
            ]
          },
          {
            "sNo": "112",
            "rollNo": "23009993510004",
            "name": "KOMAL",
            "fatherName": "SURENDER KUMAR",
            "obtainedMarks": "929",
            "maxMarks": "1300",
            "percentage": "71.46%",
            "cells": [
              "112",
              "23009993510004",
              "KOMAL",
              "SURENDER KUMAR",
              "481",
              "448",
              "929",
              "1300",
              "71.46%"
            ]
          },
          {
            "sNo": "113",
            "rollNo": "23009993510006",
            "name": "KHUSHPREET",
            "fatherName": "BALJEET SINGH",
            "obtainedMarks": "935",
            "maxMarks": "1300",
            "percentage": "71.92%",
            "cells": [
              "113",
              "23009993510006",
              "KHUSHPREET",
              "BALJEET SINGH",
              "490",
              "445",
              "935",
              "1300",
              "71.92%"
            ]
          },
          {
            "sNo": "114",
            "rollNo": "23009993510007",
            "name": "Anju Rani",
            "fatherName": "RAJBIR",
            "obtainedMarks": "966",
            "maxMarks": "1300",
            "percentage": "74.30%",
            "cells": [
              "114",
              "23009993510007",
              "Anju Rani",
              "RAJBIR",
              "503",
              "463",
              "966",
              "1300",
              "74.30%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM 1Year",
        "hasMerit": true,
        "headers": [
          "Sr No.",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 600",
          "IV Sem Marks out of 600",
          "I +II Sem",
          "Total marks",
          "%"
        ],
        "students": [
          {
            "sNo": "115",
            "rollNo": "24009990080001",
            "name": "SURYA",
            "fatherName": "SH. SUBHASH CHANDER",
            "obtainedMarks": "899",
            "maxMarks": "1200",
            "percentage": "74.92%",
            "cells": [
              "115",
              "24009990080001",
              "SURYA",
              "SH. SUBHASH CHANDER",
              "454",
              "445",
              "899",
              "1200",
              "74.92%"
            ]
          },
          {
            "sNo": "116",
            "rollNo": "24009990080003",
            "name": "SUKHJEET",
            "fatherName": "GURNAM SINGH",
            "obtainedMarks": "843",
            "maxMarks": "1200",
            "percentage": "70.25%",
            "cells": [
              "116",
              "24009990080003",
              "SUKHJEET",
              "GURNAM SINGH",
              "427",
              "416",
              "843",
              "1200",
              "70.25%"
            ]
          },
          {
            "sNo": "117",
            "rollNo": "24009990080004",
            "name": "NEHA SEHDEV",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "846",
            "maxMarks": "1200",
            "percentage": "70.50%",
            "cells": [
              "117",
              "24009990080004",
              "NEHA SEHDEV",
              "AVTAR SINGH",
              "406",
              "440",
              "846",
              "1200",
              "70.50%"
            ]
          },
          {
            "sNo": "118",
            "rollNo": "24009990080006",
            "name": "LOVEPREET KAUR",
            "fatherName": "AVTAR SINGH",
            "obtainedMarks": "858",
            "maxMarks": "1200",
            "percentage": "71.50%",
            "cells": [
              "118",
              "24009990080006",
              "LOVEPREET KAUR",
              "AVTAR SINGH",
              "415",
              "443",
              "858",
              "1200",
              "71.50%"
            ]
          },
          {
            "sNo": "119",
            "rollNo": "24009990080013",
            "name": "DIKSHA RANI",
            "fatherName": "RAJESH KUMAR",
            "obtainedMarks": "847",
            "maxMarks": "1200",
            "percentage": "70.58%",
            "cells": [
              "119",
              "24009990080013",
              "DIKSHA RANI",
              "RAJESH KUMAR",
              "422",
              "425",
              "847",
              "1200",
              "70.58%"
            ]
          }
        ]
      },
      {
        "courseName": "M.COM I1Year",
        "hasMerit": true,
        "headers": [
          "Sr. No .",
          "Roll No.",
          "Student Name",
          "Father Name",
          "III Sem Marks out of 700",
          "IV Sem Marks out of 700",
          "III +IV Sem",
          "Total Marks",
          "%"
        ],
        "students": [
          {
            "sNo": "120",
            "rollNo": "23009990080001",
            "name": "RENU BALA",
            "fatherName": "SATPAL",
            "obtainedMarks": "1022",
            "maxMarks": "1400",
            "percentage": "73%",
            "cells": [
              "120",
              "23009990080001",
              "RENU BALA",
              "SATPAL",
              "503",
              "519",
              "1022",
              "1400",
              "73%"
            ]
          },
          {
            "sNo": "121",
            "rollNo": "23009990080002",
            "name": "SANDUJA",
            "fatherName": "LEELU RAM",
            "obtainedMarks": "1098",
            "maxMarks": "1400",
            "percentage": "78.42%",
            "cells": [
              "121",
              "23009990080002",
              "SANDUJA",
              "LEELU RAM",
              "557",
              "541",
              "1098",
              "1400",
              "78.42%"
            ]
          },
          {
            "sNo": "122",
            "rollNo": "23009990080003",
            "name": "REETU PARYA",
            "fatherName": "CHANDER BHAN",
            "obtainedMarks": "1006",
            "maxMarks": "1400",
            "percentage": "71.85%",
            "cells": [
              "122",
              "23009990080003",
              "REETU PARYA",
              "CHANDER BHAN",
              "492",
              "514",
              "1006",
              "1400",
              "71.85%"
            ]
          },
          {
            "sNo": "123",
            "rollNo": "23009990080005",
            "name": "SWATI",
            "fatherName": "RAJ KUMAR",
            "obtainedMarks": "1026",
            "maxMarks": "1400",
            "percentage": "73.28%",
            "cells": [
              "123",
              "23009990080005",
              "SWATI",
              "RAJ KUMAR",
              "519",
              "507",
              "1026",
              "1400",
              "73.28%"
            ]
          },
          {
            "sNo": "124",
            "rollNo": "23009990080006",
            "name": "TARANPREET KAUR",
            "fatherName": "SATNAM SINGH",
            "obtainedMarks": "1036",
            "maxMarks": "1400",
            "percentage": "74%",
            "cells": [
              "124",
              "23009990080006",
              "TARANPREET KAUR",
              "SATNAM SINGH",
              "502",
              "534",
              "1036",
              "1400",
              "74%"
            ]
          },
          {
            "sNo": "125",
            "rollNo": "23009990080008",
            "name": "JASLEEN KAUR",
            "fatherName": "RAJVEER SINGH",
            "obtainedMarks": "1067",
            "maxMarks": "1400",
            "percentage": "76.21%",
            "cells": [
              "125",
              "23009990080008",
              "JASLEEN KAUR",
              "RAJVEER SINGH",
              "535",
              "532",
              "1067",
              "1400",
              "76.21%"
            ]
          },
          {
            "sNo": "126",
            "rollNo": "23009990080009",
            "name": "JYOTI",
            "fatherName": "JEET RAM",
            "obtainedMarks": "1056",
            "maxMarks": "1400",
            "percentage": "75.42%",
            "cells": [
              "126",
              "23009990080009",
              "JYOTI",
              "JEET RAM",
              "513",
              "543",
              "1056",
              "1400",
              "75.42%"
            ]
          },
          {
            "sNo": "127",
            "rollNo": "23009990080010",
            "name": "AASHIMA",
            "fatherName": "DHARAMPAL",
            "obtainedMarks": "1074",
            "maxMarks": "1400",
            "percentage": "76.71%",
            "cells": [
              "127",
              "23009990080010",
              "AASHIMA",
              "DHARAMPAL",
              "527",
              "547",
              "1074",
              "1400",
              "76.71%"
            ]
          },
          {
            "sNo": "128",
            "rollNo": "23009990080011",
            "name": "RIYA ARORA",
            "fatherName": "TARSEM KUMAR",
            "obtainedMarks": "1064",
            "maxMarks": "1400",
            "percentage": "76%",
            "cells": [
              "128",
              "23009990080011",
              "RIYA ARORA",
              "TARSEM KUMAR",
              "522",
              "542",
              "1064",
              "1400",
              "76%"
            ]
          },
          {
            "sNo": "129",
            "rollNo": "23009990080012",
            "name": "NAVDEEP KAUR",
            "fatherName": "PARMPREET SINGH",
            "obtainedMarks": "1039",
            "maxMarks": "1400",
            "percentage": "74.21%",
            "cells": [
              "129",
              "23009990080012",
              "NAVDEEP KAUR",
              "PARMPREET SINGH",
              "499",
              "540",
              "1039",
              "1400",
              "74.21%"
            ]
          },
          {
            "sNo": "130",
            "rollNo": "23009990080013",
            "name": "SONAM KUMARI",
            "fatherName": "SURESH KUMAR",
            "obtainedMarks": "998",
            "maxMarks": "1400",
            "percentage": "71.28%",
            "cells": [
              "130",
              "23009990080013",
              "SONAM KUMARI",
              "SURESH KUMAR",
              "476",
              "522",
              "998",
              "1400",
              "71.28%"
            ]
          },
          {
            "sNo": "131",
            "rollNo": "23009990080014",
            "name": "NISHTHA INSAN",
            "fatherName": "PAWAN KUMAR",
            "obtainedMarks": "1031",
            "maxMarks": "1400",
            "percentage": "73.64%",
            "cells": [
              "131",
              "23009990080014",
              "NISHTHA INSAN",
              "PAWAN KUMAR",
              "500",
              "531",
              "1031",
              "1400",
              "73.64%"
            ]
          }
        ]
      }
    ]
  }
];
